/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _module = __webpack_require__(1);

	var _module2 = _interopRequireDefault(_module);

	var _module3 = __webpack_require__(7);

	var _module4 = _interopRequireDefault(_module3);

	var _module5 = __webpack_require__(99);

	var _module6 = _interopRequireDefault(_module5);

	var _module7 = __webpack_require__(117);

	var _module8 = _interopRequireDefault(_module7);

	var _module9 = __webpack_require__(127);

	var _module10 = _interopRequireDefault(_module9);

	var _module11 = __webpack_require__(132);

	var _module12 = _interopRequireDefault(_module11);

	var _module13 = __webpack_require__(136);

	var _module14 = _interopRequireDefault(_module13);

	var _module15 = __webpack_require__(140);

	var _module16 = _interopRequireDefault(_module15);

	var _isolateFormDir = __webpack_require__(148);

	var _isolateFormDir2 = _interopRequireDefault(_isolateFormDir);

	var _component = __webpack_require__(149);

	var _component2 = _interopRequireDefault(_component);

	var _theme = __webpack_require__(150);

	var _theme2 = _interopRequireDefault(_theme);

	var _auth = __webpack_require__(151);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//"wysiwyg.module"

	/* global moment:false */

	angular.module('lectusAdminWui', [_module2.default.name, _module4.default.name, _module6.default.name, _module8.default.name, _module10.default.name, _module16.default.name, _module12.default.name, _module14.default.name, "angular-loading-bar", "textAngular"]).constant('moment', moment).constant('apiUrl', 'https://beds-api.holidaypremiere.fractal-beds.com').constant('sapiUrl', 'https://beds-sapi.holidaypremiere.fractal-beds.com').constant('crmApiUrl', 'https://holidaypremiere.fractal-sales.com/api').factory('User', _auth.User).factory('Auth', _auth.Auth).factory("authInterceptor", _auth.authInterceptor).component('topbar', _component2.default).directive(_isolateFormDir2.default.name, _isolateFormDir2.default).config(_auth.authHttpConfig).config(_theme2.default).config(["$urlRouterProvider", "$logProvider", function ($urlRouterProvider, $logProvider) {
	  'ngInject';

	  $urlRouterProvider.otherwise('/properties');
	  $logProvider.debugEnabled(true);
	}]).config(["$mdDateLocaleProvider", function ($mdDateLocaleProvider) {
	  'ngInject';

	  $mdDateLocaleProvider.formatDate = function (date) {
	    var m = moment(date);
	    return m.isValid() ? m.format('YYYY-MM-DD') : '';
	  };
	}]).config(['$provide', function ($provide) {
	  $provide.decorator('taOptions', ['$delegate', function (taOptions) {
	    taOptions.forceTextAngularSanitize = true;
	    taOptions.keyMappings = [];
	    taOptions.toolbar = [['h1', 'h2', 'h3', 'p', 'pre', 'quote'], ['bold', 'italics', 'underline', 'ul', 'ol', 'redo', 'undo', 'clear'], ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'], ['html', 'insertImage', 'insertLink']];
	    taOptions.classes = {
	      focussed: '',
	      toolbar: 'ta-toolbar',
	      toolbarGroup: 'ta-button-group',
	      toolbarButton: '',
	      toolbarButtonActive: 'active',
	      disabled: 'disabled',
	      textEditor: 'ta-text-editor',
	      htmlEditor: 'md-input'
	    };
	    return taOptions;
	  }]);
	  $provide.decorator('taTools', ['$delegate', function (taTools) {
	    taTools.h1.display = '<md-button aria-label="Heading 1">H1</md-button>';
	    taTools.h2.display = '<md-button aria-label="Heading 2">H2</md-button>';
	    taTools.h3.display = '<md-button aria-label="Heading 3">H3</md-button>';
	    taTools.p.display = '<md-button aria-label="Paragraph">P</md-button>';
	    taTools.pre.display = '<md-button aria-label="Pre">pre</md-button>';
	    taTools.quote.display = '<md-button class="md-icon-button" aria-label="Quote"><md-icon md-font-set="material-icons">format_quote</md-icon></md-button>';
	    taTools.bold.display = '<md-button class="md-icon-button" aria-label="Bold"><md-icon md-font-set="material-icons">format_bold</md-icon></md-button>';
	    taTools.italics.display = '<md-button class="md-icon-button" aria-label="Italic"><md-icon md-font-set="material-icons">format_italic</md-icon></md-button>';
	    taTools.underline.display = '<md-button class="md-icon-button" aria-label="Underline"><md-icon md-font-set="material-icons">format_underlined</md-icon></md-button>';
	    taTools.ul.display = '<md-button class="md-icon-button" aria-label="Buletted list"><md-icon md-font-set="material-icons">format_list_bulleted</md-icon></md-button>';
	    taTools.ol.display = '<md-button class="md-icon-button" aria-label="Numbered list"><md-icon md-font-set="material-icons">format_list_numbered</md-icon></md-button>';
	    taTools.undo.display = '<md-button class="md-icon-button" aria-label="Undo"><md-icon md-font-set="material-icons">undo</md-icon></md-button>';
	    taTools.redo.display = '<md-button class="md-icon-button" aria-label="Redo"><md-icon md-font-set="material-icons">redo</md-icon></md-button>';
	    taTools.justifyLeft.display = '<md-button class="md-icon-button" aria-label="Align left"><md-icon md-font-set="material-icons">format_align_left</md-icon></md-button>';
	    taTools.justifyRight.display = '<md-button class="md-icon-button" aria-label="Align right"><md-icon md-font-set="material-icons">format_align_right</md-icon></md-button>';
	    taTools.justifyCenter.display = '<md-button class="md-icon-button" aria-label="Align center"><md-icon md-font-set="material-icons">format_align_center</md-icon></md-button>';
	    taTools.justifyFull.display = '<md-button class="md-icon-button" aria-label="Justify"><md-icon md-font-set="material-icons">format_align_justify</md-icon></md-button>';
	    taTools.clear.display = '<md-button class="md-icon-button" aria-label="Clear formatting"><md-icon md-font-set="material-icons">format_clear</md-icon></md-button>';
	    taTools.html.display = '<md-button class="md-icon-button" aria-label="Show HTML"><md-icon md-font-set="material-icons">code</md-icon></md-button>';
	    taTools.insertLink.display = '<md-button class="md-icon-button" aria-label="Insert link"><md-icon md-font-set="material-icons">insert_link</md-icon></md-button>';
	    taTools.insertImage.display = '<md-button class="md-icon-button" aria-label="Insert photo"><md-icon md-font-set="material-icons">insert_photo</md-icon></md-button>';
	    return taTools;
	  }]);
	}]).run(["$mdDateLocale", function ($mdDateLocale) {
	  'ngInject';

	  $mdDateLocale.firstDayOfWeek = 1;
	}]);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _interceptor = __webpack_require__(2);

	var _interceptor2 = _interopRequireDefault(_interceptor);

	var _facade = __webpack_require__(3);

	var _facade2 = _interopRequireDefault(_facade);

	var _datasets = __webpack_require__(4);

	var _datasets2 = _interopRequireDefault(_datasets);

	var _urlTemplate = __webpack_require__(6);

	var _urlTemplate2 = _interopRequireDefault(_urlTemplate);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusApi', []).factory('lectusApi', _facade2.default).factory('lectusInterceptor', _interceptor2.default).factory('datasets', _datasets2.default).service("urlTemplate", _urlTemplate2.default).constant("lectusLanguages", [{ code: "fr", name: "Français" }, { code: "en", name: "English" }]).config(["$httpProvider", function lectusApiConfig($httpProvider) {
	  'ngInject';

	  $httpProvider.interceptors.push('lectusInterceptor');
	}]).run(["$rootScope", "lectusLanguages", function ($rootScope, lectusLanguages) {
	  'ngInject';

	  $rootScope.languages = lectusLanguages;
	}]);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	lectusInterceptor.$inject = ["$log", "apiUrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lectusInterceptor;
	function lectusInterceptor($log, apiUrl) {
	  "ngInject";
	  //$log.debug('$log is here to show you that this is a regular factory with injection');

	  return {
	    /*
	    request: function (config) {
	      config.headers.Authorization = 'Bearer 123';
	      return config;
	    },
	    */
	    /*
	    responseError: function(res) {
	      if (res.config.url.indexOf(apiUrl) !== 0) return res;
	      if (res.status === 401) {
	        $log.debug('redirect to login');
	      }
	      return res;
	    },
	    */
	    response: function response(res) {
	      // funny way of precondition checking
	      switch (true) {
	        case res.config.url.indexOf(apiUrl) !== 0:
	        case res.status > 299:
	        case !(res.data.links && res.data.links.base):
	          return res;
	      }
	      /*
	              if (res.config.url.indexOf(apiUrl) !== 0) return res;
	              $log.debug('intercpt', res);
	              if (res.status > 299) return res;
	              var links = res.data.links;
	              if (!links || !links.base) {
	                return res;
	              }
	              */
	      var data = res.data;
	      var links = data.links;
	      var base = data.links.base;
	      Object.keys(links).filter(function (rel) {
	        return rel !== 'base';
	      }).forEach(function (rel) {
	        return links[rel] = normalizeLink(links[rel], base);
	      });

	      if (res.data.items) {
	        res.data.items.forEach(function (item) {
	          if (!item.links) {
	            return;
	          }
	          normalizeLinks(item.links, base);
	          if (item.links && item.links.self && item.links.self.allow) {
	            permissions(item);
	          }
	        });
	      }
	      // collection permidssion
	      permissions(res.data);
	      return res;
	    }
	  };

	  function normalizeLinks(links, _base) {
	    var base = links.base || _base;
	    if (!base) return;

	    Object.keys(links).filter(function (rel) {
	      return rel !== 'base';
	    }).forEach(function (rel) {
	      return links[rel] = normalizeLink(links[rel], base);
	    });
	  }

	  function normalizeLink(_link, base) {
	    var link = angular.isString(_link) ? {
	      href: _link,
	      allow: []
	    } : _link;
	    // if relative
	    if (link.href.match(/^\/[^\/]*/)) {
	      link.href = base + link.href;
	    }
	    link.allow = link.allow || ['GET'];
	    return link;
	  }

	  function permissions(resource) {
	    // hackish way of find out that it is a collection
	    if (resource.items) {
	      collectionPermissions(resource);
	    } else if (resource.links.self) {
	      //$log.debug(resource.links.self, resource.links.self.allow);
	      resource.permissions = {
	        edit: _.intersection(resource.links.self.allow, ['PATCH', 'PUT']).length > 0,
	        delete: resource.links.self.allow.indexOf('DELETE') > -1
	      };
	    }
	  }

	  function collectionPermissions(collection) {
	    var link = collection.links.start || collection.links.self;
	    collection.permissions = {
	      add: link.allow.indexOf('POST') > -1,
	      edit: link.allow.indexOf('PATCH') > -1
	    };
	  }
	}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	"use strict";

	apiFacade.$inject = ["$http", "$log", "urlTemplate", "apiUrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = apiFacade;
	function apiFacade($http, $log, urlTemplate, apiUrl) {
	  'ngInject';

	  var links = null;

	  return $http.get(apiUrl).then(function (res) {
	    $log.debug(res.data);
	    links = res.data.links;
	    Object.keys(links).forEach(function (rel) {
	      if (links[rel].template) {
	        links[rel].href = urlTemplate.parse(links[rel].template);
	      }
	    });
	    return {
	      links: links,
	      allowed: allowed,
	      call: call
	    };
	  });

	  function getUrl(rel, tokens) {
	    return links[rel].template ? links[rel].href.expand(tokens) : links[rel].href;
	  }

	  function allowed(method, rel) {
	    return links[rel] && links[rel].methods && links[rel].methods.indexOf(method) > -1;
	  }

	  function call(method, rel, tokens, config) {
	    var url = getUrl(rel, tokens);
	    //$log.debug('call', arguments);
	    $log.debug("calling", url);
	    return $http(angular.extend({
	      method: method,
	      url: url
	    }, config));
	  }
	}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	datasets.$inject = ["lectusApi", "$http", "$q"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = datasets;
	var _ = __webpack_require__(5);

	function datasets(lectusApi, $http, $q) {
	  "ngInject";

	  var cache = {};

	  return {
	    get: get,
	    clear: clear,
	    bindSets: bindSets
	  };

	  function bindSets(names, target, indexed, opts) {
	    return $q.all(names.map(function (n) {
	      return get(n, opts);
	    })).then(function (results) {
	      return results.map(function (collection, i) {
	        var n = _.camelCase(names[i]);
	        target[n] = indexed ? _.keyBy(collection.items, "code") : collection.items;
	        return collection;
	      });
	    });
	  }

	  function get(dsName, opts) {
	    if (opts) {
	      return fetch(dsName, opts);
	    }
	    if (!cache[dsName]) {
	      cache[dsName] = fetch(dsName);
	    }
	    return cache[dsName];
	  }

	  function clear(dsName) {
	    if (angular.isString(dsName)) {
	      cache[dsName] = null;
	    } else {
	      Object.keys(cache).forEach(function (k) {
	        cache[k] = null;
	      });
	    }
	  }

	  function fetch(dsName, opts) {
	    var promise = lectusApi.then(function (lectus) {
	      return $http.get(lectus.links[dsName].href, opts);
	    }, function (error) {
	      clear(dsName);
	      return $q.reject(error);
	    }).then(function (res) {
	      return res.data;
	    }, function (error) {
	      clear(dsName);
	      return $q.reject(error);
	    });
	    if (!opts) {
	      cache[dsName] = promise;
	    }
	    return promise;
	  }
	}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = _;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UrlTemplate;
	/* eslint angular/definedundefined: 0 */
	/* eslint angular/typecheck-array: 0 */
	/* eslint angular/typecheck-string: 0 */
	/* eslint angular/typecheck-number: 0 */

	function UrlTemplate() {}
	/**
	 * @private
	 * @param {string} str
	 * @return {string}
	 */
	UrlTemplate.prototype.encodeReserved = function (str) {
	  return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
	    if (!/%[0-9A-Fa-f]/.test(part)) {
	      part = encodeURI(part).replace(/%5B/g, '[').replace(/%5D/g, ']');
	    }
	    return part;
	  }).join('');
	};

	/**
	 * @private
	 * @param {string} str
	 * @return {string}
	 */
	UrlTemplate.prototype.encodeUnreserved = function (str) {
	  return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	  });
	};

	/**
	 * @private
	 * @param {string} operator
	 * @param {string} value
	 * @param {string} key
	 * @return {string}
	 */
	UrlTemplate.prototype.encodeValue = function (operator, value, key) {
	  value = operator === '+' || operator === '#' ? this.encodeReserved(value) : this.encodeUnreserved(value);

	  if (key) {
	    return this.encodeUnreserved(key) + '=' + value;
	  } else {
	    return value;
	  }
	};

	/**
	 * @private
	 * @param {*} value
	 * @return {boolean}
	 */
	UrlTemplate.prototype.isDefined = function (value) {
	  return value !== undefined && value !== null;
	};

	/**
	 * @private
	 * @param {string}
	 * @return {boolean}
	 */
	UrlTemplate.prototype.isKeyOperator = function (operator) {
	  return operator === ';' || operator === '&' || operator === '?';
	};

	/**
	 * @private
	 * @param {Object} context
	 * @param {string} operator
	 * @param {string} key
	 * @param {string} modifier
	 */
	UrlTemplate.prototype.getValues = function (context, operator, key, modifier) {
	  var value = context[key],
	      result = [];

	  if (this.isDefined(value) && value !== '') {
	    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	      value = value.toString();

	      if (modifier && modifier !== '*') {
	        value = value.substring(0, parseInt(modifier, 10));
	      }

	      result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
	    } else {
	      if (modifier === '*') {
	        if (Array.isArray(value)) {
	          value.filter(this.isDefined).forEach(function (value) {
	            result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
	          }, this);
	        } else {
	          Object.keys(value).forEach(function (k) {
	            if (this.isDefined(value[k])) {
	              result.push(this.encodeValue(operator, value[k], k));
	            }
	          }, this);
	        }
	      } else {
	        var tmp = [];

	        if (Array.isArray(value)) {
	          value.filter(this.isDefined).forEach(function (value) {
	            tmp.push(this.encodeValue(operator, value));
	          }, this);
	        } else {
	          Object.keys(value).forEach(function (k) {
	            if (this.isDefined(value[k])) {
	              tmp.push(this.encodeUnreserved(k));
	              tmp.push(this.encodeValue(operator, value[k].toString()));
	            }
	          }, this);
	        }

	        if (this.isKeyOperator(operator)) {
	          result.push(this.encodeUnreserved(key) + '=' + tmp.join(','));
	        } else if (tmp.length !== 0) {
	          result.push(tmp.join(','));
	        }
	      }
	    }
	  } else {
	    if (operator === ';') {
	      if (this.isDefined(value)) {
	        result.push(this.encodeUnreserved(key));
	      }
	    } else if (value === '' && (operator === '&' || operator === '?')) {
	      result.push(this.encodeUnreserved(key) + '=');
	    } else if (value === '') {
	      result.push('');
	    }
	  }
	  return result;
	};

	/**
	 * @param {string} template
	 * @return {function(Object):string}
	 */
	UrlTemplate.prototype.parse = function (template) {
	  var that = this;
	  var operators = ['+', '#', '.', '/', ';', '?', '&'];

	  return {
	    expand: function expand(context) {
	      return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function (_, expression, literal) {
	        if (expression) {
	          var operator = null,
	              values = [];

	          if (operators.indexOf(expression.charAt(0)) !== -1) {
	            operator = expression.charAt(0);
	            expression = expression.substr(1);
	          }

	          expression.split(/,/g).forEach(function (variable) {
	            var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
	            values.push.apply(values, that.getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
	          });

	          if (operator && operator !== '+') {
	            var separator = ',';

	            if (operator === '?') {
	              separator = '&';
	            } else if (operator !== '#') {
	              separator = operator;
	            }
	            return (values.length !== 0 ? operator : '') + values.join(separator);
	          } else {
	            return values.join(',');
	          }
	        } else {
	          return that.encodeReserved(literal);
	        }
	      });
	    }
	  };
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _module = __webpack_require__(8);

	var _module2 = _interopRequireDefault(_module);

	var _module3 = __webpack_require__(16);

	var _module4 = _interopRequireDefault(_module3);

	var _module5 = __webpack_require__(24);

	var _module6 = _interopRequireDefault(_module5);

	var _module7 = __webpack_require__(30);

	var _module8 = _interopRequireDefault(_module7);

	var _module9 = __webpack_require__(34);

	var _module10 = _interopRequireDefault(_module9);

	var _module11 = __webpack_require__(37);

	var _module12 = _interopRequireDefault(_module11);

	var _module13 = __webpack_require__(52);

	var _module14 = _interopRequireDefault(_module13);

	var _module15 = __webpack_require__(58);

	var _module16 = _interopRequireDefault(_module15);

	var _module17 = __webpack_require__(61);

	var _module18 = _interopRequireDefault(_module17);

	var _module19 = __webpack_require__(64);

	var _module20 = _interopRequireDefault(_module19);

	var _module21 = __webpack_require__(67);

	var _module22 = _interopRequireDefault(_module21);

	var _module23 = __webpack_require__(70);

	var _module24 = _interopRequireDefault(_module23);

	var _module25 = __webpack_require__(74);

	var _module26 = _interopRequireDefault(_module25);

	var _routes = __webpack_require__(77);

	var _routes2 = _interopRequireDefault(_routes);

	var _component = __webpack_require__(78);

	var _component2 = _interopRequireDefault(_component);

	var _component3 = __webpack_require__(79);

	var _component4 = _interopRequireDefault(_component3);

	var _component5 = __webpack_require__(80);

	var _component6 = _interopRequireDefault(_component5);

	var _component7 = __webpack_require__(81);

	var _component8 = _interopRequireDefault(_component7);

	var _component9 = __webpack_require__(82);

	var _component10 = _interopRequireDefault(_component9);

	var _component11 = __webpack_require__(83);

	var _component12 = _interopRequireDefault(_component11);

	var _component13 = __webpack_require__(84);

	var _component14 = _interopRequireDefault(_component13);

	var _component15 = __webpack_require__(86);

	var _component16 = _interopRequireDefault(_component15);

	var _component17 = __webpack_require__(87);

	var _component18 = _interopRequireDefault(_component17);

	var _component19 = __webpack_require__(88);

	var _component20 = _interopRequireDefault(_component19);

	var _component21 = __webpack_require__(89);

	var _component22 = _interopRequireDefault(_component21);

	var _component23 = __webpack_require__(92);

	var _component24 = _interopRequireDefault(_component23);

	var _component25 = __webpack_require__(94);

	var _component26 = _interopRequireDefault(_component25);

	var _component27 = __webpack_require__(95);

	var _component28 = _interopRequireDefault(_component27);

	var _component29 = __webpack_require__(97);

	var _component30 = _interopRequireDefault(_component29);

	var _component31 = __webpack_require__(98);

	var _component32 = _interopRequireDefault(_component31);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global moment:false */

	exports.default = angular.module("lectusProperty", ["ngAnimate", "ngSanitize", "ngMessages", "ngAria", "ui.router", "ngMaterial", "md.data.table", "ui-leaflet", "nvd3",
	//  "mdSteppers",
	"lectusApi", _module8.default.name, _module10.default.name, _module2.default.name, _module4.default.name, _module6.default.name, _module12.default.name, _module14.default.name, _module16.default.name, _module18.default.name, _module22.default.name, _module20.default.name, _module24.default.name, _module26.default.name])
	//.constant("malarkey", malarkey)
	.constant("moment", moment).component(_component2.default.name, _component2.default).component(_component4.default.name, _component4.default).component(_component6.default.name, _component6.default).component(_component8.default.name, _component8.default).component(_component10.default.name, _component10.default).component(_component12.default.name, _component12.default).component(_component14.default.name, _component14.default).component(_component22.default.name, _component22.default).component(_component24.default.name, _component24.default).component(_component26.default.name, _component26.default).component(_component28.default.name, _component28.default).component(_component18.default.name, _component18.default).component(_component20.default.name, _component20.default).component(_component16.default.name, _component16.default).component(_component30.default.name, _component30.default)

	// dashboard
	//.component(calendarChart.name, calendarChart)
	.component(_component32.default.name, _component32.default).config(_routes2.default).run(["$transitions", function ($transitions) {
	  "ngInject";
	  // default sub state for property, because abstract states are messy

	  $transitions.onBefore({ to: "property" }, function (transition) {
	    // console.log(transition.params(), transition.router.stateService);
	    if (transition.params().property !== "new") {
	      return transition.router.stateService.target("property.dashboard", transition.params());
	    }
	  });
	}]);
	// import modAmenities from "../amenities/module";

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(9);

	var _component2 = _interopRequireDefault(_component);

	var _component3 = __webpack_require__(11);

	var _component4 = _interopRequireDefault(_component3);

	var _controller = __webpack_require__(12);

	var _controller2 = _interopRequireDefault(_controller);

	var _controller3 = __webpack_require__(13);

	var _controller4 = _interopRequireDefault(_controller3);

	var _helper = __webpack_require__(14);

	var _helper2 = _interopRequireDefault(_helper);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusAllotments', ['ui.router', 'lectusApi', 'dndLists']).component(_component2.default.name, _component2.default).component(_component4.default.name, _component4.default).factory("allotmentsHelper", _helper2.default).controller("AllotmentAddCtrl", _controller2.default).controller("AllotmentCalendarEditCtrl", _controller4.default).config(["$stateProvider", function allotmentRoutes($stateProvider) {
	  'ngInject';
	  // State

	  $stateProvider.state('property.allotments', {
	    url: '/allotments',
	    component: 'unitRelWrapper',
	    resolve: {
	      breadcrumb: function breadcrumb() {
	        [{ label: 'Allotments' }];
	      },
	      unitViewState: function unitViewState() {
	        return 'property.allotments.unit';
	      }
	    },
	    data: {
	      menu: {
	        label: 'Allotements',
	        group: 'Tarifs et dispo',
	        position: 1
	      }
	    }
	  }).state('property.allotments.unit', {
	    url: '/:unit',
	    component: _component2.default.name,
	    resolve: {
	      unitCode: ["$stateParams", function unitCode($stateParams) {
	        'ngInject';

	        return $stateParams.unit;
	      }]
	    }
	  });
	}]);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	UnitAllotmentsCtrl.$inject = ["User", "$scope", "$log", "$q", "$http", "allotmentsHelper", "$mdDialog", "$state"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moment = __webpack_require__(10);
	var _ = __webpack_require__(5);

	exports.default = {
	  name: 'unitAllotments',
	  controller: UnitAllotmentsCtrl,
	  templateUrl: 'app/allotment/unit/template.html',
	  bindings: {
	    unitCode: '<unitCode'
	  },
	  require: {
	    unitListCtrl: '^unitRelWrapper',
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function UnitAllotmentsCtrl(User, $scope, $log, $q, $http, allotmentsHelper, $mdDialog, $state) {
	  "ngInject";

	  var vm = this;
	  // colors are used for each allotment
	  //const colors = ['#00bcd4', '#2196f3', '#03a9f4', '#3f51b5', '#9c27b0'];
	  //const COLOR_OPEN_SELL = '#8BC34A';
	  var period = {
	    start: moment().startOf('day'),
	    end: moment().startOf('day').add(1, 'years')
	  };
	  var graphDates = allotmentsHelper.makeGraphDates(period);

	  angular.extend(vm, {
	    $onInit: onInit,
	    // min max should be calculated from rate bases
	    period: period,
	    availabilityGraphData: [],
	    releaseGraphData: [],
	    availabilityGraphOptions: allotmentsHelper.availabilityGraphOptions(period, graphDates),
	    releaseGraphOptions: allotmentsHelper.releaseGraphOptions(period, graphDates),
	    editCalendar: editCalendar
	  });

	  $scope.$on("allotmentAdded", onAllotmentAdded);
	  $scope.$on("allotmentDeleted", onAllotmentDeleted);
	  $scope.$on("allotmentUpdated", onAllotmentUpdated);

	  function onInit() {
	    var task1 = vm.unitListCtrl.whenReady.then(function () {
	      return vm.unitListCtrl.activateUnit(vm.unitCode);
	    }).then(function (unit) {
	      vm.unit = unit;
	      return _loadUnitAllotments(unit);
	    });
	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });
	    var task2 = vm.propertyCtrl.get('rate-bases').then(function (collection) {
	      vm.rateBases = collection.items;
	      vm.rateBasesIndex = _.keyBy(vm.rateBases, "code");
	    });

	    var task3 = vm.propertyCtrl.get('seasons').then(function (collection) {
	      vm.seasons = collection.items;
	      vm.seasonsIndex = _.keyBy(vm.seasons, "code");
	    });

	    $q.all([task1, task2]).then(setCalendarPermissions).catch(function (error) {
	      return $log.error(error);
	    });
	  }

	  function setCalendarPermissions() {
	    var editable = vm.allotments.filter(function (a) {
	      return a.permissions.edit;
	    });

	    vm.availabilityEditable = editable.length > 0;
	    vm.releaseEditable = editable.length > 0;
	  }

	  function _loadUnitAllotments(unit) {
	    return $http.get(unit.links.allotments.href).then(processLoadedAllotments);
	  }

	  function processLoadedAllotments(res) {
	    angular.extend(vm, {
	      permissions: res.data.permissions,
	      links: res.data.links,
	      allotments: res.data.items.sort(function (a) {
	        return a.contracted === false ? 1 : 0;
	      }).map(allotmentsHelper.allotmentColor)
	    });
	    vm.openSell = vm.allotments.find(function (a) {
	      return a.contracted === false;
	    });
	    // load allotments in series... (why by the way?)
	    if (vm.allotments.length) {
	      return _series(vm.allotments.slice(0));
	    }
	    return true;
	  }

	  function _series(list) {
	    return loadAllotmentCalendar(list[0]).then(function () {
	      list.shift();
	      if (list.length) {
	        return _series(list);
	      }
	      return true;
	    });
	  }

	  function loadAllotmentCalendar(a) {
	    var def = $q.defer();
	    $http.get(a.links.calendar.href, {
	      params: {
	        $sort: "date<",
	        start: vm.period.start.format('YYYY-MM-DD'),
	        end: vm.period.end.format('YYYY-MM-DD')
	      }
	    }).then(function (res) {
	      def.resolve(res.data);
	      processLoadedCalendar(a, res.data.items);
	    });
	    return def.promise;
	  }

	  function processLoadedCalendar(a, calendar) {
	    var prefix = a.contracted ? "allot." : "flex";
	    var bases = a.bases.map(function (code) {
	      return vm.rateBasesIndex[code].description;
	    }).join(',');
	    a.label = prefix + '(' + bases + ')';
	    allotmentsHelper.calendarToGraphs(a, calendar, vm.period, vm.availabilityGraphData, vm.releaseGraphData);
	  }

	  function onAllotmentAdded(e, a) {
	    $state.reload();
	  }

	  function onAllotmentDeleted(e, a) {
	    $state.reload();
	  }

	  function onAllotmentUpdated() /*e,a*/{
	    $state.reload();
	  }

	  function editCalendar($event, field) {
	    $mdDialog.show({
	      targetEvent: $event,
	      templateUrl: 'app/allotment/calendar-edit/dialog.html',
	      locals: {
	        unit: vm.unit,
	        rateBases: vm.rateBases,
	        allotments: vm.allotments,
	        seasons: vm.seasons,
	        fields: [field]
	      },
	      controller: 'AllotmentCalendarEditCtrl',
	      controllerAs: '$ctrl'
	    }).then(function (changes) {
	      $log.debug(changes);
	      //vm.availabilityGraphData.length = 0;
	      //vm.releaseGraphData.length = 0;
	      vm.allotments.filter(function (a) {
	        return changes.allotments.includes(a.code);
	      }).forEach(function (a) {
	        return loadAllotmentCalendar(a, vm.allotments.indexOf(a));
	      });
	      // apply changes locally, no round trip
	    });
	  }
	}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = moment;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	AllotmentBasesCtrl.$inject = ["$scope", "$log", "$q", "$http", "$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _ = __webpack_require__(5);

	exports.default = {
	  name: 'allotmentBasesEditor',
	  controller: AllotmentBasesCtrl,
	  templateUrl: 'app/allotment/bases-assignments/template.html',
	  require: {
	    unitAllotments: "^",
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function AllotmentBasesCtrl($scope, $log, $q, $http, $mdDialog) {
	  "ngInject";

	  var vm = this;
	  var unassignedRateBases = [];

	  angular.extend(vm, {
	    $onInit: onInit,
	    // min max should be calculated from rate bases
	    unassignedRateBases: unassignedRateBases,
	    unassignRateBasis: unassignRateBasis,
	    dropBasisOnAllotment: dropBasisOnAllotment,
	    deleteAllotment: deleteAllotment,
	    createAllotment: createAllotment,
	    createOpenSell: createOpenSell,
	    editAllowed: editAllowed
	  });

	  function editAllowed(allotment) {
	    // console.log(allotment.permissions.edit)
	    return allotment.permissions.edit;
	  }

	  function onInit() {
	    var rbDef = $q.defer();
	    var allotDef = $q.defer();
	    var stopWatch1 = $scope.$watch(function () {
	      return vm.unitAllotments.rateBases;
	    }, function (val) {
	      if (angular.isArray(val)) {
	        vm.rateBases = val;
	        rbDef.resolve();
	        stopWatch1();
	      }
	    });
	    var stopWatch2 = $scope.$watch(function () {
	      return vm.unitAllotments.allotments;
	    }, function (val) {
	      if (angular.isArray(val)) {
	        allotDef.resolve();
	        stopWatch2();
	      }
	    });

	    $q.all([rbDef.promise, allotDef.promise]).then(_refreshUnassignedBases);
	  }

	  function createOpenSell() {
	    var data = {
	      unit: vm.unitAllotments.unit.code,
	      contracted: false,
	      bases: vm.rateBases.map(function (rb) {
	        return rb.code;
	      })
	    };
	    postAllotment(data);
	  }

	  function createAllotment() {
	    $mdDialog.show({
	      controller: 'AllotmentAddCtrl',
	      controllerAs: '$ctrl',
	      templateUrl: 'app/allotment/add/template.html',
	      locals: {
	        unit: vm.unitAllotments.unit,
	        allotments: vm.unitAllotments.allotments,
	        rateBases: unassignedRateBases,
	        property: vm.propertyCtrl.property
	      }
	    }).then(function (allotment) {
	      if (allotment) {
	        $log.debug('done allotment', allotment);
	        return postAllotment(allotment);
	      }
	    }).then(_refreshUnassignedBases);
	  }

	  function postAllotment(allotment) {
	    return $http.post(vm.unitAllotments.links.self.href, allotment).then(function (res) {
	      $log.debug('created', res.data);
	      $scope.$emit("allotmentAdded", res.data);
	    }, function () {
	      $log.error(arguments);
	      // return $q.reject()
	    });
	  }

	  function deleteAllotment(a) {
	    if (a.permissions.delete == false) {
	      return;
	    }
	    var title = a.contracted ? "cette allotment" : "l'open sell";
	    var msg;
	    if (a.contracted) {
	      if (vm.openSell && vm.openSell.bases.length === vm.rateBases.length) {
	        msg = "Cette operation est irreversible!";
	      } else {
	        msg = "Tous les produits des base tarifaire associées seront indiponibles à la vente tant que vous ne les aurez pas réafecter à un allotement ou à l'open sell";
	      }
	    } else {
	      msg = "Cette operation est irreversible";
	    }
	    $mdDialog.show($mdDialog.confirm().clickOutsideToClose(true).title("Etes-vous sur de vouloir supprimer " + title + " ?").textContent(msg).ariaLabel("Confirmation de suppression").ok("Supprimer").cancel('Annuler')).then(function () {
	      return $http.delete(a.links.self.href).then(function () {
	        return $scope.$emit("allotmentDeleted", a);
	      }, function (err) {
	        return $log.error(err);
	      });
	    }).then(_refreshUnassignedBases);
	  }

	  function dropBasisOnAllotment(basisCode, a) {
	    if (a.permissions.edit == false) {
	      return false;
	    }
	    if (a.bases.indexOf(basisCode) > -1) {
	      return false;
	    }
	    var bases = a.bases.slice(0);
	    bases.push(basisCode);

	    //console.log('bases',bases, basisCode);
	    _updateAllotmentBases(a, bases).then(function () {
	      a.bases.push(basisCode);
	      if (a.contracted) {
	        var basis = vm.rateBases.find(function (rb) {
	          return rb.code === basisCode;
	        });
	        var i = unassignedRateBases.indexOf(basis);
	        if (i >= 0) {
	          unassignedRateBases.splice(i, 1);
	        }
	      }
	    }, function (errorRes) {
	      return $log.error(errorRes);
	    });

	    return true;
	  }

	  function unassignRateBasis(basis, a) {
	    $mdDialog.show($mdDialog.confirm().clickOutsideToClose(true).title('Retier la base tarifaire ?').textContent("Tous les produits de cette base tarifaie seront indiponibles à la vente tant que vous ne l'aurez pas réafecter à un allotment").ariaLabel('Alert Dialog Demo').ok('Retirer la base tarifire').cancel('Annuler')).then(function () {
	      var bases = a.bases.filter(function (code) {
	        return code !== basis;
	      });
	      //$log.debug('bases',bases, basis);
	      _updateAllotmentBases(a, bases).then(function () {
	        a.bases = bases;
	        if (a.contracted) {
	          _refreshUnassignedBases();
	        }
	      }, function (errorRes) {
	        return $log.error(errorRes);
	      });
	    });
	  }

	  function _updateAllotmentBases(allotment, bases) {
	    return $http.put(allotment.links.self.href, {
	      code: allotment.code,
	      bases: bases
	    }).then(function () {
	      _refreshUnassignedBases();
	      $log.debug('put ok');
	    });
	  }

	  function _refreshUnassignedBases() {
	    unassignedRateBases.length = 0;
	    var assigned = vm.unitAllotments.allotments.filter(function (a) {
	      return a.contracted;
	    }).reduce(function (agg, a) {
	      return _.union(agg, a.bases);
	    }, []);

	    vm.rateBases.filter(function (rb) {
	      return assigned.includes(rb.code) === false;
	    }).forEach(function (rb) {
	      return unassignedRateBases.push(rb);
	    });
	    $log.debug('unassignedRateBases', unassignedRateBases);
	  }
	}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';

	AllotmentAddCtrl.$inject = ["$log", "$mdDialog", "$http", "unit", "allotments", "rateBases"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AllotmentAddCtrl;
	function AllotmentAddCtrl($log, $mdDialog, $http, unit, allotments, rateBases) {
	  'ngInject';

	  var vm = this;
	  $log.debug(rateBases, allotments);
	  angular.extend(vm, {
	    unit: unit,
	    add: add,
	    close: function close() {
	      return $mdDialog.cancel();
	    },
	    selectedRateBases: {},
	    rateBases: rateBases,
	    options: {
	      availableRateBases: rateBases
	    }
	  });

	  function add() {
	    var bools = vm.selectedRateBases;
	    var allotment = {
	      unit: unit.code,
	      contracted: true,
	      bases: Object.keys(bools).filter(function (basisCode) {
	        return bools[basisCode] === true;
	      }).map(function (basisCode) {
	        return parseInt(basisCode, 10);
	      })
	    };
	    if (allotment.bases.length === 0) {
	      // XXX
	      vm.error = true;
	    } else {
	      $log.debug(allotment);
	      $mdDialog.hide(allotment);
	    }
	  }
	}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	"use strict";

	AllotmentCalendarEditCtrl.$inject = ["$log", "apiUrl", "unit", "rateBases", "allotments", "seasons", "fields", "$http", "$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AllotmentCalendarEditCtrl;
	function AllotmentCalendarEditCtrl($log, apiUrl, unit, rateBases, allotments, seasons, fields, $http, $mdDialog) {
	  "ngInject";

	  var PATCH_URL = apiUrl + "/commands/patch-allotments-calendar";
	  var vm = this;

	  //console.log(rateBases);
	  var editable = allotments.filter(function (a) {
	    return a.permissions.edit;
	  });

	  angular.extend(vm, {
	    cancel: function cancel() {
	      return $mdDialog.cancel();
	    },
	    applyChanges: applyChanges,
	    unit: unit,
	    rateBases: rateBases,
	    seasons: seasons,
	    periods: [],
	    ranges: [],
	    edit: {
	      available: fields.includes("available"),
	      release: fields.includes("release")
	    },
	    allotments: editable.map(function (a) {
	      return {
	        code: a.code,
	        contracted: a.contracted,
	        selected: true,
	        label: a.contracted ? "allotment" : "open sell",
	        bases: a.bases.map(function (b) {
	          return rateBases.find(function (rb) {
	            return rb.code === b;
	          }).description;
	        }),
	        style: {
	          "background-color": a.color
	        },
	        available: null,
	        release: null
	      };
	    }),
	    someContracted: editable.filter(function (a) {
	      return a.contracted;
	    }).length > 0
	  });

	  function applyChanges() {
	    var args = {
	      periods: vm.getPeriods(),
	      allotments: []
	    };
	    if (vm.seasonMode) {

	      var finalRanges = [];
	      console.log("rangesranges::", vm.ranges);
	      vm.ranges.map(function (r) {
	        r.ranges.map(function (rg) {
	          finalRanges.push(rg);
	        });

	        console.log("r.ranges::", r.ranges);
	      });
	      console.log("r.finalRanges::", finalRanges);

	      args.periods = finalRanges;
	    }

	    var availabilities = [];
	    var releases = [];

	    vm.allotments.filter(function (a) {
	      return a.selected;
	    }).forEach(function (a) {
	      args.allotments.push(a.code);
	      availabilities.push(a.available);
	      releases.push(a.contracted ? a.release : 0);
	    });
	    if (vm.edit.available) {
	      args.availabilities = availabilities;
	    }
	    if (vm.edit.release) {
	      args.releases = releases;
	    }

	    //console.log('args',args);
	    //return;

	    $http.post(PATCH_URL, args).then(function () {
	      $log.debug("nights updated");
	      $mdDialog.hide(args);
	    }, patchError);
	  }

	  function patchError() {}
	}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = allotmentsHelper;

	var moment = __webpack_require__(10);
	var d3 = __webpack_require__(15);

	function allotmentsHelper() {

	  var intFormat = d3.format(',f');

	  var GRAPH_MARGINS = {
	    top: 40,
	    right: 40,
	    bottom: 40,
	    left: 40
	  };

	  var colors = ['#8BC34A', '#00bcd4', '#2196f3', '#03a9f4', '#3f51b5', '#9c27b0', '#9c58b0', '#0f69b0', '#5d79b0', '#5a15f0', '#7b86f0', '#8BC34A', '#00bcd4'];
	  //var d3TimeFormat = d3.time.format("%d-%m-%Y");
	  return {
	    availabilityGraphOptions: availability,
	    releaseGraphOptions: release,
	    calendarToGraphs: calendarToGraphs,
	    colors: colors,
	    allotmentColor: allotmentColor,
	    makeGraphDates: makeGraphDates
	  };

	  function makeGraphDates(period) {
	    var last = period.end;
	    var dates = [];
	    var date = moment(period.start).startOf('month');
	    while (date.isBefore(last)) {
	      dates.push(date.clone().toDate());
	      date.add(1, 'months');
	    }
	    return dates;
	  }

	  function allotmentColor(a, index) {
	    var color = a.contracted ? colors[index + 1] : colors[0];
	    var light = d3.hsl(color);
	    light.l = 0.87;
	    angular.extend(a, {
	      color: color,
	      lightColor: light.toString(),
	      style: {
	        'background-color': color
	      }
	    });
	    return a;
	  }

	  function calendarToGraphs(a, calendar, period, availabilityGraph, releaseGraph) {
	    var series = {
	      code: a.code,
	      allotment: a,
	      color: a.color,
	      key: a.label || (a.contracted ? "allotement " + a.code : "open sell"),
	      values: _fillCalendar(calendar, period)
	    };
	    if (angular.isArray(availabilityGraph)) {
	      addAvailabilitySeries(a, series, availabilityGraph);
	    }
	    if (angular.isArray(releaseGraph)) {
	      addReleaseSeries(a, series, releaseGraph);
	    }
	  }
	  /*
	    function addBookedSeries(availabilityGraphData) {
	      var availValues = availabilityGraphData.map(series => series.values);
	      var i = availValues[0].length;
	      var bookedValues = new Array(i);
	      var sum = (i) => {
	        availValues.reduce((agg,dates) => agg+dates[i].booked,0);
	      };
	      while(i--) {
	        bookedValues[i-1] = sum(i);
	      }
	  
	  
	    }
	    */

	  function addAvailabilitySeries(allotment, series, graphs) {
	    var index = graphs.map(function (s) {
	      return s.code;
	    }).indexOf(allotment.code);
	    if (index > -1) graphs[index] = series;else if (allotment.contracted) graphs.unshift(series);else
	      // allotment comes last so that in thje graph it's on top
	      graphs.push(series);
	  }

	  function addReleaseSeries(allotment, series, graphs) {
	    var index = graphs.map(function (s) {
	      return s.code;
	    }).indexOf(allotment.code);
	    if (index > -1) graphs[index] = series;else graphs.push(series);
	    //open sell does not show on release graph (always 0)
	  }

	  function formatReleaseDays(val) {
	    return "j-" + intFormat(Math.abs(val));
	  }

	  function availability(period) {

	    var testDate = "Fri Apr 12 2013 19:08:55 GMT-0500 (CDT)";
	    var testDatef = "Fri Apr 12 2014 19:08:55 GMT-0500 (CDT)";

	    var debut = moment(testDate).format('MM/DD/YYYY');
	    console.log("dddddd::", moment(debut).startOf('month').toDate());
	    console.log("moment(period.start).startOf('month').toDate()::", moment(period.start).startOf('month').toDate());
	    console.log("period.end.toDate()::", period.end.toDate());

	    return {
	      deepWatchOptions: false,
	      deepWatchData: false,
	      deepWatchDataDepth: false,
	      chart: {
	        type: "stackedAreaChart",
	        height: 120,
	        margin: GRAPH_MARGINS,
	        useInteractiveGuideline: true,
	        duration: 100,
	        //zoom: zoom,
	        useVoronoi: false,
	        clipEdge: true,
	        x: function x(item) {
	          return item.date;
	        },
	        //xDomain: [moment(period.start).startOf('month').toDate(), period.end.toDate()],
	        // xDomain: [moment(debut).startOf('month').toDate(), period.end.toDate()],

	        xScale: d3.time.scale(),
	        xAxis: {
	          //xScale : d3.time.scale(),
	          tickFormat: _dateTickFormat, //d => moment(d).format('D/M/YYYY'),
	          //tickFormat: d => moment(d).format('M/YYYY'),
	          //tickValues: graphDates,
	          showMaxMin: false,
	          ticks: 12
	        },
	        y: function y(item) {
	          return item.available;
	        },
	        forceY: [0, 4],
	        yAxis: {
	          //ticks:4
	          //showMaxMin: false,
	          tickFormat: intFormat
	        },
	        legend: {
	          maxKeyLength: 400
	        },
	        showControls: false
	      }
	    };
	  }

	  function release(period) {

	    return {
	      deepWatchOptions: false,
	      deepWatchData: false,
	      deepWatchDataDepth: 0,
	      margin: GRAPH_MARGINS,
	      chart: {
	        type: "lineChart",
	        height: 120,
	        margin: GRAPH_MARGINS,
	        useInteractiveGuideline: true,
	        duration: 100,
	        x: function x(item) {
	          return item.date;
	        },
	        xScale: d3.time.scale(),
	        xDomain: [moment(period.start).startOf('month').toDate(), period.end.toDate()],
	        xAxis: {
	          //xScale : d3.time.scale(),
	          tickFormat: _dateTickFormat,
	          //tickValues: graphDates,
	          showMaxMin: false,
	          ticks: 12
	        },
	        y: function y(item) {
	          return item.release;
	        },
	        forceY: [0],
	        yAxis: {
	          //ticks:4
	          tickFormat: formatReleaseDays
	        },
	        legend: {
	          maxKeyLength: 400
	        },
	        showControls: false
	      }
	    };
	  }

	  function _dateTickFormat(d) {
	    var m = moment(d);
	    if (angular.isDefined(this)) return m.month() === 0 ? m.format('D MMM YYYY') : m.format('D MMM');
	    return m.format('ddd D/MM/YYYY');
	  }

	  // d3 hates when series have different length
	  // use this to fill holes in an allotments series
	  function _fillCalendar(items, period) {
	    //console.time('fill');
	    var originalLength = items.length;
	    var length = moment(period.end).diff(period.start, 'days');
	    var final = [];
	    var lastDate = moment(period.start);
	    var i = 0;
	    while (i < originalLength) {
	      var itemDate = moment(new Date(items[i].date));
	      var diff = itemDate.diff(lastDate, 'days');
	      while (diff > 0) {
	        final.push(_emptyDate(moment(itemDate).subtract(diff, 'days')));
	        diff -= 1;
	      }
	      final.push(_asGraphItem(items[i]));
	      lastDate = moment(items[i].date).add(1, 'days');
	      i++;
	    }
	    if (final.length === 0) {
	      //console.log("empty cal");
	      final.push(_emptyDate(moment(lastDate)));
	    }
	    i = final.length;
	    while (i <= length) {
	      final.push(_emptyDate(moment(final[i - 1].date).add(1, 'days')));
	      i++;
	    }
	    //console.timeEnd('fill');
	    //console.log(final.length,final[0].date, final[final.length-1].date);
	    return final;
	  }

	  function _emptyDate(date) {
	    //console.log(date.toDate());
	    return {
	      date: date.toDate(), //format('YYYY-MM-DD'),
	      available: 0,
	      release: 0,
	      booked: 0
	    };
	  }

	  function _asGraphItem(item) {
	    //const d = moment(item.date).toDate();
	    var d = new Date(item.date);
	    return {
	      date: d,
	      available: item.available,
	      //release: daydiff(d, new Date(item.releaseDate.replace('Z','')))
	      // RELEASE IS EXCLUSIVE SO minus another day...
	      release: moment(item.releaseDate.replace('Z', '')).diff(d, 'days') - 1,
	      booked: item.booked || 0
	    };
	  }
	}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = d3;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(17);

	var _component2 = _interopRequireDefault(_component);

	var _component3 = __webpack_require__(18);

	var _component4 = _interopRequireDefault(_component3);

	var _component5 = __webpack_require__(19);

	var _component6 = _interopRequireDefault(_component5);

	var _controller = __webpack_require__(20);

	var _controller2 = _interopRequireDefault(_controller);

	var _controller3 = __webpack_require__(21);

	var _controller4 = _interopRequireDefault(_controller3);

	var _controller5 = __webpack_require__(22);

	var _controller6 = _interopRequireDefault(_controller5);

	var _helper = __webpack_require__(23);

	var _helper2 = _interopRequireDefault(_helper);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module("lectusProducts", ["ui.router", "lectusApi"]).component(_component2.default.name, _component2.default).component(_component4.default.name, _component4.default).component(_component6.default.name, _component6.default).factory("productsHelper", _helper2.default).controller("ProductsAddOccupancyCtrl", _controller2.default).controller("ProductCalendarEditCtrl", _controller4.default).controller("ProductCloneEditCtrl", _controller6.default).config(["$stateProvider", function productRoutes($stateProvider) {
	  "ngInject";
	  // State

	  $stateProvider.state("property.products", {
	    url: "/products",
	    component: "unitRelWrapper",
	    resolve: {
	      breadcrumb: function breadcrumb() {
	        [{ label: "Offres" }];
	      },
	      unitViewState: function unitViewState() {
	        return "property.products.unit";
	      }
	    },
	    data: {
	      menu: {
	        label: "Pensions",
	        group: "Tarifs et dispo",
	        position: 2
	      }
	    }
	  }).state("property.products.unit", {
	    url: "/:unit",
	    component: _component2.default.name,
	    resolve: {
	      unitCode: ["$stateParams", function unitCode($stateParams) {
	        "ngInject";

	        return $stateParams.unit;
	      }]
	    }
	  });
	}]);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	UnitProductsCtrl.$inject = ["User", "$log", "$http", "datasets", "$q", "$state", "$mdDialog", "$filter"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _ = __webpack_require__(5);

	exports.default = {
	  name: 'unitProducts',
	  controller: UnitProductsCtrl,
	  templateUrl: 'app/products/unit/template.html',
	  bindings: {
	    unitCode: '<unitCode'
	  },
	  require: {
	    unitListCtrl: '^unitRelWrapper',
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function UnitProductsCtrl(User, $log, $http, datasets, $q, $state, $mdDialog, $filter) {
	  "ngInject";

	  var vm = this;
	  // colors are used for each products

	  $log.debug('UnitProductsCtrl');

	  angular.extend(vm, {
	    $onInit: onInit,
	    toggleProduct: toggleProduct,
	    toggleAllProducts: toggleAllProducts,
	    addOccupancies: addOccupancies,
	    checkAll: {},
	    // default and common occupancies
	    occupancies: [100, 200]
	  });

	  /**
	   * load boards and rate bases, activate unit then load products
	   * @return {[type]} [description]
	   */
	  function onInit() {
	    User.realm_access.roles.map(function (role) {
	      console.log("role ");
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });
	    console.log('units..', JSON.stringify(vm.units));
	    var p1 = datasets.bindSets(['boards'], vm, false).then(function () {
	      return datasets.bindSets(['unit-types'], vm, true);
	    }).then(function () {
	      return vm.boards.sort(function (a, b) {
	        return a.code - b.code;
	      });
	    });

	    var p2 = vm.propertyCtrl.get('rate-bases').then(function (collection) {
	      vm.rateBases = collection.items;
	      assertRateBasesExists(vm.rateBases);
	      return vm.rateBases;
	    });

	    $q.all([p1, p2, vm.unitListCtrl.whenReady]).then(function () {
	      return vm.unitListCtrl.activateUnit(vm.unitCode);
	    }).then(function (unit) {
	      vm.unit = unit;
	      vm.maxOccupancy = vm.unit.maxOccupancy;
	      vm.propertyCtrl.setBreadcrumb([{ label: "Produits" }, { label: vm.unitTypes[unit.type].name + " " + unit.name }]);
	      vm.propertyCtrl.setActions([]);
	      return _loadUnitProducts();
	    }, function (error) {
	      return $log.error(error);
	    });

	    vm.checkAll = {};
	  }

	  function addOccupancies(rb) {
	    $mdDialog.show({
	      controller: 'ProductsAddOccupancyCtrl',
	      controllerAs: '$ctrl',
	      templateUrl: 'app/products/add/template.html',
	      locals: {
	        products: vm.products,
	        rateBases: vm.rateBases,
	        defaults: rb ? [rb.code] : []
	      }
	    }).then(function (ocs) {
	      vm.occupancies = _.union(vm.occupancies, ocs).sort();
	      vm.rateGroups = _aggregateByRateGroup(vm.products, vm.rateBases);
	    });
	  }

	  function toggleAllProducts(g, boardCode) {
	    var autoConfirmation = true;
	    g.matrix.values.forEach(function (occupancyLine, occupancyIndex) {
	      return occupancyLine.forEach(function (item, boardIndex) {
	        if (item.product.board === boardCode) {
	          if (!(vm.checkAll[boardCode] && item.checked)) {
	            item.checked = angular.copy(vm.checkAll[boardCode]);
	            toggleProduct(g, occupancyIndex, boardIndex, item.product, autoConfirmation);
	          }
	        }
	      });
	    });
	  }

	  function toggleProduct(rateGroup, occupancyIndex, boardIndex, product, autoConfirmation) {
	    var value = rateGroup.matrix.values[occupancyIndex][boardIndex];
	    //value.checked = checked
	    console.log('value..', value);
	    var occupancy = vm.occupancies[occupancyIndex];
	    var board = vm.boards[boardIndex];
	    $log.debug("toggleProduct : ", rateGroup.basis.code, occupancy, board, value);

	    //  var product = rateGroup.products.find(p => p.occupancy === occupancy && p.board === board.code );
	    value.disabled = true;

	    var promise;
	    $log.debug("occupancy:", occupancy);
	    // console.log(value);

	    // remove product (existing must have links)
	    if (value.checked === false && angular.isDefined(product.links)) {
	      promise = confirmProductDeletion(product, rateGroup.basis, board, autoConfirmation).then(function () {
	        var keep = ["board", "occupancy"];
	        Object.keys(product).filter(function (k) {
	          return !_.includes(keep, k);
	        }).forEach(function (k) {
	          return product[k] = undefined;
	        });
	      }, function (res) {
	        if (!res) return;
	        $log.error(res);
	        _httpErrorDialog("Erreur lors de la suppression du produit", res);
	        value.checked = !value.checked;
	      });
	    }
	    // add product (new have no links)
	    else if (value.checked && angular.isUndefined(product.links)) {

	        var adlt = 0,
	            enf = 0,
	            bebe = 0;
	        adlt = Math.floor(product.occupancy / 100);

	        enf = Math.floor((product.occupancy - adlt * 100) / 10);
	        bebe = product.occupancy - adlt * 100 - enf * 10;

	        var productOccup = adlt + enf + bebe;
	        console.log('productOccup..', productOccup);
	        console.log('maxOccupancy..', vm.unit.maxOccupancy);

	        // if(productOccup > vm.unit.maxOccupancy  ) {
	        //   value.disabled = false;
	        //   value.checked = !value.checked;

	        //   $mdDialog.show(
	        //     $mdDialog.alert()
	        //       .clickOutsideToClose(true)
	        //       .title("Erreur ")
	        //       .textContent("Erreur l'occupation de produit est superieur que de la chambre")
	        //       .ariaLabel("Erreur l'occupation de produit est superieur que de la chambre")
	        //       .ok('OK')
	        //   )


	        //   throw new Error("Erreur l'occupation de produit est superieur que de la chambre")
	        //   //_httpErrorDialog("Erreur l'occupation de produit est superieur que de la chambre");


	        // }
	        // else { 
	        promise = addProduct(product, rateGroup.basis).then(function (p) {
	          return angular.extend(product, p);
	        }, function (res) {
	          // roll back on error
	          $log.error(res);
	          _httpErrorDialog("Erreur lors de l'ajout du produit", res);
	          value.disabled = false;
	          value.checked = !value.checked;
	        });
	        // } 
	      } else {
	        $log.error("Unexpected product state", product, value);
	        throw new Error("Unexpected product state");
	      }

	    promise.finally(function () {
	      return value.disabled = false;
	    });

	    $log.debug("product", product);
	  }

	  function addProduct(p, basis) {
	    console.log("p  ", p);

	    p.rateBasis = basis.code;
	    return $http.post(vm.unit.links.products.href, p).then(function (res) {
	      return _.extend(p, res.data);
	    });
	  }

	  function confirmProductDeletion(product, basis, board, autoConfirmation) {

	    if (autoConfirmation) {
	      return $http.delete(product.links.self.href);
	    } else {
	      return $mdDialog.show($mdDialog.confirm().title("Supprimer le produit?").htmlContent('<p>Les tarifs du produit seront aussi supprimer.</p><p>Produit: ' + basis.description + ' ' + $filter('occupancy')(product.occupancy) + ' ' + board.name + '?</p>').ariaLabel('Confirmation suppression de produit')
	      //.targetEvent(ev)
	      .ok("Oui, supprimer").cancel('Non')).then(function () {
	        return $http.delete(product.links.self.href);
	      });
	    }
	  }

	  //
	  // @expects vm.unit
	  // @expects vm.rateBases (indexed)
	  function _loadUnitProducts() {

	    if (vm.unit.occupancy == null) {
	      vm.occupancies = [100, 200];
	    } else {
	      vm.occupancies = vm.unit.occupancy;

	      console.log("occupancy", vm.unit.occupancy);

	      var cats = vm.unit.occupancy;
	      // console.log("applyChanges", cats);
	      //console.log("cats.adults", cats.adults);

	      var adults = buildSeries(cats.adults, 100);
	      var children = buildSeries(cats.children, 10);
	      var infants = buildSeries(cats.infants, 1);
	      var ocs = [];

	      adults.forEach(function (a) {
	        return children.forEach(function (c) {
	          return infants.forEach(function (i) {
	            return ocs.push(a + c + i);
	          });
	        });
	      });
	      //console.log("ocs", ocs);
	      vm.occupancies = _.union(vm.occupancies, ocs).sort();
	    }
	    // ocs.then( ocss => {
	    //   vm.occupancies = _.union(vm.occupancies, ocss).sort();
	    //   console.log("ocsoccupancies", vm.occupancies);

	    //  // vm.rateGroups = _aggregateByRateGroup(vm.products, vm.rateBases);
	    // })


	    // console.log("ocsvm.occupancies", vm.occupancies);


	    $http.get(vm.unit.links.products.href).then(function (res) {
	      vm.products = res.data.items;
	      vm.occupancies = _.union(vm.occupancies, _.uniq(vm.products.map(function (p) {
	        return p.occupancy;
	      }))).sort();
	      $log.debug('occup', vm.occupancies);
	      console.log("occup", vm.occupancies);

	      vm.rateGroups = _aggregateByRateGroup(vm.products, vm.rateBases);
	    }, _errorOnLoadProducts);
	  }

	  function buildSeries(range, pos) {
	    var array = [];
	    var i = range.min;
	    while (i <= range.max) {
	      array.push(i * pos);
	      i += 1;
	    }
	    return array;
	  }

	  function _aggregateByRateGroup(products, rateBases) {
	    return rateBases.map(function (rb) {
	      var basisProducts = products.filter(function (p) {
	        return p.rateBasis === rb.code;
	      });
	      return {
	        basis: rb,
	        products: products.filter(function (p) {
	          return p.rateBasis === rb.code;
	        }),
	        matrix: _occupancyBoardMatrix(basisProducts)
	      };
	    });
	  }

	  function _occupancyBoardMatrix(products) {
	    var occupancies = vm.occupancies;

	    var occupanciesFinal = [];
	    // console.log("occupoccupancies", vm.occupancies)
	    console.log("occupanciesoccupancies:::", occupancies);

	    if (vm.maxOccupancy != null) {
	      occupancies.map(function (o) {
	        var adlt = 0,
	            enf = 0,
	            bebe = 0;
	        adlt = Math.floor(o / 100);

	        enf = Math.floor((o - adlt * 100) / 10);
	        bebe = o - adlt * 100 - enf * 10;

	        var productOccup = adlt + enf + bebe;
	        console.log('productOccup..', productOccup);
	        console.log('maxOccupancy..', vm.maxOccupancy);
	        if (vm.maxOccupancy >= productOccup && productOccup != 0) occupanciesFinal.push(o);
	      });
	      occupancies = occupanciesFinal;
	      console.log("occupanciesFinal:::", occupanciesFinal);
	      console.log("occupancies:1::", occupancies);
	    }

	    if (vm.maxOccupancy == null) {
	      occupancies.map(function (o) {
	        var adlt = 0,
	            enf = 0,
	            bebe = 0;
	        adlt = Math.floor(o / 100);

	        enf = Math.floor((o - adlt * 100) / 10);
	        bebe = o - adlt * 100 - enf * 10;

	        var productOccup = adlt + enf + bebe;
	        if (productOccup != 0) occupanciesFinal.push(o);
	      });
	      occupancies = occupanciesFinal;
	      console.log("occupanciesFinal:::", occupanciesFinal);
	      console.log("occupancies:1::", occupancies);
	    }

	    occupancies.sort(function (a, b) {
	      return a - b;
	    });
	    console.log("occupanciesAfterSort:::", occupancies);

	    var boards = vm.boards.map(function (b) {
	      return b.code;
	    }).sort(); //_.uniq(products.map(p=>p.board)).sort();
	    var matrix = occupancies.map(function (o) {
	      // lineBoards = products defined for the occupancy o (mapped as boards)
	      var occupancyProducts = products.filter(function (p) {
	        return p.occupancy === o;
	      });
	      return boards.map(function (b) {
	        var p = occupancyProducts.find(function (p) {
	          return p.board === b;
	        });
	        return {
	          product: p || {
	            occupancy: o,
	            board: b
	          },
	          checked: angular.isDefined(p)
	        };
	      });
	    });

	    console.log("matrix:::", matrix);
	    boards.forEach(function (b) {
	      return vm.checkAll[b] = false;
	    });
	    console.log("boards....", vm.checkAll);

	    return {
	      occupancies: occupancies,
	      boards: boards,
	      values: matrix
	    };
	  }

	  function _errorOnLoadProducts() {}

	  function _httpErrorDialog(msg, res) {
	    $log.debug(res);
	    var message = $filter("json")(res.data);
	    return $mdDialog.show($mdDialog.alert().title("Whoops").htmlContent(msg + '<pre>' + res.status + '\n' + message + '</pre>').ariaLabel('Erreur').ok('OK...'));
	  }

	  function assertRateBasesExists(list) {
	    if (list.length > 0) return;

	    $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('Aucune base tarifaire créée').textContent("Vous devez créer une base tarifaire avant de pouvoir ajouter des offres.").ariaLabel('Aucune base tarifaire créée').ok('OK')).then(function () {
	      return $state.go("property.rateBasisEdit", { basis: "new" });
	    }, function () {
	      return $state.go("property.rateBasisEdit", { basis: "new" });
	    });
	  }
	}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	PaxRatesInputCtrl.$inject = ["$log"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _ = __webpack_require__(5);

	exports.default = {
	  name: 'ratesPaxForm',
	  templateUrl: 'app/products/calendar-edit/pax/template.html',
	  controller: PaxRatesInputCtrl,
	  bindings: {
	    rateGroup: "=",
	    indexedBoards: "<",
	    firstChildAge: "<"
	  }
	};


	function PaxRatesInputCtrl($log) {
	  "ngInject";

	  var vm = this;
	  //  $log.debug(vm);
	  console.log("policiesAge:::::", vm);
	  var valueTypes = [{
	    id: "additiveRatio",
	    label: "remise(-)/suppl(+) en %",
	    min: -100,
	    max: 100,
	    symbol: "%",
	    flatten: function flatten(value, base) {
	      return base + base * value / 100;
	    }
	  }, {
	    id: "additiveValue",
	    label: "remise(-)/suppl(+) en Devise",
	    min: -9999999,
	    max: 9999999,
	    symbol: "Devise",
	    flatten: function flatten(value, base) {
	      return base + value;
	    }
	    //flatten: (value, base) =>  value
	  }, {
	    id: "flatRatio",
	    label: "forfait en %",
	    min: -100,
	    max: 100,
	    symbol: "%",
	    flatten: function flatten(value, base) {
	      return base * (value / 100);
	    }
	  }, {
	    id: "flatValue",
	    label: "forfait en Devise",
	    min: 0,
	    max: 9999999,
	    symbol: "Devise",
	    flatten: function flatten(value) {
	      return value;
	    }
	  }];

	  if (angular.isUndefined(vm.rateGroup.pax)) {
	    vm.rateGroup.pax = setUpRateGroupMatrix(vm.rateGroup.products);
	    //make sure we reset all prices
	    vm.rateGroup.products.forEach(function (item) {
	      return item.price = 0;
	    });
	  }
	  angular.extend(vm, vm.rateGroup.pax);
	  angular.extend(vm, {
	    valueTypes: valueTypes,
	    valueChanged: valueChanged
	  });

	  function setUpRateGroupMatrix(products) {
	    var boards = _.uniq(products.map(function (p) {
	      return p.product.board;
	    }));
	    var occupancies = _.uniq(products.map(function (p) {
	      return p.product.occupancy;
	    })).sort();
	    var maxChildren = _getMaxAt(occupancies, 1);
	    var maxInfants = _getMaxAt(occupancies, 2);
	    var maxAdults = _getMaxAt(occupancies, 0);
	    products.forEach(function (item) {
	      var ocStr = '' + item.product.occupancy;
	      item.adt = parseInt(ocStr[0], 10);
	      item.chd = parseInt(ocStr[1], 10);
	      item.inf = parseInt(ocStr[2], 10);
	    });

	    $log.debug(maxAdults, maxChildren, maxInfants, occupancies);

	    return {
	      //boards:boards,
	      occupancies: occupancies,
	      baseBoard: boards.sort().shift(),
	      chd: _fieldArrayUntil(maxChildren, "{}° enfant"),
	      inf: _fieldArrayUntil(maxInfants, "{}° bébé"),
	      adt: _fieldArrayUntil(maxAdults, "{}° adulte").filter(function (item, i) {
	        return i > 1;
	      }),
	      boards: boards.map(function (b) {
	        return {
	          code: b,
	          adt: 0,
	          chd: 0,
	          inf: 0
	        };
	      }),
	      base: 0,
	      single: 0,
	      hasSingle: occupancies[0] < 200,
	      hasChildren: maxChildren + maxInfants > 0,
	      hasBoards: boards.length > 0,
	      units: {
	        adt: valueTypes[1],
	        chd: valueTypes[2],
	        board: valueTypes[3],
	        boardChd: valueTypes[2]
	      }
	    };
	  }

	  function _getMaxAt(occupancies, i) {
	    return occupancies.map(function (o) {
	      return ('' + o)[i];
	    }).map(function (n) {
	      return parseInt(n, 10);
	    }).sort().reverse()[0];
	  }

	  function _fieldArrayUntil(max) {
	    var array = [];
	    var i = 0;
	    while (i < max) {
	      i += 1;
	      array.push(0);
	    }
	    return array;
	  }

	  var changeFilters = {
	    base: function base() {
	      return true;
	    },
	    single: function single(item) {
	      return item.adt === 1 && item.chd != 1;
	    },
	    adt: function adt(item) {
	      return item.adt > 2 || item.adt === 1 && item.chd === 1;
	    },
	    chd: function chd(item) {
	      return item.chd > 0 && item.adt > 1;
	    },
	    inf: function inf(item) {
	      return item.inf > 0;
	    },
	    boards: function boards(item, matrix) {
	      return item.product.board != matrix.baseBoard;
	    }
	  };

	  function valueChanged(valueType) {
	    var filter = changeFilters[valueType];
	    console.log("new change", valueType, vm.rateGroup.pax, vm.single);

	    // $log.debug("changed", valueType, vm.rateGroup.pax, vm.single)
	    vm.rateGroup.products.filter(filter).forEach(function (item) {
	      return updateProductPrice(item);
	    });
	  }

	  /**
	   *
	   */
	  function updateProductPrice(item) {
	    var p = item.product;
	    //$log.debug("updateing", p.occupancy,p.board);
	    var base = vm.base;
	    var count = _.pick(item, ["adt", "chd", "inf"]);
	    // console.log("item",item);
	    var adtSub = 0;
	    // console.log("count.chd: ",count.chd);

	    // console.log("flatten: ",vm.units.adt.flatten(vm.single, base));
	    // console.log("base: ",base);
	    // console.log("vm.single: ",vm.single);

	    if (count.chd === 1 && count.adt === 1) {

	      switch (count.adt) {
	        case 0:
	          adtSub = 0;
	          break;
	        case 1:
	          adtSub = base * 2;
	          break;
	        case 2:
	          adtSub = base * count.adt;
	          break;
	        default:
	          //console.log()
	          adtSub = base * 2 + sumUpTo(count.adt - 2, vm.adt, vm.units.adt, base);
	      }
	    } else {

	      switch (count.adt) {
	        case 0:
	          adtSub = 0;
	          break;
	        case 1:
	          adtSub = vm.single + base;

	          //adtSub = vm.units.adt.flatten(vm.single, base)
	          break;
	        case 2:
	          adtSub = base * count.adt;
	          break;
	        default:
	          //console.log()
	          adtSub = base * 2 + sumUpTo(count.adt - 2, vm.adt, vm.units.adt, base);
	      }
	    }
	    // children
	    var childrenSub;
	    if (count.chd === 1 && count.adt === 1) {
	      childrenSub = ["inf"].map(function (paxType) {
	        return sumUpTo(item[paxType], vm[paxType], vm.units.chd, base);
	      }).reduce(sum, 0);
	    } else {
	      childrenSub = ["chd", "inf"].map(function (paxType) {
	        return sumUpTo(item[paxType], vm[paxType], vm.units.chd, base);
	      }).reduce(sum, 0);
	    }
	    // console.log("//childrenSub: ",vm[paxType]," ",item[paxType]," ",base," ",vm.units.chd);

	    console.log("childrenSub: ", childrenSub);

	    // boards
	    var boardSuppl = vm.boards.find(function (o) {
	      return o.code === p.board;
	    }) || { adt: 0, chd: 0, inf: 0 };
	    var boardRateAdt = vm.units.board.flatten(boardSuppl.adt, base);
	    var boardRateChd = vm.units.boardChd.flatten(boardSuppl.chd, boardRateAdt);
	    var boardRateInf = vm.units.boardChd.flatten(boardSuppl.inf, boardRateAdt);
	    //console.log(vm.base, adtSub, childrenSub, boardSub +chdBoardSub + infBoardSub);

	    item.price = adtSub + childrenSub + boardRateAdt * count.adt + boardRateChd * count.chd + boardRateInf * count.inf;
	  }

	  function sumUpTo(count, values, valueType, base) {
	    console.log("sumUpTo ", count, " ", values, " ", values.slice(0, count), " ", base);
	    console.log("sumUpTovalues ", values.slice(0, count).reduce(function (sum, value) {
	      return sum + valueType.flatten(value, base);
	    }, 0), " ", base);

	    return values.slice(0, count).reduce(function (sum, value) {
	      return sum + valueType.flatten(value, base);
	    }, 0);
	  }

	  /**
	   *  calclulates total for pax type for a given product
	   */
	  /*
	  function sumPaxValues(paxType, productItem) {
	   const matrix = vm.rateGroup.pax;
	   // paxType adt|chd|inf
	   // productItem[paxType]: paxType count
	   // matrix.units[paxType] see valueTypes
	   return matrix[paxType].slice(0, productItem[paxType])
	     .map(value => matrix.units[paxType].flatten(value, matrix.base))
	     .reduce(sum, 0);
	  }
	  */
	  function sum(sum, value) {
	    return sum + value;
	  }

	  /*
	    function flattenPaxMode() {
	      //args.products.push(p.code);
	      //args.rates.push(price);
	    }
	  */
	}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	ProductMatrixCtrl.$inject = ["$log"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _ = __webpack_require__(5);

	exports.default = {
	  name: 'productSelectMatrix',
	  controller: ProductMatrixCtrl,
	  templateUrl: 'app/products/select-matrix/template.html',
	  bindings: {
	    boards: '<',
	    products: '<',
	    unit: '<',
	    rateBases: '<',
	    values: '='
	  }
	};


	function ProductMatrixCtrl($log) {
	  "ngInject";

	  var vm = this;
	  // colors are used for each products

	  $log.debug('ProductMatrixCtrl');

	  angular.extend(vm, {
	    $onInit: onInit,
	    valueChanged: valueChanged,
	    boardChanged: boardChanged,
	    occupancyChanged: occupancyChanged,
	    rateGroupChanged: rateGroupChanged
	  });

	  function onInit() {

	    console.log('boardsss..', JSON.stringify(vm.boards));

	    console.log('products....', JSON.stringify(vm.products));
	    console.log('rateBases....', JSON.stringify(vm.rateBases));
	    console.log('vm.values...', JSON.stringify(vm.values));
	    vm.rateGroups = _aggregateByRateGroup(vm.products, vm.rateBases);
	    vm.rateGroups.forEach(refreshHeaderValues);
	  }

	  function valueChanged(group, item) {
	    updateModel(item);
	    refreshHeaderValues(group);
	  }

	  function updateModel(item) {
	    if (item.disabled) return;
	    var i = vm.values.indexOf(item.product.code);
	    if (item.checked && i === -1) {
	      vm.values.push(item.product.code);
	      vm.values.sort();
	    } else if (i > -1) {
	      vm.values.splice(i, 1);
	    }
	  }

	  function boardChanged(group, $index) {
	    var value = group.boardCodes[$index].checked;
	    group.lines.map(function (line) {
	      return line[$index];
	    }).forEach(function (item) {
	      item.checked = value;
	      updateModel(item);
	    });
	    refreshHeaderValues(group);
	  }

	  function occupancyChanged(group, $index) {
	    var value = group.occupancies[$index].checked;
	    group.lines[$index].forEach(function (item) {
	      item.checked = value;
	      updateModel(item);
	    });
	    refreshHeaderValues(group);
	  }

	  function rateGroupChanged(group) {
	    console.log('group....', JSON.stringify(group));
	    var value = angular.copy(group.checked);

	    group.lines.forEach(function (l) {
	      l.filter(function (item) {
	        return !item.disabled;
	      }).forEach(function (item) {
	        item.checked = value;
	        updateModel(item);
	      });
	    });

	    refreshHeaderValues(group);
	  }

	  function refreshHeaderValues(group) {
	    group.boardCodes.forEach(function (b, boardIndex) {
	      var checked = group.lines.map(function (l) {
	        return l[boardIndex];
	      }).filter(function (item) {
	        return !item.disabled && item.checked;
	      });
	      b.checked = checked.length === b.total;
	    });
	    group.checked = group.occupancies.map(function (o, oIndex) {
	      var checked = group.lines[oIndex].filter(function (item) {
	        return !item.disabled && item.checked;
	      });
	      o.checked = checked.length === o.total;
	      return o.checked;
	    }).reduce(function (agg, v) {
	      return agg && v;
	    }, false);
	  }

	  //copied from unit unit component
	  function _aggregateByRateGroup(products, rateBases) {
	    return rateBases.map(function (rb) {
	      var basisProducts = products.filter(function (p) {
	        return p.rateBasis === rb.code;
	      });
	      var group = _occupancyBoardMatrix(basisProducts);
	      group.basis = rb;
	      return group;
	    });
	  }

	  //copied from unit unit component
	  function _occupancyBoardMatrix(products) {
	    var occupancies = _.uniq(products.map(function (p) {
	      return p.occupancy;
	    }));
	    var boardCodes = _.uniq(products.map(function (p) {
	      return p.board;
	    }));
	    var lines = occupancies.map(function (o) {
	      console.log('o ==> ', o);
	      // lineBoards = products defined for the occupancy o (mapped as boards)
	      var occupancyProducts = products.filter(function (p) {
	        return p.occupancy === o;
	      });
	      console.log('occupancyProducts ==> ', occupancyProducts);
	      return boardCodes.map(function (b) {
	        console.log('b ===>', b);
	        var p = occupancyProducts.find(function (p) {
	          return p.board === b;
	        });
	        return {
	          product: p,
	          checked: _.isObject(p) && vm.values.includes(p.code),
	          disabled: !_.isObject(p)
	        };
	      });
	    });
	    return {
	      occupancies: occupancies.map(function (v) {
	        return {
	          checked: false,
	          code: v,
	          total: products.filter(function (p) {
	            return p.occupancy === v;
	          }).length
	        };
	      }),
	      boardCodes: boardCodes.map(function (v) {
	        return {
	          code: v,
	          checked: false,
	          total: products.filter(function (p) {
	            return p.board === v;
	          }).length
	        };
	      }),
	      lines: lines
	    };
	  }
	}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	"use strict";

	ProductsAddOccupancyCtrl.$inject = ["$log", "$http", "products", "rateBases", "defaults", "$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ProductsAddOccupancyCtrl;
	//const _ = require("_");

	function ProductsAddOccupancyCtrl($log, $http, products, rateBases, defaults, $mdDialog) {
	  "ngInject";

	  var vm = this;

	  vm.rateBases = rateBases.filter(function (rb) {
	    return rb.permissions.edit;
	  }).map(function (rb) {
	    return {
	      code: rb.code,
	      description: rb.description,
	      selected: defaults.includes(rb.code)
	    };
	  });

	  angular.extend(vm, {
	    applyChanges: applyChanges,
	    cancel: function cancel() {
	      return $mdDialog.cancel();
	    },
	    basisNeeded: false,
	    inputs: {
	      adults: {
	        label: "Adultes",
	        min: 1,
	        max: 0
	      },
	      children: {
	        label: "Enfants",
	        min: 0,
	        max: 0
	      },
	      infants: {
	        label: "Bébé",
	        min: 0,
	        max: 0
	      }
	    }
	  });

	  function applyChanges() {
	    var cats = vm.inputs;
	    console.log("applyChanges", cats);
	    console.log("cats.adults", cats.adults);

	    var bases = vm.rateBases.filter(function (rb) {
	      return rb.selected;
	    });
	    var adults = buildSeries(cats.adults, 100);
	    var children = buildSeries(cats.children, 10);
	    var infants = buildSeries(cats.infants, 1);
	    var ocs = [];
	    vm.basisNeeded = bases.length === 0;
	    if (vm.basisNeeded) {
	      return false;
	    }
	    adults.forEach(function (a) {
	      return children.forEach(function (c) {
	        return infants.forEach(function (i) {
	          return ocs.push(a + c + i);
	        });
	      });
	    });
	    console.log("ocs", ocs);

	    $mdDialog.hide(ocs);
	  }

	  function buildSeries(range, pos) {
	    var array = [];
	    var i = range.min;
	    while (i <= range.max) {
	      array.push(i * pos);
	      i += 1;
	    }
	    return array;
	  }
	  /*
	    function parseOccupancy(code) {
	      const parts = (""+code).split("").map(s=>parseInt(s,10));
	      return {
	        adults: parts[0],
	        children: parts[1],
	        infants: parts[2]
	      }
	    }
	  */
	}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	"use strict";

	ProductCalendarEditCtrl.$inject = ["$log", "$mdDialog", "apiUrl", "$http", "units", "boards", "rateBases", "propertyCtrl", "group", "seasons"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ProductCalendarEditCtrl;
	function ProductCalendarEditCtrl($log, $mdDialog, apiUrl, $http, units, boards, rateBases, propertyCtrl, group, seasons) {
	  "ngInject";

	  // console.log("-------------group-------------", group);

	  var PATCH_URL = apiUrl + "/commands/batch-update-rates";
	  var vm = this;
	  //$log.debug(units);

	  vm.periods = [];
	  vm.applyChanges = applyChanges;
	  vm.productHasChilds = productHasChilds;
	  vm.onRateGroupSwitch = onRateGroupSwitch;
	  vm.productHasTwoChilds = productHasTwoChilds;
	  vm.cancel = function () {
	    $mdDialog.cancel();
	  };
	  vm.copyPorduct = copyPorduct;
	  vm.property = propertyCtrl.property;
	  // console.log("age;",propertyCtrl.property );
	  // console.log("age0 ", vm.property.policies.age[0] );

	  vm.policiesAge = [];
	  vm.firstChildAge;
	  if (vm.property.policies.age && vm.property.policies.age.length > 1) {
	    vm.firstChildAge = vm.property.policies.age[1];
	  }
	  if (vm.property.policies.age && vm.property.policies.age.length > 2) {

	    for (var i = 2; i < vm.property.policies.age.length; i++) {
	      vm.policiesAge.push(vm.property.policies.age[i]);
	      // }
	    }
	  }
	  // //https://gist.github.com/axelpale/3118596
	  //   function k_combinations(set,product, k) {
	  //     var i, j, combs, head, tailcombs;

	  //     // There is no way to take e.g. sets of 5 elements from
	  //     // a set of 4.
	  //     if (k > set.length || k <= 0) {
	  //       return [];
	  //     }

	  //     // K-sized set has only one K-sized subset.
	  //     if (k == set.length) {
	  //       return [set];
	  //     }

	  //     // There is N 1-sized subsets in a N-sized set.
	  //     if (k == 1) {
	  //       combs = [];
	  //       for (i = 0; i < set.length; i++) {
	  //         combs.push([set[i]]);
	  //       }
	  //       return combs;
	  //     }

	  //     // Assert {1 < k < set.length}

	  //     // Algorithm description:
	  //     // To get k-combinations of a set, we want to join each element
	  //     // with all (k-1)-combinations of the other elements. The set of
	  //     // these k-sized sets would be the desired result. However, as we
	  //     // represent sets with lists, we need to take duplicates into
	  //     // account. To avoid producing duplicates and also unnecessary
	  //     // computing, we use the following approach: each element i
	  //     // divides the list into three: the preceding elements, the
	  //     // current element i, and the subsequent elements. For the first
	  //     // element, the list of preceding elements is empty. For element i,
	  //     // we compute the (k-1)-computations of the subsequent elements,
	  //     // join each with the element i, and store the joined to the set of
	  //     // computed k-combinations. We do not need to take the preceding
	  //     // elements into account, because they have already been the i:th
	  //     // element so they are already computed and stored. When the length
	  //     // of the subsequent list drops below (k-1), we cannot find any
	  //     // (k-1)-combs, hence the upper limit for the iteration:
	  //     combs = [];
	  //     for (i = 0; i < set.length - k + 1; i++) {
	  //       // head is a list that includes only our current element.
	  //       head = set.slice(i, i + 1);
	  //       // We take smaller combinations from the subsequent elements
	  //       tailcombs = k_combinations(set.slice(i + 1),product, k - 1);
	  //       // For each (k-1)-combination we join it with the current
	  //       // and store it to the set of k-combinations.
	  //       for (j = 0; j < tailcombs.length; j++) {
	  //         combs.push(head.concat(tailcombs[j]));
	  //       }
	  //     }
	  //     return combs;
	  //   }

	  // function combinations(set, product) {
	  //   var k, i, combs, k_combs;
	  //   combs = [];
	  //   if (productHasGreaterThenTwoChilds(product.occupancy)) {
	  //     // Calculate all non-empty k-combinations
	  //     for (k = 1; k <= set.length; k++) {
	  //       k_combs = k_combinations(set, k);
	  //       for (i = 0; i < k_combs.length; i++) {
	  //         combs.push({
	  //           label:k_combs[i].join(' , '),
	  //           value:true
	  //         }
	  //           );
	  //       }
	  //     }
	  //   }

	  //   return combs;
	  // }

	  /*function getCombinations(product) {
	    console.log("product combinaisons ..", product);
	    var array = vm.property.policies.age;
	    let results = [];
	     if (productHasGreaterThenTwoChilds(product.occupancy)) {
	      for (let i = 0; i < array.length; i++) {
	        console.log("first loop : ", array[i]);
	        for (let j = i; j < array.length; j++) {
	          results.push({
	            label:`${array[i]} , ${array[j]}`,
	            value:true
	          });
	        }
	      }
	    }
	     return results;
	  }*/
	  //added
	  function onRateGroupSwitch(group) {
	    if (group.products) {
	      group.products = group.products.map(function (product) {
	        //console.log('product....', product)
	        product.selected = angular.copy(group.selected);
	        return product;
	      });
	    }
	  }

	  // console.log("policiesAge ", vm.policiesAge);
	  vm.seasons = seasons;
	  vm.boards = boards;
	  vm.rateBases = rateBases;
	  vm.units = units.map(function (unit) {
	    // console.log('---------------------------UNIT-----------------------------', unit)
	    var u = {
	      code: unit.code,
	      name: unit.name
	    };
	    loadProducts(unit, u);
	    return u;
	  });

	  function productHasChilds(occupancy) {
	    //occupancy adults enfant bebe
	    return occupancy % 100 >= 10;
	  }

	  function productHasTwoChilds(occupancy) {
	    //occupancy adults enfant bebe
	    return occupancy % 100 >= 20;
	  }

	  // function productHasGreaterThenTwoChilds(occupancy) {
	  //   //occupancy adults enfant bebe 120 at least 2 childs
	  //   return occupancy % 100 >= 20;
	  // }

	  function copyPorduct(ratecpy, rateCode, rates, pourcent) {
	    for (var k = 0; k < rates.length; k++) {
	      if (rates[k].basis.code == rateCode) {
	        console.log("rateCode", rateCode);

	        for (var i = 0; i < rates[k].products.length; i++) {
	          for (var j = 0; j < ratecpy.products.length; j++) {
	            console.log("supplementEnf", rates[k].products[i].product.supEnf);
	            if (rates[k].products[i].product.occupancy == ratecpy.products[j].product.occupancy) {
	              if (rates[k].products[i].product.board == ratecpy.products[j].product.board) {

	                ratecpy.products[j].price = Number((rates[k].products[i].price / 100 * pourcent).toFixed(2));
	                // var sup=Object.keys(rates[k].products[i].product.supEnf).map((key) => [Number(key), rates[k].products[i].product.supEnf[key]]);
	                // console.log("supplementEnffinals",sup);
	                if (ratecpy.products[j].product.occupancy % 100 > 0) {
	                  console.log("supplementrrrrrddER", rates[k].products[i]);
	                  //  rates[k].products[i].product.supEnf.map(function(key0, index) {
	                  //   console.log("supplementrrrrrddR",key0);
	                  //  });
	                  Object.keys(rates[k].products[i].product.supEnf).map(function (key0, index) {

	                    ratecpy.products[j].product.supEnf[key0] = Number((rates[k].products[i].product.supEnf[key0] / 100 * pourcent).toFixed(2));
	                  });
	                  if (ratecpy.products[j].product.occupancy % 100 >= 20) {
	                    ratecpy.products[j].product.supEnf2 = [];
	                    Object.keys(rates[k].products[i].product.supEnf2).map(function (key1, index) {

	                      ratecpy.products[j].product.supEnf2[key1] = Number((rates[k].products[i].product.supEnf2[key1] / 100 * pourcent).toFixed(2));
	                    });
	                  }
	                  // rates[k].products[i].product.supEnf.map((age) => {
	                  //   console.log("supplementEnffinals",ratecpy.products[j].product.supEnf[s]);

	                  //   ratecpy.products[j].product.supEnf[s]=(rates[k].products[i].product.supEnf[s]/ 100) * pourcent
	                  // })
	                  console.log("supplementEnffinal", ratecpy.products[j].product.supEnf);
	                }
	                //ratecpy.products[j].product.supEnf =rates[k].products[i].product.supEnf;
	                //  (rates[k].products[i].price / 100) * pourcent;
	                // console.log("new price", ratecpy.products[j].price);
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	  function applyChanges() {
	    var args = {
	      periods: vm.getPeriods(),
	      products: [],
	      rates: [],
	      // supEnf: [],
	      supp: [],
	      secondSupp: []
	      //markups:[],
	    };

	    if (vm.seasonMode) {

	      var finalRanges = [];
	      console.log("rangesranges::", vm.ranges);
	      vm.ranges.map(function (r) {
	        r.ranges.map(function (rg) {
	          finalRanges.push(rg);
	        });

	        console.log("r.ranges::", r.ranges);
	      });
	      console.log("r.finalRanges::", finalRanges);

	      args.periods = finalRanges;
	    }

	    // for each unit/for each group/for each item
	    vm.units.forEach(function (u) {
	      return u.rateGroups
	      //.filter((g) => g.selected)
	      .forEach(function (g) {
	        return g.products.filter(function (p) {
	          return p.selected;
	        }).forEach(function (p) {
	          // console.log("p.suppEnf", p.product);

	          var supplementEnf = {
	            productCode: null,
	            price: p.product.supEnf
	          };

	          var supplementEnf2 = {
	            productCode: null,
	            price: p.product.supEnf2
	          };

	          // var markup=  {
	          //   productCode:null,
	          //   tarif:0

	          // };

	          // console.log("occs",occs);

	          // console.log("occs[1]",occs[1]);
	          // console.log("g.supEnf",g.supEnf);
	          //console.log("markup",g.markup);

	          //  if(g.markup != null){
	          //   markup.productCode=p.code;
	          //   markup.tarif=g.markup;
	          //   args.markups.push(markup);
	          // }
	          if (productHasChilds(p.product.occupancy)) {
	            // console.log("g.supEnf", g.supEnf);
	            supplementEnf.productCode = p.code;
	            if (productHasTwoChilds(p.product.occupancy)) {
	              supplementEnf2.productCode = p.code;
	            }

	            // console.log("supEnf", supenf);

	            if (vm.property.policies.age && vm.property.policies.age.length > 2) {
	              var price0 = {};
	              price0[vm.property.policies.age[0]] = 0;
	              angular.extend(supplementEnf.price, price0);
	              if (productHasTwoChilds(p.product.occupancy) && supplementEnf2.price != undefined) {
	                console.log("supplementEnf2", supplementEnf2.price);

	                angular.extend(supplementEnf2.price, price0);
	              }
	              var price1 = {};
	              price1[vm.property.policies.age[1]] = 0;
	              angular.extend(supplementEnf.price, price1);
	              if (productHasTwoChilds(p.product.occupancy) && supplementEnf2.price != undefined) {

	                angular.extend(supplementEnf2.price, price1);
	              }
	            }

	            // supenf.price = p.supEnf;

	            args.supp.push(supplementEnf);
	            args.secondSupp.push(supplementEnf2);
	          }

	          args.products.push(p.code);
	          args.rates.push(p.price);
	        });
	      });
	    });
	    $http.post(PATCH_URL, args).then(function () {
	      $log.debug("nights updated");
	      $mdDialog.hide(args);
	    });
	  }

	  /**
	   * [loadProducts description]
	   * @param  {[type]} unit [description]
	   * @param  {[type]} u    [description]
	   * @return {[type]}      [description]
	   */
	  function loadProducts(unit, u) {
	    // console.log('-------------LOAD product-------------', unit, u)
	    var items = unit.products.items.map(function (p) {
	      return {
	        price: null,
	        code: p.code,
	        selected: true,
	        product: p
	      };
	    });

	    u.rateGroups = vm.rateBases.map(function (rb) {
	      var products = items.filter(function (p) {
	        return p.product.rateBasis === rb.code;
	      }).map(function (p) {
	        p.product.supEnf = p.product.supEnf || {};
	        /*p.product.policiesCombinations = combinations(
	          vm.property.policies.age, p.product
	        );*/

	        // p.product.policiesCombinations = k_combinations(vm.property.policies.age,p.product, 3)

	        return p;
	      });

	      return {
	        basis: rb,
	        products: products,
	        selected: group.basis.code === rb.code ? true : false
	      };
	    });

	    $log.debug(u);
	    return u;
	  }

	  // function _getMaxAt(occupancies, i) {
	  //   return occupancies
	  //     .map(o => ('' + o)[i])
	  //     .map(n => parseInt(n, 10))
	  //     .sort()
	  //     .reverse()[0];
	  // }
	  //
	  //
	  // function _getBase(products) {
	  //   var tmp = products.slice(0);
	  //   tmp.sort((a, b) => a.board - b.board);
	  //   var doubles = tmp.filter(p => p.occupancy === 200);
	  //   if (doubles.length === 0) {
	  //     return tmp[0];
	  //   }
	  //   return doubles[0];
	  // }

	  //
	  //
	  // function turnPaxModeOn() {
	  //   // splite by rate basis
	  //   vm.units.forEach(u => {
	  //     Object.keys(u.rateBases)
	  //       .forEach(basisCode => {
	  //         var i = 0;
	  //         const basis = u.rateBases[basisCode];
	  //         basis.boards = _.uniq(basis.products.map(p => p.board));
	  //         basis.baseBoard = basis.boards.sort().shift();
	  //         basis.occupancies = _.uniq(basis.products.map(p => p.occupancy));
	  //         basis.occupancies.sort();
	  //         const maxChildren = _getMaxAt(basis.occupancies, 1);
	  //         basis.childrenPrices = [];
	  //         basis.infantsPrices = [];
	  //         i = 0;
	  //         while (i < maxChildren) {
	  //           basis.childrenPrices.push({
	  //             label: 'Enfant ' + (i + 1),
	  //             value: null
	  //           });
	  //           i++;
	  //         }
	  //         const maxInfants = _getMaxAt(basis.occupancies, 2);
	  //         i = 0;
	  //         while (i < maxInfants) {
	  //           basis.infantsPrices.push({
	  //             label: 'Bébé ' + (i + 1),
	  //             value: null
	  //           });
	  //           i++;
	  //         }
	  //         basis.boardsPrices = basis.boards.map(b => Object.create({
	  //           code: b,
	  //           value: null
	  //         }));
	  //         if (basis.occupancies[0] < 200) {
	  //           basis.hasSingle = true;
	  //         }
	  //
	  //         //const struct = paxBasedStructure(]);
	  //         $log.debug('basis', basis, maxChildren, maxInfants);
	  //       });
	  //     vm.paxMode = true;
	  //   });
	  //
	  // }
	  //
	  //
	  // // products of the same basis
	  // function paxBasedStructure(products) {
	  //   const base = _getBase(products);
	  //   $log.debug('base product', base)
	  //
	  // }
	}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	ProductCloneEditCtrl.$inject = ["$log", "$mdDialog", "apiUrl", "$http", "units", "boards", "rateBases", "propertyCtrl", "group"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ProductCloneEditCtrl;
	var moment = __webpack_require__(10);

	function ProductCloneEditCtrl($log, $mdDialog, apiUrl, $http, units, boards, rateBases, propertyCtrl, group) {
	  "ngInject";

	  // console.log("-------------group-------------", group);

	  var PATCH_URL = apiUrl + "/commands/batch-clone-rates";
	  var vm = this;
	  //$log.debug(units);
	  console.log("rateCodegroup", group);

	  vm.periods = [];
	  vm.applyChanges = applyChanges;
	  vm.productHasChilds = productHasChilds;
	  vm.onRateGroupSwitch = onRateGroupSwitch;
	  vm.productHasTwoChilds = productHasTwoChilds;
	  vm.applyClone = applyClone;
	  vm.group = group;
	  vm.cancel = function () {
	    $mdDialog.cancel();
	  };
	  vm.copyPorduct = copyPorduct;
	  vm.property = propertyCtrl.property;
	  // console.log("age;",propertyCtrl.property );
	  // console.log("age0 ", vm.property.policies.age[0] );

	  vm.policiesAge = [];
	  if (vm.property.policies.age && vm.property.policies.age.length > 2) {
	    for (var i = 2; i < vm.property.policies.age.length; i++) {
	      vm.policiesAge.push(vm.property.policies.age[i]);
	      // }
	    }
	  }
	  // //https://gist.github.com/axelpale/3118596
	  //   function k_combinations(set,product, k) {
	  //     var i, j, combs, head, tailcombs;

	  //     // There is no way to take e.g. sets of 5 elements from
	  //     // a set of 4.
	  //     if (k > set.length || k <= 0) {
	  //       return [];
	  //     }

	  //     // K-sized set has only one K-sized subset.
	  //     if (k == set.length) {
	  //       return [set];
	  //     }

	  //     // There is N 1-sized subsets in a N-sized set.
	  //     if (k == 1) {
	  //       combs = [];
	  //       for (i = 0; i < set.length; i++) {
	  //         combs.push([set[i]]);
	  //       }
	  //       return combs;
	  //     }

	  //     // Assert {1 < k < set.length}

	  //     // Algorithm description:
	  //     // To get k-combinations of a set, we want to join each element
	  //     // with all (k-1)-combinations of the other elements. The set of
	  //     // these k-sized sets would be the desired result. However, as we
	  //     // represent sets with lists, we need to take duplicates into
	  //     // account. To avoid producing duplicates and also unnecessary
	  //     // computing, we use the following approach: each element i
	  //     // divides the list into three: the preceding elements, the
	  //     // current element i, and the subsequent elements. For the first
	  //     // element, the list of preceding elements is empty. For element i,
	  //     // we compute the (k-1)-computations of the subsequent elements,
	  //     // join each with the element i, and store the joined to the set of
	  //     // computed k-combinations. We do not need to take the preceding
	  //     // elements into account, because they have already been the i:th
	  //     // element so they are already computed and stored. When the length
	  //     // of the subsequent list drops below (k-1), we cannot find any
	  //     // (k-1)-combs, hence the upper limit for the iteration:
	  //     combs = [];
	  //     for (i = 0; i < set.length - k + 1; i++) {
	  //       // head is a list that includes only our current element.
	  //       head = set.slice(i, i + 1);
	  //       // We take smaller combinations from the subsequent elements
	  //       tailcombs = k_combinations(set.slice(i + 1),product, k - 1);
	  //       // For each (k-1)-combination we join it with the current
	  //       // and store it to the set of k-combinations.
	  //       for (j = 0; j < tailcombs.length; j++) {
	  //         combs.push(head.concat(tailcombs[j]));
	  //       }
	  //     }
	  //     return combs;
	  //   }

	  // function combinations(set, product) {
	  //   var k, i, combs, k_combs;
	  //   combs = [];
	  //   if (productHasGreaterThenTwoChilds(product.occupancy)) {
	  //     // Calculate all non-empty k-combinations
	  //     for (k = 1; k <= set.length; k++) {
	  //       k_combs = k_combinations(set, k);
	  //       for (i = 0; i < k_combs.length; i++) {
	  //         combs.push({
	  //           label:k_combs[i].join(' , '),
	  //           value:true
	  //         }
	  //           );
	  //       }
	  //     }
	  //   }

	  //   return combs;
	  // }

	  /*function getCombinations(product) {
	    console.log("product combinaisons ..", product);
	    var array = vm.property.policies.age;
	    let results = [];
	       if (productHasGreaterThenTwoChilds(product.occupancy)) {
	      for (let i = 0; i < array.length; i++) {
	        console.log("first loop : ", array[i]);
	        for (let j = i; j < array.length; j++) {
	          results.push({
	            label:`${array[i]} , ${array[j]}`,
	            value:true
	          });
	        }
	      }
	    }
	       return results;
	  }*/
	  //added
	  function onRateGroupSwitch(group) {
	    if (group.products) {
	      group.products = group.products.map(function (product) {
	        //console.log('product....', product)
	        product.selected = angular.copy(group.selected);
	        return product;
	      });
	    }
	  }

	  // console.log("policiesAge ", vm.policiesAge);

	  vm.boards = boards;
	  vm.rateBases = rateBases;
	  vm.units = units.map(function (unit) {
	    // console.log('---------------------------UNIT-----------------------------', unit)
	    var u = {
	      code: unit.code,
	      name: unit.name
	    };
	    loadProducts(unit, u);
	    return u;
	  });

	  function productHasChilds(occupancy) {
	    //occupancy adults enfant bebe
	    return occupancy % 100 >= 10;
	  }

	  function productHasTwoChilds(occupancy) {
	    //occupancy adults enfant bebe
	    return occupancy % 100 >= 20;
	  }

	  // function productHasGreaterThenTwoChilds(occupancy) {
	  //   //occupancy adults enfant bebe 120 at least 2 childs
	  //   return occupancy % 100 >= 20;
	  // }

	  function copyPorduct(ratecpy, rateCode, rates, pourcent) {
	    for (var k = 0; k < rates.length; k++) {
	      if (rates[k].basis.code == rateCode) {
	        console.log("rateCode", rateCode);

	        for (var i = 0; i < rates[k].products.length; i++) {
	          for (var j = 0; j < ratecpy.products.length; j++) {
	            console.log("supplementEnf", rates[k].products[i].product.supEnf);
	            if (rates[k].products[i].product.occupancy == ratecpy.products[j].product.occupancy) {
	              if (rates[k].products[i].product.board == ratecpy.products[j].product.board) {

	                ratecpy.products[j].price = Number((rates[k].products[i].price / 100 * pourcent).toFixed(2));
	                // var sup=Object.keys(rates[k].products[i].product.supEnf).map((key) => [Number(key), rates[k].products[i].product.supEnf[key]]);
	                // console.log("supplementEnffinals",sup);
	                if (ratecpy.products[j].product.occupancy % 100 > 0) {
	                  console.log("supplementrrrrrddER", rates[k].products[i]);
	                  //  rates[k].products[i].product.supEnf.map(function(key0, index) {
	                  //   console.log("supplementrrrrrddR",key0);
	                  //  });
	                  Object.keys(rates[k].products[i].product.supEnf).map(function (key0, index) {

	                    ratecpy.products[j].product.supEnf[key0] = Number((rates[k].products[i].product.supEnf[key0] / 100 * pourcent).toFixed(2));
	                  });
	                  if (ratecpy.products[j].product.occupancy % 100 >= 20) {
	                    ratecpy.products[j].product.supEnf2 = [];
	                    Object.keys(rates[k].products[i].product.supEnf2).map(function (key1, index) {

	                      ratecpy.products[j].product.supEnf2[key1] = Number((rates[k].products[i].product.supEnf2[key1] / 100 * pourcent).toFixed(2));
	                    });
	                  }
	                  // rates[k].products[i].product.supEnf.map((age) => {
	                  //   console.log("supplementEnffinals",ratecpy.products[j].product.supEnf[s]);

	                  //   ratecpy.products[j].product.supEnf[s]=(rates[k].products[i].product.supEnf[s]/ 100) * pourcent
	                  // })
	                  console.log("supplementEnffinal", ratecpy.products[j].product.supEnf);
	                }
	                //ratecpy.products[j].product.supEnf =rates[k].products[i].product.supEnf;
	                //  (rates[k].products[i].price / 100) * pourcent;
	                // console.log("new price", ratecpy.products[j].price);
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	  function applyChanges() {
	    var args = {
	      periods: vm.getPeriods(),
	      products: [],
	      rates: [],
	      // supEnf: [],
	      supp: [],
	      secondSupp: []
	      //markups:[],
	    };

	    // for each unit/for each group/for each item
	    vm.units.forEach(function (u) {
	      return u.rateGroups
	      //.filter((g) => g.selected)
	      .forEach(function (g) {
	        return g.products.filter(function (p) {
	          return p.selected;
	        }).forEach(function (p) {
	          // console.log("p.suppEnf", p.product);

	          var supplementEnf = {
	            productCode: null,
	            price: p.product.supEnf
	          };

	          var supplementEnf2 = {
	            productCode: null,
	            price: p.product.supEnf2
	          };

	          // var markup=  {
	          //   productCode:null,
	          //   tarif:0

	          // };

	          // console.log("occs",occs);

	          // console.log("occs[1]",occs[1]);
	          // console.log("g.supEnf",g.supEnf);
	          //console.log("markup",g.markup);

	          //  if(g.markup != null){
	          //   markup.productCode=p.code;
	          //   markup.tarif=g.markup;
	          //   args.markups.push(markup);
	          // }
	          if (productHasChilds(p.product.occupancy)) {
	            // console.log("g.supEnf", g.supEnf);
	            supplementEnf.productCode = p.code;
	            if (productHasTwoChilds(p.product.occupancy)) {
	              supplementEnf2.productCode = p.code;
	            }

	            // console.log("supEnf", supenf);

	            if (vm.property.policies.age && vm.property.policies.age.length > 2) {
	              var price0 = {};
	              price0[vm.property.policies.age[0]] = 0;
	              angular.extend(supplementEnf.price, price0);
	              if (productHasTwoChilds(p.product.occupancy) && supplementEnf2.price != undefined) {
	                console.log("supplementEnf2", supplementEnf2.price);

	                angular.extend(supplementEnf2.price, price0);
	              }
	              var price1 = {};
	              price1[vm.property.policies.age[1]] = 0;
	              angular.extend(supplementEnf.price, price1);
	              if (productHasTwoChilds(p.product.occupancy) && supplementEnf2.price != undefined) {

	                angular.extend(supplementEnf2.price, price1);
	              }
	            }

	            // supenf.price = p.supEnf;

	            args.supp.push(supplementEnf);
	            args.secondSupp.push(supplementEnf2);
	          }

	          args.products.push(p.code);
	          args.rates.push(p.price);
	        });
	      });
	    });
	    $http.post(PATCH_URL, args).then(function () {
	      $log.debug("nights updated");
	      $mdDialog.hide(args);
	    });
	  }

	  /**
	   * [loadProducts description]
	   * @param  {[type]} unit [description]
	   * @param  {[type]} u    [description]
	   * @return {[type]}      [description]
	   */
	  function loadProducts(unit, u) {
	    // console.log('-------------LOAD product-------------', unit, u)
	    var items = unit.products.items.map(function (p) {
	      return {
	        price: null,
	        code: p.code,
	        selected: true,
	        product: p
	      };
	    });

	    u.rateGroups = vm.rateBases.map(function (rb) {
	      var products = items.filter(function (p) {
	        return p.product.rateBasis === rb.code;
	      }).map(function (p) {
	        p.product.supEnf = p.product.supEnf || {};
	        /*p.product.policiesCombinations = combinations(
	          vm.property.policies.age, p.product
	        );*/

	        // p.product.policiesCombinations = k_combinations(vm.property.policies.age,p.product, 3)

	        return p;
	      });

	      return {
	        basis: rb,
	        products: products,
	        selected: group.basis.code === rb.code ? true : false
	      };
	    });

	    $log.debug(u);
	    return u;
	  }

	  function applyClone(group, input) {
	    var periods = [];
	    var startDate, endDate;
	    startDate = moment(input.start).format('YYYY-MM-DD');
	    endDate = moment(input.end).format('YYYY-MM-DD');

	    var period = {
	      start: startDate,
	      end: endDate
	      //   weekdays: [0, 1, 2, 3, 4, 5, 6]
	    };

	    periods.push(period);
	    console.log("group::", group);
	    console.log("input::", moment(input.start).format('YYYY-MM-DD'));
	    console.log("end::", moment(input.end).format('YYYY-MM-DD'));

	    var args = {
	      group: group,
	      periods: periods,
	      applicableDate: input.applicableDate,
	      pourcent: input.pourcent
	    };

	    console.log("args::", args);
	    $http.post(PATCH_URL, args).then(function () {
	      $log.debug("clone updated");
	      $mdDialog.hide(args);
	    });
	  }
	  // function _getMaxAt(occupancies, i) {
	  //   return occupancies
	  //     .map(o => ('' + o)[i])
	  //     .map(n => parseInt(n, 10))
	  //     .sort()
	  //     .reverse()[0];
	  // }
	  //
	  //
	  // function _getBase(products) {
	  //   var tmp = products.slice(0);
	  //   tmp.sort((a, b) => a.board - b.board);
	  //   var doubles = tmp.filter(p => p.occupancy === 200);
	  //   if (doubles.length === 0) {
	  //     return tmp[0];
	  //   }
	  //   return doubles[0];
	  // }

	  //
	  //
	  // function turnPaxModeOn() {
	  //   // splite by rate basis
	  //   vm.units.forEach(u => {
	  //     Object.keys(u.rateBases)
	  //       .forEach(basisCode => {
	  //         var i = 0;
	  //         const basis = u.rateBases[basisCode];
	  //         basis.boards = _.uniq(basis.products.map(p => p.board));
	  //         basis.baseBoard = basis.boards.sort().shift();
	  //         basis.occupancies = _.uniq(basis.products.map(p => p.occupancy));
	  //         basis.occupancies.sort();
	  //         const maxChildren = _getMaxAt(basis.occupancies, 1);
	  //         basis.childrenPrices = [];
	  //         basis.infantsPrices = [];
	  //         i = 0;
	  //         while (i < maxChildren) {
	  //           basis.childrenPrices.push({
	  //             label: 'Enfant ' + (i + 1),
	  //             value: null
	  //           });
	  //           i++;
	  //         }
	  //         const maxInfants = _getMaxAt(basis.occupancies, 2);
	  //         i = 0;
	  //         while (i < maxInfants) {
	  //           basis.infantsPrices.push({
	  //             label: 'Bébé ' + (i + 1),
	  //             value: null
	  //           });
	  //           i++;
	  //         }
	  //         basis.boardsPrices = basis.boards.map(b => Object.create({
	  //           code: b,
	  //           value: null
	  //         }));
	  //         if (basis.occupancies[0] < 200) {
	  //           basis.hasSingle = true;
	  //         }
	  //
	  //         //const struct = paxBasedStructure(]);
	  //         $log.debug('basis', basis, maxChildren, maxInfants);
	  //       });
	  //     vm.paxMode = true;
	  //   });
	  //
	  // }
	  //
	  //
	  // // products of the same basis
	  // function paxBasedStructure(products) {
	  //   const base = _getBase(products);
	  //   $log.debug('base product', base)
	  //
	  // }
	}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	productsHelper.$inject = ["$filter", "$mdColorPalette"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = productsHelper;

	var moment = __webpack_require__(10);
	var d3 = __webpack_require__(15);

	function productsHelper($filter, $mdColorPalette) {
	  "ngInject";

	  // XXX this should not be hard coded;

	  var boardMap = new Map();
	  boardMap.set(1000, "BO");
	  boardMap.set(1100, "BB");
	  boardMap.set(1110, "HB");
	  boardMap.set(1101, "HBd");
	  boardMap.set(1111, "FB");
	  boardMap.set(2111, "AI");
	  boardMap.set(1222, "AI");
	  boardMap.set(1333, "AIP");
	  boardMap.set(1444, "AIB");

	  /*
	  const GRAPH_MARGINS = {
	    top: 40,
	    right: 40,
	    bottom: 40,
	    left: 40
	  };
	  */

	  // occupancy palletes
	  // single light blue /blue
	  // double light-green /green
	  // triple purple / Deep Purple
	  // quadruple / amber orange
	  // quintuple / deep orange brown

	  // regle de 3
	  // hue = 100% => 360
	  // occupnacies adult = 100% => 900`
	  // 900 => 360
	  // 200 => 88
	  // occupancy hue = (200*360/900)
	  var occupanciesPalettes = [[$mdColorPalette["blue"], $mdColorPalette["light-blue"]], [$mdColorPalette["green"], $mdColorPalette["orange"]], [$mdColorPalette["purple"], $mdColorPalette["blue"]], [$mdColorPalette["amber"], $mdColorPalette["deep-orange"]], [$mdColorPalette["red"], $mdColorPalette["purple"]], [$mdColorPalette["teal"], $mdColorPalette["cyan"]], [$mdColorPalette["lime"], $mdColorPalette["teal"]], [$mdColorPalette["grey"], $mdColorPalette["blue-grey"]], [$mdColorPalette["pink"], $mdColorPalette["light-green"]], [$mdColorPalette["brown"], $mdColorPalette["grey"]], [$mdColorPalette["blue"], $mdColorPalette["light-blue"]], [$mdColorPalette["green"], $mdColorPalette["orange"]], [$mdColorPalette["purple"], $mdColorPalette["blue"]], [$mdColorPalette["amber"], $mdColorPalette["deep-orange"]], [$mdColorPalette["red"], $mdColorPalette["purple"]], [$mdColorPalette["teal"], $mdColorPalette["cyan"]], [$mdColorPalette["lime"], $mdColorPalette["teal"]], [$mdColorPalette["grey"], $mdColorPalette["blue-grey"]], [$mdColorPalette["pink"], $mdColorPalette["light-green"]], [$mdColorPalette["brown"], $mdColorPalette["grey"]]];

	  //"light-green","purple","amber","deep-orange","pink","teal"];
	  var boards = [1000, 1100, 1110, 1101, 1111, 1222, 1333, 1444];
	  var boardsColors = ["400", "500", "600", "700", "800", "900", "400", "600"];

	  // adults => main color ["light-green","green","lime"];
	  // children => main palette
	  // infants =>

	  // 22210

	  //const colors = ['#8BC34A','#00bcd4', '#2196f3', '#03a9f4', '#3f51b5', '#9c27b0']

	  //  const colors = d3.scale.linear().domain([0,99]).interpolate(d3.interpolateHcl)

	  var adultPalettes = occupanciesPalettes.map(function (palette) {
	    return d3.scale.linear().domain([0, 446]).interpolate(d3.interpolateHcl).range([d3.rgb(palette[0]["400"].hex), d3.rgb(palette[1]["900"].hex)]);
	  });

	  // console.log(adultPalettes)

	  return {
	    ratesGraphOptions: ratesGraphOptions,
	    calendarToGraphs: calendarToGraphs,
	    productColor: productColor,
	    calendarToGraphsSuppEnf: calendarToGraphsSuppEnf,
	    calendarToGraphsSupp2Enf: calendarToGraphsSupp2Enf
	  };

	  function productColor(p /*,index,bases*/) {
	    //const basis = bases.find(b=>b.code === p.rateBasis);
	    //var rgb = (p.occupancy === 200 && p.board === 1000) ? "#8BC34A" : basis.color;// color(index);
	    //console.log(rgb,-index*0.10);
	    //var rgb = basis.color[boardShades[""+p.board]].hex;//shadeColor2(rgb, boardShades[""+p.board]);
	    console.log("productColor :: ", p);

	    if (p.occupancy > 100) {
	      var adults = Math.floor(p.occupancy / 100);
	      var iBoard = boards.indexOf(p.board);
	      var underAge = p.occupancy - adults * 100;
	      var value = underAge * 10 + iBoard;
	      //console.log(value);

	      var rgb = adultPalettes[adults - 1](value);
	    }
	    /*
	        const adults = Math.floor(p.occupancy/100);
	        const children = Math.floor((p.occupancy - (adults*100))/10);
	        const infants = p.occupancy - ((adults*100)+(children*10));
	        var base = $mdColorPalette[occupanciesPalettes[adults-1]]["500"].hex;
	        var hsl = d3.hsl(base);
	      // console.log(adults,children,infants);
	        // children add saturation
	        // infants add luminosity
	        hsl.s = (5 + children) /10;
	        hsl.l =  (5 + infants) /10;
	        hsl.h += ((boards.indexOf(p.board)) * 60);
	    
	    
	        base = hsl.toString();
	        */
	    //
	    /**
	    var base = adultPalettes[n](p.occupancy - ((n+1)*100));
	    // console.log(base)
	    var hsl = d3.hsl(base);
	    **/
	    //hsl.h = hsl.h + ((boards.indexOf(p.board)) * 20);
	    //console.log((boards.indexOf(p.board)) * 20);
	    //var rgb = hsl.toString();
	    //var rgb = $mdColorPalette[occupanciesPalettes[n]]["500"].hex;
	    //var rgb =  shadeColor2(basis.color["500"].hex,boardShades[""+p.board]);
	    //rgb =  blendColors(rgb, basis.color["500"].hex, 0.9);
	    //console.log("color",rgb);
	    //console.log(base);
	    //
	    if (p.occupancy === 200) {
	      rgb = $mdColorPalette["red"][boardsColors[boards.indexOf(p.board)]].hex;
	    } else {
	      rgb = undefined;
	    }

	    //rgb = (p.occupancy === 200 && p.board === 1000) ? "#8BC34A" : undefined;

	    angular.extend(p, {
	      color: rgb,
	      style: {
	        'background-color': rgb
	      }
	    });
	    return p;
	  }

	  function calendarToGraphsSuppEnf(product, calendar, period, ratesGraph) {
	    var series = {
	      code: product.code,
	      product: product,
	      //  color: product.color,
	      key: $filter("occupancy")(product.occupancy) + " " + "supplement 1 (enfant < " + product.age + ")" + boardMap.get(product.board),
	      values: _fillCalendar(calendar, period)
	    };

	    console.log("calendarToGraphsTest:::", series);
	    //const index = ratesGraph.data.map(s => s.product.code).indexOf(product.code);
	    //return series;
	    ratesGraph.data.push(series);
	    console.log("calendarToGraphsTestratesGraph.data:::", ratesGraph.data[ratesGraph.data.length - 1]);
	    var test = Object.assign({}, ratesGraph.data);
	    console.log("calendarToGraphsTestratesGraph.data:testtestSuppEnf::", test);
	    // if (index > -1) ratesGraph.data[index] = series;
	    // else  ratesGraph.data.push(series);
	  }

	  function calendarToGraphsSupp2Enf(product, calendar, period, ratesGraph) {
	    var series = {
	      code: product.code,
	      product: product,
	      //  color: product.color,
	      key: $filter("occupancy")(product.occupancy) + " " + "supplement 2 (enfant < " + product.age + ")" + boardMap.get(product.board),
	      values: _fillCalendar(calendar, period)
	    };

	    console.log("calendarToGraphsTest:::", series);
	    //const index = ratesGraph.data.map(s => s.product.code).indexOf(product.code);
	    //return series;
	    ratesGraph.data.push(series);
	    console.log("calendarToGraphsTestratesGraph.data:::", ratesGraph.data[ratesGraph.data.length - 1]);
	    var test = Object.assign({}, ratesGraph.data);
	    console.log("calendarToGraphsTestratesGraph.data:testtestSuppEnf::", test);
	    // if (index > -1) ratesGraph.data[index] = series;
	    // else  ratesGraph.data.push(series);
	  }

	  function calendarToGraphs(product, calendar, period, ratesGraph) {
	    var series = {
	      code: product.code,
	      product: product,
	      //  color: product.color,
	      key: $filter("occupancy")(product.occupancy) + " " + boardMap.get(product.board),
	      values: _fillCalendar(calendar, period)
	    };
	    // const index = ratesGraph.data.map(s => s.product.code).indexOf(product.code);
	    // if (index > -1) ratesGraph.data[index] = series;
	    // else  ratesGraph.data.push(series);
	    ratesGraph.data.push(series);
	    var test = Object.assign({}, ratesGraph.data);
	    console.log("calendarToGraphsTestratesGraph.data:testtest::", test);
	  }

	  function ratesGraphOptions(period) {
	    console.log("ratesGraphOptions", period.start.toDate());
	    console.log("ratesGraphOptions", period.end.toDate());

	    return {
	      deepWatchOptions: false,
	      deepWatchData: false,
	      deepWatchDataDepth: 0,
	      refreshDataOnly: true,
	      chart: {
	        noData: "Tarifs non communiqués",
	        type: "lineChart",
	        height: 500,
	        //margin: GRAPH_MARGINS,
	        useInteractiveGuideline: true,
	        duration: 100,
	        //interpolate: '',
	        //zoom: zoom,
	        clipEdge: false,
	        x: function x(item) {
	          return item.date;
	        },
	        // xDomain: [period.start.toDate(), period.end.toDate()],
	        // test
	        xScale: d3.time.scale(),
	        xAxis: {
	          //xScale : d3.time.scale(),
	          tickFormat: d3.time.format("%d/%m"),
	          //tickFormat: d3.time.format("%d/%m/%Y"),//d => moment(d).format('D/M/YYYY'),
	          //tickFormat: d => moment(d).format('D/M/YYYY'),
	          //tickValues: graphDates,
	          showMinMax: false
	          //ticks: graphDates.length + 1
	        },
	        y: function y(item) {
	          return item.price;
	        },
	        //forceY: [0,4],
	        yAxis: {
	          //ticks:4
	          tickFormat: d3.format(',f')
	        },
	        legend: {
	          maxKeyLength: 400
	        },
	        showLegend: false,
	        showControls: false
	      }
	    };
	  }

	  // d3 hates when series have different length
	  // use this to fill holes in an allotments series
	  function _fillCalendar(items, period) {
	    //console.time('fill');
	    var originalLength = items.length;
	    var length = moment(period.end).diff(period.start, 'days');
	    var final = [];
	    var lastDate = moment(period.start);
	    var i = 0;
	    while (i < originalLength) {
	      var itemDate = moment(new Date(items[i].date));
	      var diff = itemDate.diff(lastDate, 'days');
	      while (diff > 0) {
	        final.push(_emptyDate(moment(itemDate).subtract(diff, 'days')));
	        diff -= 1;
	      }
	      final.push(_asGraphItem(items[i]));
	      lastDate = moment(items[i].date).add(1, 'days');
	      i++;
	    }
	    if (final.length === 0) {
	      //console.log("empty cal");
	      final.push(_emptyDate(moment(lastDate)));
	    }
	    i = final.length;
	    while (i <= length) {
	      final.push(_emptyDate(moment(final[i - 1].date).add(1, 'days')));
	      i++;
	    }
	    //console.timeEnd('fill');
	    //console.log(final.length,final[0].date, final[final.length-1].date);
	    return final;
	  }

	  function _emptyDate(date) {
	    //console.log(date.toDate());
	    return {
	      date: date.toDate(), //format('YYYY-MM-DD'),
	      price: 0.0
	    };
	  }

	  function _asGraphItem(item) {
	    //const d = moment(item.date).toDate();
	    var d = new Date(item.date);
	    return {
	      date: d,
	      price: parseFloat(item.price)
	    };
	  }

	  /*
	        function shadeColor2(color, percent) {
	          var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
	          return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
	      }
	  
	      function blendColors(c0, c1, p) {
	          var f=parseInt(c0.slice(1),16),t=parseInt(c1.slice(1),16),R1=f>>16,G1=f>>8&0x00FF,B1=f&0x0000FF,R2=t>>16,G2=t>>8&0x00FF,B2=t&0x0000FF;
	          return "#"+(0x1000000+(Math.round((R2-R1)*p)+R1)*0x10000+(Math.round((G2-G1)*p)+G1)*0x100+(Math.round((B2-B1)*p)+B1)).toString(16).slice(1);
	      }*/
	}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(25);

	var _component2 = _interopRequireDefault(_component);

	var _component3 = __webpack_require__(26);

	var _component4 = _interopRequireDefault(_component3);

	var _controller = __webpack_require__(27);

	var _controller2 = _interopRequireDefault(_controller);

	var _rule = __webpack_require__(28);

	var _rule2 = _interopRequireDefault(_rule);

	var _helper = __webpack_require__(29);

	var _helper2 = _interopRequireDefault(_helper);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusDiscounts', ["ngMaterial"]).component(_component2.default.name, _component2.default).component(_component4.default.name, _component4.default).controller("DiscountCopyCtrl", _controller2.default).filter("discountRule", _rule2.default).factory("discountsHelper", _helper2.default).config(["$stateProvider", function discountRoutes($stateProvider) {
	  'ngInject';
	  // State

	  $stateProvider.state('property.discounts', {
	    url: '/discounts',
	    component: _component2.default.name,
	    data: {
	      menu: {
	        label: 'Promotions',
	        group: 'Tarifs et dispo',
	        position: 5
	      }
	    }
	  }).state('property.discountEdit', {
	    url: '/discounts/:discount/edit',
	    component: _component4.default.name,
	    resolve: {
	      discountCode: ["$stateParams", function discountCode($stateParams) {
	        'ngInject';

	        return $stateParams.discount;
	      }]
	    }
	  });
	}]);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	DiscountListCtrl.$inject = ["User", "$log", "$state", "$q", "$mdDialog", "datasets", "$http", "discountsHelper"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// const moment = require("moment");
	var _ = __webpack_require__(5);

	exports.default = {
	  name: 'discountList',
	  controller: DiscountListCtrl,
	  templateUrl: 'app/discounts/list/template2.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function DiscountListCtrl(User, $log, $state, $q, $mdDialog, datasets, $http, discountsHelper) {
	  'ngInject';

	  var vm = this;

	  angular.extend(vm, {
	    $onInit: init,
	    copy: copy,
	    remove: remove
	  });

	  function init() {

	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });
	    var propCtrl = vm.propertyCtrl;
	    var p1 = propCtrl.get('units').then(function (collection) {
	      return $q.all(collection.items.map(loadUnitProducts));
	    }).then(function (units) {
	      return vm.units = units;
	    });
	    var p2 = propCtrl.get('rate-bases').then(function (collection) {
	      return vm.rateBases = _.keyBy(collection.items, "code");
	    });
	    var p3 = datasets.bindSets(["boards", "unit-types"], vm, true);

	    $q.all([p1, p2, p3]).then(function () {
	      return propCtrl.get('discounts', {
	        $sort: "bookingPeriod>"
	      });
	    }).then(function (collection) {
	      angular.extend(vm, {
	        permissions: collection.permissions,
	        links: collection.links,
	        items: collection.items.map(decode)
	      });
	      setUpToolBar(propCtrl, vm.permissions);
	    });
	  }

	  function copy($event, discount) {
	    $mdDialog.show({
	      controller: "DiscountCopyCtrl",
	      controllerAs: "$ctrl",
	      templateUrl: 'app/discounts/copy/template.html',
	      targetEvent: $event,
	      fullscreen: true,
	      locals: {
	        discount: discount,
	        collectionHref: vm.links.self.href
	      }
	    }).then(function () {
	      return $state.reload();
	    });
	  }

	  function loadUnitProducts(unit) {
	    return $http.get(unit.links.products.href).then(function (res) {
	      unit.products = res.data.items;
	      return unit;
	    });
	  }

	  function productsGrid(unit) {
	    if (unit.all) {
	      return { unit: unit };
	    }
	    var rateBases = _.uniq(unit.products.map(function (p) {
	      return p.rateBasis;
	    }));
	    var occupancies = _.uniq(unit.products.map(function (p) {
	      return p.occupancy;
	    }));
	    var boards = _.uniq(unit.products.map(function (p) {
	      return p.board;
	    }));
	    // build the grid
	    var grid = rateBases.map(function (rateBasis) {
	      return occupancies.map(function (occupancy) {
	        return boards.map(function (board) {
	          return _.some(unit.products, { rateBasis: rateBasis, board: board, occupancy: occupancy });
	        });
	      });
	    });
	    return {
	      unit: unit,
	      // base: {board: _.min(boards)},
	      rateBases: rateBases,
	      occupancies: occupancies,
	      boards: boards,
	      grid: grid
	    };
	  }

	  function decode(discount) {
	    var decoded = discountsHelper.parse(discount);
	    decoded.units = uniqueUnits(discount.products, vm.units);
	    decoded.unitsGrid = decoded.units.map(productsGrid);
	    /*
	    if (copy.products.length === u.products.length) {
	      u.all = true;
	    }
	    else {
	      productsGrid(copy)
	    }
	    */
	    return decoded;
	    /*
	    return {
	      code: discount.code,
	      reference: discount.reference,
	      label: discount.label,
	      booking: {
	        period: parseBookingPeriod(discount.booking.period),
	        advance: parseIntRange(discount.booking.advance)
	      },
	      stay: {
	        period: parseStayPeriod(discount.stay.period),
	        length: parseIntRange(discount.stay.length)
	      },
	      cancellation: discount.cancellation,
	      payment: discount.payment,
	      rule: discount.rule,
	      units: uniqueUnits(discount.products, vm.units)
	    }*/
	  }

	  function uniqueUnits(productCodes, units) {
	    return units.map(function (u) {
	      var copy = _.pick(u, ["code", "name", "type"]);
	      copy.products = u.products.filter(function (p) {
	        return productCodes.includes(p.code);
	      });
	      copy.rateBases = _.uniq(copy.products.map(function (p) {
	        return p.rateBasis;
	      }));
	      if (copy.products.length === u.products.length) {
	        copy.all = true;
	      }
	      return copy;
	    }).filter(function (uCopy) {
	      return uCopy.products.length > 0;
	    });
	  }

	  function setUpToolBar(container, permissions) {
	    // console.log("setup up tool bar")
	    container.setBreadcrumb([{
	      label: "Promotions"
	    }]);

	    var actions = [{
	      label: "ajouter une promotion",
	      icon: "add",
	      href: $state.href("property.discountEdit", {
	        discount: "new"
	      })
	    }];
	    // const actions = permissions.add ? [{
	    //   label: "ajouter une promotion",
	    //   icon: "add",
	    //   href: $state.href("property.discountEdit", {
	    //     discount: "new"
	    //   })
	    // }] : [];
	    container.setActions(actions);
	  }

	  function remove($event, discount) {

	    var confirm = $mdDialog.confirm().title('Etes-vous sûr de vouloir supprimer cette promotion?').textContent('Cette opération est irreversible.').ariaLabel('Supression de promo').targetEvent($event).ok('Supprimer').cancel('Garder');

	    $mdDialog.show(confirm).then(function () {
	      return $http.delete(discount.links.self.href);
	    }).then(function () {
	      return $state.reload();
	    });
	  }

	  //
	  // function parsePeriod(string, regex) {
	  //   const match = string.match(regex);
	  //   const start = moment(match[1]);
	  //   const end = moment(match[2]);
	  //   return {
	  //     start: start.toDate(),
	  //     end: end.subtract(1, 'days')
	  //       .toDate()
	  //   }
	  // }
	  // function parseIntRange(string) {
	  //   const match = string.match(/^\[(\d+),(\d+)\)$/);
	  //   return {
	  //     min: parseInt(match[1], 10),
	  //     max: parseInt(match[2], 10) - 1
	  //   }
	  // }
	  //
	  // function parseBookingPeriod(string) {
	  //   return parsePeriod(string, /^\["([^"]+)","([^"]+)"\)$/)
	  // }
	  //
	  // function parseStayPeriod(string) {
	  //   return parsePeriod(string, /^\[([^,]{10}),([^,]{10})\)$/)
	  // }
	}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';

	DiscountEditCtrl.$inject = ["User", "$scope", "$state", "$log", "$q", "$mdDialog", "$http", "$stateParams", "datasets", "discountsHelper", "$mdToast", "lectusLanguages"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'discountEdit',
	  controller: DiscountEditCtrl,
	  templateUrl: 'app/discounts/edit/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  },
	  bindings: {
	    discountCode: "<"
	  }
	};


	function DiscountEditCtrl(User, $scope, $state, $log, $q, $mdDialog, $http, $stateParams, datasets, discountsHelper, $mdToast, lectusLanguages) {
	  "ngInject";

	  var vm = this;

	  angular.extend(vm, {
	    $onInit: $onInit,
	    languages: lectusLanguages,
	    save: save,
	    toggleCombinDiscount: toggleCombinDiscount,
	    options: {
	      bookingMin: moment().startOf('day').toDate(),
	      discountNights: {
	        f: "1ère(s) nuit(s)",
	        l: "dernière(s) nuit(s)",
	        e: "les plus chères",
	        c: "les moins chères"
	      }
	    },
	    countries: [],
	    combinationGroup: [],
	    toggles: {}
	  });

	  function $onInit() {
	    var propCtrl = vm.propertyCtrl;
	    setUpToolBar(propCtrl);
	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });

	    datasets.bindSets(["countries"], vm, false);

	    var p3 = datasets.bindSets(["boards", "unit-types"], vm, true);
	    var p2 = propCtrl.bindSets(["rate-bases"], vm);
	    var p1 = propCtrl.get('units').then(function (collection) {
	      return $q.all(collection.items.map(loadUnitProducts));
	    }).then(function (units) {
	      return vm.units = units;
	    });

	    $q.all([p1, p2, p3]).then(function () {
	      return loadDiscount(vm.discountCode);
	    }).then(function () {
	      vm.toggles = {
	        cancellation: angular.isArray(vm.discount.cancellation),
	        payment: vm.discount.payOnArrival,
	        markets: angular.isArray(vm.discount.markets)
	      };
	      vm.ready = true;
	      watchAndSyncPeriods();
	      assertProductsExist();
	    });

	    $q.all([p1, p2, p3]).then(function () {
	      return propCtrl.get('discounts', {
	        $sort: "bookingPeriod>"
	      });
	    }).then(function (collection) {
	      console.log("items", collection.items);

	      collection.items.map(function (disc) {
	        //disc = discountsHelper.parse(disc);
	        //  discountsHelper.parse(res.data);
	        disc.stay.period = parseStayPeriod(disc.stay.period);

	        console.log("items", disc);
	      });

	      angular.extend(vm, {
	        permissions: collection.permissions,
	        links: collection.links,
	        items: collection.items
	        //.map(decode)
	      });
	      setUpToolBar(propCtrl, vm.permissions);
	    });
	  }

	  function setUpToolBar(container) {
	    container.setBreadcrumb([{
	      label: "Promotions",
	      href: $state.href("property.discounts")
	    }]).setActions([]);
	  }

	  function watchAndSyncPeriods() {
	    var unwatchBookingStart = $scope.$watch(function () {
	      return vm.discount.stay.period.start;
	    }, function (val) {
	      if (angular.isDate(val)) {
	        vm.discount.stay.period.start = val;
	      }
	    });
	    var unwatchStayStart = $scope.$watch("discountForm.stayStart.$dirty", function (val) {
	      if (val === true) {
	        unwatchBookingStart();
	        unwatchStayStart();
	      }
	    });
	    var unwatchBookingEnd = $scope.$watch(function () {
	      return vm.discount.stay.period.end;
	    }, function (val) {
	      if (angular.isDate(val)) {
	        vm.discount.stay.period.end = val;
	      }
	    });
	    var unwatchStayEnd = $scope.$watch("discountForm.stayEnd.$dirty", function (val) {
	      if (val === true) {
	        unwatchBookingEnd();
	        unwatchStayEnd();
	      }
	    });
	  }

	  function loadUnitProducts(unit) {
	    return $http.get(unit.links.products.href).then(function (res) {
	      unit.products = res.data.items;
	      return unit;
	    });
	  }

	  function loadDiscount(code) {
	    var _arguments = arguments;

	    if (code === 'new') {
	      vm.isNew = true;
	      vm.discount = scaffold();
	      return;
	    }
	    return $http.get(vm.propertyCtrl.property.links.discounts.href + '/' + code, {
	      headers: {
	        'accept-language': ''
	      }
	    }).then(function (res) {
	      $log.debug('discount loaded', res.data);

	      vm.pristine = res.data;
	      vm.discount = discountsHelper.parse(res.data);
	      console.log("avdiscountcombinationGroup", JSON.stringify(vm.discount));

	      if (vm.discount.combinationGroup != null) vm.combinationGroup = vm.discount.combinationGroup;

	      console.log("discountcombinationGroup", vm.combinationGroup);
	    }, function () {
	      $log.debug('error loading discount', _arguments);
	    });
	  }

	  function refGenerator() {
	    var now = moment();
	    var formatedDate = moment(now, 'YYYY-MM-DD').format("YYYYMMDDHHmmss");
	    return "promo-" + formatedDate;
	  }

	  function scaffold() {
	    return {
	      //reference: '',
	      reference: refGenerator(),
	      label: {},
	      score: {
	        min: 1,
	        max: 10
	      },
	      ctrlStayPeriod: false,
	      ctrlCheckinDate: false,
	      ctrlCheckoutDate: false,
	      combinable: false,
	      combination: {
	        group: [],
	        rule: ''
	      },
	      // combinationGroup:[],
	      // combinationRule:'',
	      products: [],
	      rule: {
	        unit: null,
	        value: null
	      },
	      booking: {
	        period: {},
	        advance: {
	          min: 0,
	          max: 356
	        }
	      },
	      stay: {
	        period: {},
	        length: {
	          min: 1,
	          max: 30
	        }
	      },
	      payOnArrival: false,
	      baseOnly: false,
	      availability: -1,
	      cancellation: null
	    };
	  }

	  function toggleCombinDiscount(d) {
	    var combinationGroup = vm.combinationGroup;
	    if (combinationGroup != null) {
	      if (!combinationGroup.includes(d.code)) combinationGroup.push(d.code);else {
	        combinationGroup.splice(combinationGroup.indexOf(d.code));
	        console.log("delete ", d.code);
	      }
	    }
	    console.log("combinationGroup", combinationGroup);

	    vm.combinationGroup = combinationGroup;
	  }

	  function save() {
	    // for(var i=0; i<vm.discount.combinationGroup.length;i++){
	    //   if(vm.discount.combinationGroup[i]==true){
	    //     vm.discount.combination.group.push(vm.discount.combinationGroup[i]);
	    //   }
	    // }
	    vm.discount.combinationGroup = vm.combinationGroup;
	    // vm.discount.combination.group=vm.discount.combinationGroup.filter(a => a.true);
	    console.log("encoded", JSON.stringify(vm.discount));

	    var encoded = encode(vm.discount);

	    //return
	    //  return;

	    // pristine is the initial state of the discount
	    // we could also do if vm.isNew
	    // xxx we should have one source of truth! duh.
	    var promise = vm.pristine ? $http.put(vm.pristine.links.self.href, encoded) : $http.post(vm.propertyCtrl.property.links.discounts.href, encoded);

	    promise.then(function () {
	      $state.go("property.discountList");
	      //  saveSuccess;
	      $log.debug('saved');
	      $mdToast.show($mdToast.simple().textContent('Modifications enregistrées').hideDelay(3000));
	      $state.reload();
	    });
	  }

	  function saveSuccess() {
	    $state.go("property.discountList");
	  }

	  function patchFailure() {
	    $log.error(arguments);
	  }

	  function encode(discount) {
	    if (vm.allProducts) {
	      discount.products = vm.units.reduce(function (agg, u) {
	        return u.products.map(function (p) {
	          return p.code;
	        }).concat(agg);
	      }, []).sort();
	    }
	    discount.payOnArrival = vm.toggles.payment ? discount.payOnArrival : false;
	    discount.availability = vm.toggles.availability ? discount.availability : -1;

	    return discountsHelper.format(discount);
	  }

	  function assertProductsExist() {
	    var products = vm.units.reduce(function (agg, u) {
	      return u.products.concat(agg);
	    }, []);
	    if (products.length > 0) return;

	    $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('Aucun produit créé').textContent("Vous devez créer des offres avant de pouvoir ajouter des promotions.").ariaLabel('Delete failed').ok('OK')).then(function () {
	      return $state.go("property.products");
	    }, function () {
	      return $state.go("property.products");
	    });
	  }

	  function parseStayPeriod(string) {
	    var match = string.match(/^\[([^,]{10}),([^,]{10})\)$/);
	    var start = moment(match[1]);
	    var end = moment(match[2]);
	    return {
	      start: start.format('YYYY-MM-DD'),
	      end: end.subtract(1, 'days').format('YYYY-MM-DD')
	    };
	  }
	  /*
	    function init() {
	    vm.units = property.units.items.map(u => angular.copy(u));
	    loadProducts()
	      .then(setProductsUiHelpers);
	      angular.extend(vm, {
	      options: {
	        bookingMin: moment().startOf('day').toDate(),
	        stayMin: moment().startOf('day').toDate(),
	        discountNights: {
	          f: "1ère(s) nuit(s)",
	          l: "dernière(s) nuit(s)",
	          e: "les plus chères",
	          c: "les moins chères"
	        }
	      },
	      toggles: {
	        cancellation: angular.isArray(vm.discount.cancellation),
	        payment: angular.isNumber(vm.discount.payment),
	        markets: angular.isObject(vm.discount.markets)
	      },
	      save: save
	    });
	     setCalendarContraints();
	  }
	  function setCalendarContraints() {
	    $scope.$watch(() => vm.discount.booking.period, (v) => {
	      if (angular.isObject(v))
	        updateStayMinDate();
	    });
	    $scope.$watch(() => vm.discount.booking.advance, (v) => {
	      if (angular.isObject(v))
	        updateStayMinDate();
	    });
	  }
	   function loadProducts() {
	    const promises = vm.units.map(
	      u =>
	      $http.get(u.links.products.href).then(res => {
	        u.products = res.data.items.map(p => {
	          //p.rateBasis = findByCode(p.rateBasis, property.rateBases.items);
	          //p.board = findByCode(p.board, vm.boards);
	          return p;
	        })
	      })
	    );
	    return $q.all(promises);
	  }
	      function setProductsUiHelpers() {
	      const selectedProductCodes = vm.discount.products;
	      vm.units.forEach(u => {
	        u.selected = u.products.reduce(
	          (selected, p) => {
	            p.selected = selectedProductCodes.includes(p.code);
	            return selected || p.selected;
	          },
	          false
	        );
	      });
	    }
	     function updateStayMinDate() {
	      if (!angular.isObject(vm.discount.booking.advance)) return;
	      const bookingStart = vm.discount.booking.period.start || moment().startOf('day').toDate();
	      const b2sMin = vm.discount.booking.advance.min;
	      if (bookingStart === null) return;
	      if (b2sMin !== null) {
	        vm.options.stayMin = moment(bookingStart).add(b2sMin, 'days').toDate();
	      } else {
	        vm.options.stayMin = moment(bookingStart).toDate();
	      }
	      //console.log('vm.options.stayMin', vm.options.stayMin)
	    }
	    function findByCode(code, set) {
	      return set.find(item => item.code === code);
	    }
	   */
	}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	DiscountCopyCtrl.$inject = ["$log", "$http", "$scope", "$mdDialog", "lectusApi", "discount", "discountsHelper", "collectionHref"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DiscountCopyCtrl;

	var moment = __webpack_require__(10);

	function DiscountCopyCtrl($log, $http, $scope, $mdDialog, lectusApi, discount, discountsHelper, collectionHref) {
	  "ngInject";

	  var vm = this;

	  var originalStayStart = discount.stay.period.start;
	  var originalStayEnd = discount.stay.period.end;

	  angular.extend(vm, {
	    stayDateFilter: stayDateFilter,
	    save: save,
	    cancel: cancel,
	    booking: {
	      start: moment().startOf("day").toDate(),
	      end: discount.booking.period.end
	    },
	    stay: {}
	  });

	  $scope.$watch(function () {
	    return vm.stay.start;
	  }, function (val) {
	    var start = moment(val);
	    var end = moment(vm.stay.end);
	    if (angular.isDefined(val) && angular.isDefined(vm.stay.end) && start.isValid() && end.isValid() && end.isBefore(start)) {
	      vm.stay.end = moment(val).add(1, "days").toDate();
	    }
	  });

	  function stayDateFilter(d) {
	    var m = moment(d);
	    return m.isBefore(originalStayStart, 'day') || m.isAfter(originalStayEnd, 'day');
	  }

	  function save() {
	    var copy = _.omit(discount, ["links", "code", "acl", "audit", "units", "permissions"]);
	    copy.reference = vm.reference;
	    copy.booking.period = vm.booking;
	    copy.stay.period = vm.stay;
	    var encoded = discountsHelper.format(copy);

	    $http.post(collectionHref, encoded).then(function (res) {
	      $mdDialog.hide(res.data);
	    }, function (res) {
	      vm.status = "error";
	      $log.error("error saving discount", res);
	      vm.error = "Un problème est survenu lors de l'enrgistrement";
	    });
	    // console.log(encoded, collectionHref);
	  }

	  function cancel() {
	    $mdDialog.cancel();
	  }
	}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = discountRule;
	function discountRule() {

	  var nightsMap = {
	    f: {
	      one: 'première nuit offerte',
	      many: 'les {} premières nuits offertes'
	    },
	    l: {
	      one: 'dernière nuit offerte',
	      many: 'les {} dernères nuits offertes'
	    },
	    c: {
	      one: 'nuit la moins chère offerte',
	      many: '{} nuits les moins chères offertes'
	    },
	    e: {
	      one: 'nuit la plus chère offerte',
	      many: '{} nuits les plus chères offertes'
	    }
	  };

	  return function discountRuleFilter(rule, currency) {
	    if (rule.unit === 'n') {
	      return formatNightDicount(rule) + baseOnly(rule);
	    } else if (rule.unit === "m") {
	      return ["Remise de ", rule.value, currency].join(' ') + baseOnly(rule);
	    } else {
	      return ["Remise de ", rule.value, rule.unit].join(' ') + baseOnly(rule);
	    }
	  };

	  function formatNightDicount(rule) {
	    var nights = rule.nights || 'f';
	    return plural(rule.value, nightsMap[nights]);
	  }

	  function plural(count, map) {
	    return count === 1 ? map.one : map['many'].replace('{}', count);
	  }

	  function baseOnly(rule) {
	    return rule.baseOnly ? " sur la base" : "";
	  }
	}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = discountsHelper;

	var moment = __webpack_require__(10);

	function discountsHelper() {
	  "ngInject";

	  return {
	    parse: parse,
	    format: format
	  };

	  function parse(raw) {
	    return _.extend(_.omit(raw, ["booking", "stay"]), {
	      booking: {
	        period: parseBookingPeriod(raw.booking.period),
	        advance: parseIntRange(raw.booking.advance)
	      },
	      stay: {
	        period: parseStayPeriod(raw.stay.period),
	        length: parseIntRange(raw.stay.length)
	      }
	    });
	  }
	  function format(discount) {
	    return _.extend(_.omit(discount, ["booking", "stay"]), {
	      booking: {
	        period: formatBookingPeriod(discount.booking.period),
	        advance: formatIntRange(discount.booking.advance)
	      },
	      stay: {
	        period: formatStayPeriod(discount.stay.period),
	        length: formatIntRange(discount.stay.length)
	      }
	    });
	  }

	  function parseBookingPeriod(string) {
	    var match = string.match(/^\["([^"]+)","([^"]+)"\)$/);
	    var start = moment(match[1]);
	    var end = moment(match[2]);
	    return {
	      start: start.toDate(),
	      end: end.subtract(1, 'days').toDate()
	    };
	  }

	  function formatBookingPeriod(range) {
	    var format = '"YYYY-MM-DD HH:mm:ss"';
	    var start = moment(range.start).format(format);
	    var end = moment(range.end).startOf('day').add(1, 'days').format(format);
	    return formatRange(start, end);
	  }

	  function parseStayPeriod(string) {
	    var match = string.match(/^\[([^,]{10}),([^,]{10})\)$/);
	    var start = moment(match[1]);
	    var end = moment(match[2]);
	    return {
	      start: start.toDate(),
	      end: end.subtract(1, 'days').toDate()
	    };
	  }

	  function formatStayPeriod(range) {
	    var format = 'YYYY-MM-DD';
	    var start = moment(range.start).format(format);
	    var end = moment(range.end).startOf('day').add(1, 'days').format(format);
	    return formatRange(start, end);
	  }

	  function parseIntRange(string) {
	    var match = string.match(/^\[(\d+),(\d+)\)$/);
	    return {
	      min: parseInt(match[1], 10),
	      max: parseInt(match[2], 10) - 1
	    };
	  }

	  function formatIntRange(range) {
	    return formatRange(range.min, range.max + 1);
	  }

	  function formatRange(start, end) {
	    return "[" + start + "," + end + ")";
	  }
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(31);

	var _component2 = _interopRequireDefault(_component);

	var _component3 = __webpack_require__(32);

	var _component4 = _interopRequireDefault(_component3);

	var _component5 = __webpack_require__(33);

	var _component6 = _interopRequireDefault(_component5);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module("lectusPropertyDescription", ["ngAnimate", "ngAria", "ui.router", "ngMaterial", "lectusApi"]).component(_component2.default.name, _component2.default).component(_component6.default.name, _component6.default).component(_component4.default.name, _component4.default).config(["$stateProvider", function routes($stateProvider) {
	  'ngInject';

	  // State

	  $stateProvider.state('property.description', {
	    url: '/description',
	    component: _component2.default.name,
	    data: {
	      menu: {
	        rel: 'description',
	        label: 'Descriptif',
	        group: 'info',
	        position: 2
	      }
	    }
	  }).state('property.description.translation', {
	    url: '/:lang',
	    component: _component6.default.name,
	    resolve: {
	      enableCompare: function enableCompare() {
	        return true;
	      },
	      languageCode: ["$stateParams", function languageCode($stateParams) {
	        "ngInject";

	        return $stateParams.lang;
	      }]
	    }
	  });
	}]);

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';

	TranslationListCtrl.$inject = ["$log", "$timeout", "$mdSidenav", "$state", "$stateParams", "lectusLanguages"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "propertyTranslationList",
	  controller: TranslationListCtrl,
	  templateUrl: 'app/content/translation-list/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function TranslationListCtrl($log, $timeout, $mdSidenav, $state, $stateParams, lectusLanguages) {
	  "ngInject";

	  var vm = this;

	  $log.debug('DescriptionCtrl');

	  angular.extend(vm, {
	    languages: _.keyBy(lectusLanguages, "code"),
	    $onInit: $onInit,
	    get: get
	  });

	  function $onInit() {
	    vm.ready = vm.propertyCtrl.get("description").then(function (collection) {
	      vm.links = collection.links;
	      vm.permissions = collection.permissions;
	      vm.translations = lectusLanguages.map(function (lang) {
	        var t9n = collection.items.find(function (item) {
	          return item.lang === lang.code;
	        }) || {
	          lang: lang.code,
	          status: 'missing',
	          links: {}
	        };
	        t9n.links.view = {
	          href: $state.href("property.description.translation", {
	            lang: lang.code
	          })
	        };
	        return t9n;
	      });
	    });
	  }

	  function get(lang) {
	    return vm.translations.find(function (t) {
	      return t.lang === lang;
	    });
	  }
	}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	TranslationEditCtrl.$inject = ["$log", "$http", "$q"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _ = __webpack_require__(5);

	exports.default = {
	  name: "propertyTranslationEdit",
	  controller: TranslationEditCtrl,
	  templateUrl: 'app/content/translation-edit/template.html',
	  require: {
	    translationCtrl: "^propertyTranslationView",
	    descriptionCtrl: "^propertyTranslationList"
	  },
	  bindings: {
	    translation: "=",
	    closeHandler: "="
	  }
	  //http://localhost:3000/#/properties/11/description/fr/edit

	};
	function TranslationEditCtrl($log, $http, $q) {
	  "ngInject";

	  var vm = this;

	  vm.$onInit = function $onInit() {
	    vm.copy = angular.copy(vm.translation);
	    vm.lang = vm.descriptionCtrl.languages[vm.translation.lang];
	    if (_.get(vm.copy, "links.self")) {
	      vm.save = update;
	    } else {
	      vm.save = add;
	    }
	  };

	  function update() {
	    // TODO check if unit names translation have been modified
	    // those are stored with units, not in property description
	    saveUnitNamesChange(vm.translation, vm.copy).then(function () {
	      return $http.put(vm.translation.links.self.href, cleanUp(vm.copy));
	    }).then(function (res) {
	      return vm.closeHandler(res.data);
	    });
	  }

	  function add() {
	    saveUnitNamesChange(vm.translation, vm.copy).then(function () {
	      return $http.post(vm.descriptionCtrl.links.self.href, cleanUp(vm.copy));
	    }).then(function (res) {
	      return vm.closeHandler(res.data);
	    });
	  }

	  function saveUnitNamesChange(original, edit) {
	    var changed = [];
	    original.units.forEach(function (uOriginal) {
	      var code = uOriginal.code;
	      var uEdit = edit.units.find(function (ue) {
	        return ue.code === code;
	      });
	      if (uOriginal.name !== uEdit.name) {
	        changed.push(uEdit);
	      }
	    });

	    return $q.all(changed.map(sendUnitName));
	  }

	  function sendUnitName(unitDesc) {
	    var body = {
	      code: unitDesc.code,
	      name: {}
	    };
	    body.name[vm.translation.lang] = unitDesc.name;
	    return $http.put(unitDesc.links.unit.href, body);
	  }

	  function cleanUp(copy) {
	    return {
	      property: copy.property,
	      lang: copy.lang,
	      description: copy.description,
	      policies: copy.policies,
	      units: copy.units.map(function (u) {
	        return _.pick(u, ["code", "description"]);
	      })
	    };
	  }
	}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	TranslationViewCtrl.$inject = ["$log", "$http", "datasets", "$state"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _ = __webpack_require__(5);

	exports.default = {
	  name: "propertyTranslationView",
	  controller: TranslationViewCtrl,
	  templateUrl: 'app/content/translation-view/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer',
	    listCtrl: "^propertyTranslationList"
	  },
	  bindings: {
	    languageCode: "<",
	    enableCompare: "<",
	    closeHandler: "="
	  }
	};


	function TranslationViewCtrl($log, $http, datasets, $state) {
	  "ngInject";

	  var vm = this;

	  vm.state = "view";
	  vm.edit = edit;
	  vm.closeEditView = closeEditView;

	  vm.$onInit = function $onInit() {

	    var opts = {
	      headers: {
	        "Accept-Language": vm.languageCode
	      }
	    };

	    $log.debug("TranslationViewCtrl", vm.languageCode);

	    vm.ready = datasets.bindSets(["unit-types"], vm, true, opts).then(function () {
	      return vm.propertyCtrl.bindSets(["units"], vm, false, opts);
	    }).then(function () {
	      return vm.listCtrl.ready;
	    }).then(function () {
	      return $http.get(vm.listCtrl.links.self.href + "/" + vm.languageCode);
	    }).then(_translationLoaded, _errorOnLoad).finally(function () {
	      if (vm.enableCompare) {
	        setupCompareFeature();
	      }
	    });
	  };

	  function _translationLoaded(res) {
	    res.data.units = _hackArroundJSONBPGBug(res.data.units);
	    var translation = res.data;
	    vm.original = angular.copy(res.data);
	    translation.units = vm.units.map(function (u) {
	      var desc = _hackArroundJSONBPGBug(translation.units).find(function (desc) {
	        return desc.code === u.code;
	      });
	      if (desc) {
	        angular.extend(desc, _.pick(u, ["name", "type"]));
	      } else {
	        // not translated
	        desc = angular.extend(_.pick(u, ["code", "name", "type"]), { description: "" });
	      }
	      desc.links = {
	        unit: u.links.self
	      };
	      return desc;
	    });
	    translation.units.sort(function (a, b) {
	      return a.code > b.code ? 1 : b.code > a.code ? -1 : 0;
	    });
	    vm.translation = translation;
	  }

	  function _hackArroundJSONBPGBug(units) {
	    if (_.isString(units)) {
	      var json = units.replace(/^\{/, "[").replace(/\}$/, "]").replace(/"\{/g, "{").replace(/\}"/g, "}").replace(/\\/g, "");
	      console.log(json);
	      return JSON.parse(json);
	    } else {
	      return units;
	    }
	  }

	  function edit() {
	    vm.state = "edit";
	  }

	  function _errorOnLoad(res) {
	    if (res.status === 404) {
	      vm.translation = {
	        lang: vm.languageCode,
	        property: vm.propertyCtrl.property.code,
	        description: "",
	        units: vm.units.map(function (u) {
	          return angular.extend(_.pick(u, ["code", "name", "type"]), { description: "" });
	        })
	      };
	      vm.saveTranslation = add;
	      edit();
	    } else {
	      $log.error("Unexpected server error ", res.status);
	    }
	  }

	  function add() {}

	  function setupCompareFeature() {
	    vm.otherTranslations = vm.listCtrl.translations.filter(function (t) {
	      return t.lang !== vm.translation.lang && t.status !== 'missing';
	    });
	    vm.compare = vm.enableCompare && vm.otherTranslations.length > 0;
	    vm.compareTo = compareTo;
	    vm.closeCompareView = closeCompareView;
	  }

	  function closeCompareView() {
	    vm.compareToLang = undefined;
	  }

	  function compareTo(translation) {
	    vm.compareToLang = translation.lang;
	  }

	  function closeEditView(update) {
	    if (update) {
	      $state.go("property.description", {}, { reload: true });
	    }
	    vm.state = "view";
	  }
	}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(35);

	var _component2 = _interopRequireDefault(_component);

	var _component3 = __webpack_require__(36);

	var _component4 = _interopRequireDefault(_component3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module("lectusMedia", ["ngAnimate", "ngSanitize", "ngMessages", "ngAria", "ui.router", "ngMaterial", "lectusApi", "ngFileUpload"]).component(_component2.default.name, _component2.default).component(_component4.default.name, _component4.default).config(["$stateProvider", function mediaRoutes($stateProvider) {
	  'ngInject';
	  // State

	  $stateProvider.state('property.media', {
	    url: '/media',
	    component: 'mediaGallery',
	    data: {
	      menu: {
	        label: 'Media',
	        group: 'info',
	        position: 2
	      }
	    }
	  });
	}]);

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';

	MediaGalleryCtrl.$inject = ["$scope", "$log", "$http", "$mdDialog", "$mdToast"];
	AddDialogWrapper.$inject = ["$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//https://docs.angularjs.org/guide/component
	exports.default = {
	  name: 'mediaGallery',
	  controller: MediaGalleryCtrl,
	  templateUrl: 'app/media/gallery/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function MediaGalleryCtrl($scope, $log, $http, $mdDialog, $mdToast) {
	  "ngInject";

	  var vm = this;

	  vm.$onInit = function () {
	    vm.propertyCtrl.setBreadcrumb([{ label: 'Medias' }]);
	    vm.propertyCtrl.setActions([{ icon: "add", label: "ajouter une photo ou une video", run: addNew }]);
	    load();
	  };

	  angular.extend(vm, {
	    addNew: addNew,
	    changeOrder: changeOrder,
	    removeMedia: removeMedia,
	    update: update,
	    test: test
	  });

	  function update($event, media) {
	    // shoud just send diff anuse patch
	    $http({
	      method: "PUT",
	      url: media.links.self.href,
	      headers: {
	        "Content-Language": "**"
	      },
	      data: media
	    }).then(onSuccess, onError);
	  }

	  function onSuccess(response) {
	    console.log('successfully updated');
	    $mdToast.show($mdToast.simple().textContent('Modifications enregistrées').hideDelay(3000));
	  }
	  function onError(response) {
	    console.log(response);
	  }

	  function load() {
	    vm.propertyCtrl.get("media").then(function (data) {
	      console.log("collection media::: ", data.items);
	      vm.items = data.items;
	      vm.links = data.links;

	      loadUnits();
	    });
	  }

	  function loadUnits() {
	    var hotel = {
	      code: "null",
	      name: "Hotel"

	    };
	    vm.propertyCtrl.get('units').then(function (data) {
	      vm.units = data.items.concat(hotel);
	    });
	  }

	  /**
	   * fix me please
	   * @param  {[type]} item  [description]
	   * @param  {[type]} index [description]
	   * @return {[type]}       [description]
	   */
	  function changeOrder(item, index) {
	    $log.debug("item new index", index);

	    /*
	    var i = index;
	    // push
	    while (i < vm.items.length) {
	      vm.items[i].weight +=1;
	      i++;
	    }
	    item.weight = index;
	    //item.weight = index;
	    $log.info("item",item.weight, "all", vm.items);
	    */

	    var range = [index, item.weight].sort(function (a, b) {
	      return a - b;
	    });
	    // stupid but works, i am lazy, somebody do something about this
	    var items = vm.items.filter(function (i) {
	      return range[0] <= i.weight && i.weight <= range[1] && i !== item;
	    });

	    //  console.log("items to change", range, items);
	    var inc = index < item.weight ? 1 : -1;
	    items.forEach(function (i) {
	      return i.weight += inc;
	    });
	    item.weight = index;
	    //    console.log(item, items.map(i => console.log(i.weight)));

	    items.push(item);

	    vm.items.forEach(function (item) {
	      $http.put(item.links.self.href, _.pick(item, ["url", "weight"]));
	    });

	    return item;
	  }

	  function removeMedia($event, media) {
	    var confirm = $mdDialog.confirm().title('Confirmer la suppression?').textContent('Etes-vous sûr de vouloir supprimer cet element ?').ariaLabel('Delete pic').targetEvent($event).ok('Supprimer').cancel('Ne pas supprimer');

	    $log.debug(media.links);

	    $mdDialog.show(confirm).then(function () {
	      return $http.delete(media.links.self.href);
	    }).then(function () {
	      return vm.items.splice(vm.items.indexOf(media), 1);
	    });
	  }

	  function addNew() {

	    $mdDialog.show({
	      template: '<md-dialog><media-upload weight="' + vm.items.length + '" target="\'' + vm.links.self.href + '\'" on-saved="$ctrl.onSaved(mediaInfo)" on-cancel="$ctrl.onCancel()" ></media-upload></md-dialog>',
	      clickOutsideToClose: false,
	      controller: AddDialogWrapper,
	      controllerAs: "$ctrl"
	    }).then(function (mediaInfo) {
	      $log.debug("saved!", mediaInfo);
	      load();
	    });
	  }

	  function test($event, media) {
	    console.log("media;; ", media);
	    // shoud just send diff anuse patch
	    $http({
	      method: "PUT",
	      url: media.links.self.href,
	      headers: {
	        "Content-Language": "**"
	      },
	      data: media
	    }).then(onSuccess, onError);
	  }
	}

	function AddDialogWrapper($mdDialog) {
	  "ngInject";

	  this.onSaved = function (mediaInfo) {
	    $mdDialog.hide(mediaInfo);
	  };
	  this.onCancel = function () {
	    $mdDialog.cancel();
	  };
	}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';

	MediaUploadCtrl.$inject = ["$scope", "$log", "$q", "Upload"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'mediaUpload',
	  controller: MediaUploadCtrl,
	  templateUrl: 'app/media/upload/template.html',
	  // require: {
	  //   propertyCtrl: '^propertyContainer'
	  // },
	  bindings: {
	    target: "<",
	    weight: "=",
	    onSaved: "&",
	    onCancel: "&",
	    breadcrumb: '<'
	  }

	};


	function MediaUploadCtrl($scope, $log, $q, Upload) {
	  "ngInject";

	  var vm = this;

	  vm.validation = {
	    size: { max: '100MB' }
	    // width: {min: 600},
	    // height: {min: 800},
	    // pattern: "image/jpeg",
	    // accept: "image/jpeg"
	  };

	  vm.post = upload;

	  $scope.$on("postMedia", function ($event, postInfo) {
	    $log.debug("postMedia", arguments);
	    postInfo.progress = upload(postInfo);
	  });

	  function upload() {
	    console.log("vm.target ", vm.target);

	    vm.uploading = true;
	    return Upload.upload({
	      url: vm.target,
	      data: {
	        file: vm.file,
	        subject: vm.subject,
	        weight: vm.weight
	      }
	    }).then(function (res) {
	      $log.debug('Success ' + res.config.data.file.name + 'uploaded. Response: ' + res.data);
	      vm.onSaved({ mediaInfo: res.data });
	      return res.data;
	    }, function (res) {
	      $log.debug('Error status: ' + res.status);
	      vm.uploading = false;
	      return res;
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      $log.debug('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  }
	}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _component = __webpack_require__(38);

	var _component2 = _interopRequireDefault(_component);

	var _component3 = __webpack_require__(39);

	var _component4 = _interopRequireDefault(_component3);

	var _component5 = __webpack_require__(42);

	var _component6 = _interopRequireDefault(_component5);

	var _component7 = __webpack_require__(43);

	var _component8 = _interopRequireDefault(_component7);

	var _component9 = __webpack_require__(46);

	var _component10 = _interopRequireDefault(_component9);

	var _component11 = __webpack_require__(48);

	var _component12 = _interopRequireDefault(_component11);

	var _component13 = __webpack_require__(49);

	var _component14 = _interopRequireDefault(_component13);

	var _component15 = __webpack_require__(50);

	var _component16 = _interopRequireDefault(_component15);

	var _routes = __webpack_require__(51);

	var _routes2 = _interopRequireDefault(_routes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusBookings', ["ngAnimate", "ngSanitize", "ngMessages", "ngAria", 'ui.router', 'lectusApi', 'dndLists']).component(_component2.default.name, _component2.default).component(_component4.default.name, _component4.default).component(_component6.default.name, _component6.default).component(_component12.default.name, _component12.default).component(_component8.default.name, _component8.default).component(_component10.default.name, _component10.default).component(_component14.default.name, _component14.default).component(_component16.default.name, _component16.default)
	// .component(bookingEditComp.name,bookingEditComp)

	.config(_routes2.default);
	// import bookingEditComp from './view/edit/controller';

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	"use strict";

	BookingListCtrl.$inject = ["$log", "$state", "$scope", "$mdDialog", "$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "bookingList",
	  controller: BookingListCtrl,
	  templateUrl: 'app/bookings/list/template.html',
	  bindings: {
	    lectus: "<",
	    bookingViewState: "<"
	  }
	};


	function BookingListCtrl($log, $state, $scope, $mdDialog, $http) {
	  "ngInject";

	  var vm = this;
	  var query = {
	    customer: '',
	    limit: 25,
	    order: '-createdOn',
	    page: 1
	  };

	  vm.loadBooking = loadBookings;

	  vm.$onInit = function () {
	    // only load property bookings
	    if (vm.propertyCtrl) {
	      query.property = vm.propertyCtrl.property.code;
	    }
	    angular.extend(vm, {
	      customerFilterOptions: {
	        debounce: 500
	      },
	      query: query,
	      loadBookings: loadBookings,
	      showBooking: showBooking
	    });
	    $scope.$watch(function () {
	      return vm.query.customer;
	    }, onSearchChange, true);

	    loadBookings();
	  };

	  function onSearchChange(newValue, oldValue) {
	    if (newValue === oldValue) {
	      return;
	    }
	    var bookmark = vm.query.page;
	    if (!oldValue) {
	      bookmark = vm.query.page;
	    }

	    if (newValue !== oldValue) {
	      vm.query.page = 1;
	    }
	    if (!newValue) {
	      vm.query.page = bookmark;
	    }
	    loadBookings();
	  }

	  function loadBookings() {
	    //const href = vm.propertyCtrl.property.links.bookings.href;
	    var href = vm.lectus.links.bookings.href;
	    $log.debug(vm.query, arguments);
	    var sort = vm.query.order.indexOf("-") === 0 ? vm.query.order.replace("-", "") + ">" : vm.query.order + '<';
	    var q = vm.query;
	    console.log(vm.query, arguments);
	    console.log("vm.query", vm.query);
	    $log.debug(vm.query.checkin);

	    vm.loadingPromise = $http.get(href, {
	      params: {
	        $limit: q.limit,
	        $skip: q.page * q.limit - q.limit,
	        $sort: sort,
	        property: query.property,
	        name: isNaN(q.customer) ? q.customer || undefined : undefined,
	        number: !isNaN(q.customer) ? q.customer : undefined,
	        checkin: vm.filter && moment(q.checkin || null).isValid() ? moment(q.checkin).format('YYYY-MM-DD') : undefined,
	        createdOn: vm.filter && moment(q.createdOn || null).isValid() ? moment(q.createdOn).format('YYYY-MM-DD') : undefined,
	        propertyName: vm.filter && q.propertyName ? q.propertyName : undefined
	      }
	    }).then(function (res) {
	      angular.extend(vm, {
	        items: res.data.items,
	        total: res.data.total
	      });
	    });
	  }

	  function showBooking(b) {
	    $log.debug(b);
	    $state.go(vm.bookingViewState, { property: b.property.code, booking: b.number });
	  }
	}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	BookingViewCtrl.$inject = ["$log", "$state", "$scope", "$mdDialog", "$http", "$q", "datasets"];
	BookingCCCtrl.$inject = ["$mdDialog", "cc"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _controller = __webpack_require__(40);

	var _controller2 = _interopRequireDefault(_controller);

	var _controller3 = __webpack_require__(41);

	var _controller4 = _interopRequireDefault(_controller3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  name: "bookingView",
	  controller: BookingViewCtrl,
	  templateUrl: 'app/bookings/view/template.html',
	  bindings: {
	    lectus: "<",
	    bookingNumber: "<"
	  },
	  require: {
	    propertyCtrl: '?^propertyContainer'
	  }
	};


	function BookingViewCtrl($log, $state, $scope, $mdDialog, $http, $q, datasets) {
	  "ngInject";

	  var vm = this;
	  vm.status = ["", "", "reservée", "Confirmé", "Annulé", "No show", "Arrivée"];

	  vm.$onInit = function () {
	    loadBooking(vm.bookingNumber);

	    vm.currency = vm.propertyCtrl.property.currency;
	    datasets.bindSets(["boards"], vm, true);
	    vm.noShowFunction = noShowFunction;
	    vm.updadePayment = updadePayment;
	    vm.editItem = editItem;
	    vm.arrivedFunction = arrivedFunction;
	    vm.toggleshow = toggleshow;
	    loadBooking(vm.bookingNumber);
	    vm.annulerItem = annulerItem, vm.confirmerItem = confirmerItem;
	  };

	  vm.viewCC = function ($event) {
	    if (!vm.booking.cc) return;
	    // 4111111111111111/18/02/123/CONNOR PAGE

	    var fields = ["number", "year", "month", "cvv", "name"];

	    var cc = vm.booking.cc.split("/").reduce(function (agg, val, i) {
	      agg[fields[i]] = val;
	      return agg;
	    }, {});
	    $mdDialog.show({
	      templateUrl: 'app/bookings/cc.html',
	      targetEvent: $event,
	      locals: { cc: cc },
	      clickOutsideToClose: true,
	      controller: BookingCCCtrl,
	      controllerAs: '$ctrl'
	    });
	  };

	  vm.noShow = function () /*item*/{
	    $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).textContent("Cette fonctionnalité n'a pas encore été implémentée").ariaLabel('Not Implemented').ok('OK').cancel('Ne pas supprimer')

	    //.targetEvent(ev)
	    );
	  };

	  function noShowFunction($event, n, all) {
	    var href = vm.propertyCtrl.property.links.bookings.href;
	    //const href = "http://beds-sapi.fractalite.com/bookings-on-hold/"

	    var query = [{ "op": "replace", "path": "/status", "value": "NO_SHOW" }];

	    //n.status=5;
	    //n.items[0].status= 5;
	    for (var i = 0; i < all.items.length; i++) {
	      if (all.items[i].number == n.number) {
	        all.items[i].status = 5;
	        all.items[i].total = 5500;
	      }
	    }

	    var confirm = $mdDialog.confirm().title('Confirmer no show?').textContent('Etes-vous sûr de vouloir Confirmer no show  ?').ariaLabel('no show').targetEvent($event).ok('Oui').cancel('Non');

	    $log.debug(n);
	    var promise;
	    //promise =
	    $mdDialog.show(confirm).then(function () {
	      return $http.put(href + "/" + n.booking, all.items[0]);
	    });
	    //$mdDialog.show(confirm).then(() => $http.patch(href + all.number , query)
	    //
	    //    $mdDialog.show(confirm).then(() =>$http( {
	    //     method:"PATCH",
	    //     url: href  + n.booking,
	    //     headers:{
	    //       "Content-Type":"application/json",
	    //       "AUTHORIZATION":"Bearer Ouw4hte62nT30oO6Nso0IHCe14F9ldEP"
	    //     },

	    //     data: query
	    //   }
	    // )
	    // )
	    //   $mdDialog.show(confirm).

	    //  promise.then(res => close(res.data), saveFailed);


	    //  .then(() =>$http.delete(i.links.self.href))
	    //  .then(() => vm.items.splice(vm.items.indexOf(media),1));
	  }

	  function arrivedFunction($event, n, all) {
	    var href = vm.propertyCtrl.property.links.bookings.href;
	    // /properties/:property/bookings/:booking/items/:bookingItem
	    // const href = "http://beds-sapi.fractalite.com/bookings-on-hold/"

	    //var query=[{"op":"replace","path":"/status","value":"Arrivée"}];

	    //n.status=6;
	    //n.items[0].status= 6;
	    for (var i = 0; i < all.items.length; i++) {
	      if (all.items[i].number == n.number) {
	        all.items[i].show = true;
	      }
	    }
	    all.cc = "tt";
	    var confirm = $mdDialog.confirm().title('Confirmer arrived?').textContent('Etes-vous sûr de vouloir Confirmer l Arrivée  ?').ariaLabel('Arrivée').targetEvent($event).ok('Oui').cancel('Non');
	    //(url, data, config)

	    $log.debug(n);
	    var promise;
	    $mdDialog.show(confirm).then(function () {
	      return $http.put(href + "/" + n.booking + "/items/" + n.booking, all.items[0]);
	    });

	    //  .then(() =>$http.delete(i.links.self.href))
	    //  .then(() => vm.items.splice(vm.items.indexOf(media),1));
	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }

	  function loadBooking(number) {
	    //const href = vm.propertyCtrl.property.links.bookings.href;
	    var href = vm.propertyCtrl.property.links.bookings.href;
	    vm.loadingPromise = $http.get(href + "/" + number).then(function (res) {
	      $log.debug('properties', res.data);
	      vm.arrived = res.data.arrived;
	      vm.booking = res.data;
	      vm.booking.total = res.data.items.reduce(function (sum, item) {
	        return sum + item.total;
	      }, 0);
	      // vm.booking.payments = res.data.items.reduce((sum,item) => sum + item.payments[0].amount , 0);
	      var pay;
	      //  for(var i=0; i<res.data.items.length;i++){
	      //   console.log("vm.booking.payments",vm.booking.payments);

	      //   var objPay=JSON.parse(res.data.items[i].payments[0]);
	      //   pay=Number(objPay.amount);
	      //     }
	      //   var objPay=JSON.parse(res.data.payments[0]);
	      // pay=Number(objPay.amount);
	      vm.booking.paymentss = Number(res.data.payments[0].amount);

	      vm.arrived = res.data.arrived;
	      console.log("vm.arrived", vm.booking.arrived);
	      console.log("vm.booking.payments", vm.booking.payments);
	    });
	  }
	  function toggleshow($event, ordre, arrived) {
	    if (arrived != true) {
	      arrivedsFunction($event, ordre);
	    } else noshowFunction($event, ordre);
	  }

	  function arrivedsFunction($event, ordre) {
	    var href = vm.propertyCtrl.property.links.bookings.href;

	    vm.arrived = true;
	    ordre.arrived = true;
	    console.log(" showFunction ", vm.arrived);

	    $http.put(href + "/" + ordre.number, ordre).then(function (res) {
	      $log.debug('properties', res.data);
	      vm.arrived = res.data.arrived;
	    });
	  }
	  function noshowFunction($event, ordre) {
	    var href = vm.propertyCtrl.property.links.bookings.href;

	    vm.arrived = false;
	    ordre.arrived = false;
	    console.log(" noshowFunction ", vm.arrived);

	    $http.put(href + "/" + ordre.number, ordre).then(function (res) {
	      $log.debug('properties', res.data);
	      vm.arrived = res.data.arrived;
	    });

	    //loadBooking(ordre.number);


	    //  .then(() =>$http.delete(i.links.self.href))
	    //  .then(() => vm.items.splice(vm.items.indexOf(media),1));
	  }

	  function updadePayment(ev, order) {
	    $mdDialog.show(_editDialog(ev, order)).then(function (result) {
	      loadBooking(vm.bookingNumber);

	      // add to units list,
	      // or do a new http request ?
	      // $scope.$emit('property:changed',{relation:'units'})
	    });
	  }

	  function editItem(ev, order, item) {
	    $mdDialog.show(_editDialogBooking(ev, order, item)).then(function (result) {
	      loadBooking(vm.bookingNumber);

	      // add to units list,
	      // or do a new http request ?
	      // $scope.$emit('property:changed',{relation:'units'})
	    });
	  }

	  function _editDialog($event, order) {
	    return {
	      templateUrl: 'app/bookings/view/edit/template.html',
	      controller: _controller2.default,
	      controllerAs: '$ctrl',
	      targetEvent: $event,
	      locals: {
	        order: order,

	        propertyCtrl: vm.propertyCtrl
	      }
	    };
	  }

	  function _editDialogBooking($event, order, item) {
	    return {
	      templateUrl: 'app/bookings/view/editBooking/template.html',
	      controller: _controller4.default,
	      controllerAs: '$ctrl',
	      targetEvent: $event,
	      locals: {
	        order: order,
	        item: item,
	        propertyCtrl: vm.propertyCtrl
	      }
	    };
	  }

	  function annulerItem($event, order, item) {
	    //var order = vm.copy;
	    console.log("order", order);

	    var href = order.links.base;
	    var PATCH_URL = href + "/commands/booking-items";

	    item.status = 4;
	    item.total = 0;

	    console.log("href", href);

	    var confirm = $mdDialog.confirm().title('Annuler cette reservation?').targetEvent($event).ok('Oui').cancel('Ne pas Annuler');

	    $mdDialog.show(confirm)
	    // then(() => doRemove(unit) );
	    .then(function () {
	      return $http.post(PATCH_URL, item);
	    })
	    //  .then(res => {
	    //   $log.debug('properties', res.data);
	    //   loadBooking(vm.bookingNumber);
	    // }))
	    //  .then(() =>$http.delete(unit.links.self.href))
	    .then(function () {
	      return $state.reload();
	    });

	    // order.bookingItems=order.items;


	    // $http .post(PATCH_URL, item)
	    //    .then(res => {
	    //     $log.debug('properties', res.data);
	    //     loadBooking(vm.bookingNumber);
	    //   })
	  }

	  function confirmerItem($event, order, item) {
	    //var order = vm.copy;
	    console.log("order", order);

	    var href = order.links.base;
	    var PATCH_URL = href + "/commands/booking-items";

	    item.status = 3;

	    console.log("href", href);

	    var confirm = $mdDialog.confirm().title('confirmer cette reservation?').targetEvent($event).ok('Oui').cancel('Ne pas confirmer');

	    $mdDialog.show(confirm)
	    // then(() => doRemove(unit) );
	    .then(function () {
	      return $http.post(PATCH_URL, item).then(function (res) {
	        $log.debug('properties', res.data);
	        loadBooking(vm.bookingNumber);
	      });
	    })
	    //  .then(() =>$http.delete(unit.links.self.href))
	    .then(function () {
	      return $state.reload();
	    });

	    // order.bookingItems=order.items;


	    // $http .post(PATCH_URL, item)
	    //    .then(res => {
	    //     $log.debug('properties', res.data);
	    //     loadBooking(vm.bookingNumber);
	    //   })
	  }
	}

	function BookingCCCtrl($mdDialog, cc) {
	  this.cc = cc;
	  this.close = function () {
	    $mdDialog.hide();
	  };
	}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	OrderEditCtrl.$inject = ["$log", "$mdDialog", "$http", "order", "propertyCtrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OrderEditCtrl;
	var _ = __webpack_require__(5);

	function OrderEditCtrl($log, $mdDialog, $http, order, propertyCtrl) {
	  "ngInject";

	  var vm = this;
	  var posS = [{ name: "OTA", reference: "" }, { name: "B2B", reference: "" }, { name: "B2C", reference: "" }, { name: "Walk-in", reference: "" }, { name: "TO", reference: "" }, { name: "MICE", reference: "" }];

	  console.log("order: ", order);

	  if (order != null) init(order);

	  function init(order) {

	    // var objPay=JSON.parse(order.payments[0]);
	    //console.log("objPay: ", order);

	    var pay = Number(order.payments[0].amount);
	    console.log("pay: ", pay);

	    // order.payments[0].amount=Number(order.payments[0].amount);
	    //order.payments[0]=objPay;
	    console.log("order: ", order);
	    console.log("pay: ", pay);

	    order.payments[0].amount = pay;
	    console.log("res.dataPa", order.payments[0].amount);

	    // console.log("vm.property", vm.property);
	    // console.log("vm.propertyCtrl", vm.propertyCtrl);
	    // console.log("vm.property", propertyCtrl.property);
	    // console.log("vm.property", propertyCtrl);
	    console.log("vm.order", order);

	    angular.extend(vm, {
	      status: 'loading',
	      copy: order,
	      save: save,
	      posS: posS,
	      cancel: function cancel() {
	        return $mdDialog.cancel();
	      }

	    });
	  }

	  function save(order) {

	    var promise;

	    //  const href = order.links.base;
	    // const PATCH_URL = href + "/commands/booking-items";
	    var href = order.links.self.href;

	    console.log("href", href);
	    // order.bookingItems=order.items;
	    console.log("saveorder", order);

	    $http.put(href, order).then(function (res) {
	      $log.debug('properties', res.data);
	    });
	    //promise.then(res => close(res.data));
	    $mdDialog.hide(order);
	  }

	  function close(order) {
	    $log.debug("close", order);
	    $mdDialog.hide(order);
	  }
	}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	OrderEditBookingCtrl.$inject = ["$log", "$mdDialog", "$q", "$http", "order", "item", "propertyCtrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OrderEditBookingCtrl;
	var _ = __webpack_require__(5);

	function OrderEditBookingCtrl($log, $mdDialog, $q, $http, order, item, propertyCtrl) {
	  "ngInject";

	  var vm = this;

	  var paxNbr = 0,
	      paxNbrChild = 0,
	      paxNbrInf = 0;
	  var nightTarif, totalTarif;
	  console.log("item: ", item);

	  if (item != null) init(item);

	  function init(item) {
	    console.log("propertyCtrl: ", propertyCtrl);

	    var propCtrl = propertyCtrl;
	    var p1 = propCtrl.get('units')
	    //.then(collection => $q.all(collection.items.map(loadUnitProducts)))
	    .then(function (collection) {
	      return vm.units = collection.items;
	    });

	    //.then(units => vm.units = units);
	    console.log("units: ", vm.units);
	    console.log("units: ", p1.value);
	    console.log("units: ", p1.$$state.value);
	    vm.units = p1.$$state.value;

	    nightTarif = parseFloat(item.total) / parseFloat(item.nights);

	    console.log("nightTarif ", nightTarif);

	    //paxNbr=item.guests.length;
	    var today = new Date();
	    for (var i = 0; i < item.guests.length; i++) {
	      if (item.guests[i].birthdate) {
	        if (diff_years(item.guests[i].birthdate, today) < 2) paxNbrInf++;else paxNbrChild++;
	      } else paxNbr++;
	    }

	    console.log("paxNbr ", paxNbr, paxNbrInf, paxNbrChild);

	    totalTarif = nightTarif * item.nights;
	    console.log("totalTarfi ", totalTarif);

	    //  // var objPay=JSON.parse(order.payments[0]);
	    //   //console.log("objPay: ", order);

	    //   var pay=Number(order.payments[0].amount);
	    //   console.log("pay: ", pay);


	    //  // order.payments[0].amount=Number(order.payments[0].amount);
	    //  //order.payments[0]=objPay;
	    //  console.log("order: ", order);
	    //  console.log("pay: ", pay);

	    //  order.payments[0].amount=pay;
	    //   console.log("res.dataPa",  order.payments[0].amount);

	    //   // console.log("vm.property", vm.property);
	    //   // console.log("vm.propertyCtrl", vm.propertyCtrl);
	    //   // console.log("vm.property", propertyCtrl.property);
	    //   // console.log("vm.property", propertyCtrl);
	    console.log("vm.item", item);

	    angular.extend(vm, {
	      status: 'loading',
	      copy: order,
	      save: save,
	      saveItem: saveItem,
	      item: item,
	      paxNbr: paxNbr,
	      paxNbrInf: paxNbrInf,
	      paxNbrChild: paxNbrChild,
	      nightTarif: nightTarif,
	      totalTarif: totalTarif,
	      calculTotal: calculTotal,
	      diff_years: diff_years,
	      cancel: function cancel() {
	        return $mdDialog.cancel();
	      }

	    });
	  }

	  function save(order) {

	    //var order = vm.copy;

	    var promise;
	    console.log("href", order.links.base);
	    console.log("href", order.links.base);

	    // const href = vm.propertyCtrl.property.links.bookings.href;
	    // const href = order.links.index.href;
	    var href = vm.order.links.base;
	    var PATCH_URL = href + "/commands/booking-items";

	    console.log("href", order.links.base);
	    //  // order.bookingItems=order.items;
	    //   console.log("saveorder", order);
	    //   //var item;
	    //   console.log("saveorder", order.items[0]);
	    //   console.log("saveorder", order.items[0].number);

	    // vm.item.number=order.items[0].number;
	    // vm.item.nights=order.items[0].nights;
	    // vm.item.total=order.items[0].total;


	    console.log("item :: ", vm.item);

	    $http.post(PATCH_URL, order.items[0]).then(function (res) {
	      $log.debug('properties', res.data);
	    });
	    return promise.then(function (res) {
	      return close(res.data);
	    });
	    $mdDialog.hide(order);
	  }

	  function saveItem(item) {
	    var nbrGst = vm.paxNbr;
	    var nbrChild = vm.paxNbrChild;
	    var nbrInf = vm.paxNbrInf;

	    var order = vm.copy;
	    var guests = [];

	    var promise;

	    console.log("vm.order.links.base :: ", order.links.base);

	    var href = order.links.base;
	    var PATCH_URL = href + "/commands/booking-items";
	    var date = new Date(item.checkin);

	    item.checkin = moment(date).add(2, 'hours');

	    item.total = parseFloat(vm.nightTarif) * parseFloat(item.nights);

	    var childBirthdate = new Date();
	    childBirthdate.setFullYear(childBirthdate.getFullYear() - 10);
	    var infantBirthdate = new Date();
	    infantBirthdate.setFullYear(infantBirthdate.getFullYear() - 1);
	    for (var i = 0; i < nbrGst; i++) {
	      var gst = {

	        lastName: item.guests[0].lastName,
	        firstName: item.guests[0].firstName
	      };
	      guests.push(gst);
	    }
	    for (var i = 0; i < nbrChild; i++) {
	      var gst = {

	        lastName: item.guests[0].lastName,
	        firstName: item.guests[0].firstName,
	        birthdate: childBirthdate

	      };
	      guests.push(gst);
	    }
	    for (var i = 0; i < nbrInf; i++) {
	      var gst = {

	        lastName: item.guests[0].lastName,
	        firstName: item.guests[0].firstName,
	        birthdate: infantBirthdate

	      };
	      guests.push(gst);
	    }
	    item.guests = guests;
	    console.log("paxNbr :: ", nbrGst);

	    console.log("guests :: ", guests);

	    console.log("item :: ", item);
	    console.log("vm.units :: ", vm.units);
	    var unit;
	    for (var i = 0; i < vm.units.length; i++) {
	      if (vm.units[i].code == item.product.unit.code) {
	        console.log("vm.unitscode :: ", vm.units[i]);
	        unit = vm.units[i];
	      }
	    }
	    item.product.unit = unit;

	    $http.post(PATCH_URL, item).then(function (res) {
	      $log.debug('properties', res.data);
	    });
	    //return promise.then(res => close(res.data));
	    //promise.then(res => close(res.data));
	    $mdDialog.hide(item);
	  }

	  function close(item) {
	    $log.debug("close", item);
	    $mdDialog.hide(item);
	  }

	  function diff_years(dt2, dt1) {
	    var dt11 = new Date(dt1);
	    var dt22 = new Date(dt2);

	    var diff = (dt22.getTime() - dt11.getTime()) / 1000;
	    diff /= 60 * 60 * 24;
	    return Math.abs(Math.round(diff / 365.25));
	  }

	  function calculTotal() {

	    console.log("INcalculTotal :: ");

	    var tNight = parseInt(vm.nightTarif);
	    var nNight = parseInt(vm.item.nights);
	    vm.totalTarif = tNight * nNight;
	    console.log("calculTotal :: ", vm.totalTarif);
	  }
	}

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	"use strict";

	BookingEditCtrl.$inject = ["$log", "$state", "$mdToast", "$mdDialog", "$http", "$q", "datasets"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// import OrderEditCtrl from "./edit/controller";
	// import OrderEditBookingCtrl from "./editBooking/controller";
	// import TravellerEditCtrl from "./traveller/controller"
	exports.default = {
	  name: "bookingEdit",
	  controller: BookingEditCtrl,
	  templateUrl: 'app/bookings/edit/template.html',
	  bindings: {
	    lectus: "<",
	    bookingNumber: "<"
	  },
	  require: {
	    propertyCtrl: '?^propertyContainer'
	  }
	};


	function BookingEditCtrl($log, $state, $mdToast, $mdDialog, $http, $q, datasets) {
	  "ngInject";
	  //console.log('BookingEditCtrl...');


	  var vm = this;

	  //vm.status = ["", "", "reservée", "Confirmé", "Annulé", "No show", "Arrivée"];
	  vm.status = [{
	    code: 2,
	    name: "reservée"
	  }, {
	    code: 3,
	    name: "Confirmé"
	  }, {
	    code: 4,
	    name: "Annulé"
	  }, {
	    code: 5,
	    name: "No show"
	  }, {
	    code: 6,
	    name: "Arrivée"
	  }];
	  var roomTypes = ["", "Chambre"];
	  var pos = [{
	    name: "OTA",
	    reference: ""
	  }, {
	    name: "B2B",
	    reference: ""
	  }, {
	    name: "B2C",
	    reference: ""
	  }, {
	    name: "Walk-in",
	    reference: ""
	  }, {
	    name: "TO",
	    reference: ""
	  }, {
	    name: "MICE",
	    reference: ""
	  }];
	  var paymentMethods = [{
	    "name": "cc",
	    "code": "2",
	    "bank": "-1"
	  }, {
	    "name": "cash",
	    "code": "10",
	    "bank": "-1"
	  }, {
	    "name": "check",
	    "code": "3",
	    "bank": "-1"
	  }, {
	    "name": "payzone",
	    "code": "21",
	    "bank": "-1"
	  }, {
	    "name": "paybox",
	    "code": "22",
	    "bank": "-1"
	  }, {
	    "name": "credit",
	    "code": "18",
	    "bank": "-1"
	  }, {
	    "name": "account",
	    "code": "18",
	    "bank": "-1"
	  }];

	  //$ctrl.status[i.status]

	  vm.$onInit = function () {

	    angular.extend(vm, {
	      currency: vm.propertyCtrl.property.currency,
	      pos: pos,
	      paymentMethods: paymentMethods,
	      deleteGuest: deleteGuest,
	      deleteAddon: deleteAddon,
	      updateTotal: updateTotal,
	      isDiscountSelected: isDiscountSelected,
	      addDiscount: addDiscount,
	      deleteDiscount: deleteDiscount,
	      deletePayment: deletePayment,
	      addAddon: addAddon,
	      addPayment: addPayment,
	      save: save
	    });
	    // vm.addGuest = addGuest

	    datasets.bindSets(["boards"], vm, true);
	    loadBooking(vm.bookingNumber);

	    var propCtrl = vm.propertyCtrl;
	    var p1 = propCtrl.get('units')
	    //  .then(collection => $q.all(collection.items.map(loadUnitProducts)))
	    .then(function (collection) {
	      return vm.units = collection.items.map(unitEncoder);
	    });
	    var p2 = datasets.bindSets(["boards"]).then(function (collection) {
	      return vm.board = _.keyBy(collection.items, "code");
	    });

	    var p3 = propCtrl.get('rate-bases')
	    //.then(collection => vm.rateBases = _.keyBy(collection.items, "code"));
	    .then(function (collection) {
	      return vm.rateBases = collection.items.map(rateBasisEncoder);
	    });

	    var p4 = propCtrl.get('discounts', {
	      $sort: "bookingPeriod>"
	    }).then(function (collection) {
	      vm.discounts = collection.items;
	    });
	  };

	  // function addGuest(ev, item) {
	  //   $mdDialog.show(_editDialog(ev, null))
	  //     .then(result => {
	  //       item.guests.push(result);
	  //     })
	  //   // var newGuest = { lastName: null, firstName: null }
	  //   // item.guests.push(newGuest);
	  // }

	  // function _editDialog($event) {
	  //   console.log('vm.links', vm.links)
	  //   return {
	  //     templateUrl: 'app/bookings/edit/traveller/template.html',
	  //     controller: TravellerEditCtrl,
	  //     controllerAs: '$ctrl',
	  //     targetEvent: $event,
	  //     // locals: {
	  //     //   propertyCtrl: vm.propertyCtrl
	  //     // }
	  //   }
	  // }

	  function addDiscount(item) {
	    var newDiscount = {
	      "code": "-1",
	      "rule": {
	        "unit": "%",
	        "value": 0,
	        "nights": "f"
	      },
	      "label": "",
	      "amount": 0,
	      "markets": null,
	      "baseOnly": true,
	      "reference": "",
	      "cancellation": ["0%0"],
	      "payOnArrival": false
	    };
	    item.discount.push(newDiscount);
	  }

	  function addAddon(item) {
	    var newAddon = {
	      "qte": 1,
	      "code": "-1",
	      "name": "",
	      "total": 0
	    };
	    item.addon.push(newAddon);
	  }

	  function addPayment() {
	    var newPayment = {
	      "bank": "-1",
	      "currency": "EUR"
	    };
	    vm.booking.payments.push(newPayment);
	  }

	  function isDiscountSelected(item, discount) {
	    if (item.discount && Array.isArray(item.discount)) {
	      for (var i = 0; i < item.discount.length; i++) {
	        if (item.discount[i].code == discount.code) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }

	  function save($event) {
	    //console.log('save:')
	    var order = vm.booking;
	    order.propertyContent = vm.propertyCtrl.property;
	    order.items.map(function (o) {
	      var discount = "";
	      var checkin = o.checkin.replace("-", "");
	      checkin = checkin.replace("-", "");
	      if (o.product.discounts != null) {
	        o.product.discounts.map(function (d, i) {
	          if (i === 0) discount = d.code;else discount = discount + "," + d.code;
	        });
	      }
	      var reference = vm.propertyCtrl.property.code + ":" + o.product.code + ":" + o.nights + ":" + checkin + ":" + discount + ":" + o.total;
	      o.ref = reference;
	      o.product.boardName = vm.boards[o.product.board].name;
	    });

	    var href = order.links.base;
	    var PATCH_URL = href + "/commands/update-booking";
	    // console.log('save: PATCH_URL', PATCH_URL)
	    // console.log('save: items', order)

	    var promise = $http.post(PATCH_URL, order);
	    return promise.then(function (res) {
	      return close(res.data);
	    });
	  }

	  function close(item) {
	    $log.debug("close", item);
	    $mdDialog.hide(item);
	    $mdToast.show($mdToast.simple().textContent('Modification Enregistrée').hideDelay(3000));
	    $state.reload();
	  }

	  function updateTotal(item) {
	    item.total = item.pricePerNight * item.nights;
	    //vm.booking.pricing.prices[0].total=
	  }

	  function rateBasisEncoder(rateBase) {
	    return {
	      code: rateBase.code,
	      description: rateBase.description
	    };
	  }
	  /*function deleteGuest(guests, i) {
	   guests.splice(i, 1);
	   };
	   */

	  //totalTarfi = nightTarif * item.nights;
	  function deleteGuest($event, guests, i) {
	    var confirm = $mdDialog.confirm().title('Supprimer ce voyageur?')
	    // .textContent('Tous les allotement, produits et tarifs lié a cette catégorie seront supprimés')
	    .ariaLabel('Delete room guests').targetEvent($event).ok('Supprimer').cancel('Ne pas supprimer');

	    $mdDialog.show(confirm)
	    // then(() => doRemove(unit) );
	    .then(function () {
	      return guests.splice(i, 1);
	    });
	    //  .then(() => $state.reload());
	  }

	  function deleteAddon($event, addon, i) {
	    var confirm = $mdDialog.confirm().title('Supprimer cette préstation?')
	    // .textContent('Tous les allotement, produits et tarifs lié a cette catégorie seront supprimés')
	    .ariaLabel('Delete addon').targetEvent($event).ok('Supprimer').cancel('Ne pas supprimer');

	    $mdDialog.show(confirm)
	    // then(() => doRemove(unit) );
	    .then(function () {
	      return addon.splice(i, 1);
	    });
	    //  .then(() => $state.reload());
	  }

	  function deleteDiscount($event, discount, i) {
	    var confirm = $mdDialog.confirm().title('Supprimer cette promotion?')
	    // .textContent('Tous les allotement, produits et tarifs lié a cette catégorie seront supprimés')
	    .ariaLabel('Delete discount').targetEvent($event).ok('Supprimer').cancel('Ne pas supprimer');

	    $mdDialog.show(confirm)
	    // then(() => doRemove(unit) );
	    .then(function () {
	      return discount.splice(i, 1);
	    });
	    //  .then(() => $state.reload());
	  }

	  function deletePayment($event, payments, i) {
	    var confirm = $mdDialog.confirm().title('Supprimer ce paiement?')
	    // .textContent('Tous les allotement, produits et tarifs lié a cette catégorie seront supprimés')
	    .ariaLabel('Delete payment').targetEvent($event).ok('Supprimer').cancel('Ne pas supprimer');

	    $mdDialog.show(confirm)
	    // then(() => doRemove(unit) );
	    .then(function () {
	      return payments.splice(i, 1);
	    });
	    //  .then(() => $state.reload());
	  }

	  function loadUnitProducts(unit) {
	    return $http.get(unit.links.products.href).then(function (res) {
	      unit.products = res.data.items;
	      return unit;
	    });
	  }

	  function unitEncoder(unit) {
	    return {
	      code: unit.code,
	      name: unit.name,
	      type: roomTypes[unit.type]
	    };
	  }

	  function loadBooking(number) {
	    var href = vm.propertyCtrl.property.links.bookings.href;
	    vm.loadingPromise = $http.get(href + "/" + number).then(function (res) {
	      $log.debug('properties', res.data);
	      vm.arrived = res.data.arrived;
	      vm.booking = res.data;
	      vm.booking.total = res.data.items.reduce(function (sum, item) {
	        return sum + item.total;
	      }, 0);
	      vm.booking.items = vm.booking.items.map(function (item) {
	        //remove this when updating booking items PATCH
	        item.pricePerNight = parseFloat(item.total) / parseFloat(item.nights);
	        return item;
	      });
	      vm.arrived = res.data.arrived;
	      //  console.log("vm.arrived", vm.booking.arrived);
	      //console.log("vm.booking.payments", vm.booking.payments);
	    });
	  }
	}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PropertyBookingListCtrl.$inject = ["$log", "$state", "$scope", "$mdDialog", "$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _chartUtils = __webpack_require__(44);

	var chartUtils = _interopRequireWildcard(_chartUtils);

	var _controller = __webpack_require__(45);

	var _controller2 = _interopRequireDefault(_controller);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var d3 = __webpack_require__(15);
	exports.default = {
	  name: "propertyBookingList",
	  controller: PropertyBookingListCtrl,
	  templateUrl: 'app/bookings/property-list/template.html',
	  bindings: {
	    lectus: "<",
	    bookingViewState: "<",
	    reportData: "<",
	    bookingCreateState: "<",
	    bookingEditState: "<"
	  },
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PropertyBookingListCtrl($log, $state, $scope, $mdDialog, $http) {

	  "ngInject";

	  var vm = this;
	  var query = {
	    customer: '',
	    limit: 2500000,
	    order: '-createdOn',
	    page: 1
	  };
	  var summ, paymnt;
	  var nuiteenuitee = 0;
	  vm.status = ["", "", "reservée", "Confirmé", "Annulé", "No show", "Arrivée"];
	  vm.loadBooking = loadBookings;

	  // vm.cmdBooking;
	  // vm.cmdExpedia;

	  // vm.cmdSiteEtApp;
	  // vm.cmdMarmara;
	  // vm.cmdtestchannel;

	  // vm.revBooking;
	  // vm.revExpedia;

	  // vm.revSiteEtApp;
	  // vm.revMarmara;
	  // vm.revtestchannel;

	  vm.cmdOTA;
	  vm.cmdWalking;

	  vm.cmdB2C;
	  vm.cmdTO;
	  vm.cmdB2B;

	  vm.cmdtestchannel;

	  vm.revOTA;
	  vm.revWalking;

	  vm.revB2C;
	  vm.revTO;
	  vm.revB2B;
	  vm.revtestchannel;

	  vm.$onInit = function () {
	    var _angular$extend;

	    // only load property bookings
	    if (vm.propertyCtrl) {
	      query.property = vm.propertyCtrl.property.code;
	    }
	    angular.extend(vm, (_angular$extend = {
	      customerFilterOptions: {
	        debounce: 500
	      },
	      summ: summ,
	      paymnt: paymnt,
	      query: query,
	      add: add,
	      loadBookings: loadBookings,
	      showBooking: showBooking,
	      editBooking: editBooking,
	      searchBookings: searchBookings,
	      createBooking: createBooking,
	      //  loadStats:loadStats,
	      toggleshow: toggleshow,
	      loadSum: loadSum,
	      loadPayments: loadPayments,
	      loadRest: loadRest,
	      loadBooking: loadBooking,
	      posStat: posStat,
	      posWalkingCmd: posWalkingCmd,
	      posWalkingRev: posWalkingRev,
	      posOTACmd: posOTACmd,
	      posOTARev: posOTARev,

	      posTestRev: posTestRev,
	      posTestCmd: posTestCmd,
	      posB2BCmd: posB2BCmd,
	      posB2BRev: posB2BRev,
	      posB2CCmd: posB2CCmd,
	      posB2CRev: posB2CRev
	    }, _defineProperty(_angular$extend, "posTestCmd", posTestCmd), _defineProperty(_angular$extend, "posTestRev", posTestRev), _defineProperty(_angular$extend, "posTOCmd", posTOCmd), _defineProperty(_angular$extend, "posTORev", posTORev), _defineProperty(_angular$extend, "loadSumRl", loadSumRl), _defineProperty(_angular$extend, "nuiteenuitee", nuiteenuitee), _defineProperty(_angular$extend, "loadNuitee", loadNuitee), _angular$extend));
	    //$scope.$watch(()=>vm.query.customer, onSearchChange);
	    //$scope.$watch(()=>vm.query.createdOn, onSearchChange);
	    //$scope.$watch(()=>vm.query.checkin, onSearchChange);

	    loadBookings();
	    //loadStats();
	  };

	  vm.$onChanges = function (changes) {
	    if (changes.reportData && vm.reportData) {
	      ready.then(updateData);
	    }
	    if (changes.unitsMap && vm.unitsMap) {
	      ready.then(updateData);
	    }
	    if (changes.viewBy) {
	      ["bkUnits", "bkBoards", "bkOccupancies", "ciUnits", "ciBoards", "ciOccupancies"].filter(function (name) {
	        return _.isObject(vm.pies[name]);
	      }).forEach(function (name) {
	        vm.pies[name].redraw();
	      });
	    }
	  };

	  function onSearchChange(newValue, oldValue) {
	    if (newValue === oldValue) {
	      return;
	    }
	    var bookmark = vm.query.page;
	    if (!oldValue) {
	      bookmark = vm.query.page;
	    }

	    if (newValue !== oldValue) {
	      vm.query.page = 1;
	    }
	    if (!newValue) {
	      vm.query.page = bookmark;
	    }
	    loadBookings();
	  }

	  function posOTACmd(items) {
	    vm.cmdOTA = 0;

	    console.log("vm.items ", items);

	    console.log("vm.items.length ", items.length);
	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {
	        // console.log("items[i].items.length ", items[i].items.length);
	        if (items[i].pos != null) {
	          if (items[i].pos.name === "OTA") {
	            vm.cmdOTA = vm.cmdOTA + 1;
	          }
	        }
	        // for(var j=0; j<items[i].items.length;j++){
	        //   if( items[i].items[j].pos!=null){
	        //    if( items[i].items[j].pos.name==="OTA"){
	        //     vm.cmdOTA=vm.cmdOTA+1;

	        //   }

	        // }
	        // }
	      }
	    }
	    console.log("vm.revtestchannel ", vm.cmdOTA);

	    return vm.cmdOTA;
	  }

	  function posOTARev(items) {

	    vm.revOTA = 0;

	    console.log("vm.items ", items);

	    console.log("vm.items.length ", items.length);
	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {
	        // console.log("items[i].items.length ", items[i].items.length);

	        for (var j = 0; j < items[i].items.length; j++) {
	          if (items[i].pos != null) {
	            if (items[i].pos.name === "OTA") {
	              vm.revOTA = vm.revOTA + items[i].items[j].total;
	            }
	          }
	        }
	      }
	    }
	    console.log("vm.revtestchannel ", vm.revOTA);

	    return vm.revOTA.toFixed(2);
	  }

	  function posWalkingCmd(items) {
	    vm.cmdWalking = 0;

	    console.log("vm.items ", items);

	    console.log("vm.items.length ", items.length);
	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {

	        if (items[i].pos != null) {

	          if (items[i].pos.name === "Walk-in") {
	            vm.cmdWalking = vm.cmdWalking + 1;
	          }
	        }
	        // console.log("items[i].items.length ", items[i].items.length);

	        // for(var j=0; j<items[i].items.length;j++){
	        //   if( items[i].items[j].pos!=null){

	        //   if( items[i].items[j].pos.name==="Walking"){
	        //     vm.cmdWalking=vm.cmdWalking+1;

	        //   }


	        // }
	        // }
	      }
	    }
	    console.log("vm.cmdWalking ", vm.cmdWalking);

	    return vm.cmdWalking;
	  }
	  function posWalkingRev(items) {

	    vm.revWalking = 0;

	    console.log("vm.items ", items);

	    console.log("vm.items.length ", items.length);
	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {
	        // console.log("items[i].items.length ", items[i].items.length);

	        for (var j = 0; j < items[i].items.length; j++) {
	          if (items[i].pos != null) {

	            if (items[i].pos.name === "Walk-in") {
	              vm.revWalking = vm.revWalking + items[i].items[j].total;
	            }
	          }
	        }
	      }
	    }
	    console.log("vm.revtestchannel ", vm.revWalking);

	    return vm.revWalking.toFixed(2);
	  }

	  function posB2CCmd(items) {

	    vm.cmdB2C = 0;

	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {
	        // console.log("items[i].items.length ", items[i].items.length);
	        if (items[i].pos != null) {

	          if (items[i].pos.name === "B2C") {
	            vm.cmdB2C = vm.cmdB2C + 1;
	          }
	        }
	        // for(var j=0; j<items[i].items.length;j++){
	        //   if( items[i].items[j].pos!=null){

	        //   if( items[i].items[j].pos.name==="B2C"){
	        //     vm.cmdB2C=vm.cmdB2C+1;

	        //   }

	        // }
	        // }
	      }
	    }

	    return vm.cmdB2C;
	  }
	  function posB2CRev(items) {

	    vm.revB2C = 0;

	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {

	        for (var j = 0; j < items[i].items.length; j++) {

	          if (items[i].pos != null) {

	            if (items[i].pos.name === "B2C") {
	              vm.revB2C = vm.revB2C + items[i].items[j].total;
	            }
	          }
	        }
	      }
	    }
	    console.log("vm.revB2C.final ", vm.revB2C);

	    return vm.revB2C.toFixed(2);
	  }

	  function posTOCmd(items) {

	    vm.cmdTO = 0;

	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {
	        // console.log("items[i].items.length ", items[i].items.length);

	        if (items[i].pos != null) {

	          if (items[i].pos.name === "TO") {
	            vm.cmdTO = vm.cmdTO + 1;
	          }
	        }
	        // for(var j=0; j<items[i].items.length;j++){
	        //   if( items[i].items[j].pos!=null){

	        //     if( items[i].items[j].pos.name==="TO"){
	        //       vm.cmdTO=vm.cmdTO+1;

	        //     }

	        // }
	        // }
	      }
	    }
	    return vm.cmdTO;
	  }
	  function posTORev(items) {

	    vm.revTO = 0;

	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {
	        // console.log("items[i].items.length ", items[i].items.length);

	        for (var j = 0; j < items[i].items.length; j++) {
	          if (items[i].pos != null) {

	            if (items[i].pos.name === "TO") {
	              vm.revTO = vm.revTO + items[i].items[j].total;
	            }
	          }
	        }
	      }
	    }
	    return vm.revTO.toFixed(2);
	  }

	  function posB2BCmd(items) {

	    vm.cmdB2B = 0;

	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {
	        // console.log("items[i].items.length ", items[i].items.length);
	        if (items[i].pos != null) {

	          if (items[i].pos.name === "B2B") {
	            vm.cmdB2B = vm.cmdB2B + 1;
	          }
	        }

	        // for(var j=0; j<items[i].items.length;j++){
	        //   if( items[i].items[j].pos!=null){

	        //     if( items[i].items[j].pos.name==="B2B"){
	        //       vm.cmdB2B=vm.cmdB2B+1;
	        //       vm.revB2B=vm.revB2B+items[i].items[j].total;

	        //     }

	        // }
	        // }
	      }
	    }
	    return vm.cmdB2B;
	  }

	  function posB2BRev(items) {

	    vm.revB2B = 0;
	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {
	        // console.log("items[i].items.length ", items[i].items.length);

	        for (var j = 0; j < items[i].items.length; j++) {
	          if (items[i].pos != null) {

	            if (items[i].pos.name === "B2B") {
	              vm.revB2B = vm.revB2B + items[i].items[j].total;
	            }
	          }
	        }
	      }
	    }

	    return vm.revB2B.toFixed(2);
	  }

	  function posTestCmd(items) {

	    vm.cmdtestchannel = 0;

	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {
	        // console.log("items[i].items.length ", items[i].items.length);

	        for (var j = 0; j < items[i].items.length; j++) {
	          if (items[i].items[j].pos != null) {

	            if (items[i].items[j].pos.name === "test-channel") {

	              vm.cmdtestchannel = vm.cmdtestchannel + 1;
	              console.log("vm.revtestchannel ", vm.revtestchannel);
	            }
	          }
	        }
	      }
	    }
	    return vm.cmdtestchannel;
	  }
	  function posTestRev(items) {

	    vm.revtestchannel = 0;

	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {
	        // console.log("items[i].items.length ", items[i].items.length);

	        for (var j = 0; j < items[i].items.length; j++) {
	          if (items[i].items[j].pos != null) {

	            if (items[i].pos.name === "test-channel") {

	              vm.revtestchannel = vm.revtestchannel + items[i].items[j].total;
	              console.log("vm.revtestchannel ", vm.revtestchannel);
	            }
	          }
	        }
	      }
	    }

	    return vm.revtestchannel.toFixed(2);
	  }

	  function posStat(items) {
	    vm.cmdOTA = 0;
	    vm.cmdWalking = 0;

	    vm.cmdB2C = 0;
	    vm.cmdTO = 0;
	    vm.cmdB2B = 0;

	    vm.cmdtestchannel = 0;

	    vm.revOTA = 0;
	    vm.revWalking = 0;

	    vm.revB2C = 0;
	    vm.revTO = 0;
	    vm.revB2B = 0;

	    vm.revtestchannel = 0;

	    console.log("vm.items ", items);

	    console.log("vm.items.length ", items.length);
	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {
	        // console.log("items[i].items.length ", items[i].items.length);

	        for (var j = 0; j < items[i].items.length; j++) {
	          if (items[i].items[j].pos != null) {
	            if (items[i].items[j].pos.name === "OTA") {
	              vm.cmdOTA = vm.cmdOTA + 1;
	              vm.revOTA = vm.revOTA + items[i].items[j].total;
	            }
	            if (items[i].items[j].pos.name === "Walk-in") {
	              vm.cmdWalking = vm.cmdWalking + 1;
	              vm.revWalking = vm.revWalking + items[i].items[j].total;
	            }
	            if (items[i].items[j].pos.name === "B2C") {
	              vm.cmdB2C = vm.cmdB2C + 1;
	              vm.revB2C = vm.revB2C + items[i].items[j].total;
	            }
	            if (items[i].items[j].pos.name === "TO") {
	              vm.cmdTO = vm.cmdTO + 1;
	              vm.revTO = vm.revTO + items[i].items[j].total;
	            }
	            if (items[i].items[j].pos.name === "B2B") {
	              vm.cmdB2B = vm.cmdB2B + 1;
	              vm.revB2B = vm.revB2B + items[i].items[j].total;
	            }
	            if (items[i].items[j].pos.name === "test-channel") {

	              console.log("test-channel");

	              vm.cmdtestchannel = vm.cmdtestchannel + 1;
	              vm.revtestchannel = vm.revtestchannel + items[i].items[j].total;
	              console.log("vm.revtestchannel ", vm.revtestchannel);
	            }
	          }
	        }
	      }
	    }
	    console.log("vm.revtestchannel ", vm.revtestchannel);

	    vm.cmdOTA.toFixed(2);
	    vm.cmdWalking.toFixed(2);

	    vm.cmdB2C.toFixed(2);
	    vm.cmdTO.toFixed(2);
	    vm.cmdB2B.toFixed(2);

	    vm.cmdtestchannel.toFixed(2);

	    vm.revOTA.toFixed(2);
	    vm.revWalking.toFixed(2);

	    vm.revB2C.toFixed(2);
	    vm.revTO.toFixed(2);
	    vm.revB2B.toFixed(2);

	    vm.revtestchannel = 0;
	  }

	  function loadStats(items) {
	    console.log("vm.items.length ", items.length);

	    var smm = 0;
	    var pay = 0;
	    // console.log("vm.items.length ", vm.items.length);

	    for (var i = 0; i < items.length; i++) {
	      console.log("items[i].items.length ", items[i].items.length);

	      for (var j = 0; j < items[i].items.length; j++) {

	        console.log("summ", parseFloat(items[i].items[j].total));

	        smm = smm + parseFloat(items[i].items[j].total);
	        if (items[i].items[j].payments != null) {
	          console.log("pay", parseFloat(items[i].items[j].payments[0].amount));

	          pay = pay + parseFloat(items[i].items[j].payments[0].amount);
	        }
	      }
	    }
	    vm.summ = smm;
	    vm.paymnt = pay;
	    vm.rest = smm - pay;
	    console.log("summ", vm.summ);
	    vm.rest.toFixed(2);
	  }

	  function loadSum(items) {

	    var smm = 0;
	    // console.log("vm.items.length ", vm.items.length);
	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {
	        // console.log("items[i].items.length ", items[i].items.length);

	        for (var j = 0; j < items[i].items.length; j++) {

	          smm = smm + parseFloat(items[i].items[j].total);
	        }
	      }
	    }
	    vm.summ = smm;
	    return vm.summ.toFixed(2);;
	  }

	  function loadSumRl(items) {
	    console.log("loadSumRl");

	    var smm = 0;
	    var nuitee = 0;
	    // console.log("vm.items.length ", vm.items.length);

	    if (vm.checkoutfin != null && vm.checkoutfin != undefined) {
	      for (var i = 0; i < items.length; i++) {
	        // console.log("items[i].items.length ", items[i].items.length);

	        for (var j = 0; j < items[i].items.length; j++) {

	          var checkoutfinn = new Date(vm.checkoutfin);
	          var checkin = new Date(items[i].items[j].checkin);
	          var checkout = moment(checkin).add(items[i].items[j].nights, 'days');
	          var checkoutt = new Date(checkout);

	          var nightRl,
	              guests = 0;
	          guests = items[i].items[j].guests.length;
	          var nightPrice = parseFloat(items[i].items[j].total) / parseFloat(items[i].items[j].nights);
	          console.log("guestsguestsguestsguests", guests);

	          //  console.log("items[i].items[j]", items[i].items[j]);
	          //  console.log("nightPrice", nightPrice);
	          //  console.log("nightPrice", nightPrice);
	          //  console.log("moment(checkout).day()", moment(checkout).day());
	          //  console.log("vm.checkoutfin).day()",moment(vm.checkoutfin).day() );
	          var days = (checkoutt - checkoutfinn) / (1000 * 3600 * 24);
	          console.log("days", days);

	          if (days > 0) {

	            //  var  Difference_In_TimeNightRl = vm.checkoutfin - checkin;
	            console.log("INIFFFFF");

	            nightRl = (checkoutfinn - checkin) / (1000 * 3600 * 24);
	          }

	          // else nightRl= checkout.getDay() - checkin.getDay();
	          else {
	              console.log("INNNELSE");

	              nightRl = (checkoutt - checkin) / (1000 * 3600 * 24);

	              // nightRl= moment(checkout).day() - moment(checkin).day();
	            }
	          console.log("nightRl", nightRl);

	          nuitee = nuitee + parseFloat(nightRl * guests);
	          console.log("nuiteeIIIII", nuitee);

	          console.log("items[i].items[j]", items[i].items[j]);

	          console.log("realPrice", parseFloat(nightRl * nightPrice));

	          smm = smm + parseFloat(nightRl * nightPrice);
	        }
	      }
	    }
	    vm.summRl = smm;
	    console.log("smmRRR", smm);
	    console.log("nuiteenuiteenuiteenuitee", nuitee);
	    nuiteenuitee = nuitee;
	    vm.nuitees = nuitee;
	    return vm.summRl.toFixed(2);;
	  }

	  function loadNuitee(items) {
	    console.log("loadSumRl");

	    var smm = 0;
	    var nuitee = 0;
	    // console.log("vm.items.length ", vm.items.length);

	    if (vm.checkoutfin != null && vm.checkoutfin != undefined) {
	      for (var i = 0; i < items.length; i++) {
	        // console.log("items[i].items.length ", items[i].items.length);

	        for (var j = 0; j < items[i].items.length; j++) {

	          if (items[i].items[j].status === 3) {

	            var checkoutfinn = new Date(vm.checkoutfin);
	            var checkin = new Date(items[i].items[j].checkin);
	            var checkout = moment(checkin).add(items[i].items[j].nights, 'days');
	            var checkoutt = new Date(checkout);

	            var nightRl,
	                guests = 0;
	            guests = items[i].items[j].guests.length;
	            var nightPrice = parseFloat(items[i].items[j].total) / parseFloat(items[i].items[j].nights);
	            console.log("guestsguestsguestsguests", guests);

	            //  console.log("items[i].items[j]", items[i].items[j]);
	            //  console.log("nightPrice", nightPrice);
	            //  console.log("nightPrice", nightPrice);
	            //  console.log("moment(checkout).day()", moment(checkout).day());
	            //  console.log("vm.checkoutfin).day()",moment(vm.checkoutfin).day() );
	            var days = (checkoutt - checkoutfinn) / (1000 * 3600 * 24);
	            console.log("days", days);

	            if (days > 0) {

	              //  var  Difference_In_TimeNightRl = vm.checkoutfin - checkin;
	              console.log("INIFFFFF");

	              nightRl = (checkoutfinn - checkin) / (1000 * 3600 * 24);
	            }

	            // else nightRl= checkout.getDay() - checkin.getDay();
	            else {
	                console.log("INNNELSE");

	                nightRl = (checkoutt - checkin) / (1000 * 3600 * 24);

	                // nightRl= moment(checkout).day() - moment(checkin).day();
	              }
	            console.log("nightRl", nightRl);

	            nuitee = nuitee + parseFloat(nightRl * guests);
	            console.log("nuiteeIIIII", nuitee);

	            console.log("items[i].items[j]", items[i].items[j]);

	            console.log("realPrice", parseFloat(nightRl * nightPrice));

	            smm = smm + parseFloat(nightRl * nightPrice);
	          }
	        }
	      }
	    }
	    vm.summRl = smm;
	    console.log("smmRRR", smm);
	    console.log("nuiteenuiteenuiteenuitee", nuitee);
	    nuiteenuitee = nuitee;
	    vm.nuitees = nuitee;
	    return vm.nuitees.toFixed(2);;
	  }

	  function loadBooking(items) {

	    var book = 0;
	    console.log("vm.items ", items.length);
	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {

	        for (var j = 0; j < items[i].items.length; j++) {

	          if (items[i].items[j].pos != null) {
	            if (items[i].items[j].pos.name === "test-channel") {
	              book = book + 1;
	              //m.revBooking=revBooking+items[i].items[j].total;
	            }
	          }
	        }
	      }
	    }
	    console.log("booking ", book);

	    return book;
	    //   vm.cmdtestchannel=booking;
	    // return vm.cmdtestchannel ;
	  }
	  function loadPayments(items) {

	    var pay = 0;
	    // console.log("vm.items.length ", vm.items.length);
	    if (vm.calculStat = "yes") {

	      for (var i = 0; i < items.length; i++) {
	        //console.log("JSON.parse(items[i].payments",JSON.parse(items[i].payments));
	        if (JSON.parse(items[i].payments) != null) {
	          var objPay = JSON.parse(items[i].payments[0]);
	          var rp = Number(objPay.amount);
	          pay = pay + parseFloat(rp);
	          console.log("pay ", pay);
	          console.log("rp ", items[i].payments);
	          console.log("rp0 ", items[i].payments[0]);
	          console.log("rp00 ", objPay.number);
	        }

	        // console.log("payments ", pay);

	        // for(var j=0; j<items[i].items.length;j++){


	        //   if(items[i].items[j].payments!=null)
	        //   {       

	        //     pay=pay+parseFloat(items[i].items[j].payments[0].amount);

	        //   }


	        // }
	      }
	    }
	    vm.paymnt = pay;
	    return vm.paymnt.toFixed(2);;
	  }

	  function loadRest(items) {

	    var smm = 0;
	    var pay = 0;
	    // console.log("vm.items.length ", vm.items.length);
	    if (vm.calculStat = "yes") {
	      for (var i = 0; i < items.length; i++) {
	        if (items[i].payments != null) {
	          var objPay = JSON.parse(items[i].payments[0]);

	          var rp = Number(objPay.amount);

	          pay = pay + parseFloat(rp);
	        }
	        for (var j = 0; j < items[i].items.length; j++) {

	          smm = smm + parseFloat(items[i].items[j].total);
	          // if(items[i].items[j].payments!=null)
	          // {      

	          //   pay=pay+parseFloat(items[i].items[j].payments[0].amount);

	          // }

	        }
	      }
	    }
	    vm.rest = smm - pay;
	    console.log("rest", vm.rest);
	    return vm.rest.toFixed(2);;
	  }

	  function loadBookings() {
	    //console.log(vm.propertyCtrl.property);
	    //const href = vm.propertyCtrl.property.links.bookings.href;
	    var href = vm.lectus.links.bookings.href;
	    //console.log(vm.query, arguments);
	    var sort = vm.query.order.indexOf("-") === 0 ? vm.query.order.replace("-", "") + ">" : vm.query.order + '<';
	    var q = vm.query;

	    vm.checkoutfin = moment(q.checkinAu || null).isValid() ? moment(q.checkinAu).format('YYYY-MM-DD') : undefined;

	    if (moment(q.checkinAu || null).isValid() || moment(q.createdOnAu || null).isValid() || vm.query.customer) {
	      vm.calculStat = "yes";
	    }
	    console.log(vm.query, arguments);
	    console.log("vm.query", vm.query);
	    console.log("checkinPeriod", moment(q.checkin || null).isValid() ? moment(q.checkinDu).format('YYYY-MM-DD') + " AND items.checkin <=" + moment(q.checkinAu).format('YYYY-MM-DD') : undefined);
	    console.log("createdOnPeriod", moment(q.createdOn || null).isValid() ? moment(q.createdOnDu).format('YYYY-MM-DD') + " AND b.created_on::date <=" + moment(q.createdOnAu).format('YYYY-MM-DD') : undefined);
	    vm.loadingPromise = $http.get(href, {
	      params: {
	        property: query.property,
	        $limit: vm.query.limit,
	        $skip: vm.query.page * vm.query.limit - vm.query.limit,
	        $sort: sort,
	        name: isNaN(vm.query.customer) ? vm.query.customer || undefined : undefined,
	        number: !isNaN(vm.query.customer) ? vm.query.customer : undefined,
	        // checkinPeriod: moment(q.checkinDu||null).isValid() ? moment(q.checkinDu).format('YYYY-MM-DD')+" AND items.checkin <= "+moment(q.checkinAu).format('YYYY-MM-DD') : undefined,
	        // createdOnPeriod: moment(q.createdOnDu||null).isValid() ? moment(q.createdOnDu).format('YYYY-MM-DD') + " AND b.created_on::date <= "+ moment(q.createdOnAu).format('YYYY-MM-DD') : undefined,
	        // checkinPeriod: moment(q.checkinDu||null).isValid() ?  [ moment(q.checkinDu).format('YYYY-MM-DD'),moment(q.checkinAu).format('YYYY-MM-DD')] : undefined,
	        checkinPeriodDu: moment(q.checkinDu || null).isValid() ? moment(q.checkinDu).format('YYYY-MM-DD') : undefined,
	        checkinPeriodAu: moment(q.checkinAu || null).isValid() ? moment(q.checkinAu).format('YYYY-MM-DD') : undefined,
	        createdOnPeriodDu: moment(q.createdOnDu || null).isValid() ? moment(q.createdOnDu).format('YYYY-MM-DD') : undefined,
	        createdOnPeriodAu: moment(q.createdOnAu || null).isValid() ? moment(q.createdOnAu).format('YYYY-MM-DD') : undefined

	        // createdOnPeriod: moment(q.createdOnDu||null).isValid() ? [  moment(q.createdOnDu).format('YYYY-MM-DD'), moment(q.createdOnAu).format('YYYY-MM-DD') ]: undefined,

	        // checkin: moment(q.checkin||null).isValid() ? moment(q.checkin).format('YYYY-MM-DD') : undefined,
	        // createdOn: moment(q.createdOn||null).isValid() ? moment(q.createdOn).format('YYYY-MM-DD') : undefined
	      }
	    }).then(function (res) {
	      $log.debug('properties', res.data);
	      console.log("res", res.data.items);
	      // var items=JSON.parse(res.data.items);
	      // for(var i=0;i<items.length;i++){
	      //   items[i].payments[0]=JSON.parse(items[i].payments[0]);

	      // }
	      vm.query.checkinDu = null;
	      vm.query.checkinAu = null;

	      vm.query.createdOnDu = null;
	      vm.query.createdOnAu = null;
	      vm.query.customer = null;

	      // loadStats(res.data.items);
	      // loadSum(res.data.items);
	      // loadPayments(res.data.items);
	      // loadRest(res.data.items);
	      // posStat(res.data.items);
	      // posOTARev(res.data.items);
	      // posOTACmd(res.data.items);
	      // posWalkingRev(res.data.items);
	      // posWalkingCmd(res.data.items);
	      // posTestRev(res.data.items);
	      // posTestCmd(res.data.items);
	      // posB2BCmd(res.data.items);
	      // posB2BRev(res.data.items);
	      // posB2CCmd(res.data.items);
	      // posB2CRev(res.data.items);
	      // posTestCmd(res.data.items);
	      // posTestRev(res.data.items);
	      // posTOCmd(res.data.items);
	      // posTORev(res.data.items);


	      angular.extend(vm, {
	        items: res.data.items,
	        //items: items,

	        total: res.data.total
	        // bookingTotal : res.data.items.reduce((sum,item) =>  sum + item.total , 0)


	      });
	    });
	  }

	  function searchBookings(cr) {
	    //console.log(vm.propertyCtrl.property);
	    //const href = vm.propertyCtrl.property.links.bookings.href;
	    var href = vm.lectus.links.bookings.href;
	    console.log("cr", cr);
	    var sort = vm.query.order.indexOf("-") === 0 ? vm.query.order.replace("-", "") + ">" : vm.query.order + '<';
	    var q = vm.query;

	    console.log(vm.query, arguments);
	    console.log("vm.query", vm.query);
	    console.log("checkinPeriod", moment(q.checkin || null).isValid() ? moment(q.checkinDu).format('YYYY-MM-DD') + " And " + moment(q.checkinAu).format('YYYY-MM-DD') : undefined);
	    console.log("createdOnPeriod", moment(q.createdOn || null).isValid() ? moment(q.createdOnDu).format('YYYY-MM-DD') + " And " + moment(q.createdOnAu).format('YYYY-MM-DD') : undefined);

	    vm.loadingPromise = $http.get(href, {
	      params: {
	        property: query.property,
	        $limit: vm.query.limit,
	        $skip: vm.query.page * vm.query.limit - vm.query.limit,
	        $sort: sort,
	        name: isNaN(vm.query.customer) ? vm.query.customer || undefined : undefined,
	        number: !isNaN(vm.query.customer) ? vm.query.customer : undefined,

	        checkinPeriod: moment(q.checkin || null).isValid() ? moment(q.checkinDu).format('YYYY-MM-DD') + " And " + moment(q.checkinAu).format('YYYY-MM-DD') : undefined,
	        createdOnPeriod: moment(q.createdOn || null).isValid() ? moment(q.createdOnDu).format('YYYY-MM-DD') + " And " + moment(q.createdOnAu).format('YYYY-MM-DD') : undefined

	        // checkin:  moment(q.checkin||null).isValid() ? moment(q.checkin).format('YYYY-MM-DD') : undefined,
	        // createdOn:  moment(cr||null).isValid() ? moment(cr).format('YYYY-MM-DD') : undefined
	        // checkin: vm.filter && moment(q.checkin||null).isValid() ? moment(q.checkin).format('YYYY-MM-DD') : undefined,
	        // createdOn: vm.filter && moment(cr||null).isValid() ? moment(cr).format('YYYY-MM-DD') : undefined
	      }
	    }).then(function (res) {
	      $log.debug('properties', res.data);
	      // loadStats(res.data.items);
	      loadSum(res.data.items);
	      loadPayments(res.data.items);
	      loadRest(res.data.items);
	      angular.extend(vm, {
	        items: res.data.items,
	        total: res.data.total

	      });
	    });
	  }

	  function showBooking(b) {
	    $state.go(vm.bookingViewState, { booking: b.number });
	  }
	  function createBooking() {
	    $state.go(vm.bookingCreateState);
	  }

	  function toggleshow(ordre) {
	    var baseUrl = ordre.links.amenities.href;
	    if (ordre.show = false) arrivedFunction(ordre);else noshowFunction(ordre);
	  }

	  function arrivedFunction(ordre) {
	    var href = vm.propertyCtrl.property.links.bookings.href;
	    // /properties/:property/bookings/:booking/items/:bookingItem
	    // const href = "http://beds-sapi.fractalite.com/bookings-on-hold/"

	    //var query=[{"op":"replace","path":"/status","value":"Arrivée"}];

	    //n.status=6;
	    //n.items[0].status= 6;
	    ordre.show = true;

	    $http.put(href + "/" + ordre.booking, ordre);

	    //  .then(() =>$http.delete(i.links.self.href))
	    //  .then(() => vm.items.splice(vm.items.indexOf(media),1));
	  }
	  function noshowFunction($event, ordre) {
	    var href = vm.propertyCtrl.property.links.bookings.href;
	    // /properties/:property/bookings/:booking/items/:bookingItem
	    // const href = "http://beds-sapi.fractalite.com/bookings-on-hold/"

	    //var query=[{"op":"replace","path":"/status","value":"Arrivée"}];

	    //n.status=6;
	    //n.items[0].status= 6;
	    ordre.show = false;

	    $http.put(href + "/" + ordre.booking, ordre);

	    //  .then(() =>$http.delete(i.links.self.href))
	    //  .then(() => vm.items.splice(vm.items.indexOf(media),1));
	  }

	  // function createPie(elementId, count, unit, data) {
	  //   return new d3pie(
	  //     elementId,
	  //     _.defaultsDeep({
	  //         header: {
	  //           title: {
	  //             text: count,
	  //             fontSize: 14
	  //           },
	  //           subtitle: {
	  //             text: unit
	  //           },
	  //           location: "top-center"
	  //         },
	  //         size: {
	  //           canvasHeight: 240,
	  //           canvasWidth: 240,
	  //           pieInnerRadius: "40%",
	  //           pieOuterRadius: "60%"
	  //         },
	  //         misc: {
	  //           canvasPadding: {
	  //             "top": 0,
	  //             "right": 0,
	  //             "bottom": 0,
	  //             "left": 0
	  //           }
	  //         },
	  //         tooltips: {
	  //           type: 'caption'
	  //         },
	  //         data: {
	  //           content: data
	  //         }
	  //       },
	  //       chartUtils.pieOptions)
	  //   );
	  // }


	  // function updateData() {
	  //   if (!vm.reportData) return;
	  //   //const bookings = destinations.filter(d => d.bookings.stays > 0);
	  //   //const checkins = destinations.filter(d => d.confirmedCheckins.stays > 0);

	  //   ["bkUnits", "bkBoards", "bkOccupancies", "ciUnits", "ciBoards", "ciOccupancies" ]
	  //   .filter(name => _.isObject(vm.pies[name]))
	  //     .forEach(name => {
	  //       vm.pies[name].destroy();
	  //       vm.pies[name]= null;
	  //     });

	  //     const report = vm.reportData;

	  //     vm.hasBookings = _.isArray(report.bkUnits);
	  //     vm.hasCheckins = _.isArray(report.ciUnits);

	  //   if (report.bkUnits) {
	  //     vm.pies.bkUnits = createPie(
	  //       "bookings-units-pie",
	  //       "Catégories",
	  //       "",
	  //       [20]
	  //     );
	  //     vm.pies.bkBoards = createPie(
	  //       "bookings-boards-pie",
	  //       "Pensions",
	  //       "",
	  //       report.bkBoards.map(mapBoard)
	  //     );
	  //     vm.pies.bkOccupancies = createPie(
	  //       "bookings-occupancies-pie",
	  //       "Occupations",
	  //       "",
	  //       report.bkOccupancies.map(mapOccupancy)
	  //     );

	  //   }


	  // }

	  function add(ev) {
	    $mdDialog.show(_editDialog(ev)).then(function (result) {
	      // add to units list,
	      // or do a new http request ?
	      // $scope.$emit('property:changed',{relation:'units'})
	    });
	  }
	  function _editDialog($event) {
	    return {
	      templateUrl: 'app/bookings/property-list/createBooking/template.html',
	      controller: _controller2.default,
	      controllerAs: '$ctrl',
	      targetEvent: $event,
	      locals: {
	        //order: order,

	        propertyCtrl: vm.propertyCtrl
	      }
	    };
	  }

	  function editBooking(b) {
	    console.log('editBooking', b);
	    $state.go(vm.bookingEditState, { booking: b.number });
	  }
	}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var d3 = __webpack_require__(15);
	var moment = __webpack_require__(10);

	var formatNumber = exports.formatNumber = d3.format(',');

	var formatMAD = exports.formatMAD = function formatMAD(v) {
	  return formatNumber(v) + " MAD";
	};

	var defaultOptions = exports.defaultOptions = {
	  deepWatchOptions: false,
	  deepWatchData: false,
	  deepWatchDataDepth: false,
	  chart: {
	    type: "multiBarChart",
	    x: function x(d) {
	      return d.date;
	    },
	    y: function y(d) {
	      return d.value;
	    },
	    showValues: true,
	    showLegend: true,
	    showControls: false,
	    stacked: true,
	    forceY: [0, 1000],
	    duration: 500,
	    height: 160,
	    xAxis: {
	      tickFormat: function tickFormat(d) {
	        return moment(d).format('ddd D');
	      },
	      ticks: d3.time.week,
	      showMaxMin: true
	    },
	    //reduceXTicks: false,
	    yAxis: {
	      tickFormat: formatNumber,
	      showMaxMin: false
	    },
	    tooltip: {
	      headerFormatter: d3.time.format("%A %-d %b %Y")
	    }
	  }
	};

	var pieOptions = exports.pieOptions = {
	  header: {
	    title: {
	      fontSize: 18,
	      font: "Roboto"
	    },
	    subtitle: {
	      color: "#666666",
	      fontSize: 12,
	      font: "Roboto"
	    },
	    location: "pie-center",
	    titleSubtitlePadding: 2
	  },
	  size: {
	    canvasHeight: 260,
	    canvasWidth: 300,
	    pieInnerRadius: "60%",
	    pieOuterRadius: "75%"
	  },
	  data: {
	    //  sortOrder: "value-desc"
	  },
	  labels: {
	    outer: {
	      pieDistance: 12
	    },
	    inner: {
	      hideWhenLessThanPercentage: 3
	    },
	    mainLabel: {
	      fontSize: 11
	    },
	    percentage: {
	      color: "#ffffff",
	      decimalPlaces: 0
	    },
	    value: {
	      color: "#adadad",
	      fontSize: 11
	    },
	    lines: {
	      enabled: true,
	      style: "straight"
	    },
	    truncation: {
	      enabled: true,
	      truncateLength: 16
	    }
	  },
	  tooltips: {
	    enabled: true,
	    type: "placeholder",
	    string: "{label}: {value} ({percentage}%)",
	    "styles": {
	      "font": "Roboto",
	      "fontSize": 14
	    }
	  },
	  effects: {
	    pullOutSegmentOnClick: false
	  }
	};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	OrderCreateBookingCtrl.$inject = ["$log", "$q", "$mdDialog", "$http", "propertyCtrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OrderCreateBookingCtrl;
	var _ = __webpack_require__(5);

	function OrderCreateBookingCtrl($log, $q, $mdDialog, $http, propertyCtrl) {
	  "ngInject";

	  var vm = this;

	  var order = {

	    property: 1,
	    items: [{
	      booking: 581,
	      number: 239,
	      status: 3,
	      checkin: "2021-08-07",
	      nights: 1,
	      product: {
	        code: 813,
	        unit: {
	          code: 135,
	          name: "Single",
	          typ: "Chambre"
	        },
	        basis: {
	          code: 46,
	          description: "All Inclusive Flexible"
	        },
	        board: 1222,
	        price: 1000,
	        rates: [1000],
	        taxInc: false,
	        currency: "MAD",
	        property: 1,
	        available: true,
	        occupancy: 100,
	        commission: 0,
	        cancellation: ["2n0"],
	        payOnArrival: false
	      },
	      guests: [{
	        lastName: "test",
	        firstName: "test"
	      }],

	      cancellation: [{
	        from: "2021-08-06",
	        charge: "0.00"
	      }],
	      total: 1004
	    }],
	    number: 581,
	    cc: null,
	    arrived: false,
	    payments: [{
	      bank: "-1",
	      amount: 1000,
	      method: "-1",
	      number: "24922-W0dkWoJ30",
	      currency: "MAD"
	    }],
	    pos: null,
	    customer: {
	      code: -1,
	      email: "test@test.test",
	      phone: "00",
	      lastName: "test",
	      firstName: "test"
	    }

	  };

	  function init() {

	    // var objPay=JSON.parse(order.payments[0]);
	    //console.log("objPay: ", order);
	    var propCtrl = vm.propertyCtrl;
	    var p1 = propCtrl.get('units').then(function (collection) {
	      return $q.all(collection.items.map(loadUnitProducts));
	    }).then(function (units) {
	      return vm.units = units;
	    });
	    var p2 = propCtrl.get('rate-bases').then(function (collection) {
	      return vm.rateBases = _.keyBy(collection.items, "code");
	    });
	    var p3 = datasets.bindSets(["boards", "unit-types"], vm, true);

	    angular.extend(vm, {
	      status: 'loading',
	      //copy: order,
	      save: save,
	      cancel: function cancel() {
	        return $mdDialog.cancel();
	      }

	    });
	  }

	  function loadUnitProducts(unit) {
	    return $http.get(unit.links.products.href).then(function (res) {
	      unit.products = res.data.items;
	      return unit;
	    });
	  }

	  function save(order) {

	    //var order = vm.copy;

	    var promise;

	    // const href = vm.propertyCtrl.property.links.bookings.href;
	    // const href = order.links.index.href;
	    var href = order.links.base;
	    var PATCH_URL = href + "/commands/booking-items";

	    console.log("href", order.links.base);
	    // order.bookingItems=order.items;
	    console.log("saveorder", order);
	    //var item;
	    console.log("saveorder", order.items[0]);
	    console.log("saveorder", order.items[0].number);

	    // vm.item.number=order.items[0].number;
	    // vm.item.nights=order.items[0].nights;
	    // vm.item.total=order.items[0].total;
	    console.log("item :: ", vm.item);

	    $http.post(PATCH_URL, order.items[0]).then(function (res) {
	      $log.debug('properties', res.data);
	    });
	    return promise.then(function (res) {
	      return close(res.data);
	    });
	    $mdDialog.hide(order);
	  }

	  function close(order) {
	    $log.debug("close", order);
	    $mdDialog.hide(order);
	  }
	}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PropertyBookingOnHoldListCtrl.$inject = ["$log", "$state", "$mdToast", "$mdDialog", "$http", "apiUrl", "sapiUrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _controller = __webpack_require__(47);

	var _controller2 = _interopRequireDefault(_controller);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  name: "propertyBookingOnHoldList",
	  controller: PropertyBookingOnHoldListCtrl,
	  templateUrl: "app/bookings/property-booking-on-hold-list/template.html",
	  bindings: {
	    lectus: "<"
	  },
	  require: {
	    propertyCtrl: "^propertyContainer"
	  }
	};


	function PropertyBookingOnHoldListCtrl($log, $state, $mdToast, $mdDialog, $http, apiUrl, sapiUrl) {
	  "ngInject";

	  console.log("booking on hold");
	  var vm = this;
	  var query = {
	    customer: "",
	    limit: 2500000,
	    order: "createdOn",
	    page: 1,
	    askforfree: false
	  };
	  var summ, paymnt;
	  // var nuiteenuitee = 0;
	  vm.status = ["", "", "reservée", "Confirmé", "Annulé", "No show", "Arrivée"];

	  vm.$onInit = function () {
	    // only load property bookings
	    if (vm.propertyCtrl) {
	      query.property = vm.propertyCtrl.property.code;
	    }
	    angular.extend(vm, {
	      customerFilterOptions: {
	        debounce: 500
	      },
	      query: query,
	      confirm: confirm,
	      addPayment: addPayment,
	      loadBookings: loadBookings
	    });
	    //$scope.$watch(()=>vm.query.customer, onSearchChange);
	    //$scope.$watch(()=>vm.query.createdOn, onSearchChange);
	    //$scope.$watch(()=>vm.query.checkin, onSearchChange);

	    loadBookings();
	    //loadStats();
	  };

	  function encodePayment(payment) {
	    return {
	      method: payment.method,
	      number: "0",
	      amount: payment.amount,
	      // "currency":"MAD",
	      date: moment().format("YYYY-MM-DD"),
	      bank: "-1"
	    };
	  }
	  function bookingEncode(booking) {
	    return {
	      op: "replace",
	      path: "/status",
	      value: "confirmed",
	      payments: booking.payments.map(encodePayment)
	    };
	  }

	  function confirm(ev, booking) {
	    // if (booking.payments && booking.payments == 0)
	    //   return

	    var data = bookingEncode(booking);

	    var req = {
	      method: "POST",
	      url: apiUrl + "/confirm-bookings-on-hold/" + booking.number,
	      headers: {
	        "Content-Type": "application/json",
	        "Sapi-Url": sapiUrl
	      },
	      data: data
	    };

	    $http(req).then(onSuccess, onFailure);

	    // var config = {
	    //   headers: {
	    //     'Content-Type': 'application/json'
	    //   }
	    // }

	    // $http.post(apiUrl + '/confirm-bookings-on-hold/' + booking.number, data, config)
	    //   .success(function (data, status, headers, config) {
	    //     console.log('onSuccess', response)

	    //   })
	    //   .error(function (data, status, header, config) {
	    //     console.log('onFailure..', error)

	    //   });
	  }

	  function onSuccess(response) {
	    console.log("onSuccess", response);
	    $mdToast.show($mdToast.simple().textContent("Réservation confirmée").hideDelay(3000));
	    $state.reload();
	  }

	  function onFailure(error) {
	    console.log("onFailure..", error);
	  }

	  function addPayment(ev, booking) {
	    $mdDialog.show(_editDialog(ev)).then(function (payment) {
	      booking.payments.push(payment);
	    });
	  }

	  function _editDialog($event) {
	    console.log("vm.links", vm.links);
	    return {
	      templateUrl: "app/bookings/property-booking-on-hold-list/payment/template.html",
	      controller: _controller2.default,
	      controllerAs: "$ctrl",
	      targetEvent: $event,
	      locals: {
	        propertyCtrl: vm.propertyCtrl
	      }
	    };
	  }

	  function loadBookings() {
	    console.log("loadBookings..", vm.propertyCtrl.property);
	    //const href = vm.propertyCtrl.property.links.bookings.href;
	    //const href = vm.lectus.links.bookings.href;
	    var href = apiUrl + "/bookings-on-hold";
	    console.log("vm.query", vm.query);

	    //console.log(vm.query, arguments);
	    var sort = vm.query && vm.query.order && vm.query.order.indexOf("-") === 0 ? vm.query.order.replace("-", "") + ">" : vm.query.order + "<";
	    var q = vm.query;

	    // vm.checkoutfin = moment(q.checkinAu || null).isValid() ? moment(q.checkinAu).format('YYYY-MM-DD') : undefined;
	    console.log("query...", query);
	    vm.loadingPromise = $http.get(href, {
	      params: {
	        property: vm.query.property,
	        $limit: vm.query.limit,
	        $skip: vm.query.page * vm.query.limit - vm.query.limit,
	        $sort: sort,
	        askforfree: q.askforfree,
	        name: isNaN(vm.query.customer) ? vm.query.customer || undefined : undefined,
	        number: !isNaN(vm.query.customer) ? vm.query.customer : undefined,
	        checkin: moment(q.checkin || null).isValid() ? moment(q.checkin).format("YYYY-MM-DD") : undefined,
	        checkout: moment(q.checkout || null).isValid() ? moment(q.checkout).format("YYYY-MM-DD") : undefined,
	        createdOnStart: moment(q.createdOnStart || null).isValid() ? moment(q.createdOnStart).format("YYYY-MM-DD") : undefined,
	        createdOnEnd: moment(q.createdOnEnd || null).isValid() ? moment(q.createdOnEnd).format("YYYY-MM-DD") : undefined
	      }
	    }).then(function (res) {
	      $log.debug("properties", res.data);
	      console.log("res...", res.data.items);
	      angular.extend(vm, {
	        items: res.data.items.map(function (item) {
	          item.payments = item.payments || [];
	          return item;
	        }),
	        //items: items,

	        total: res.data.total
	        // bookingTotal : res.data.items.reduce((sum,item) =>  sum + item.total , 0)
	      });
	    });
	  }

	  // function editBooking(b) {
	  //   console.log('editBooking', b);
	  //   $state.go(vm.bookingEditState, { booking: b.number })
	  // }
	}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PaymentEditCtrl.$inject = ["$log", "$mdDialog", "$q"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PaymentEditCtrl;
	var _ = __webpack_require__(5);
	//https://github.com/danialfarid/ng-file-upload


	function PaymentEditCtrl($log, $mdDialog, $q) {
	    "ngInject";

	    var vm = this;

	    // console.log('booking..', booking)
	    vm.paymentMethods = [{
	        "name": "cc",
	        "code": "2",
	        "bank": "-1"
	    }, {
	        "name": "cash",
	        "code": "10",
	        "bank": "-1"
	    }, {
	        "name": "check",
	        "code": "3",
	        "bank": "-1"
	    }, {
	        "name": "credit",
	        "code": "18",
	        "bank": "-1"
	    }, {
	        "name": "account",
	        "code": "18",
	        "bank": "-1"
	    }];

	    init();

	    function init() {
	        // vm.property = propertyCtrl.property;
	        angular.extend(vm, {
	            status: 'loading',
	            title: "Nouveau paiement",
	            copy: { check: {} },
	            save: save,
	            cancel: function cancel() {
	                return $mdDialog.cancel();
	            }
	        });
	    }

	    function save() {
	        console.log('onClose..', vm.copy);
	        $mdDialog.hide(vm.copy);
	    }
	}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PropertyCreateBookingsCtrl.$inject = ["$log", "$state", "$scope", "datasets", "$q", "$mdDialog", "$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moment = __webpack_require__(10);

	exports.default = {
	  name: "propertyCreateBooking",
	  controller: PropertyCreateBookingsCtrl,
	  templateUrl: 'app/bookings/property-list/createBookings/template.html',
	  bindings: {
	    lectus: "<",
	    bookingViewState: "<",
	    bookingListState: "<"
	  },
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PropertyCreateBookingsCtrl($log, $state, $scope, datasets, $q, $mdDialog, $http) {
	  "ngInject";

	  var vm = this;
	  var orderItems = [];
	  var itemCount = 1;
	  var item = [];
	  var order;
	  var boards = [{ code: 1000, name: "Chambre Seulement" }, { code: 1100, name: "Petit-déjeuner" }, { code: 1110, name: "Demi-pension" }, { code: 1111, name: "Pension complète" }, { code: 2111, name: "All inclusive" }];
	  var payments = [];
	  var posS = [{ name: "OTA", reference: "" }, { name: "B2B", reference: "" }, { name: "B2C", reference: "" }, { name: "Walk-in", reference: "" }, { name: "TO", reference: "" }, { name: "MICE", reference: "" }];
	  var pos, baseTarifaire, totalPrice;

	  item.push(itemCount);

	  vm.$onInit = function () {

	    var propCtrl = vm.propertyCtrl;
	    var p1 = propCtrl.get('units').then(function (collection) {
	      return $q.all(collection.items.map(loadUnitProducts));
	    }).then(function (units) {
	      return vm.units = units;
	    });
	    var p2 = propCtrl.get('rate-bases').then(function (collection) {
	      return vm.rateBases = _.keyBy(collection.items, "code");
	    });
	    var p3 = datasets.bindSets(["boards"]).then(function (collection) {
	      return vm.board = _.keyBy(collection.items, "code");
	    });

	    console.log("propCtrl: ", propCtrl.property.code);
	    for (var i = 0; i < orderItems.length; i++) {
	      orderItems[i].totalPrice = parseFloat(orderItems[i].total) * parseFloat(night);
	      console.log("orderItems[i].totalPrice: ", orderItems[i].totalPrice);
	    }
	    // console.log("vm.rateBases: ",vm.rateBases);
	    //console.log("vm.board: ",vm.board);

	    console.log("p1: ", p1);
	    console.log("p2: ", p2);
	    console.log("p3: ", p3);

	    // only load property bookings

	    angular.extend(vm, {
	      customerFilterOptions: {
	        debounce: 500
	      },
	      payments: payments,
	      orderItems: orderItems,
	      order: order,
	      save: save,
	      addItem: addItem,
	      itemCount: itemCount,
	      item: item,
	      posS: posS,
	      pos: pos,
	      boards: boards,
	      cancel: cancel,
	      deleteItem: deleteItem,
	      baseTarifaire: baseTarifaire
	    });
	    //$scope.$watch(()=>vm.query.customer, onSearchChange);
	    //$scope.$watch(()=>vm.query.createdOn, onSearchChange);
	    //$scope.$watch(()=>vm.query.checkin, onSearchChange);

	    loadBookings();
	  };

	  function loadUnitProducts(unit) {
	    return $http.get(unit.links.products.href).then(function (res) {
	      unit.products = res.data.items;
	      return unit;
	    });
	  }

	  function addItem() {
	    itemCount++;
	    item.push(itemCount);
	    console.log("itemCount: ", itemCount);
	  }

	  function deleteItem() {
	    itemCount--;
	    item.splice(-1, 1);
	    console.log("itemCount-: ", itemCount);
	  }

	  function save(order, orderItems, night, checkin) {
	    // console.log("Object :: ", Object.values(order.items));
	    // var items=order.items;
	    // order.items=null;
	    // order.items=Object.entries(items);
	    console.log("vm.propertyCtrl :: ", vm.propertyCtrl);
	    console.log("order :: ", order);
	    console.log("pos :: ", vm.pos);
	    console.log("checkin :: ", checkin);

	    var amount = vm.payments[0].amount.toString();
	    vm.payments[0].amount = amount;
	    vm.payments[0].currency = "MAD";
	    vm.payments[0].bank = -1;
	    vm.payments[0].method = 21;
	    order.payments = vm.payments;
	    order.aclD = "{g:dmc,g:contracting}";
	    /// order.aclW = "{g:atlasvoyages,g:contracting,u:Hermes}";
	    order.aclW = "{g:dmc,g:sup-" + vm.propertyCtrl.property.accountingCode + ",u:Hermes}";
	    order.aclR = "{g:dmc,g:sup-" + vm.propertyCtrl.property.accountingCode + ",u:Hermes}";
	    order.createdBy = "BookBeds";
	    order.modifiedBy = "Bookbeds";

	    vm.pos.reference = "";
	    order.pos = vm.pos;

	    //var order = vm.copy;
	    // order.property=
	    // console.log("orderItems :: ", orderItems);
	    // console.log("baseTarifaire :: ", vm.baseTarifaire);
	    var basis = {

	      code: vm.baseTarifaire.code,
	      description: vm.baseTarifaire.description
	    };
	    var date = new Date(checkin);
	    //date=checkin;
	    // console.log("checkin :: ", date);
	    // console.log("checkin-1 :: ", date.getDay() - 1);
	    // console.log("checkin-1mom :: ", moment(date).add(-1,'day'));
	    console.log("checkin+H :: ", moment(date).add(2, 'hours'));

	    var cancellations = [];
	    var cancellation = {
	      // from: date.setDate(date.getDay() - 1),
	      //from: moment(date).add(-1,'day'),

	      from: checkin,
	      charge: "0.00"
	    };
	    cancellations.push(cancellation);
	    for (var i = 0; i < orderItems.length; i++) {
	      orderItems[i].night = night;
	      orderItems[i].status = 3;
	      //add tarif by night
	      orderItems[i].total = parseFloat(orderItems[i].total) * parseFloat(night);
	      //orderItems[i].guest='{4}';
	      orderItems[i].cancellation = cancellations;
	      orderItems[i].allotment = '{}';
	      var gsts = [];
	      for (var j = 0; j < orderItems[i].guests; j++) {
	        var gst = {

	          lastName: order.customer.lastName,
	          firstName: order.customer.firstName
	        };
	        gsts.push(gst);

	        //  orderItems[i].guest = '{' + orderItems[i].guests + '}';
	      }

	      for (var j = 0; j < orderItems[i].child; j++) {
	        var childBirthdate = new Date();
	        childBirthdate.setFullYear(childBirthdate.getFullYear() - 10);
	        var gst = {

	          lastName: order.customer.lastName,
	          firstName: order.customer.firstName,
	          birthdate: childBirthdate
	        };
	        gsts.push(gst);
	      }

	      for (var j = 0; j < orderItems[i].infant; j++) {
	        var infantBirthdate = new Date();
	        infantBirthdate.setFullYear(infantBirthdate.getFullYear() - 1);
	        var gst = {

	          lastName: order.customer.lastName,
	          firstName: order.customer.firstName,
	          birthdate: infantBirthdate
	        };
	        gsts.push(gst);
	      }
	      orderItems[i].guest = gsts;

	      orderItems[i].checkin = moment(date).add(2, 'hours');
	      orderItems[i].product.basis = basis;
	      orderItems[i].product.currency = vm.baseTarifaire.currency;
	    }
	    order.items = orderItems;
	    order.property = vm.propertyCtrl.property.code;
	    var href = vm.propertyCtrl.property.links.base;
	    // const href = order.links.index.href;
	    //  const href = order.links.base;
	    var PATCH_URL = href + "/commands/booking";

	    console.log("order :: ", order);

	    console.log("order length :: ", order.items.length);

	    $http.post(PATCH_URL, order).then(function (res) {
	      $log.debug('properties', res.data);
	    });
	    // return promise.then(res => close(res.data));


	    return listbookings();
	    $mdDialog.hide(order);
	  }

	  function showBooking(b) {
	    $state.go(vm.bookingViewState, { booking: b.number });
	  }

	  function listbookings() {
	    $state.go(vm.bookingListState);
	  }

	  function listbookings() {
	    $state.go(vm.bookingListState);
	  }
	  function cancel() {
	    $state.go(vm.bookingListState);
	  }
	}

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	"use strict";

	PropertyBookingListDayCtrl.$inject = ["$log", "$state", "$scope", "$mdDialog", "$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "propertyBookingListDay",
	  controller: PropertyBookingListDayCtrl,
	  templateUrl: 'app/bookings/property-list-day/template.html',
	  bindings: {
	    lectus: "<",
	    bookingViewState: "<"
	  },
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PropertyBookingListDayCtrl($log, $state, $scope, $mdDialog, $http) {
	  "ngInject";

	  var vm = this;
	  var summ, paymnt;

	  var query = {
	    customer: '',
	    limit: 25,
	    order: 'createdOn',
	    page: 1,
	    createdOn: moment().format('YYYY-MM-DD')
	  };

	  vm.loadBooking = loadBookings;

	  vm.$onInit = function () {
	    // only load property bookings
	    if (vm.propertyCtrl) {
	      query.property = vm.propertyCtrl.property.code;
	    }
	    angular.extend(vm, {
	      customerFilterOptions: {
	        debounce: 500
	      },
	      summ: summ,
	      paymnt: paymnt,
	      query: query,
	      loadBookings: loadBookings,
	      showBooking: showBooking,
	      searchBookings: searchBookings,
	      loadStats: loadStats

	    });
	    //$scope.$watch(()=>vm.query.customer, onSearchChange);
	    //$scope.$watch(()=>vm.query.createdOn, onSearchChange);
	    //$scope.$watch(()=>vm.query.checkin, onSearchChange);

	    loadBookings();
	  };

	  function onSearchChange(newValue, oldValue) {
	    if (newValue === oldValue) {
	      return;
	    }
	    var bookmark = vm.query.page;
	    if (!oldValue) {
	      bookmark = vm.query.page;
	    }

	    if (newValue !== oldValue) {
	      vm.query.page = 1;
	    }
	    if (!newValue) {
	      vm.query.page = bookmark;
	    }
	    loadBookings();
	  }

	  function loadBookings() {
	    //console.log(vm.propertyCtrl.property);
	    //const href = vm.propertyCtrl.property.links.bookings.href;
	    var href = vm.lectus.links.bookings.href;
	    //console.log(vm.query, arguments);
	    var sort = vm.query.order.indexOf("-") === 0 ? vm.query.order.replace("-", "") + ">" : vm.query.order + '<';
	    var q = vm.query;
	    console.log(vm.query, arguments);
	    console.log("vm.query", vm.query);

	    vm.loadingPromise = $http.get(href, {
	      params: {
	        property: query.property,
	        $limit: vm.query.limit,
	        $skip: vm.query.page * vm.query.limit - vm.query.limit,
	        $sort: sort,
	        name: isNaN(vm.query.customer) ? vm.query.customer || undefined : undefined,
	        number: !isNaN(vm.query.customer) ? vm.query.customer : undefined,

	        // checkin:  moment(q.checkin||null).isValid() ? moment(q.checkin).format('YYYY-MM-DD') : undefined,
	        createdOn: moment(q.createdOn || null).isValid() ? moment().format('YYYY-MM-DD') : undefined
	      }
	    }).then(function (res) {
	      $log.debug('properties', res.data);
	      loadStats(res.data.items);

	      angular.extend(vm, {
	        items: res.data.items,
	        total: res.data.total
	      });
	    });
	  }

	  function searchBookings(cr) {
	    //console.log(vm.propertyCtrl.property);
	    //const href = vm.propertyCtrl.property.links.bookings.href;
	    var href = vm.lectus.links.bookings.href;
	    console.log("cr", cr);
	    var sort = vm.query.order.indexOf("-") === 0 ? vm.query.order.replace("-", "") + ">" : vm.query.order + '<';
	    var q = vm.query;

	    console.log(vm.query, arguments);
	    console.log("vm.query", vm.query);

	    vm.loadingPromise = $http.get(href, {
	      params: {
	        property: query.property,
	        $limit: vm.query.limit,
	        $skip: vm.query.page * vm.query.limit - vm.query.limit,
	        $sort: sort,
	        name: isNaN(vm.query.customer) ? vm.query.customer || undefined : undefined,
	        number: !isNaN(vm.query.customer) ? vm.query.customer : undefined,

	        checkin: moment(q.checkin || null).isValid() ? moment(q.checkin).format('YYYY-MM-DD') : undefined,
	        createdOn: moment(cr || null).isValid() ? moment(cr).format('YYYY-MM-DD') : undefined
	        // checkin: vm.filter && moment(q.checkin||null).isValid() ? moment(q.checkin).format('YYYY-MM-DD') : undefined,
	        // createdOn: vm.filter && moment(cr||null).isValid() ? moment(cr).format('YYYY-MM-DD') : undefined
	      }
	    }).then(function (res) {
	      $log.debug('properties', res.data);
	      loadStats(res.data.items);
	      angular.extend(vm, {
	        items: res.data.items,
	        total: res.data.total
	      });
	    });
	  }

	  function showBooking(b) {
	    $state.go(vm.bookingViewState, { booking: b.number });
	  }

	  function loadStats(items) {
	    console.log("vm.items.length ", items.length);

	    var smm = 0;
	    var pay = 0;
	    // console.log("vm.items.length ", vm.items.length);

	    for (var i = 0; i < items.length; i++) {
	      console.log("items[i].items.length ", items[i].items.length);

	      for (var j = 0; j < items[i].items.length; j++) {

	        console.log("summ", parseFloat(items[i].items[j].total));

	        smm = smm + parseFloat(items[i].items[j].total);
	        if (items[i].payments != null) {
	          var objPay = JSON.parse(items[i].payments[0]);
	          var rp = Number(objPay.amount);
	          pay = pay + parseFloat(rp);
	          console.log("rp ", rp);
	          console.log("pay ", pay);

	          // pay=pay+parseFloat(items[i].items[j].payments[0].amount);
	        }
	      }
	    }
	    vm.summ = smm;
	    vm.paymnt = pay;
	    vm.rest = smm - pay;
	    console.log("summ", vm.summ);
	  }
	}

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	"use strict";

	PropertyBookingListDayCheckinCtrl.$inject = ["$log", "$state", "$scope", "$mdDialog", "$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "propertyBookingListDayCheckin",
	  controller: PropertyBookingListDayCheckinCtrl,
	  templateUrl: 'app/bookings/property-list-day-checkin/template.html',
	  bindings: {
	    lectus: "<",
	    bookingViewState: "<"
	  },
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PropertyBookingListDayCheckinCtrl($log, $state, $scope, $mdDialog, $http) {
	  "ngInject";

	  var vm = this;
	  var summ, paymnt;

	  var query = {
	    customer: '',
	    limit: 25,
	    order: 'createdOn',
	    page: 1,
	    checkin: moment().format('YYYY-MM-DD')
	  };

	  vm.loadBooking = loadBookings;

	  vm.$onInit = function () {
	    // only load property bookings
	    if (vm.propertyCtrl) {
	      query.property = vm.propertyCtrl.property.code;
	    }
	    angular.extend(vm, {
	      customerFilterOptions: {
	        debounce: 500
	      },
	      summ: summ,
	      paymnt: paymnt,
	      query: query,
	      loadBookings: loadBookings,
	      showBooking: showBooking,
	      searchBookings: searchBookings,
	      loadStats: loadStats
	    });
	    //$scope.$watch(()=>vm.query.customer, onSearchChange);
	    //$scope.$watch(()=>vm.query.createdOn, onSearchChange);
	    //$scope.$watch(()=>vm.query.checkin, onSearchChange);

	    loadBookings();
	  };

	  function onSearchChange(newValue, oldValue) {
	    if (newValue === oldValue) {
	      return;
	    }
	    var bookmark = vm.query.page;
	    if (!oldValue) {
	      bookmark = vm.query.page;
	    }

	    if (newValue !== oldValue) {
	      vm.query.page = 1;
	    }
	    if (!newValue) {
	      vm.query.page = bookmark;
	    }
	    loadBookings();
	  }

	  function loadBookings() {
	    //console.log(vm.propertyCtrl.property);
	    //const href = vm.propertyCtrl.property.links.bookings.href;
	    var href = vm.lectus.links.bookings.href;
	    //console.log(vm.query, arguments);
	    var sort = vm.query.order.indexOf("-") === 0 ? vm.query.order.replace("-", "") + ">" : vm.query.order + '<';
	    var q = vm.query;
	    console.log(vm.query, arguments);
	    console.log("vm.query", vm.query);

	    vm.loadingPromise = $http.get(href, {
	      params: {
	        property: query.property,
	        $limit: vm.query.limit,
	        $skip: vm.query.page * vm.query.limit - vm.query.limit,
	        $sort: sort,
	        name: isNaN(vm.query.customer) ? vm.query.customer || undefined : undefined,
	        number: !isNaN(vm.query.customer) ? vm.query.customer : undefined,

	        checkin: moment().format('YYYY-MM-DD')
	        //createdOn: moment(q.createdOn||null).isValid() ? moment().format('YYYY-MM-DD') : undefined
	      }
	    }).then(function (res) {
	      $log.debug('properties', res.data);
	      loadStats(res.data.items);

	      angular.extend(vm, {
	        items: res.data.items,
	        total: res.data.total
	      });
	    });
	  }

	  function searchBookings(cr) {
	    //console.log(vm.propertyCtrl.property);
	    //const href = vm.propertyCtrl.property.links.bookings.href;
	    var href = vm.lectus.links.bookings.href;
	    console.log("cr", cr);
	    var sort = vm.query.order.indexOf("-") === 0 ? vm.query.order.replace("-", "") + ">" : vm.query.order + '<';
	    var q = vm.query;

	    console.log(vm.query, arguments);
	    console.log("vm.query", vm.query);

	    vm.loadingPromise = $http.get(href, {
	      params: {
	        property: query.property,
	        $limit: vm.query.limit,
	        $skip: vm.query.page * vm.query.limit - vm.query.limit,
	        $sort: sort,
	        name: isNaN(vm.query.customer) ? vm.query.customer || undefined : undefined,
	        number: !isNaN(vm.query.customer) ? vm.query.customer : undefined,

	        checkin: moment(q.checkin || null).isValid() ? moment(q.checkin).format('YYYY-MM-DD') : undefined,
	        createdOn: moment(cr || null).isValid() ? moment(cr).format('YYYY-MM-DD') : undefined
	        // checkin: vm.filter && moment(q.checkin||null).isValid() ? moment(q.checkin).format('YYYY-MM-DD') : undefined,
	        // createdOn: vm.filter && moment(cr||null).isValid() ? moment(cr).format('YYYY-MM-DD') : undefined
	      }
	    }).then(function (res) {
	      $log.debug('properties', res.data);
	      loadStats(res.data.items);
	      angular.extend(vm, {
	        items: res.data.items,
	        total: res.data.total
	      });
	    });
	  }

	  function showBooking(b) {
	    $state.go(vm.bookingViewState, { booking: b.number });
	  }

	  function loadStats(items) {
	    console.log("vm.items.length ", items.length);

	    var smm = 0;
	    var pay = 0;
	    // console.log("vm.items.length ", vm.items.length);

	    for (var i = 0; i < items.length; i++) {
	      console.log("items[i].items.length ", items[i].items.length);

	      for (var j = 0; j < items[i].items.length; j++) {

	        console.log("summ", parseFloat(items[i].items[j].total));

	        smm = smm + parseFloat(items[i].items[j].total);
	        if (items[i].payments != null) {
	          var objPay = JSON.parse(items[i].payments[0]);
	          var rp = Number(objPay.amount);
	          pay = pay + parseFloat(rp);
	          // pay=pay+parseFloat(items[i].items[j].payments[0].amount);
	        }
	      }
	    }
	    vm.summ = smm;
	    vm.paymnt = pay;
	    vm.rest = smm - pay;
	    console.log("summ", vm.summ);
	  }
	}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	'use strict';

	routes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';

	  //$urlRouterProvider.when('/home', '/home/index');

	  var resolveLectusApi = function resolveLectusApi(lectusApi) {
	    "ngInject";

	    return lectusApi;
	  };
	  resolveLectusApi.$inject = ["lectusApi"];

	  // State
	  $stateProvider.state('bookings', {
	    url: '/bookings',
	    component: 'bookingList',
	    resolve: {
	      lectus: resolveLectusApi,
	      bookingViewState: function bookingViewState() {
	        return 'property.booking';
	      },
	      bookingCreateState: function bookingCreateState() {
	        return 'property.createBooking';
	      }

	    }
	  });

	  // .state('bookingsOnHold', {
	  //   url: '/bookings-on-hold',
	  //   component: 'bookingOnHoldList',
	  //   resolve: {
	  //     lectus: resolveLectusApi
	  //   }
	  // });
	}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(53);

	var _component2 = _interopRequireDefault(_component);

	var _component3 = __webpack_require__(54);

	var _component4 = _interopRequireDefault(_component3);

	var _component5 = __webpack_require__(56);

	var _component6 = _interopRequireDefault(_component5);

	var _routes = __webpack_require__(57);

	var _routes2 = _interopRequireDefault(_routes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusRequests', ['ui.router', 'lectusApi', 'dndLists']).component(_component2.default.name, _component2.default).component(_component4.default.name, _component4.default).component(_component6.default.name, _component6.default).config(_routes2.default);

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	"use strict";

	RequestListCtrl.$inject = ["$log", "$state", "$scope", "$mdDialog", "$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "requestList",
	  controller: RequestListCtrl,
	  templateUrl: 'app/requests/list/template.html',
	  bindings: {
	    lectus: "<",
	    requestViewState: "<"
	  }
	};


	function RequestListCtrl($log, $state, $scope, $mdDialog, $http) {
	  "ngInject";

	  var vm = this;
	  var query = {
	    customer: '',
	    limit: 25,
	    order: '-createdOn',
	    page: 1
	  };

	  vm.loadBooking = loadBookings;

	  vm.$onInit = function () {
	    // only load property bookings
	    if (vm.propertyCtrl) {
	      query.property = vm.propertyCtrl.property.code;
	    }
	    angular.extend(vm, {
	      customerFilterOptions: {
	        debounce: 500
	      },
	      query: query,
	      loadBookings: loadBookings,
	      showBooking: showBooking
	    });
	    $scope.$watch(function () {
	      return vm.query.customer;
	    }, onSearchChange, true);

	    loadBookings();
	  };

	  function onSearchChange(newValue, oldValue) {
	    if (newValue === oldValue) {
	      return;
	    }
	    var bookmark = vm.query.page;
	    if (!oldValue) {
	      bookmark = vm.query.page;
	    }

	    if (newValue !== oldValue) {
	      vm.query.page = 1;
	    }
	    if (!newValue) {
	      vm.query.page = bookmark;
	    }
	    loadBookings();
	  }

	  function loadBookings() {
	    //const href = vm.propertyCtrl.property.links.bookings.href;
	    var href = vm.lectus.links['bookings-on-hold'].href;
	    $log.debug(vm.query, arguments);
	    var sort = vm.query.order.indexOf("-") === 0 ? vm.query.order.replace("-", "") + ">" : vm.query.order + '<';
	    var q = vm.query;

	    $log.debug(vm.query.checkin);

	    vm.loadingPromise = $http.get(href, {
	      params: {
	        $limit: q.limit,
	        $skip: q.page * q.limit - q.limit,
	        $sort: sort,
	        property: query.property,
	        name: isNaN(q.customer) ? q.customer || undefined : undefined,
	        number: !isNaN(q.customer) ? q.customer : undefined,
	        checkin: vm.filter && moment(q.checkin || null).isValid() ? moment(q.checkin).format('YYYY-MM-DD') : undefined,
	        createdOn: vm.filter && moment(q.createdOn || null).isValid() ? moment(q.createdOn).format('YYYY-MM-DD') : undefined,
	        propertyName: vm.filter && q.propertyName ? q.propertyName : undefined
	      }
	    }).then(function (res) {
	      angular.extend(vm, {
	        items: res.data.items,
	        total: res.data.total
	      });
	    });
	  }

	  function showBooking(b) {
	    $log.debug(b);
	    $state.go(vm.requestViewState, { property: b.property.code, request: b.number });
	  }
	}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	RequestViewCtrl.$inject = ["$log", "$state", "$scope", "$mdDialog", "$http", "$q", "datasets"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _statuses = __webpack_require__(55);

	exports.default = {
	  name: "requestView",
	  controller: RequestViewCtrl,
	  templateUrl: 'app/requests/view/template.html',
	  bindings: {
	    lectus: "<",
	    bookingNumber: "<"
	  },
	  require: {
	    propertyCtrl: '?^propertyContainer'
	  }
	};


	function RequestViewCtrl($log, $state, $scope, $mdDialog, $http, $q, datasets) {
	  "ngInject";

	  var vm = this;

	  vm.STATUS = _statuses.STATUS;
	  vm.statusUI = _statuses.statusUI;

	  vm.$onInit = function () {
	    vm.propertyCtrl.property; // do struff

	    vm.currency = vm.propertyCtrl.property.currency;
	    datasets.bindSets(["boards"], vm, true);
	    loadBooking(vm.bookingNumber).then(function (booking) {
	      vm.propertyCtrl.setBreadcrumb([{ label: 'Demandes de réservations', href: $state.href("property.requests") }, { label: booking.number }]);
	    });
	  };

	  vm.acceptRequest = function () {
	    saveDecision(_statuses.STATUS.ACCEPTED).then(acceptSucceeded, acceptFailed);
	  };

	  vm.rejectRequest = function () {
	    saveDecision(_statuses.STATUS.REJECTED).then(rejectSucceeded, rejectFailed);
	  };

	  function saveDecision(status) {
	    return $http.put(vm.booking.links.self.href, {
	      number: vm.booking.number,
	      status: status
	    });
	  }

	  function acceptSucceeded() {
	    vm.booking.status = _statuses.STATUS.ACCEPTED;
	    showAlert("Accord enregistré.", "Le client sera notifié sous peu.");
	  }

	  function acceptFailed() {
	    showAlert("Erreur", "Impossible d'enregistrer l'accord.");
	  }

	  function rejectSucceeded() {
	    vm.booking.status = _statuses.STATUS.REJECTED;
	    showAlert("Rejet enregistré.", "Le client sera notifié sous peu.");
	  }
	  function rejectFailed() {
	    showAlert("Erreur", "Impossible d'enregistrer le rejet.");
	  }

	  function showAlert(title, textContent) {
	    var alert = $mdDialog.alert({
	      title: title,
	      textContent: textContent,
	      ok: 'Close'
	    });
	    return $mdDialog.show(alert).then(function () {
	      alert = undefined;
	    });
	  }

	  function loadBooking(number) {
	    //const href = vm.propertyCtrl.property.links.requests.href;
	    var href = vm.lectus.links['bookings-on-hold'].href;
	    return vm.loadingPromise = $http.get(href + "/" + number).then(function (res) {
	      $log.debug('properties', res.data);
	      vm.booking = res.data;
	      vm.booking.total = res.data.items.reduce(function (sum, item) {
	        return sum + item.total;
	      }, 0);
	      return vm.booking;
	    });
	  }
	}

	function BookingCCCtrl($mdDialog, cc) {
	  this.cc = cc;
	  this.close = function () {
	    $mdDialog.hide();
	  };
	}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	"use strict";

	module.exports = {
	    statusUI: [{
	        label: "void", color: "#FF5722",
	        icon: "radio_button_unchecked"
	    }, {
	        label: "Option", color: "#FF5722",
	        icon: "av_timer"
	    }, {
	        label: "Expirée", color: "rgba(0,0,0,0.54)",
	        icon: "av_timer"
	    }, {
	        label: "Confirmé", color: "#FF5722",
	        icon: "check"
	    }, {
	        label: "Annulé", color: "#FF5722",
	        icon: "remove_circle"
	    }, {
	        label: "No show", color: "#FF5722",
	        icon: "help_outline"
	    }, {
	        label: "En attente", color: "#FF9800",
	        icon: "pause_circle_outline"
	    }, {
	        label: "Acceptée", color: "#4CAF50",
	        icon: "check_circle_outline"
	    }, {
	        label: "Rejetée", color: "#F44336",
	        icon: "highlight_off"
	    }],
	    STATUS: {
	        VOID: 0,
	        HOLD: 1,
	        EXPIRED: 2,
	        CONFIRMED: 3,
	        CANCELED: 4,
	        NO_SHOW: 5,
	        REQUESTED: 6,
	        ACCEPTED: 7,
	        REJECTED: 8
	    }
	};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PropertyRequestListCtrl.$inject = ["$log", "$state", "$scope", "$mdDialog", "$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _statuses = __webpack_require__(55);

	exports.default = {
	  name: "propertyRequestList",
	  controller: PropertyRequestListCtrl,
	  templateUrl: 'app/requests/property-list/template.html',
	  bindings: {
	    lectus: "<",
	    requestViewState: "<"
	  },
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PropertyRequestListCtrl($log, $state, $scope, $mdDialog, $http) {
	  "ngInject";

	  var vm = this;
	  var query = {
	    customer: '',
	    limit: 25,
	    order: 'createdOn',
	    page: 1
	  };

	  vm.statusLabels = _statuses.statusLabels;
	  vm.statusIcons = _statuses.statusIcons;
	  vm.statusUI = _statuses.statusUI;
	  vm.loadBooking = loadBookings;

	  vm.$onInit = function () {
	    // only load property bookings
	    if (vm.propertyCtrl) {
	      query.property = vm.propertyCtrl.property.code;
	      vm.propertyCtrl.setBreadcrumb([{ label: 'Demandes de réservattion' }]);
	    }

	    angular.extend(vm, {
	      customerFilterOptions: {
	        debounce: 500
	      },
	      query: query,
	      loadBookings: loadBookings,
	      showBooking: showBooking
	    });
	    $scope.$watch(function () {
	      return vm.query.customer;
	    }, onSearchChange);

	    loadBookings();
	  };

	  function onSearchChange(newValue, oldValue) {
	    if (newValue === oldValue) {
	      return;
	    }
	    var bookmark = vm.query.page;
	    if (!oldValue) {
	      bookmark = vm.query.page;
	    }

	    if (newValue !== oldValue) {
	      vm.query.page = 1;
	    }
	    if (!newValue) {
	      vm.query.page = bookmark;
	    }
	    loadBookings();
	  }

	  function loadBookings() {
	    //console.log(vm.propertyCtrl.property);
	    //const href = vm.propertyCtrl.property.links.bookings.href;
	    var href = vm.lectus.links['bookings-on-hold'].href;
	    //console.log(vm.query, arguments);
	    var sort = vm.query.order.indexOf("-") === 0 ? vm.query.order.replace("-", "") + ">" : vm.query.order + '<';

	    vm.loadingPromise = $http.get(href, {
	      params: {
	        property: query.property,
	        limit: vm.query.limit,
	        $skip: vm.query.page * vm.query.limit - vm.query.limit,
	        $sort: sort, //,
	        name: isNaN(vm.query.customer) ? vm.query.customer || undefined : undefined,
	        number: !isNaN(vm.query.customer) ? vm.query.customer : undefined
	      }
	    }).then(function (res) {
	      $log.debug('properties', res.data);
	      angular.extend(vm, {
	        items: res.data.items,
	        total: res.data.total
	      });
	    });
	  }

	  function showBooking(b) {
	    $state.go(vm.requestViewState, { request: b.number });
	  }
	}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	'use strict';

	routes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';

	  var resolveLectusApi = function resolveLectusApi(lectusApi) {
	    "ngInject";

	    return lectusApi;
	  };
	  resolveLectusApi.$inject = ["lectusApi"];

	  // State
	  $stateProvider.state('requests', {
	    url: '/requests',
	    component: 'requestList',
	    resolve: {
	      lectus: resolveLectusApi,
	      requestViewState: function requestViewState() {
	        return 'property.request';
	      }
	    }
	  });
	}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(59);

	var _component2 = _interopRequireDefault(_component);

	var _routes = __webpack_require__(60);

	var _routes2 = _interopRequireDefault(_routes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusStopSales', ['ui.router', 'lectusApi', 'dndLists']).component(_component2.default.name, _component2.default)

	//.component(propertyRequestListComp.name,propertyRequestListComp)
	.config(_routes2.default);
	// .config(function productRoutes($stateProvider) {
	//     "ngInject";
	//     // State
	//     $stateProvider
	//     .state('property.stopSales', {
	//         url: '/stopsales',
	//         component: 'stopSales',
	//         resolve:{
	//           lectus: resolveLectusApi,
	//           requestViewState: () => 'property.stopSales'
	//         }
	//        })
	//        .state('property.stopSalesEdit', {
	//          url: '/stopsales/:stopsale/edit',
	//          component: 'stopSalesEdit',
	//          resolve: {
	//          discountCode: function($stateParams) {
	//             'ngInject';
	//             return $stateParams.stopSales;
	//           }
	//          }
	//       })
	//     })


	//import propertyRequestListComp from './property-list/component';

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	StopSalestCtrl.$inject = ["User", "$log", "$state", "$q", "$scope", "datasets", "$mdDialog", "$http", "discountsHelper"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moment = __webpack_require__(10);

	exports.default = {
	  name: "stopSales",
	  controller: StopSalestCtrl,
	  templateUrl: 'app/stop-sales/list/template.html',
	  bindings: {
	    lectus: "<",
	    requestViewState: "<",
	    discountCode: "<"

	  },
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function StopSalestCtrl(User, $log, $state, $q, $scope, datasets, $mdDialog, $http, discountsHelper) {
	  "ngInject";

	  this.myDate = new Date();

	  this.minDate = new Date(this.myDate.getFullYear(), this.myDate.getMonth(), this.myDate.getDate());

	  var vm = this;
	  var query = {
	    customer: '',
	    limit: 25,
	    order: '-createdOn',
	    page: 1
	  };

	  var typestp = { 0: "Hotel", 1: "Base Tarifaire", 2: "Unit", 3: "Pension" };
	  var typestp1 = ["Hotel", "Base Tarifaire", "Unit", "Pension"];

	  angular.extend(vm, {
	    $onInit: init,
	    // copy: copy,
	    loadstopsales: loadstopsales,
	    remove: remove,
	    createstopsales: createstopsales,
	    edit: edit,
	    stopSalesStatus: stopSalesStatus,
	    applyDateFilter: applyDateFilter,
	    clearDateFilter: clearDateFilter
	    //mindate:mindate

	  });

	  // function mindate() {
	  //   var now = new Date();
	  //   return new Date(
	  //     now.getFullYear() - 2,
	  //     now.getMonth(),
	  //     now.getDate()
	  //   );
	  // }


	  function createstopsales(stpsls) {
	    //if(stpsls.typeCode==null) {stpsls.typeCode=vm.propertyCtrl.property.items[0].property }


	    var data = {
	      type: typestp1[stpsls.type],
	      typeCode: stpsls.typecode,
	      debut: dateAsString(stpsls.debut),
	      fin: dateAsString(stpsls.fin),
	      //  debut: moment(stpsls.debut).format("YYYY-MM-DD"),
	      //  fin: moment(stpsls.fin).format("YYYY-MM-DD"),
	      description: stpsls.description

	    };
	    postStopSales(data);
	  }

	  function postStopSales(stopsales) {
	    $log.debug('link', vm.propertyCtrl.property.links);

	    //var href = "http://beds-api.fractalite.com/properties/2/stop-sales";

	    return $http.post(vm.propertyCtrl.property.links["stop-sales"].href, stopsales).then(function (res) {
	      $log.debug('created', res.data);
	      $scope.$emit("stopsalesAdded", res.data);
	    }, function () {
	      $log.error(arguments);
	      // return $q.reject()
	    }).then(function () {
	      return $state.reload();
	    });
	  }

	  function dateAsString(d) {
	    return d ? moment(d).format('YYYY-MM-DD') : null;
	  }

	  function toRange(start, end, open) {
	    var str = ["[", start, ","];
	    if (open) {
	      str.push(")");
	    } else {
	      str.push(end, "]");
	    }
	    return str.join("");
	  }

	  function loadstopsales() {
	    var _arguments = arguments;


	    return $http.get(vm.propertyCtrl.property.links["stop-sales"].href, {
	      headers: {
	        'accept-language': ''
	      }
	    }).then(function (res) {
	      $log.debug('stopsales loaded', res.data);
	      vm.stopsaless = res.data;
	      //vm.discount = discountsHelper.parse(res.data);
	    }, function () {
	      $log.debug('error loading stopsales', _arguments);
	    });
	  }

	  function edit($event, stopsales) {
	    var promise;
	    promise = $http({
	      method: "PUT",
	      url: stopsales.links.self.href,
	      headers: {
	        "Content-Language": "**"
	      },
	      data: _.pick(stopsales, ['code', 'type', 'description', 'type_code', 'debut', 'fin', 'property'])
	    });
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }

	  function init() {

	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });
	    var propCtrl = vm.propertyCtrl;
	    load();
	    var p1 = propCtrl.get('units').then(function (collection) {
	      return vm.units = _.keyBy(collection.items, "code");
	    });

	    // .then(collection => $q.all(collection.items.map(loadUnitProducts)))
	    // .then(units => vm.units = units);
	    var p2 = propCtrl.get('rate-bases').then(function (collection) {
	      return vm.rateBases = _.keyBy(collection.items, "code");
	    });
	    var p3 = datasets.bindSets(["boards", "unit-types"], vm, true);
	    var p4 = propCtrl.get('stop-sales').then(function (stpsales) {
	      vm.stpsales = stpsales;
	      //vm.filteredStopSales=stpsales.items;
	      vm.filteredStopSales = stpsales.items.sort(function (a, b) {
	        return new Date(a.audit.createdOn) - new Date(b.audit.createdOn);
	      });
	    });

	    propCtrl.get("amenities").then(function (amenities) {
	      vm._propertyAmenities = amenities.items;
	      vm.propertyAmenities = amenities.items.map(function (a) {
	        return a.amenity;
	      });
	      vm.permissions = amenities.permissions;
	    });
	    datasets.get("amenities").then(function (collection) {
	      vm.options = {
	        property: collection.items.filter(function (a) {
	          return a.property;
	        }),
	        unit: collection.items.filter(function (a) {
	          return a.unit;
	        }),
	        rate: collection.items.filter(function (a) {
	          return a.rate;
	        })
	      };
	    });
	  }

	  function load() {
	    vm.propertyCtrl.get("stop-sales").then(function (collection) {
	      vm.items = collection.items;
	      vm.links = collection.links;
	    });
	  }

	  function loadUnitProducts(unit) {
	    return $http.get(unit.links.products.href).then(function (res) {
	      unit.products = res.data.items;
	      return unit;
	    });
	  }

	  function productsGrid(unit) {
	    if (unit.all) {
	      return { unit: unit };
	    }
	    var rateBases = _.uniq(unit.products.map(function (p) {
	      return p.rateBasis;
	    }));
	    var occupancies = _.uniq(unit.products.map(function (p) {
	      return p.occupancy;
	    }));
	    var boards = _.uniq(unit.products.map(function (p) {
	      return p.board;
	    }));
	    // build the grid
	    var grid = rateBases.map(function (rateBasis) {
	      return occupancies.map(function (occupancy) {
	        return boards.map(function (board) {
	          return _.some(unit.products, { rateBasis: rateBasis, board: board, occupancy: occupancy });
	        });
	      });
	    });
	    return {
	      unit: unit,
	      // base: {board: _.min(boards)},
	      rateBases: rateBases,
	      occupancies: occupancies,
	      boards: boards,
	      grid: grid
	    };
	  }

	  $scope.minDate = function () {
	    var now = new Date();
	    return new Date(now.getFullYear() - 2, now.getMonth(), now.getDate());
	  };

	  /*function remove($event,stpsls) {
	     var confirm = $mdDialog.confirm()
	      .title('Etes-vous sûr de vouloir supprimer ?')
	      .textContent('Cette opération est irreversible.')
	      .ariaLabel('Supression de stopsales')
	      .targetEvent($event)
	      .ok('Supprimer')
	      .cancel('Garder');
	       $log.debug('removeee', stpsls.links.self.href);
	     $mdDialog.show(confirm)  
	   
	      .then(() => $http.delete(stpsls.links.self.href))
	     
	      .then(() => $state.reload());
	  }*/

	  function remove($event, stpsls) {
	    var confirm = $mdDialog.confirm().title('Etes-vous sûr de vouloir supprimer ?').textContent('Cette opération est irreversible.').ariaLabel('Supression de stopsales').targetEvent($event).ok('Supprimer').cancel('Garder');

	    $mdDialog.show(confirm).then(function () {
	      return $http.delete(stpsls.links.self.href);
	    }).then(function () {
	      // 1️⃣ Remove item locally
	      vm.stpsales.items = vm.stpsales.items.filter(function (item) {
	        return item !== stpsls;
	      });

	      // 2️⃣ Reapply existing filters
	      applyDateFilter(vm.filterstopsales.filterStartDate, vm.filterstopsales.filterEndDate, vm.filterstopsales.selectedRoomType);
	    });
	  }

	  function decode(discount) {
	    var decoded = discountsHelper.parse(discount);
	    decoded.units = uniqueUnits(discount.products, vm.units);
	    decoded.unitsGrid = decoded.units.map(productsGrid);
	    /*
	    if (copy.products.length === u.products.length) {
	      u.all = true;
	    }
	    else {
	      productsGrid(copy)
	    }
	    */
	    return decoded;
	    /*
	    return {
	      code: discount.code,
	      reference: discount.reference,
	      label: discount.label,
	      booking: {
	        period: parseBookingPeriod(discount.booking.period),
	        advance: parseIntRange(discount.booking.advance)
	      },
	      stay: {
	        period: parseStayPeriod(discount.stay.period),
	        length: parseIntRange(discount.stay.length)
	      },
	      cancellation: discount.cancellation,
	      payment: discount.payment,
	      rule: discount.rule,
	      units: uniqueUnits(discount.products, vm.units)
	    }*/
	  }

	  function stopSalesStatus(stopsales) {
	    var promise;

	    console.log("ss", stopsales);
	    promise = $http({
	      method: "PUT",
	      url: stopsales.links.self.href,
	      headers: {
	        "Content-Language": "**"
	      },
	      data: _.pick(stopsales, ['code', 'type', 'description', 'type_code', 'debut', 'fin', 'property', 'status'])
	    });
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	  }

	  function uniqueUnits(productCodes, units) {
	    return units.map(function (u) {
	      var copy = _.pick(u, ["code", "name", "type"]);
	      copy.products = u.products.filter(function (p) {
	        return productCodes.includes(p.code);
	      });
	      copy.rateBases = _.uniq(copy.products.map(function (p) {
	        return p.rateBasis;
	      }));
	      if (copy.products.length === u.products.length) {
	        copy.all = true;
	      }
	      return copy;
	    }).filter(function (uCopy) {
	      return uCopy.products.length > 0;
	    });
	  }

	  vm.filteredStopSales = [];
	  // will store filtered results

	  function applyDateFilter(filterStartDate, filterEndDate, selectedRoomType) {
	    console.log("in filter");
	    // const start = vm.filterStartDate ? new Date(vm.filterStartDate) : null;
	    //const end = vm.filterEndDate ? new Date(vm.filterEndDate) : null;
	    var start = filterStartDate ? new Date(filterStartDate) : null;
	    var end = filterEndDate ? new Date(filterEndDate) : null;
	    var roomType = selectedRoomType || "";

	    vm.filteredStopSales = vm.stpsales.items.filter(function (r) {
	      var debut = new Date(r.debut);
	      var fin = new Date(r.fin);

	      // Date filter
	      var matchDate = true;
	      if (start && end) matchDate = debut >= start && fin <= end;else if (start) matchDate = fin >= start;else if (end) matchDate = debut <= end;

	      // Room type filter (only for type==2 i.e., chambre)
	      var matchRoom = true;
	      if (roomType) {

	        matchRoom = r.type == 'Unit' && r.typeCode == roomType;
	      }

	      return matchDate && matchRoom;
	    });
	    console.log("filteredStopSales::", vm.filteredStopSales);
	  };

	  function clearDateFilter() {
	    vm.filterstopsales.filterStartDate = null;
	    vm.filterstopsales.filterEndDate = null;
	    vm.filterstopsales.selectedRoomType = null;
	    vm.filterstopsales.filteredOnRequests = angular.copy(vm.onRequests.items);
	  };
	}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	'use strict';

	routes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';

	  var resolveLectusApi = function resolveLectusApi(lectusApi) {
	    "ngInject";

	    return lectusApi;
	  };
	  resolveLectusApi.$inject = ["lectusApi"];

	  // State
	  $stateProvider.state('property.stopSales', {
	    url: '/stopsales',
	    component: 'stopSales',
	    resolve: {
	      lectus: resolveLectusApi,
	      requestViewState: function requestViewState() {
	        return 'property.stopSales';
	      }
	    }
	  })
	  //  .state('property.stopSalesEdit', {
	  //    url: '/stopsales/:stopsale/edit',
	  //    component: editComp.name,
	  //    resolve: {
	  //    discountCode: function($stateParams) {
	  //       'ngInject';
	  //       return $stateParams.stopSales;
	  //     }
	  //    }
	  // })
	  ;
	}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(62);

	var _component2 = _interopRequireDefault(_component);

	var _routes = __webpack_require__(63);

	var _routes2 = _interopRequireDefault(_routes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusOnRequest', ['ui.router', 'lectusApi', 'dndLists']).component(_component2.default.name, _component2.default)

	//.component(propertyRequestListComp.name,propertyRequestListComp)
	.config(_routes2.default);
	// .config(function productRoutes($stateProvider) {
	//     "ngInject";
	//     // State
	//     $stateProvider
	//     .state('property.stopSales', {
	//         url: '/stopsales',
	//         component: 'stopSales',
	//         resolve:{
	//           lectus: resolveLectusApi,
	//           requestViewState: () => 'property.stopSales'
	//         }
	//        })
	//        .state('property.stopSalesEdit', {
	//          url: '/stopsales/:stopsale/edit',
	//          component: 'stopSalesEdit',
	//          resolve: {
	//          discountCode: function($stateParams) {
	//             'ngInject';
	//             return $stateParams.stopSales;
	//           }
	//          }
	//       })
	//     })


	//import propertyRequestListComp from './property-list/component';

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	OnRequestCtrl.$inject = ["User", "$log", "$state", "$q", "$scope", "datasets", "$mdDialog", "$http", "discountsHelper"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moment = __webpack_require__(10);

	exports.default = {
	  name: "onRequest",
	  controller: OnRequestCtrl,
	  templateUrl: 'app/on-request/list/template.html',
	  bindings: {
	    lectus: "<",
	    requestViewState: "<",
	    discountCode: "<"

	  },
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function OnRequestCtrl(User, $log, $state, $q, $scope, datasets, $mdDialog, $http, discountsHelper) {
	  "ngInject";

	  this.myDate = new Date();

	  this.minDate = new Date(this.myDate.getFullYear(), this.myDate.getMonth(), this.myDate.getDate());

	  var vm = this;

	  var query = {
	    customer: '',
	    limit: 25,
	    order: '-createdOn',
	    page: 1
	  };

	  var typestp = { 0: "Hotel", 1: "Base Tarifaire", 2: "Unit", 3: "Pension" };
	  var typestp1 = ["Hotel", "Base Tarifaire", "Unit", "Pension"];

	  angular.extend(vm, {
	    $onInit: init,
	    // copy: copy,
	    loadonrequests: loadonrequests,
	    remove: remove,
	    createonrequests: createonrequests,
	    edit: edit,
	    clearDateFilter: clearDateFilter,
	    applyDateFilter: applyDateFilter,
	    //filteronrequests:filteronrequests,
	    filteredOnRequests: []

	    //mindate:mindate

	  });

	  // function mindate() {
	  //   var now = new Date();
	  //   return new Date(
	  //     now.getFullYear() - 2,
	  //     now.getMonth(),
	  //     now.getDate()
	  //   );
	  // }


	  function createonrequests(stpsls) {
	    //if(stpsls.typeCode==null) {stpsls.typeCode=vm.propertyCtrl.property.items[0].property }
	    console.log("createonrequests", stpsls);

	    var data = {
	      type: typestp1[stpsls.type],
	      typeCode: stpsls.typecode,
	      debut: dateAsString(stpsls.debut),
	      fin: dateAsString(stpsls.fin),
	      //  debut: moment(stpsls.debut).format("YYYY-MM-DD"),
	      //  fin: moment(stpsls.fin).format("YYYY-MM-DD"),
	      description: stpsls.description

	    };
	    postStopSales(data);
	  }

	  function postStopSales(stopsales) {
	    $log.debug('link', vm.propertyCtrl.property.links);
	    console.log("vm.propertyCtrl.property.links", vm.propertyCtrl.property.links);
	    console.log("vm.propertyCtrl.property.links", vm.propertyCtrl.property.links["on-requests"].href);

	    //var href = "http://beds-api.fractalite.com/properties/2/stop-sales";

	    return $http.post(vm.propertyCtrl.property.links["on-requests"].href, stopsales).then(function (res) {
	      $log.debug('created', res.data);
	      $scope.$emit("stopsalesAdded", res.data);
	    }, function () {
	      $log.error(arguments);
	      // return $q.reject()
	    }).then(function () {
	      return $state.reload();
	    });
	  }

	  function dateAsString(d) {
	    return d ? moment(d).format('YYYY-MM-DD') : null;
	  }

	  function toRange(start, end, open) {
	    var str = ["[", start, ","];
	    if (open) {
	      str.push(")");
	    } else {
	      str.push(end, "]");
	    }
	    return str.join("");
	  }

	  function loadonrequests() {
	    var _arguments = arguments;


	    return $http.get(vm.propertyCtrl.property.links["on-requests"].href, {
	      headers: {
	        'accept-language': ''
	      }
	    }).then(function (res) {
	      $log.debug('stopsales loaded', res.data);
	      vm.stopsaless = res.data;
	      //vm.discount = discountsHelper.parse(res.data);
	    }, function () {
	      $log.debug('error loading discount', _arguments);
	    });
	  }

	  function edit($event, stopsales) {
	    var promise;
	    promise = $http({
	      method: "PUT",
	      url: stopsales.links.self.href,
	      headers: {
	        "Content-Language": "**"
	      },
	      data: _.pick(stopsales, ['code', 'type', 'description', 'type_code', 'debut', 'fin', 'property'])
	    });
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }

	  function init() {

	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });
	    var propCtrl = vm.propertyCtrl;
	    vm;
	    load();
	    var p1 = propCtrl.get('units').then(function (collection) {
	      return vm.units = _.keyBy(collection.items, "code");
	    });
	    // .then(collection => $q.all(collection.items.map(loadUnitProducts)))
	    // .then(units => {
	    //   console.log("vm.units",units)
	    //   vm.units = units});
	    var p2 = propCtrl.get('rate-bases').then(function (collection) {
	      return vm.rateBases = _.keyBy(collection.items, "code");
	    });
	    var p3 = datasets.bindSets(["boards", "unit-types"], vm, true);
	    var p4 = propCtrl.get('on-requests').then(function (onRequests) {
	      vm.onRequests = onRequests;
	      //vm.filteredOnRequests = onRequests.items;
	      vm.filteredOnRequests = onRequests.items.sort(function (a, b) {
	        return new Date(a.audit.createdOn) - new Date(b.audit.createdOn);
	      });
	    });

	    propCtrl.get("amenities").then(function (amenities) {
	      vm._propertyAmenities = amenities.items;
	      vm.propertyAmenities = amenities.items.map(function (a) {
	        return a.amenity;
	      });
	      vm.permissions = amenities.permissions;
	    });
	    datasets.get("amenities").then(function (collection) {
	      vm.options = {
	        property: collection.items.filter(function (a) {
	          return a.property;
	        }),
	        unit: collection.items.filter(function (a) {
	          return a.unit;
	        }),
	        rate: collection.items.filter(function (a) {
	          return a.rate;
	        })
	      };
	    });
	  }

	  function load() {
	    vm.propertyCtrl.get("on-requests").then(function (collection) {
	      vm.items = collection.items;
	      vm.links = collection.links;
	    });
	  }

	  function loadUnitProducts(unit) {
	    return $http.get(unit.links.products.href).then(function (res) {
	      unit.products = res.data.items;
	      return unit;
	    });
	  }

	  function productsGrid(unit) {
	    if (unit.all) {
	      return { unit: unit };
	    }
	    var rateBases = _.uniq(unit.products.map(function (p) {
	      return p.rateBasis;
	    }));
	    var occupancies = _.uniq(unit.products.map(function (p) {
	      return p.occupancy;
	    }));
	    var boards = _.uniq(unit.products.map(function (p) {
	      return p.board;
	    }));
	    // build the grid
	    var grid = rateBases.map(function (rateBasis) {
	      return occupancies.map(function (occupancy) {
	        return boards.map(function (board) {
	          return _.some(unit.products, { rateBasis: rateBasis, board: board, occupancy: occupancy });
	        });
	      });
	    });
	    return {
	      unit: unit,
	      // base: {board: _.min(boards)},
	      rateBases: rateBases,
	      occupancies: occupancies,
	      boards: boards,
	      grid: grid
	    };
	  }

	  $scope.minDate = function () {
	    var now = new Date();
	    return new Date(now.getFullYear() - 2, now.getMonth(), now.getDate());
	  };

	  /*function remove($event,onRequest) {
	     var confirm = $mdDialog.confirm()
	      .title('Etes-vous sûr de vouloir supprimer ?')
	      .textContent('Cette opération est irreversible.')
	      .ariaLabel('Supression de stopsales')
	      .targetEvent($event)
	      .ok('Supprimer')
	      .cancel('Garder');
	       $log.debug('removeee', onRequest.links.self.href);
	     $mdDialog.show(confirm)  
	   
	      .then(() => $http.delete(onRequest.links.self.href))
	     
	      .then(() => $state.reload());
	  }*/

	  function remove($event, onreq) {
	    var confirm = $mdDialog.confirm().title('Etes-vous sûr de vouloir supprimer ?').textContent('Cette opération est irreversible.').ariaLabel('Supression de onrequest').targetEvent($event).ok('Supprimer').cancel('Garder');

	    $mdDialog.show(confirm).then(function () {
	      return $http.delete(onRequest.links.self.href);
	    }).then(function () {
	      // 1️⃣ Remove item locally
	      vm.onRequest.items = vm.onRequest.items.filter(function (item) {
	        return item !== onreq;
	      });

	      // 2️⃣ Reapply existing filters
	      applyDateFilter(vm.filteronrequests.filterStartDate, vm.filteronrequests.filterEndDate, vm.filteronrequests.selectedRoomType);
	    });
	  }

	  function decode(discount) {
	    var decoded = discountsHelper.parse(discount);
	    decoded.units = uniqueUnits(discount.products, vm.units);
	    decoded.unitsGrid = decoded.units.map(productsGrid);
	    /*
	    if (copy.products.length === u.products.length) {
	      u.all = true;
	    }
	    else {
	      productsGrid(copy)
	    }
	    */
	    return decoded;
	    /*
	    return {
	      code: discount.code,
	      reference: discount.reference,
	      label: discount.label,
	      booking: {
	        period: parseBookingPeriod(discount.booking.period),
	        advance: parseIntRange(discount.booking.advance)
	      },
	      stay: {
	        period: parseStayPeriod(discount.stay.period),
	        length: parseIntRange(discount.stay.length)
	      },
	      cancellation: discount.cancellation,
	      payment: discount.payment,
	      rule: discount.rule,
	      units: uniqueUnits(discount.products, vm.units)
	    }*/
	  }

	  function uniqueUnits(productCodes, units) {
	    return units.map(function (u) {
	      var copy = _.pick(u, ["code", "name", "type"]);
	      copy.products = u.products.filter(function (p) {
	        return productCodes.includes(p.code);
	      });
	      copy.rateBases = _.uniq(copy.products.map(function (p) {
	        return p.rateBasis;
	      }));
	      if (copy.products.length === u.products.length) {
	        copy.all = true;
	      }
	      return copy;
	    }).filter(function (uCopy) {
	      return uCopy.products.length > 0;
	    });
	  }

	  vm.filteredOnRequests = [];
	  // will store filtered results

	  function applyDateFilter(filterStartDate, filterEndDate, selectedRoomType) {
	    console.log("in filter");
	    // const start = vm.filterStartDate ? new Date(vm.filterStartDate) : null;
	    //const end = vm.filterEndDate ? new Date(vm.filterEndDate) : null;
	    var start = filterStartDate ? new Date(filterStartDate) : null;
	    var end = filterEndDate ? new Date(filterEndDate) : null;
	    var roomType = selectedRoomType || "";

	    vm.filteredOnRequests = vm.onRequests.items.filter(function (r) {
	      var debut = new Date(r.debut);
	      var fin = new Date(r.fin);

	      // Date filter
	      var matchDate = true;
	      if (start && end) matchDate = debut >= start && fin <= end;else if (start) matchDate = fin >= start;else if (end) matchDate = debut <= end;

	      // Room type filter (only for type==2 i.e., chambre)
	      var matchRoom = true;
	      if (roomType) {

	        matchRoom = r.type == 'Unit' && r.typeCode == roomType;
	      }

	      return matchDate && matchRoom;
	    });
	    console.log("filteredOnRequests::", vm.filteredOnRequests);
	  };

	  function clearDateFilter() {
	    vm.filteronrequests.filterStartDate = null;
	    vm.filteronrequests.filterEndDate = null;
	    vm.filteronrequests.selectedRoomType = null;
	    vm.filteronrequests.filteredOnRequests = angular.copy(vm.onRequests.items);
	  };
	}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	'use strict';

	routes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';

	  var resolveLectusApi = function resolveLectusApi(lectusApi) {
	    "ngInject";

	    return lectusApi;
	  };
	  resolveLectusApi.$inject = ["lectusApi"];

	  // State
	  $stateProvider.state('property.OnRequest', {
	    url: '/onrequest',
	    component: 'onRequest',
	    resolve: {
	      lectus: resolveLectusApi,
	      requestViewState: function requestViewState() {
	        return 'property.onRequest';
	      }
	    }
	  })
	  //  .state('property.stopSalesEdit', {
	  //    url: '/stopsales/:stopsale/edit',
	  //    component: editComp.name,
	  //    resolve: {
	  //    discountCode: function($stateParams) {
	  //       'ngInject';
	  //       return $stateParams.stopSales;
	  //     }
	  //    }
	  // })
	  ;
	}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(65);

	var _component2 = _interopRequireDefault(_component);

	var _routes = __webpack_require__(66);

	var _routes2 = _interopRequireDefault(_routes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusSeasons', ['ui.router', 'lectusApi', 'dndLists']).component(_component2.default.name, _component2.default)

	//.component(propertyRequestListComp.name,propertyRequestListComp)
	.config(_routes2.default);
	// .config(function productRoutes($stateProvider) {
	//     "ngInject";
	//     // State
	//     $stateProvider
	//     .state('property.stopSales', {
	//         url: '/stopsales',
	//         component: 'stopSales',
	//         resolve:{
	//           lectus: resolveLectusApi,
	//           requestViewState: () => 'property.stopSales'
	//         }
	//        })
	//        .state('property.stopSalesEdit', {
	//          url: '/stopsales/:stopsale/edit',
	//          component: 'stopSalesEdit',
	//          resolve: {
	//          discountCode: function($stateParams) {
	//             'ngInject';
	//             return $stateParams.stopSales;
	//           }
	//          }
	//       })
	//     })


	//import propertyRequestListComp from './property-list/component';

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	SeasonsCtrl.$inject = ["User", "$log", "$state", "$q", "$scope", "datasets", "$mdDialog", "$http", "discountsHelper"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var moment = __webpack_require__(10);

	exports.default = {
	  name: "seasons",
	  controller: SeasonsCtrl,
	  templateUrl: 'app/seasons/list/template.html',
	  bindings: {
	    lectus: "<",
	    requestViewState: "<",
	    discountCode: "<"

	  },
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function SeasonsCtrl(User, $log, $state, $q, $scope, datasets, $mdDialog, $http, discountsHelper) {
	  "ngInject";

	  this.myDate = new Date();

	  this.minDate = new Date(this.myDate.getFullYear(), this.myDate.getMonth(), this.myDate.getDate());

	  var vm = this;
	  var query = {
	    customer: '',
	    limit: 25,
	    order: '-createdOn',
	    page: 1
	  };

	  var typestp = { 0: "Hotel", 1: "Base Tarifaire", 2: "Unit", 3: "Pension" };
	  var typestp1 = ["Hotel", "Base Tarifaire", "Unit", "Pension"];

	  angular.extend(vm, {
	    $onInit: init,
	    // copy: copy,
	    loadSeasons: loadSeasons,
	    remove: remove,
	    createSeasons: createSeasons,
	    edit: edit,
	    addSeasonPeriodRange: addSeasonPeriodRange,
	    removeSeasonsPeriodRange: removeSeasonsPeriodRange
	    //mindate:mindate

	  });

	  // function mindate() {
	  //   var now = new Date();
	  //   return new Date(
	  //     now.getFullYear() - 2,
	  //     now.getMonth(),
	  //     now.getDate()
	  //   );
	  // }


	  function createSeasons(season) {
	    //if(stpsls.typeCode==null) {stpsls.typeCode=vm.propertyCtrl.property.items[0].property }
	    console.log("createonrequests", season);

	    var data = _defineProperty({
	      description: season.description,
	      category: season.season,
	      ranges: season.ranges,
	      debut: dateAsString(season.debut),
	      fin: dateAsString(season.fin)
	    }, "description", season.description);
	    postSeason(data);
	  }

	  function addSeasonPeriodRange(seasons) {
	    // console.log('line...', line)
	    console.log("vm.newRange..", vm.seasonRng);
	    console.log("seasons..", seasons);
	    // console.log("seasons+ranges..", seasons.ranges)

	    if (seasons.ranges == undefined) {
	      seasons.ranges = [];
	    }
	    var newRange = angular.copy(vm.seasonRng);

	    newRange.start = moment(newRange.start).format("YYYY-MM-DD");
	    newRange.end = moment(newRange.end).format("YYYY-MM-DD");

	    var start = moment(newRange.start);
	    var end = moment(newRange.end);
	    if (moment(moment(newRange.start).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid() && moment(moment(newRange.end).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid()) {
	      for (var i = seasons.ranges.length - 1; i >= 0; i--) {
	        var rateFrom = moment(seasons.ranges[i].start);
	        var rateTo = moment(seasons.ranges[i].end);
	        if (start.isSame(rateFrom) || end.isSame(rateTo) || start.isAfter(rateFrom) && start.isBefore(rateTo) || end.isAfter(rateFrom) && end.isBefore(rateTo)) break;
	      }
	      if (i < 0) {
	        seasons.ranges.push(newRange);
	        vm.newRangeBooking = {
	          start: "",
	          end: ""

	        };
	      } else alert("overlap between periods");
	    } else if (moment(moment(newRange.start).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid() == false) alert("select start date");else if (moment(moment(newRange.end).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid() == false) alert("select to date");

	    console.log("vm.basis.seasons.ranges..", seasons.ranges);
	  }

	  function removeSeasonsPeriodRange(seasons, index) {
	    seasons.ranges.splice(index, 1);
	  }

	  function postSeason(season) {
	    $log.debug('link', vm.propertyCtrl.property.links);
	    console.log("vm.propertyCtrl.property.links", vm.propertyCtrl.property.links);
	    console.log("vm.propertyCtrl.property.links", vm.propertyCtrl.property.links["seasons"].href);

	    //var href = "http://beds-api.fractalite.com/properties/2/stop-sales";

	    return $http.post(vm.propertyCtrl.property.links["seasons"].href, season).then(function (res) {
	      $log.debug('created', res.data);
	      $scope.$emit("seasonAdded", res.data);
	    }, function () {
	      $log.error(arguments);
	      // return $q.reject()
	    }).then(function () {
	      return $state.reload();
	    });
	  }

	  function dateAsString(d) {
	    return d ? moment(d).format('YYYY-MM-DD') : null;
	  }

	  function toRange(start, end, open) {
	    var str = ["[", start, ","];
	    if (open) {
	      str.push(")");
	    } else {
	      str.push(end, "]");
	    }
	    return str.join("");
	  }

	  function loadSeasons() {
	    var _arguments = arguments;

	    console.log('property-seasons', vm.propertyCtrl.property.links);
	    return $http.get(vm.propertyCtrl.property.links["property-seasons"].href, {
	      headers: {
	        'accept-language': ''
	      }
	    }).then(function (res) {
	      $log.debug('season loaded', res.data);
	      vm.stopsaless = res.data;
	      //vm.discount = discountsHelper.parse(res.data);
	    }, function () {
	      $log.debug('error loading discount', _arguments);
	    });
	  }

	  function edit($event, stopsales) {
	    var promise;
	    promise = $http({
	      method: "PUT",
	      url: stopsales.links.self.href,
	      headers: {
	        "Content-Language": "**"
	      },
	      data: _.pick(stopsales, ['code', 'category', 'debut', 'fin', 'property'])
	    });
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }

	  function init() {

	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });
	    var propCtrl = vm.propertyCtrl;
	    console.log("propCtrl::", propCtrl);
	    load();
	    var p1 = propCtrl.get('units').then(function (collection) {
	      return vm.units = _.keyBy(collection.items, "code");
	    });
	    // .then(collection => $q.all(collection.items.map(loadUnitProducts)))
	    // .then(units => {
	    //   console.log("vm.units",units)
	    //   vm.units = units});
	    var p2 = propCtrl.get('rate-bases').then(function (collection) {
	      return vm.rateBases = _.keyBy(collection.items, "code");
	    });
	    var p3 = datasets.bindSets(["boards", "unit-types"], vm, true);
	    var p4 = propCtrl.get('seasons').then(function (seasons) {
	      return vm.seasons = seasons;
	    });

	    propCtrl.get("amenities").then(function (amenities) {
	      vm._propertyAmenities = amenities.items;
	      vm.propertyAmenities = amenities.items.map(function (a) {
	        return a.amenity;
	      });
	      vm.permissions = amenities.permissions;
	    });
	    datasets.get("amenities").then(function (collection) {
	      vm.options = {
	        property: collection.items.filter(function (a) {
	          return a.property;
	        }),
	        unit: collection.items.filter(function (a) {
	          return a.unit;
	        }),
	        rate: collection.items.filter(function (a) {
	          return a.rate;
	        })
	      };
	    });
	  }

	  function load() {
	    vm.propertyCtrl.get("seasons").then(function (collection) {
	      vm.items = collection.items;
	      vm.links = collection.links;
	    });
	  }

	  function loadUnitProducts(unit) {
	    return $http.get(unit.links.products.href).then(function (res) {
	      unit.products = res.data.items;
	      return unit;
	    });
	  }

	  function productsGrid(unit) {
	    if (unit.all) {
	      return { unit: unit };
	    }
	    var rateBases = _.uniq(unit.products.map(function (p) {
	      return p.rateBasis;
	    }));
	    var occupancies = _.uniq(unit.products.map(function (p) {
	      return p.occupancy;
	    }));
	    var boards = _.uniq(unit.products.map(function (p) {
	      return p.board;
	    }));
	    // build the grid
	    var grid = rateBases.map(function (rateBasis) {
	      return occupancies.map(function (occupancy) {
	        return boards.map(function (board) {
	          return _.some(unit.products, { rateBasis: rateBasis, board: board, occupancy: occupancy });
	        });
	      });
	    });
	    return {
	      unit: unit,
	      // base: {board: _.min(boards)},
	      rateBases: rateBases,
	      occupancies: occupancies,
	      boards: boards,
	      grid: grid
	    };
	  }

	  $scope.minDate = function () {
	    var now = new Date();
	    return new Date(now.getFullYear() - 2, now.getMonth(), now.getDate());
	  };

	  function remove($event, saeson) {

	    var confirm = $mdDialog.confirm().title('Etes-vous sûr de vouloir supprimer ?').textContent('Cette opération est irreversible.').ariaLabel('Supression de season').targetEvent($event).ok('Supprimer').cancel('Garder');

	    $log.debug('removeee', saeson.links.self.href);

	    $mdDialog.show(confirm).then(function () {
	      return $http.delete(saeson.links.self.href);
	    }).then(function () {
	      return $state.reload();
	    });
	  }

	  function decode(discount) {
	    var decoded = discountsHelper.parse(discount);
	    decoded.units = uniqueUnits(discount.products, vm.units);
	    decoded.unitsGrid = decoded.units.map(productsGrid);
	    /*
	    if (copy.products.length === u.products.length) {
	      u.all = true;
	    }
	    else {
	      productsGrid(copy)
	    }
	    */
	    return decoded;
	    /*
	    return {
	      code: discount.code,
	      reference: discount.reference,
	      label: discount.label,
	      booking: {
	        period: parseBookingPeriod(discount.booking.period),
	        advance: parseIntRange(discount.booking.advance)
	      },
	      stay: {
	        period: parseStayPeriod(discount.stay.period),
	        length: parseIntRange(discount.stay.length)
	      },
	      cancellation: discount.cancellation,
	      payment: discount.payment,
	      rule: discount.rule,
	      units: uniqueUnits(discount.products, vm.units)
	    }*/
	  }

	  function uniqueUnits(productCodes, units) {
	    return units.map(function (u) {
	      var copy = _.pick(u, ["code", "name", "type"]);
	      copy.products = u.products.filter(function (p) {
	        return productCodes.includes(p.code);
	      });
	      copy.rateBases = _.uniq(copy.products.map(function (p) {
	        return p.rateBasis;
	      }));
	      if (copy.products.length === u.products.length) {
	        copy.all = true;
	      }
	      return copy;
	    }).filter(function (uCopy) {
	      return uCopy.products.length > 0;
	    });
	  }
	}

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	'use strict';

	routes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';

	  var resolveLectusApi = function resolveLectusApi(lectusApi) {
	    "ngInject";

	    return lectusApi;
	  };
	  resolveLectusApi.$inject = ["lectusApi"];

	  // State
	  $stateProvider.state('property.Seasons', {
	    url: '/seasons',
	    component: 'seasons',
	    resolve: {
	      lectus: resolveLectusApi,
	      requestViewState: function requestViewState() {
	        return 'property.seasons';
	      }
	    }
	  })
	  //  .state('property.stopSalesEdit', {
	  //    url: '/stopsales/:stopsale/edit',
	  //    component: editComp.name,
	  //    resolve: {
	  //    discountCode: function($stateParams) {
	  //       'ngInject';
	  //       return $stateParams.stopSales;
	  //     }
	  //    }
	  // })
	  ;
	}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(68);

	var _component2 = _interopRequireDefault(_component);

	var _routes = __webpack_require__(69);

	var _routes2 = _interopRequireDefault(_routes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusPropertyCommentsDate', ['ui.router', 'lectusApi', 'dndLists']).component(_component2.default.name, _component2.default)

	//.component(propertyRequestListComp.name,propertyRequestListComp)
	.config(_routes2.default);
	// .config(function productRoutes($stateProvider) {
	//     "ngInject";
	//     // State
	//     $stateProvider
	//     .state('property.stopSales', {
	//         url: '/stopsales',
	//         component: 'stopSales',
	//         resolve:{
	//           lectus: resolveLectusApi,
	//           requestViewState: () => 'property.stopSales'
	//         }
	//        })
	//        .state('property.stopSalesEdit', {
	//          url: '/stopsales/:stopsale/edit',
	//          component: 'stopSalesEdit',
	//          resolve: {
	//          discountCode: function($stateParams) {
	//             'ngInject';
	//             return $stateParams.stopSales;
	//           }
	//          }
	//       })
	//     })


	//import propertyRequestListComp from './property-list/component';

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PropertyCommentsDatesCtrl.$inject = ["$log", "$state", "$q", "$scope", "datasets", "$mdDialog", "$http", "discountsHelper"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moment = __webpack_require__(10);

	exports.default = {
	  name: "propertyCommentsDate",
	  controller: PropertyCommentsDatesCtrl,
	  templateUrl: 'app/comments-prop/list/template.html',
	  bindings: {
	    lectus: "<",
	    requestViewState: "<",
	    discountCode: "<"

	  },
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PropertyCommentsDatesCtrl($log, $state, $q, $scope, datasets, $mdDialog, $http, discountsHelper) {
	  "ngInject";

	  this.myDate = new Date();

	  this.minDate = new Date(this.myDate.getFullYear(), this.myDate.getMonth(), this.myDate.getDate());

	  var vm = this;
	  var query = {
	    customer: '',
	    limit: 25,
	    order: '-createdOn',
	    page: 1
	  };

	  var typestp = { 0: "Hotel", 1: "Base Tarifaire", 2: "Unit", 3: "Pension" };
	  var typestp1 = ["Hotel", "Base Tarifaire", "Unit", "Pension"];

	  angular.extend(vm, {
	    $onInit: init,
	    // copy: copy,
	    loadComment: loadComment,
	    remove: remove,
	    createComment: createComment,
	    edit: edit,
	    commentStatus: commentStatus
	    //mindate:mindate

	  });

	  // function mindate() {
	  //   var now = new Date();
	  //   return new Date(
	  //     now.getFullYear() - 2,
	  //     now.getMonth(),
	  //     now.getDate()
	  //   );
	  // }


	  function createComment(comment) {
	    //if(stpsls.typeCode==null) {stpsls.typeCode=vm.propertyCtrl.property.items[0].property }


	    var data = {
	      type: typestp1[comment.type],
	      typeCode: comment.typecode,
	      debut: dateAsString(comment.debut),
	      fin: dateAsString(comment.fin),
	      //  debut: moment(stpsls.debut).format("YYYY-MM-DD"),
	      //  fin: moment(stpsls.fin).format("YYYY-MM-DD"),
	      description: comment.description,
	      internal: comment.internal,
	      external: comment.external

	    };
	    postComment(data);
	  }

	  function postComment(comment) {
	    $log.debug('link', vm.propertyCtrl.property.links);

	    //var href = "http://beds-api.fractalite.com/properties/2/stop-sales";

	    return $http.post(vm.propertyCtrl.property.links["property-comments-dates"].href, comment).then(function (res) {
	      $log.debug('created', res.data);
	      $scope.$emit("property-comments-datesADD", res.data);
	    }, function () {
	      $log.error(arguments);
	      // return $q.reject()
	    }).then(function () {
	      return $state.reload();
	    });
	  }

	  function dateAsString(d) {
	    return d ? moment(d).format('YYYY-MM-DD') : null;
	  }

	  function toRange(start, end, open) {
	    var str = ["[", start, ","];
	    if (open) {
	      str.push(")");
	    } else {
	      str.push(end, "]");
	    }
	    return str.join("");
	  }

	  function loadComment() {
	    var _arguments = arguments;

	    console.log("property-comments-dates", vm.propertyCtrl.property.links["property-comments-dates"].href);
	    return $http.get(vm.propertyCtrl.property.links["property-comments-dates"].href, {
	      headers: {
	        'accept-language': ''
	      }
	    }).then(function (res) {
	      $log.debug('comments loaded', res.data);
	      vm.comments = res.data;
	      //vm.discount = discountsHelper.parse(res.data);
	    }, function () {
	      $log.debug('error loading Comment', _arguments);
	    });
	  }

	  function edit($event, comment) {
	    var promise;
	    promise = $http({
	      method: "PUT",
	      url: comment.links.self.href,
	      headers: {
	        "Content-Language": "**"
	      },
	      data: _.pick(comment, ['code', 'type', 'description', 'type_code', 'debut', 'fin', 'property'])
	    });
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }

	  function init() {
	    var propCtrl = vm.propertyCtrl;
	    load();
	    console.log("property-comments-dates", vm.propertyCtrl.property.links);

	    var p1 = propCtrl.get('units').then(function (collection) {
	      return vm.units = _.keyBy(collection.items, "code");
	    });

	    // .then(collection => $q.all(collection.items.map(loadUnitProducts)))
	    // .then(units => vm.units = units);
	    var p2 = propCtrl.get('rate-bases').then(function (collection) {
	      return vm.rateBases = _.keyBy(collection.items, "code");
	    });
	    var p3 = datasets.bindSets(["boards", "unit-types"], vm, true);
	    var p4 = propCtrl.get('property-comments-dates').then(function (comment) {
	      return vm.comments = comment;
	    });

	    propCtrl.get("amenities").then(function (amenities) {
	      vm._propertyAmenities = amenities.items;
	      vm.propertyAmenities = amenities.items.map(function (a) {
	        return a.amenity;
	      });
	      vm.permissions = amenities.permissions;
	    });
	    datasets.get("amenities").then(function (collection) {
	      vm.options = {
	        property: collection.items.filter(function (a) {
	          return a.property;
	        }),
	        unit: collection.items.filter(function (a) {
	          return a.unit;
	        }),
	        rate: collection.items.filter(function (a) {
	          return a.rate;
	        })
	      };
	    });
	  }

	  function load() {
	    vm.propertyCtrl.get("property-comments-dates").then(function (collection) {
	      vm.items = collection.items;
	      vm.links = collection.links;
	    });
	  }

	  function loadUnitProducts(unit) {
	    return $http.get(unit.links.products.href).then(function (res) {
	      unit.products = res.data.items;
	      return unit;
	    });
	  }

	  function productsGrid(unit) {
	    if (unit.all) {
	      return { unit: unit };
	    }
	    var rateBases = _.uniq(unit.products.map(function (p) {
	      return p.rateBasis;
	    }));
	    var occupancies = _.uniq(unit.products.map(function (p) {
	      return p.occupancy;
	    }));
	    var boards = _.uniq(unit.products.map(function (p) {
	      return p.board;
	    }));
	    // build the grid
	    var grid = rateBases.map(function (rateBasis) {
	      return occupancies.map(function (occupancy) {
	        return boards.map(function (board) {
	          return _.some(unit.products, { rateBasis: rateBasis, board: board, occupancy: occupancy });
	        });
	      });
	    });
	    return {
	      unit: unit,
	      // base: {board: _.min(boards)},
	      rateBases: rateBases,
	      occupancies: occupancies,
	      boards: boards,
	      grid: grid
	    };
	  }

	  $scope.minDate = function () {
	    var now = new Date();
	    return new Date(now.getFullYear() - 2, now.getMonth(), now.getDate());
	  };

	  function remove($event, comment) {

	    var confirm = $mdDialog.confirm().title('Etes-vous sûr de vouloir supprimer ?').textContent('Cette opération est irreversible.').ariaLabel('Supression de commentaire').targetEvent($event).ok('Supprimer').cancel('Garder');

	    $log.debug('removeee', comment.links.self.href);

	    $mdDialog.show(confirm).then(function () {
	      return $http.delete(comment.links.self.href);
	    }).then(function () {
	      return $state.reload();
	    });
	  }

	  function decode(discount) {
	    var decoded = discountsHelper.parse(discount);
	    decoded.units = uniqueUnits(discount.products, vm.units);
	    decoded.unitsGrid = decoded.units.map(productsGrid);
	    /*
	    if (copy.products.length === u.products.length) {
	      u.all = true;
	    }
	    else {
	      productsGrid(copy)
	    }
	    */
	    return decoded;
	    /*
	    return {
	      code: discount.code,
	      reference: discount.reference,
	      label: discount.label,
	      booking: {
	        period: parseBookingPeriod(discount.booking.period),
	        advance: parseIntRange(discount.booking.advance)
	      },
	      stay: {
	        period: parseStayPeriod(discount.stay.period),
	        length: parseIntRange(discount.stay.length)
	      },
	      cancellation: discount.cancellation,
	      payment: discount.payment,
	      rule: discount.rule,
	      units: uniqueUnits(discount.products, vm.units)
	    }*/
	  }

	  function commentStatus(comment) {
	    var promise;

	    console.log("ss", comment);
	    promise = $http({
	      method: "PUT",
	      url: comment.links.self.href,
	      headers: {
	        "Content-Language": "**"
	      },
	      data: _.pick(comment, ['code', 'type', 'description', 'type_code', 'debut', 'fin', 'property', 'status'])
	    });
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	  }

	  function uniqueUnits(productCodes, units) {
	    return units.map(function (u) {
	      var copy = _.pick(u, ["code", "name", "type"]);
	      copy.products = u.products.filter(function (p) {
	        return productCodes.includes(p.code);
	      });
	      copy.rateBases = _.uniq(copy.products.map(function (p) {
	        return p.rateBasis;
	      }));
	      if (copy.products.length === u.products.length) {
	        copy.all = true;
	      }
	      return copy;
	    }).filter(function (uCopy) {
	      return uCopy.products.length > 0;
	    });
	  }
	}

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	'use strict';

	routes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';

	  var resolveLectusApi = function resolveLectusApi(lectusApi) {
	    "ngInject";

	    return lectusApi;
	  };
	  resolveLectusApi.$inject = ["lectusApi"];

	  // State
	  $stateProvider.state('property.propertyCommentsDate', {
	    url: '/propertycommentsdate',
	    component: 'propertyCommentsDate',
	    resolve: {
	      lectus: resolveLectusApi,
	      requestViewState: function requestViewState() {
	        return 'property.propertyCommentsDate';
	      }
	    }
	  })
	  //  .state('property.stopSalesEdit', {
	  //    url: '/stopsales/:stopsale/edit',
	  //    component: editComp.name,
	  //    resolve: {
	  //    discountCode: function($stateParams) {
	  //       'ngInject';
	  //       return $stateParams.stopSales;
	  //     }
	  //    }
	  // })
	  ;
	}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(71);

	var _component2 = _interopRequireDefault(_component);

	var _component3 = __webpack_require__(72);

	var _component4 = _interopRequireDefault(_component3);

	var _helper = __webpack_require__(73);

	var _helper2 = _interopRequireDefault(_helper);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusPrestations', ["ngAnimate", "ngSanitize", "ngAria", 'ui.router', "ngMaterial", "md.data.table", 'lectusApi', 'dndLists']).component(_component2.default.name, _component2.default).component(_component4.default.name, _component4.default).factory("prestationsHelper", _helper2.default).config(["$stateProvider", function prestationRoutes($stateProvider) {
	  "ngInject";

	  $stateProvider.state('property.prestations', {
	    url: '/prestations',
	    component: _component2.default.name,
	    data: {
	      menu: {
	        rel: 'self',
	        label: 'Prestations',
	        group: 'Tarifs et dispo',
	        position: 4
	      }
	    }
	  }).state('property.prestationEdit', {
	    url: '/prestations/:prestation/edit',
	    component: _component4.default.name,
	    resolve: {
	      prestationCode: ["$stateParams", function prestationCode($stateParams) {
	        'ngInject';

	        return $stateParams.prestation;
	      }]
	    }
	  });
	}]);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PrestationsCtrl.$inject = ["User", "$log", "$state", "$q", "$mdDialog", "$http", "discountsHelper"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moment = __webpack_require__(10);

	exports.default = {
	  name: "prestations",
	  controller: PrestationsCtrl,
	  templateUrl: 'app/prestations/list/template.html',
	  bindings: {
	    lectus: "<",
	    requestViewState: "<",
	    discountCode: "<"

	  },
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PrestationsCtrl(User, $log, $state, $q, $mdDialog, $http, discountsHelper) {
	  "ngInject";

	  var vm = this;
	  var query = {
	    limit: 25,
	    order: 'nom',
	    page: 1
	  };

	  angular.extend(vm, {
	    $onInit: init,
	    query: query,
	    // copy: copy,
	    // loadPrestations: loadPrestations,
	    remove: remove,
	    edit: edit,
	    clone: clone,
	    createPrestation: createPrestation
	    //mindate:mindate

	  });

	  function init() {
	    // vm.propertyCtrl.setBreadcrumb([{ label: 'Préstations' }]);
	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });
	    var propCtrl = vm.propertyCtrl;

	    var p1 = propCtrl.get('prestations').then(function (collection) {
	      collection.items = collection.items.map(function (item) {
	        item.details = false;
	        return item;
	      });
	      vm.prestations = collection.items;
	    });

	    var p2 = propCtrl.get('discounts', {
	      $sort: "bookingPeriod>"
	    }).then(function (collection) {
	      console.log('discounts', collection);
	      angular.extend(vm, {
	        discounts: collection.items.map(function (a) {
	          return a.code;
	        }),
	        _discounts: collection.items.map(decode)
	      });
	    });

	    var p3 = propCtrl.get('units').then(function (collection) {
	      return angular.extend(vm, {
	        units: collection.items.map(function (a) {
	          return a.code;
	        }),
	        _units: collection.items.map(decodeUnit)
	      });
	    });

	    var p4 = propCtrl.get('rate-bases').then(function (collection) {
	      return vm.rateBases = _.keyBy(collection.items, "code");
	    });

	    $q.all([p1, p2, p3, p4]).then(function () {
	      buildDiscountssNames();
	      buildUnitsNames();
	    });

	    setUpToolBar(propCtrl);
	  }

	  function decode(discount) {
	    var decoded = discountsHelper.parse(discount);
	    return decoded;
	  }

	  function decodeUnit(unit) {
	    return unit.name;
	  }

	  function buildOffersNames() {
	    console.log('building...');
	    vm.prestations = vm.prestations.map(function (p) {
	      p.offersNames = [];
	      if (p.offers && angular.isArray(p.offers)) {
	        var index = -1;
	        var length = p.offers == null ? 0 : p.offers.length;
	        while (++index < length) {
	          var offerCode = p.offers[index];
	          var i = vm.offers.indexOf(offerCode);
	          if (i > -1) {
	            var d = vm._discounts[i];
	            p.offersNames.push("Réf." + d.nom);
	          }
	        }
	      }
	      return p;
	    });

	    console.log('vm.prestations...end', vm.prestations);
	  }

	  function buildDiscountssNames() {
	    console.log('building...');
	    vm.prestations = vm.prestations.map(function (p) {
	      p.discountsNames = [];
	      if (p.discounts && angular.isArray(p.discounts)) {
	        var index = -1;
	        var length = p.discounts == null ? 0 : p.discounts.length;
	        while (++index < length) {
	          var discountCode = p.discounts[index];
	          console.log('discount code', discountCode);
	          var i = vm.discounts.indexOf(discountCode);
	          console.log('found..', i);
	          if (i > -1) {
	            var d = vm._discounts[i];
	            console.log('d....', d);
	            p.discountsNames.push("Réf." + d.reference + " " + d.label);
	          }
	        }
	      }
	      return p;
	    });

	    console.log('vm.prestations...end', vm.prestations);
	  }

	  function buildUnitsNames() {
	    //console.log('building...')
	    vm.prestations = vm.prestations.map(function (p) {
	      p.unitsNames = [];
	      if (p.unit && angular.isArray(p.unit)) {
	        var index = -1;
	        var length = p.unit == null ? 0 : p.unit.length;
	        while (++index < length) {
	          var unitCode = p.unit[index];
	          var i = vm.units.indexOf(unitCode);
	          //  console.log('found..', i)
	          if (i > -1) {
	            var name = vm._units[i];
	            //   console.log('name....', name)
	            p.unitsNames.push(name);
	          }
	        }
	      }
	      return p;
	    });

	    // console.log('vm.prestations...end', vm.prestations)
	  }

	  function edit($event, prst) {
	    $state.go("property.prestationEdit", {
	      prestation: prst.code
	    });
	  }

	  function clone($event, prst) {
	    //  prst.clone = true

	    var confirm = $mdDialog.confirm().title('Etes-vous sûr de vouloir dupliquer ?')
	    // .textContent('Cette opération est irreversible.')
	    .ariaLabel('Duplication de prestation').targetEvent($event).ok('Dupliquer').cancel('Annuler');

	    $log.debug('Dupliquer', prst.links.self.href);

	    $mdDialog.show(confirm).then(function () {
	      return createPrestation(prst);
	    }).then(function () {
	      return $state.reload();
	    });
	  }

	  function createPrestation(prestation) {
	    // avoid voilating property_prestations_pkey constraint
	    delete prestation.code;

	    prestation.nom = prestation.nom + '_copie';
	    postPrestation(prestation);
	  }

	  function postPrestation(prestation) {
	    $log.debug('link', vm.propertyCtrl.property.links);

	    //var href = "http://beds-api.fractalite.com/properties/2/stop-sales";

	    return $http.post(vm.propertyCtrl.property.links["prestations"].href, prestation);
	    // .then(function (res) {
	    //   $log.debug('created', res.data);
	    //   $scope.$emit("prestationAdded", res.data);
	    // }, function () {
	    //   $log.error(arguments);
	    //   // return $q.reject()
	    // })
	    // .then(() => $state.reload());
	  }

	  // function loadPrestations() {

	  //   return $http.get(vm.propertyCtrl.property.links["prestations"].href, {
	  //     headers: {
	  //       'accept-language': ''
	  //     }
	  //   })
	  //     .then(res => {
	  //       $log.debug('prestations loaded', res.data);
	  //       vm.prestationss = res.data
	  //       //vm.discount = discountsHelper.parse(res.data);
	  //     }, () => {
	  //       $log.debug('error loading discount', arguments);
	  //     });
	  // }


	  function setUpToolBar(container) {
	    container.setBreadcrumb([{
	      label: "Préstations"
	    }]);

	    var actions = [{
	      label: "ajouter une préstation",
	      icon: "add",
	      href: $state.href("property.prestationEdit", {
	        prestation: "new"
	      })
	    }];

	    container.setActions(actions);
	  }

	  function remove($event, prst) {

	    var confirm = $mdDialog.confirm().title('Etes-vous sûr de vouloir supprimer ?').textContent('Cette opération est irreversible.').ariaLabel('Supression de prestation').targetEvent($event).ok('Supprimer').cancel('Garder');

	    $log.debug('removeee', prst.links.self.href);

	    $mdDialog.show(confirm).then(function () {
	      return $http.delete(prst.links.self.href);
	    }).then(function () {
	      return $state.reload();
	    });
	  }
	}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	PrestationEditCtrl.$inject = ["$scope", "$state", "$log", "$q", "$mdDialog", "$http", "$stateParams", "datasets", "prestationsHelper", "discountsHelper", "$mdToast", "lectusLanguages"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moment = __webpack_require__(10);
	exports.default = {
	  name: 'prestationEdit',
	  controller: PrestationEditCtrl,
	  templateUrl: 'app/prestations/edit/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  },
	  bindings: {
	    prestationCode: "<"
	  }
	};


	function PrestationEditCtrl($scope, $state, $log, $q, $mdDialog, $http, $stateParams, datasets, prestationsHelper, discountsHelper, $mdToast, lectusLanguages) {
	  "ngInject";

	  var vm = this;

	  var prestationType = ["Reduction", "Supplement"];
	  var pricePourcentage = ["Price", "%"];
	  var tarifType = ["Forfait", "Chambre", "Pax"];
	  var tarifApp = ["Sejour", "Nuit"];
	  var option = ["Obligatoire", "Optionelle", "Selected"];
	  // const enfantBebeType = ["Enfant", "Bebe"];
	  var prestationTypologies = ["Offre", "Assurance", "Transfert", "Pensions", "Autres"];

	  var options = {
	    minStartDate: moment().format('YYYY-MM-DD'),
	    minEndDate: null
	  };

	  angular.extend(vm, {
	    $onInit: $onInit,
	    remove: remove,
	    options: options,
	    createPrestation: createPrestation,
	    addChildrenPolicy: addChildrenPolicy,
	    filterSelfOffre: filterSelfOffre,
	    addPeriodRange: addPeriodRange,
	    addReservationPeriodRange: addReservationPeriodRange,
	    blurChildPurchaseprice: blurChildPurchaseprice,
	    blurChildValue: blurChildValue,
	    blurAdultPrice: blurAdultPrice,
	    blurAdultPurchaseprice: blurAdultPurchaseprice,
	    removePeriodRange: removePeriodRange,
	    removeBookingPeriodRange: removeBookingPeriodRange,
	    newRange: {
	      from: "",
	      to: ""
	    },
	    newRangeBooking: {
	      from: "",
	      to: "" //,
	      //transformDate: transformDate
	      // prestationTypologies: prestationTypologies

	    } });

	  this.myDate = new Date();

	  this.minDate = new Date(this.myDate.getFullYear(), this.myDate.getMonth(), this.myDate.getDate());

	  var query = {
	    customer: '',
	    limit: 25,
	    order: '-createdOn',
	    page: 1
	  };

	  // function transformDate(date) {
	  //   return moment(date, "YYYYMMDD").format("YYYY/MM/DD");
	  // }

	  function addPeriodRange() {
	    // console.log('line...', line)
	    console.log("vm.newRange..", vm.newRange);

	    var newRange = angular.copy(vm.newRange);

	    newRange.from = moment(newRange.from).format("YYYY-MM-DD");
	    newRange.to = moment(newRange.to).format("YYYY-MM-DD");

	    var start = moment(newRange.from);
	    var end = moment(newRange.to);
	    if (moment(moment(newRange.from).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid() && moment(moment(newRange.to).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid()) {
	      for (var i = vm.prestation.period.ranges.length - 1; i >= 0; i--) {
	        var rateFrom = moment(vm.prestation.period.ranges[i].from);
	        var rateTo = moment(vm.prestation.period.ranges[i].to);
	        if (start.isSame(rateFrom) || end.isSame(rateTo) || start.isAfter(rateFrom) && start.isBefore(rateTo) || end.isAfter(rateFrom) && end.isBefore(rateTo)) break;
	      }
	      if (i < 0) {
	        vm.prestation.period.ranges.push(newRange);
	        vm.newRange = {
	          from: "",
	          to: ""
	        };
	      } else alert("overlap between periods");
	    } else if (moment(moment(newRange.from).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid() == false) alert("select from date");else if (moment(moment(newRange.to).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid() == false) alert("select to date");
	  }

	  function addReservationPeriodRange() {
	    // console.log('line...', line)
	    console.log("vm.newRange..", vm.newRangeBooking);

	    var newRange = angular.copy(vm.newRangeBooking);

	    newRange.from = moment(newRange.from).format("YYYY-MM-DD");
	    newRange.to = moment(newRange.to).format("YYYY-MM-DD");

	    var start = moment(newRange.from);
	    var end = moment(newRange.to);
	    if (moment(moment(newRange.from).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid() && moment(moment(newRange.to).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid()) {
	      for (var i = vm.prestation.bookingPeriod.ranges.length - 1; i >= 0; i--) {
	        var rateFrom = moment(vm.prestation.bookingPeriod.ranges[i].from);
	        var rateTo = moment(vm.prestation.bookingPeriod.ranges[i].to);
	        if (start.isSame(rateFrom) || end.isSame(rateTo) || start.isAfter(rateFrom) && start.isBefore(rateTo) || end.isAfter(rateFrom) && end.isBefore(rateTo)) break;
	      }
	      if (i < 0) {
	        vm.prestation.bookingPeriod.ranges.push(newRange);
	        vm.newRangeBooking = {
	          from: "",
	          to: ""
	        };
	      } else alert("overlap between periods");
	    } else if (moment(moment(newRange.from).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid() == false) alert("select from date");else if (moment(moment(newRange.to).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid() == false) alert("select to date");

	    console.log("vm.vm.prestation.bookingPeriod.ranges..", vm.prestation.bookingPeriod.ranges);
	  }

	  function filterSelfOffre(offer) {
	    return offer.code !== vm.prestation.code && parseInt(vm.prestation.typology, 10) == 0 && offer.rate == vm.prestation.rate;
	  }

	  function removePeriodRange(index) {
	    vm.prestation.period.ranges.splice(index, 1);
	  }

	  function removeBookingPeriodRange(index) {
	    vm.prestation.bookingPeriod.ranges.splice(index, 1);
	  }

	  function remove($event, index) {
	    var confirm = $mdDialog.confirm().title('Etes-vous sûr de vouloir supprimer ?').textContent('Cette opération est irreversible.').ariaLabel('Supression de prestation').targetEvent($event).ok('Supprimer').cancel('Garder');
	    $mdDialog.show(confirm).then(function () {
	      return vm.prestation.childs.splice(index, 1);
	    });
	  }

	  function decode(discount) {
	    var decoded = discountsHelper.parse(discount);
	    return decoded;
	  }

	  function $onInit() {
	    //const propCtrl = vm.propertyCtrl;
	    console.log('on init...');
	    var propCtrl = vm.propertyCtrl;
	    load();
	    var p1 = propCtrl.get('units').then(function (collection) {
	      return $q.all(collection.items.map(loadUnitProducts));
	    }).then(function (units) {
	      return vm.units = units;
	    });
	    var p2 = propCtrl.get('rate-bases').then(function (collection) {
	      return vm.rateBases = _.keyBy(collection.items, "code");
	    });
	    var p3 = datasets.bindSets(["boards", "unit-types"], vm, true);
	    // const p4 = propCtrl.get('prestations')
	    //   .then(prestation => vm.prestationsss = prestation);

	    propCtrl.get("amenities").then(function (amenities) {
	      vm._propertyAmenities = amenities.items;
	      vm.propertyAmenities = amenities.items.map(function (a) {
	        return a.amenity;
	      });
	      vm.permissions = amenities.permissions;
	    });

	    datasets.get("amenities").then(function (collection) {
	      vm.options = {
	        property: collection.items.filter(function (a) {
	          return a.property;
	        }),
	        unit: collection.items.filter(function (a) {
	          return a.unit;
	        }),
	        rate: collection.items.filter(function (a) {
	          return a.rate;
	        })
	      };
	    });

	    propCtrl.get('prestations').then(function (collection) {
	      collection.items = collection.items.map(function (item) {
	        item.details = false;
	        return item;
	      });
	      vm.prestations = collection.items;
	    });

	    propCtrl.get('discounts', {
	      $sort: "bookingPeriod>"
	    }).then(function (collection) {
	      //console.log('discounts', collection)
	      angular.extend(vm, {
	        permissions: collection.permissions,
	        links: collection.links,
	        discounts: collection.items.map(decode)
	      });
	    });
	    $scope.$watch(function () {
	      return vm.newRange.from;
	    }, newRangeFrom);
	    $scope.$watch(function () {
	      return vm.newRange.to;
	    }, newRangeTo);
	    loadPrestation(vm.prestationCode);
	  }

	  function newRangeFrom(fresh, old) {

	    if (fresh === old || fresh === "") return;

	    if (fresh) vm.newRange.from = moment(fresh).format("YYYY-MM-DD");

	    vm.options.minEndDate = dateAsString(moment(vm.newRange.from).add(1, 'days').format('YYYY-MM-DD'));

	    if (vm.newRange.to == "" || moment(vm.newRange.from).isAfter(moment(vm.newRange.to))) vm.newRange.to = moment(vm.newRange.from).add(1, 'days').format("YYYY-MM-DD");
	  }

	  function newRangeTo(fresh, old) {
	    if (fresh === old || fresh === "") return;
	    if (fresh) vm.newRange.to = moment(fresh).format("YYYY-MM-DD");
	  }

	  function loadPrestation(code) {
	    var _arguments = arguments;

	    if (code === 'new') {
	      vm.isNew = true;
	      vm.prestation = scaffold();
	      return;
	    }
	    return $http.get(vm.propertyCtrl.property.links.prestations.href + '/' + code, {
	      headers: {
	        'accept-language': ''
	      }
	    }).then(function (res) {
	      //   console.log('prestation loaded', res);
	      vm.pristine = res.data;
	      vm.prestation = prestationsHelper.parse(res.data);
	      vm.prestation.childs = vm.prestation.childs || [];
	      vm.prestation.period = vm.prestation.period || {
	        ranges: []
	      };
	      vm.prestation.bookingPeriod = vm.prestation.bookingPeriod || {
	        ranges: []
	      };
	      // console.log('vm.prestation...', vm.prestation)
	      // if (vm.discount.combinationGroup != null) vm.combinationGroup = vm.discount.combinationGroup;

	      // console.log("discountcombinationGroup", vm.combinationGroup);
	    }, function () {
	      $log.debug('error loading discount', _arguments);
	    });
	  }

	  function scaffold() {
	    return {
	      childs: [],
	      period: {
	        ranges: []
	      },
	      bookingPeriod: {
	        ranges: []

	        // rule: {
	        //   unit: null,
	        //   value: null,
	        //   pricingPolicy: null,
	        //   appliedRule: null
	        // },
	        // option: null,
	        // minStay: 1,
	        // period: {

	        // }

	        // reference: '',
	        // label: {},
	        // score: {
	        //   min: 1,
	        //   max: 10
	        // },
	        // combinable: false,
	        // combination: {
	        //   group: [],
	        //   rule: ''
	        // },
	        // // combinationGroup:[],
	        // // combinationRule:'',
	        // products: [],

	        // booking: {
	        //   period: {},
	        //   advance: {
	        //     min: 0,
	        //     max: 356
	        //   }
	        // },
	        // stay: {
	        //   period: {},
	        //   length: {
	        //     min: 1,
	        //     max: 30
	        //   }
	        // },
	        // payOnArrival: false,
	        // baseOnly: false,
	        // availability: -1,
	        // cancellation: null
	      } };
	  }

	  function addChildrenPolicy() {

	    //   var confirm = $mdDialog.confirm()
	    //     .title('Supprimer cette catégorie?')
	    //     .textContent('Tous les allotement, produits et tarifs lié a cette catégorie seront supprimés')
	    //     .ariaLabel('Delete unit category')
	    //     .targetEvent($event)
	    //     .ok('Supprimer')
	    //     .cancel('Ne pas supprimer');

	    //   $mdDialog.show(confirm)
	    //     // then(() => doRemove(unit) );
	    //     .then(() => $http.delete(unit.links.self.href))
	    //     .then(() => $state.reload());
	    // }


	    vm.prestation.childs.push({});
	  }

	  function createPrestation() {
	    //if(stpsls.typeCode==null) {stpsls.typeCode=vm.propertyCtrl.property.items[0].property }
	    var prestation = vm.prestation;
	    console.log(" applyOnBoard ;::", prestation.applyOnBoard);

	    if (prestation.childs.length == 0) prestation.childTypologieParents = false;
	    // var data = {
	    //   nom: prestation.nom,//name
	    //   supplier: prestation.supplier,
	    //   description: prestation.description,
	    //   rate: prestation.rate,
	    //   unit: prestation.unit,
	    //   prestationType: prestationType[prestation.type],
	    //   price: prestation.price,
	    //   pricePourcentage: pricePourcentage[prestation.pricePourcentage],
	    //   tarifType: tarifType[prestation.tarifType],//rateType
	    //   tarifApplicable: tarifApp[prestation.tarifApp],
	    //   option: option[prestation.option],
	    //   // priceEnfantPourcentage: pricePourcentage[prestation.enfantpricetype],
	    //   // enfantPrice: prestation.enfantPrice,
	    //   // priceBebePourcentage: pricePourcentage[prestation.bebepricetype],

	    //   // bebePrice: prestation.bebePrice,
	    //   minStay: prestation.minStay,
	    //   property: prestation.property,
	    //   debut: dateAsString(prestation.debut),//from, start
	    //   fin: dateAsString(prestation.fin),//to, end
	    //   childs: prestation.childs

	    // }

	    // console.log('prestation.....', prestation)
	    //return
	    var data = {
	      nom: prestation.nom,
	      supplier: prestation.supplier,
	      description: prestation.description || null,
	      rate: prestation.rate,
	      unit: prestation.unit,
	      prestationType: prestationType[prestation.type],
	      purchaseprice: prestation.purchaseprice,
	      markup: prestation.markup,
	      price: prestation.price,
	      pricePourcentage: pricePourcentage[prestation.pricePourcentage],
	      tarifType: tarifType[prestation.tarifType],
	      tarifApplicable: tarifApp[prestation.tarifApp],
	      option: option[prestation.option],
	      typology: prestationTypologies[prestation.typology],
	      discounts: prestation.discounts,
	      offers: prestation.offers,
	      boards: prestation.boards,
	      childTypologieParents: prestation.childTypologieParents,
	      justification: prestation.justification,
	      btob: prestation.btob,
	      btoc: prestation.btoc,
	      adltNbr: prestation.adultsNbr,
	      applyOnBoard: prestation.applyOnBoard,

	      // priceEnfantPourcentage: pricePourcentage[prestation.enfantpricetype],
	      //enfantBebe: enfantBebeType[prestation.nonadult],
	      // enfantPrice: prestation.enfantPrice,
	      // priceBebePourcentage: pricePourcentage[prestation.bebepricetype],

	      // bebePrice: prestation.bebePrice,
	      minStay: prestation.minStay,
	      property: prestation.property,
	      debut: dateAsString(prestation.debut),
	      fin: dateAsString(prestation.fin),
	      childs: prestation.childs,
	      period: prestation.period,
	      bookingPeriod: prestation.bookingPeriod //,
	      //testdaterange: encodeDateRanges(prestation) //
	      //  debut: moment(stpsls.debut).format("YYYY-MM-DD"),
	      //  fin: moment(stpsls.fin).format("YYYY-MM-DD"),

	    };

	    if (!vm.isNew) angular.extend(data, {
	      code: prestation.code
	    });
	    prestationRequest(data);
	    $state.reload();
	  }

	  // function encodeDateRanges(prestation) {
	  //   var encoded = prestation.lines.map(function (line) {
	  //     console.log('linnnenenene', line)
	  //     return "[" + moment(line.from, "YYYY-MM-DD").format("YYYY-MM-DD") + "," + moment(line.to, "YYYY-MM-DD").format("YYYY-MM-DD") + ")"
	  //   })

	  //   console.log('encoded...', encoded)
	  //   //["[2021-08-27,2022-01-01)", "[2022-08-27,2023-01-01)", "[2023-08-27,2024-01-01)"]
	  //   return encoded

	  // }

	  function prestationRequest(encoded) {
	    $log.debug('link', vm.propertyCtrl.property.links);

	    //var href = "http://beds-api.fractalite.com/properties/2/stop-sales";

	    // return $http.post(vm.propertyCtrl.property.links["prestations"].href, prestation)
	    //   .then(function (res) {
	    //     $log.debug('created', res.data);
	    //     $scope.$emit("prestationAdded", res.data);
	    //   }, function () {
	    //     $log.error(arguments);
	    //     // return $q.reject()
	    //   })
	    //   .then(() => $state.reload());


	    var promise = vm.isNew ? $http.post(vm.propertyCtrl.property.links.prestations.href, encoded) : $http.put(vm.pristine.links.self.href, encoded);

	    promise.then(function () {
	      $state.go("property.prestationList");
	      //  saveSuccess;
	      $log.debug('saved');
	      $mdToast.show($mdToast.simple().textContent('Modifications enregistrées').hideDelay(3000));
	    });
	  }

	  function dateAsString(d) {
	    return d ? moment(d).format('YYYY-MM-DD') : null;
	  }

	  function load() {
	    vm.propertyCtrl.get("prestations").then(function (collection) {
	      vm.items = collection.items;
	      vm.links = collection.links;
	    });
	  }

	  function loadUnitProducts(unit) {
	    return $http.get(unit.links.products.href).then(function (res) {
	      unit.products = res.data.items;
	      return unit;
	    });
	  }

	  function productsGrid(unit) {
	    if (unit.all) {
	      return {
	        unit: unit
	      };
	    }
	    var rateBases = _.uniq(unit.products.map(function (p) {
	      return p.rateBasis;
	    }));
	    var occupancies = _.uniq(unit.products.map(function (p) {
	      return p.occupancy;
	    }));
	    var boards = _.uniq(unit.products.map(function (p) {
	      return p.board;
	    }));
	    // build the grid
	    var grid = rateBases.map(function (rateBasis) {
	      return occupancies.map(function (occupancy) {
	        return boards.map(function (board) {
	          return _.some(unit.products, {
	            rateBasis: rateBasis,
	            board: board,
	            occupancy: occupancy
	          });
	        });
	      });
	    });
	    return {
	      unit: unit,
	      // base: {board: _.min(boards)},
	      rateBases: rateBases,
	      occupancies: occupancies,
	      boards: boards,
	      grid: grid
	    };
	  }

	  $scope.minDate = function () {
	    var now = new Date();
	    return new Date(now.getFullYear() - 2, now.getMonth(), now.getDate());
	  };

	  function uniqueUnits(productCodes, units) {
	    return units.map(function (u) {
	      var copy = _.pick(u, ["code", "name", "type"]);
	      copy.products = u.products.filter(function (p) {
	        return productCodes.includes(p.code);
	      });
	      copy.rateBases = _.uniq(copy.products.map(function (p) {
	        return p.rateBasis;
	      }));
	      if (copy.products.length === u.products.length) {
	        copy.all = true;
	      }
	      return copy;
	    }).filter(function (uCopy) {
	      return uCopy.products.length > 0;
	    });
	  }

	  function blurChildPurchaseprice(child) {
	    console.log("blurChildPurchaseprice");
	    var markup = 0;
	    var value = 0;
	    var purchaseprice = 0;
	    purchaseprice = Number(child.purchaseprice);
	    markup = Number(child.markup);
	    value = purchaseprice * (1 + markup / 100);
	    //.toFixed(2);
	    // child.value=child.value / (1+(child.markup/100));.toFixed(2);
	    console.log("blurChildPurchaseprice", Math.round(value * 100) / 100);

	    //child.value=Number(value).toFixed(2);
	    child.value = Math.round(value * 100) / 100;
	  }

	  function blurChildValue(child) {
	    console.log("blurChildValue");
	    var purchaseprice = 0;
	    var markup = 0;
	    var value = 0;
	    value = Number(child.value);
	    markup = Number(child.markup);
	    //child.purchaseprice=child.purchaseprice * (1+(child.markup/100));
	    purchaseprice = value / (1 + markup / 100);
	    console.log("blurChildPurchaseprice", Math.round(purchaseprice * 100) / 100);

	    // child.purchaseprice=Number(purchaseprice).toFixed(2);
	    child.purchaseprice = Math.round(purchaseprice * 100) / 100;
	  }

	  function blurAdultPrice(prestation) {
	    console.log("blurChildValue");
	    var purchaseprice = 0;
	    var markup = 0;
	    var price = 0;
	    price = Number(prestation.price);
	    markup = Number(prestation.markup);
	    //child.purchaseprice=child.purchaseprice * (1+(child.markup/100));
	    purchaseprice = price / (1 + markup / 100);
	    console.log("blurChildPurchaseprice", Math.round(purchaseprice * 100) / 100);

	    // child.purchaseprice=Number(purchaseprice).toFixed(2);
	    prestation.purchaseprice = Math.round(purchaseprice * 100) / 100;
	  }

	  function blurAdultPurchaseprice(prestation) {
	    console.log("blurChildPurchaseprice");
	    var markup = 0;
	    var price = 0;
	    var purchaseprice = 0;
	    purchaseprice = Number(prestation.purchaseprice);
	    markup = Number(prestation.markup);
	    price = purchaseprice * (1 + markup / 100);
	    //.toFixed(2);
	    // child.value=child.value / (1+(child.markup/100));.toFixed(2);
	    console.log("blurChildPurchaseprice", Math.round(price * 100) / 100);

	    //child.value=Number(value).toFixed(2);
	    prestation.price = Math.round(price * 100) / 100;
	  }
	}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prestationsHelper;
	var moment = __webpack_require__(10);

	function prestationsHelper() {
	  "ngInject";

	  var prestationType = ["Reduction", "Supplement"];
	  var pricePourcentage = ["Price", "%"];
	  var tarifApp = ["Sejour", "Nuit"];
	  var tarifType = ["Forfait", "Chambre", "Pax"];
	  var option = ["Obligatoire", "Optionelle", "Selected"];
	  var prestationTypologies = ["Offre", "Assurance", "Transfert", "Pensions", "Autres"];

	  return {
	    parse: parse //,
	    // format: format
	  };

	  function parse(raw) {
	    console.log("raw...", raw);
	    return _.extend(_.omit(raw, ["prestationType", "pricePourcentage", "price", "tarifApplicable", "tarifType", "option", "debut", "fin"]), {
	      type: prestationType.indexOf(raw.prestationType),
	      pricePourcentage: pricePourcentage.indexOf(raw.pricePourcentage),
	      price: +raw.price,
	      purchaseprice: +raw.purchaseprice,
	      markup: +raw.markup,
	      tarifApp: tarifApp.indexOf(raw.tarifApplicable),
	      tarifType: tarifType.indexOf(raw.tarifType),
	      option: option.indexOf(raw.option),
	      debut: moment(raw.debut).toDate(),
	      fin: moment(raw.fin).toDate(),
	      discounts: raw.discounts,
	      offers: raw.offers,
	      typology: prestationTypologies.indexOf(raw.typology),
	      childTypologieParents: raw.childTypologieParents,
	      adultsNbr: raw.adltNbr
	      // enfantpricetype: pricePourcentage.indexOf(raw.priceEnfantPourcentage),
	      // enfantPrice: +raw.enfantPrice,
	      // bebepricetype: pricePourcentage.indexOf(raw.priceBebePourcentage),
	      // bebePrice: +raw.bebePrice,
	    });
	  }
	  // function format(discount) {
	  //     return _.extend(
	  //         _.omit(discount, ["booking", "stay"]),
	  //         {
	  //             booking: {
	  //                 period: formatBookingPeriod(discount.booking.period),
	  //                 advance: formatIntRange(discount.booking.advance)
	  //             },
	  //             stay: {
	  //                 period: formatStayPeriod(discount.stay.period),
	  //                 length: formatIntRange(discount.stay.length)
	  //             }
	  //         }
	  //     );
	  // }

	  // function parseBookingPeriod(string) {
	  //     const match = string.match(/^\["([^"]+)","([^"]+)"\)$/);
	  //     const start = moment(match[1]);
	  //     const end = moment(match[2]);
	  //     return {
	  //         start: start.toDate(),
	  //         end: end.subtract(1, 'days').toDate()
	  //     }
	  // }

	  // function formatBookingPeriod(range) {
	  //     const format = '"YYYY-MM-DD HH:mm:ss"';
	  //     const start = moment(range.start).format(format);
	  //     const end = moment(range.end).startOf('day').add(1, 'days').format(format);
	  //     return formatRange(start, end);
	  // }

	  // function parseStayPeriod(string) {
	  //     const match = string.match(/^\[([^,]{10}),([^,]{10})\)$/);
	  //     const start = moment(match[1]);
	  //     const end = moment(match[2]);
	  //     return {
	  //         start: start.toDate(),
	  //         end: end.subtract(1, 'days').toDate()
	  //     }
	  // }

	  // function formatStayPeriod(range) {
	  //     const format = 'YYYY-MM-DD';
	  //     const start = moment(range.start).format(format);
	  //     const end = moment(range.end).startOf('day').add(1, 'days').format(format);
	  //     return formatRange(start, end);
	  // }

	  // function parseIntRange(string) {
	  //     const match = string.match(/^\[(\d+),(\d+)\)$/);
	  //     return {
	  //         min: parseInt(match[1], 10),
	  //         max: parseInt(match[2], 10) - 1
	  //     }
	  // }

	  // function formatIntRange(range) {
	  //     return formatRange(range.min, range.max + 1);
	  // }

	  // function formatRange(start, end) {
	  //     return `[${start},${end})`;
	  // }

	}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(75);

	var _component2 = _interopRequireDefault(_component);

	var _routes = __webpack_require__(76);

	var _routes2 = _interopRequireDefault(_routes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusyieldprice', ['ui.router', 'lectusApi', 'dndLists']).component(_component2.default.name, _component2.default)

	//.component(propertyRequestListComp.name,propertyRequestListComp)
	.config(_routes2.default);
	// .config(function productRoutes($stateProvider) {
	//     "ngInject";
	//     // State
	//     $stateProvider
	//     .state('property.stopSales', {
	//         url: '/stopsales',
	//         component: 'stopSales',
	//         resolve:{
	//           lectus: resolveLectusApi,
	//           requestViewState: () => 'property.stopSales'
	//         }
	//        })
	//        .state('property.stopSalesEdit', {
	//          url: '/stopsales/:stopsale/edit',
	//          component: 'stopSalesEdit',
	//          resolve: {
	//          discountCode: function($stateParams) {
	//             'ngInject';
	//             return $stateParams.stopSales;
	//           }
	//          }
	//       })
	//     })


	//import propertyRequestListComp from './property-list/component';

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	YieldPriceCtrl.$inject = ["$log", "$state", "$q", "$scope", "datasets", "$mdDialog", "$http", "discountsHelper"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moment = __webpack_require__(10);

	exports.default = {
	  name: "yieldprice",
	  controller: YieldPriceCtrl,
	  templateUrl: 'app/yield-price/list/template.html',
	  bindings: {
	    lectus: "<",
	    requestViewState: "<",
	    discountCode: "<"

	  },
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function YieldPriceCtrl($log, $state, $q, $scope, datasets, $mdDialog, $http, discountsHelper) {
	  "ngInject";

	  this.myDate = new Date();

	  this.minDate = new Date(this.myDate.getFullYear(), this.myDate.getMonth(), this.myDate.getDate());

	  var vm = this;
	  var query = {
	    customer: '',
	    limit: 25,
	    order: '-createdOn',
	    page: 1
	  };

	  var typestp = { 0: "Hotel", 1: "Base Tarifaire", 2: "Unit", 3: "Pension" };
	  var typestp1 = ["Hotel", "Base Tarifaire", "Unit", "Pension"];

	  angular.extend(vm, {
	    $onInit: init,
	    // copy: copy,
	    loadyield: loadyield,
	    remove: remove,
	    createyield: createyield,
	    edit: edit
	    //mindate:mindate

	  });

	  // function mindate() {
	  //   var now = new Date();
	  //   return new Date(
	  //     now.getFullYear() - 2,
	  //     now.getMonth(),
	  //     now.getDate()
	  //   );
	  // }


	  function createyield(yld) {
	    //if(stpsls.typeCode==null) {stpsls.typeCode=vm.propertyCtrl.property.items[0].property }


	    var data = {
	      rate: yld.rate,
	      unit: yld.unit,
	      pourcent: yld.pourcent,
	      remplissage: yld.taux,

	      debut: dateAsString(yld.debut),
	      fin: dateAsString(yld.fin),

	      description: yld.description

	    };
	    postyield(data);
	  }

	  function postyield(yld) {
	    $log.debug('link', vm.propertyCtrl.property.links);

	    //var href = "http://beds-api.fractalite.com/properties/2/stop-sales";

	    return $http.post(vm.propertyCtrl.property.links["yield"].href, yld).then(function (res) {
	      $log.debug('created', res.data);
	      $scope.$emit("yieldAdded", res.data);
	    }, function () {
	      $log.error(arguments);
	      // return $q.reject()
	    }).then(function () {
	      return $state.reload();
	    });
	  }

	  function dateAsString(d) {
	    return d ? moment(d).format('YYYY-MM-DD') : null;
	  }

	  function toRange(start, end, open) {
	    var str = ["[", start, ","];
	    if (open) {
	      str.push(")");
	    } else {
	      str.push(end, "]");
	    }
	    return str.join("");
	  }

	  function loadyield() {
	    var _arguments = arguments;


	    return $http.get(vm.propertyCtrl.property.links["yield"].href, {
	      headers: {
	        'accept-language': ''
	      }
	    }).then(function (res) {
	      $log.debug('yield loaded', res.data);
	      vm.stopsaless = res.data;
	      //vm.discount = discountsHelper.parse(res.data);
	    }, function () {
	      $log.debug('error loading discount', _arguments);
	    });
	  }

	  function edit($event, stopsales) {
	    var promise;
	    promise = $http({
	      method: "PUT",
	      url: stopsales.links.self.href,
	      headers: {
	        "Content-Language": "**"
	      },
	      data: _.pick(stopsales, ['code', 'type', 'description', 'type_code', 'debut', 'fin', 'property'])
	    });
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }

	  function init() {
	    var propCtrl = vm.propertyCtrl;
	    load();
	    var p1 = propCtrl.get('units').then(function (collection) {
	      return $q.all(collection.items.map(loadUnitProducts));
	    }).then(function (units) {
	      return vm.units = units;
	    });
	    var p2 = propCtrl.get('rate-bases').then(function (collection) {
	      return vm.rateBases = _.keyBy(collection.items, "code");
	    });
	    var p3 = datasets.bindSets(["boards", "unit-types"], vm, true);
	    var p4 = propCtrl.get('yield').then(function (ylds) {
	      return vm.ylds = ylds;
	    });

	    propCtrl.get("amenities").then(function (amenities) {
	      vm._propertyAmenities = amenities.items;
	      vm.propertyAmenities = amenities.items.map(function (a) {
	        return a.amenity;
	      });
	      vm.permissions = amenities.permissions;
	    });
	    datasets.get("amenities").then(function (collection) {
	      vm.options = {
	        property: collection.items.filter(function (a) {
	          return a.property;
	        }),
	        unit: collection.items.filter(function (a) {
	          return a.unit;
	        }),
	        rate: collection.items.filter(function (a) {
	          return a.rate;
	        })
	      };
	    });
	  }

	  function load() {
	    vm.propertyCtrl.get("stop-sales").then(function (collection) {
	      vm.items = collection.items;
	      vm.links = collection.links;
	    });
	  }

	  function loadUnitProducts(unit) {
	    return $http.get(unit.links.products.href).then(function (res) {
	      unit.products = res.data.items;
	      return unit;
	    });
	  }

	  function productsGrid(unit) {
	    if (unit.all) {
	      return { unit: unit };
	    }
	    var rateBases = _.uniq(unit.products.map(function (p) {
	      return p.rateBasis;
	    }));
	    var occupancies = _.uniq(unit.products.map(function (p) {
	      return p.occupancy;
	    }));
	    var boards = _.uniq(unit.products.map(function (p) {
	      return p.board;
	    }));
	    // build the grid
	    var grid = rateBases.map(function (rateBasis) {
	      return occupancies.map(function (occupancy) {
	        return boards.map(function (board) {
	          return _.some(unit.products, { rateBasis: rateBasis, board: board, occupancy: occupancy });
	        });
	      });
	    });
	    return {
	      unit: unit,
	      // base: {board: _.min(boards)},
	      rateBases: rateBases,
	      occupancies: occupancies,
	      boards: boards,
	      grid: grid
	    };
	  }

	  $scope.minDate = function () {
	    var now = new Date();
	    return new Date(now.getFullYear() - 2, now.getMonth(), now.getDate());
	  };

	  function remove($event, yld) {

	    var confirm = $mdDialog.confirm().title('Etes-vous sûr de vouloir supprimer ?').textContent('Cette opération est irreversible.').ariaLabel('Supression de yield').targetEvent($event).ok('Supprimer').cancel('Garder');

	    $log.debug('removeee', yld.links.self.href);

	    $mdDialog.show(confirm).then(function () {
	      return $http.delete(yld.links.self.href);
	    }).then(function () {
	      return $state.reload();
	    });
	  }

	  function decode(discount) {
	    var decoded = discountsHelper.parse(discount);
	    decoded.units = uniqueUnits(discount.products, vm.units);
	    decoded.unitsGrid = decoded.units.map(productsGrid);
	    /*
	    if (copy.products.length === u.products.length) {
	      u.all = true;
	    }
	    else {
	      productsGrid(copy)
	    }
	    */
	    return decoded;
	    /*
	    return {
	      code: discount.code,
	      reference: discount.reference,
	      label: discount.label,
	      booking: {
	        period: parseBookingPeriod(discount.booking.period),
	        advance: parseIntRange(discount.booking.advance)
	      },
	      stay: {
	        period: parseStayPeriod(discount.stay.period),
	        length: parseIntRange(discount.stay.length)
	      },
	      cancellation: discount.cancellation,
	      payment: discount.payment,
	      rule: discount.rule,
	      units: uniqueUnits(discount.products, vm.units)
	    }*/
	  }

	  function uniqueUnits(productCodes, units) {
	    return units.map(function (u) {
	      var copy = _.pick(u, ["code", "name", "type"]);
	      copy.products = u.products.filter(function (p) {
	        return productCodes.includes(p.code);
	      });
	      copy.rateBases = _.uniq(copy.products.map(function (p) {
	        return p.rateBasis;
	      }));
	      if (copy.products.length === u.products.length) {
	        copy.all = true;
	      }
	      return copy;
	    }).filter(function (uCopy) {
	      return uCopy.products.length > 0;
	    });
	  }
	}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	"use strict";

	routes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';

	  var resolveLectusApi = function resolveLectusApi(lectusApi) {
	    "ngInject";

	    return lectusApi;
	  };
	  resolveLectusApi.$inject = ["lectusApi"];

	  // State

	}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	'use strict';

	routes.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';

	  //$urlRouterProvider.when('/home', '/home/index');

	  var resolveLectusApi = function resolveLectusApi(lectusApi) {
	    "ngInject";

	    return lectusApi;
	  };
	  resolveLectusApi.$inject = ["lectusApi"];

	  // State
	  $stateProvider.state('properties', {
	    url: '/properties',
	    component: 'propertyList',
	    resolve: {
	      lectus: resolveLectusApi
	    }
	  }).state('property', {
	    url: '/properties/:property',
	    component: 'propertyContainer',
	    resolve: {
	      property: ["lectusApi", "$stateParams", "$http", function property(lectusApi, $stateParams, $http) {
	        'ngInject';

	        if ($stateParams.property === "new") return null;
	        console.log(lectusApi);
	        return $http.get(lectusApi.links.properties.href + '/' + $stateParams.property).then(function (res) {
	          console.log('-------------------------resdata-------------------', res.data);
	          return res.data;
	        });
	      }]
	      //abstract:true
	    } }).state('property.dashboard', {
	    url: '',
	    component: 'propertyDashboard'
	  }).state('property.datasheet', {
	    url: '/datasheet',
	    component: 'propertyDatasheet',
	    data: {
	      menu: {
	        rel: 'self',
	        label: 'Fiche',
	        group: 'info',
	        position: 0
	      }
	    }
	  }).state('property.bookings', {
	    url: '/bookings',
	    component: 'propertyBookingList',
	    data: {
	      menu: {
	        rel: 'self',
	        label: 'Réservations',
	        group: 'Réservations',
	        position: 10
	      }
	    },
	    resolve: {
	      lectus: resolveLectusApi,
	      // bookingViewState: () => 'property.booking',
	      bookingViewState: function bookingViewState() {
	        return 'property.bookingView';
	      },
	      bookingEditState: function bookingEditState() {
	        return 'property.bookingEdit';
	      },
	      bookingCreateState: function bookingCreateState() {
	        return 'property.createBooking';
	      }

	    }
	  }).state('property.bookingsOnHold', {
	    url: '/bookings-on-hold',
	    component: 'propertyBookingOnHoldList',
	    data: {
	      menu: {
	        rel: 'self',
	        label: 'Précommandes',
	        group: 'Réservations',
	        position: 10
	      }
	    },
	    resolve: {
	      lectus: resolveLectusApi
	      // bookingViewState: () => 'property.booking',

	    }
	  })
	  // .state('property.booking', {
	  //   url: '/bookings/:booking',
	  //   component: 'bookingView',
	  //   resolve: {
	  //     bookingNumber: function ($stateParams) { "ngInject"; return $stateParams.booking; }
	  //   }
	  // })
	  .state('property.bookingView', {
	    url: '/bookings/:booking',
	    component: 'bookingView',
	    resolve: {
	      bookingNumber: ["$stateParams", function bookingNumber($stateParams) {
	        "ngInject";
	        return $stateParams.booking;
	      }]
	    }
	  }).state('property.bookingEdit', {
	    url: '/bookings/:booking/edit',
	    component: 'bookingEdit',
	    resolve: {
	      bookingNumber: ["$stateParams", function bookingNumber($stateParams) {
	        "ngInject";
	        return $stateParams.booking;
	      }]
	    }
	  }).state('property.bookingsDay', {
	    url: '/bookingsDay',
	    component: 'propertyBookingListDay',
	    data: {
	      menu: {
	        rel: 'self',
	        label: 'Réservations d\'aujourd\'hui',
	        group: 'Réservations',
	        position: 10
	      }
	    },
	    resolve: {
	      lectus: resolveLectusApi,
	      bookingViewState: function bookingViewState() {
	        return 'property.booking';
	      }
	    }
	  }).state('property.createBooking', {
	    url: '/createBooking',
	    component: 'propertyCreateBooking',

	    resolve: {
	      lectus: resolveLectusApi,
	      bookingViewState: function bookingViewState() {
	        return 'property.booking';
	      },
	      bookingListState: function bookingListState() {
	        return 'property.bookings';
	      }
	    }
	  }).state('property.bookingsDayCheckin', {
	    url: '/bookingsCheckinDay',
	    component: 'propertyBookingListDayCheckin',
	    data: {
	      menu: {
	        rel: 'self',
	        label: 'Liste des Checkin',
	        group: 'Réservations',
	        position: 10
	      }
	    },
	    resolve: {
	      lectus: resolveLectusApi,
	      bookingViewState: function bookingViewState() {
	        return 'property.booking';
	      }
	    }
	  })

	  // .state('property.prestations', {
	  //   url: '/prestations',
	  //   component: 'prestations',
	  //   data:{
	  //     menu:{
	  //       rel: 'self',
	  //       label: 'Prestations',
	  //       group: 'Tarifs et dispo',
	  //       position: 2
	  //     }
	  //   }
	  // })


	  // .state('property.yieldprice', {
	  //   url: '/yieldprice',
	  //   component: 'yieldprice',
	  //   data:{
	  //     menu:{
	  //       rel: 'self',
	  //       label: 'Yield price',
	  //       group: 'Tarifs et dispo',
	  //       position: 2
	  //     }
	  //   }
	  // })


	  .state('property.stopsales', {
	    url: '/stopsales',
	    component: 'stopSales',
	    data: {
	      menu: {
	        rel: 'self',
	        label: 'Stop Sales',
	        group: 'Tarifs et dispo',
	        position: 4
	      }
	    }
	  }).state('property.onrequest', {
	    url: '/onrequest',
	    component: 'onRequest',
	    data: {
	      menu: {
	        rel: 'self',
	        label: 'On Request',
	        group: 'Tarifs et dispo',
	        position: 5
	      }
	    }
	  }).state('property.seasons', {
	    url: '/seasons',
	    component: 'seasons',
	    data: {
	      menu: {
	        rel: 'self',
	        label: 'Saisons',
	        group: 'Tarifs et dispo',
	        position: 7
	      }
	    }
	  }).state('property.propertycommentsdate', {
	    url: '/propertycommentsdate',
	    component: 'propertyCommentsDate',
	    data: {
	      menu: {
	        rel: 'self',
	        label: 'Commentaires',
	        group: 'Tarifs et dispo',
	        position: 6
	      }
	    }
	  })
	  // .state('property.stopSalesEdit', {
	  //   url: '/stopsales/:stopsale/edit',
	  //   component: 'stopSalesEdit',
	  //   resolve: {
	  //    discountCode: function($stateParams) {
	  //      'ngInject';
	  //      return $stateParams.stopSales;
	  //    }
	  //   }
	  // })

	  // .state('property.requests', {
	  //   url: '/requests',
	  //   component: 'propertyRequestList',
	  //   data:{
	  //     menu:{
	  //       rel: 'self',
	  //       label: 'Requests',
	  //       group: 'Réservations',
	  //       position: 10
	  //     }
	  //   },
	  //   resolve:{
	  //     lectus: resolveLectusApi,
	  //     requestViewState: () => 'property.request'
	  //   }
	  // })
	  // .state('property.request', {
	  //   url: '/requests/:request',
	  //   component: 'requestView',
	  //   resolve:{
	  //     lectus: resolveLectusApi,
	  //     bookingNumber: function($stateParams) { "ngInject"; return $stateParams.request;}
	  //   }
	  // })
	  ;
	}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	"use strict";

	PropertyListCtrl.$inject = ["$log", "$http", "$state", "$scope"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "propertyList",
	  controller: PropertyListCtrl,
	  templateUrl: 'app/property/list/template.html',
	  bindings: {
	    lectus: "<"
	  }
	};


	function PropertyListCtrl($log, $http, $state, $scope) {
	  "ngInject";

	  var vm = this;

	  vm.$onInit = function () {
	    angular.extend(vm, {
	      loadProperties: loadProperties,
	      showProperty: showProperty,
	      filter: {
	        options: {
	          debounce: 500
	        }
	      },
	      query: {
	        filter: '',
	        limit: 20,
	        order: 'name',
	        page: 1
	      },
	      dest: {
	        items: []
	      }
	    });
	    $scope.$watch(function () {
	      return vm.dest.searchText;
	    }, onDestChange);

	    $scope.$watch(function () {
	      return vm.query.filter;
	    }, onSearchChange);
	    $scope.$watch(function () {
	      return vm.query.locality;
	    }, onSearchChange);
	    //loadProperties();
	  };

	  function onDestChange(newValue, oldValue) {
	    if (newValue !== oldValue) {
	      $http.get(vm.lectus.links.destinations.href, {
	        params: {
	          search: newValue,
	          $limit: 5,
	          $skip: 0
	        }
	      }).then(function (res) {
	        return vm.dest.items = res.data.items;
	      });
	    }
	  }

	  function onSearchChange(newValue, oldValue) {
	    var bookmark = vm.query.page;
	    if (!oldValue) {
	      bookmark = vm.query.page;
	    }

	    if (newValue !== oldValue) {
	      vm.query.page = 1;
	    }
	    if (!newValue) {
	      vm.query.page = bookmark;
	    }
	    loadProperties();
	  }

	  function loadProperties() {
	    //console.log(vm.query, arguments);
	    var sort = vm.query.order.indexOf("-") === 0 ? vm.query.order.replace("-", "") + ">" : vm.query.order + '<';
	    vm.loadingPromise = $http.get(vm.lectus.links.properties.href, {
	      params: {
	        $limit: vm.query.limit,
	        $skip: vm.query.page * vm.query.limit - vm.query.limit,
	        $sort: sort,
	        search: vm.query.filter || undefined,
	        locality: vm.query.locality ? vm.query.locality.code : undefined
	      }
	    }).then(function (res) {
	      // if only one hotel and user has no add permission redirect to that hotel
	      console.log("res.data.", res.data);
	      console.log("res.data.permissions.add ", res.data.permissions);

	      if (!res.data.permissions.add && res.data.total == 1) {
	        //    if ( res.data.total == 1) {
	        showProperty(res.data.items[0]);
	      }

	      angular.extend(vm, {
	        permissions: res.data.permissions,
	        properties: res.data.items,
	        total: res.data.total
	      });
	    });
	  }

	  function showProperty(p) {

	    $state.go('property', {
	      property: p.code
	    });
	  }
	}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "propertyAdd",
	  controller: StepperDemoController,
	  templateUrl: 'app/property/add/template.html'

	  // function PropertyAddCtrl($log, $mdSidenav, $q, $http, $state, $mdStepper, $timeout) {
	  //   "ngInject";
	  //
	  //   const vm = this;
	  //   const stepperId = 'stepper';
	  //
	  //   $timeout(() => {
	  //     //$mdStepper("property-add-stepper").next();
	  //
	  //   }, 10)
	  //
	  // }


	};
	function StepperDemoController($mdStepper, $timeout) {
	  "ngInject";

	  this.$mdStepper = $mdStepper;
	  this.$timeout = $timeout;
	  this.isVertical = false;
	  this.isLinear = true;
	  this.isAlternative = true;
	  this.isMobileStepText = true;
	  this.campaign = false;
	}
	StepperDemoController.prototype.selectCampaign = function () {
	  var _this = this;
	  var steppers = this.$mdStepper('stepper-demo');
	  steppers.showFeedback('Checking, please wait ...');
	  this.$timeout(function () {
	    if (_this.campaign) {
	      steppers.clearError();
	      steppers.next();
	    } else {
	      _this.campaign = !_this.campaign;
	      steppers.error('Wrong campaign');
	    }
	  }, 3000);
	};
	StepperDemoController.prototype.previousStep = function () {
	  var steppers = this.$mdStepper('stepper-demo');
	  steppers.back();
	};
	StepperDemoController.prototype.cancel = function () {
	  var steppers = this.$mdStepper('stepper-demo');
	  steppers.back();
	};
	StepperDemoController.prototype.nextStep = function () {
	  var steppers = this.$mdStepper('stepper-demo');
	  steppers.next();
	};
	StepperDemoController.prototype.toggleMobileStepText = function () {
	  this.isMobileStepText = !this.isMobileStepText;
	};
	StepperDemoController.prototype.toggleLinear = function () {
	  this.isLinear = !this.isLinear;
	};
	StepperDemoController.prototype.toggleAlternative = function () {
	  this.isAlternative = !this.isAlternative;
	};
	StepperDemoController.prototype.toggleVertical = function () {
	  this.isVertical = !this.isVertical;
	};
	StepperDemoController.prototype.showError = function () {
	  var steppers = this.$mdStepper('stepper-demo');
	  steppers.error('Wrong campaign');
	};
	StepperDemoController.prototype.clearError = function () {
	  var steppers = this.$mdStepper('stepper-demo');
	  steppers.clearError();
	};
	StepperDemoController.prototype.showFeedback = function () {
	  var steppers = this.$mdStepper('stepper-demo');
	  steppers.showFeedback('Step 1 looks great! Step 2 is comming up.');
	};
	StepperDemoController.prototype.clearFeedback = function () {
	  var steppers = this.$mdStepper('stepper-demo');
	  steppers.clearFeedback();
	};
	StepperDemoController.$inject = ['$mdStepper', '$timeout'];

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	"use strict";

	PropertyContainerCtrl.$inject = ["$log", "$mdSidenav", "$q", "$http", "$state", "$mdColorPalette"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "propertyContainer",
	  controller: PropertyContainerCtrl,
	  templateUrl: 'app/property/container/template.html',
	  bindings: {
	    property: "<property"
	  }
	};


	function PropertyContainerCtrl($log, $mdSidenav, $q, $http, $state, $mdColorPalette) {
	  "ngInject";

	  var vm = this;
	  //const relationsCache = new Map();

	  vm.$onInit = function () {
	    //console.log('gey')
	    //vm.property.links.edit = $state.href("property"); // do struff
	    //console.log(this);
	    if (vm.property === null) {
	      $state.go(".datasheet");
	      return;
	    }
	    _setUpMenu(vm.property);
	    /*
	        if ("property" === $state.current.name) {
	          $state.go('.dashboard');
	        }
	        */
	  };

	  angular.extend(vm, {
	    toggleMenu: toggleMenu,
	    setActions: setActions,
	    setBreadcrumb: setBreadcrumb,
	    get: get,
	    // get item from child collection identified by rel
	    getItem: getItem,
	    bindSets: bindSets
	  });

	  // cache purge
	  //$scope.$on("propertyRelChanged", function() {
	  //  relationsCache.clear();
	  //});
	  // may be we should add some timeout to;


	  function _setUpMenu(property) {

	    var propertyLinks = Object.keys(property.links);

	    var menuItems = $state.get().filter(function (s) {
	      return s.name.indexOf("property.") === 0 && s.data && s.data.hasOwnProperty('menu');
	    }).filter(function (s) {
	      return angular.isUndefined(s.data.menu.rel) || propertyLinks.includes(s.data.menu.rel);
	    }).sort(function (a, b) {
	      return a.data.menu.position - b.data.menu.position;
	    }).map(function (s) {
	      return angular.extend({ href: $state.href(s.name) }, {}, s.data.menu);
	    }).reduce(function (agg, item) {
	      if (angular.isUndefined(agg[item.group])) {
	        agg[item.group] = [];
	      }
	      agg[item.group].push(item);
	      return agg;
	    }, {});

	    vm.menu = menuItems;
	  }

	  function toggleMenu() {
	    $mdSidenav('property-menu').toggle();
	  }

	  function setActions(actions) {
	    vm.actions = actions;
	    return vm;
	  }

	  function setBreadcrumb(crumbs) {
	    vm.breadcrumb = crumbs;
	    return vm;
	  }

	  function get(rel, opts) {
	    //if (relationsCache.has(rel)) {
	    //  return $q.resolve(relationsCache.get(rel));
	    //}
	    // cache
	    if (vm.property.links[rel]) {
	      return $http.get(vm.property.links[rel].href, opts).then(function (res) {
	        if (rel === "rate-bases") setRateBasesColors(res.data.items);
	        //relationsCache.set(rel, res.data);
	        return res.data;
	      });
	    } else {
	      return $q.reject(new Error('unknow child resource ' / rel));
	    }
	  }

	  function getItem(rel, id) {
	    if (vm.property.links[rel]) {
	      return $http.get(vm.property.links[rel].href + "/" + id).then(function (res) {
	        return res.data;
	      });
	    } else {
	      return $q.reject(new Error('unknow child resource ' / rel));
	    }
	  }

	  function bindSets(names, target, indexed, options) {
	    return $q.all(names.map(function (n) {
	      return get(n, options);
	    })).then(function (results) {
	      return results.map(function (collection, i) {
	        var prop = _.camelCase(names[i]);
	        target[prop] = indexed ? _.keyBy(collection.items, "code") : collection.items;
	        return collection;
	      });
	    });
	  }

	  function setRateBasesColors(bases) {
	    // not expecting more than 6 rateBases.
	    // notmally it is BAR, Net B2B, Net TO,
	    var palettes = ["blue", "amber", "orange", "brown", "lime", "teal"];
	    return bases.map(function (b, i) {
	      b.color = $mdColorPalette[palettes[i]];
	      return b;
	    });
	  }

	  /*
	    function shadeColor2(color, percent) {
	      var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
	      return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
	  }
	  
	  function blendColors(c0, c1, p) {
	      var f=parseInt(c0.slice(1),16),t=parseInt(c1.slice(1),16),R1=f>>16,G1=f>>8&0x00FF,B1=f&0x0000FF,R2=t>>16,G2=t>>8&0x00FF,B2=t&0x0000FF;
	      return "#"+(0x1000000+(Math.round((R2-R1)*p)+R1)*0x10000+(Math.round((G2-G1)*p)+G1)*0x100+(Math.round((B2-B1)*p)+B1)).toString(16).slice(1);
	  }*/
	}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	'use strict';

	PropertyDashboardCtrl.$inject = ["$http", "$q", "datasets"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "propertyDashboard",
	  controller: PropertyDashboardCtrl,
	  templateUrl: 'app/property/dashboard/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PropertyDashboardCtrl($http, $q, datasets) {
	  "ngInject";

	  var vm = this;
	  // var colores_g = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];

	  vm.$onInit = function () {

	    vm.period = {
	      from: moment().startOf("month").format("YYYY-MM-DD"),
	      to: moment().endOf("month").format("YYYY-MM-DD")
	    };
	    vm.hasNext = true;
	    vm.hasPrevious = true;
	    vm.viewMode = "booking";
	    $q.all([datasets.bindSets(["unit-types"], vm, true), vm.propertyCtrl.get('units').then(function (collection) {
	      return vm.units = collection.items;
	    })]).then(function () {
	      vm.unitsMap = vm.units.reduce(function (agg, unit) {
	        agg[unit.code] = vm.unitTypes[unit.type].name + " " + unit.name;
	        return agg;
	      }, {});
	      loadReport();
	    });
	  };

	  vm.nextMonth = function () {
	    var start = moment(vm.period.from).add(1, "month");
	    vm.period = {
	      from: start.format("YYYY-MM-DD"),
	      to: moment(start).endOf("month").format("YYYY-MM-DD")
	    };
	    loadReport();
	  };
	  vm.previousMonth = function () {
	    var start = moment(vm.period.from).subtract(1, "month");
	    vm.period = {
	      from: start.format("YYYY-MM-DD"),
	      to: moment(start).endOf("month").format("YYYY-MM-DD")
	    };
	    loadReport();
	  };

	  function loadReport() {
	    var p = vm.propertyCtrl.property;
	    $http.get(p.links.self.href + "/report", {
	      params: vm.period
	    }).then(function (res) {
	      angular.extend(vm, res.data);
	    });
	  }
	}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	'use strict';

	PropertyDatasheetCtrl.$inject = ["User", "$log", "$http", "$state", "lectusApi", "$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "propertyDatasheet",
	  controller: PropertyDatasheetCtrl,
	  templateUrl: 'app/property/datasheet/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  },
	  bindings: {
	    lectusApi: "<"
	  }
	};


	function PropertyDatasheetCtrl(User, $log, $http, $state, lectusApi, $mdDialog) {

	  "ngInject";

	  var vm = this;
	  vm.$onInit = function () {

	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });
	    vm.propertyCtrl.setBreadcrumb([{ label: 'Information' }]);
	    vm.property = vm.propertyCtrl.property;

	    if (vm.property === null) {
	      // new
	      vm.editInfo = true;
	      vm.isNew = true;
	    }
	  };

	  angular.extend(vm, {
	    edit: {},
	    editInfo: false,
	    toggleEditInfo: toggleEditInfo,
	    toggleEditPolicies: toggleEditPolicies,
	    toggleEdit: toggleEdit,
	    onInfoChanged: onInfoChanged,
	    onPoliciesChanged: onPoliciesChanged,
	    confirmDelete: confirmDelete,
	    updateProp: updateProp
	  });

	  function toggleEditInfo() {
	    vm.editInfo = !vm.editInfo;
	  }

	  function toggleEditPolicies() {
	    vm.editPolicies = !vm.editPolicies;
	  }

	  function toggleEdit(section) {
	    vm.edit[section] = !vm.edit[section];
	  }

	  function onInfoChanged(changes) {
	    $log.debug('onInfoChanged', changes);

	    if (vm.isNew) {
	      return addProperty(changes);
	    }

	    if (vm.property.links.self) {
	      $http.put(vm.property.links.self.href, angular.extend({ code: vm.property.code }, changes)).then(function () {
	        //console.log(res.data);
	        $state.go($state.current, {}, { reload: true });
	      });
	    }
	    // if new post to collection.links.href
	    // if old put to item.links.self
	  }

	  function onPoliciesChanged(changes) {
	    $log.debug('onPoliciesChanged', changes);

	    if (vm.property.links.self) {
	      $http.put(vm.property.links.self.href, angular.extend({ code: vm.property.code }, changes)).then(function () {
	        //console.log(res.data);
	        $state.go($state.current, {}, { reload: true });
	      });
	    }
	  }

	  function addProperty(property) {
	    lectusApi.then(function (api) {
	      $http.post(api.links.properties.href, property).then(function (res) {
	        //console.log(res.data);
	        $state.go("property.datasheet", { property: res.data.code });
	      });
	    });
	  }

	  function confirmDelete($event) {
	    var confirm = $mdDialog.confirm().title('Supprimer l\'établissement ' + vm.property.name + '?').textContent('Tous les allotement, produits et tarifs lié a cette catégorie seront supprimés').ariaLabel('Delete property').targetEvent($event).ok('Oui, Supprimer').cancel('Ne pas supprimer');

	    $mdDialog.show(confirm)
	    // then(() => doRemove(unit) );
	    .then(function () {
	      return $http.delete(vm.property.links.self.href);
	    }).then(function () {
	      return $state.go('properties');
	    });
	  }

	  function updateProp() {
	    console.log("updateProp", vm.property);

	    var href = vm.property.links.base;
	    var code = { code: vm.property.code
	      // const href = order.links.index.href;
	      //  const href = order.links.base;
	    };var PATCH_URL = href + "/commands/update-property";

	    $http.post(PATCH_URL, code).then(function (res) {
	      $log.debug('properties', res.data);
	    });
	  }
	}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	'use strict';

	ViewCtrl.$inject = ["datasets", "crmApiUrl", "$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "propertyInfoView",
	  templateUrl: 'app/property/datasheet/view/template.html',
	  controller: ViewCtrl,
	  bindings: {
	    property: '<property',
	    onEdit: '&',
	    updateProp: '&'
	  }
	};


	function ViewCtrl(datasets, crmApiUrl, $http) {
	  'ngInject';

	  var vm = this;

	  if (crmApiUrl && crmApiUrl.indexOf("<<") === -1) {
	    vm.hasGlobalCRMConfig = true;
	  } else {
	    vm.hasGlobalCRMConfig = false;
	  }
	  vm.map = setupGeoUI(this.property);
	  //vm.updateProp=updateProp(this.property);

	  vm.combinableHashMap = {
	    'S': "Séquentielle",
	    'T': "Globale"
	  };
	  // this.property.brand=parseInt(this.property.brand);
	  // this.property.brand=this.property.brand-1;
	  console.log("property:::", vm.property);

	  datasets.bindSets(["rating-systems"], vm, true).then(function (results) {
	    console.log(results);
	  });
	  // datasets.bindSets(["brands"],vm).then(results => {
	  //   console.log("brandsresults",results);

	  //    vm.brands=results.items;
	  //   console.log("brandsresults",vm.brands);
	  // });


	  datasets.get("brands").then(function (results) {
	    console.log("brandsrresultsesults", results);

	    vm.brandss = results.items;
	    console.log("brandsrresultsesultsitems", results.items);
	  });
	  function setupGeoUI(property) {
	    var lat = property.coordinates[1] || 33.027;
	    var lng = property.coordinates[0] || -7.086;
	    return {
	      center: {
	        lat: lat,
	        lng: lng,
	        zoom: 12
	      },
	      markers: {
	        property: {
	          lat: lat,
	          lng: lng,
	          focus: true
	        }
	      }
	    };
	  }

	  function updatePropa(property) {
	    console.log("updateProp", property);

	    var href = property.links.base;
	    var code = { code: property.code
	      // const href = order.links.index.href;
	      //  const href = order.links.base;
	    };var PATCH_URL = href + "/commands/update-property";

	    $http.post(PATCH_URL, code).then(function (res) {
	      $log.debug('properties', res.data);
	    });
	  }
	}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PropertyInfoEditCtrl.$inject = ["$log", "datasets", "$q", "$scope", "$http", "Upload", "apiUrl", "crmApiUrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DeepDiff = __webpack_require__(85);
	var moment = __webpack_require__(10);

	exports.default = {
	  name: "propertyInfoEdit",
	  controller: PropertyInfoEditCtrl,
	  templateUrl: "app/property/datasheet/edit/template.html",
	  bindings: {
	    property: "<property",
	    onClose: "&",
	    onChange: "&",
	    onCreate: "&",
	    target: "<"

	  }
	};


	function PropertyInfoEditCtrl($log, datasets, $q, $scope, $http, Upload, apiUrl, crmApiUrl) {
	  "ngInject";

	  var vm = this;

	  console.log('crmConfig : ', crmApiUrl);

	  var allRatingSystems = [];

	  vm.$onInit = function () {
	    if (vm.property) {
	      // vm.property.brand=parseInt(vm.property.brand);
	      if (vm.property.brand) {
	        vm.property.brand = vm.property.brand.code;
	      }
	      vm.original = decode(vm.property);

	      // vm.getSuppliers = getSuppliers
	      // make editable copy
	      vm.copy = angular.copy(vm.original);
	      vm.copy.combination_rule = vm.copy.combination_rule || 'T';
	      vm.map = setupGeoUI(vm.copy);
	    } else {
	      scaffold();
	    }

	    if (crmApiUrl && crmApiUrl.indexOf("<<") === -1) {
	      vm.hasGlobalCRMConfig = true;
	      vm.copy.crmAdresse = crmApiUrl;
	    } else {
	      vm.hasGlobalCRMConfig = false;
	    }

	    angular.extend(vm, {
	      save: save,
	      options: {
	        timezones: moment.tz.names()
	      }
	    });

	    datasets.bindSets(["property-types", "countries", "destinations", "brands"], vm.options);
	    datasets.get("rating-systems").then(function (collection) {
	      allRatingSystems = collection.items;
	      vm.options.ratingSystems = collection.items;
	      setupRatingSystems(collection.items, vm.copy);
	    });
	    //vm.copy = angular.copy(vm.property);
	    //
	    $scope.$watch(function () {
	      return vm.copy.type;
	    }, propertyTypeChanged);

	    // if (!isValidURL(vm.copy.crmAdresse)) {
	    //   datasheetEditForm.crmAdresse.$setValidity('validationError', false);
	    //   // Angular will make datasheetEditForm.crmAdresse.$error.validationError = true;
	    // }
	  };

	  function isValidURL(string) {
	    var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
	    return res !== null;
	  }

	  vm.getSuppliers = function (searchTxt) {
	    //http://crm.sotlamer.travel/api/legalpersons?&classification=2
	    //&str"+ searchText
	    //console.log('crmapi URL')
	    if (isValidURL(vm.copy.crmAdresse)) {
	      return $http({
	        method: 'GET',
	        //   url: vm.copy.crmAdresse + "/persons?criteria=" + searchTxt+"&group=0"
	        //     url: vm.copy.crmAdresse + "/suppliers?criteria=" + searchTxt+"&group=0"
	        url: vm.copy.crmAdresse + "/suppliers?criteria=" + searchTxt + "&group=-1"

	        //AV
	        // url: vm.copy.crmAdresse + "/persons?criteria=" + searchTxt+"&group=1"

	      }).then(function (response) {
	        //console.log('supplier data', response)
	        //response.data = response.data && response.data.contents && Array.isArray(response.data.contents) ? response.data.contents : [];
	        if (response && response.data && response.data.content) {
	          return response.data.content.map(supplierEncode).filter(supplierFilter);
	        } else {
	          return [];
	        }
	      });
	    } else {
	      return [];
	    }
	  };

	  function supplierEncode(supplier) {
	    return {
	      code: supplier.id,
	      name: supplier.name
	    };
	  }

	  // vm.selectedSupplier = function (supplier) {
	  //   vm.copy.accountingCode = supplier.id;
	  // }


	  function supplierFilter(supplier) {
	    if (supplier.name && supplier.name !== "") return true;else return false;
	  }

	  vm.giataDestinations = function (searchText) {

	    return $http({
	      method: 'GET',
	      // url: "https://locations.atlasvoyages.com/apollo-giata/api/pois?lang=en&qt=byName&str=" + searchText
	      url: vm.copy.crmAdresse + "/destinations?name=" + searchText
	      // url: "http://crmapi.atlasvoyages.com/api/destinations?name="+searchText

	    }).then(function (response) {
	      console.log('response data', response);
	      // response.data = response.data && Array.isArray(response.data) ? response.data : [];

	      // crm
	      response.data = response.data && Array.isArray(response.data.content) ? response.data.content : [];
	      //console.log('response.content...', response)
	      //console.log('response.content...', response.body)
	      //console.log('response.content...', response.data)

	      return response.data.map(destinationEncodeCrm);
	      //return response.data.map(destinationEncodeLocations);
	    });
	  };

	  function destinationEncodeLocations(destination) {
	    console.log('destination...', destination);
	    return {
	      code: parseInt(destination._id, 10),
	      name: destination.DestinationName,
	      countryCode: destination.CountryCode,
	      countryName: destination.CountryName
	    };
	  }

	  function destinationEncodeCrm(destination) {
	    console.log('destination...', destination);
	    if (destination.country != null) {
	      return {
	        code: parseInt(destination.sourceCode, 10),
	        name: destination.name,
	        countryCode: destination.country.alpha2,
	        countryName: destination.country.nameEn
	      };
	    } else {
	      return {
	        code: parseInt(destination.sourceCode, 10),
	        name: destination.name
	      };
	    }
	  }

	  function scaffold() {
	    vm.copy = {
	      coordinates: [-7.086, 33.027]
	    };
	    vm.map = setupGeoUI(vm.copy);
	    vm.map.center.zoom = 5;
	  }

	  function decode() {

	    // console.log('property...', vm.property);
	    var decoded = angular.copy(vm.property);
	    // relations
	    decoded.type = decoded.type ? decoded.type.code : undefined;
	    // decoded.locality = decoded.locality ? decoded.locality.code : undefined;
	    // vm.dest = decoded.locality
	    // angular cannot parse string as number in ngModel
	    decoded.taxes = decoded.taxes ? parseFloat(decoded.taxes, 10) : undefined;
	    return decoded;
	  }

	  function isNew() {
	    // console.log("isNew", vm.original)

	    return !_.isObject(vm.original);
	  }

	  function propertyTypeChanged(newVal, oldVal) {
	    if (angular.isUndefined(newVal) || newVal && oldVal && newVal.code === oldVal.code) {
	      return;
	    }
	    vm.options.ratingSystems = allRatingSystems.filter(function (sys) {
	      return _.includes(sys.propertyTypes, newVal.code);
	    });
	  }

	  function setupGeoUI(property) {
	    var lat = property.coordinates[1] || 33.027;
	    var lng = property.coordinates[0] || -7.086;
	    //  const lat = 33.027;
	    //const lng = -7.086;
	    $scope.$on("leafletDirectiveMarker.dragend", function (event, args) {
	      var marker = vm.map.markers.property;
	      //$log.debug(event);
	      marker.lat = parseFloat(args.model.lat.toFixed(10), 10);
	      marker.lng = parseFloat(args.model.lng.toFixed(10), 10);
	    });
	    $scope.$on("leafletDirectiveMap.click", function (event, args) {
	      //$log.debug(args);
	      var marker = vm.map.markers.property;
	      marker.lat = parseFloat(args.leafletEvent.latlng.lat.toFixed(10), 10);
	      marker.lng = parseFloat(args.leafletEvent.latlng.lng.toFixed(10), 10);
	    });
	    return {
	      center: {
	        lat: lat,
	        lng: lng,
	        zoom: 12
	      },
	      markers: {
	        property: {
	          lat: lat,
	          lng: lng,
	          message: "Positionnez ce markeur",
	          focus: true,
	          draggable: true
	        }
	      },
	      events: { // or just {} //all events
	        markers: {
	          enable: ['dragend', 'click']
	          //logic: 'emit'
	        }
	      }
	    };
	  }

	  function setupRatingSystems(systems, property) {
	    var selected = Object.keys(property.rating || {});
	    systems.filter(function (sys) {
	      return _.includes(selected, sys.code);
	    }).forEach(function (sys) {
	      return sys.selected = true;
	    });
	  }

	  function upload() {
	    console.log("vm.target", vm.target);

	    vm.uploading = true;
	    return Upload.upload({
	      url: vm.target,
	      data: {
	        file: vm.file
	      }
	    }).then(function (res) {
	      // console.log("vm.target", vm.target);
	      // console.log('Success1 ' + res.config.data.file.name + 'uploaded. Response: ' + res.data);
	      $log.debug('Success ' + res.config.data.file.name + 'uploaded. Response: ' + res.data);
	      vm.onSaved({
	        mediaInfo: res.data
	      });
	      return res.data;
	    }, function (res) {
	      $log.debug('Error status: ' + res.status);
	      vm.uploading = false;
	      return res;
	    }
	    // , function (evt) {
	    //     var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	    //     $log.debug('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    // }
	    );
	  }

	  function save() {
	    encode().then(function (encoded) {

	      if (isNew()) {
	        return vm.onChange({
	          changes: encoded
	        });
	      }
	      var changes = {};
	      DeepDiff(vm.original, encoded).map(function (d) {
	        return d.path[0];
	      }).forEach(function (field) {
	        changes[field] = encoded[field];
	      });
	      vm.onChange({
	        changes: changes
	      });
	    });
	  }

	  function encode() {
	    // addDestination()
	    var defer = $q.defer();
	    addCountry().then(function (country) {
	      // console.log('country....', country)
	      addDestination().then(function (destination) {

	        // console.log('--------destination---------', destination)
	        // console.log('--------copy---------', vm.copy.locality)
	        vm.copy.locality = destination.code;
	        //vm.copy.locality = vm.dist._id;
	        vm.copy.country = country.code;
	        console.log('accountingCode....', vm.copy);
	        var accountingCode = void 0;

	        if (angular.isString(vm.copy.accountingCode)) {
	          accountingCode = vm.copy.accountingCode;
	        } else if (vm.copy.accountingCode && angular.isObject(vm.copy.accountingCode)) {
	          accountingCode = vm.copy.accountingCode.code;
	        }
	        //  return
	        vm.copy.accountingCode = accountingCode;
	        var property = angular.copy(vm.copy);
	        var valuesMap = property.rating;
	        property.rating = vm.options.ratingSystems.filter(function (sys) {
	          return sys.selected;
	        }).reduce(function (agg, sys) {
	          agg[sys.code] = valuesMap[sys.code];
	          return agg;
	        }, {});

	        // geo
	        property.coordinates = [vm.map.markers.property.lng, vm.map.markers.property.lat];

	        defer.resolve(property);
	      });
	    });

	    return defer.promise;
	  }

	  function getCountry(countryCode) {

	    // var apiUrl = vm.property.links.base;
	    var defer = $q.defer();
	    $http.get(apiUrl + "/countries/" + countryCode).then(function (res) {
	      console.log('get country', res.data);
	      defer.resolve(res.data);
	    }, function (res) {
	      if (res.status === 404) {
	        console.log('Country..', res);
	        defer.resolve(null);
	      } else {
	        defer.reject(res.statusText);
	      }
	    });

	    return defer.promise;
	  }

	  function getDestinationByCode(destinationCode) {
	    console.log(' destination to get', destinationCode);

	    //var apiUrl = vm.property.links.base;
	    var defer = $q.defer();
	    $http.get(apiUrl + "/destinations/" + destinationCode).then(function (res) {
	      console.log('get destination', res.data);
	      defer.resolve(res.data);
	    }, function (res) {
	      if (res.status === 404) {
	        console.log('destination..', res);
	        defer.resolve(null);
	      } else {
	        defer.reject(res.statusText);
	      }
	    });

	    return defer.promise;
	  }

	  function addDestination() {

	    // var apiUrl = vm.property.links.base;
	    var defer = $q.defer();
	    var dest = vm.copy.locality;

	    console.log('dest before post ', vm.copy.locality);
	    console.log('dest.code before post ', vm.copy.locality.code);
	    getDestinationByCode(dest.code).then(function (destination) {
	      if (destination == null) {
	        destination = {
	          code: dest.code,
	          name: {
	            en: dest.name,
	            fr: dest.name
	          },
	          country: dest.countryCode
	        };
	        console.log('dest before post ', destination);

	        $http.post(apiUrl + "/destinations", destination).then(function (res) {
	          $scope.$emit("created", res.data);
	          defer.resolve(res.data);
	        }, function (e) {
	          $log.error(arguments);
	          defer.reject(e);
	        });
	      } else {
	        console.log('dest resolve ', destination);

	        defer.resolve(destination);
	      }
	    });

	    return defer.promise;
	  }

	  function addCountry() {

	    // var apiUrl = apiUrl
	    // "http://localhost:3030"
	    //vm.property.links.base;
	    console.log('addCountry apiUrl..', apiUrl);
	    var defer = $q.defer();

	    var dest = vm.copy.locality;
	    var countryCode = dest.countryCode || dest.country;

	    getCountry(countryCode).then(function (country) {
	      if (country == null) {
	        country = {
	          code: countryCode,
	          name: {
	            en: dest.countryName,
	            fr: dest.countryName
	          }
	        };

	        $http.post(apiUrl + "/countries", country).then(function (res) {
	          $scope.$emit("created", res.data);
	          defer.resolve(res.data);
	        }, function (e) {
	          $log.error(arguments);
	          defer.reject(e);
	        });
	      } else {
	        defer.resolve(country);
	      }
	    });
	    return defer.promise;
	  }
	}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	module.exports = DeepDiff;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	'use strict';

	PropertyContactstCtrl.$inject = ["$log", "$http", "$mdDialog"];
	ContactAddCtrl.$inject = ["$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "propertyContacts",
	  controller: PropertyContactstCtrl,
	  templateUrl: 'app/property/contacts/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PropertyContactstCtrl($log, $http, $mdDialog) {
	  "ngInject";

	  var vm = this;
	  vm.$onInit = function () {
	    vm.contacts = vm.propertyCtrl.property.contacts || [];
	    vm.remove = remove;
	    vm.add = add;
	  };

	  function remove(contact) {
	    var index = vm.contacts.indexOf(contact);
	    if (index === -1) return;

	    vm.contacts.splice(index, 1);
	    $http.put(vm.propertyCtrl.property.links.self.href, {
	      code: vm.propertyCtrl.property.code,
	      contacts: vm.contacts
	    });
	  }

	  function add() {
	    $mdDialog.show({
	      controller: ContactAddCtrl,
	      controllerAs: '$ctrl',
	      templateUrl: 'app/property/contacts/add.html'
	    }).then(function (contact) {
	      vm.contacts.push(contact);
	      $http.put(vm.propertyCtrl.property.links.self.href, {
	        code: vm.propertyCtrl.property.code,
	        contacts: vm.contacts
	      });
	    });
	  }
	}

	function ContactAddCtrl($mdDialog) {
	  "ngInject";

	  var vm = this;
	  vm.contact = {
	    usage: '',
	    medium: 'tel',
	    value: ''
	  };

	  angular.extend(vm, {
	    usage: {
	      'default': 'Géneral',
	      booking: 'Résevations',
	      accounting: 'Comptabilité',
	      commercial: 'Commercial'
	    },
	    medium: {
	      'tel': 'Télephone',
	      'email': 'Email',
	      'fax': 'Fax'
	    },
	    confirm: confirm,
	    cancel: cancel
	  });

	  function confirm() {
	    $mdDialog.hide(vm.contact);
	  }

	  function cancel() {
	    $mdDialog.cancel();
	  }
	}

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	'use strict';

	PoliciesCtrl.$inject = ["$log", "ccCodeSet"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "propertyPolicies",
	  controller: PoliciesCtrl,
	  templateUrl: 'app/property/policies/view/template.html',
	  bindings: {
	    property: '<property',
	    onEdit: '&',
	    languages: '<'
	  }
	};


	function PoliciesCtrl($log, ccCodeSet) {
	  "ngInject";

	  var vm = this;
	  vm.$onInit = function () {};

	  vm.cc = ccCodeSet;
	}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PoliciesEditCtrl.$inject = ["$log", "$scope", "$http", "ccCodeSet"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _ = __webpack_require__(5);
	var moment = __webpack_require__(10);
	var DeepDiff = __webpack_require__(85);

	exports.default = {
	  name: "propertyPoliciesEdit",
	  controller: PoliciesEditCtrl,
	  templateUrl: 'app/property/policies/edit/template.html',
	  bindings: {
	    property: "<property",
	    onClose: "&",
	    onChange: "&"
	  }
	};


	function PoliciesEditCtrl($log, $scope, $http, ccCodeSet) {
	  "ngInject";

	  var vm = this;

	  vm.$onInit = function () {
	    // need to get property with ALL translations (no lang in Accept-Language)
	    // so that we can show all translations... bad design.
	    $http.get(vm.property.links.self.href, {
	      headers: {
	        'Accept-Language': "**"
	      }
	    }).then(function (res) {
	      var original = res.data.policies || {};
	      angular.extend(vm, {
	        original: original,
	        copy: decode(original),
	        addAgeSegment: addAgeSegment,
	        filterInfant: filterInfant,
	        save: save
	      });
	    });
	    //console.log(vm.copy)
	  };

	  function filterInfant(index) {
	    return index !== 0;
	  }

	  function decode(policies) {
	    var DEFAULTS = {
	      checkout: "12:00",
	      checkin: "14:00",
	      age: [2, 12],
	      name: [],
	      petsAllowed: false,
	      adultsOnly: false,
	      cc: []
	    };
	    var copy = _.defaults(_.omitBy(policies, function (val) {
	      return val === null;
	    }), DEFAULTS);
	    console.log("policies", policies);
	    console.log("copy", copy);

	    //Hack infant age=0
	    copy.age[0] = 0;
	    copy.name[0] = "bebe";
	    copy.checkout = moment(copy.checkout, "HH:mm").toDate();
	    copy.checkin = moment(copy.checkin, "HH:mm").toDate();
	    copy.hasOther = _.isObject(copy.other);
	    copy.hasOther = _.isObject(copy.other);
	    console.log(" copy.hasOther", copy.hasOther);
	    console.log(" hasOther", copy.hasOther);
	    var cc = Array.from(ccCodeSet.entries()).map(function (e) {
	      return {
	        code: e[0],
	        name: e[1].name,
	        selected: copy.cc.includes(e[0])
	      };
	    });
	    copy.cc = cc;
	    return copy;
	  }

	  function encode(copy) {
	    var encoded = {
	      checkout: moment(copy.checkout).format("HH:mm"),
	      checkin: moment(copy.checkin).format("HH:mm"),
	      adultsOnly: copy.adultsOnly,
	      age: copy.adultsOnly ? null : _.uniq(copy.age).sort(function (a, b) {
	        return a - b;
	      }),
	      name: copy.adultsOnly ? null : copy.name,
	      // age: copy.age ,

	      petsAllowed: copy.petsAllowed,
	      pets: copy.petsAllowed ? copy.pets : "null",
	      other: copy.hasOther ? copy.other : null,
	      cc: copy.cc.filter(function (o) {
	        return o.selected;
	      }).map(function (o) {
	        return o.code;
	      })
	      // if age policy is lectus default, omit it
	      // if (_.isEqual(encoded.age, [2,12])) {
	      //   encoded.age = null;
	      // }
	    };console.log(encoded);

	    return encoded;
	  }

	  function save() {
	    var encoded = encode(vm.copy);
	    console.log("encoded:::", encoded);

	    var changes = {};
	    DeepDiff(vm.original, encoded).map(function (d) {
	      return d.path[0];
	    }).forEach(function (field) {
	      console.log(field);
	      changes[field] = encoded[field];
	    });

	    //changes=encoded;
	    changes['age'] = encoded['age'];
	    changes['name'] = encoded['name'];
	    $log.debug("changes", changes);
	    console.log(changes);
	    console.log("changes::", changes);

	    // diff =
	    //console.log(changes);
	    // vm.onChange({changes:{policies:changes}})

	    vm.onChange({
	      changes: {
	        policies: changes
	      }
	    });
	  }

	  function addAgeSegment() {
	    vm.copy.age.push(16);
	  }
	}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PropertyUnitsCtrl.$inject = ["$log", "$state", "$mdDialog", "$http", "$q", "datasets"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _controller = __webpack_require__(90);

	var _controller2 = _interopRequireDefault(_controller);

	var _controller3 = __webpack_require__(91);

	var _controller4 = _interopRequireDefault(_controller3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  name: "propertyUnits",
	  controller: PropertyUnitsCtrl,
	  templateUrl: 'app/property/units/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PropertyUnitsCtrl($log, $state, $mdDialog, $http, $q, datasets) {
	  "ngInject";

	  var vm = this;
	  vm.query = {
	    limit: 20,
	    order: 'code',
	    page: 1
	  };
	  vm.$onInit = function () {
	    datasets.bindSets(["unit-types"], vm, true);
	    loadUnits().then(function () {
	      angular.extend(vm, {
	        add: add,
	        edit: edit,
	        combinationsEdit: combinationsEdit,
	        remove: remove,
	        moveUp: moveUp
	      });
	    });
	  };

	  function loadUnits() {
	    return vm.propertyCtrl.get('units').then(function (collection) {
	      return angular.extend(vm, collection);
	    });
	  }

	  function add(ev) {
	    $mdDialog.show(_editDialog(ev, null)).then(function (result) {
	      $log.debug('new unit', result);
	      vm.items.push(result);
	      // add to units list,
	      // or do a new http request ?
	      // $scope.$emit('property:changed',{relation:'units'})
	    });
	  }

	  function edit(ev, unit) {
	    $mdDialog.show(_editDialog(ev, unit)).then(function (result) {
	      $log.debug('edit unit', result);
	      loadUnits();
	      //const index = vm.items.indexOf(unit);
	      //vm.items[index] = result;
	      // add to units list,
	      // or do a new http request ?
	      // $scope.$emit('property:changed',{relation:'units'})
	    });
	  }

	  function combinationsEdit(ev, unit) {
	    $mdDialog.show(_CombinationsEditDialog(ev, unit)).then(function (result) {
	      $log.debug('edit unit', result);
	      //  loadUnits()
	      //const index = vm.items.indexOf(unit);
	      //vm.items[index] = result;
	      // add to units list,
	      // or do a new http request ?
	      // $scope.$emit('property:changed',{relation:'units'})
	    });
	  }

	  function _CombinationsEditDialog($event, unit) {
	    return {
	      templateUrl: 'app/property/units/policies-combinations/template.html',
	      controller: _controller4.default,
	      controllerAs: '$ctrl',
	      targetEvent: $event,
	      locals: {
	        unit: unit,
	        units: vm.items,
	        unitsHref: vm.links.self.href,
	        propertyCtrl: vm.propertyCtrl
	      }
	    };
	  }

	  function _editDialog($event, unit) {
	    return {
	      templateUrl: 'app/property/units/edit/template.html',
	      controller: _controller2.default,
	      controllerAs: '$ctrl',
	      targetEvent: $event,
	      locals: {
	        unit: unit,
	        units: vm.items,
	        unitsHref: vm.links.self.href,
	        propertyCtrl: vm.propertyCtrl
	      }
	    };
	  }

	  function moveUp($event, i) {
	    var unit = vm.items[i];
	    var previous = vm.items[i - 1];
	    if (i < 1) return;

	    previous.weight += 1;
	    unit.weight -= 1;
	    var promises = [previous, unit].map(function (u) {
	      return $http.put(u.links.self.href, _.pick(u, ["code", "weight"]));
	    });

	    $q.all(promises).then(function () {
	      vm.items[i - 1] = unit;
	      vm.items[i] = previous;
	    });
	  }

	  function remove($event, unit) {
	    var confirm = $mdDialog.confirm().title('Supprimer cette catégorie?').textContent('Tous les allotement, produits et tarifs lié a cette catégorie seront supprimés').ariaLabel('Delete unit category').targetEvent($event).ok('Supprimer').cancel('Ne pas supprimer');

	    $mdDialog.show(confirm)
	    // then(() => doRemove(unit) );
	    .then(function () {
	      return $http.delete(unit.links.self.href);
	    }).then(function () {
	      return $state.reload();
	    });
	  }
	}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	UnitEditCtrl.$inject = ["$log", "$mdDialog", "datasets", "$http", "unit", "units", "unitsHref", "lectusLanguages", "propertyCtrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UnitEditCtrl;
	var _ = __webpack_require__(5);

	function UnitEditCtrl($log, $mdDialog, datasets, $http, unit, units, unitsHref, lectusLanguages, propertyCtrl) {
	  "ngInject";

	  var vm = this;

	  vm.langs = lectusLanguages;

	  if (unit === null) {
	    init({
	      code: -1,
	      name: {},
	      type: null,
	      area: null,
	      count: null,
	      weight: units.length + 1,
	      occupancy: {}
	    });
	  } else {
	    $log.debug("get unit");
	    $http({
	      method: "GET",
	      url: unit.links.self.href,
	      headers: {
	        "Accept-Language": "**"
	      },
	      data: _.pick(unit, ["code", "name", "type", "area", "count", "occupancy", "maxOccupancy"])
	    }).then(function (res) {
	      return init(res.data);
	    });
	  }

	  function init(unit) {
	    datasets.get("unit-types").then(function (collection) {
	      return vm.unitTypes = collection.items;
	    });

	    vm.property = propertyCtrl.property;
	    // console.log("vm.property", vm.property);
	    // console.log("vm.propertyCtrl", vm.propertyCtrl);
	    // console.log("vm.property", propertyCtrl.property);
	    // console.log("vm.property", propertyCtrl);

	    angular.extend(vm, {
	      status: "loading",
	      title: unit.code === -1 ? "Nouvelle catégorie d'unités" : "Modifier la catégorie " + (unit.name && unit.name.fr ? unit.name.fr : unit.name),
	      copy: unit,
	      existingNames: units.map(function (u) {
	        return u.name;
	      }),
	      save: save,
	      cancel: function cancel() {
	        return $mdDialog.cancel();
	      },
	      inputs: {
	        adults: {
	          label: "Adultes",
	          min: 0,
	          max: 1
	        },
	        children: {
	          label: "Enfants",
	          min: 0,
	          max: 0
	        },
	        infants: {
	          label: "Bébé",
	          min: 0,
	          max: 0
	        }
	      }
	      //  policiesCombinations: combinations(vm.property.policies.age), //k_combinations(vm.property.policies.age,p.product, 3)
	    });

	    initPolicyCombinations();
	  }

	  function combsWithRep(n, lst) {
	    return n ? lst.length ? combsWithRep(n - 1, lst).map(function (t) {
	      return [lst[0]].concat(t);
	    }).concat(combsWithRep(n, lst.slice(1))) : [] : [[]];
	  }

	  function initPolicyCombinations() {
	    var allCombinations = [];
	    //i can be set to min enfant

	    if (vm.copy && vm.copy.occupancy && vm.copy.occupancy.children && !isNaN(vm.copy.occupancy.children.max)) {
	      for (var i = 0; i <= vm.copy.occupancy.children.max; i++) {
	        var combs = combsWithRep(i, vm.property.policies.age);
	        var index = -1;
	        var length = combs == null ? 0 : combs.length;

	        while (++index < length) {
	          var entry = combs[index];
	          if (entry && entry.length > 0) allCombinations.push({
	            label: entry,
	            value: true
	          });
	        }
	      }
	    }

	    console.log("allCombinations...", allCombinations);
	    vm.policiesCombinations = allCombinations;
	  }

	  function initPolicyCombinations_old() {
	    var allCombinations = [];
	    //i can be set to min enfant
	    for (var i = 0; i < vm.copy.occupancy.children.max; i++) {
	      var combs = k_combinations(vm.property.policies.age, i + 1);
	      var index = -1;
	      var length = combs == null ? 0 : combs.length;

	      while (++index < length) {
	        var entry = combs[index];
	        allCombinations.push({
	          label: entry,
	          value: true
	        });
	      }
	    }

	    console.log("allCombinations...", allCombinations);
	    vm.policiesCombinations = allCombinations;
	  }

	  //https://gist.github.com/axelpale/3118596
	  function k_combinations(set, k) {
	    var i, j, combs, head, tailcombs;

	    // There is no way to take e.g. sets of 5 elements from
	    // a set of 4.
	    if (k > set.length || k <= 0) {
	      return [];
	    }

	    // K-sized set has only one K-sized subset.
	    if (k == set.length) {
	      return [set];
	    }

	    // There is N 1-sized subsets in a N-sized set.
	    if (k == 1) {
	      combs = [];
	      for (i = 0; i < set.length; i++) {
	        combs.push([set[i]]);
	      }
	      return combs;
	    }

	    // Assert {1 < k < set.length}

	    // Algorithm description:
	    // To get k-combinations of a set, we want to join each element
	    // with all (k-1)-combinations of the other elements. The set of
	    // these k-sized sets would be the desired result. However, as we
	    // represent sets with lists, we need to take duplicates into
	    // account. To avoid producing duplicates and also unnecessary
	    // computing, we use the following approach: each element i
	    // divides the list into three: the preceding elements, the
	    // current element i, and the subsequent elements. For the first
	    // element, the list of preceding elements is empty. For element i,
	    // we compute the (k-1)-computations of the subsequent elements,
	    // join each with the element i, and store the joined to the set of
	    // computed k-combinations. We do not need to take the preceding
	    // elements into account, because they have already been the i:th
	    // element so they are already computed and stored. When the length
	    // of the subsequent list drops below (k-1), we cannot find any
	    // (k-1)-combs, hence the upper limit for the iteration:
	    combs = [];
	    for (i = 0; i < set.length - k + 1; i++) {
	      // head is a list that includes only our current element.
	      head = set.slice(i, i + 1);
	      // We take smaller combinations from the subsequent elements
	      tailcombs = k_combinations(set.slice(i + 1), k - 1);
	      // For each (k-1)-combination we join it with the current
	      // and store it to the set of k-combinations.
	      for (j = 0; j < tailcombs.length; j++) {
	        combs.push(head.concat(tailcombs[j]));
	      }
	    }
	    return combs;
	  }

	  function combinations(set) {
	    console.log("children ages policies ", set);
	    var k, i, combs, k_combs;
	    combs = [];
	    //  if (productHasGreaterThenTwoChilds(product.occupancy)) {
	    // Calculate all non-empty k-combinations
	    for (k = 1; k <= set.length; k++) {
	      k_combs = k_combinations(set, k);
	      for (i = 0; i < k_combs.length; i++) {
	        combs.push({
	          label: k_combs[i].join(" , "),
	          value: true
	        });
	      }
	    }
	    //  }

	    return combs;
	  }

	  function save() {
	    //var occp= vm.inputs;
	    var occp;
	    if (vm.property.policies.adultsOnly == true) {
	      occp = {
	        adults: {
	          label: "Adultes",
	          min: vm.copy.occupancy.adults.min,
	          max: vm.copy.occupancy.adults.max
	        },
	        children: {
	          label: "Enfants",
	          min: 0,
	          max: 0
	        },
	        infants: {
	          label: "Bébé",
	          min: 0,
	          max: 0
	        }
	      };
	    } else {
	      occp = {
	        adults: {
	          label: "Adultes",
	          min: vm.copy.occupancy.adults.min,
	          max: vm.copy.occupancy.adults.max
	        },
	        children: {
	          label: "Enfants",
	          min: vm.copy.occupancy.children.min,
	          max: vm.copy.occupancy.children.max
	        },
	        infants: {
	          label: "Bébé",
	          min: 0, //vm.copy.occupancy.infants.min,
	          max: 0 // vm.copy.occupancy.infants.max,
	        }
	      };
	    }
	    //  var occp=   {
	    //     adults: {
	    //       label: "Adultes",
	    //        min: vm.adult.min,
	    //       max: vm.adult.max
	    //     },
	    //     children: {
	    //       label: "Enfants",
	    //       min: vm.enfant.min,
	    //       max: vm.enfant.max
	    //     },
	    //     infants: {
	    //       label: "Bébé",
	    //       min: vm.bebe.min,
	    //       max: vm.bebe.max
	    //     }
	    //   }

	    var unit = vm.copy;
	    unit.occupancy = occp;

	    $log.debug("save", unit);
	    var promise;
	    if (unit.code === -1) {
	      promise = $http({
	        method: "POST",
	        url: unitsHref,
	        headers: {
	          "Content-Language": "**"
	        },
	        data: _.pick(unit, ["name", "type", "area", "count", "occupancy", "maxOccupancy"])
	      });
	    } else {
	      // shoud just send diff anuse patch
	      promise = $http({
	        method: "PUT",
	        url: unit.links.self.href,
	        headers: {
	          "Content-Language": "**"
	        },
	        data: _.pick(unit, ["code", "name", "type", "area", "count", "occupancy", "maxOccupancy"])
	      });
	    }
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	  }

	  function close(unit) {
	    $log.debug("close", unit);
	    $mdDialog.hide(unit);
	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }
	}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	policiesCombinationsEditCtrl.$inject = ["$log", "$mdDialog", "datasets", "$http", "unit", "units", "unitsHref", "lectusLanguages", "propertyCtrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = policiesCombinationsEditCtrl;
	var _ = __webpack_require__(5);

	function policiesCombinationsEditCtrl($log, $mdDialog, datasets, $http, unit, units, unitsHref, lectusLanguages, propertyCtrl) {
	  "ngInject";

	  var vm = this;

	  vm.langs = lectusLanguages;
	  if (unit === null) return;
	  //   let roomHashMap = {
	  //     0: '0 adultes',
	  //     1: 'Ch. single',
	  //     2: 'Ch. double',
	  //     3: 'Ch. triple',
	  //     4: 'Ch. quadruple'
	  //   };
	  $log.debug("get unit");
	  $http({
	    method: "GET",
	    url: unit.links.self.href,
	    headers: {
	      "Accept-Language": "**"
	    },
	    data: _.pick(unit, ["code", "name", "type", "area", "count", "occupancy", "maxOccupancy"])
	  }).then(function (res) {
	    return init(res.data);
	  });

	  function init(unit) {

	    console.log('on unit ..', unit);
	    datasets.get("unit-types").then(function (collection) {
	      return vm.unitTypes = collection.items;
	    });

	    vm.property = propertyCtrl.property;

	    // title: unit.code === -1 ?
	    //     "Nouvelle catégorie d'unités" : "Modifier la catégorie " +
	    //     (unit.name && unit.name.fr ? unit.name.fr : unit.name),
	    angular.extend(vm, {
	      status: "loading",
	      title: 'Règles de combinabilitée de la catégorie : ' + (unit.name && unit.name.fr ? unit.name.fr : unit.name),
	      copy: unit,
	      save: save,
	      changeSelectAllState: changeSelectAllState,
	      cancel: function cancel() {
	        return $mdDialog.cancel();
	      }
	    });

	    $log.debug('vm.copy.occupancy ..', vm.copy.occupancy);
	    $log.debug('vm.property.policies ..', vm.property.policies);
	    initPoliciesCombinations();
	  }

	  function changeSelectAllState(comb) {
	    comb.childrens.forEach(function (child) {
	      child.selected = angular.copy(comb.selectAll);
	    });
	  }

	  function combsWithRep(n, lst) {
	    return n ? lst.length ? combsWithRep(n - 1, lst).map(function (t) {
	      return [lst[0]].concat(t);
	    }).concat(combsWithRep(n, lst.slice(1))) : [] : [[]];
	  }

	  function adultLabelFormatter(i) {
	    return i == 1 ? i + ' Adulte' : i + ' Adultes';
	  }

	  function bebeLabelFormatter(i) {
	    return i == 1 ? i + ' Bébé' : i + ' Bébés';
	  }

	  function getAllInfants() {
	    var infants = vm.copy.occupancy.infants;
	    var min = infants.min;
	    var max = infants.max;
	    var arr = [];
	    var step = 1;
	    for (var i = min; i <= max; i += step) {
	      arr.push({
	        label: i,
	        value: true
	      });
	    }
	    return arr;
	  }

	  function initPoliciesCombinations() {

	    var allChildrenCombinations = childrenAgesPoliciesCombinations();
	    var adults = vm.copy.occupancy.adults;
	    var min = adults.min;
	    var max = adults.max;
	    var arr = [];
	    var step = 1;
	    for (var i = min; i <= max; i += step) {
	      arr.push({
	        showAllChildrenCombs: false,
	        adults: {
	          label: adultLabelFormatter(i),
	          value: i,
	          selected: true
	        },
	        childrens: applyDefaultChecked(angular.copy(allChildrenCombinations), i)
	        // infants: angular.copy(infants)
	      });
	    }

	    vm.combinations = arr;
	  }

	  function applyDefaultChecked(allChildrenCombinations, adult) {

	    vm.copy.combinations = vm.copy.combinations || [];

	    return allChildrenCombinations.map(function (cmb) {
	      //console.log('---------------------cmb-------------', cmb, adult)
	      var copy = angular.copy(cmb);
	      copy.value.unshift(adult);
	      var joined = copy.value.join('-');
	      if (vm.copy.combinations.indexOf(joined) > -1) {
	        cmb.selected = false;
	      } else {
	        cmb.selected = true;
	      }
	      return cmb;
	    });
	  }

	  //
	  // vm.showAll = function (comb) {

	  // }

	  function childrenAgesPoliciesCombinations() {
	    var allCombinations = [];

	    //console.log('ignoredChildrenCombinations..', ignoredChildrenCombinations)


	    //i can be set to min enfant
	    for (var i = 0; i <= vm.copy.occupancy.children.max; i++) {
	      var combs = combsWithRep(i, vm.property.policies.age);
	      var index = -1;
	      var length = combs == null ? 0 : combs.length;
	      while (++index < length) {
	        var entry = combs[index];
	        if (entry && entry.length > 0) {
	          //console.log('entry', entry)
	          allCombinations.push({
	            label: entry,
	            value: entry,
	            selected: true
	          });
	        }
	      }
	    }

	    // console.log("allCombinations...", allCombinations);
	    return allCombinations;
	  }

	  //   //https://gist.github.com/axelpale/3118596


	  function close(unit) {
	    $log.debug("close", unit);
	    $mdDialog.hide(unit);
	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }

	  function getChildrenCombs(combination) {
	    var i = -1;
	    var length = combination.childrens == null ? 0 : combination.childrens.length;
	    var selectedChildAgesCombs = [];
	    while (++i < length) {
	      var childCombs = combination.childrens[i];
	      console.log('childCombs', childCombs);
	      if (!childCombs.selected) {
	        childCombs.value.unshift(combination.adults.value);
	        selectedChildAgesCombs.push(childCombs.value.join("-"));
	      }
	    }
	    return selectedChildAgesCombs;
	  }

	  function _buildSelectedCombinations(combinations) {

	    var i = -1;
	    var length = combinations == null ? 0 : combinations.length;
	    var selectedCombs = [];
	    while (++i < length) {
	      var combination = combinations[i];
	      console.log('combination...', combination);
	      var adultAndChildsCombs = getChildrenCombs(combination);
	      adultAndChildsCombs.forEach(function (combItem) {
	        selectedCombs.push(combItem);
	      });
	    }
	    return selectedCombs;
	  }

	  function save() {
	    //var occp= vm.inputs;

	    var unit = vm.copy;

	    var selectedCombinations = _buildSelectedCombinations(angular.copy(vm.combinations));
	    //console.log('selectedCombinations..', selectedCombinations);

	    unit.combinations = selectedCombinations;
	    $log.debug("save", unit);
	    var promise;
	    promise = $http({
	      method: "PUT",
	      url: unit.links.self.href,
	      headers: {
	        "Content-Language": "**"
	      },
	      data: _.pick(unit, ["code", "combinations"])
	    });
	    //}
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	  }
	}

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PropertyCommentsCtrl.$inject = ["$log", "$state", "$mdDialog", "$http", "$q", "datasets"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _controller = __webpack_require__(93);

	var _controller2 = _interopRequireDefault(_controller);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  name: "propertyComments",
	  controller: PropertyCommentsCtrl,
	  templateUrl: 'app/property/comments/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PropertyCommentsCtrl($log, $state, $mdDialog, $http, $q, datasets) {
	  "ngInject";

	  var vm = this;
	  vm.$onInit = function () {
	    // datasets.bindSets(["unit-types"],vm,true);
	    loadComments().then(function () {
	      angular.extend(vm, {
	        add: add,
	        edit: edit,
	        remove: remove
	      });
	    });
	  };

	  function loadComments() {
	    return vm.propertyCtrl.get('property-comment').then(function (collection) {
	      return angular.extend(vm, collection);
	    });
	  }

	  function add(ev) {
	    $mdDialog.show(_editDialog(ev, null)).then(function (result) {
	      console.log("itemssss..", vm.items);
	      vm.items.push(result);
	      // add to units list,
	      // or do a new http request ?
	      // $scope.$emit('property:changed',{relation:'units'})
	    });
	  }

	  function edit(ev, comment) {
	    $mdDialog.show(_editDialog(ev, comment)).then(function (result) {
	      $log.debug('edit unit', result);
	      // loadUnits()
	      //const index = vm.items.indexOf(unit);
	      //vm.items[index] = result;
	      // add to units list,
	      // or do a new http request ?
	      // $scope.$emit('property:changed',{relation:'units'})
	    });
	  }

	  function _editDialog($event, comment) {
	    console.log('vm.links', vm.links);
	    return {
	      templateUrl: 'app/property/comments/edit/template.html',
	      controller: _controller2.default,
	      controllerAs: '$ctrl',
	      targetEvent: $event,
	      locals: {
	        target: vm.links.self.href,
	        comment: comment,
	        propertyCtrl: vm.propertyCtrl
	      }
	    };
	  }

	  // function moveUp($event, i) {
	  //   const unit = vm.items[i];
	  //   var previous = vm.items[i - 1];
	  //   if (i < 1) return;

	  //   previous.weight += 1;
	  //   unit.weight -= 1;
	  //   var promises = [previous, unit]
	  //     .map(u => $http.put(u.links.self.href, _.pick(u, ["code", "weight"])));

	  //   $q.all(promises).then(() => {
	  //     vm.items[i - 1] = unit;
	  //     vm.items[i] = previous;
	  //   })
	  // }


	  function remove($event, unit) {
	    var confirm = $mdDialog.confirm().title('Supprimer ce commentaire?').textContent('Tous les documents liés a ce commentaire seront supprimés').ariaLabel('Delete commentaire').targetEvent($event).ok('Supprimer').cancel('Ne pas supprimer');

	    $mdDialog.show(confirm)
	    // then(() => doRemove(unit) );
	    .then(function () {
	      return $http.delete(unit.links.self.href);
	    }).then(function () {
	      return $state.reload();
	    });
	  }
	}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	CommentEditCtrl.$inject = ["$log", "$mdDialog", "Upload", "target", "$q", "comment", "propertyCtrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CommentEditCtrl;
	var _ = __webpack_require__(5);
	//https://github.com/danialfarid/ng-file-upload

	function CommentEditCtrl($log, $mdDialog, Upload, target, $q, comment, propertyCtrl) {
	  "ngInject";

	  var vm = this;

	  console.log('comment..', comment);

	  vm.validation = {
	    size: {
	      max: '40MB'
	    }
	    // width: {min: 600},
	    // height: {min: 800},
	    // pattern: "image/jpeg",
	    // accept: "image/jpeg"
	  };

	  vm.remove = remove;

	  if (comment === null) {
	    comment = {};
	  }
	  init(comment);

	  function init(comment) {
	    vm.property = propertyCtrl.property;
	    angular.extend(vm, {
	      status: 'loading',
	      // title: comment.code === -1 ? "Nouveau commentaire" : "Modifier le commentaire " + comment.label,
	      title: "Nouveau commentaire",
	      copy: comment,
	      save: save,
	      cancel: function cancel() {
	        return $mdDialog.cancel();
	      }
	    });
	  }

	  function upload() {
	    console.log("vm.target ", vm.target);
	    var defer = $q.defer();

	    vm.uploading = true;
	    Upload.upload({
	      url: target,
	      data: vm.copy,
	      file: vm.files
	    }).then(function (res) {
	      $log.debug('Success ' + res.config.data.file.name + 'uploaded. Response: ' + res.data);
	      console.log('res...', res);
	      defer.resolve(res);
	    }, function (res) {
	      $log.debug('Error status: ' + res.status);
	      vm.uploading = false;
	      defer.reject(res);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      $log.debug('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });

	    return defer.promise;
	  }

	  function save() {
	    var promise;
	    promise = upload();
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	  }

	  function close(unit) {
	    $log.debug("close", unit);
	    $mdDialog.hide(unit);
	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }

	  function remove(index) {
	    vm.files.splice(index, 1);
	  }
	}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	"use strict";

	PropertyTagsCtrl.$inject = ["$log", "$http", "$q", "datasets"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "propertyTags",
	  controller: PropertyTagsCtrl,
	  templateUrl: "app/property/tags/template.html",
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PropertyTagsCtrl($log, $http, $q, datasets) {
	  "ngInject";

	  var vm = this;

	  // vm.unitTaFilter = {
	  //   unit: true,
	  //   name: ""
	  // }

	  vm.$onInit = function () {
	    var property = vm.propertyCtrl;
	    // property.setBreadcrumb([{
	    //   label: 'Services & Equipements'
	    // }]);

	    // datasets.bindSets(["unit-types"], vm, true);

	    datasets.get("tags").then(function (collection) {
	      console.log('tags....', collection);
	      vm.options = {
	        tags: collection.items //collection.items
	      };
	    });

	    property.get("tags").then(function (tags) {
	      // vm._propertyAmenities = amenities.items;
	      console.log('property tags....', tags);
	      vm._propertyTags = tags.items;
	      vm.propertyTags = tags.items.map(function (a) {
	        return a.tag;
	      });
	      vm.permissions = tags.permissions;

	      angular.extend(vm, {
	        toggleProperty: togglePropertyTag
	      });
	    });

	    // property.get("amenities").then(amenities => {
	    //   vm._propertyAmenities = amenities.items;
	    //   vm.propertyAmenities = amenities.items.map(a => a.amenity);
	    //   vm.permissions = amenities.permissions;
	    // })

	    // vm.unitsPromise = property.get("units").then(processUnits)
	    //   .then(units => {
	    //     vm.units = units
	    //     angular.extend(vm, {
	    //       toggleUnit: toggleUnitAmenity,
	    //       toggleProperty: togglePropertyAmenity
	    //     })
	    //   });
	  };

	  // function processUnits(collection) {
	  //   const promises = collection.items.map(u => _.pick(u, ["code", "name", "type", "links"]))
	  //     .map(loadUnitAmenities);
	  //   return $q.all(promises);
	  // }


	  function loadUnitAmenities(u) {
	    return $http.get(u.links.amenities.href).then(function (res) {
	      u._amenities = res.data.items;
	      u.amenities = res.data.items.map(function (a) {
	        return a.amenity;
	      });
	      return u;
	    });
	  }

	  // function toggleUnitAmenity(u, a) {
	  //   if (a.disabled) return;
	  //   const baseUrl = u.links.amenities.href;
	  //   if (!u.amenities.includes(a.code)) addAmenity(a, baseUrl, u.amenities, u._amenities)
	  //   else removeAmenity(a, baseUrl, u.amenities, u._amenities);
	  // }

	  function togglePropertyTag(a) {
	    console.log("togglePropertyTag", a);
	    console.log("togglePropertyTag----------", vm.propertyCtrl.property.links.tags);

	    //const baseUrl = vm.propertyCtrl.property.links.tags.href;
	    if (a.disabled) return;
	    var propTags = vm.propertyTags;
	    var baseUrl = vm.propertyCtrl.property.links.tags.href;
	    // const baseUrl = a.links.self.href;
	    if (!propTags.includes(a.code)) addTag(a, baseUrl, propTags, vm._propertyTags);else removeTag(a, baseUrl, propTags, vm._propertyTags);
	  }

	  function addTag(a, baseUrl, selectedCodes, selectedTags) {
	    $log.debug("addTag", a, baseUrl, selectedCodes, selectedTags);
	    // add;
	    a.disabled = true;
	    $http.post(baseUrl, { tag: a.code }).then(function (res) {
	      selectedTags.push(res.data);
	      selectedCodes.push(a.code);
	      a.disabled = false;
	    }, function () {
	      $log.error("cannot add amenity");
	      a.disabled = false;
	    });
	  }

	  function removeTag(a, baseUrl, selectedCodes, selectedTags) {
	    console.log("removeTag", a, baseUrl, selectedCodes, selectedTags);
	    var index = selectedCodes.indexOf(a.code);
	    a.disabled = true;
	    // bug in mo-http for composite keys after post
	    //var url = selectedTags.find(pa => ua.tag === a.code).links.self.href;
	    $http.delete(baseUrl + "/" + a.code).then(function () {
	      selectedCodes.splice(index, 1);
	      selectedTags.splice(index, 1);
	      a.disabled = false;
	    }, function () {
	      $log.error("cannot remove amenity");
	      a.disabled = false;
	    });
	  }
	}

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PropertyBoardsCtrl.$inject = ["$log", "$state", "$mdDialog", "$http", "$q", "$scope", "datasets"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _controller = __webpack_require__(96);

	var _controller2 = _interopRequireDefault(_controller);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  name: "propertyBoards",
	  controller: PropertyBoardsCtrl,
	  templateUrl: 'app/property/boards/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PropertyBoardsCtrl($log, $state, $mdDialog, $http, $q, $scope, datasets) {
	  "ngInject";

	  var vm = this;

	  angular.extend(vm, {
	    $onInit: onInit
	  });

	  //vm.preferedLanguage = "fr"

	  // const ready = $q.defer();

	  function onInit() {

	    delete vm.propertyBoards;
	    delete vm.boardsGroups;
	    delete vm.alternativenames;
	    vm.boardsGroups = [];
	    var propCtrl = vm.propertyCtrl;

	    var p1 = datasets.get('boards').then(function (collection) {
	      return vm.boards = collection.items;
	    });

	    var p2 = propCtrl.get('property-boards').then(function (collection) {
	      return vm.propertyBoards = collection.items;
	    });

	    $q.all([p1, p2]).then(function () {
	      console.log("on init.....");
	      angular.extend(vm, {

	        boardsGroups: groupByBoard(vm.boards, vm.propertyBoards),
	        // languagesFilter: languagesFilter,
	        edit: edit,
	        remove: remove
	      });
	      //return vm.boardsGroups = groupByBoard(vm.boards, vm.propertyBoards)
	      // return vm.unitGroups
	      // $scope.$apply()
	    });
	    console.log('vm.alternativenames....', vm.boards);

	    //console.log('vm.alternativenames....', alternativenames);

	  }

	  // function languagesFilter(lang) {
	  //   return lang === vm.preferedLanguage
	  // }

	  function groupByBoard(boards, propertyBoards) {
	    console.log('groupByBoard....', propertyBoards);
	    console.log('groupByBoardboards....', boards);

	    return boards.map(function (b) {
	      // console.log('boardsBoards....', b)

	      // console.log('b....', b)
	      //console.log('propertyBoards....', propertyBoards)
	      propertyBoards.map(function (pbs) {
	        console.log('propertyBoards....', pbs.alternativenames);
	      });
	      var pb = propertyBoards.filter(function (pbs) {
	        return pbs.board === b.code;
	      });
	      if (pb.length > 0) {
	        angular.extend(b, {
	          alternativenames: pb[0].alternativenames,
	          description: pb[0].description,
	          isNew: false
	        });
	        console.log('alternativenames....', pb[0].alternativenames);
	      } else {
	        angular.extend(b, {
	          isNew: true
	        });
	      }

	      return b;
	    });
	  }

	  // vm.$onInissst = function () {
	  //   vm.loadingPromise = datasets.get("boards", {
	  //     headers: {
	  //       "Accept-Language": "**"
	  //     }
	  //   })
	  //     .then(result => {
	  //       console.log('result....', result)
	  //       angular.extend(vm, {
	  //         items: result.items,
	  //         edit: edit
	  //       });
	  //     });

	  // };


	  // function add(ev) {
	  //   $mdDialog.show(_editDialog(ev, null))
	  //     .then(result => {
	  //       vm.items.push(result);
	  //       // add to units list,
	  //       // or do a new http request ?
	  //       // $scope.$emit('property:changed',{relation:'units'})
	  //     })
	  // }

	  function edit(ev, board) {
	    $mdDialog.show(_editDialog(ev, board)).then(function (result) {
	      $log.debug('edit unit', result);
	      $state.reload();
	    });
	  }

	  function _editDialog($event, board) {
	    console.log('vm.links', vm.links);
	    vm.links = vm.links || vm.propertyCtrl.property.links;

	    return {
	      templateUrl: 'app/property/boards/edit/template.html',
	      controller: _controller2.default,
	      controllerAs: '$ctrl',
	      targetEvent: $event,
	      locals: {
	        target: vm.links.self.href,
	        board: angular.copy(board),
	        propertyCtrl: vm.propertyCtrl
	      }
	    };
	  }

	  // function deletePropertyBoard(url) {
	  //   var deferred = $q.defer();

	  //   $http.delete(url).then((res) => {
	  //     deferred.resolve(res)
	  //   })

	  //   return deferred.promise

	  // }

	  function remove($event, board, index) {
	    if (!board.isNew) {
	      var baseUrl = vm.propertyCtrl.property.links["property-boards"].href;
	      var confirm = $mdDialog.confirm().title('Supprimer la formule ?').textContent('L\'alias et le descriptif liée à cette pension seront supprimés').ariaLabel('Delete formule').targetEvent($event).ok('Supprimer').cancel('Ne pas supprimer');

	      $mdDialog.show(confirm).then(function () {
	        return $http.delete(baseUrl + "/" + board.code);
	      }).then(function () {
	        // $window.location.reload();
	        // onInit()
	        // $state.reload();
	        delete vm.boardsGroups[index].alternativenames;
	        delete vm.boardsGroups[index].description;
	        //$scope.status = 'You decided to get rid of your debt.';
	      }, onDeleteFailure);
	    }
	  }

	  function onDeleteFailure(res) {
	    $log.error("cant delete rate basis", res);

	    $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('Impossible de supprimer la base l\'alias de la pension').textContent('Impossible de supprimer la base tarifaire. Veuillez contacter l administrateur.').ariaLabel('Delete failed').ok('OK'));
	  }
	}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	BoardEditCtrl.$inject = ["$log", "$mdDialog", "$http", "target", "$q", "board", "propertyCtrl", "lectusLanguages"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BoardEditCtrl;
	var _ = __webpack_require__(5);

	function BoardEditCtrl($log, $mdDialog, $http, target, $q, board, propertyCtrl, lectusLanguages) {
	  "ngInject";

	  var vm = this;

	  console.log('propertyBoard edit..', board);

	  vm.preferedLanguage = "fr";

	  vm.langs = lectusLanguages;
	  vm.copy = angular.copy(board);
	  init(board);

	  function init(board) {
	    vm.propertyCtrl = propertyCtrl;
	    angular.extend(vm, {
	      langs: lectusLanguages,
	      languagesFilter: languagesFilter,
	      copy: board,
	      save: save,
	      cancel: function cancel() {
	        return $mdDialog.cancel();
	      }
	    });
	  }

	  function save() {

	    var baseUrl = vm.propertyCtrl.property.links["property-boards"].href;

	    var encoded = {
	      property: vm.propertyCtrl.property.code,
	      board: vm.copy.code,
	      alternativenames: vm.copy.alternativenames,
	      description: vm.copy.description
	    };
	    var promise;
	    if (vm.copy.isNew) {
	      promise = $http({
	        method: "POST",
	        url: baseUrl,
	        headers: {
	          "Content-Language": "**"
	        },
	        data: encoded
	      });
	    } else {
	      promise = $http({
	        method: "PUT",
	        url: baseUrl + "/" + vm.copy.code,
	        headers: {
	          "Content-Language": "**"
	        },
	        data: encoded
	      });
	    }

	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	  }

	  function close(unit) {
	    $log.debug("close", unit);
	    $mdDialog.hide(unit);
	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }

	  function languagesFilter(lang) {
	    console.log("lang...", lang);
	    return lang.code === vm.preferedLanguage;
	  }

	  //_.pick(unit, ['name', 'type', 'area', 'count', 'occupancy'])
	}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	'use strict';

	WrapperController.$inject = ["$log", "$q", "$state", "datasets"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'unitRelWrapper',
	  controller: WrapperController,
	  templateUrl: 'app/property/unit-rel-wrapper/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  },
	  bindings: {
	    breadcrumb: '<',
	    unitViewState: '<'
	  }
	};


	function WrapperController($log, $q, $state, datasets) {
	  "ngInject";

	  var vm = this;
	  var ready = $q.defer();
	  /*
	  datasets.bindSets(['boards'], vm, true);
	  */
	  vm.$onInit = function () {
	    var propCtrl = vm.propertyCtrl;

	    vm.breadcrumb = vm.breadcrumb || [{ label: "Unités" }];
	    //vm.propertyCtrl.property; // do struff

	    var p1 = datasets.get('unit-types').then(function (collection) {
	      vm.unitTypes = collection.items;
	      vm.unitTypesIndex = _.keyBy(vm.unitTypes, "code");
	    });
	    var p2 = propCtrl.setBreadcrumb(vm.breadcrumb).get('units').then(function (collection) {
	      //$log.debug('units', collection);
	      vm.units = collection.items;
	      ready.resolve(vm);
	      return vm;
	    });

	    vm.whenReady = $q.all([p1, p2])
	    // .then(() => vm.unitGroups = groupByType(vm.units, vm.unitTypes));
	    .then(function () {
	      vm.unitGroups = groupByType(vm.units, vm.unitTypes);
	      vm.unitGroups.map(function (group) {
	        group.units.sort(function (a, b) {
	          return a.code > b.code ? 1 : b.code > a.code ? -1 : 0;
	        });
	      });
	    });

	    console.log("vm.unitGroups", vm.unitGroups);

	    vm.unitGroups.map(function (group) {
	      group.units.sort(function (a, b) {
	        return a.code > b.code ? 1 : b.code > a.code ? -1 : 0;
	      });
	    });
	    console.log("vm.unitGroups", vm.unitGroups);
	  };

	  angular.extend(vm, {
	    showUnit: showUnit,
	    getUnit: getUnit,
	    activateUnit: activateUnit
	  });

	  function activateUnit(code) {
	    return ready.promise.then(function () {
	      var unit = getUnit(code);
	      if (angular.isUndefined(unit)) {
	        // should redirect to unit selection page
	        return $q.reject(new Error("404"));
	      }
	      vm.activeUnit = unit;
	      var type = vm.unitTypes.find(function (t) {
	        return t.code === unit.type;
	      }).name;
	      $log.debug(vm.breadcrumb.concat([{ label: type + " " + unit.name }]));
	      vm.propertyCtrl.setBreadcrumb(vm.breadcrumb.concat([{ label: type + " " + unit.name }]));
	      return unit;
	    });
	  }

	  function showUnit(unit) {
	    //$log.debug(vm.unitViewState);
	    $state.go(vm.unitViewState, { unit: unit.code });
	  }

	  function getUnit(code) {
	    return vm.units.find(function (u) {
	      return u.code == code;
	    });
	  }

	  function groupByType(units, unitTypes) {

	    return unitTypes.map(function (t) {
	      return {
	        type: t,
	        units: units.filter(function (u) {
	          return u.type === t.code;
	        })
	      };
	    }).filter(function (group) {
	      return group.units.length > 0;
	    });
	  }
	}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	SalesBreakdownCtrl.$inject = ["datasets", "$filter"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _chartUtils = __webpack_require__(44);

	var chartUtils = _interopRequireWildcard(_chartUtils);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	exports.default = {
	  name: "salesBreakdown",
	  controller: SalesBreakdownCtrl,
	  templateUrl: "app/property/dashboard/sales-breakdown/template.html",
	  require: {
	    propertyCtrl: "?propertyContainer"
	  },
	  bindings: {
	    reportData: "<",
	    unitsMap: "<",
	    viewBy: "<"
	  }
	};


	function SalesBreakdownCtrl(datasets, $filter) {
	  "ngInject";

	  var vm = this;
	  var COLORS = {
	    boards: {
	      1000: "#fafa6e",
	      1100: "#9cdf7c",
	      1110: "#4abd8c",
	      1101: "#00968e",
	      1222: "#106e7c"
	    },
	    unitTypes: {},
	    occupancies: {
	      100: "#2196F3",
	      200: "#E91E63",
	      300: "#009688",
	      400: "#CDDC39",
	      500: "#FF9800"
	    }
	  };

	  var formatOccupancy = $filter('occupancy');
	  var ready = datasets.bindSets(["boards"], vm, true);

	  init();

	  function init() {

	    angular.extend(vm, {
	      pies: {
	        bkUnits: null,
	        bkBoards: null,
	        bkOccupancies: null,
	        ciUnits: null,
	        ciBoards: null,
	        ciOccupancies: null
	      },
	      unitsMap: {},
	      data: {
	        units: [],
	        boards: [],
	        occupancies: []
	      }
	    });
	  }

	  vm.$onChanges = function (changes) {
	    if (changes.reportData && vm.reportData) {
	      ready.then(updateData);
	    }
	    if (changes.unitsMap && vm.unitsMap) {
	      ready.then(updateData);
	    }
	    if (changes.viewBy) {
	      ["bkUnits", "bkBoards", "bkOccupancies", "ciUnits", "ciBoards", "ciOccupancies"].filter(function (name) {
	        return _.isObject(vm.pies[name]);
	      }).forEach(function (name) {
	        vm.pies[name].redraw();
	      });
	    }
	  };

	  function updateData() {
	    if (!vm.reportData) return;
	    //const bookings = destinations.filter(d => d.bookings.stays > 0);
	    //const checkins = destinations.filter(d => d.confirmedCheckins.stays > 0);

	    ["bkUnits", "bkBoards", "bkOccupancies", "ciUnits", "ciBoards", "ciOccupancies"].filter(function (name) {
	      return _.isObject(vm.pies[name]);
	    }).forEach(function (name) {
	      vm.pies[name].destroy();
	      vm.pies[name] = null;
	    });

	    var report = vm.reportData;

	    vm.hasBookings = _.isArray(report.bkUnits);
	    vm.hasCheckins = _.isArray(report.ciUnits);

	    if (report.bkUnits) {
	      vm.pies.bkUnits = createPie("bookings-units-pie", "Catégories", "", report.bkUnits.map(mapUnit));
	      vm.pies.bkBoards = createPie("bookings-boards-pie", "Pensions", "", report.bkBoards.map(mapBoard));
	      vm.pies.bkOccupancies = createPie("bookings-occupancies-pie", "Occupations", "", report.bkOccupancies.map(mapOccupancy));
	    }

	    //  key: (vm.unitsMap[d.unit] || d.unit), // code;
	    //  value: d.nights

	    if (report.ciUnits) {

	      vm.pies.ciUnits = createPie("checkins-units-pie", "Catégories", "", report.ciUnits.map(mapUnit));
	      vm.pies.ciBoards = createPie("checkins-boards-pie", "Pensions", "", report.ciBoards.map(mapBoard));
	      vm.pies.ciOccupancies = createPie("checkins-occupancies-pie", "Occupations", "", report.ciOccupancies.map(mapOccupancy));
	    }
	  }

	  function mapUnit(d) {
	    return {
	      label: vm.unitsMap[d.unit] || d.unit,
	      value: d.nights
	    };
	  }

	  function mapBoard(d) {
	    return {
	      label: vm.boards[d.board].name,
	      value: d.night_paxes,
	      color: COLORS.boards[d.board],
	      caption: d.night_paxes + " pax*nuits"
	    };
	  }

	  function mapOccupancy(d) {
	    return {
	      label: formatOccupancy(d.occupancy),
	      value: d.nights,
	      color: COLORS.occupancies[d.occupancy],
	      caption: d.nights + " nuitée(s)"
	    };
	  }

	  function createPie(elementId, count, unit, data) {
	    return new d3pie(elementId, _.defaultsDeep({
	      header: {
	        title: {
	          text: count,
	          fontSize: 14
	        },
	        subtitle: {
	          text: unit
	        },
	        location: "top-center"
	      },
	      size: {
	        canvasHeight: 240,
	        canvasWidth: 240,
	        pieInnerRadius: "40%",
	        pieOuterRadius: "60%"
	      },
	      misc: {
	        canvasPadding: {
	          "top": 0,
	          "right": 0,
	          "bottom": 0,
	          "left": 0
	        }
	      },
	      tooltips: {
	        type: 'caption'
	      },
	      data: {
	        content: data
	      }
	    }, chartUtils.pieOptions));
	  }

	  // function colores_google(n) {
	  //   var colores_g = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];
	  //   return colores_g[n % colores_g.length];
	  // }
	}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _module = __webpack_require__(100);

	var _module2 = _interopRequireDefault(_module);

	var _component = __webpack_require__(109);

	var _component2 = _interopRequireDefault(_component);

	var _component3 = __webpack_require__(110);

	var _component4 = _interopRequireDefault(_component3);

	var _component5 = __webpack_require__(111);

	var _component6 = _interopRequireDefault(_component5);

	var _directive = __webpack_require__(112);

	var _directive2 = _interopRequireDefault(_directive);

	var _directive3 = __webpack_require__(113);

	var _directive4 = _interopRequireDefault(_directive3);

	var _deadline = __webpack_require__(114);

	var _deadline2 = _interopRequireDefault(_deadline);

	var _util = __webpack_require__(115);

	var _util2 = _interopRequireDefault(_util);

	var _controller = __webpack_require__(116);

	var _controller2 = _interopRequireDefault(_controller);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusRateBasis', ['ui.router', 'lectusApi', 'nvd3', 'ngMessages', _module2.default.name])
	//.component('rateBaseView',rateBaseView)
	//.component('rateBaseEdit',rateBaseEdit)
	.factory("rateUtil", _util2.default).directive("cancellationInput", _directive2.default).directive("marketsInput", _directive4.default).filter("deadline", _deadline2.default).controller("EditRateBasisCalendarCtrl", _controller2.default)
	//.controller(EditCalCtrl.name,EditCalCtrl)

	.component(_component2.default.name, _component2.default).component(_component4.default.name, _component4.default).component(_component6.default.name, _component6.default).config(["$stateProvider", function rateBasesRoutes($stateProvider) {
	  'ngInject';

	  resloveCode.$inject = ["$stateParams"];
	  function resloveCode($stateParams) {
	    'ngInject';

	    return $stateParams.basis;
	  }

	  //console.log('rb toutes')
	  // State
	  $stateProvider.state('property.rateBasisList', {
	    url: '/rate-bases',
	    component: _component2.default.name,
	    data: {
	      menu: {
	        rel: 'rate-bases',
	        label: 'Bases tarifaires',
	        group: 'Tarifs et dispo',
	        position: 0
	      }
	    },
	    resolve: {
	      segments: ["rateUtil", "property", "crmApiUrl", function segments(rateUtil, property, crmApiUrl) {
	        'ngInject';

	        var crmApiUrl;
	        if (property.crmAdresse) {
	          crmApiUrl = property.crmAdresse;
	        }
	        if (crmApiUrl) {
	          crmApiUrl = crmApiUrl;
	        }
	        return rateUtil.getSegments(crmApiUrl);
	        // return rateUtil.getSegments("http://crmapi.valeriahotels.com/api")
	        return rateUtil.getSegments("https://crm.sotlamer.com/api");
	        // return rateUtil.getSegments("http://crmtest-api.fractal-sales.com/api")
	      }]
	    }
	  }).state('property.rateBasisView', {
	    url: '/rate-bases/:basis',
	    component: _component4.default.name,
	    resolve: {
	      basisCode: resloveCode,
	      segments: ["rateUtil", "property", "crmApiUrl", function segments(rateUtil, property, crmApiUrl) {
	        'ngInject';

	        var crmApiUrl;
	        if (property.crmAdresse) {
	          crmApiUrl = property.crmAdresse;
	        }
	        if (crmApiUrl) {
	          crmApiUrl = crmApiUrl;
	        }
	        return rateUtil.getSegments(crmApiUrl);
	        // return rateUtil.getSegments("http://crmapi.valeriahotels.com/api")
	        return rateUtil.getSegments("https://crm.sotlamer.com/api");
	        // return rateUtil.getSegments("http://crmtest-api.fractal-sales.com/api")
	      }]
	    }
	  }).state('property.rateBasisEdit', {
	    url: '/rate-bases/:basis/edit',
	    component: _component6.default.name,
	    resolve: {
	      basisCode: resloveCode,
	      segments: ["rateUtil", "property", "crmApiUrl", function segments(rateUtil, property, crmApiUrl) {
	        'ngInject';

	        var crmApiUrl;
	        if (property.crmAdresse) {
	          crmApiUrl = property.crmAdresse;
	        }
	        if (crmApiUrl) {
	          crmApiUrl = crmApiUrl;
	        }
	        return rateUtil.getSegments(crmApiUrl);
	        // return rateUtil.getSegments("http://crmapi.valeriahotels.com/api")
	        return rateUtil.getSegments("https://crm.sotlamer.com/api");
	        // return rateUtil.getSegments("http://crmtest-api.fractal-sales.com/api")
	      }]
	    }
	  });
	}]);

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(101);

	var _component2 = _interopRequireDefault(_component);

	var _directive = __webpack_require__(102);

	var _directive2 = _interopRequireDefault(_directive);

	var _notInValidator = __webpack_require__(103);

	var _notInValidator2 = _interopRequireDefault(_notInValidator);

	var _occupancyFilter = __webpack_require__(104);

	var _occupancyFilter2 = _interopRequireDefault(_occupancyFilter);

	var _childAgeFilter = __webpack_require__(105);

	var _childAgeFilter2 = _interopRequireDefault(_childAgeFilter);

	var _cancellationFilter = __webpack_require__(106);

	var _cancellationFilter2 = _interopRequireDefault(_cancellationFilter);

	var _relationsService = __webpack_require__(107);

	var _relationsService2 = _interopRequireDefault(_relationsService);

	var _isolateFormDir = __webpack_require__(108);

	var _isolateFormDir2 = _interopRequireDefault(_isolateFormDir);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusCommon', []).component(_component2.default.name, _component2.default).directive("timelanes", _directive2.default).directive("notIn", _notInValidator2.default).directive("isolateForm", _isolateFormDir2.default).filter("occupancy", _occupancyFilter2.default).filter("childAge", _childAgeFilter2.default).filter("cancellation", _cancellationFilter2.default).factory("relations", _relationsService2.default).factory("ccCodeSet", function ccCodeSet() {
	  var codeSet = new Map();
	  codeSet.set(4, { name: "Visa", icon: "pf-visa" });
	  codeSet.set(34, { name: "American Express", icon: "pf-american-express" });
	  codeSet.set(50, { name: "MasterCard", icon: "pf-mastercard" });
	  codeSet.set(62, { name: "China UnionPay", icon: "" });
	  codeSet.set(300, { name: "Diners Club", icon: "pf-diners" });
	  codeSet.set(3528, { name: "JCB", icon: "pf-jcb" });
	  codeSet.set(6011, { name: "Discover", icon: "pf-discover" });
	  return codeSet;
	});
	/*
	Card Type	Card Number Prefix
	American Express	34, 37
	China UnionPay	62, 88
	Diners ClubCarte Blanche	300-305
	Diners Club International	300-305, 309, 36, 38-39
	Diners Club US & Canada	54, 55
	Discover Card	6011, 622126-622925, 644-649, 65
	JCB	3528-3589
	Laser	6304, 6706, 6771, 6709
	Maestro	5018, 5020, 5038, 5612, 5893, 6304, 6759, 6761, 6762, 6763, 0604, 6390
	Dankort	5019
	MasterCard	50-55
	Visa	4
	Visa Electron	4026, 417500, 4405, 4508, 4844, 4913, 4917
	*/

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moment = __webpack_require__(10);

	exports.default = {
	  name: "periodsInput",
	  templateUrl: "app/common/periods-input/template.html",
	  controller: PeriodsInputCtrl,
	  bindings: {
	    model: "=",
	    valueCallback: "="
	  }
	};


	function PeriodsInputCtrl() {
	  "ngInject";

	  var vm = this;

	  vm.options = {
	    minDate: moment().startOf("day").toDate(),
	    maxDate: moment().startOf("day").add(3, "years").toDate()
	  };

	  vm.weekdays = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"].map(function (name, index) {
	    return {
	      index: index,
	      name: name,
	      selected: true
	    };
	  });

	  vm.valueCallback = valueCallback;

	  vm.addPeriod = function () {
	    var p = {
	      start: null,
	      end: null,
	      weekdays: createWeekDays()
	    };
	    p.dateFilterStart = dateFilterStart(p);
	    p.dateFilterEnd = dateFilterEnd(p);
	    vm.model.push(p);
	    vm.weekdays.forEach(function (d) {
	      return d.selected = true;
	    });
	  };

	  if (vm.model.length === 0) {
	    vm.addPeriod();
	  }

	  function createWeekDays() {
	    return ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"].map(function (name, index) {
	      return {
	        index: index,
	        name: name,
	        selected: true
	      };
	    });
	  }

	  vm.removePeriod = function (p) {
	    var index = vm.model.indexOf(p);
	    if (index >= 0) {
	      vm.model.splice(index, 1);
	    }
	  };

	  function valueCallback() {
	    var f = "YYYY-MM-DD";
	    return vm.model.sort(function (a, b) {
	      a.start.getTime() - b.start.getTime();
	    }).map(function (p) {
	      return {
	        start: moment(p.start).format(f),
	        end: moment(p.end).format(f),
	        weekdays: p.weekdays.filter(function (wd) {
	          return wd.selected;
	        }).map(function (wd) {
	          return wd.index;
	        })
	      };
	    });
	  }

	  function dateFilterStart(p) {
	    return function (date) {
	      return false === isDateInPeriods(date, otherValidPeriods(p));
	    };
	  }

	  function dateFilterEnd(p) {
	    return function (date) {
	      if (date.getTime() < p.start.getTime()) return false;
	      //console.log(date);
	      return false === isDateInPeriods(date, otherValidPeriods(p));
	    };
	  }

	  function isDateInPeriods(d, periods) {
	    var date = d.getTime();
	    //return angular.isDefined(periods.find(p => m.isBetween(p.start, p.end, null, "[]")));
	    return angular.isDefined(periods.find(function (p) {
	      return p.start.getTime() <= date && date <= p.end.getTime();
	    }));
	  }

	  function otherValidPeriods(period) {
	    return vm.model.filter(function (p) {
	      return p !== period && angular.isDate(p.start) && angular.isDate(p.end);
	    });
	  }

	  // function sortPeriods(a, b) {
	  //   return moment(a.start).diff(b.start);
	  // }
	}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	timelanes.$inject = ["$log", "$window"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = timelanes;
	/* global  */

	var moment = __webpack_require__(10);
	var d3 = __webpack_require__(15);

	/** @ngInject */
	function timelanes($log, $window) {
	  'ngInject';
	  //

	  var LANE_BOX_HEIGHT = 32;
	  var LANE_PADDING_TOP = 12;
	  var LANE_STROKE_THICKNESS = 12;
	  //const CURSOR_DATE_HEIGHT = 16;
	  //const X_AXIS_TICK_HEIGHT = 16;

	  return {
	    template: '<div class="cal-heatmap" config="config" data="data"></div>',
	    restrict: 'E',
	    link: link,
	    scope: {
	      data: '=',
	      config: '='
	    }
	  };

	  function link(scope, el) {
	    var config = scope.config || {
	      box: {
	        width: 960
	      },
	      margin: {
	        top: 20,
	        right: 15,
	        bottom: 15,
	        left: 60
	      },
	      values: function values(series) {
	        return series.values;
	      },
	      y: {
	        id: function id(d) {
	          return d.id;
	        },
	        label: function label(d) {
	          return d.label;
	        }
	      },
	      categories: {
	        value: function value(d) {
	          return d.rules;
	        }
	      },
	      colors: d3.scale.category10(),
	      start: moment.utc().toDate(),
	      end: moment.utc().endOf('year').toDate()
	    };

	    scope.$watch(function () {
	      return scope.data;
	    }, function () {
	      return build(el[0], config, scope.data || [], scope);
	    });
	  }

	  function build(element, config, lanes, scope) {
	    var now = moment.utc().startOf('day');
	    var width = 0,
	        height = 0,
	        miniHeight = 0;
	    var laneItems = config.values;
	    var laneId = config.y.id;
	    var laneLabel = config.y.label;
	    var all = lanes.reduce(function (agg, lane) {
	      return agg.concat(laneItems(lane));
	    }, []);
	    var zValues = d3.map(all, config.categories.value).keys();
	    var zValuesStr = zValues.map(function (v) {
	      return v.toString();
	    });

	    angular.element($window).on('resize', render);
	    scope.$on('$destroy', cleanUp);

	    if (config.categories.sort) {
	      config.categories.sort(zValues);
	    }
	    var highlighted;

	    d3.select(element).select('svg').remove();

	    var chart = d3.select(element).append('svg:svg').attr('width', "100%").style({
	      width: '100%'
	    }).attr('class', 'chart timelanes');
	    updateDimensions(chart.node().getBoundingClientRect().width);
	    chart.attr('height', height);

	    var mini = chart.append('g').attr('transform', "translate(" + config.margin.left + ", " + (config.margin.top + 30) + ")").attr('width', width).attr('height', miniHeight).attr('class', 'mini');

	    //console.log([d3.min(all, d => d.start), d3.max(all, d => d.end)]);
	    // scales
	    var x = d3.time.scale.utc().domain([d3.min(all, function (d) {
	      return d.start;
	    }), d3.max(all, function (d) {
	      return d.end;
	    })])
	    //.domain(config.x.domain)
	    .range([0, width]);
	    var ext = d3.extent(lanes, laneId);
	    var y = d3.scale.linear().domain([ext[0], ext[1] + 1]).range([0, miniHeight]);
	    var zColor = d3.scale.category10();
	    // draw the lanes for the mini chart

	    // Y AXIS
	    mini.append('g').attr('class', 'axis lanes lane-labels').selectAll('.laneText').data(lanes).enter().append('text').text(laneLabel).attr('x', 0).attr('y', function (d) {
	      return y(laneId(d)) + 8;
	    }).attr('dy', '0.5ex').attr('text-anchor', 'start').attr('class', 'laneText');

	    // X AXIS
	    var xMonthAxis = d3.svg.axis().scale(x).orient('top').ticks(d3.time.months, 1).tickSize(15, 0, 0).tickFormat(d3.time.format('%b %Y'));

	    mini.append('g').attr('class', 'axis month').attr('transform', 'translate(0,0.5)').call(xMonthAxis).selectAll('text').attr('dx', 5).attr('dy', 12).style("text-anchor", "start");

	    setupLanesData();

	    addCursor(mini, width, miniHeight - 1);

	    // TODAY LINE
	    mini.append('line').attr('class', 'today').attr('x1', x(now) + 0.5).attr('y1', 0).attr('x2', x(now) + 0.5).attr('y2', -15);

	    mini.selectAll('rect.background').remove();

	    /**
	     *  render updates widths
	     */
	    function render() {
	      updateDimensions(chart.node().getBoundingClientRect().width);
	      x.range([0, width]);
	      y.range([0, miniHeight]);

	      xMonthAxis.scale(x);

	      mini.select('.axis.month').call(xMonthAxis);

	      mini.select('.today').attr('x1', x(now) + 0.5).attr('x2', x(now) + 0.5).attr('y2', miniHeight);

	      mini.selectAll('.dividers').attr('x1', 0).attr('x2', width);

	      mini.selectAll('.period').attr('d', function (d) {
	        var path = d3.select(this).attr('d').split(' ');
	        // x1 =
	        path[1] = x(d.start);
	        path[4] = x(d.end);
	        return path.join(' ');
	      });
	    }

	    function cleanUp() {
	      angular.element($window).off('resize', render);
	    }

	    function setupLanesData() {
	      // 2px space is for highlight effect
	      var offset = LANE_PADDING_TOP + 2 + LANE_STROKE_THICKNESS / 2;
	      lanes.forEach(function (lane) {
	        var id = laneId(lane);
	        var laneY = y(laneId(lane)) + offset;
	        mini.append('g').attr('class', 'lane lane-items lane-' + id).selectAll('miniItems').data(laneItems(lane)).enter().append('path').attr('class', 'period').attr('stroke-width', LANE_STROKE_THICKNESS).style('stroke', function (d) {
	          //$log.info('d', d);
	          return d.color || zColor(zValuesStr.indexOf(config.categories.value(d).toString()));
	        }).attr('d', function (d) {
	          //console.log(d.start);
	          return ['M', x(d.start), laneY, 'H', x(d.end)].join(' ');
	        });
	      });
	    }

	    function updateDimensions(parentWidth) {
	      // month tick height 15
	      // cursor date height 20px
	      width = parentWidth - config.margin.left - config.margin.right;
	      height = lanes.length * LANE_BOX_HEIGHT + 70; // - config.margin.top - config.margin.bottom;
	      miniHeight = height - 50; // 50 for ?
	      //console.log('height',height,miniHeight, lanes);
	    }

	    function addCursor(g) {
	      var guideLayer = g.append('g').attr('class', 'cursor').attr('width', width).attr('height', miniHeight).style("opacity", "0");

	      guideLayer.append("path"); // this is the black vertical line to follow mouse
	      guideLayer.append("text") // this is the black vertical line to follow mouse
	      .attr('y', y.range()[0] - 20);
	      var laneHalf = miniHeight / (2 * lanes.length);

	      var tooltipWidth = Math.round(width / 3);
	      var tooltip = guideLayer.append('g').attr('height', miniHeight).attr('width', tooltipWidth).attr('class', 'tooltip');
	      tooltip.append('rect').attr('height', miniHeight).attr('width', tooltipWidth).style('fill', 'rgba(240,248,255,0.5)').attr('class', 'tooltip');
	      tooltip.selectAll('.tooltipText').data(lanes).enter().append('text').attr('x', 10).attr('y', function (d) {
	        return y(laneId(d)) + laneHalf;
	      }).attr('dy', '0.5ex').attr('text-anchor', 'start');
	      var lastDate;
	      chart.attr('pointer-events', 'all').on('mouseout', function () {
	        guideLayer.style("opacity", "0");
	        g.selectAll('.period.highlighted').classed("highlighted", false);
	      });
	      chart.on('mouseover', function () {
	        guideLayer.style("opacity", "1");
	      }).on('mousemove', function () {
	        // mouse moving over canvas
	        var yRange = y.range(); // range of y axis
	        var xCoor = d3.mouse(this)[0] - config.margin.left; // mouse position in x
	        if (xCoor < 0) {
	          return;
	        }
	        var xDate = x.invert(xCoor); // date corresponding to mouse x
	        var date = moment(xDate).startOf('day');
	        if (!xDate || lastDate && lastDate.isSame(date)) {
	          return;
	        }
	        lastDate = date;
	        // $log.debug(xDate);
	        guideLayer.select("path").attr("d", function () {
	          return (
	            // position vertical line
	            "M" + xCoor + "," + yRange[0] + "L" + xCoor + "," + yRange[1]
	          );
	        });
	        guideLayer.select("text").attr('x', xCoor).text(date.format('ddd DD/MM'));
	        //$log.debug(xDate);
	        var selection = g.selectAll('.period') // for each circle group
	        .filter(function (d) {
	          return moment(d.start).isSameOrBefore(xDate) && moment(d.end).isSameOrAfter(xDate);
	        });
	        if (highlighted) {
	          var turnoff = highlighted.filter(function (d) {
	            return selection.indexOf(d) === -1;
	          });
	          // $log.debug(turnoff);
	          turnoff.each(function () {
	            d3.select(this).classed('highlighted', false);
	          });
	        }
	        selection.each(function () {
	          d3.select(this).classed('highlighted', true);
	        });
	        highlighted = selection;

	        var ttX = xCoor + tooltipWidth >= width ? xCoor - tooltipWidth : xCoor;

	        tooltip.attr('transform', "translate(" + ttX + ",10)");
	        //.attr('text-anchor', (xCoor > width/2) ? 'end': 'start');
	        tooltip.selectAll('text').text(function (d) {
	          var period = mini.select('.lane-' + laneId(d) + ' .highlighted').data()[0];
	          return config.categories.format(config.categories.value(period));
	        });
	      });
	    }
	  }
	}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = notIn;
	function notIn() {
	  return {
	    require: 'ngModel',
	    scope: {
	      notIn: '&notIn'
	    },
	    link: function link(scope, elm, attrs, ctrl) {
	      ctrl.$validators.notIn = function (modelValue, viewValue) {
	        if (ctrl.$isEmpty(modelValue)) {
	          // consider empty models to be valid
	          return true;
	        }
	        var dupe = scope.notIn().find(function (i) {
	          return i.toLowerCase() === viewValue.toLowerCase();
	        });
	        // it is invalid
	        return angular.isUndefined(dupe);
	      };
	    }
	  };
	}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = occupancy;
	function occupancy() {
	  'ngInject';

	  var adults = [null, "Single", "Double", "Triple", "Quadruple", "Quintuple"];

	  return function (value) {
	    var adultsCount = Math.floor(value / 100);
	    var remainder = value - adultsCount * 100;
	    var children = Math.floor(remainder / 10);
	    var infants = remainder - children * 10;
	    var str = [];
	    if (adults[adultsCount]) {
	      str.push(adults[adultsCount]);
	    } else {
	      str.push(adultsCount + ' adt. ');
	    }
	    if (children > 0) {
	      str.push(children + " enf.");
	    }
	    if (infants > 0) {
	      str.push(infants + " bébé");
	    }
	    return str.join(" ");
	  };
	}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = childAgeFilter;
	function childAgeFilter() {
	  return function (value) {
	    return value == 0 ? "Bébé" : "Enfant/Ado";
	    //return (parseInt(value, 10) < 3) ? "Bébé" : "Enfant/Ado";
	  };
	}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cancellation;
	function cancellation() {
	  var cache = {
	    '0%0': 'Annulation gratuite',
	    '999%100': 'Non remboursable'
	  };
	  return function (rule, currency) {
	    if (!cache[rule]) {
	      cache[rule] = format(rule, currency);
	    }
	    return cache[rule];
	  };

	  function format(rule, currency) {
	    var match = rule.match(/^(\d{1,3})([mn%])(\d+(.\d+)?)$/);
	    var days = parseInt(match[1], 10);
	    var unit = match[2] === 'm' ? currency || 'Dh' : match[2];
	    var charge = parseFloat(match[3]);
	    return charge + ' ' + unit + ' \xE0 ' + days + 'j avant arriver';
	  }
	}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	relations.$inject = ["$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = relations;

	var _ = __webpack_require__(5);

	function relations($http) {
	  "ngInject";

	  return {
	    fetch: fetch
	  };

	  function fetch(rel, resource) {
	    return $http.get(resource.links[rel].href).then(function (res) {
	      resource[_.camelCase(rel)] = res.data;
	      return res.data;
	    });
	  }
	}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isolateForm;

	// isolate sub form
	function isolateForm() {
	  'ngInject';

	  return {
	    restrict: 'A',
	    require: '?form',
	    link: function link(scope, elm, attrs, ctrl) {
	      if (!ctrl) {
	        return;
	      }
	      // Do a copy of the controller
	      var ctrlCopy = {};
	      angular.copy(ctrl, ctrlCopy);

	      // Get the parent of the form
	      var parent = elm.parent().controller('form');
	      // Remove parent link to the controller
	      parent.$removeControl(ctrl);

	      // Replace form controller with a "isolated form"
	      var isolatedFormCtrl = {
	        $setValidity: function $setValidity(validationToken, isValid, control) {
	          ctrlCopy.$setValidity(validationToken, isValid, control);
	          parent.$setValidity(validationToken, true, ctrl);
	        },
	        $setDirty: function $setDirty() {
	          elm.removeClass('ng-pristine').addClass('ng-dirty');
	          ctrl.$dirty = true;
	          ctrl.$pristine = false;
	        }
	      };
	      angular.extend(ctrl, isolatedFormCtrl);
	    }
	  };
	}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	'use strict';

	ListController.$inject = ["User", "$log", "$http", "$state", "rateUtil", "$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'rateBasisList',
	  controller: ListController,
	  templateUrl: 'app/rate-basis/list/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  },
	  bindings: {

	    segments: "<"
	  }
	};


	function ListController(User, $log, $http, $state, rateUtil, $mdDialog) {
	  "ngInject";

	  var vm = this;

	  vm.confirmDelete = confirmDelete;

	  /*
	  datasets.bindSets(['boards'], vm, true);
	  */
	  vm.$onInit = function () {

	    console.log("segments::", vm.segments);
	    vm.propertyCtrl.property; // do struff
	    vm.propertyCtrl.setBreadcrumb([{ label: 'Bases tarifaires' }]);
	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });

	    $http.get(vm.propertyCtrl.property.links['rate-bases'].href).then(function (res) {
	      vm.links = res.data.links;
	      vm.permissions = res.data.permissions;
	      // actions
	      // if (vm.permissions.add) {
	      //   vm.propertyCtrl.setActions([{
	      //     icon:"add",
	      //     label:"Ajouter",
	      //     href: $state.href("property.rateBasisEdit",{basis:"new"})}
	      //   ]);
	      // }
	      // else {
	      //   vm.propertyCtrl.setActions([]);
	      // }

	      vm.propertyCtrl.setActions([{
	        icon: "add",
	        label: "Ajouter",
	        href: $state.href("property.rateBasisEdit", { basis: "new" }) }]);

	      vm.rateBases = res.data.items.map(rateUtil.decodeRateBasis).map(function (rb) {
	        // console.log(rb);
	        angular.extend(rb.links, {
	          view: $state.href("property.rateBasisView", { basis: rb.code }),
	          edit: $state.href("property.rateBasisEdit", { basis: rb.code })
	        });
	        return rb;
	      });
	      vm.rateBases = vm.rateBases.sort(function (a, b) {
	        return a.code - b.code;
	      });
	    });
	  };

	  function confirmDelete($event, basis) {
	    var confirm = $mdDialog.confirm().title('Supprimer la base tarifaire ' + basis.description + ' ?').textContent('Toutes les offres et les tarifs associés seront supprimé. Cette opération est irreversible.').ariaLabel('Suprimer la base tarifaire').targetEvent($event).ok('Supprimer la base tarifaire').cancel('Ne pas supprimer');

	    $mdDialog.show(confirm).then(function () {
	      return $http.delete(basis.links.self.href);
	    }).then(function () {
	      $state.reload();
	      //$scope.status = 'You decided to get rid of your debt.';
	    }, onDeleteFailure);
	  }

	  function onDeleteFailure(res) {
	    $log.error("cant delete rate basis", res);

	    $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('Impossible de supprimer la base tarifaire').textContent('Impossible de supprimer la base tarifaire. Veuillez contacter l administrateur.').ariaLabel('Delete failed').ok('OK'));
	  }
	}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	ViewController.$inject = ["$log", "$q", "datasets", "$state", "$http", "rateUtil", "$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var moment = __webpack_require__(10);
	var d3 = __webpack_require__(15);

	exports.default = {
	  name: "rateBasisView",
	  controller: ViewController,
	  templateUrl: 'app/rate-basis/view/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  },
	  bindings: {
	    boards: '<boards',
	    basisCode: '<basisCode',
	    segments: "<"
	  }
	};


	function ViewController($log, $q, datasets, $state, $http, rateUtil, $mdDialog) {
	  "ngInject";

	  var vm = this;
	  var GRAPH_MARGINS = {
	    top: 20,
	    right: 24,
	    bottom: 40,
	    left: 24
	  };

	  if (vm.basisCode === "new") {
	    return $state.go('property.rateBasisEdit');
	  }

	  datasets.bindSets(['boards'], vm, /*indexed*/true);
	  datasets.get('countries').then(function (set) {
	    vm.countriesList = set.items;
	    vm.countries = _.keyBy(set.items, "code");
	  });

	  vm.$onInit = function () {
	    vm.propertyCtrl.property; // do struff
	    console.log("segmentsINVIEW::", vm.segments);
	    loadRateBasis(vm.basisCode).then(loadCalendar, loadFailed).then(function () {
	      vm.propertyCtrl.setBreadcrumb([{ label: 'Bases Tarifaires', href: $state.href("property.rateBasisList") }, { label: vm.basis.description }]);
	      //vm.propertyCtrl.setActions([{label:"add"}]);
	    });

	    angular.extend(vm, {
	      editMinStay: editMinStay,
	      editCancellation: editCancellation,
	      editMarkup: editMarkup,
	      editMarkupss: editMarkupss
	    });
	  };

	  function loadRateBasis(code) {
	    var basesLink = vm.propertyCtrl.property.links['rate-bases'];
	    return $http.get(basesLink.href + "/" + code).then(function (res) {
	      vm.basis = rateUtil.decodeRateBasis(res.data);
	      return vm.basis;
	    });
	  }

	  function loadFailed(res) {
	    $log.error(res);
	    return $q.reject(res);
	  }

	  function loadCalendar() {
	    var basis = vm.basis;
	    //console.log(vm.basis.stay.period.start);
	    var stayStart = moment(basis.stay.period.start);
	    var stayEnd = moment(basis.stay.period.end);
	    var today = moment().startOf('day');
	    if (stayEnd.diff(today, 'days') <= 0) {
	      $log.debug('past', today.diff(stayEnd, 'days'));
	      // past dont load.
	      return;
	    }
	    var start = moment.max(stayStart, today).format('YYYY-MM-DD');
	    var end = moment.max(stayEnd, today).format('YYYY-MM-DD');
	    $http.get(basis.links.calendar.href + "?start=" + start + "&end=" + end).then(function (res) {
	      //console.log(res.data);
	      vm.cancellation = {
	        options: cancellationGraphOptions(),
	        data: [cancellationGraphData(res.data.items)]
	      };
	      vm.minStay = {
	        options: minStayOptions({
	          start: start,
	          end: end
	        }),
	        data: [{
	          key: 'minStay',
	          values: res.data.items
	        }]
	      };

	      vm.markup = {
	        options: markupOptions({
	          start: start,
	          end: end
	        }),
	        data: [{
	          key: 'markup',
	          values: res.data.items
	        }]
	      };
	      console.log("m.basis.markups;:::", vm.basis.markups);
	      var mrkpssss = Object.keys(vm.basis.markups);
	      console.log("m.basis.mrkpssss;:::", mrkpssss);
	      console.log("m.basis.mrkpssss1;:::", Object.keys(vm.basis.markups));

	      var datas = [];
	      if (vm.basis.markups != null) {
	        mrkpssss.map(function (mrk) {
	          console.log("m.basis.mrk;:::", mrk);
	          console.log("res.data.items[0].markup0", res.data.items[0].markups);
	          var mrkpsexist = Object.keys(res.data.items[0].markups);
	          var mrkpsexistvalues = Object.values(res.data.items[0].markups);
	          console.log("mrkpsexistvalues;:::", mrkpsexistvalues);

	          mrkpsexist.map(function (value) {
	            console.log("res.data.items[0].markup.value;:::", value);

	            //  var items=[];

	            if (mrk === value) {
	              // res.data.items.map( itm => {
	              //  var item=itm;
	              //  item.mrkp=Object.values(itm.markups)
	              //  items.push(itm)
	              // })
	              var items = [];
	              //   items=Object.assign(res.data.items);
	              items = structuredClone(res.data.items);
	              // items.map( it => {
	              for (var j = 0; j < items.length; j++) {
	                if (items[j].markups != null) {
	                  var _iteratorNormalCompletion = true;
	                  var _didIteratorError = false;
	                  var _iteratorError = undefined;

	                  try {
	                    for (var _iterator = Object.entries(items[j].markups)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                      var _step$value = _slicedToArray(_step.value, 2),
	                          key = _step$value[0],
	                          value1 = _step$value[1];

	                      //   console.log(`${key}: ${value1}`);
	                      if (key === value) {
	                        console.log("key === value ", key, " ", value1);

	                        //  console.log("Object.keys(items[j]).map((key) => [Number(key), items[j][key]]  ",Object.keys(items[j]).map((key) => [Number(key), items[j].markups[key]]));
	                        //  mrkpValue = Object.keys(it.markups).map((key) =>;
	                        items[j].markupp = value1;
	                        console.log("items[j].markupp ", items[j].markupp);
	                      }
	                    }
	                  } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                      }
	                    } finally {
	                      if (_didIteratorError) {
	                        throw _iteratorError;
	                      }
	                    }
	                  }
	                }
	              }
	              //)
	              var obj = {
	                key: value,
	                values: items
	                //values: res.data.items
	              };
	              datas.push(obj);
	              items = [];
	            }
	            //  else {
	            //   items[i].price=null;


	            //  }
	          });
	        });
	      }

	      /*   datas.map( mrk =>{ 
	           console.log("mrkmrkmrk;:::",mrk.values.length );
	           console.log("mrkmrkmrkvalues;:::",mrk.values )
	           console.log("mrkmrkmrkvalues;:::",mrk.markupp )
	          })
	         console.log("datassize;:::",datas.length )*/
	      // console.log("datasize;:::",data.length )

	      //  vm.basis.markups.map( mrk =>{ 
	      vm.markups = {
	        options: markupsOptions({
	          start: start,
	          end: end
	        }),
	        datas: datas
	        // data: [{
	        //  key: mrk,
	        //   values: res.data.items
	        //  }]
	      };
	    });
	    // })
	  }

	  //
	  // edit calendar dialos
	  //

	  function editMinStay($event) {
	    calendarEditDialog($event, "minStay");
	  }

	  function editCancellation($event) {
	    calendarEditDialog($event, "cancellation");
	  }

	  function editMarkup($event) {
	    calendarEditDialog($event, "markup");
	  }
	  function editMarkupss($event) {
	    calendarEditDialog($event, "markupss");
	  }
	  function calendarEditDialog($event, itemType) {
	    $mdDialog.show({
	      targetEvent: $event,
	      templateUrl: 'app/rate-basis/edit-calendar/template.html',
	      locals: {
	        itemTypes: [itemType],
	        rateBasis: vm.basis
	      },
	      controller: 'EditRateBasisCalendarCtrl',
	      controllerAs: '$ctrl'
	    }).then(function () /*updateInfo*/{
	      //console.log('updateInfo',updateInfo);
	      // XXX could save a trip here
	      // patchLocalCalendarData(updateInfo)
	      // empty data first
	      vm.cancellation.data.length = 0;
	      vm.minStay.data.length = 0;
	      loadCalendar();
	    });
	  }
	  /*
	    function patchLocalCalendarData(updateInfo) {
	      //console.log('updateInfo',updateInfo);
	      //  save a trip here
	    }
	    */

	  //
	  // GRAPHS
	  //


	  function cancellationGraphOptions() {
	    return {
	      box: {
	        width: 960,
	        height: 200
	      },
	      margin: GRAPH_MARGINS,
	      values: function values(series) {
	        return series.values;
	      },
	      x: {
	        domain: [moment.utc().startOf('month'), moment().utc().startOf('month').add(1, 'years').toDate()]
	      },
	      y: {
	        id: function id() {
	          return vm.basis.code;
	        },
	        label: function label() {
	          return '';
	        } //series.label
	      },
	      categories: {
	        value: function value(d) {
	          return d && d.cancellation;
	        },
	        format: function format(cancellation) {
	          return cancellation ? cancellation.map(function (r) {
	            switch (r) {
	              case "0%0":
	                return "gratuite";
	              case "999%100":
	                return "non remboursable";
	              default:
	                return formatCancellation(r);
	            }
	          }).join(' ') : 'N/C';
	        },
	        sort: function sort(a, b) {
	          if (!b) return;
	          //console.log('sort',a,b);
	          var a1 = a[0].split(/(%mn)/)[0];
	          var b1 = b[0].split(/(%mn)/)[0];
	          return parseInt(b1, 10) - parseInt(a1, 10);
	        }
	      },
	      colors: d3.scale.category10(),
	      start: moment.utc().toDate(),
	      end: moment.utc().endOf('year').toDate()
	    };
	  }

	  function formatCancellation(r) {
	    console.log("currency:: ", vm.basis.currency);
	    var v = r.match(/^(\d+)([%mn])(.+)$/);
	    var days = v[1];
	    var value;
	    if (v[3] === '0') {
	      value = 'annulation gratuite';
	    } else if (r.match(/%100$/)) {
	      value = 'non remboursable';
	    } else {
	      var unit = v[2] === 'm' ? vm.basis.currency : v[2] === 'n' ? 'nuit' : v[2];
	      value = [v[3], unit].join(' ');
	    }
	    return " (" + days + "j avant = " + value + ") ";
	  }

	  function cancellationGraphData(data) {
	    var days = data;
	    var len = days.length;
	    if (len === 0) {
	      return {
	        label: '',
	        values: []
	      };
	    }
	    var i = 0;
	    var period = _startPeriod(days[0]);
	    var periods = [];
	    while (i < len) {
	      if (!_.isEqual(period.cancellation, days[i].cancellation)) {
	        _endPeriod(days[i - 1]);
	        period = _startPeriod(days[i]);
	      }
	      i++;
	    }
	    _endPeriod(days[i - 1]);

	    function _startPeriod(startDay) {
	      var rules = startDay.cancellation;
	      var p = {
	        start: moment.utc(startDay.date).toDate(),
	        end: null,
	        cancellation: startDay.cancellation
	      };
	      if (rules && rules.length === 1) {
	        if (rules[0] === "999%100") {
	          p.color = "#F44336";
	        } else if (rules[0] === "0%0") {
	          p.color = "#4caf50";
	        }
	      }
	      return p;
	    }

	    function _endPeriod(endDay) {
	      period.end = moment.utc(endDay.date).endOf('day').toDate();
	      periods.push(period);
	    }
	    return {
	      values: periods
	    };
	  }

	  function minStayOptions(period) {
	    var graphDates = makeGraphDates(period.start, period.end);
	    return {
	      deepWatchOptions: false,
	      chart: {
	        type: 'lineChart',
	        height: 200,
	        margin: GRAPH_MARGINS,
	        useInteractiveGuideline: true,
	        duration: 100,
	        //zoom: zoom,
	        x: function x(item) {
	          return moment(item.date).toDate();
	        },
	        xScale: d3.time.scale(),
	        xDomain: [moment(period.start).toDate(), moment(period.end).toDate()],
	        yDomain: [0, 10],
	        xAxis: {
	          //xScale : d3.time.scale(),
	          tickFormat: function tickFormat(d) {
	            return moment(d).format('D/M/YY');
	          },
	          //tickValues: graphDates,
	          showMaxMin: false,
	          ticks: graphDates.length + 1
	        },
	        y: function y(item) {
	          return item.minStay;
	        },
	        yAxis: {
	          ticks: 10
	        },
	        showLegend: false
	      }
	    };
	  }

	  function markupOptions(period) {
	    var graphDates = makeGraphDates(period.start, period.end);
	    return {
	      deepWatchOptions: false,
	      chart: {
	        type: 'lineChart',
	        height: 200,
	        margin: GRAPH_MARGINS,
	        useInteractiveGuideline: true,
	        duration: 100,
	        //zoom: zoom,
	        x: function x(item) {
	          return moment(item.date).toDate();
	        },
	        xScale: d3.time.scale(),
	        xDomain: [moment(period.start).toDate(), moment(period.end).toDate()],
	        yDomain: [0, 100],
	        xAxis: {
	          //xScale : d3.time.scale(),
	          tickFormat: function tickFormat(d) {
	            return moment(d).format('D/M/YY');
	          },
	          //tickValues: graphDates,
	          showMaxMin: false,
	          ticks: graphDates.length + 1
	        },
	        y: function y(item) {
	          return item.markup;
	        },
	        yAxis: {
	          ticks: 10
	        },
	        showLegend: false
	      }
	    };
	  }

	  function markupsOptions(period) {
	    var graphDates = makeGraphDates(period.start, period.end);

	    return {
	      deepWatchOptions: false,
	      chart: {
	        type: 'lineChart',
	        height: 200,
	        margin: GRAPH_MARGINS,
	        useInteractiveGuideline: true,
	        duration: 100,
	        //zoom: zoom,
	        x: function x(item) {
	          return moment(item.date).toDate();
	        },
	        xScale: d3.time.scale(),
	        xDomain: [moment(period.start).toDate(), moment(period.end).toDate()],
	        yDomain: [0, 100],
	        xAxis: {
	          //xScale : d3.time.scale(),
	          tickFormat: function tickFormat(d) {
	            return moment(d).format('D/M/YY');
	          },
	          //tickValues: graphDates,
	          showMaxMin: false,
	          ticks: graphDates.length + 1
	        },

	        y: function y(item) {
	          return item.markupp;
	        },

	        yAxis: {
	          ticks: 10
	        },
	        showLegend: false
	      }
	    };
	  }

	  function makeGraphDates(start, end) {
	    var last = moment(end);
	    var i = 1;
	    var dates = [];
	    var date = moment(start).startOf('month');
	    while (date.isBefore(last)) {
	      dates.push(date.clone().toDate());
	      date.add(1, 'months');
	      i++;
	    }
	    return dates;
	  }
	  /*
	    function dateTickFormat(d) {
	      return angular.isDefined(this) ?
	        moment(d).format('MMM YYYY') :
	        moment(d).format('ddd DD MMM');
	    }*/
	}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	RateBasisEditCtrl.$inject = ["$log", "$scope", "$http", "$state", "datasets", "rateUtil"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var moment = __webpack_require__(10);

	exports.default = {
	  name: "rateBasisEdit",
	  controller: RateBasisEditCtrl,
	  templateUrl: 'app/rate-basis/edit/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  },
	  bindings: {
	    basisCode: "<",
	    segments: "<"
	  }
	};


	function RateBasisEditCtrl($log, $scope, $http, $state, datasets, rateUtil) {
	  "ngInject";

	  var vm = this;
	  datasets.bindSets(['boards'], vm, /*indexed*/true);

	  vm.minDate = moment().startOf("day").toDate();
	  vm.selected = [];

	  vm.$onInit = function () {
	    var property = vm.propertyCtrl.property; // do struff
	    //vm.propertyCtrl.setBreadcrumb(['Rate bases']);
	    //vm.propertyCtrl.setActions([{label:"add"}]);
	    //
	    _setupToolbar(vm.propertyCtrl);

	    datasets.get("amenities").then(function (collection) {
	      vm.options = {
	        property: collection.items.filter(function (a) {
	          return a.property;
	        }),
	        unit: collection.items.filter(function (a) {
	          return a.unit;
	        }),
	        rate: collection.items.filter(function (a) {
	          return a.rate;
	        })
	      };
	    });
	    datasets.get("markup_type").then(function (collection) {
	      vm.options = {
	        property: collection.items.filter(function (a) {
	          return a.property;
	        }),
	        unit: collection.items.filter(function (a) {
	          return a.unit;
	        }),
	        rate: collection.items.filter(function (a) {
	          return a.rate;
	        })
	      };
	    });
	    datasets.get('markup_type').then(function (set) {
	      vm.markups = set.items;
	    });

	    // vm.ratePromise = property.get("units").then(processUnits)
	    //   .then(rates => {
	    //     vm.rates = rates
	    //     angular.extend(vm, {
	    //       toggleRate: toggleRateAmenity
	    //     })
	    //   });
	    vm.rateAmenitiesFilter = {
	      rate: true,
	      name: ""
	    };

	    datasets.get('countries').then(function (set) {
	      vm.countriesList = set.items;
	      vm.countries = _.keyBy(set.items, "code");
	    });
	    var basesLink = property.links['rate-bases'];

	    // new
	    if (vm.basisCode === 'new') {
	      //$log.debug('basesLink', basesLink);
	      if (basesLink.allow.includes('POST')) {
	        vm.basis = scaffold(property.code);
	        console.log('vm.basis..', vm.basis);
	        _watchAndSyncPeriods();
	      } else {
	        $log.error('POST not allowed ', basesLink);
	        // silent ?
	        return $state.go('property.rateBases');
	      }
	    } else {
	      $http.get(basesLink.href + '/' + vm.basisCode).then(function (res) {
	        vm.basis = decode(res.data);
	        vm.countriesRestrict = vm.basis.sales.countries && vm.basis.sales.countries.length > 0;
	        vm.segmentsRestrict = Object.keys(vm.basis.sales.segments).length > 0;
	        vm.prestationsRestrict = Object.keys(vm.basis.prestations).length > 0;
	        vm.disableBookingStart = moment(vm.basis.booking.period.start).isBefore(moment(), "days");
	        vm.disableStayStart = moment(vm.basis.stay.period.start).isBefore(moment(), "days");
	        vm.countriesExcluded = vm.basis.stop.countries && vm.basis.stop.countries.length > 0;
	        vm.markupsRestrict = Object.keys(vm.basis.markups).length > 0;
	        // angular.extend(vm, {
	        //         toggleRate: toggleRateAmenities
	        //       });
	        _watchAndSyncPeriods();
	      }, loadFailed);

	      $http.get(property.links['rate-bases'].href + '/' + vm.basisCode + '/amenities').then(function (amenities) {

	        vm.amenitiesss = amenities.data;
	        vm.amenitiesss1 = vm.amenitiesss.items.map(function (a) {
	          return a.amenity;
	        });
	        //vm.selected= vm.amenitiesss.items.map(a => a.amenity.code);

	        //vm.selected= vm.amenitiesss.items.map(a => a.amenity);

	        vm.amenitiesss2 = vm.amenitiesss.items.map(function (a) {
	          return a.amenity;
	        });
	        vm.amenitiesss3 = vm.amenitiesss.items.map(function (am) {
	          return {
	            amenity: am.amenity
	          };
	        });
	        vm.amenitiesss3.map(function (b) {
	          return Object.create({
	            selected: true
	          });
	        });
	        //amenities.data;
	        // vm._rateAmenities = amenities.items;
	        // vm.rateAmenities = amenities.items.map(a => a.amenity);
	        // vm.amenitiesRestrict = amenities.items.length;

	        // vm.ampermissions = amenities.permissions;
	      });
	    }
	  };

	  // function processUnits(collection) {
	  //   const promises = collection.items.map(u => _.pick(u, ["code", "name", "type", "links"]))
	  //     .map(loadUnitAmenities);
	  //   return $q.all(promises);
	  // }


	  // function loadUnitAmenities(u) {
	  //   return $http.get(u.links.amenities.href).then(res => {
	  //     u._amenities = res.data.items;
	  //     u.amenities = res.data.items.map(a => a.amenity);
	  //     return u;
	  //   });
	  // }


	  angular.extend(vm, {
	    save: save,
	    segments: vm.segments,
	    prestations: rateUtil.prestations,
	    toggleRate: toggleRateAmenities,
	    removeSeasonsPeriodRange: removeSeasonsPeriodRange,
	    addSeasonPeriodRange: addSeasonPeriodRange,
	    chargeUnits: {
	      '%': '%',
	      'm': 'm',
	      'n': 'nuit(s)'
	    },
	    currencies: ['MAD'],
	    types: [{
	      code: 'wholesale',
	      name: 'Net'
	    }, {
	      code: 'com',
	      name: 'Commission',
	      commission: true
	    }]
	  });

	  function scaffold(propertyCode) {
	    // var checkin = "23:59"
	    // vm.propertyCtrl.property.policies && vm.propertyCtrl.property.policies.checkin ||
	    // "12:00";
	    return {
	      code: -1,
	      description: "",
	      property: propertyCode,
	      commission: 0,
	      payOnArrival: false,
	      taxInc: true,
	      booking: {
	        period: {
	          start: moment().startOf("day").toDate(),
	          end: null
	        },
	        advance: {
	          min: 0,
	          max: 365,
	          timeLimit: getDefaultTime() //moment(checkin, ["HH:mm", "HH:mm:ss"]).toDate()
	        }
	      },
	      stay: {
	        period: {
	          start: moment().startOf("day").toDate(),
	          end: null
	        },
	        max: 365
	      },
	      sales: {
	        segments: [],
	        countries: []
	      },
	      stop: {

	        countries: []
	      },
	      // view helpers
	      type: '',
	      commissionable: false,
	      seasons: {
	        ranges: []
	      }
	    };
	  }

	  function decode(rb) {
	    return rateUtil.decodeRateBasis(rb);
	  }

	  function getDefaultTime() {
	    return new Date(new Date().toDateString() + ' ' + '23:59');
	  }
	  function removeSeasonsPeriodRange(index) {
	    vm.basis.seasons.ranges.splice(index, 1);
	  }
	  function encode(rb) {
	    var dtf = "YYYY-MM-DDTHH:mm:ss";
	    console.log('seasons...', rb.seasons);

	    var encoded = {
	      code: rb.code === -1 ? undefined : rb.code,
	      property: vm.propertyCtrl.property.code,
	      commission: rb.commission,
	      description: rb.description,
	      currency: rb.currency,
	      payOnArrival: rb.commission > 0 ? rb.payOnArrival : false,
	      taxInc: rb.taxInc,
	      booking: {
	        period: toRange(moment(rb.booking.period.start).format(dtf), moment(rb.booking.period.end).format(dtf)),
	        interval: toRange(rb.booking.advance.min, rb.booking.advance.max, false),
	        timeLimit: rb.booking.advance.min === 0 ? timeToMinutes(rb.booking.advance.timeLimit) : undefined
	        // timeLimit: rb.booking.advance.min === 0 ? timeToMinutes(getDefaultTime()) : undefined

	      },
	      stay: {
	        period: toRange(dateAsString(rb.stay.period.start), dateAsString(rb.stay.period.end)),
	        max: rb.stay.max
	      },
	      sales: {
	        segments: vm.segmentsRestrict ? booleansToArray(rb.sales.segments) : null,
	        countries: vm.countriesRestrict ? rb.sales.countries : null

	        //packaging: rb.sales.packagingRestrict ? null : rb.sales.countries,
	      },
	      markups: vm.markupsRestrict ? booleansToArray(rb.markups) : null,
	      seasons: rb.seasons,
	      stop: {
	        countries: vm.countriesExcluded ? rb.stop.countries : null

	        //packaging: rb.sales.packagingRestrict ? null : rb.sales.countries,

	        // prestations: vm.prestationsRestrict ? booleansToArray(rb.sales.prestations) : null

	      } };
	    return encoded;
	  }

	  function timeToMinutes(date) {
	    console.log('date...', date);
	    // return date ? (date.getHours() * 60) + date.getMinutes() : null;
	    return date ? date.getHours() * 60 + date.getMinutes() : null;
	  }

	  function addSeasonPeriodRange() {
	    // console.log('line...', line)
	    console.log("vm.newRange..", vm.seasons);

	    var newRange = angular.copy(vm.seasons);

	    newRange.from = moment(newRange.from).format("YYYY-MM-DD");
	    newRange.to = moment(newRange.to).format("YYYY-MM-DD");
	    newRange.season = newRange.season;

	    var start = moment(newRange.from);
	    var end = moment(newRange.to);
	    if (moment(moment(newRange.from).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid() && moment(moment(newRange.to).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid()) {
	      for (var i = vm.basis.seasons.ranges.length - 1; i >= 0; i--) {
	        var rateFrom = moment(vm.basis.seasons.ranges[i].from);
	        var rateTo = moment(vm.basis.seasons.ranges[i].to);
	        if (start.isSame(rateFrom) || end.isSame(rateTo) || start.isAfter(rateFrom) && start.isBefore(rateTo) || end.isAfter(rateFrom) && end.isBefore(rateTo)) break;
	      }
	      if (i < 0) {
	        vm.basis.seasons.ranges.push(newRange);
	        vm.newRangeBooking = {
	          from: "",
	          to: "",
	          season: ""
	        };
	      } else alert("overlap between periods");
	    } else if (moment(moment(newRange.from).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid() == false) alert("select from date");else if (moment(moment(newRange.to).format("YYYY-MM-DD"), "YYYY-MM-DD").isValid() == false) alert("select to date");

	    console.log("vm.basis.seasons.ranges..", vm.basis.seasons.ranges);
	  }

	  function toggleRateAmenitiesTarif(r, a) {
	    $log.debug('toggleRateAmenities', a);

	    if (a.disabled) return;
	    var index = vm.selected.indexOf(a);
	    var rateAmenities2 = vm.amenitiesss2;
	    var rateAIndex = vm.amenitiesss2.indexOf(a);
	    var rateAmenities = vm.options.rate;
	    var rateA = rateAmenities.filter(function (obj) {
	      return obj.code == a;
	    });

	    // if (rateAmenities2.length== 0){
	    //   vm.amenitiesss2.push(rateA);
	    // }
	    if (!rateAmenities2.includes(a)) {
	      if (!vm.selected.includes(a)) {
	        // addAmenity(a, baseUrl, vm.amenitiesss1, vm.amenitiesss.items);
	        vm.selected.push(a);
	        vm.amenitiesss2.push(rateA);
	      }
	      //if (!rateAmenities2.includes(a)) vm.amenitiesss2.push(rateA);
	      else {
	          //vm.amenitiesss2.splice(rateAIndex,1);
	          vm.selected.splice(index, 1);
	        }
	    } else {
	      if (!vm.selected.includes(a)) {
	        // addAmenity(a, baseUrl, vm.amenitiesss1, vm.amenitiesss.items);
	        vm.selected.push(a);
	        // vm.amenitiesss2.splice(rateAIndex,1);

	      } else {
	        vm.selected.splice(index, 1);
	        //const rateAIndex =vm.amenitiesss2.findIndex(obj => obj.code == a);
	        //const rateAIndex = vm.amenitiesss2.indexOf(a);

	        vm.amenitiesss2.splice(rateAIndex, 1);
	      }
	    }
	    //removeAmenity(a, baseUrl, rateAmenities, vm.amenitiesss.items);
	    // addAmenity(a, baseUrl, r.amenities, r._amenities)
	  }

	  function toggleRateAmenities(r, a) {
	    $log.debug('toggleRateAmenities', a);
	    if (a.disabled) return;
	    //const rateAmenities = vm.amenitiesss1;
	    var baseUrl = r.links.amenities.href;
	    var index = vm.selected.indexOf(a);
	    var rateAmenities2 = vm.amenitiesss2;
	    var rateAIndex = vm.amenitiesss2.indexOf(a);
	    var rateAmenities = vm.options.rate;
	    var rateA = rateAmenities.filter(function (obj) {
	      return obj.code == a;
	    });

	    // if (rateAmenities2.length== 0){
	    //   vm.amenitiesss2.push(rateA);
	    // }
	    if (!rateAmenities2.includes(a)) {
	      if (!vm.selected.includes(a)) {
	        // addAmenity(a, baseUrl, vm.amenitiesss1, vm.amenitiesss.items);
	        vm.selected.push(a);
	        vm.amenitiesss2.push(rateA);
	      }
	      //if (!rateAmenities2.includes(a)) vm.amenitiesss2.push(rateA);
	      else {
	          //vm.amenitiesss2.splice(rateAIndex,1);
	          vm.selected.splice(index, 1);
	        }
	    } else {
	      if (!vm.selected.includes(a)) {
	        // addAmenity(a, baseUrl, vm.amenitiesss1, vm.amenitiesss.items);
	        vm.selected.push(a);
	        // vm.amenitiesss2.splice(rateAIndex,1);

	      } else {
	        vm.selected.splice(index, 1);
	        //const rateAIndex =vm.amenitiesss2.findIndex(obj => obj.code == a);
	        //const rateAIndex = vm.amenitiesss2.indexOf(a);

	        vm.amenitiesss2.splice(rateAIndex, 1);
	      }
	    }
	    //removeAmenity(a, baseUrl, rateAmenities, vm.amenitiesss.items);
	    // addAmenity(a, baseUrl, r.amenities, r._amenities)
	  }

	  function toggleRateAmenity(r, a) {
	    if (a.disabled) return;
	    var rateAmenities = vm.amenitiesss1;
	    var baseUrl = r.links.amenities.href;
	    if (a.length > 0) {

	      for (var t = 0; t < a.length; t++) {
	        if (!rateAmenities.includes(a[t])) addAmenity(a[t], baseUrl, vm.amenitiesss1, vm.amenitiesss.items);else removeAmenity(a[t], baseUrl, rateAmenities, vm.amenitiesss.items);
	      }
	      // addAmenity(a, baseUrl, r.amenities, r._amenities)
	    }
	  }

	  // function togglePropertyAmenity(a) {
	  //   $log.debug("togglePropertyAmenity",a)

	  //   if(a.disabled) return;
	  //   const propAmenities = vm.propertyAmenities;
	  //   const baseUrl = vm.propertyCtrl.property.links.amenities.href;
	  //   if (!propAmenities.includes(a.code)) addAmenity(a, baseUrl, propAmenities, vm._propertyAmenities);
	  //   else removeAmenity(a, baseUrl, propAmenities, vm._propertyAmenities);
	  // }


	  function addAmenity(a, baseUrl, selectedCodes, selectedAmenities) {
	    //$log.debug("addAmenity",a, baseUrl, selectedCodes, selectedAmenities)

	    // add;
	    //a.disabled = true;
	    $http.post(baseUrl, { amenity: a }).then(function (res) {
	      selectedAmenities.push(res.data);
	      //selectedCodes.push(a.code);
	      //a.disabled = false;
	    }, function () {
	      $log.error("cannot add amenity");
	      a.disabled = false;
	    });
	  }

	  function removeAmenity(a, baseUrl, selectedCodes, selectedAmenities) {
	    $log.debug("removeAmenity", a, baseUrl, selectedCodes, selectedAmenities);
	    var index = selectedCodes.indexOf(a);
	    // a.disabled = true;
	    // bug in mo-http for composite keys after post
	    //var url = selectedAmenities.find(pa => ua.amenity === a.code).links.self.href;
	    $http.delete(baseUrl + "/" + a).then(function () {
	      selectedCodes.splice(index, 1);
	      selectedAmenities.splice(index, 1);
	      //  a.disabled = false;
	    }, function () {
	      $log.error("cannot remove amenity");
	      // a.disabled = false;
	    });
	  }

	  function save() {
	    console.log("vm.basis", vm.basis);

	    var encoded = encode(vm.basis);
	    //return;
	    console.log("vm.basis", vm.basis);
	    $log.debug('encoded', encoded);
	    // const slctd = vm.selected;
	    //return;
	    var href = vm.propertyCtrl.property.links['rate-bases'].href;

	    // $log.debug('post',href,encoded);
	    // return;
	    if (angular.isUndefined(encoded.code)) {
	      $http.post(href, encoded).then(saveSuccess, postFailure);
	      toggleRateAmenity(vm.basis, vm.selected);
	    } else {
	      $http.put(vm.basis.links.self.href, encoded).then(saveSuccess, patchFailure);
	      // toggleRateAmenity(vm.basis,vm.basis.prestationsRates);
	      toggleRateAmenity(vm.basis, vm.selected);
	    }
	  }

	  function saveSuccess(res) {
	    $state.go('property.rateBasisView', { basis: res.data.code });
	  }

	  function patchFailure() {
	    $log.error(arguments);
	  }

	  function postFailure() {
	    $log.error(arguments);
	  }

	  function booleansToArray(bools) {
	    return Object.keys(bools).filter(function (b) {
	      return bools[b];
	    });
	  }

	  function dateAsString(d) {
	    return d ? moment(d).format('YYYY-MM-DD') : null;
	  }

	  function toRange(start, end, open) {
	    var str = ["[", start, ","];
	    if (open) {
	      str.push(")");
	    } else {
	      str.push(end, "]");
	    }
	    return str.join("");
	  }

	  function loadFailed() {
	    // dialog404.show('Base tarifaire :num introuvable','property.rateBases');
	    $log.error(arguments);
	  }

	  function _setupToolbar(container) {
	    container.setBreadcrumb([{ label: "Bases tarifaires", href: $state.href("property.rateBasisList") }]);
	  }

	  function _watchAndSyncPeriods() {
	    $scope.$watch(function () {
	      return vm.basis.booking.period.start;
	    }, function (bookingStart) {
	      var stay = vm.basis.stay.period;
	      if (!angular.isDate(bookingStart)) return;
	      if (!angular.isDate(stay.start)) {
	        stay.start = bookingStart;
	      } else if (moment(stay.start).isBefore(bookingStart)) {
	        stay.start = bookingStart;
	      }
	    });
	    $scope.$watch(function () {
	      return vm.basis.booking.period.end;
	    }, function (bookingEnd) {
	      var stay = vm.basis.stay.period;
	      if (!angular.isDate(bookingEnd)) return;
	      if (!angular.isDate(stay.end)) {
	        stay.end = bookingEnd;
	      } else if (moment(stay.end).isBefore(bookingEnd)) {
	        stay.end = bookingEnd;
	      }
	    });
	  }
	}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	'use strict';

	cancellationInput.$inject = ["$log"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cancellationInput;
	function cancellationInput($log) {
	  'ngInject';

	  return {
	    templateUrl: 'app/rate-basis/cancellation-input/template.html',
	    restrict: 'E',
	    link: link,
	    require: 'ngModel',
	    scope: {
	      currency: '='
	    }
	  };

	  function link(scope, el, attrs, ngModelCtrl) {

	    init();

	    ngModelCtrl.$formatters.push(function (modelValue) {
	      return modelValue ? modelValue.map(decode) : [];
	    });
	    ngModelCtrl.$render = function () {
	      var rules = ngModelCtrl.$viewValue || [];
	      scope.rules = rules;
	      $log.debug(rules);
	      if (rules.length === 1) {
	        if (isFree(rules[0])) scope.cancellationType = 'free';else if (isNRF(rules[0])) scope.cancellationType = 'nrf';
	      } else if (rules.length > 0) {
	        scope.cancellationType = 'custom';
	      }
	    };
	    ngModelCtrl.$parsers.push(function (viewValue) {
	      return viewValue.map(encode);
	    });
	    ngModelCtrl.$validators.noRules = function (modelValue) {
	      return angular.isArray(modelValue) && modelValue.length > 0;
	    };

	    function init() {

	      angular.extend(scope, {
	        rules: [],
	        nonRefundable: nonRefundable,
	        freeCancellation: freeCancellation,
	        add: add,
	        remove: remove,
	        newRule: {},
	        units: {
	          '%': '%',
	          'm': scope.currency,
	          'n': 'nuit(s)'
	        }
	      });
	    }

	    function add(rule, clear) {
	      var copy = angular.copy(rule);
	      var existing = scope.rules.find(function (r) {
	        return r.days === copy.days;
	      });
	      if (existing) {
	        scope.rules[scope.rules.indexOf(existing)] = copy;
	      } else {
	        scope.rules.push(copy);
	        scope.rules.sort(sort);
	      }
	      if (clear) {
	        rule.days = undefined;
	        rule.unit = undefined;
	        rule.charge = undefined;
	      }
	      ngModelCtrl.$setViewValue(scope.rules.slice());
	    }

	    function remove(index) {
	      scope.rules.splice(index, 1);
	      ngModelCtrl.$setViewValue(scope.rules.slice());
	    }

	    function clear() {
	      scope.rules.length = 0;
	    }

	    function nonRefundable() {
	      clear();
	      add({
	        days: 999,
	        unit: '%',
	        charge: 100
	      });
	    }

	    function freeCancellation() {
	      clear();
	      add({
	        days: 0,
	        unit: '%',
	        charge: 0
	      });
	    }

	    function sort(r1, r2) {
	      return r2.days - r1.days;
	    }
	  }

	  function decode(rule) {
	    $log.debug('decode(rule) ', rule);
	    var match = rule.match(/^(\d{1,3})([mn%])(\d+(.\d+)?)$/);
	    return {
	      days: parseInt(match[1], 10),
	      unit: match[2],
	      charge: parseFloat(match[3])
	    };
	  }

	  function encode(rule) {
	    return [rule.days, rule.unit, rule.charge].join('');
	  }

	  function isFree(rule) {
	    return rule.days === 0 && rule.charge === 0;
	  }
	  function isNRF(rule) {
	    return rule.days === 999 && rule.charge === 100 && rule.unit === '%';
	  }
	}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	'use strict';

	marketsInput.$inject = ["$log"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = marketsInput;
	function marketsInput($log) {
	  'ngInject';

	  return {
	    templateUrl: 'app/rate-basis/markets-input/template.html',
	    restrict: 'E',
	    link: link,
	    require: 'ngModel',
	    scope: {
	      countries: '='
	    }
	  };

	  function link(scope, el, attrs, ngModelCtrl) {
	    ngModelCtrl.$formatters.push(function (modelValue) {
	      return modelValue ? modelValue.map(decode) : [];
	    });
	    ngModelCtrl.$render = function () {
	      var selection = ngModelCtrl.$viewValue || [];
	      scope.selection = selection;
	      // $log.debug(selection);
	    };
	    ngModelCtrl.$parsers.push(function (viewValue) {
	      // $log.debug("viewValue",viewValue)
	      return viewValue.map(encode);
	    });
	    ngModelCtrl.$validators.required = function (modelValue) {
	      // $log.debug("validators", modelValue)
	      return angular.isArray(modelValue) && modelValue.length > 0;
	    };

	    scope.updateViewValue = function () {
	      ngModelCtrl.$setViewValue(scope.selection.slice());
	    };

	    function decode(code) {
	      $log.debug('decode(cc) ', code);
	      return scope.countries.find(function (c) {
	        return c.code === code;
	      });
	    }

	    function encode(country) {
	      return country.code;
	    }
	  }
	}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deadline;
	function deadline() {
	  'ngInject';
	  /**
	   * @param  {[type]} deadline.min [description]
	   * @param  {[type]} deadline.max [description]
	   * @return {[type]}          [description]
	   */

	  return function (value) {
	    console.log(value);
	    if (!value) return;
	    var parts = [];
	    if (value.max) {
	      parts.push(value.max + "j.");
	    }
	    if (value.min === 0) {
	      parts.push("jusqu'au jour d'arrivé");
	    } else {
	      parts.push(value.min + "j. avant l'arrivé");
	    }
	    return parts.join(" ");
	  };
	}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	"use strict";

	rateUtil.$inject = ["moment", "$state", "$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rateUtil;
	/* global _:false */

	function rateUtil(moment, $state, $http) {

	  /*- Site & Appli
	  - Walk-in ( pour le front desk/téléphone)
	  - B2B ( pour les agences de voyages)
	  - OTA 
	  - TO
	  - MICE ( pour les groupes loisirs et affaires)*/

	  // to: 'TO',
	  // agency: 'Agences',
	  // siteWeb: 'Site Web',
	  // application: 'Application',
	  // crs: 'CRS',
	  // trip: 'Trip.com',
	  // booking: 'Booking',
	  // expedia: 'Expedia'
	  'ngInject';

	  return {
	    segments: [{ "name": "Site & Appli" }, { "name": "Walk-in" }, { "name": "B2B" }, { "name": "OTA" }, { "name": "TO" }, { "name": "MICE" }],
	    prestations: {
	      spa: 'SPA'
	    },
	    getSegments: getSegments,
	    decodeRateBasis: decodeRateBasis,
	    decodeCancellation: decodeCancellation,
	    decodeRange: decodeRange,
	    decodeIntRange: decodeIntRange,
	    decodeDateRange: decodeDateRange
	  };

	  function getSegments(crmApiUrl) {
	    // var url = crmApiUrl
	    //valeria test purpose 
	    console.log('getSegmentscrmApiUrl', crmApiUrl);
	    crmApiUrl.replace('http', 'https');
	    console.log('getSegmentscrmApiUrl', crmApiUrl);
	    //var crmUrl="https://crm.sotlamer.com/api";
	    var url = crmApiUrl + "/segments";
	    return $http({
	      method: 'GET',
	      url: url
	    }).then(function (response) {
	      console.log('getSegments', response);
	      return response.data;
	    });
	  }

	  // sees ints
	  function decodeRange(value) {
	    var endpoints = value.slice(1, -1).split(",", 2);
	    var start = endpoints[0] ? endpoints[0] : null;
	    var end = endpoints[1] ? endpoints[1] : null;
	    return [_.trim(start, '"'), _.trim(end, '"'), value[0], value[value.length - 1]];
	  }

	  function decodeIntRange(value) {
	    var array = decodeRange(value);
	    var val = {
	      min: parseInt(array[0], 10),
	      max: array[1] === null ? null : parseInt(array[1], 10),
	      open: array[1] === null
	    };
	    if (val.open === false && array[3] === ')') {
	      val.max -= 1;
	    }
	    return val;
	  }

	  function decodeDateRange(value) {
	    var array = decodeRange(value);
	    var val = {
	      start: moment(array[0]).toDate(),
	      end: array[1] === null ? null : moment(array[1]).toDate(),
	      open: array[1] === null
	    };
	    if (val.open === false && array[3] === ')') {
	      val.end = moment(val.end).startOf('day').subtract(1, 'days').toDate();
	    }
	    return val;
	  }

	  function decodeCancellation(c, currency) {
	    var rules = c.map(function (rule) {
	      var match = rule.match(/^(\d+)([%mn])([\d.]+)$/);
	      return {
	        days: match[1],
	        unit: match[2] === 'm' ? currency : match[2],
	        charge: new Number(match[3])
	      };
	    });
	    var type = 'custom';
	    if (c.length === 1) {
	      if (c[0] === '0%0') {
	        type = 'free';
	        rules.length = 0;
	      }
	      if (c[0] === '999%100') {
	        type = 'nrf';
	        rules.length = 0;
	      }
	    }
	    return {
	      type: type,
	      rules: rules
	    };
	  }

	  function decodeSalesCountries(list) {
	    return list;
	  }

	  function decodeRateBasis(rb) {
	    console.log('rb::,', rb);
	    var com = parseFloat(rb.commission, 10);
	    var decoded = _.pick(rb, ["links", "permissions", "code", "property", "description", "payOnArrival"]);
	    var bookingPeriod = decodeDateRange(rb.booking.period);
	    bookingPeriod.start = new Date(bookingPeriod.start);
	    bookingPeriod.end = new Date(bookingPeriod.end);
	    _.merge(decoded, {
	      type: com == 0 ? "Net" : "Commissionable",
	      commission: com,
	      commissionable: com > 0,
	      taxInc: rb.taxInc || false,
	      currency: rb.currency,
	      booking: {
	        //period: bookingPeriod,
	        period: decodeDateRange(rb.booking.period),
	        advance: decodeIntRange(rb.booking.interval),
	        timeLimit: angular.isNumber(rb.booking.timeLimit) ? moment().startOf("day").minutes(rb.booking.timeLimit).toDate() : null
	      },
	      stay: {
	        period: decodeDateRange(rb.stay.period),
	        max: rb.stay.max
	      },
	      sales: {
	        segments: rb.sales.segments ? rb.sales.segments.reduce(function (agg, seg) {
	          agg[seg] = true;
	          return agg;
	        }, {}) : {},
	        countries: decodeSalesCountries(rb.sales.countries)
	      },
	      markups: rb.markups ? rb.markups.reduce(function (agg, seg) {
	        agg[seg] = true;
	        return agg;
	      }, {}) : {},
	      markps: rb.markups,
	      seasons: rb.seasons,
	      stop: {

	        countries: decodeSalesCountries(rb.stop.countries)
	      },
	      prestations: rb.prestations ? rb.prestations.reduce(function (agg, pres) {
	        agg[pres] = true;
	        return agg;
	      }, {}) : {}

	    });
	    if (decoded.commission == 0) decoded.type = 'net';
	    decoded.links.edit = { href: $state.href("property.rateBasisEdit", { basis: decoded.code }) };
	    return decoded;
	  }
	}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	"use strict";

	EditRateBasisCalendarCtrl.$inject = ["$log", "$mdDialog", "rateBasis", "apiUrl", "datasets", "itemTypes", "$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = EditRateBasisCalendarCtrl;
	function EditRateBasisCalendarCtrl($log, $mdDialog, rateBasis, apiUrl, datasets, itemTypes, $http) {
	  "ngInject";

	  var vm = this;
	  var COMMAND_URL = apiUrl + "/commands/rate-conditions-calendars";

	  //console.log(rateBasis);

	  angular.extend(vm, {
	    periods: [],
	    rateBasis: rateBasis,
	    cancel: function cancel() {
	      return $mdDialog.cancel();
	    },
	    applyChanges: applyChanges
	  });

	  if (itemTypes.includes("cancellation")) {
	    vm.editCancellation = true;
	    vm.rules = [];
	  }
	  if (itemTypes.includes("minStay")) {
	    vm.editMinStay = true;
	    vm.minStay = 1;
	  }

	  if (itemTypes.includes("markup")) {
	    vm.editMarkup = true;
	    vm.markup = 0;
	  }

	  if (itemTypes.includes("markupss")) {
	    vm.editMarkupss = true;
	    vm.markupss = 0;
	  }

	  datasets.get('markup_type').then(function (set) {
	    vm.markups = set.items;
	  });
	  function applyChanges() {
	    var args = {
	      periods: vm.getPeriods(),
	      rateBases: [rateBasis.code]
	    };
	    if (vm.editMinStay) {
	      args.minStay = [vm.minStay];
	    }

	    if (vm.editMarkup) {
	      args.markup = [vm.markup];
	    }
	    if (vm.editMarkupss) {
	      args.markups = [vm.markupss];
	    }
	    if (vm.editCancellation) {
	      args.cancellation = [vm.rules];
	    }
	    vm.status = "processing";
	    $http.post(COMMAND_URL, args).then(function () {
	      $log.debug('nights updated');
	      $mdDialog.hide(args);
	    }, handleError);
	  }

	  function handleError(res) {
	    $log.error(res);
	    vm.status = "error";
	    vm.error = true;
	    vm.errorRes = res;
	  }
	}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(118);

	var _component2 = _interopRequireDefault(_component);

	var _component3 = __webpack_require__(119);

	var _component4 = _interopRequireDefault(_component3);

	var _component5 = __webpack_require__(120);

	var _component6 = _interopRequireDefault(_component5);

	var _component7 = __webpack_require__(121);

	var _component8 = _interopRequireDefault(_component7);

	var _component9 = __webpack_require__(122);

	var _component10 = _interopRequireDefault(_component9);

	var _component11 = __webpack_require__(123);

	var _component12 = _interopRequireDefault(_component11);

	var _component13 = __webpack_require__(124);

	var _component14 = _interopRequireDefault(_component13);

	var _component15 = __webpack_require__(125);

	var _component16 = _interopRequireDefault(_component15);

	var _component17 = __webpack_require__(126);

	var _component18 = _interopRequireDefault(_component17);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusYield', ['ui.router', 'lectusApi']).component(_component2.default.name, _component2.default).component(_component4.default.name, _component4.default).component(_component6.default.name, _component6.default).component(_component8.default.name, _component8.default).component(_component10.default.name, _component10.default).component(_component12.default.name, _component12.default).component(_component14.default.name, _component14.default).component(_component16.default.name, _component16.default).component(_component18.default.name, _component18.default).config(["$stateProvider", function amenitiesRoutes($stateProvider) {
	  'ngInject';
	  // State

	  $stateProvider.state('property.calendarGraphs', {
	    url: "/calendars/graphs",
	    component: 'unitRelWrapper',
	    resolve: {
	      breadcrumb: function breadcrumb() {
	        return [{ label: 'Tarifs et dispo' }];
	      },
	      unitViewState: function unitViewState() {
	        return 'property.calendarGraphs.unit';
	      }
	    },
	    data: {
	      menu: {
	        label: 'Calendriers',
	        group: 'Tarifs et dispo',
	        position: 3
	      }
	    }
	  }).state('property.calendarGraphs.unit', {
	    // global amenities dataset management
	    url: "/:unit",
	    component: _component2.default.name,
	    resolve: {
	      unitCode: ["$stateParams", function unitCode($stateParams) {
	        'ngInject';

	        return $stateParams.unit;
	      }]
	    }
	  }).state('property.calendarsTable', {
	    // global amenities dataset management
	    url: "/calendars/table",
	    component: _component4.default.name
	  }).state('property.calendarTable', {
	    url: "/calendars/room/table",
	    component: _component6.default.name,

	    data: {
	      menu: {
	        label: 'Etat des Chambres',
	        group: 'Tarifs et dispo',
	        position: 3
	      }
	    }
	  });
	}]);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	UnitGraphsCtrl.$inject = ["User", "$log", "$q", "$http", "$mdDialog", "$state", "datasets", "relations", "allotmentsHelper", "productsHelper"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _occupancy = __webpack_require__(104);

	var _occupancy2 = _interopRequireDefault(_occupancy);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var moment = __webpack_require__(10);
	var _ = __webpack_require__(5);

	exports.default = {
	  name: 'unitCalendarGraphs',
	  controller: UnitGraphsCtrl,
	  templateUrl: 'app/yield/unit-graphs/template.html',
	  bindings: {
	    unitCode: '<unitCode'
	  },
	  require: {
	    unitListCtrl: '^unitRelWrapper',
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function UnitGraphsCtrl(User, $log, $q, $http, $mdDialog, $state, datasets, relations, allotmentsHelper, productsHelper) {
	  "ngInject";

	  var vm = this;
	  // colors are used for each allotment
	  vm.uploadStart;
	  // console.log("teeest",vm.uploadStart);
	  // if(vm.uploadStart!=undefined)
	  vm.uploadStart1 = moment();

	  var period = {
	    start: vm.uploadStart1.startOf('day'),
	    end: moment().startOf('day').add(6, 'months')
	  };
	  var calFilter = {
	    $sort: "date<",
	    start: period.start.format('YYYY-MM-DD'),
	    end: period.end.format('YYYY-MM-DD')
	  };
	  var boardMap = new Map();
	  boardMap.set(1000, "BO");
	  boardMap.set(1100, "BB");
	  boardMap.set(1110, "HB");
	  boardMap.set(1101, "HBd");
	  boardMap.set(1111, "FB");
	  boardMap.set(2111, "AI");
	  boardMap.set(1222, "AI");
	  boardMap.set(1333, "AIP");
	  boardMap.set(1444, "AIB");

	  var boardss = [{ code: 1000, name: "BO" }, { code: 1100, name: "BB" }, { code: 1110, name: "HB" }, { code: 1111, name: "FB" }, { code: 1222, name: "AI" }, { code: 1333, name: "AIP" }, { code: 1444, name: "AIB" }];

	  //const graphDates = _makeGraphDates(period);

	  angular.extend(vm, {
	    $onInit: onInit,
	    //uploadStart:uploadStart,
	    // boardMap,boardMap,
	    period: period,
	    editAvailable: editAvailable,
	    boardss: boardss,
	    selectedProductType: selectedProductType,
	    selectedBoards: selectedBoards,
	    processProductsWithFilter: processProductsWithFilter,
	    loadData: loadData,
	    editRates: editRates,
	    clonePeriodRates: clonePeriodRates,
	    availability: {
	      data: [],
	      options: allotmentsHelper.availabilityGraphOptions(period)
	    },
	    rates: {
	      data: [],
	      options: productsHelper.ratesGraphOptions(period)
	    }
	  });

	  function onInit() {

	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });
	    if (vm.uploadStart != undefined) {
	      //console.log("here",vm.uploadStart.moment());
	      vm.uploadStart1 = vm.uploadStart;
	      vm.period.start = moment(vm.uploadStart).startOf('day');
	      vm.period.end = moment(vm.uploadStart).startOf('day').add(6, 'months');
	      //vm.availabilityChartApi=null;
	      // vm.availability.options=null;
	      // vm.rates.options=null;
	      // vm.availability.data=[];
	      // vm.rates.data=[];
	      delete vm.availability.options;
	      delete vm.rates.options;
	      vm.availability.options = allotmentsHelper.availabilityGraphOptions(vm.period);
	      vm.rates.options = productsHelper.ratesGraphOptions(vm.period);
	    }
	    // const p3 = datasets.bindSets(["boards"])
	    //   .then(collection => vm.board = _.keyBy(collection.items, "code"));
	    var p1 = datasets.bindSets(['boards'], vm, false).then(function () {
	      return datasets.bindSets(['unit-types'], vm, true);
	    }).then(function () {
	      return vm.boards.map(function (board) {
	        board.name = boardMap.get(board.code);
	        console.log("board.name", board.name);
	        console.log("boardMap.get(board.code)", boardMap.get(board.code));
	      });
	    });
	    // () => vm.boards.sort((a, b) => a.code - b.code));
	    //  vm.boards.map(board => {
	    //   board.name=boardMap.get(board.code)

	    // })
	    // vm.boardss.sort((a, b) => a.code - b.code);
	    console.log("m.board", vm.boards);
	    //console.log("m.boardp1",p1);


	    // property actions
	    vm.propertyCtrl.setActions(_buildViewActions());

	    if (vm.uploadStart != undefined) {

	      vm.ready.then(function () {
	        return processAllotments() //.then(addBookedGraphSeries)
	        .then(function () {
	          vm.rateGroups.map(function (a) {
	            processProductsWithFilter(a);
	          });
	        });
	      }).catch(function (error) {
	        $log.error(error);
	      });
	    } else {
	      vm.ready = datasets.bindSets(["boards"], vm, true).then(function () {
	        return vm.propertyCtrl.get('rate-bases');
	      }).then(function (collection) {
	        vm.rateBases = collection.items;
	        vm.rateBasesIndex = _.keyBy(vm.rateBases, "code");
	        return vm.unitListCtrl.activateUnit(vm.unitCode);
	      }).then(function (unit) {
	        vm.unit = _.pick(unit, ["code", "name", "type", "links"]);
	        var tasks = ["allotments", "products"].map(function (rel) {
	          return relations.fetch(rel, vm.unit);
	        });
	        return $q.all(tasks);
	      });
	      var task3 = vm.propertyCtrl.get('seasons').then(function (collection) {
	        vm.seasons = collection.items;
	        vm.seasonsIndex = _.keyBy(vm.seasons, "code");
	      });
	      vm.ready.then(function () {
	        return processAllotments() //.then(addBookedGraphSeries)
	        .then(processProducts);
	      }).catch(function (error) {
	        $log.error(error);
	      });
	    }
	  }

	  function processAllotments() {
	    console.log("period:::", vm.period);
	    // vm.availability.options=null;
	    // vm.rates.options=null;

	    var period = vm.period;
	    var collection = vm.unit.allotments;
	    var calFilter = {
	      $sort: "date<",
	      start: period.start.format('YYYY-MM-DD'),
	      end: period.end.format('YYYY-MM-DD')
	    };
	    var tasks = collection.items
	    // set open sell last
	    .sort(function (a) {
	      return a.contracted === false ? 1 : 0;
	    }).map(allotmentsHelper.allotmentColor).map(function (a) {
	      var prefix = a.contracted ? "allot." : "flex";
	      var bases = a.bases.map(function (code) {
	        console.log("vm.rateBasesIndex[code]:::", vm.rateBasesIndex[code]);

	        vm.rateBasesIndex[code].description;
	      }).join(',');
	      a.label = prefix + '(' + bases + ')';
	      return a;
	    }).map(function (a) {
	      return function () {
	        return $http.get(a.links.calendar.href, {
	          params: calFilter
	        }).then(function (res) {
	          return allotmentsHelper.calendarToGraphs(a, res.data.items, period, vm.availability.data);
	        });
	      };
	    });
	    return _parallel(tasks).then(function () {
	      addBookedGraphSeries();

	      return vm.availabilityChartApi.refresh();
	    });
	  }

	  function addBookedGraphSeries() {
	    if (vm.uploadStart != undefined) {
	      var indexOldReserve;
	      vm.availability.data.map(function (d, i) {
	        if (d.code === -1) {
	          indexOldReserve = i;
	        }
	      });
	      vm.availability.data.splice(indexOldReserve, 1);
	    }
	    var graphs = vm.availability.data;
	    if (graphs.length === 0) return;
	    var all = graphs.map(function (s) {
	      return s.values;
	    });
	    var bookedValues = all[0].map(function (v, i) {
	      var item = _.pick(v, ["date", "booked"]);
	      item.available = all.reduce(function (agg, series) {
	        return series[i].booked;
	      }, 0);
	      return item;
	    });

	    vm.availability.data.push({
	      code: -1,
	      //allotment: a,
	      color: '#CCCCCC',
	      key: "Réservés",
	      values: bookedValues

	    });
	  }

	  function applyAllotmentChanges(changes) {
	    $log.debug(changes);
	    //vm.availabilityGraphData.length = 0;
	    //vm.releaseGraphData.length = 0;
	    var changed = vm.unit.allotments.items.filter(function (a) {
	      return changes.allotments.includes(a.code);
	    });
	    $log.debug(changed);

	    changed.map(function (a) {
	      $http.get(a.links.calendar.href, {
	        params: calFilter
	      }).then(function (res) {
	        return allotmentsHelper.calendarToGraphs(a, res.data.items, period, vm.availability.data);
	      });
	    });
	    // apply changes locally, no round trip
	  }

	  function processProducts() {
	    console.log("inproductdate:", period);
	    console.log("inproductdatecalFilter:", calFilter);

	    var calFilter = {
	      $sort: "date<",
	      start: period.start.format('YYYY-MM-DD'),
	      end: period.end.format('YYYY-MM-DD')
	    };
	    var collection = vm.unit.products;
	    var tasks = [];
	    //const totalProductAdded=[];
	    vm.rateGroups = vm.rateBases.map(function (rb) {
	      return {
	        basis: rb,
	        products: collection.items.filter(function (p) {
	          return p.rateBasis === rb.code;
	        }),
	        data: [], // holder for graph data
	        occupancies: [],
	        selectedProduct: [],
	        boards: [],
	        selectBoards: []
	      };
	    }).map(function (group) {
	      group.disabled = true;
	      var totalProductAdded = [];

	      var finalProductAddded = [];
	      group.products.map(function (p) {
	        if (group.occupancies.indexOf(Math.floor(p.occupancy / 100)) === -1) {
	          group.occupancies.push(Math.floor(p.occupancy / 100));
	          // group.selectedProduct.push(Math.floor(p.occupancy / 100))
	        }
	        //group.occupancies.add(Math.floor(p.occupancy / 100));
	        if (group.boards.indexOf(p.board) === -1) {
	          group.boards.push(p.board);
	          // group.selectedProduct.push(Math.floor(p.occupancy / 100))
	        }
	      });
	      group.products.map(function (p, i) {
	        return productsHelper.productColor(p, i, vm.rateBases);
	      }).map(function (p) {
	        return function () {
	          return $http.get(p.links.calendar.href, {
	            params: calFilter
	          }).then(function (res) {

	            if (group.selectedProduct.indexOf(Math.floor(p.occupancy / 100)) != -1) {

	              if (res.data.items.length) {
	                //show graph of supp 1 child
	                if (p.occupancy % 100 >= 10) {
	                  console.log("innnnn p.occupancy % 100 >= 10", p.occupancy % 100);
	                  var suppExist = false;
	                  res.data.items.map(function (r) {
	                    var productSupp;
	                    if (r.supplement != null) {
	                      productSupp = Object.keys(r.supplement).map(function (key) {
	                        return [Number(key), r.supplement[key]];
	                      });
	                    }
	                    if (r.supplement != null && productSupp.length > 2) suppExist = true;
	                  });

	                  console.log("productSupp.length:::", productSupp.length);
	                  console.log("productSuppsuppExist:::", suppExist);
	                  if (suppExist = true) {
	                    var productSupp = [];
	                    res.data.items.map(function (r) {
	                      if (r.supplement != null) {

	                        productSupp = Object.entries(r.supplement);

	                        //productSupp= Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);
	                      }
	                    });
	                    // console.log("productSupp:::",productSupp);
	                    var productAdded = [];
	                    if (productSupp.length) {
	                      productSupp.forEach(function (_ref) {
	                        var _ref2 = _slicedToArray(_ref, 2),
	                            key = _ref2[0],
	                            value = _ref2[1];

	                        var i = 0;
	                        if (value != null) {

	                          var prdct = Object.assign({}, p);
	                          prdct.age = key;
	                          productAdded.push(prdct);
	                          i++;
	                        }
	                      });
	                    }

	                    if (productAdded.length) {
	                      console.log("productAddedLength;:::", productAdded);

	                      for (var k = 0; k < productAdded.length; k++) {
	                        var items = [];
	                        for (var i = 0; i < res.data.items.length; i++) {

	                          // var productSuppitemi= Object.keys(res.data.items[i].supplement).map((key) => [Number(key), res.data.items[i].supplement[key]]);
	                          //items[i]=res.data.items[i]
	                          items[i] = Object.assign({}, res.data.items[i]);
	                          console.log("productAddedLengthINNN;:::");

	                          var productSuppitemi;
	                          var ageExist = false;
	                          if (res.data.items[i].supplement != null) {
	                            productSuppitemi = Object.entries(res.data.items[i].supplement);

	                            productSuppitemi.forEach(function (_ref3) {
	                              var _ref4 = _slicedToArray(_ref3, 2),
	                                  key = _ref4[0],
	                                  value = _ref4[1];

	                              if (key === productAdded[k].age) {
	                                console.log("productAddedLengthINNNAGE;:::");
	                                ageExist = true;
	                                // console.log(" items[i].priceadd:Befor::", items[i].price);
	                                items[i].price = parseFloat(value).toString();
	                              }
	                              //  else {
	                              //   items[i].price=null;


	                              //  }
	                            });

	                            if (ageExist == false) {
	                              items[i].price = null;
	                            }
	                          } else {
	                            items[i].price = null;
	                          }
	                        }
	                        productAdded[k].items = items;
	                      }
	                    }

	                    console.log("finalProductAddded[k]:::::", finalProductAddded);
	                  }
	                  var toHelperpro, toGroupData;
	                  productAdded.map(function (prd) {
	                    finalProductAddded.push(prd);
	                    console.log("productAddedtocalendr[k]:::::", prd);

	                    toHelperpro = Object.assign({}, prd);

	                    productsHelper.calendarToGraphsSuppEnf(toHelperpro, toHelperpro.items, vm.period, group);
	                    // totalProductAdded.push(productsHelper.calendarToGraphsSuppEnf(toHelperpro, toHelperpro.items, vm.period, group));
	                  });
	                }

	                //show graph of supp 2 child
	                if (p.occupancy % 100 >= 20) {
	                  console.log("i2nnnnn p.occupancy % 100 >= 10");

	                  var suppExist = false;
	                  res.data.items.map(function (r) {
	                    var product2Supp;
	                    if (r.secondSupplement != null) {
	                      product2Supp = Object.keys(r.secondSupplement).map(function (key) {
	                        return [Number(key), r.secondSupplement[key]];
	                      });
	                    }
	                    if (r.secondSupplement != null && product2Supp.length > 2) suppExist = true;
	                  });
	                  if (suppExist = true) {
	                    var product2Supp = [];
	                    res.data.items.map(function (r) {
	                      if (r.secondSupplement != null) {

	                        product2Supp = Object.entries(r.secondSupplement);

	                        //productSupp= Object.keys(r.secondSupplement).map((key) => [Number(key), r.secondSupplement[key]]);
	                      }
	                    });
	                    // console.log("productSupp:::",productSupp);
	                    var productAdded = [];
	                    if (product2Supp.length) {
	                      product2Supp.forEach(function (_ref5) {
	                        var _ref6 = _slicedToArray(_ref5, 2),
	                            key = _ref6[0],
	                            value = _ref6[1];

	                        var i = 0;
	                        if (value != 0) {

	                          var prdct = Object.assign({}, p);
	                          prdct.age = key;
	                          productAdded.push(prdct);
	                          i++;
	                        }
	                      });
	                    }

	                    if (productAdded.length) {
	                      console.log("productAddedLength;:::", productAdded);

	                      for (var k = 0; k < productAdded.length; k++) {
	                        var items = [];
	                        for (var i = 0; i < res.data.items.length; i++) {

	                          // var productSuppitemi= Object.keys(res.data.items[i].supplement).map((key) => [Number(key), res.data.items[i].supplement[key]]);
	                          //items[i]=res.data.items[i]
	                          items[i] = Object.assign({}, res.data.items[i]);
	                          console.log("productAddedLengthINNN;:::");

	                          var product2Suppitemi;
	                          var ageExist = false;
	                          if (res.data.items[i].secondSupplement != null) {
	                            product2Suppitemi = Object.entries(res.data.items[i].secondSupplement);

	                            product2Suppitemi.forEach(function (_ref7) {
	                              var _ref8 = _slicedToArray(_ref7, 2),
	                                  key = _ref8[0],
	                                  value = _ref8[1];

	                              if (key === productAdded[k].age) {
	                                console.log("productAddedLengthINNNAGE;:::");
	                                ageExist = true;
	                                // console.log(" items[i].priceadd:Befor::", items[i].price);
	                                items[i].price = parseFloat(value).toString();
	                              }
	                              //  else {
	                              //   items[i].price=null;


	                              //  }
	                            });

	                            if (ageExist == false) {
	                              items[i].price = null;
	                            }
	                          } else {
	                            items[i].price = null;
	                          }
	                        }
	                        productAdded[k].items = items;
	                      }
	                    }

	                    console.log("finalProductAddded[k]:::::", finalProductAddded);
	                  }
	                  var toHelperpro, toGroupData;
	                  productAdded.map(function (prd) {
	                    finalProductAddded.push(prd);
	                    console.log("productAddedtocalendr[k]:::::", prd);

	                    toHelperpro = Object.assign({}, prd);

	                    productsHelper.calendarToGraphsSupp2Enf(toHelperpro, toHelperpro.items, vm.period, group);
	                    // totalProductAdded.push(productsHelper.calendarToGraphsSuppEnf(toHelperpro, toHelperpro.items, vm.period, group));
	                  });
	                }

	                productsHelper.calendarToGraphs(p, res.data.items, vm.period, group);
	              }
	            }
	          });
	        };
	      }).forEach(function (task) {
	        return tasks.push(task);
	      });

	      group.options = angular.copy(vm.rates.options);
	      console.log("group.::::", group);
	      return group;
	    });

	    return _series(tasks).catch(function (error) {
	      return $log.debug(error);
	    }).then(function () {
	      vm.rateGroups.forEach(function (g) {
	        var refresh = g.chartApi.refresh();
	        g.disabled = false;
	        return refresh;
	      });
	    });
	  }

	  function editAvailable($event) {
	    $mdDialog.show({
	      targetEvent: $event,
	      templateUrl: 'app/allotment/calendar-edit/dialog.html',
	      locals: {
	        unit: vm.unit,
	        rateBases: vm.rateBases,
	        allotments: vm.unit.allotments.items.filter(function (a) {
	          return a.permissions.edit;
	        }),
	        seasons: vm.seasons,
	        fields: ["available"]
	      },
	      controller: 'AllotmentCalendarEditCtrl',
	      controllerAs: '$ctrl'
	    }).then(applyAllotmentChanges);
	  }

	  function editRates($event, group) {
	    $mdDialog.show({
	      targetEvent: $event,
	      templateUrl: 'app/products/calendar-edit/dialog.html',
	      locals: {
	        units: [vm.unit],
	        rateBases: vm.rateBases.filter(function (rb) {
	          return rb.permissions.edit;
	        }),
	        boards: vm.boards,
	        products: vm.unit.products.items,
	        fields: ["available"],
	        group: group,
	        seasons: vm.seasons,
	        propertyCtrl: vm.propertyCtrl
	      },
	      controller: 'ProductCalendarEditCtrl',
	      controllerAs: '$ctrl'
	    }).then(applyRateChanges);
	  }
	  function clonePeriodRates($event, group) {
	    $mdDialog.show({
	      targetEvent: $event,
	      templateUrl: 'app/products/clone-rates-period/dialog.html',
	      locals: {
	        units: [vm.unit],
	        rateBases: vm.rateBases.filter(function (rb) {
	          return rb.permissions.edit;
	        }),
	        boards: vm.boards,
	        products: vm.unit.products.items,
	        fields: ["available"],
	        group: group,
	        propertyCtrl: vm.propertyCtrl
	      },
	      controller: 'ProductCloneEditCtrl',
	      controllerAs: '$ctrl'
	    }).then(applyRateChanges);
	  }

	  function applyRateChanges(changes) {
	    $log.debug(changes);
	    //vm.availabilityGraphData.length = 0;
	    //vm.releaseGraphData.length = 0;
	    var changedGroups = [];
	    var changed = vm.unit.products.items.filter(function (p) {
	      return changes.products.includes(p.code);
	    });

	    var promises = changed.map(function (p) {
	      var group = vm.rateGroups.find(function (g) {
	        return g.basis.code === p.rateBasis;
	      });
	      changedGroups.push(group);
	      return $http.get(p.links.calendar.href, {
	        params: calFilter
	      }).then(function (res) {
	        return productsHelper.calendarToGraphs(p, res.data.items, period, group);
	      });
	    });

	    $log.debug("changed groups", changedGroups.map(function (g) {
	      return g.basis.description;
	    }));

	    $q.all(promises)
	    // refresh only changed groups;
	    .then(function () {
	      return _.uniq(changedGroups).forEach(function (g) {
	        return g.chartApi.refresh();
	      });
	    });
	    // TODO apply changes locally, no round trip
	  }

	  //
	  // helpers
	  //

	  function _series(tasks) {
	    var def = $q.defer();
	    var p = tasks.reduce(function (p, task) {
	      return p.catch(function (e) {
	        return $log.error(e);
	      }).finally(function () {
	        return task();
	      });
	    }, def.promise);
	    def.resolve();
	    return p;
	  }

	  function _parallel(tasks) {
	    var all = tasks.map(function (task) {
	      return task();
	    });
	    return $q.all(all);
	  }

	  function _buildViewActions() {
	    return [{
	      icon: "view_comfy",
	      label: "Mode tableau",
	      href: $state.href("property.calendarsTable")
	    }];
	  }

	  function selectedProductType(group, productType) {
	    console.log("selectedProduct", group);

	    if (group.selectedProduct.indexOf(productType) === -1) group.selectedProduct.push(productType);else group.selectedProduct.splice(group.selectedProduct.indexOf(productType), 1);
	    // processProductsWithFilter(group);


	    //  vm.ready.then(() => {
	    //   return processAllotments() //.then(addBookedGraphSeries)
	    //     .then(processProductsWithFilter(group));
	    // }).catch(error => {
	    //   $log.error(error);
	    // });
	    //  group.then(processProductsWithFilter);
	    //  processProductsWithFilter(group);

	  }

	  function selectedBoards(group, board) {
	    console.log("selectedProduct", group);

	    if (group.selectBoards.indexOf(board) === -1) group.selectBoards.push(board);else group.selectBoards.splice(group.selectBoards.indexOf(board), 1);

	    console.log("selectBoards", group.selectBoards);
	    processProductsWithFilter(group);
	    //  vm.ready.then(() => {
	    //   return processAllotments() //.then(addBookedGraphSeries)
	    //     .then(processProductsWithFilter(group));
	    // }).catch(error => {
	    //   $log.error(error);
	    // });
	    //  group.then(processProductsWithFilter);
	    //  processProductsWithFilter(group);

	  }

	  function processProductsWithFilter(group0) {

	    console.log("grouphere=::::", group0);
	    var collection = vm.unit.products;
	    var tasks = [];

	    var calFilter = {
	      $sort: "date<",
	      start: period.start.format('YYYY-MM-DD'),
	      end: period.end.format('YYYY-MM-DD')
	    };
	    //const totalProductAdded=[];
	    group0.data.length = 0;
	    var totalProductAdded = [];

	    var finalProductAddded = [];

	    console.log("vm.rateGroups:", vm.rateGroups);

	    vm.rateGroups = vm.rateBases.map(function (rb) {
	      return {
	        basis: rb,
	        products: collection.items.filter(function (p) {
	          return p.rateBasis === rb.code;
	        }),
	        data: [] // holder for graph data
	        // occupancies: [],
	        // selectedProduct:[]
	      };
	    }).map(function (group) {
	      //  console.log("groupheregroup=group.code::::",group);
	      // console.log("groupheregroup=group.code0::::",group0);

	      if (group.basis.code === group0.basis.code) {
	        var totalProductAdded = [];

	        var finalProductAddded = [];
	        group = group0;
	        console.log("groupheregroup=::::", group);

	        group.products.map(function (p, i) {
	          return productsHelper.productColor(p, i, vm.rateBases);
	        }).map(function (p) {

	          console.log("grouphere00=::::", p.links.calendar.href);

	          return function () {
	            return $http.get(p.links.calendar.href, {
	              params: calFilter
	            }).then(function (res) {
	              console.log("grouphere11=::::");

	              if (group.selectedProduct.indexOf(Math.floor(p.occupancy / 100)) != -1 && group.selectBoards.indexOf(p.board) != -1) {
	                console.log("grouphere222=::::", group);

	                if (res.data.items.length) {
	                  //show graph of supp 1 child
	                  if (p.occupancy % 100 >= 10) {
	                    console.log("p.occupancy % 100:::", p.occupancy % 100);
	                    var suppExist = false;
	                    res.data.items.map(function (r) {
	                      var productSupp;
	                      if (r.supplement != null) {
	                        productSupp = Object.keys(r.supplement).map(function (key) {
	                          return [Number(key), r.supplement[key]];
	                        });
	                      }
	                      if (r.supplement != null && productSupp.length > 2) suppExist = true;
	                    });
	                    console.log("suppExist:::", suppExist);

	                    if (suppExist = true) {
	                      console.log("suppExist:::", suppExist);

	                      var productSupp = [];
	                      res.data.items.map(function (r) {
	                        if (r.supplement != null) {

	                          productSupp = Object.entries(r.supplement);
	                          console.log("productSupp1:::", productSupp);
	                          console.log("r.productSupp1.code:::", r.product);
	                          console.log("r.productSupp1.date:::", r.date);

	                          //productSupp= Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);
	                        }
	                      });
	                      // console.log("productSupp:::",productSupp);
	                      var productAdded = [];
	                      if (productSupp.length) {
	                        var i = 0;

	                        productSupp.forEach(function (_ref9) {
	                          var _ref10 = _slicedToArray(_ref9, 2),
	                              key = _ref10[0],
	                              value = _ref10[1];

	                          console.log("productSuppvalue[key]:::", key);
	                          console.log("productSuppvalue[value]:::", value);

	                          if (value != null & i > 1) {
	                            //  if (value != null ) {

	                            var prdct = Object.assign({}, p);
	                            prdct.age = key;
	                            productAdded.push(prdct);
	                          }
	                          i++;
	                        });
	                      }

	                      if (productAdded.length) {
	                        console.log("productAddedLength1;:::", productAdded);

	                        for (var k = 0; k < productAdded.length; k++) {
	                          var items = [];
	                          for (var i = 0; i < res.data.items.length; i++) {

	                            // var productSuppitemi= Object.keys(res.data.items[i].supplement).map((key) => [Number(key), res.data.items[i].supplement[key]]);
	                            //items[i]=res.data.items[i]
	                            items[i] = Object.assign({}, res.data.items[i]);
	                            //  console.log("productAddedLengthINNN;:::");

	                            var productSuppitemi;
	                            var ageExist = false;
	                            if (res.data.items[i].supplement != null) {
	                              productSuppitemi = Object.entries(res.data.items[i].supplement);

	                              productSuppitemi.forEach(function (_ref11) {
	                                var _ref12 = _slicedToArray(_ref11, 2),
	                                    key = _ref12[0],
	                                    value = _ref12[1];

	                                if (key === productAdded[k].age) {
	                                  //    console.log("productAddedLengthINNNAGE;:::");
	                                  ageExist = true;
	                                  // console.log(" items[i].priceadd:Befor::", items[i].price);
	                                  items[i].price = parseFloat(value).toString();
	                                }
	                                //  else {
	                                //   items[i].price=null;


	                                //  }
	                              });

	                              if (ageExist == false) {
	                                items[i].price = null;
	                              }
	                            } else {
	                              items[i].price = null;
	                            }
	                          }
	                          productAdded[k].items = items;
	                        }
	                      }

	                      console.log("finalProductAddded[k]:::::", finalProductAddded);
	                    }
	                    var toHelperpro, toGroupData;
	                    productAdded.map(function (prd) {
	                      finalProductAddded.push(prd);
	                      console.log("productAddedtocalendr[k]:::::", prd);

	                      toHelperpro = Object.assign({}, prd);

	                      productsHelper.calendarToGraphsSuppEnf(toHelperpro, toHelperpro.items, vm.period, group);
	                      // totalProductAdded.push(productsHelper.calendarToGraphsSuppEnf(toHelperpro, toHelperpro.items, vm.period, group));
	                    });
	                  }

	                  //show graph of supp 2 child
	                  if (p.occupancy % 100 >= 20) {

	                    var suppExist = false;
	                    res.data.items.map(function (r) {
	                      var product2Supp;
	                      if (r.secondSupplement != null) {
	                        product2Supp = Object.keys(r.secondSupplement).map(function (key) {
	                          return [Number(key), r.secondSupplement[key]];
	                        });
	                      }
	                      if (r.secondSupplement != null && product2Supp.length > 2) suppExist = true;
	                    });
	                    if (suppExist = true) {
	                      var product2Supp = [];
	                      res.data.items.map(function (r) {
	                        if (r.secondSupplement != null) {

	                          product2Supp = Object.entries(r.secondSupplement);

	                          //productSupp= Object.keys(r.secondSupplement).map((key) => [Number(key), r.secondSupplement[key]]);
	                        }
	                      });
	                      // console.log("productSupp:::",productSupp);
	                      var productAdded = [];
	                      if (product2Supp.length) {
	                        product2Supp.forEach(function (_ref13) {
	                          var _ref14 = _slicedToArray(_ref13, 2),
	                              key = _ref14[0],
	                              value = _ref14[1];

	                          var i = 0;
	                          if (value != null) {

	                            var prdct = Object.assign({}, p);
	                            prdct.age = key;
	                            productAdded.push(prdct);
	                            i++;
	                          }
	                        });
	                      }

	                      if (productAdded.length) {
	                        console.log("productAddedLength;:::", productAdded);

	                        for (var k = 0; k < productAdded.length; k++) {
	                          var items = [];
	                          for (var i = 0; i < res.data.items.length; i++) {

	                            // var productSuppitemi= Object.keys(res.data.items[i].supplement).map((key) => [Number(key), res.data.items[i].supplement[key]]);
	                            //items[i]=res.data.items[i]
	                            items[i] = Object.assign({}, res.data.items[i]);
	                            console.log("productAddedLengthINNN;:::");

	                            var product2Suppitemi;
	                            var ageExist = false;
	                            if (res.data.items[i].secondSupplement != null) {
	                              product2Suppitemi = Object.entries(res.data.items[i].secondSupplement);

	                              product2Suppitemi.forEach(function (_ref15) {
	                                var _ref16 = _slicedToArray(_ref15, 2),
	                                    key = _ref16[0],
	                                    value = _ref16[1];

	                                if (key === productAdded[k].age) {
	                                  console.log("productAddedLengthINNNAGE;:::");
	                                  ageExist = true;
	                                  // console.log(" items[i].priceadd:Befor::", items[i].price);
	                                  items[i].price = parseFloat(value).toString();
	                                }
	                                //  else {
	                                //   items[i].price=null;


	                                //  }
	                              });

	                              if (ageExist == false) {
	                                items[i].price = null;
	                              }
	                            } else {
	                              items[i].price = null;
	                            }
	                          }
	                          productAdded[k].items = items;
	                        }
	                      }

	                      console.log("finalProductAddded[k]:::::", finalProductAddded);
	                    }
	                    var toHelperpro, toGroupData;
	                    productAdded.map(function (prd) {
	                      finalProductAddded.push(prd);
	                      console.log("productAddedtocalendr[k]:::::", prd);

	                      toHelperpro = Object.assign({}, prd);

	                      productsHelper.calendarToGraphsSupp2Enf(toHelperpro, toHelperpro.items, vm.period, group);
	                      // totalProductAdded.push(productsHelper.calendarToGraphsSuppEnf(toHelperpro, toHelperpro.items, vm.period, group));
	                    });
	                  }

	                  productsHelper.calendarToGraphs(p, res.data.items, vm.period, group);
	                }
	              }
	            });
	          };
	        }).forEach(function (task) {
	          return tasks.push(task);
	        });
	        //  var non_duplidated_data = _.uniq(data, 'name'); 
	        //   group=_.uniq(group.series.key, 'name'); 

	        //  group.filter()
	        group.options = angular.copy(vm.rates.options);
	        console.log("group.::::", group);
	        return group;
	      }
	    });
	    return _series(tasks).catch(function (error) {
	      return $log.debug(error);
	    }).then(function () {
	      vm.rateGroups.forEach(function (g) {
	        var refresh = g.chartApi.refresh();
	        g.disabled = false;
	        return refresh;
	      });
	    });
	  }

	  // function selectedProductType(group,productType) {
	  //   console.log("selectedProduct",group);

	  //   if (group.selectedProduct.indexOf(productType) === -1) group.selectedProduct.push(productType);
	  //    else group.selectedProduct.splice(group.selectedProduct.indexOf(productType),1);
	  //    processProductsWithFilter(group);
	  //   //  vm.ready.then(() => {
	  //   //   return processAllotments() //.then(addBookedGraphSeries)
	  //   //     .then(processProductsWithFilter(group));
	  //   // }).catch(error => {
	  //   //   $log.error(error);
	  //   // });
	  //   //  group.then(processProductsWithFilter);
	  //   //  processProductsWithFilter(group);


	  // }

	  function loadData() {
	    console.log("period change :::", vm.uploadStart);
	    console.log("period change2 :::", vm.period);

	    onInit();
	    //  vm.ready.then(() => {
	    //   return processAllotments() //.then(addBookedGraphSeries)
	    //     .then(processProductsWithFilter(group));
	    // }).catch(error => {
	    //   $log.error(error);
	    // });
	    //  group.then(processProductsWithFilter);
	    //  processProductsWithFilter(group);

	  }

	  //
	  // function fixRatesGraphYDomain(graph) {
	  // // console.log(graph.data);
	  //   if (graph.data.length === 0) {
	  //     graph.data = null;
	  //   }
	  // }
	}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PropertyCalendarsTableCtrl.$inject = ["User", "$scope", "$log", "$q", "$state", "datasets", "$mdDialog", "$http", "$stateParams"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moment = __webpack_require__(10);
	var _ = __webpack_require__(5);

	exports.default = {
	  name: 'propertyCalendarsTable',
	  controller: PropertyCalendarsTableCtrl,
	  templateUrl: 'app/yield/property-table/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PropertyCalendarsTableCtrl(User, $scope, $log, $q, $state, datasets, $mdDialog, $http, $stateParams) {
	  "ngInject";

	  var DATE_FORMAT = "YYYY-MM-DD";
	  // TODO
	  var vm = this;

	  vm.startDate = moment($stateParams.date, DATE_FORMAT).isValid() ? moment($stateParams.date).toDate() : moment().startOf('day').toDate();
	  vm.selectedProduct0 = [];
	  vm.selectedBoards0 = [];
	  vm.loading = true;

	  angular.extend(vm, {
	    $onInit: onInit,
	    period: parsePeriod(vm.startDate),
	    editAllotments: batchEditAvailable,
	    editRates: batchEditRates,
	    updatePeriod: updatePeriod,
	    selectedProductType: selectedProductType,
	    selectedBoard: selectedBoard,
	    selectedBoards: selectedBoard(),
	    selectedProduct: selectedProductType(),
	    updateChanges: updateChanges

	  });

	  function onInit() {
	    //vm.selectedBoards=[];
	    // vm.selectedProduct0=[];
	    //vm.selectedProduct0.push(1);
	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });
	    vm.propertyCtrl.setActions(_buildViewActions());
	    vm.occupancies = [];
	    vm.ready = datasets.bindSets(["boards"], vm, true).then(function () {
	      return vm.propertyCtrl.get('rate-bases');
	    }).then(function (collection) {
	      vm.rateBases = collection.items;
	      vm.rateBasesIndexed = _.keyBy(vm.rateBases, "code");
	    }).then(function () {
	      return vm.propertyCtrl.get('units');
	    }).then(function (collection) {
	      vm.units = collection.items.map(function (u) {
	        return angular.copy(u);
	      });
	    }).then(function () {
	      return vm.propertyCtrl.get('stop-sales');
	    }).then(function (collection) {
	      vm.stopSales = collection.items.map(function (u) {
	        return angular.copy(u);
	      });
	    }).then(function () {
	      return vm.propertyCtrl.get('on-requests');
	    }).then(function (collection) {
	      // console.log("on-requestsbefore",collection.items)
	      //  vm.onRequests = collection.items;
	      vm.onRequests = collection.items.map(function (u) {
	        return angular.copy(u);
	      });
	      // console.log("on-requestsAfter",vm.onRequests)
	    })
	    //.then(function ()  {vm.selectedProduct0.push(1);})
	    .then(function () {
	      return vm.units.map(function (unit) {
	        $http.get(unit.links.products.href).then(function (res) {
	          vm.productssOccup = res.data.items.map(function (prod) {

	            if (vm.occupancies.length === 0) {
	              vm.occupancies.push(Math.floor(prod.occupancy / 100));
	              console.log("occupancies.push", prod.occupancy);

	              // group.selectedProduct.push(Math.floor(p.occupancy / 100))
	            } else {
	              if (vm.occupancies.indexOf(Math.floor(prod.occupancy / 100)) === -1) {
	                console.log("elseoccupancies.push", prod.occupancy);

	                vm.occupancies.push(Math.floor(prod.occupancy / 100));

	                // group.selectedProduct.push(Math.floor(p.occupancy / 100))
	              }
	            }
	          });
	        });
	      });
	    }).catch(function (error) {
	      $log.error(error);
	    });

	    console.log("vm.ready", vm.ready);
	  }

	  function updatePeriod(date) {
	    $log.debug('update period');
	    console.log("update period");
	    console.log("selectedProductType()", selectedProductType());

	    vm.period = parsePeriod(date);
	    vm.selectedBoards = selectedBoard();

	    vm.selectedProduct = vm.selectedProduct0;
	  }
	  function parsePeriod(startDate) {
	    var start = moment(startDate).startOf('day');
	    var end = moment(start).add(15, 'days');
	    var dates = [];
	    var date = moment(start);
	    while (dates.length < 15) {
	      dates.push(date.toDate());
	      date.add(1, 'days');
	    }
	    return {
	      selectedProduct: vm.selectedProduct0,
	      start: start,
	      end: end,
	      dates: dates
	    };
	  }

	  function updateChanges() {
	    $log.debug('update period');
	    console.log("update period");
	    console.log("selectedProductType()", selectedProductType());

	    //vm.period = parsePeriod(date);
	    // vm.selectedBoards=selectedBoard();

	    vm.selectedProduct = returnChanges();
	    vm.selectedBoards = returnBoards();
	  }

	  function returnChanges() {
	    console.log("returnChanges()", vm.selectedProduct0);

	    return {
	      selectedProduct: vm.selectedProduct0

	    };
	  }
	  function returnBoards() {
	    console.log("returnBoards()", vm.selectedBoards0);

	    return {
	      selectedBoards: vm.selectedBoards0

	    };
	  }

	  function batchEditAvailable($event) {
	    $mdDialog.show({
	      targetEvent: $event,
	      templateUrl: 'app/allotment/calendar-edit/dialog.html',
	      locals: {
	        unit: vm.unit,
	        rateBases: vm.rateBases,
	        allotments: vm.unit.allotments.items,
	        fields: ["available"]
	      },
	      controller: 'AllotmentCalendarEditCtrl',
	      controllerAs: '$ctrl'
	    });
	    //.then(applyAllotmentChanges);
	  }

	  function batchEditRates($event) {
	    $mdDialog.show({
	      targetEvent: $event,
	      templateUrl: 'app/products/calendar-edit/dialog.html',
	      locals: {
	        units: [vm.unit],
	        rateBases: vm.rateBases,
	        boards: vm.boards,
	        products: vm.unit.products.items,
	        fields: ["available"]
	      },
	      controller: 'ProductCalendarEditCtrl',
	      controllerAs: '$ctrl'
	    });
	    //.then(applyRateChanges);
	  }

	  function _buildViewActions() {
	    return [{
	      icon: "edit",
	      label: "Modifier",
	      items: [{
	        label: "Disponibilité",
	        action: batchEditAvailable
	      }, {
	        label: "Tarifs",
	        action: batchEditRates
	      }]
	    }, {
	      icon: "show_chart",
	      label: "Mode graphes",
	      href: $state.href("property.calendarGraphs")
	    }];
	  }

	  function selectedBoard(board) {
	    //console.log("selectedProduct",group);

	    if (vm.selectedBoards0.indexOf(board) === -1) vm.selectedBoards0.push(board);else vm.selectedBoards0.splice(vm.selectedBoards0.indexOf(board), 1);

	    console.log("selectedBoards0", vm.selectedBoards0);
	    // processProductsWithFilter(vm.selectedBoards);
	    //  vm.ready.then(() => {
	    //   return processAllotments() //.then(addBookedGraphSeries)
	    //     .then(processProductsWithFilter(group));
	    // }).catch(error => {
	    //   $log.error(error);
	    // });
	    //  group.then(processProductsWithFilter);
	    //  processProductsWithFilter(group);
	    return vm.selectedBoards0;
	  }
	  function selectedProductType(productType) {
	    // console.log("selectedProduct");

	    if (vm.selectedProduct0.indexOf(productType) === -1) vm.selectedProduct0.push(productType);else vm.selectedProduct0.splice(vm.selectedProduct0.indexOf(productType), 1);
	    console.log("selectedProduct", vm.selectedProduct0);
	    // processProductsWithFilter(vm.selectedProduct0);
	    //  vm.ready.then(() => {
	    //   return processAllotments() //.then(addBookedGraphSeries)
	    //     .then(processProductsWithFilter(group));
	    // }).catch(error => {
	    //   $log.error(error);
	    // });
	    //  group.then(processProductsWithFilter);
	    //  processProductsWithFilter(group);
	    //  vm.ready.then(() => {
	    //   return processAllotments() //.then(addBookedGraphSeries)
	    //     .then(processProductsWithFilter(group));
	    // }).catch(error => {
	    //   $log.error(error);
	    // });
	    //$state.reload();
	    return vm.selectedProduct0;
	    //   vm.ready.then(() => {
	    //     console.log("selectedProduct");


	    // }).catch(error => {
	    //   $log.error(error);
	    // });
	    // console.log("vm.ready",vm.ready);

	  }
	}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PropertyCalendarsTableCRoomtrl.$inject = ["User", "$scope", "$log", "$q", "$state", "datasets", "$mdDialog", "$http", "$stateParams"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moment = __webpack_require__(10);
	var _ = __webpack_require__(5);

	exports.default = {
	  name: 'propertyCalendarsTableRoom',
	  controller: PropertyCalendarsTableCRoomtrl,
	  templateUrl: 'app/yield/property-table-room/template.html',
	  require: {
	    propertyCtrl: '^propertyContainer'

	  }
	};


	function PropertyCalendarsTableCRoomtrl(User, $scope, $log, $q, $state, datasets, $mdDialog, $http, $stateParams) {
	  "ngInject";

	  var DATE_FORMAT = "YYYY-MM-DD";
	  // TODO
	  var vm = this;

	  console.log("vm.startDate::", moment($stateParams.date).toDate());
	  console.log("vm.startDate::", moment(localStorage.getItem("dateStart")));
	  if (localStorage.getItem("dateStart") != null && localStorage.getItem("dateStart") != undefined) {
	    console.log("vm.startDatemoment(localStorage.getItem::", moment(localStorage.getItem("dateStart")).toDate());
	    vm.startDate = moment(localStorage.getItem("dateStart")).toDate() ? moment(localStorage.getItem("dateStart")).toDate() :
	    // moment($stateParams.date).toDate() :
	    moment().startOf('day').toDate();
	  } else {

	    vm.startDate = moment($stateParams.date, DATE_FORMAT).isValid() ? moment($stateParams.date).toDate() : moment().startOf('day').toDate();
	  }

	  console.log("vm.startDateinput::", vm.startDate);
	  vm.selectedProduct0 = [];
	  vm.selectedBoards0 = [];
	  vm.loading = true;

	  angular.extend(vm, {
	    $onInit: onInit,
	    period: parsePeriod(vm.startDate),
	    editAllotments: batchEditAvailable,
	    editRates: batchEditRates,
	    updatePeriod: updatePeriod,
	    selectedProductType: selectedProductType,
	    selectedBoard: selectedBoard,
	    selectedBoards: selectedBoard(),
	    selectedProduct: selectedProductType(),
	    updateChanges: updateChanges,
	    updateChangesUnit: updateChangesUnit,
	    roomChange: roomChange

	  });

	  function onInit() {
	    //vm.selectedBoards=[];
	    // vm.selectedProduct0=[];
	    //vm.selectedProduct0.push(1);
	    console.log("localStorage.getItemUnit", localStorage.getItem("unit"));
	    console.log("vm.selectedRoom", vm.selectedRoom);
	    vm.selectedRoom = localStorage.getItem("unit");
	    console.log("vm.selectedRoomaftrlocal", vm.selectedRoom);
	    console.log("moment($stateParams.date).toDate() ", moment($stateParams.date).toDate());
	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });
	    vm.propertyCtrl.setActions(_buildViewActions());
	    vm.occupancies = [];
	    vm.ready = datasets.bindSets(["boards"], vm, true).then(function () {
	      return vm.propertyCtrl.get('rate-bases');
	    }).then(function (collection) {
	      vm.rateBases = collection.items;
	      vm.rateBasesIndexed = _.keyBy(vm.rateBases, "code");
	    }).then(function () {
	      return vm.propertyCtrl.get('units');
	    }).then(function (collection) {
	      vm.units = collection.items.map(function (u) {
	        return angular.copy(u);
	      });
	    }).then(function () {
	      return vm.propertyCtrl.get('stop-sales');
	    }).then(function (collection) {
	      vm.stopSales = collection.items.map(function (u) {
	        return angular.copy(u);
	      });
	    }).then(function () {
	      return vm.propertyCtrl.get('on-requests');
	    }).then(function (collection) {
	      // console.log("on-requestsbefore",collection.items)
	      //  vm.onRequests = collection.items;
	      vm.onRequests = collection.items.map(function (u) {
	        return angular.copy(u);
	      });
	      // console.log("on-requestsAfter",vm.onRequests)
	    })
	    //.then(function ()  {vm.selectedProduct0.push(1);})
	    .then(function () {
	      return vm.units.map(function (unit) {
	        $http.get(unit.links.products.href).then(function (res) {
	          vm.productssOccup = res.data.items.map(function (prod) {

	            if (vm.occupancies.length === 0) {
	              vm.occupancies.push(Math.floor(prod.occupancy / 100));
	              console.log("occupancies.push", prod.occupancy);

	              // group.selectedProduct.push(Math.floor(p.occupancy / 100))
	            } else {
	              if (vm.occupancies.indexOf(Math.floor(prod.occupancy / 100)) === -1) {
	                console.log("elseoccupancies.push", prod.occupancy);

	                vm.occupancies.push(Math.floor(prod.occupancy / 100));

	                // group.selectedProduct.push(Math.floor(p.occupancy / 100))
	              }
	            }
	          });
	        });
	      });
	    }).catch(function (error) {
	      $log.error(error);
	    });

	    console.log("vm.ready", vm.ready);
	  }

	  function roomChange() {
	    console.log("unit::", vm.selectedRoom);
	  }
	  function updatePeriod(date) {
	    $log.debug('update period');
	    console.log("update period");
	    console.log("selectedProductType()", selectedProductType());

	    vm.period = parsePeriod(date);
	    console.log("updatePeriod::::", vm.period);
	    vm.selectedBoards = selectedBoard();

	    vm.selectedProduct = vm.selectedProduct0;
	  }
	  function parsePeriod(startDate) {
	    var start = moment(startDate).startOf('day');
	    var end = moment(start).add(31, 'days');
	    console.log("update localStorageStartstart", start);
	    var dates = [];
	    var date = moment(start);
	    while (dates.length < 31) {
	      dates.push(date.toDate());
	      date.add(1, 'days');
	    }
	    // if( moment(startDate).startOf('day')  != moment($stateParams.date).toDate() && moment(start).format("YYYY-MM-DD") != moment($stateParams.date).format("YYYY-MM-DD")){
	    if (moment(start).format("YYYY-MM-DD") != moment($stateParams.date).format("YYYY-MM-DD")) {
	      console.log("update localStorage now", moment(start).format("YYYY-MM-DD"));
	      console.log("update localStorageStart", moment($stateParams.date).format("YYYY-MM-DD"));

	      localStorage.setItem("date", dates);
	      localStorage.setItem("dateStart", start);

	      if (localStorage.getItem("dateStart") != null) {
	        console.log("update localStoragegetItem", localStorage.getItem("dateStart"));
	        console.log("update localStoragegetItem", moment(localStorage.getItem("dateStart")).toDate());
	      }
	    }
	    console.log("update localStoragegetItemafterchangebefore", moment(localStorage.getItem("dateStart")).format("YYYY-MM-DD"));
	    console.log("update stateParamsbefore", moment($stateParams.date).format("YYYY-MM-DD"));

	    //if(moment(localStorage.getItem("dateStart")).format("YYYY-MM-DD") != moment($stateParams.date).format("YYYY-MM-DD")){
	    if (moment(localStorage.getItem("dateStart")).format("YYYY-MM-DD")) {
	      start = moment(localStorage.getItem("dateStart"));
	      end = moment(localStorage.getItem("dateStart")).add(31, 'days');
	      dates = [];
	      date = moment(start);
	      while (dates.length < 31) {
	        dates.push(date.toDate());
	        date.add(1, 'days');
	      }

	      console.log("update localStoragegetItemafterchangereq", moment(localStorage.getItem("dateStart")).toDate());
	      console.log("update localStoragegetItemafterchangereqdates", dates);
	    }
	    return {
	      selectedProduct: vm.selectedProduct0,
	      start: start,
	      end: end,
	      dates: dates
	    };
	  }
	  function updateChangesUnit(room) {
	    console.log("room", room);
	    return vm.selectedRoom = room;
	  }
	  function updateChanges() {
	    $log.debug('update period');
	    console.log("update period");
	    console.log("selectedProductType()", selectedProductType());

	    //vm.period = parsePeriod(date);
	    // vm.selectedBoards=selectedBoard();

	    vm.selectedProduct = returnChanges();
	    vm.selectedBoards = returnBoards();
	  }

	  function returnChanges() {
	    console.log("returnChanges()", vm.selectedProduct0);

	    return {
	      selectedProduct: vm.selectedProduct0

	    };
	  }
	  function returnBoards() {
	    console.log("returnBoards()", vm.selectedBoards0);

	    return {
	      selectedBoards: vm.selectedBoards0

	    };
	  }

	  function batchEditAvailable($event) {
	    $mdDialog.show({
	      targetEvent: $event,
	      templateUrl: 'app/allotment/calendar-edit/dialog.html',
	      locals: {
	        unit: vm.unit,
	        rateBases: vm.rateBases,
	        allotments: vm.unit.allotments.items,
	        fields: ["available"]
	      },
	      controller: 'AllotmentCalendarEditCtrl',
	      controllerAs: '$ctrl'
	    });
	    //.then(applyAllotmentChanges);
	  }

	  function batchEditRates($event) {
	    $mdDialog.show({
	      targetEvent: $event,
	      templateUrl: 'app/products/calendar-edit/dialog.html',
	      locals: {
	        units: [vm.unit],
	        rateBases: vm.rateBases,
	        boards: vm.boards,
	        products: vm.unit.products.items,
	        fields: ["available"]
	      },
	      controller: 'ProductCalendarEditCtrl',
	      controllerAs: '$ctrl'
	    });
	    //.then(applyRateChanges);
	  }

	  function _buildViewActions() {
	    return null;
	  }

	  function selectedBoard(board) {
	    //console.log("selectedProduct",group);

	    if (vm.selectedBoards0.indexOf(board) === -1) vm.selectedBoards0.push(board);else vm.selectedBoards0.splice(vm.selectedBoards0.indexOf(board), 1);

	    console.log("selectedBoards0", vm.selectedBoards0);
	    // processProductsWithFilter(vm.selectedBoards);
	    //  vm.ready.then(() => {
	    //   return processAllotments() //.then(addBookedGraphSeries)
	    //     .then(processProductsWithFilter(group));
	    // }).catch(error => {
	    //   $log.error(error);
	    // });
	    //  group.then(processProductsWithFilter);
	    //  processProductsWithFilter(group);
	    return vm.selectedBoards0;
	  }
	  function selectedProductType(productType) {
	    // console.log("selectedProduct");

	    if (vm.selectedProduct0.indexOf(productType) === -1) vm.selectedProduct0.push(productType);else vm.selectedProduct0.splice(vm.selectedProduct0.indexOf(productType), 1);
	    console.log("selectedProduct", vm.selectedProduct0);
	    // processProductsWithFilter(vm.selectedProduct0);
	    //  vm.ready.then(() => {
	    //   return processAllotments() //.then(addBookedGraphSeries)
	    //     .then(processProductsWithFilter(group));
	    // }).catch(error => {
	    //   $log.error(error);
	    // });
	    //  group.then(processProductsWithFilter);
	    //  processProductsWithFilter(group);
	    //  vm.ready.then(() => {
	    //   return processAllotments() //.then(addBookedGraphSeries)
	    //     .then(processProductsWithFilter(group));
	    // }).catch(error => {
	    //   $log.error(error);
	    // });
	    //$state.reload();
	    return vm.selectedProduct0;
	    //   vm.ready.then(() => {
	    //     console.log("selectedProduct");


	    // }).catch(error => {
	    //   $log.error(error);
	    // });
	    // console.log("vm.ready",vm.ready);

	  }
	}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	'use strict';

	UnitProductsTableCtrl.$inject = ["$log", "$q", "$http", "moment", "apiUrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	exports.default = {
	  name: 'unitProductsTable',
	  controller: UnitProductsTableCtrl,
	  templateUrl: 'app/yield/property-table/unit-products/template.html',
	  bindings: {
	    unit: '<',
	    rateBases: '<',
	    boards: '<',
	    period: '<',
	    selectedProduct: '<',
	    selectedBoards: '<',
	    occupancies: '<',
	    boardss: '<'

	  }
	};


	function UnitProductsTableCtrl($log, $q, $http, moment, apiUrl) {
	  "ngInject";

	  var vm = this;

	  vm.$onChanges = function (changes) {
	    console.log("change00::", changes);
	    //console.log("change00vm.selectedProduct::",vm.selectedProduct);
	    init();

	    if (changes.hasOwnProperty('selectedBoards') || changes.hasOwnProperty('selectedProduct')) {
	      console.log("vm.hasOwnProperty::::selectedBoardsselectedProduct");

	      init();
	    }
	    if (!changes.hasOwnProperty('period')) return;
	    if (changes.period.isFirstChange()) {
	      init();
	    } else {
	      reloadCalendars(vm.period);
	    }
	  };

	  vm.priceChanged = priceChanged;

	  function init() {
	    //  console.log("vm.productssOccup22::::",vm.selectedProduct.selectedProduct);
	    console.log("vm.productssOccup22::::", vm.selectedProduct);

	    // console.log("vm.productssOccup::::",productssOccup);
	    //  console.log("vm.$onChanges::::",vm.$onChanges);

	    console.log("vm.rateBases::::", vm.rateBases);
	    console.log("vm.occupancies::::", vm.occupancies);

	    console.log("vm.boardss::::", vm.boardss);
	    console.log("vm.selectedBoards::::", vm.selectedBoards);

	    //vm.pdtss;
	    vm.unit.occupancies = [];
	    var pending = [];
	    var LastproductsAdded = [];
	    var productsFiltred = [];
	    vm.loading = true;

	    vm.ready = $http.get(vm.unit.links.products.href).then(function (res) {
	      var products = res.data.items.map(function (p) {
	        pending.push(loadCalendar(p, vm.period));
	        return p;
	      });
	      console.log("vm.productssOccup::::", vm.productssOccup);

	      //vm.products = products;

	      products.map(function (prod) {
	        if (vm.selectedProduct.selectedProduct.indexOf(Math.floor(prod.occupancy / 100)) != -1 && vm.selectedBoards.selectedBoards.indexOf(prod.board) != -1) {
	          //      if (vm.selectedProduc.indexOf(Math.floor(prod.occupancy / 100)) != -1 && vm.selectedBoards.indexOf(prod.board) != -1){

	          productsFiltred.push(prod);
	        }

	        // group.selectedProduct.push(Math.floor(p.occupancy / 100))
	      });
	      console.log("productsFiltred", productsFiltred);
	      vm.productsFiltred = productsFiltred;
	      vm.products = productsFiltred;
	      console.log("productsFiltredproducts", vm.products);

	      // console.log("vm.vm.products::::",vm.products);
	      var productsToAdded = [];
	      var productsAdded = [];
	      // console.log("vm.pending::::",pending);


	      vm.products.map(function (prod) {

	        if (vm.occupancies.indexOf(Math.floor(prod.occupancy / 100)) === -1) {
	          vm.occupancies.push(Math.floor(prod.occupancy / 100));

	          // group.selectedProduct.push(Math.floor(p.occupancy / 100))
	        }

	        // console.log("vm.prod::::",prod);

	        if (prod.occupancy % 100 >= 10) {

	          var product = Object.assign({}, prod);
	          product.calendar = prod.calendar;
	          // console.log("vm.product::::",product);
	          // console.log("vm.prod::::",prod.calendar);

	          product.name = "sup";
	          productsToAdded.push(product);
	        }
	        //   console.log("vm.productsAdded::::",productsToAdded);

	        //Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]])
	        // prod.calendar.items.map(itm=> {

	        //   // console.log("vm.productssupp::::",itm.price.supplement);
	        // })
	      });
	      //console.log("productsAdded:::",productsToAdded);

	      //vm.pdts=productsToAdded;
	      console.log("vm.vm.pdts.length::::", vm.products.length);
	      console.log("vm.pdttt01::::");

	      //  console.log("vm.pdttt0::::",loadCalendarSupp(productsToAdded,vm.period,LastproductsAdded,vm.products));

	      loadCalendarSupp(productsToAdded, vm.period, LastproductsAdded, vm.products);
	      console.log("vm.pdproductsToAddedttt0::::", LastproductsAdded);
	      vm.pdtss = LastproductsAdded;
	      console.log("pending::::", pending);

	      LastproductsAdded.map(function (prodToAdded) {

	        // pending.push(prodToAdded);
	        //vm.products.push(prodToAdded)
	      });
	      console.log("vm.pdttt::::", vm.pdts.length);

	      //    productsToAdded.map(prodToAdded=> {
	      //    vm.products.push(prodToAdded)
	      //  })
	      // const LastproductsAdded=productsToAdded.map(prodToAdded=> {
	      //   pending.push(loadCalendar(prodToAdded, vm.period));

	      //   console.log("prodToAdded:::",prodToAdded.calendar);

	      //   return prodToAdded;
	      //   //vm.products.push(prodAdded);
	      // })


	      //console.log("pending:::",vm);
	      //   productsToAdded.map(prodToAdded=> {
	      //     console.log("productsToAdded:::",prodToAdded.calendar);
	      // })

	      // LastproductsAdded.map(prodToAdded=> {
	      // productsToAdded.map(prodToAdded=> {
	      //   //pending.push(loadCalendar(prodToAdded, vm.period));
	      //   console.log("prodToAdded:::",prodToAdded.calendar);

	      //   var suppExist = false;
	      //   prodToAdded.calendar.items.map(r => {
	      //             var productSupp;
	      //             if (r.supplement != null) {
	      //               productSupp = Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);

	      //             }
	      //             if (r.supplement != null && productSupp.length > 2) suppExist = true;


	      //           });
	      //           console.log("suppExist:::",suppExist);


	      //   //vm.products.push(prodAdded);
	      // })
	      // //productsAdded

	      // console.log("LastproductsAdded:::",LastproductsAdded);

	      //  LastproductsAdded.map(prodAdded=> {
	      //   vm.products.push(prodAdded);
	      // })
	      //console.log("vmvm::::",LastproductsAdded);
	    });
	    //$q.all(pending).then(() => vm.loading = false);

	    // console.log("vm.vm.productslaast::::",vm.products);
	  }

	  function reloadCalendars(period) {
	    vm.loading = true;
	    var promises = vm.products.map(function (product) {
	      return loadCalendar(product, period);
	    });
	    $q.all(promises).then(function () {
	      return vm.loading = false;
	    }, function () {
	      vm.loading = false;
	      vm.error = "Error loading rates";
	    });
	  }

	  function loadCalendar(product, period, _callback) {
	    $http.get(product.links.calendar.href, {
	      params: {
	        $sort: 'date<',
	        start: period.start.format('YYYY-MM-DD'),
	        end: period.end.format('YYYY-MM-DD')
	      }
	    }).then(function (res) {
	      var nightsToShow = period.end.diff(period.start, 'days');
	      var calendar = [];
	      var nights = res.data.items;
	      $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	      if (nights.length !== nightsToShow) {
	        // returned calendar can have holes, make sure we fill them
	        var date = moment(period.start);
	        var i = 0;
	        while (i < nightsToShow) {
	          var rec = findRecord(date, nights);
	          //reviveCancellation(rec);
	          calendar.push(rec);
	          date.add(1, 'days');
	          i++;
	        }
	      } else {
	        calendar = nights;
	      }
	      calendar.forEach(function (night) {
	        night.price = parseFloat(night.price);
	        night.pristinePrice = night.price;
	      });
	      product.calendar = {
	        items: calendar
	      };
	    });

	    //_callback();
	  }

	  function loadCalendarSupp(products, period, LastproductsAdded, vmproducts) {
	    vm.loadingsup = true;
	    // var LastproductsAdded=[];
	    //  vm.pdts=products; 
	    // console.log("inloadCalendarSuppProduct",products)
	    var pendingSupp = [];
	    var promises = products.map(function (product) {

	      console.log("prodToAdded1100:::", product);

	      $http.get(product.links.calendar.href, {
	        params: {
	          $sort: 'date<',
	          start: period.start.format('YYYY-MM-DD'),
	          end: period.end.format('YYYY-MM-DD')
	        }
	      }).then(function (res) {
	        var nightsToShow = period.end.diff(period.start, 'days');
	        var calendar = [];
	        var nights = res.data.items;
	        $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	        if (nights.length !== nightsToShow) {
	          // returned calendar can have holes, make sure we fill them
	          var date = moment(period.start);
	          var i = 0;
	          while (i < nightsToShow) {
	            var rec = findRecord(date, nights);
	            //reviveCancellation(rec);
	            calendar.push(rec);
	            date.add(1, 'days');
	            i++;
	          }
	        } else {
	          calendar = nights;
	        }
	        calendar.forEach(function (night) {
	          night.price = parseFloat(night.price);
	          night.pristinePrice = night.price;
	        });
	        product.calendar = {
	          items: calendar
	        };
	        console.log("prodToAdded11:::", product);
	        console.log("teeeest", LastproductsAdded.length);
	        var suppExist = false;

	        product.calendar.items.map(function (r) {

	          var productSupp;
	          if (r.supplement != null) {
	            productSupp = Object.keys(r.supplement).map(function (key) {
	              return [Number(key), r.supplement[key]];
	            });
	          }
	          if (r.supplement != null && productSupp.length > 2) suppExist = true;
	        });
	        // if (suppExist==true) {

	        //   LastproductsAdded.push(r);
	        // }

	        if (suppExist = true) {
	          // console.log("suppExist:::",suppExist);

	          var productSupp = [];
	          product.calendar.items.map(function (rs) {
	            if (rs.supplement != null) {

	              productSupp = Object.entries(rs.supplement);
	              // console.log("productSupp:::", productSupp);

	              //productSupp= Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);
	            }
	          });
	          // console.log("productSupp:::",productSupp);
	          var productAdded = [];
	          if (productSupp.length) {
	            var i = 0;

	            productSupp.forEach(function (_ref) {
	              var _ref2 = _slicedToArray(_ref, 2),
	                  key = _ref2[0],
	                  value = _ref2[1];

	              ///  console.log("productSuppvalue[key, value]:::", value);

	              if (value != null & i > 1) {

	                var prdct = Object.assign({}, product);
	                prdct.age = key;
	                prdct.name = prdct.name + " " + key;
	                productAdded.push(prdct);
	                console.log("prdct.name:::", prdct.name);
	              }
	              i++;
	            });
	          }

	          if (productAdded.length) {
	            console.log("productAddedLength;:::", productAdded.length);
	            // console.log("productAddedLength;:::", productAdded);

	            for (var k = 0; k < productAdded.length; k++) {
	              var items = [];
	              for (var i = 0; i < productAdded[k].calendar.items.length; i++) {

	                // var productSuppitemi= Object.keys(res.data.items[i].supplement).map((key) => [Number(key), res.data.items[i].supplement[key]]);
	                //items[i]=res.data.items[i]
	                items[i] = Object.assign({}, productAdded[k].calendar.items[i]);
	                //  console.log("productAddedLengthINNN;:::");

	                var productSuppitemi;
	                var ageExist = false;
	                if (productAdded[k].calendar.items[i].supplement != null) {
	                  productSuppitemi = Object.entries(productAdded[k].calendar.items[i].supplement);

	                  productSuppitemi.forEach(function (_ref3) {
	                    var _ref4 = _slicedToArray(_ref3, 2),
	                        key = _ref4[0],
	                        value = _ref4[1];

	                    if (key === productAdded[k].age) {
	                      //    console.log("productAddedLengthINNNAGE;:::",value);
	                      //    console.log("productAddedLengthINNNAGEkey;:::",key);

	                      ageExist = true;
	                      //        console.log(" items[i].priceadd:Befor::", items[i].price);
	                      productAdded[k].calendar.items[i].price = parseFloat(value);
	                      //       console.log(" items[i].priceadd:::", items[i].price);

	                    }
	                    //  else {
	                    //   items[i].price=null;


	                    //  }
	                  });

	                  if (ageExist == false) {
	                    items[i].price = null;
	                  }
	                } else {
	                  items[i].price = null;
	                }
	              }
	              productAdded[k].items = items;
	              //vm.unit.sup.push(productAdded[k])
	              //products.push(productAdded[k]);
	              //vm.pdts.push(productAdded[k]);
	              //console.log("ppp:::",vm.pdts.length);
	            }
	          }

	          //       console.log("productAdded[k]:::::", productAdded);
	          //  LastproductsAdded=productAdded;
	          productAdded.map(function (prodToAdded) {
	            LastproductsAdded.push(prodToAdded);
	            //products.push(prodToAdded);
	            // vm.pdts.push(prodToAdded);
	            console.log("addtopdts:::", vm.pdts);
	            var productf = LastproductsAdded;
	            vm.pdts = productf;
	            vm.products.push(prodToAdded);
	            vm.unit.sp = vm.pdts.length;
	            pendingSupp.push(prodToAdded);
	            //  console.log("productAdded[k]prodToAdded:::::", prodToAdded);
	          });
	          //   const productf=LastproductsAdded;
	          //  vm.pdts=productf;   
	          //    console.log("teeeestpdts",vm.pdts);
	          // products.map(product=> {

	          //   console.log("productAdded[k]prodToAdded:::::", product);
	          //    })
	        }

	        // console.log("suppExist:::",suppExist);

	      });

	      //.then(() =>{ 
	      //  console.log("teeeest",LastproductsAdded.length);
	      //  vm.loading = false
	      // })
	      //const LastproductsAddedF=LastproductsAdded;
	      //       vm.pdts=LastproductsAddedF;

	    });
	    $q.all(LastproductsAdded).then(function () {
	      console.log("pendingSuppOK");
	      console.log("pendingSuppOKpendingSupp", pendingSupp.length);
	      vm.loadingsup = false;
	    });

	    // products.map(prodToAdded=> {
	    //   //pending.push(loadCalendar(prodToAdded, vm.period));
	    //   console.log("prodToAdded22:::",prodToAdded.calendar);

	    //   var suppExist = false;
	    //   prodToAdded.calendar.items.map(r => {

	    //             var productSupp;
	    //             if (r.supplement != null) {
	    //               productSupp = Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);

	    //             }
	    //             if (r.supplement != null && productSupp.length > 2) suppExist = true;


	    //           });
	    //           console.log("suppExist:::",suppExist);


	    // console.log("productAdded[k]prodToAdded:::::", productf);
	    //   //vm.products.push(prodAdded);
	    // })
	    //productsAdded

	    // console.log("LastproductsAdded:::",LastproductsAdded);
	    // vm.LastproductsAdded=LastproductsAdded;
	    // products=LastproductsAdded;


	    LastproductsAdded.map(function (prodAdded) {
	      products.push(prodAdded);
	      //console.log("ppp:::",prodAdded);

	      //return prodAdded;
	      //vm.products.push(prodAdded);
	    });
	    //  vm.unit.sp=vm.pdts;


	    // products.map(p=> {
	    // console.log("ppp:::",p);
	    // return p;
	    //   //vm.products.push(prodAdded);
	    // })
	    // vm.products=LastproductsAdded;


	    // products.map(prodToAdded=> {
	    //   //pending.push(loadCalendar(prodToAdded, vm.period));
	    //   console.log("prodToAdded:::",prodToAdded.calendar);

	    //   var suppExist = false;
	    //   prodToAdded.calendar.items.map(r => {
	    //             var productSupp;
	    //             if (r.supplement != null) {
	    //               productSupp = Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);

	    //             }
	    //             if (r.supplement != null && productSupp.length > 2) suppExist = true;


	    //           });
	    //           console.log("suppExist:::",suppExist);


	    //   //vm.products.push(prodAdded);
	    // })
	    console.log("vmvmvmloading:::", vm.loading);

	    // console.log("Lastproductsout:::",LastproductsAdded);

	    // console.log("vm.occupanciesout:::",vm.occupancies);
	    //vm.loading = false;
	  }

	  function findRecord(date, nights) {
	    return nights.find(function (n) {
	      return n.date === date.format('YYYY-MM-DD');
	    }) || {
	      date: date.format('YYYY-MM-DD')
	    };
	  }

	  function priceChanged(product, night) {
	    // tmp link TODO get ling from api
	    if (night.pristinePrice == night.price) {
	      return;
	    }
	    if (isNaN(night.price) || night.price < 0) {
	      night.price = night.pristinePrice;
	      return;
	    }

	    $http.post(apiUrl + '/commands/batch-update-rates', {
	      products: [product.code],
	      rates: [night.price],
	      periods: [{ start: night.date, end: night.date }]
	    }).then(function () {
	      $log.debug('night updated', night);
	      night.pristinePrice = night.price;
	    });
	  }

	  function loadCalendarSupplement(product, period) {
	    $http.get(product.links.calendar.href, {
	      params: {
	        $sort: 'date<',
	        start: period.start.format('YYYY-MM-DD'),
	        end: period.end.format('YYYY-MM-DD')
	      }
	    }).then(function (res) {
	      var nightsToShow = period.end.diff(period.start, 'days');
	      var calendar = [];
	      var nights = res.data.items;
	      $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	      if (nights.length !== nightsToShow) {
	        // returned calendar can have holes, make sure we fill them
	        var date = moment(period.start);
	        var i = 0;
	        while (i < nightsToShow) {
	          var rec = findRecord(date, nights);
	          //reviveCancellation(rec);
	          calendar.push(rec);
	          date.add(1, 'days');
	          i++;
	        }
	      } else {
	        calendar = nights;
	      }
	      calendar.forEach(function (night) {
	        night.price = parseFloat(night.price);
	        night.pristinePrice = night.price;
	      });
	      product.calendar = {
	        items: calendar
	      };
	    });
	  }
	  /*
	       const cancellationLabels = {
	        "999%100":"NRF",
	        "0%0":"Gratuite"
	      }
	        function reviveCancellation(rec) {
	          $log.debug(rec);
	          if (!rec.cancellation) return;
	           const hash = rec.cancellation.join('/');
	           $log.debug(hash);
	           if (!cancellationLabels[hash]) {
	            cancellationLabels[hash] = formatCancellation(rec.cancellation);
	          }
	          rec.cancellationLabel =  cancellationLabels[hash];
	        }
	         function formatCancellation(rules) {
	          return 'custom';
	        }
	   */
	}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	'use strict';

	UnitAllotmentsTableCtrl.$inject = ["$log", "$q", "$scope", "$http", "moment", "apiUrl", "allotmentsHelper"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'unitAllotmentsTable',
	  templateUrl: 'app/yield/property-table/unit-allotments/template.html',
	  controller: UnitAllotmentsTableCtrl,
	  bindings: {
	    unit: '<',
	    rateBases: '<',
	    period: '<'
	  }

	  /** @ngInject */
	};
	function UnitAllotmentsTableCtrl($log, $q, $scope, $http, moment, apiUrl, allotmentsHelper) {
	  var vm = this;

	  var PATCH_URL = apiUrl + "/commands/patch-allotments-calendar";

	  vm.$onChanges = function (changes) {
	    if (!changes.hasOwnProperty('period')) return;
	    if (changes.period.isFirstChange()) {
	      init();
	    } else {
	      reloadCalendars(vm.period);
	    }
	  };

	  angular.extend(vm, {
	    availabilityChanged: availabilityChanged,
	    releaseChanged: releaseChanged
	  });

	  function init() {
	    var pending = [];
	    vm.loading = true;
	    $http.get(vm.unit.links.allotments.href).then(function (res) {
	      var allotments = res.data.items.map(function (a) {
	        reviveAllotment(a);
	        pending.push(loadCalendar(a, vm.period));
	        return a;
	      });
	      allotments.sort(function (a) {
	        return a.contracted ? 1 : 0;
	      });
	      vm.allotments = allotments.map(allotmentsHelper.allotmentColor);
	    });

	    $q.all(pending).then(function () {
	      return vm.loading = false;
	    });
	  }

	  function reloadCalendars(period) {
	    vm.loading = true;
	    var promises = vm.allotments.map(function (a) {
	      return loadCalendar(a, period);
	    });
	    $q.all(promises).then(function () {
	      return vm.loading = false;
	    }, function () {
	      vm.loading = false;
	      vm.error = "Error loading rates";
	    });
	  }

	  function reviveAllotment(allotment) {
	    allotment.label = allotment.contracted ? 'Allotement' : 'Open Sell/Flex';
	    allotment.label += ' (' + allotment.bases.map(function (b) {
	      return vm.rateBases[b].description;
	    }).join(',') + ')';
	    return allotment;
	  }

	  function loadCalendar(allotment, period) {
	    return $http.get(allotment.links.calendar.href, {
	      params: {
	        $sort: 'date<',
	        start: period.start.format('YYYY-MM-DD'),
	        end: period.end.format('YYYY-MM-DD')
	      }
	    }).then(function (res) {
	      var nightsToShow = period.end.diff(period.start, 'days');
	      var calendar = [];
	      var nights = res.data.items;
	      //console.log("nights", nightsToShow, nights)
	      if (nights.length !== nightsToShow) {
	        // returned calendar can have holes, make sure we fill them
	        var date = moment(period.start);
	        var i = 0;
	        while (i < nightsToShow) {
	          var rec = findRecord(date, nights) || {
	            date: date.format('YYYY-MM-DD'),
	            available: 0,
	            releaseDate: moment(date).add(1, "days").format('YYYY-MM-DD')
	          };
	          rec.release = date.diff(rec.releaseDate, 'days') + 1;
	          calendar.push(rec);
	          date.add(1, 'days');
	          i++;
	        }
	      } else {
	        calendar = nights;
	      }
	      calendar.forEach(function (night) {
	        night.pristineAvailable = night.available;
	        night.pristineRelease = night.release;
	      });

	      allotment.calendar = {
	        items: calendar
	      };
	    });

	    function findRecord(date, nights) {
	      return nights.find(function (n) {
	        return n.date === date.format('YYYY-MM-DD');
	      });
	    }
	  }

	  function availabilityChanged(allotment, night) {
	    // console.log("availabilityChanged",allotment, night)
	    // tmp link TODO get ling from api
	    if (night.pristineAvailable == night.available) {
	      return;
	    }
	    if (isNaN(night.available) || night.available < 0) {
	      night.available = night.pristineAvailable;
	      // some feedback please
	      return;
	    }
	    $http.post(PATCH_URL, {
	      allotments: [allotment.code],
	      availabilities: [night.available],
	      periods: [{
	        start: night.date,
	        end: night.date
	      }]
	    }).then(function () {
	      $log.debug('night updated available', night);
	      night.pristineAvailable = night.available;
	    });
	  }

	  function releaseChanged(allotment, night) {
	    // tmp link TODO get ling from api
	    if (night.pristineRelease == night.release) {
	      return;
	    }
	    if (isNaN(night.release) || night.release < 0) {
	      night.release = night.pristineRelease;
	      return;
	    }
	    $http.post(PATCH_URL, {
	      allotments: [allotment.code],
	      releases: [night.release],
	      periods: [{
	        start: night.date,
	        end: night.date
	      }]
	    }).then(function () {
	      $log.debug('night updated release', night);
	      night.pristineRelease = night.release;
	    });
	  }
	}

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	UnitStopsalesTableCtrl.$inject = ["$state", "User", "$log", "$q", "$http", "moment", "apiUrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var moment = __webpack_require__(10);

	exports.default = {
	  name: 'unitStopsalesTable',
	  controller: UnitStopsalesTableCtrl,
	  templateUrl: 'app/yield/property-table/unit-stopSales/template.html',
	  bindings: {
	    unit: '<',
	    rateBases: '<',
	    boards: '<',
	    period: '<',
	    selectedProduct: '<',
	    selectedBoards: '<',
	    occupancies: '<',
	    boardss: '<',
	    property: '<',
	    stopSales: '<',
	    onRequests: '<'

	  }
	};


	function UnitStopsalesTableCtrl($state, User, $log, $q, $http, moment, apiUrl) {
	  "ngInject";

	  var vm = this;

	  vm.$onChanges = function (changes) {
	    console.log("changeStop::", changes);

	    //console.log("change00vm.selectedProduct::",vm.selectedProduct);
	    init();

	    if (!changes.hasOwnProperty('period')) return;
	    if (changes.period.isFirstChange()) {
	      init();
	    } else {
	      init();
	      //reloadCalendars(vm.period);
	    }
	  };

	  vm.priceChanged = priceChanged;
	  vm.stopChanged = stopChanged;

	  function init() {
	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });

	    console.log("propertyCtrlpropertyCtrl0:", vm.unit.links);
	    console.log("propertyCtrlpropertyCtrl0Code:", vm.unit.code);

	    console.log("propertyCtrlpropertyCtrl0:", vm.property.property);
	    console.log("stopSalesstopSales:", vm.stopSales);
	    console.log("stopPeriod:", vm.period);
	    console.log("onRequestsonRequests00:", vm.onRequests);
	    //console.log("change00onRequests::", JSON.stringify(vm.onRequests));
	    //console.log("change00onRequests1::");


	    // console.log("vm.productssOccup::::",productssOccup);
	    vm.stopSalesExist = [];
	    vm.onRequestExist = [];

	    //vm.pdtss;
	    vm.unit.occupancies = [];
	    var pending = [];
	    var LastproductsAdded = [];
	    var stopSalesFiltred = [];
	    vm.loading = true;
	    //  vm.stopsaless=[];
	    // const p4 = vm.property.get('stop-sales')
	    //         .then(stpsales => {

	    //           //  console.log("propertyCtrlpropertyCtrl22:",stpsales);
	    //             vm.stpsales = stpsales});

	    //             console.log("propertyCtrlpropertyCtrl22:",vm.stpsale);


	    vm.ready =

	    // $http.get(vm.property.property.links["stop-sales"].href , {
	    //     headers: {
	    //       'accept-language': ''
	    //     }
	    //   })
	    //   .then(res => {
	    //     $log.debug('stopsales loaded', res.data);
	    //     console.log("propertyCtrlpropertyCtrl22:",res.data);
	    //     res.data.items.map(stop =>{ 
	    //         console.log("pushstp",stop);


	    //           vm.stopsaless.push(stop);
	    //           console.log("pushstpstopsaless",vm.stopsaless);


	    //        });
	    //        console.log("pushstpstopsalessLength",vm.stopsaless.length);
	    //   //  vm.stopsaless = res.data.items;
	    //     //vm.discount = discountsHelper.parse(res.data);
	    //   }, () => {
	    //     $log.debug('error loading stopsales', arguments);
	    //   });;
	    //$q.all(pending).then(() => vm.loading = false);

	    vm.period.dates.map(function (date) {

	      var stpsls = {
	        "date": date,
	        "exist": false

	      };

	      vm.stopSalesExist.push(stpsls);
	      vm.onRequestExist.push(stpsls);
	    });
	    console.log("vm.stopSales:", vm.stopSales);

	    checkStopSales();
	    //  checkOnRequests();
	    // console.log("vm.vm.productslaast::::",vm.products);
	  }

	  function checkStopSales() {
	    // console.log("checkStopSales:",vm.stopsaless);

	    var StopF = [];
	    console.log("pushstpstopsalessLength2", vm.stopSales);
	    console.log("vm.stopSalesunit:", vm.unit);
	    StopF = vm.stopSales.filter(function (stop) {
	      return stop.type == 'Unit';
	    });
	    vm.stopSalesFiltred = StopF.filter(function (stop) {
	      return stop.typeCode == vm.unit.code;
	    });

	    console.log("vm.stopSalesAfterFilter", vm.stopSalesFiltred);
	    console.log("vm.stopSalesExistBefore:", vm.stopSalesExist);

	    vm.stopSalesExist.map(function (stop) {

	      vm.stopSalesFiltred.map(function (stpF) {
	        console.log("infilter", stpF.status);
	        console.log("infilter2", stop.date);
	        console.log("stop.date::", Date.parse(stop.date));
	        console.log("stop.date:::", Date.parse(moment(stop.date, "YYYY-MM-DD").format("YYYY-MM-DD")));
	        //  && Date.parse(stpF.date) <= Date.parse(stop.fin)
	        console.log("stop.date:::", moment(stop.date, "YYYY-MM-DD").format("YYYY-MM-DD"));
	        console.log("stop.date:::", Date.parse(stpF.debut));

	        //if( Date.parse(stpF.debut) <= Date.parse(stop.date)  && Date.parse(stop.date) <= Date.parse(stpF.fin) ) {
	        //   if( Date.parse(stpF.debut) <=  moment(Date.parse(stop.date)).add(2,'hours')  && Date.parse(stop.date) <= Date.parse(stpF.fin) ) {
	        if (Date.parse(stpF.debut) <= Date.parse(moment(stop.date, "YYYY-MM-DD").format("YYYY-MM-DD")) && Date.parse(moment(stop.date, "YYYY-MM-DD").format("YYYY-MM-DD")) <= Date.parse(stpF.fin)) {
	          // Date.parse(moment(Date.parse(stop.date),"YYYY-MM-DD").format("YYYY-MM-DD"))
	          //&& stpF.status == true) {
	          console.log("vm.stopSalesAfterFilteryees");
	          console.log("stop.date::", moment(stop.date, "YYYY-MM-DD").format("YYYY-MM-DD"));
	          console.log("Date.parse(stpF.debut)::", stpF.debut);
	          console.log("stop.date::", Date.parse(moment(Date.parse(stop.date), "YYYY-MM-DD").format("YYYY-MM-DD")));
	          console.log("Date.parse(stpF.debut)::", Date.parse(stpF.debut));
	          // console.log("vm.stopSalesAfterFilteryeescode",stpF.code);
	          // console.log("vm.stopSalesAfterFilteryeesdebut",stpF.debut);
	          // console.log("vm.stopSalesAfterFilteryeesfin",stpF.fin);

	          stop.exist = true;
	          stop.code = stpF.code;
	          stop.from = stpF.debut;
	          stop.to = stpF.fin;
	        }
	      });
	    });
	    console.log("vm.stopSalesExistAfter:", vm.stopSalesExist);
	  }

	  function checkOnRequests() {
	    // console.log("checkStopSales:",vm.stopsaless);
	    var onReqF = [];
	    console.log("checkOnRequests", vm.requests);
	    onReqF = vm.requests.filter(function (req) {
	      return req.type == 'Unit';
	    });
	    console.log("checkOnRequestsonReqF", vm.requests);

	    vm.onRequestsFiltred = onReqF.filter(function (req) {
	      return req.typeCode == vm.unit.code;
	    });
	    console.log("vm.onRequestsFiltred:", vm.onRequestsFiltred);

	    vm.onRequestsExist.map(function (onReq) {

	      vm.onRequestsFiltred.map(function (onReqF) {

	        //  && Date.parse(stpF.date) <= Date.parse(stop.fin)
	        if (Date.parse(onReqF.debut) <= Date.parse(onReq.date) && Date.parse(onReq.date) <= Date.parse(onReqF.fin)) {
	          console.log("vm.onRequestsFiltredyees");
	          onReq.exist = true;
	          // console.log("vm.onReqonReq:",onReq);
	        }
	      });
	    });
	    console.log("vm.onRequestsExist:", vm.onRequestsExist);
	  }

	  function reloadCalendars(period) {
	    vm.loading = true;
	    var promises = vm.products.map(function (product) {
	      return loadCalendar(product, period);
	    });
	    $q.all(promises).then(function () {
	      return vm.loading = false;
	    }, function () {
	      vm.loading = false;
	      vm.error = "Error loading rates";
	    });
	  }

	  function loadCalendar(product, period, _callback) {
	    $http.get(product.links.calendar.href, {
	      params: {
	        $sort: 'date<',
	        start: period.start.format('YYYY-MM-DD'),
	        end: period.end.format('YYYY-MM-DD')
	      }
	    }).then(function (res) {
	      var nightsToShow = period.end.diff(period.start, 'days');
	      var calendar = [];
	      var nights = res.data.items;
	      $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	      if (nights.length !== nightsToShow) {
	        // returned calendar can have holes, make sure we fill them
	        var date = moment(period.start);
	        var i = 0;
	        while (i < nightsToShow) {
	          var rec = findRecord(date, nights);
	          //reviveCancellation(rec);
	          calendar.push(rec);
	          date.add(1, 'days');
	          i++;
	        }
	      } else {
	        calendar = nights;
	      }
	      calendar.forEach(function (night) {
	        night.price = parseFloat(night.price);
	        night.pristinePrice = night.price;
	      });
	      product.calendar = {
	        items: calendar
	      };
	    });

	    //_callback();
	  }

	  function loadCalendarSupp(products, period, LastproductsAdded, vmproducts) {
	    vm.loadingsup = true;
	    // var LastproductsAdded=[];
	    //  vm.pdts=products; 
	    // console.log("inloadCalendarSuppProduct",products)
	    var pendingSupp = [];
	    var promises = products.map(function (product) {

	      console.log("prodToAdded1100:::", product);

	      $http.get(product.links.calendar.href, {
	        params: {
	          $sort: 'date<',
	          start: period.start.format('YYYY-MM-DD'),
	          end: period.end.format('YYYY-MM-DD')
	        }
	      }).then(function (res) {
	        var nightsToShow = period.end.diff(period.start, 'days');
	        var calendar = [];
	        var nights = res.data.items;
	        $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	        if (nights.length !== nightsToShow) {
	          // returned calendar can have holes, make sure we fill them
	          var date = moment(period.start);
	          var i = 0;
	          while (i < nightsToShow) {
	            var rec = findRecord(date, nights);
	            //reviveCancellation(rec);
	            calendar.push(rec);
	            date.add(1, 'days');
	            i++;
	          }
	        } else {
	          calendar = nights;
	        }
	        calendar.forEach(function (night) {
	          night.price = parseFloat(night.price);
	          night.pristinePrice = night.price;
	        });
	        product.calendar = {
	          items: calendar
	        };
	        console.log("prodToAdded11:::", product);
	        console.log("teeeest", LastproductsAdded.length);
	        var suppExist = false;

	        product.calendar.items.map(function (r) {

	          var productSupp;
	          if (r.supplement != null) {
	            productSupp = Object.keys(r.supplement).map(function (key) {
	              return [Number(key), r.supplement[key]];
	            });
	          }
	          if (r.supplement != null && productSupp.length > 2) suppExist = true;
	        });
	        // if (suppExist==true) {

	        //   LastproductsAdded.push(r);
	        // }

	        if (suppExist = true) {
	          // console.log("suppExist:::",suppExist);

	          var productSupp = [];
	          product.calendar.items.map(function (rs) {
	            if (rs.supplement != null) {

	              productSupp = Object.entries(rs.supplement);
	              // console.log("productSupp:::", productSupp);

	              //productSupp= Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);
	            }
	          });
	          // console.log("productSupp:::",productSupp);
	          var productAdded = [];
	          if (productSupp.length) {
	            var i = 0;

	            productSupp.forEach(function (_ref) {
	              var _ref2 = _slicedToArray(_ref, 2),
	                  key = _ref2[0],
	                  value = _ref2[1];

	              ///  console.log("productSuppvalue[key, value]:::", value);

	              if (value != null & i > 1) {

	                var prdct = Object.assign({}, product);
	                prdct.age = key;
	                prdct.name = prdct.name + " " + key;
	                productAdded.push(prdct);
	                console.log("prdct.name:::", prdct.name);
	              }
	              i++;
	            });
	          }

	          if (productAdded.length) {
	            console.log("productAddedLength;:::", productAdded.length);
	            // console.log("productAddedLength;:::", productAdded);

	            for (var k = 0; k < productAdded.length; k++) {
	              var items = [];
	              for (var i = 0; i < productAdded[k].calendar.items.length; i++) {

	                // var productSuppitemi= Object.keys(res.data.items[i].supplement).map((key) => [Number(key), res.data.items[i].supplement[key]]);
	                //items[i]=res.data.items[i]
	                items[i] = Object.assign({}, productAdded[k].calendar.items[i]);
	                //  console.log("productAddedLengthINNN;:::");

	                var productSuppitemi;
	                var ageExist = false;
	                if (productAdded[k].calendar.items[i].supplement != null) {
	                  productSuppitemi = Object.entries(productAdded[k].calendar.items[i].supplement);

	                  productSuppitemi.forEach(function (_ref3) {
	                    var _ref4 = _slicedToArray(_ref3, 2),
	                        key = _ref4[0],
	                        value = _ref4[1];

	                    if (key === productAdded[k].age) {
	                      //    console.log("productAddedLengthINNNAGE;:::",value);
	                      //    console.log("productAddedLengthINNNAGEkey;:::",key);

	                      ageExist = true;
	                      //        console.log(" items[i].priceadd:Befor::", items[i].price);
	                      productAdded[k].calendar.items[i].price = parseFloat(value);
	                      //       console.log(" items[i].priceadd:::", items[i].price);

	                    }
	                    //  else {
	                    //   items[i].price=null;


	                    //  }
	                  });

	                  if (ageExist == false) {
	                    items[i].price = null;
	                  }
	                } else {
	                  items[i].price = null;
	                }
	              }
	              productAdded[k].items = items;
	              //vm.unit.sup.push(productAdded[k])
	              //products.push(productAdded[k]);
	              //vm.pdts.push(productAdded[k]);
	              //console.log("ppp:::",vm.pdts.length);
	            }
	          }

	          //       console.log("productAdded[k]:::::", productAdded);
	          //  LastproductsAdded=productAdded;
	          productAdded.map(function (prodToAdded) {
	            LastproductsAdded.push(prodToAdded);
	            //products.push(prodToAdded);
	            // vm.pdts.push(prodToAdded);
	            console.log("addtopdts:::", vm.pdts);
	            var productf = LastproductsAdded;
	            vm.pdts = productf;
	            vm.products.push(prodToAdded);
	            vm.unit.sp = vm.pdts.length;
	            pendingSupp.push(prodToAdded);
	            //  console.log("productAdded[k]prodToAdded:::::", prodToAdded);
	          });
	          //   const productf=LastproductsAdded;
	          //  vm.pdts=productf;   
	          //    console.log("teeeestpdts",vm.pdts);
	          // products.map(product=> {

	          //   console.log("productAdded[k]prodToAdded:::::", product);
	          //    })
	        }

	        // console.log("suppExist:::",suppExist);

	      });

	      //.then(() =>{ 
	      //  console.log("teeeest",LastproductsAdded.length);
	      //  vm.loading = false
	      // })
	      //const LastproductsAddedF=LastproductsAdded;
	      //       vm.pdts=LastproductsAddedF;

	    });
	    $q.all(LastproductsAdded).then(function () {
	      console.log("pendingSuppOK");
	      console.log("pendingSuppOKpendingSupp", pendingSupp.length);
	      vm.loadingsup = false;
	    });

	    // products.map(prodToAdded=> {
	    //   //pending.push(loadCalendar(prodToAdded, vm.period));
	    //   console.log("prodToAdded22:::",prodToAdded.calendar);

	    //   var suppExist = false;
	    //   prodToAdded.calendar.items.map(r => {

	    //             var productSupp;
	    //             if (r.supplement != null) {
	    //               productSupp = Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);

	    //             }
	    //             if (r.supplement != null && productSupp.length > 2) suppExist = true;


	    //           });
	    //           console.log("suppExist:::",suppExist);


	    // console.log("productAdded[k]prodToAdded:::::", productf);
	    //   //vm.products.push(prodAdded);
	    // })
	    //productsAdded

	    // console.log("LastproductsAdded:::",LastproductsAdded);
	    // vm.LastproductsAdded=LastproductsAdded;
	    // products=LastproductsAdded;


	    LastproductsAdded.map(function (prodAdded) {
	      products.push(prodAdded);
	      //console.log("ppp:::",prodAdded);

	      //return prodAdded;
	      //vm.products.push(prodAdded);
	    });
	    //  vm.unit.sp=vm.pdts;


	    // products.map(p=> {
	    // console.log("ppp:::",p);
	    // return p;
	    //   //vm.products.push(prodAdded);
	    // })
	    // vm.products=LastproductsAdded;


	    // products.map(prodToAdded=> {
	    //   //pending.push(loadCalendar(prodToAdded, vm.period));
	    //   console.log("prodToAdded:::",prodToAdded.calendar);

	    //   var suppExist = false;
	    //   prodToAdded.calendar.items.map(r => {
	    //             var productSupp;
	    //             if (r.supplement != null) {
	    //               productSupp = Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);

	    //             }
	    //             if (r.supplement != null && productSupp.length > 2) suppExist = true;


	    //           });
	    //           console.log("suppExist:::",suppExist);


	    //   //vm.products.push(prodAdded);
	    // })
	    console.log("vmvmvmloading:::", vm.loading);

	    // console.log("Lastproductsout:::",LastproductsAdded);

	    // console.log("vm.occupanciesout:::",vm.occupancies);
	    //vm.loading = false;
	  }

	  function findRecord(date, nights) {
	    return nights.find(function (n) {
	      return n.date === date.format('YYYY-MM-DD');
	    }) || {
	      date: date.format('YYYY-MM-DD')
	    };
	  }

	  function priceChanged(product, night) {
	    // tmp link TODO get ling from api
	    if (night.pristinePrice == night.price) {
	      return;
	    }
	    if (isNaN(night.price) || night.price < 0) {
	      night.price = night.pristinePrice;
	      return;
	    }

	    $http.post(apiUrl + '/commands/batch-update-rates', {
	      products: [product.code],
	      rates: [night.price],
	      periods: [{ start: night.date, end: night.date }]
	    }).then(function () {
	      $log.debug('night updated', night);
	      night.pristinePrice = night.price;
	    });
	  }

	  //     function stopChanged(stp,date){
	  function stopChanged(stp, index, date) {
	    var stpFrom = moment(stp.from).format("YYYY-MM-DD");
	    var stpTo = moment(stp.to).format("YYYY-MM-DD");
	    var checkDate = moment(date).format("YYYY-MM-DD");

	    var oldStop = {
	      code: stp.code,
	      type: stp.type,
	      typeCode: stp.type_code,
	      description: stp.description,
	      property: stp.property,
	      debut: stpFrom,
	      fin: stpTo

	    };
	    var newStop = {
	      type: stp.type,
	      typeCode: stp.type_code,
	      description: stp.description,
	      property: stp.property,
	      debut: stpFrom,
	      fin: stpTo

	    };
	    if (vm.stopSalesExist[index].exist == true) {
	      vm.stopSalesExist[index].exist = false;
	      // if(date == stp.from || date == stp.to){   

	      if (checkDate == stpFrom || checkDate == stpTo) {
	        if (checkDate == stpFrom && checkDate != stpTo) {
	          oldStop.debut = moment(stpFrom, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");

	          stopSalesUpdate(oldStop);
	          $state.reload();
	        }
	        if (checkDate == stpTo && checkDate != stpFrom) {

	          oldStop.fin = moment(stpTo, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD");
	          console.log("first or last day):", oldStop.fin);
	          console.log("moment first or last day):", moment(stpTo, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD"));
	          stopSalesUpdate(oldStop);
	          $state.reload();
	        }
	        if (checkDate == stpTo && checkDate == stpFrom) {
	          remove(oldStop);
	        }
	        //  put oldStop;

	        init();
	        console.log("first or last day):");
	      } else {

	        oldStop.fin = moment(checkDate, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD");
	        var newStop2 = {
	          type: "Unit",
	          typeCode: vm.unit.code,
	          description: "Stop Sales",
	          property: vm.property.property.code,
	          debut: moment(checkDate, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD"),
	          fin: stpTo
	          // newStop.debut=moment(checkDate,"YYYY-MM-DD").add(1,'days').format("YYYY-MM-DD")
	        };stopSalesUpdate(oldStop);
	        postStopSales(newStop2).then($state.reload());
	        init();
	      }
	    } else {
	      var newStop1 = {

	        type: "Unit",
	        typeCode: vm.unit.code,
	        description: "Stop Sales",
	        property: vm.property.property.code,
	        debut: moment(checkDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
	        fin: moment(checkDate, "YYYY-MM-DD").format("YYYY-MM-DD")
	      };
	      console.log("newStop1):", newStop1);

	      vm.stopSalesExist[index].exist = true;
	      postStopSales(newStop1).then($state.reload());;
	      init();
	    }

	    //  var originalTo=stp.to;
	    //  console.log("originalTo:",originalTo)
	    //  console.log("originalfrom:",stp.from)
	    //  console.log("moment(stp.from):",moment(stp.from).format("YYYY-MM-DD"))
	    //  console.log("moment(stp.to):",Date.parse(stp.to))
	    //  console.log("moment(date):",moment(date).format("YYYY-MM-DD"))
	    //  console.log("stpcode:",stp.code)
	    //  console.log("dateTo:",date)
	    //  console.log("vm.stopSalesExist[index].exist:",vm.stopSalesExist[index].exist)
	    //  console.log("index:",index)
	    //  init();

	  }
	  function postStopSales(stopsales) {
	    $log.debug('link', vm.property.property.links);

	    //var href = "http://beds-api.fractalite.com/properties/2/stop-sales";
	    console.log("stopsales):", stopsales);

	    return $http.post(vm.property.property.links["stop-sales"].href, stopsales).then(function (res) {
	      $log.debug('created', res.data);
	      //  $scope.$emit("stopsalesAdded",res.data);
	    }, function () {
	      $log.error(arguments);
	      // return $q.reject()
	    });
	    //  .then(() => $state.reload());
	  }

	  function stopSalesUpdate(stopsales) {
	    var promise;

	    console.log("ss", stopsales);
	    promise = $http({
	      method: "PUT",
	      url: vm.property.property.links["stop-sales"].href + "/" + stopsales.code,
	      headers: {
	        "Content-Language": "**"
	      },
	      data: _.pick(stopsales, ['code', 'type', 'description', 'type_code', 'debut', 'fin', 'property', 'status'])
	    });
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	    //.then(() => $state.reload());;
	  }
	  function remove(stopsales) {

	    console.log("remove):", stopsales);

	    $http.delete(vm.property.property.links["stop-sales"].href + "/" + stopsales.code).then(function () {
	      return $state.reload();
	    });
	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }

	  function loadCalendarSupplement(product, period) {
	    $http.get(product.links.calendar.href, {
	      params: {
	        $sort: 'date<',
	        start: period.start.format('YYYY-MM-DD'),
	        end: period.end.format('YYYY-MM-DD')
	      }
	    }).then(function (res) {
	      var nightsToShow = period.end.diff(period.start, 'days');
	      var calendar = [];
	      var nights = res.data.items;
	      $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	      if (nights.length !== nightsToShow) {
	        // returned calendar can have holes, make sure we fill them
	        var date = moment(period.start);
	        var i = 0;
	        while (i < nightsToShow) {
	          var rec = findRecord(date, nights);
	          //reviveCancellation(rec);
	          calendar.push(rec);
	          date.add(1, 'days');
	          i++;
	        }
	      } else {
	        calendar = nights;
	      }
	      calendar.forEach(function (night) {
	        night.price = parseFloat(night.price);
	        night.pristinePrice = night.price;
	      });
	      product.calendar = {
	        items: calendar
	      };
	    });
	  }
	  /*
	         const cancellationLabels = {
	        "999%100":"NRF",
	        "0%0":"Gratuite"
	      }
	        function reviveCancellation(rec) {
	          $log.debug(rec);
	          if (!rec.cancellation) return;
	             const hash = rec.cancellation.join('/');
	             $log.debug(hash);
	             if (!cancellationLabels[hash]) {
	            cancellationLabels[hash] = formatCancellation(rec.cancellation);
	          }
	          rec.cancellationLabel =  cancellationLabels[hash];
	        }
	           function formatCancellation(rules) {
	          return 'custom';
	        }
	     */
	}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	'use strict';

	UnitOnrequestsTableCtrl.$inject = ["$state", "User", "$log", "$q", "$http", "moment", "apiUrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	exports.default = {
	  name: 'unitOnrequestsTable',
	  controller: UnitOnrequestsTableCtrl,
	  templateUrl: 'app/yield/property-table/unit-requests/template.html',
	  bindings: {
	    unit: '<',
	    rateBases: '<',
	    boards: '<',
	    period: '<',
	    selectedProduct: '<',
	    selectedBoards: '<',
	    occupancies: '<',
	    boardss: '<',
	    property: '<',
	    onRequests: '<'

	  }
	};


	function UnitOnrequestsTableCtrl($state, User, $log, $q, $http, moment, apiUrl) {
	  "ngInject";

	  var vm = this;

	  vm.$onChanges = function (changes) {
	    console.log("change00::", changes);

	    //console.log("change00vm.selectedProduct::",vm.selectedProduct);
	    init();

	    if (!changes.hasOwnProperty('period')) return;
	    if (changes.period.isFirstChange()) {
	      init();
	    } else {
	      init();
	      //reloadCalendars(vm.period);
	    }
	  };

	  vm.priceChanged = priceChanged;
	  vm.onReqChanged = onReqChanged;

	  function init() {

	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });
	    console.log("unitOnrequestsTable:", vm.onRequests);

	    console.log("propertyCtrlpropertyCtrl0:", vm.unit.links);
	    console.log("propertyCtrlpropertyCtrl0:", vm.property.property);

	    console.log("stopPeriod:", vm.period);
	    console.log("onRequestsonRequests00:", vm.onRequests);
	    //console.log("change00onRequests::", JSON.stringify(vm.onRequests));
	    //console.log("change00onRequests1::");


	    // console.log("vm.productssOccup::::",productssOccup);
	    vm.onRequestsExist = [];

	    //vm.pdtss;
	    vm.unit.occupancies = [];
	    var pending = [];
	    var LastproductsAdded = [];
	    vm.loading = true;
	    //  vm.stopsaless=[];
	    // const p4 = vm.property.get('stop-sales')
	    //         .then(stpsales => {

	    //           //  console.log("propertyCtrlpropertyCtrl22:",stpsales);
	    //             vm.stpsales = stpsales});

	    //             console.log("propertyCtrlpropertyCtrl22:",vm.stpsale);


	    vm.ready =

	    // $http.get(vm.property.property.links["stop-sales"].href , {
	    //     headers: {
	    //       'accept-language': ''
	    //     }
	    //   })
	    //   .then(res => {
	    //     $log.debug('stopsales loaded', res.data);
	    //     console.log("propertyCtrlpropertyCtrl22:",res.data);
	    //     res.data.items.map(stop =>{ 
	    //         console.log("pushstp",stop);


	    //           vm.stopsaless.push(stop);
	    //           console.log("pushstpstopsaless",vm.stopsaless);


	    //        });
	    //        console.log("pushstpstopsalessLength",vm.stopsaless.length);
	    //   //  vm.stopsaless = res.data.items;
	    //     //vm.discount = discountsHelper.parse(res.data);
	    //   }, () => {
	    //     $log.debug('error loading stopsales', arguments);
	    //   });;
	    //$q.all(pending).then(() => vm.loading = false);

	    vm.period.dates.map(function (date) {

	      var stpsls = {
	        "date": date,
	        "exist": false

	      };

	      vm.onRequestsExist.push(stpsls);
	    });
	    console.log("vm.stopSales:", vm.stopSales);

	    checkOnRequests();
	    // console.log("vm.vm.productslaast::::",vm.products);
	  }

	  function checkOnRequests() {
	    // console.log("checkStopSales:",vm.stopsaless);
	    var onReqF = [];
	    console.log("checkOnRequests", vm.onRequests);
	    onReqF = vm.onRequests.filter(function (req) {
	      return req.type == 'Unit';
	    });
	    console.log("checkOnRequestsonReqF", onReqF);

	    vm.onRequestsFiltred = onReqF.filter(function (req) {
	      return req.typeCode == vm.unit.code;
	    });
	    console.log("vm.onRequestsFiltred:", vm.onRequestsFiltred);

	    vm.onRequestsExist.map(function (onReq) {

	      vm.onRequestsFiltred.map(function (onReqF) {

	        console.log("vm.onRequestsFiltred");

	        //  && Date.parse(stpF.date) <= Date.parse(stop.fin)moment(Date.parse(onReq.date))
	        //if( Date.parse(onReqF.debut) <= moment(Date.parse(onReq.date)).add(2,'hours') && Date.parse(onReq.date) <= Date.parse(onReqF.fin)) {
	        if (Date.parse(onReqF.debut) <= Date.parse(moment(onReq.date, "YYYY-MM-DD").format("YYYY-MM-DD")) && Date.parse(moment(onReq.date, "YYYY-MM-DD").format("YYYY-MM-DD")) <= Date.parse(onReqF.fin)) {

	          console.log("vm.onRequestsFiltredyees");
	          onReq.exist = true;
	          onReq.code = onReqF.code;
	          onReq.from = onReqF.debut;
	          onReq.to = onReqF.fin;

	          // console.log("vm.onReqonReq:",onReq);
	        }
	      });
	    });
	    console.log("vm.onRequestsExist:", vm.onRequestsExist);
	  }

	  function reloadCalendars(period) {
	    vm.loading = true;
	    var promises = vm.products.map(function (product) {
	      return loadCalendar(product, period);
	    });
	    $q.all(promises).then(function () {
	      return vm.loading = false;
	    }, function () {
	      vm.loading = false;
	      vm.error = "Error loading rates";
	    });
	  }

	  function loadCalendar(product, period, _callback) {
	    $http.get(product.links.calendar.href, {
	      params: {
	        $sort: 'date<',
	        start: period.start.format('YYYY-MM-DD'),
	        end: period.end.format('YYYY-MM-DD')
	      }
	    }).then(function (res) {
	      var nightsToShow = period.end.diff(period.start, 'days');
	      var calendar = [];
	      var nights = res.data.items;
	      $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	      if (nights.length !== nightsToShow) {
	        // returned calendar can have holes, make sure we fill them
	        var date = moment(period.start);
	        var i = 0;
	        while (i < nightsToShow) {
	          var rec = findRecord(date, nights);
	          //reviveCancellation(rec);
	          calendar.push(rec);
	          date.add(1, 'days');
	          i++;
	        }
	      } else {
	        calendar = nights;
	      }
	      calendar.forEach(function (night) {
	        night.price = parseFloat(night.price);
	        night.pristinePrice = night.price;
	      });
	      product.calendar = {
	        items: calendar
	      };
	    });

	    //_callback();
	  }

	  function loadCalendarSupp(products, period, LastproductsAdded, vmproducts) {
	    vm.loadingsup = true;
	    // var LastproductsAdded=[];
	    //  vm.pdts=products; 
	    // console.log("inloadCalendarSuppProduct",products)
	    var pendingSupp = [];
	    var promises = products.map(function (product) {

	      console.log("prodToAdded1100:::", product);

	      $http.get(product.links.calendar.href, {
	        params: {
	          $sort: 'date<',
	          start: period.start.format('YYYY-MM-DD'),
	          end: period.end.format('YYYY-MM-DD')
	        }
	      }).then(function (res) {
	        var nightsToShow = period.end.diff(period.start, 'days');
	        var calendar = [];
	        var nights = res.data.items;
	        $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	        if (nights.length !== nightsToShow) {
	          // returned calendar can have holes, make sure we fill them
	          var date = moment(period.start);
	          var i = 0;
	          while (i < nightsToShow) {
	            var rec = findRecord(date, nights);
	            //reviveCancellation(rec);
	            calendar.push(rec);
	            date.add(1, 'days');
	            i++;
	          }
	        } else {
	          calendar = nights;
	        }
	        calendar.forEach(function (night) {
	          night.price = parseFloat(night.price);
	          night.pristinePrice = night.price;
	        });
	        product.calendar = {
	          items: calendar
	        };
	        console.log("prodToAdded11:::", product);
	        console.log("teeeest", LastproductsAdded.length);
	        var suppExist = false;

	        product.calendar.items.map(function (r) {

	          var productSupp;
	          if (r.supplement != null) {
	            productSupp = Object.keys(r.supplement).map(function (key) {
	              return [Number(key), r.supplement[key]];
	            });
	          }
	          if (r.supplement != null && productSupp.length > 2) suppExist = true;
	        });
	        // if (suppExist==true) {

	        //   LastproductsAdded.push(r);
	        // }

	        if (suppExist = true) {
	          // console.log("suppExist:::",suppExist);

	          var productSupp = [];
	          product.calendar.items.map(function (rs) {
	            if (rs.supplement != null) {

	              productSupp = Object.entries(rs.supplement);
	              // console.log("productSupp:::", productSupp);

	              //productSupp= Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);
	            }
	          });
	          // console.log("productSupp:::",productSupp);
	          var productAdded = [];
	          if (productSupp.length) {
	            var i = 0;

	            productSupp.forEach(function (_ref) {
	              var _ref2 = _slicedToArray(_ref, 2),
	                  key = _ref2[0],
	                  value = _ref2[1];

	              ///  console.log("productSuppvalue[key, value]:::", value);

	              if (value != null & i > 1) {

	                var prdct = Object.assign({}, product);
	                prdct.age = key;
	                prdct.name = prdct.name + " " + key;
	                productAdded.push(prdct);
	                console.log("prdct.name:::", prdct.name);
	              }
	              i++;
	            });
	          }

	          if (productAdded.length) {
	            console.log("productAddedLength;:::", productAdded.length);
	            // console.log("productAddedLength;:::", productAdded);

	            for (var k = 0; k < productAdded.length; k++) {
	              var items = [];
	              for (var i = 0; i < productAdded[k].calendar.items.length; i++) {

	                // var productSuppitemi= Object.keys(res.data.items[i].supplement).map((key) => [Number(key), res.data.items[i].supplement[key]]);
	                //items[i]=res.data.items[i]
	                items[i] = Object.assign({}, productAdded[k].calendar.items[i]);
	                //  console.log("productAddedLengthINNN;:::");

	                var productSuppitemi;
	                var ageExist = false;
	                if (productAdded[k].calendar.items[i].supplement != null) {
	                  productSuppitemi = Object.entries(productAdded[k].calendar.items[i].supplement);

	                  productSuppitemi.forEach(function (_ref3) {
	                    var _ref4 = _slicedToArray(_ref3, 2),
	                        key = _ref4[0],
	                        value = _ref4[1];

	                    if (key === productAdded[k].age) {
	                      //    console.log("productAddedLengthINNNAGE;:::",value);
	                      //    console.log("productAddedLengthINNNAGEkey;:::",key);

	                      ageExist = true;
	                      //        console.log(" items[i].priceadd:Befor::", items[i].price);
	                      productAdded[k].calendar.items[i].price = parseFloat(value);
	                      //       console.log(" items[i].priceadd:::", items[i].price);

	                    }
	                    //  else {
	                    //   items[i].price=null;


	                    //  }
	                  });

	                  if (ageExist == false) {
	                    items[i].price = null;
	                  }
	                } else {
	                  items[i].price = null;
	                }
	              }
	              productAdded[k].items = items;
	              //vm.unit.sup.push(productAdded[k])
	              //products.push(productAdded[k]);
	              //vm.pdts.push(productAdded[k]);
	              //console.log("ppp:::",vm.pdts.length);
	            }
	          }

	          //       console.log("productAdded[k]:::::", productAdded);
	          //  LastproductsAdded=productAdded;
	          productAdded.map(function (prodToAdded) {
	            LastproductsAdded.push(prodToAdded);
	            //products.push(prodToAdded);
	            // vm.pdts.push(prodToAdded);
	            console.log("addtopdts:::", vm.pdts);
	            var productf = LastproductsAdded;
	            vm.pdts = productf;
	            vm.products.push(prodToAdded);
	            vm.unit.sp = vm.pdts.length;
	            pendingSupp.push(prodToAdded);
	            //  console.log("productAdded[k]prodToAdded:::::", prodToAdded);
	          });
	          //   const productf=LastproductsAdded;
	          //  vm.pdts=productf;   
	          //    console.log("teeeestpdts",vm.pdts);
	          // products.map(product=> {

	          //   console.log("productAdded[k]prodToAdded:::::", product);
	          //    })
	        }

	        // console.log("suppExist:::",suppExist);

	      });

	      //.then(() =>{ 
	      //  console.log("teeeest",LastproductsAdded.length);
	      //  vm.loading = false
	      // })
	      //const LastproductsAddedF=LastproductsAdded;
	      //       vm.pdts=LastproductsAddedF;

	    });
	    $q.all(LastproductsAdded).then(function () {
	      console.log("pendingSuppOK");
	      console.log("pendingSuppOKpendingSupp", pendingSupp.length);
	      vm.loadingsup = false;
	    });

	    // products.map(prodToAdded=> {
	    //   //pending.push(loadCalendar(prodToAdded, vm.period));
	    //   console.log("prodToAdded22:::",prodToAdded.calendar);

	    //   var suppExist = false;
	    //   prodToAdded.calendar.items.map(r => {

	    //             var productSupp;
	    //             if (r.supplement != null) {
	    //               productSupp = Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);

	    //             }
	    //             if (r.supplement != null && productSupp.length > 2) suppExist = true;


	    //           });
	    //           console.log("suppExist:::",suppExist);


	    // console.log("productAdded[k]prodToAdded:::::", productf);
	    //   //vm.products.push(prodAdded);
	    // })
	    //productsAdded

	    // console.log("LastproductsAdded:::",LastproductsAdded);
	    // vm.LastproductsAdded=LastproductsAdded;
	    // products=LastproductsAdded;


	    LastproductsAdded.map(function (prodAdded) {
	      products.push(prodAdded);
	      //console.log("ppp:::",prodAdded);

	      //return prodAdded;
	      //vm.products.push(prodAdded);
	    });
	    //  vm.unit.sp=vm.pdts;


	    // products.map(p=> {
	    // console.log("ppp:::",p);
	    // return p;
	    //   //vm.products.push(prodAdded);
	    // })
	    // vm.products=LastproductsAdded;


	    // products.map(prodToAdded=> {
	    //   //pending.push(loadCalendar(prodToAdded, vm.period));
	    //   console.log("prodToAdded:::",prodToAdded.calendar);

	    //   var suppExist = false;
	    //   prodToAdded.calendar.items.map(r => {
	    //             var productSupp;
	    //             if (r.supplement != null) {
	    //               productSupp = Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);

	    //             }
	    //             if (r.supplement != null && productSupp.length > 2) suppExist = true;


	    //           });
	    //           console.log("suppExist:::",suppExist);


	    //   //vm.products.push(prodAdded);
	    // })
	    console.log("vmvmvmloading:::", vm.loading);

	    // console.log("Lastproductsout:::",LastproductsAdded);

	    // console.log("vm.occupanciesout:::",vm.occupancies);
	    //vm.loading = false;
	  }

	  function findRecord(date, nights) {
	    return nights.find(function (n) {
	      return n.date === date.format('YYYY-MM-DD');
	    }) || {
	      date: date.format('YYYY-MM-DD')
	    };
	  }

	  function priceChanged(product, night) {
	    // tmp link TODO get ling from api
	    if (night.pristinePrice == night.price) {
	      return;
	    }
	    if (isNaN(night.price) || night.price < 0) {
	      night.price = night.pristinePrice;
	      return;
	    }

	    $http.post(apiUrl + '/commands/batch-update-rates', {
	      products: [product.code],
	      rates: [night.price],
	      periods: [{ start: night.date, end: night.date }]
	    }).then(function () {
	      $log.debug('night updated', night);
	      night.pristinePrice = night.price;
	    });
	  }
	  function onReqChanged(onReq, index, date) {

	    var onReqFrom = moment(onReq.from).format("YYYY-MM-DD");
	    var onReqTo = moment(onReq.to).format("YYYY-MM-DD");
	    var checkDate = moment(date).format("YYYY-MM-DD");

	    var oldoOnReq = {
	      code: onReq.code,
	      type: onReq.type,
	      typeCode: onReq.type_code,
	      description: onReq.description,
	      property: onReq.property,
	      debut: onReqFrom,
	      fin: onReqTo

	    };
	    var newOnReq = {
	      type: onReq.type,
	      typeCode: onReq.type_code,
	      description: onReq.description,
	      property: onReq.property,
	      debut: onReqFrom,
	      fin: onReqTo

	    };

	    if (vm.onRequestsExist[index].exist == true) {
	      vm.onRequestsExist[index].exist = false;
	      // if(date == stp.from || date == stp.to){   

	      if (checkDate == onReqFrom || checkDate == onReqTo) {
	        if (checkDate == onReqFrom && checkDate != onReqTo) {
	          oldoOnReq.debut = moment(onReqFrom, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");

	          onReqUpdate(oldoOnReq);
	          $state.reload();
	        }
	        if (checkDate == onReqTo && checkDate != onReqFrom) {

	          oldoOnReq.fin = moment(onReqTo, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD");
	          console.log("first or last day):", oldoOnReq.fin);
	          console.log("moment first or last day):", moment(onReqTo, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD"));
	          onReqUpdate(oldoOnReq);
	          $state.reload();
	        }
	        if (checkDate == onReqTo && checkDate == onReqFrom) {
	          remove(oldoOnReq);
	        }
	        //  put oldStop;

	        init();
	        console.log("first or last day):");
	      } else {

	        oldoOnReq.fin = moment(checkDate, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD");
	        var newOnReq2 = {
	          type: "Unit",
	          typeCode: vm.unit.code,
	          description: "En demande",
	          property: vm.property.property.code,
	          debut: moment(checkDate, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD"),
	          fin: onReqTo
	          // newStop.debut=moment(checkDate,"YYYY-MM-DD").add(1,'days').format("YYYY-MM-DD")
	        };onReqUpdate(oldoOnReq);
	        postOnReq(newOnReq2).then($state.reload());
	        init();
	      }
	    } else {
	      var newOnReq1 = {

	        type: "Unit",
	        typeCode: vm.unit.code,
	        description: "En demande",
	        property: vm.property.property.code,
	        debut: moment(checkDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
	        fin: moment(checkDate, "YYYY-MM-DD").format("YYYY-MM-DD")
	      };
	      console.log("newOnReq1):", newOnReq1);

	      vm.onRequestsExist[index].exist = true;
	      postOnReq(newOnReq1).then($state.reload());;
	      init();
	    }

	    if (vm.onRequestsExist[index].exist == true) {
	      vm.onRequestsExist[index].exist = false;
	    } else vm.onRequestsExist[index].exist = true;
	    //   var originalTo=stp.to;
	    // console.log("originalTo:",originalTo)
	    console.log("dateTo:", date);
	    console.log("index:", index);
	  }

	  function postOnReq(onReq) {
	    $log.debug('link', vm.property.property.links);

	    //var href = "http://beds-api.fractalite.com/properties/2/stop-sales";
	    console.log("onReq):", onReq);

	    return $http.post(vm.property.property.links["on-requests"].href, onReq).then(function (res) {
	      $log.debug('created', res.data);
	      //  $scope.$emit("stopsalesAdded",res.data);
	    }, function () {
	      $log.error(arguments);
	      // return $q.reject()
	    });
	    //  .then(() => $state.reload());
	  }

	  function onReqUpdate(onReq) {
	    var promise;

	    console.log("onReq", onReq);
	    promise = $http({
	      method: "PUT",
	      url: vm.property.property.links["on-requests"].href + "/" + onReq.code,
	      headers: {
	        "Content-Language": "**"
	      },
	      data: _.pick(onReq, ['code', 'type', 'description', 'type_code', 'debut', 'fin', 'property', 'status'])
	    });
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	    //.then(() => $state.reload());;
	  }
	  function remove(onReq) {

	    console.log("remove):", onReq);

	    $http.delete(vm.property.property.links["on-requests"].href + "/" + onReq.code).then(function () {
	      return $state.reload();
	    });
	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }

	  function loadCalendarSupplement(product, period) {
	    $http.get(product.links.calendar.href, {
	      params: {
	        $sort: 'date<',
	        start: period.start.format('YYYY-MM-DD'),
	        end: period.end.format('YYYY-MM-DD')
	      }
	    }).then(function (res) {
	      var nightsToShow = period.end.diff(period.start, 'days');
	      var calendar = [];
	      var nights = res.data.items;
	      $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	      if (nights.length !== nightsToShow) {
	        // returned calendar can have holes, make sure we fill them
	        var date = moment(period.start);
	        var i = 0;
	        while (i < nightsToShow) {
	          var rec = findRecord(date, nights);
	          //reviveCancellation(rec);
	          calendar.push(rec);
	          date.add(1, 'days');
	          i++;
	        }
	      } else {
	        calendar = nights;
	      }
	      calendar.forEach(function (night) {
	        night.price = parseFloat(night.price);
	        night.pristinePrice = night.price;
	      });
	      product.calendar = {
	        items: calendar
	      };
	    });
	  }
	  /*
	         const cancellationLabels = {
	        "999%100":"NRF",
	        "0%0":"Gratuite"
	      }
	        function reviveCancellation(rec) {
	          $log.debug(rec);
	          if (!rec.cancellation) return;
	             const hash = rec.cancellation.join('/');
	             $log.debug(hash);
	             if (!cancellationLabels[hash]) {
	            cancellationLabels[hash] = formatCancellation(rec.cancellation);
	          }
	          rec.cancellationLabel =  cancellationLabels[hash];
	        }
	           function formatCancellation(rules) {
	          return 'custom';
	        }
	     */
	}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	UnitStopsalesTableRoomCtrl.$inject = ["$window", "$scope", "$state", "User", "$log", "$q", "$http", "moment", "apiUrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var moment = __webpack_require__(10);

	exports.default = {
	  name: 'unitStopsalesTableRoom',
	  controller: UnitStopsalesTableRoomCtrl,
	  templateUrl: 'app/yield/property-table-room/unit-stopSales/template.html',
	  bindings: {
	    unit: '<',
	    rateBases: '<',
	    boards: '<',
	    period: '<',
	    selectedProduct: '<',
	    selectedBoards: '<',
	    selectedRoom: '<',
	    occupancies: '<',
	    boardss: '<',
	    property: '<',
	    stopSales: '<',
	    onRequests: '<'

	  }
	};


	function UnitStopsalesTableRoomCtrl($window, $scope, $state, User, $log, $q, $http, moment, apiUrl) {
	  "ngInject";

	  var vm = this;

	  vm.$onChanges = function (changes) {
	    console.log("change00::", changes);

	    //console.log("change00vm.selectedProduct::",vm.selectedProduct);
	    init();

	    if (!changes.hasOwnProperty('period')) return;
	    if (changes.period.isFirstChange()) {
	      init();
	    } else {
	      init();
	      //reloadCalendars(vm.period);
	    }
	  };

	  vm.priceChanged = priceChanged;
	  vm.stopChanged = stopChanged;
	  vm.updatePeriod = updatePeriod;

	  function init() {
	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });
	    vm.unitSelected = vm.selectedRoom;
	    console.log("vm.unitSelected;:", vm.unitSelected);
	    console.log("propertyCtrlpropertyCtrl0:", vm.unit.links);
	    console.log("propertyCtrlpropertyCtrl0Code:", vm.unit.code);
	    if (vm.unitSelected != undefined && vm.unitSelected != -1) {
	      localStorage.setItem("unit", vm.unit.code);
	    }if (vm.unitSelected == -1) {
	      localStorage.removeItem("unit");
	    }
	    console.log("localStorageunit:", localStorage.getItem("unit"));

	    console.log("propertyCtrlpropertyCtrl0:", vm.property.property);
	    console.log("stopSalesstopSales:", vm.stopSales);
	    console.log("stopPeriod:", vm.period);
	    console.log("onRequestsonRequests00:", vm.onRequests);
	    //console.log("change00onRequests::", JSON.stringify(vm.onRequests));
	    //console.log("change00onRequests1::");


	    // console.log("vm.productssOccup::::",productssOccup);
	    vm.stopSalesExist = [];
	    vm.onRequestExist = [];

	    //vm.pdtss;
	    vm.unit.occupancies = [];
	    var pending = [];
	    var LastproductsAdded = [];
	    var stopSalesFiltred = [];
	    vm.loading = true;
	    //  vm.stopsaless=[];
	    // const p4 = vm.property.get('stop-sales')
	    //         .then(stpsales => {

	    //           //  console.log("propertyCtrlpropertyCtrl22:",stpsales);
	    //             vm.stpsales = stpsales});

	    //             console.log("propertyCtrlpropertyCtrl22:",vm.stpsale);


	    vm.ready =

	    // $http.get(vm.property.property.links["stop-sales"].href , {
	    //     headers: {
	    //       'accept-language': ''
	    //     }
	    //   })
	    //   .then(res => {
	    //     $log.debug('stopsales loaded', res.data);
	    //     console.log("propertyCtrlpropertyCtrl22:",res.data);
	    //     res.data.items.map(stop =>{ 
	    //         console.log("pushstp",stop);


	    //           vm.stopsaless.push(stop);
	    //           console.log("pushstpstopsaless",vm.stopsaless);


	    //        });
	    //        console.log("pushstpstopsalessLength",vm.stopsaless.length);
	    //   //  vm.stopsaless = res.data.items;
	    //     //vm.discount = discountsHelper.parse(res.data);
	    //   }, () => {
	    //     $log.debug('error loading stopsales', arguments);
	    //   });;
	    //$q.all(pending).then(() => vm.loading = false);

	    vm.period.dates.map(function (date) {

	      var stpsls = {
	        "date": date,
	        "exist": false

	      };

	      vm.stopSalesExist.push(stpsls);
	      vm.onRequestExist.push(stpsls);
	    });
	    console.log("vm.stopSales:", vm.stopSales);

	    checkStopSales();
	    //  checkOnRequests();
	    // console.log("vm.vm.productslaast::::",vm.products);
	  }

	  function checkStopSales() {
	    // console.log("checkStopSales:",vm.stopsaless);
	    console.log("aaaaaaproperty", vm.property.property);

	    vm.property.get('stop-sales').then(function (collection) {
	      //vm.stopSales = collection.items.map(u => angular.copy(u));
	      console.log("aaaaaa", vm.stopSales);
	    });
	    var StopF = [];
	    console.log("pushstpstopsalessLength2", vm.stopSales);
	    console.log("vm.stopSalesunit:", vm.unit);
	    StopF = vm.stopSales.filter(function (stop) {
	      return stop.type == 'Unit';
	    });
	    vm.stopSalesFiltred = StopF.filter(function (stop) {
	      return stop.typeCode == vm.unit.code;
	    });

	    console.log("vm.stopSalesAfterFilter", vm.stopSalesFiltred);
	    console.log("vm.stopSalesExistBefore:", vm.stopSalesExist);

	    vm.stopSalesExist.map(function (stop) {

	      vm.stopSalesFiltred.map(function (stpF) {
	        console.log("infilter", stpF.status);
	        console.log("infilter2", stop.date);
	        console.log("stop.date::", Date.parse(stop.date));
	        console.log("stop.date:::", Date.parse(moment(stop.date, "YYYY-MM-DD").format("YYYY-MM-DD")));
	        //  && Date.parse(stpF.date) <= Date.parse(stop.fin)
	        console.log("stop.date:::", moment(stop.date, "YYYY-MM-DD").format("YYYY-MM-DD"));
	        console.log("stop.date:::", Date.parse(stpF.debut));

	        //if( Date.parse(stpF.debut) <= Date.parse(stop.date)  && Date.parse(stop.date) <= Date.parse(stpF.fin) ) {
	        //   if( Date.parse(stpF.debut) <=  moment(Date.parse(stop.date)).add(2,'hours')  && Date.parse(stop.date) <= Date.parse(stpF.fin) ) {
	        if (Date.parse(stpF.debut) <= Date.parse(moment(stop.date, "YYYY-MM-DD").format("YYYY-MM-DD")) && Date.parse(moment(stop.date, "YYYY-MM-DD").format("YYYY-MM-DD")) <= Date.parse(stpF.fin)) {
	          // Date.parse(moment(Date.parse(stop.date),"YYYY-MM-DD").format("YYYY-MM-DD"))
	          //&& stpF.status == true) {
	          console.log("vm.stopSalesAfterFilteryees");
	          console.log("stop.date::", moment(stop.date, "YYYY-MM-DD").format("YYYY-MM-DD"));
	          console.log("Date.parse(stpF.debut)::", stpF.debut);
	          console.log("stop.date::", Date.parse(moment(Date.parse(stop.date), "YYYY-MM-DD").format("YYYY-MM-DD")));
	          console.log("Date.parse(stpF.debut)::", Date.parse(stpF.debut));
	          // console.log("vm.stopSalesAfterFilteryeescode",stpF.code);
	          // console.log("vm.stopSalesAfterFilteryeesdebut",stpF.debut);
	          // console.log("vm.stopSalesAfterFilteryeesfin",stpF.fin);

	          stop.exist = true;
	          stop.code = stpF.code;
	          stop.from = stpF.debut;
	          stop.to = stpF.fin;
	        }
	      });
	    });
	    console.log("vm.stopSalesExistAfter:", vm.stopSalesExist);
	  }

	  function checkOnRequests() {
	    // console.log("checkStopSales:",vm.stopsaless);
	    var onReqF = [];
	    console.log("checkOnRequests", vm.requests);
	    onReqF = vm.requests.filter(function (req) {
	      return req.type == 'Unit';
	    });
	    console.log("checkOnRequestsonReqF", vm.requests);

	    vm.onRequestsFiltred = onReqF.filter(function (req) {
	      return req.typeCode == vm.unit.code;
	    });
	    console.log("vm.onRequestsFiltred:", vm.onRequestsFiltred);

	    vm.onRequestsExist.map(function (onReq) {

	      vm.onRequestsFiltred.map(function (onReqF) {

	        //  && Date.parse(stpF.date) <= Date.parse(stop.fin)
	        if (Date.parse(onReqF.debut) <= Date.parse(onReq.date) && Date.parse(onReq.date) <= Date.parse(onReqF.fin)) {
	          console.log("vm.onRequestsFiltredyees");
	          onReq.exist = true;
	          // console.log("vm.onReqonReq:",onReq);
	        }
	      });
	    });
	    console.log("vm.onRequestsExist:", vm.onRequestsExist);
	  }

	  function reloadCalendars(period) {
	    vm.loading = true;
	    var promises = vm.products.map(function (product) {
	      return loadCalendar(product, period);
	    });
	    $q.all(promises).then(function () {
	      return vm.loading = false;
	    }, function () {
	      vm.loading = false;
	      vm.error = "Error loading rates";
	    });
	  }

	  function updatePeriod(date) {
	    $log.debug('update period');
	    console.log("update period");

	    vm.period = parsePeriod(date);
	    //  vm.selectedProduct=vm.selectedProduct0;
	  }
	  function parsePeriod(startDate) {
	    var start = moment(startDate).startOf('day');
	    var end = moment(start).add(31, 'days');
	    var dates = [];
	    var date = moment(start);
	    while (dates.length < 31) {
	      dates.push(date.toDate());
	      date.add(1, 'days');
	    }
	    init();
	    return {
	      selectedProduct: vm.selectedProduct0,
	      start: start,
	      end: end,
	      dates: dates
	    };
	  }

	  function loadCalendar(product, period, _callback) {
	    $http.get(product.links.calendar.href, {
	      params: {
	        $sort: 'date<',
	        start: period.start.format('YYYY-MM-DD'),
	        end: period.end.format('YYYY-MM-DD')
	      }
	    }).then(function (res) {
	      var nightsToShow = period.end.diff(period.start, 'days');
	      var calendar = [];
	      var nights = res.data.items;
	      $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	      if (nights.length !== nightsToShow) {
	        // returned calendar can have holes, make sure we fill them
	        var date = moment(period.start);
	        var i = 0;
	        while (i < nightsToShow) {
	          var rec = findRecord(date, nights);
	          //reviveCancellation(rec);
	          calendar.push(rec);
	          date.add(1, 'days');
	          i++;
	        }
	      } else {
	        calendar = nights;
	      }
	      calendar.forEach(function (night) {
	        night.price = parseFloat(night.price);
	        night.pristinePrice = night.price;
	      });
	      product.calendar = {
	        items: calendar
	      };
	    });

	    //_callback();
	  }

	  function loadCalendarSupp(products, period, LastproductsAdded, vmproducts) {
	    vm.loadingsup = true;
	    // var LastproductsAdded=[];
	    //  vm.pdts=products; 
	    // console.log("inloadCalendarSuppProduct",products)
	    var pendingSupp = [];
	    var promises = products.map(function (product) {

	      console.log("prodToAdded1100:::", product);

	      $http.get(product.links.calendar.href, {
	        params: {
	          $sort: 'date<',
	          start: period.start.format('YYYY-MM-DD'),
	          end: period.end.format('YYYY-MM-DD')
	        }
	      }).then(function (res) {
	        var nightsToShow = period.end.diff(period.start, 'days');
	        var calendar = [];
	        var nights = res.data.items;
	        $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	        if (nights.length !== nightsToShow) {
	          // returned calendar can have holes, make sure we fill them
	          var date = moment(period.start);
	          var i = 0;
	          while (i < nightsToShow) {
	            var rec = findRecord(date, nights);
	            //reviveCancellation(rec);
	            calendar.push(rec);
	            date.add(1, 'days');
	            i++;
	          }
	        } else {
	          calendar = nights;
	        }
	        calendar.forEach(function (night) {
	          night.price = parseFloat(night.price);
	          night.pristinePrice = night.price;
	        });
	        product.calendar = {
	          items: calendar
	        };
	        console.log("prodToAdded11:::", product);
	        console.log("teeeest", LastproductsAdded.length);
	        var suppExist = false;

	        product.calendar.items.map(function (r) {

	          var productSupp;
	          if (r.supplement != null) {
	            productSupp = Object.keys(r.supplement).map(function (key) {
	              return [Number(key), r.supplement[key]];
	            });
	          }
	          if (r.supplement != null && productSupp.length > 2) suppExist = true;
	        });
	        // if (suppExist==true) {

	        //   LastproductsAdded.push(r);
	        // }

	        if (suppExist = true) {
	          // console.log("suppExist:::",suppExist);

	          var productSupp = [];
	          product.calendar.items.map(function (rs) {
	            if (rs.supplement != null) {

	              productSupp = Object.entries(rs.supplement);
	              // console.log("productSupp:::", productSupp);

	              //productSupp= Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);
	            }
	          });
	          // console.log("productSupp:::",productSupp);
	          var productAdded = [];
	          if (productSupp.length) {
	            var i = 0;

	            productSupp.forEach(function (_ref) {
	              var _ref2 = _slicedToArray(_ref, 2),
	                  key = _ref2[0],
	                  value = _ref2[1];

	              ///  console.log("productSuppvalue[key, value]:::", value);

	              if (value != null & i > 1) {

	                var prdct = Object.assign({}, product);
	                prdct.age = key;
	                prdct.name = prdct.name + " " + key;
	                productAdded.push(prdct);
	                console.log("prdct.name:::", prdct.name);
	              }
	              i++;
	            });
	          }

	          if (productAdded.length) {
	            console.log("productAddedLength;:::", productAdded.length);
	            // console.log("productAddedLength;:::", productAdded);

	            for (var k = 0; k < productAdded.length; k++) {
	              var items = [];
	              for (var i = 0; i < productAdded[k].calendar.items.length; i++) {

	                // var productSuppitemi= Object.keys(res.data.items[i].supplement).map((key) => [Number(key), res.data.items[i].supplement[key]]);
	                //items[i]=res.data.items[i]
	                items[i] = Object.assign({}, productAdded[k].calendar.items[i]);
	                //  console.log("productAddedLengthINNN;:::");

	                var productSuppitemi;
	                var ageExist = false;
	                if (productAdded[k].calendar.items[i].supplement != null) {
	                  productSuppitemi = Object.entries(productAdded[k].calendar.items[i].supplement);

	                  productSuppitemi.forEach(function (_ref3) {
	                    var _ref4 = _slicedToArray(_ref3, 2),
	                        key = _ref4[0],
	                        value = _ref4[1];

	                    if (key === productAdded[k].age) {
	                      //    console.log("productAddedLengthINNNAGE;:::",value);
	                      //    console.log("productAddedLengthINNNAGEkey;:::",key);

	                      ageExist = true;
	                      //        console.log(" items[i].priceadd:Befor::", items[i].price);
	                      productAdded[k].calendar.items[i].price = parseFloat(value);
	                      //       console.log(" items[i].priceadd:::", items[i].price);

	                    }
	                    //  else {
	                    //   items[i].price=null;


	                    //  }
	                  });

	                  if (ageExist == false) {
	                    items[i].price = null;
	                  }
	                } else {
	                  items[i].price = null;
	                }
	              }
	              productAdded[k].items = items;
	              //vm.unit.sup.push(productAdded[k])
	              //products.push(productAdded[k]);
	              //vm.pdts.push(productAdded[k]);
	              //console.log("ppp:::",vm.pdts.length);
	            }
	          }

	          //       console.log("productAdded[k]:::::", productAdded);
	          //  LastproductsAdded=productAdded;
	          productAdded.map(function (prodToAdded) {
	            LastproductsAdded.push(prodToAdded);
	            //products.push(prodToAdded);
	            // vm.pdts.push(prodToAdded);
	            console.log("addtopdts:::", vm.pdts);
	            var productf = LastproductsAdded;
	            vm.pdts = productf;
	            vm.products.push(prodToAdded);
	            vm.unit.sp = vm.pdts.length;
	            pendingSupp.push(prodToAdded);
	            //  console.log("productAdded[k]prodToAdded:::::", prodToAdded);
	          });
	          //   const productf=LastproductsAdded;
	          //  vm.pdts=productf;   
	          //    console.log("teeeestpdts",vm.pdts);
	          // products.map(product=> {

	          //   console.log("productAdded[k]prodToAdded:::::", product);
	          //    })
	        }

	        // console.log("suppExist:::",suppExist);

	      });

	      //.then(() =>{ 
	      //  console.log("teeeest",LastproductsAdded.length);
	      //  vm.loading = false
	      // })
	      //const LastproductsAddedF=LastproductsAdded;
	      //       vm.pdts=LastproductsAddedF;

	    });
	    $q.all(LastproductsAdded).then(function () {
	      console.log("pendingSuppOK");
	      console.log("pendingSuppOKpendingSupp", pendingSupp.length);
	      vm.loadingsup = false;
	    });

	    // products.map(prodToAdded=> {
	    //   //pending.push(loadCalendar(prodToAdded, vm.period));
	    //   console.log("prodToAdded22:::",prodToAdded.calendar);

	    //   var suppExist = false;
	    //   prodToAdded.calendar.items.map(r => {

	    //             var productSupp;
	    //             if (r.supplement != null) {
	    //               productSupp = Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);

	    //             }
	    //             if (r.supplement != null && productSupp.length > 2) suppExist = true;


	    //           });
	    //           console.log("suppExist:::",suppExist);


	    // console.log("productAdded[k]prodToAdded:::::", productf);
	    //   //vm.products.push(prodAdded);
	    // })
	    //productsAdded

	    // console.log("LastproductsAdded:::",LastproductsAdded);
	    // vm.LastproductsAdded=LastproductsAdded;
	    // products=LastproductsAdded;


	    LastproductsAdded.map(function (prodAdded) {
	      products.push(prodAdded);
	      //console.log("ppp:::",prodAdded);

	      //return prodAdded;
	      //vm.products.push(prodAdded);
	    });
	    //  vm.unit.sp=vm.pdts;


	    // products.map(p=> {
	    // console.log("ppp:::",p);
	    // return p;
	    //   //vm.products.push(prodAdded);
	    // })
	    // vm.products=LastproductsAdded;


	    // products.map(prodToAdded=> {
	    //   //pending.push(loadCalendar(prodToAdded, vm.period));
	    //   console.log("prodToAdded:::",prodToAdded.calendar);

	    //   var suppExist = false;
	    //   prodToAdded.calendar.items.map(r => {
	    //             var productSupp;
	    //             if (r.supplement != null) {
	    //               productSupp = Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);

	    //             }
	    //             if (r.supplement != null && productSupp.length > 2) suppExist = true;


	    //           });
	    //           console.log("suppExist:::",suppExist);


	    //   //vm.products.push(prodAdded);
	    // })
	    console.log("vmvmvmloading:::", vm.loading);

	    // console.log("Lastproductsout:::",LastproductsAdded);

	    // console.log("vm.occupanciesout:::",vm.occupancies);
	    //vm.loading = false;
	  }

	  function findRecord(date, nights) {
	    return nights.find(function (n) {
	      return n.date === date.format('YYYY-MM-DD');
	    }) || {
	      date: date.format('YYYY-MM-DD')
	    };
	  }

	  function priceChanged(product, night) {
	    // tmp link TODO get ling from api
	    if (night.pristinePrice == night.price) {
	      return;
	    }
	    if (isNaN(night.price) || night.price < 0) {
	      night.price = night.pristinePrice;
	      return;
	    }

	    $http.post(apiUrl + '/commands/batch-update-rates', {
	      products: [product.code],
	      rates: [night.price],
	      periods: [{ start: night.date, end: night.date }]
	    }).then(function () {
	      $log.debug('night updated', night);
	      night.pristinePrice = night.price;
	    });
	  }

	  //     function stopChanged(stp,date){
	  function stopChanged(stp, index, date) {
	    var stpFrom = moment(stp.from).format("YYYY-MM-DD");
	    var stpTo = moment(stp.to).format("YYYY-MM-DD");
	    var checkDate = moment(date).format("YYYY-MM-DD");

	    var oldStop = {
	      code: stp.code,
	      type: stp.type,
	      typeCode: stp.type_code,
	      description: stp.description,
	      property: stp.property,
	      debut: stpFrom,
	      fin: stpTo

	    };
	    var newStop = {
	      type: stp.type,
	      typeCode: stp.type_code,
	      description: stp.description,
	      property: stp.property,
	      debut: stpFrom,
	      fin: stpTo

	    };
	    if (vm.stopSalesExist[index].exist == true) {
	      vm.stopSalesExist[index].exist = false;
	      // if(date == stp.from || date == stp.to){   

	      if (checkDate == stpFrom || checkDate == stpTo) {
	        if (checkDate == stpFrom && checkDate != stpTo) {
	          oldStop.debut = moment(stpFrom, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");

	          stopSalesUpdate(oldStop);
	          //updatePeriod( vm.period) 
	          // $window.location.reload()
	          $state.reload();
	          // init();
	        }
	        if (checkDate == stpTo && checkDate != stpFrom) {

	          oldStop.fin = moment(stpTo, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD");
	          console.log("first or last day):", oldStop.fin);
	          console.log("moment first or last day):", moment(stpTo, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD"));
	          stopSalesUpdate(oldStop);
	          //updatePeriod( vm.period) 
	          //$window.location.reload()
	          $state.reload();
	          // init();
	        }
	        if (checkDate == stpTo && checkDate == stpFrom) {
	          remove(oldStop);
	          //updatePeriod( vm.period) 
	          //init();
	        }
	        //  put oldStop;

	        //init()
	        console.log("first or last day):");
	      } else {

	        oldStop.fin = moment(checkDate, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD");
	        var newStop2 = {
	          type: "Unit",
	          typeCode: vm.unit.code,
	          description: "Stop Sales",
	          property: vm.property.property.code,
	          debut: moment(checkDate, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD"),
	          fin: stpTo
	          // newStop.debut=moment(checkDate,"YYYY-MM-DD").add(1,'days').format("YYYY-MM-DD")
	        };stopSalesUpdate(oldStop);
	        postStopSales(newStop2).then($state.reload());
	        //updatePeriod( vm.period)
	        //.then($state.reload());
	        //.then($window.location.reload());
	        //.then($state.reload());
	        //   init()
	      }
	    } else {
	      var newStop1 = {

	        type: "Unit",
	        typeCode: vm.unit.code,
	        description: "Stop Sales",
	        property: vm.property.property.code,
	        debut: moment(checkDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
	        fin: moment(checkDate, "YYYY-MM-DD").format("YYYY-MM-DD")
	      };
	      console.log("newStop1):", newStop1);

	      vm.stopSalesExist[index].exist = true;
	      postStopSales(newStop1)
	      // .then($state.reload());
	      //  updatePeriod( vm.period)
	      //.then($window.location.reload());
	      .then($state.reload());;
	      // init()
	    }

	    //  var originalTo=stp.to;
	    //  console.log("originalTo:",originalTo)
	    //  console.log("originalfrom:",stp.from)
	    //  console.log("moment(stp.from):",moment(stp.from).format("YYYY-MM-DD"))
	    //  console.log("moment(stp.to):",Date.parse(stp.to))
	    //  console.log("moment(date):",moment(date).format("YYYY-MM-DD"))
	    //  console.log("stpcode:",stp.code)
	    //  console.log("dateTo:",date)
	    //  console.log("vm.stopSalesExist[index].exist:",vm.stopSalesExist[index].exist)
	    //  console.log("index:",index)
	    //  init();

	  }
	  function postStopSales(stopsales) {
	    $log.debug('link', vm.property.property.links);

	    //var href = "http://beds-api.fractalite.com/properties/2/stop-sales";
	    console.log("stopsales):", stopsales);

	    return $http.post(vm.property.property.links["stop-sales"].href, stopsales).then(function (res) {
	      $log.debug('created', res.data);
	      //  $scope.$emit("stopsalesAdded",res.data);
	    }, function () {
	      $log.error(arguments);
	      // return $q.reject()
	    });
	    //  .then(() => $state.reload());
	  }

	  function stopSalesUpdate(stopsales) {
	    var promise;

	    console.log("ss", stopsales);
	    promise = $http({
	      method: "PUT",
	      url: vm.property.property.links["stop-sales"].href + "/" + stopsales.code,
	      headers: {
	        "Content-Language": "**"
	      },
	      data: _.pick(stopsales, ['code', 'type', 'description', 'type_code', 'debut', 'fin', 'property', 'status'])
	    });
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed).then(function () {
	      return $state.reload();
	    });;
	  }
	  function remove(stopsales) {

	    console.log("remove):", stopsales);

	    $http.delete(vm.property.property.links["stop-sales"].href + "/" + stopsales.code).then(function () {
	      return $state.reload();
	    });
	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }

	  function loadCalendarSupplement(product, period) {
	    $http.get(product.links.calendar.href, {
	      params: {
	        $sort: 'date<',
	        start: period.start.format('YYYY-MM-DD'),
	        end: period.end.format('YYYY-MM-DD')
	      }
	    }).then(function (res) {
	      var nightsToShow = period.end.diff(period.start, 'days');
	      var calendar = [];
	      var nights = res.data.items;
	      $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	      if (nights.length !== nightsToShow) {
	        // returned calendar can have holes, make sure we fill them
	        var date = moment(period.start);
	        var i = 0;
	        while (i < nightsToShow) {
	          var rec = findRecord(date, nights);
	          //reviveCancellation(rec);
	          calendar.push(rec);
	          date.add(1, 'days');
	          i++;
	        }
	      } else {
	        calendar = nights;
	      }
	      calendar.forEach(function (night) {
	        night.price = parseFloat(night.price);
	        night.pristinePrice = night.price;
	      });
	      product.calendar = {
	        items: calendar
	      };
	    });
	  }
	  /*
	         const cancellationLabels = {
	        "999%100":"NRF",
	        "0%0":"Gratuite"
	      }
	        function reviveCancellation(rec) {
	          $log.debug(rec);
	          if (!rec.cancellation) return;
	             const hash = rec.cancellation.join('/');
	             $log.debug(hash);
	             if (!cancellationLabels[hash]) {
	            cancellationLabels[hash] = formatCancellation(rec.cancellation);
	          }
	          rec.cancellationLabel =  cancellationLabels[hash];
	        }
	           function formatCancellation(rules) {
	          return 'custom';
	        }
	     */
	}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	'use strict';

	UnitOnrequestsTableRoomCtrl.$inject = ["$state", "$stateParams", "User", "$log", "$q", "$http", "moment", "apiUrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	exports.default = {
	  name: 'unitOnrequestsTableRoom',
	  controller: UnitOnrequestsTableRoomCtrl,
	  templateUrl: 'app/yield/property-table-room/unit-requests/template.html',
	  bindings: {
	    unit: '<',
	    rateBases: '<',
	    boards: '<',
	    period: '<',
	    selectedProduct: '<',
	    selectedBoards: '<',
	    occupancies: '<',
	    boardss: '<',
	    property: '<',
	    onRequests: '<'

	  }
	};


	function UnitOnrequestsTableRoomCtrl($state, $stateParams, User, $log, $q, $http, moment, apiUrl) {
	  "ngInject";

	  var vm = this;

	  vm.$onChanges = function (changes) {
	    console.log("change007::", changes);

	    //console.log("change00vm.selectedProduct::",vm.selectedProduct);
	    init();

	    if (!changes.hasOwnProperty('period')) return;
	    if (changes.period.isFirstChange()) {
	      init();
	    } else {
	      //reloadCalendars(vm.period);
	      init();
	    }
	  };

	  vm.priceChanged = priceChanged;
	  vm.onReqChanged = onReqChanged;

	  function init() {

	    User.realm_access.roles.map(function (role) {
	      if (role === 'contracting') {
	        vm.permissionsContracting = true;
	        console.log("role true");
	      }
	      console.log("role ::", role);
	    });
	    console.log("unitOnrequestsTable:", vm.onRequests);

	    console.log("propertyCtrlpropertyCtrl0:", vm.unit.links);
	    console.log("propertyCtrlpropertyCtrl0:", vm.property.property);

	    console.log("stopPeriod:", vm.period);
	    console.log("localstorage: ", localStorage.getItem("date"));
	    console.log("localstoragedateStart: ", localStorage.getItem("dateStart"));

	    console.log("onRequestsonRequests00:", vm.onRequests);
	    //console.log("change00onRequests::", JSON.stringify(vm.onRequests));
	    //console.log("change00onRequests1::");


	    // console.log("vm.productssOccup::::",productssOccup);
	    vm.onRequestsExist = [];

	    //vm.pdtss;
	    vm.unit.occupancies = [];
	    var pending = [];
	    var LastproductsAdded = [];
	    vm.loading = true;
	    //  vm.stopsaless=[];
	    // const p4 = vm.property.get('stop-sales')
	    //         .then(stpsales => {

	    //           //  console.log("propertyCtrlpropertyCtrl22:",stpsales);
	    //             vm.stpsales = stpsales});

	    //             console.log("propertyCtrlpropertyCtrl22:",vm.stpsale);


	    vm.ready =

	    // $http.get(vm.property.property.links["stop-sales"].href , {
	    //     headers: {
	    //       'accept-language': ''
	    //     }
	    //   })
	    //   .then(res => {
	    //     $log.debug('stopsales loaded', res.data);
	    //     console.log("propertyCtrlpropertyCtrl22:",res.data);
	    //     res.data.items.map(stop =>{ 
	    //         console.log("pushstp",stop);


	    //           vm.stopsaless.push(stop);
	    //           console.log("pushstpstopsaless",vm.stopsaless);


	    //        });
	    //        console.log("pushstpstopsalessLength",vm.stopsaless.length);
	    //   //  vm.stopsaless = res.data.items;
	    //     //vm.discount = discountsHelper.parse(res.data);
	    //   }, () => {
	    //     $log.debug('error loading stopsales', arguments);
	    //   });;
	    //$q.all(pending).then(() => vm.loading = false);

	    vm.period.dates.map(function (date) {

	      var stpsls = {
	        "date": date,
	        "exist": false

	      };

	      vm.onRequestsExist.push(stpsls);
	    });
	    console.log("vm.stopSales:", vm.stopSales);

	    checkOnRequests();
	    // console.log("vm.vm.productslaast::::",vm.products);
	  }

	  function checkOnRequests() {
	    // console.log("checkStopSales:",vm.stopsaless);
	    var onReqF = [];
	    console.log("checkOnRequests", vm.onRequests);
	    onReqF = vm.onRequests.filter(function (req) {
	      return req.type == 'Unit';
	    });
	    console.log("checkOnRequestsonReqF", onReqF);

	    vm.onRequestsFiltred = onReqF.filter(function (req) {
	      return req.typeCode == vm.unit.code;
	    });
	    console.log("vm.onRequestsFiltred:", vm.onRequestsFiltred);

	    vm.onRequestsExist.map(function (onReq) {

	      vm.onRequestsFiltred.map(function (onReqF) {

	        console.log("vm.onRequestsFiltred");

	        //  && Date.parse(stpF.date) <= Date.parse(stop.fin)moment(Date.parse(onReq.date))
	        //if( Date.parse(onReqF.debut) <= moment(Date.parse(onReq.date)).add(2,'hours') && Date.parse(onReq.date) <= Date.parse(onReqF.fin)) {
	        if (Date.parse(onReqF.debut) <= Date.parse(moment(onReq.date, "YYYY-MM-DD").format("YYYY-MM-DD")) && Date.parse(moment(onReq.date, "YYYY-MM-DD").format("YYYY-MM-DD")) <= Date.parse(onReqF.fin)) {

	          console.log("vm.onRequestsFiltredyees");
	          onReq.exist = true;
	          onReq.code = onReqF.code;
	          onReq.from = onReqF.debut;
	          onReq.to = onReqF.fin;

	          // console.log("vm.onReqonReq:",onReq);
	        }
	      });
	    });
	    console.log("vm.onRequestsExist:", vm.onRequestsExist);
	  }

	  function reloadCalendars(period) {
	    vm.loading = true;
	    var promises = vm.products.map(function (product) {
	      return loadCalendar(product, period);
	    });
	    $q.all(promises).then(function () {
	      return vm.loading = false;
	    }, function () {
	      vm.loading = false;
	      vm.error = "Error loading rates";
	    });
	  }

	  function loadCalendar(product, period, _callback) {
	    $http.get(product.links.calendar.href, {
	      params: {
	        $sort: 'date<',
	        start: period.start.format('YYYY-MM-DD'),
	        end: period.end.format('YYYY-MM-DD')
	      }
	    }).then(function (res) {
	      var nightsToShow = period.end.diff(period.start, 'days');
	      var calendar = [];
	      var nights = res.data.items;
	      $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	      if (nights.length !== nightsToShow) {
	        // returned calendar can have holes, make sure we fill them
	        var date = moment(period.start);
	        var i = 0;
	        while (i < nightsToShow) {
	          var rec = findRecord(date, nights);
	          //reviveCancellation(rec);
	          calendar.push(rec);
	          date.add(1, 'days');
	          i++;
	        }
	      } else {
	        calendar = nights;
	      }
	      calendar.forEach(function (night) {
	        night.price = parseFloat(night.price);
	        night.pristinePrice = night.price;
	      });
	      product.calendar = {
	        items: calendar
	      };
	    });

	    //_callback();
	  }

	  function loadCalendarSupp(products, period, LastproductsAdded, vmproducts) {
	    vm.loadingsup = true;
	    // var LastproductsAdded=[];
	    //  vm.pdts=products; 
	    // console.log("inloadCalendarSuppProduct",products)
	    var pendingSupp = [];
	    var promises = products.map(function (product) {

	      console.log("prodToAdded1100:::", product);

	      $http.get(product.links.calendar.href, {
	        params: {
	          $sort: 'date<',
	          start: period.start.format('YYYY-MM-DD'),
	          end: period.end.format('YYYY-MM-DD')
	        }
	      }).then(function (res) {
	        var nightsToShow = period.end.diff(period.start, 'days');
	        var calendar = [];
	        var nights = res.data.items;
	        $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	        if (nights.length !== nightsToShow) {
	          // returned calendar can have holes, make sure we fill them
	          var date = moment(period.start);
	          var i = 0;
	          while (i < nightsToShow) {
	            var rec = findRecord(date, nights);
	            //reviveCancellation(rec);
	            calendar.push(rec);
	            date.add(1, 'days');
	            i++;
	          }
	        } else {
	          calendar = nights;
	        }
	        calendar.forEach(function (night) {
	          night.price = parseFloat(night.price);
	          night.pristinePrice = night.price;
	        });
	        product.calendar = {
	          items: calendar
	        };
	        console.log("prodToAdded11:::", product);
	        console.log("teeeest", LastproductsAdded.length);
	        var suppExist = false;

	        product.calendar.items.map(function (r) {

	          var productSupp;
	          if (r.supplement != null) {
	            productSupp = Object.keys(r.supplement).map(function (key) {
	              return [Number(key), r.supplement[key]];
	            });
	          }
	          if (r.supplement != null && productSupp.length > 2) suppExist = true;
	        });
	        // if (suppExist==true) {

	        //   LastproductsAdded.push(r);
	        // }

	        if (suppExist = true) {
	          // console.log("suppExist:::",suppExist);

	          var productSupp = [];
	          product.calendar.items.map(function (rs) {
	            if (rs.supplement != null) {

	              productSupp = Object.entries(rs.supplement);
	              // console.log("productSupp:::", productSupp);

	              //productSupp= Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);
	            }
	          });
	          // console.log("productSupp:::",productSupp);
	          var productAdded = [];
	          if (productSupp.length) {
	            var i = 0;

	            productSupp.forEach(function (_ref) {
	              var _ref2 = _slicedToArray(_ref, 2),
	                  key = _ref2[0],
	                  value = _ref2[1];

	              ///  console.log("productSuppvalue[key, value]:::", value);

	              if (value != null & i > 1) {

	                var prdct = Object.assign({}, product);
	                prdct.age = key;
	                prdct.name = prdct.name + " " + key;
	                productAdded.push(prdct);
	                console.log("prdct.name:::", prdct.name);
	              }
	              i++;
	            });
	          }

	          if (productAdded.length) {
	            console.log("productAddedLength;:::", productAdded.length);
	            // console.log("productAddedLength;:::", productAdded);

	            for (var k = 0; k < productAdded.length; k++) {
	              var items = [];
	              for (var i = 0; i < productAdded[k].calendar.items.length; i++) {

	                // var productSuppitemi= Object.keys(res.data.items[i].supplement).map((key) => [Number(key), res.data.items[i].supplement[key]]);
	                //items[i]=res.data.items[i]
	                items[i] = Object.assign({}, productAdded[k].calendar.items[i]);
	                //  console.log("productAddedLengthINNN;:::");

	                var productSuppitemi;
	                var ageExist = false;
	                if (productAdded[k].calendar.items[i].supplement != null) {
	                  productSuppitemi = Object.entries(productAdded[k].calendar.items[i].supplement);

	                  productSuppitemi.forEach(function (_ref3) {
	                    var _ref4 = _slicedToArray(_ref3, 2),
	                        key = _ref4[0],
	                        value = _ref4[1];

	                    if (key === productAdded[k].age) {
	                      //    console.log("productAddedLengthINNNAGE;:::",value);
	                      //    console.log("productAddedLengthINNNAGEkey;:::",key);

	                      ageExist = true;
	                      //        console.log(" items[i].priceadd:Befor::", items[i].price);
	                      productAdded[k].calendar.items[i].price = parseFloat(value);
	                      //       console.log(" items[i].priceadd:::", items[i].price);

	                    }
	                    //  else {
	                    //   items[i].price=null;


	                    //  }
	                  });

	                  if (ageExist == false) {
	                    items[i].price = null;
	                  }
	                } else {
	                  items[i].price = null;
	                }
	              }
	              productAdded[k].items = items;
	              //vm.unit.sup.push(productAdded[k])
	              //products.push(productAdded[k]);
	              //vm.pdts.push(productAdded[k]);
	              //console.log("ppp:::",vm.pdts.length);
	            }
	          }

	          //       console.log("productAdded[k]:::::", productAdded);
	          //  LastproductsAdded=productAdded;
	          productAdded.map(function (prodToAdded) {
	            LastproductsAdded.push(prodToAdded);
	            //products.push(prodToAdded);
	            // vm.pdts.push(prodToAdded);
	            console.log("addtopdts:::", vm.pdts);
	            var productf = LastproductsAdded;
	            vm.pdts = productf;
	            vm.products.push(prodToAdded);
	            vm.unit.sp = vm.pdts.length;
	            pendingSupp.push(prodToAdded);
	            //  console.log("productAdded[k]prodToAdded:::::", prodToAdded);
	          });
	          //   const productf=LastproductsAdded;
	          //  vm.pdts=productf;   
	          //    console.log("teeeestpdts",vm.pdts);
	          // products.map(product=> {

	          //   console.log("productAdded[k]prodToAdded:::::", product);
	          //    })
	        }

	        // console.log("suppExist:::",suppExist);

	      });

	      //.then(() =>{ 
	      //  console.log("teeeest",LastproductsAdded.length);
	      //  vm.loading = false
	      // })
	      //const LastproductsAddedF=LastproductsAdded;
	      //       vm.pdts=LastproductsAddedF;

	    });
	    $q.all(LastproductsAdded).then(function () {
	      console.log("pendingSuppOK");
	      console.log("pendingSuppOKpendingSupp", pendingSupp.length);
	      vm.loadingsup = false;
	    });

	    // products.map(prodToAdded=> {
	    //   //pending.push(loadCalendar(prodToAdded, vm.period));
	    //   console.log("prodToAdded22:::",prodToAdded.calendar);

	    //   var suppExist = false;
	    //   prodToAdded.calendar.items.map(r => {

	    //             var productSupp;
	    //             if (r.supplement != null) {
	    //               productSupp = Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);

	    //             }
	    //             if (r.supplement != null && productSupp.length > 2) suppExist = true;


	    //           });
	    //           console.log("suppExist:::",suppExist);


	    // console.log("productAdded[k]prodToAdded:::::", productf);
	    //   //vm.products.push(prodAdded);
	    // })
	    //productsAdded

	    // console.log("LastproductsAdded:::",LastproductsAdded);
	    // vm.LastproductsAdded=LastproductsAdded;
	    // products=LastproductsAdded;


	    LastproductsAdded.map(function (prodAdded) {
	      products.push(prodAdded);
	      //console.log("ppp:::",prodAdded);

	      //return prodAdded;
	      //vm.products.push(prodAdded);
	    });
	    //  vm.unit.sp=vm.pdts;


	    // products.map(p=> {
	    // console.log("ppp:::",p);
	    // return p;
	    //   //vm.products.push(prodAdded);
	    // })
	    // vm.products=LastproductsAdded;


	    // products.map(prodToAdded=> {
	    //   //pending.push(loadCalendar(prodToAdded, vm.period));
	    //   console.log("prodToAdded:::",prodToAdded.calendar);

	    //   var suppExist = false;
	    //   prodToAdded.calendar.items.map(r => {
	    //             var productSupp;
	    //             if (r.supplement != null) {
	    //               productSupp = Object.keys(r.supplement).map((key) => [Number(key), r.supplement[key]]);

	    //             }
	    //             if (r.supplement != null && productSupp.length > 2) suppExist = true;


	    //           });
	    //           console.log("suppExist:::",suppExist);


	    //   //vm.products.push(prodAdded);
	    // })
	    console.log("vmvmvmloading:::", vm.loading);

	    // console.log("Lastproductsout:::",LastproductsAdded);

	    // console.log("vm.occupanciesout:::",vm.occupancies);
	    //vm.loading = false;
	  }

	  function findRecord(date, nights) {
	    return nights.find(function (n) {
	      return n.date === date.format('YYYY-MM-DD');
	    }) || {
	      date: date.format('YYYY-MM-DD')
	    };
	  }

	  function priceChanged(product, night) {
	    // tmp link TODO get ling from api
	    if (night.pristinePrice == night.price) {
	      return;
	    }
	    if (isNaN(night.price) || night.price < 0) {
	      night.price = night.pristinePrice;
	      return;
	    }

	    $http.post(apiUrl + '/commands/batch-update-rates', {
	      products: [product.code],
	      rates: [night.price],
	      periods: [{ start: night.date, end: night.date }]
	    }).then(function () {
	      $log.debug('night updated', night);
	      night.pristinePrice = night.price;
	    });
	  }
	  function onReqChanged(onReq, index, date) {

	    var onReqFrom = moment(onReq.from).format("YYYY-MM-DD");
	    var onReqTo = moment(onReq.to).format("YYYY-MM-DD");
	    var checkDate = moment(date).format("YYYY-MM-DD");

	    var oldoOnReq = {
	      code: onReq.code,
	      type: onReq.type,
	      typeCode: onReq.type_code,
	      description: onReq.description,
	      property: onReq.property,
	      debut: onReqFrom,
	      fin: onReqTo

	    };
	    var newOnReq = {
	      type: onReq.type,
	      typeCode: onReq.type_code,
	      description: onReq.description,
	      property: onReq.property,
	      debut: onReqFrom,
	      fin: onReqTo

	    };

	    if (vm.onRequestsExist[index].exist == true) {
	      vm.onRequestsExist[index].exist = false;
	      // if(date == stp.from || date == stp.to){   

	      if (checkDate == onReqFrom || checkDate == onReqTo) {
	        if (checkDate == onReqFrom && checkDate != onReqTo) {
	          oldoOnReq.debut = moment(onReqFrom, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");

	          onReqUpdate(oldoOnReq);
	          $state.reload();
	        }
	        if (checkDate == onReqTo && checkDate != onReqFrom) {

	          oldoOnReq.fin = moment(onReqTo, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD");
	          console.log("first or last day):", oldoOnReq.fin);
	          console.log("moment first or last day):", moment(onReqTo, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD"));
	          onReqUpdate(oldoOnReq);
	          $state.reload();
	        }
	        if (checkDate == onReqTo && checkDate == onReqFrom) {
	          remove(oldoOnReq);
	        }
	        //  put oldStop;

	        init();
	        console.log("first or last day):");
	      } else {

	        oldoOnReq.fin = moment(checkDate, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD");
	        var newOnReq2 = {
	          type: "Unit",
	          typeCode: vm.unit.code,
	          description: "En demande",
	          property: vm.property.property.code,
	          debut: moment(checkDate, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD"),
	          fin: onReqTo
	          // newStop.debut=moment(checkDate,"YYYY-MM-DD").add(1,'days').format("YYYY-MM-DD")
	        };onReqUpdate(oldoOnReq);
	        postOnReq(newOnReq2).then($state.reload());
	        init(vm.period);
	      }
	    } else {
	      var newOnReq1 = {

	        type: "Unit",
	        typeCode: vm.unit.code,
	        description: "En demande",
	        property: vm.property.property.code,
	        debut: moment(checkDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
	        fin: moment(checkDate, "YYYY-MM-DD").format("YYYY-MM-DD")
	      };
	      console.log("newOnReq1):", newOnReq1);

	      vm.onRequestsExist[index].exist = true;
	      postOnReq(newOnReq1).then($state.reload());;
	      init();
	    }

	    if (vm.onRequestsExist[index].exist == true) {
	      vm.onRequestsExist[index].exist = false;
	    } else vm.onRequestsExist[index].exist = true;
	    //   var originalTo=stp.to;
	    // console.log("originalTo:",originalTo)
	    console.log("dateTo:", date);
	    console.log("index:", index);
	  }

	  function postOnReq(onReq) {
	    $log.debug('link', vm.property.property.links);

	    //var href = "http://beds-api.fractalite.com/properties/2/stop-sales";
	    console.log("onReq):", onReq);

	    return $http.post(vm.property.property.links["on-requests"].href, onReq).then(function (res) {
	      $log.debug('created', res.data);
	      //  $scope.$emit("stopsalesAdded",res.data);
	    }, function () {
	      $log.error(arguments);
	      // return $q.reject()
	    }).then(function () {
	      return $state.reload();
	    });

	    //.then(() => $state.reload());
	  }

	  function onReqUpdate(onReq) {
	    var promise;

	    console.log("onReq", onReq);
	    promise = $http({
	      method: "PUT",
	      url: vm.property.property.links["on-requests"].href + "/" + onReq.code,
	      headers: {
	        "Content-Language": "**"
	      },
	      data: _.pick(onReq, ['code', 'type', 'description', 'type_code', 'debut', 'fin', 'property', 'status'])
	    });
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	    //.then(() => $state.reload());;
	  }
	  function remove(onReq) {

	    console.log("remove):", onReq);
	    console.log("remove)))):", $stateParams);
	    $http.delete(vm.property.property.links["on-requests"].href + "/" + onReq.code).then(function () {
	      return $state.reload();
	    });
	    //.then(() =>$state.transitionTo($state.current, $stateParams, { reload: true, inherit: false, notify: true }));

	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }

	  function loadCalendarSupplement(product, period) {
	    $http.get(product.links.calendar.href, {
	      params: {
	        $sort: 'date<',
	        start: period.start.format('YYYY-MM-DD'),
	        end: period.end.format('YYYY-MM-DD')
	      }
	    }).then(function (res) {
	      var nightsToShow = period.end.diff(period.start, 'days');
	      var calendar = [];
	      var nights = res.data.items;
	      $log.debug('nightsToShow', nightsToShow, 'res.data.items', nights);
	      if (nights.length !== nightsToShow) {
	        // returned calendar can have holes, make sure we fill them
	        var date = moment(period.start);
	        var i = 0;
	        while (i < nightsToShow) {
	          var rec = findRecord(date, nights);
	          //reviveCancellation(rec);
	          calendar.push(rec);
	          date.add(1, 'days');
	          i++;
	        }
	      } else {
	        calendar = nights;
	      }
	      calendar.forEach(function (night) {
	        night.price = parseFloat(night.price);
	        night.pristinePrice = night.price;
	      });
	      product.calendar = {
	        items: calendar
	      };
	    });
	  }

	  function changerun(changes) {
	    console.log("change009::", changes);

	    //console.log("change00vm.selectedProduct::",vm.selectedProduct);
	    init();

	    if (!changes.hasOwnProperty('period')) return;
	    if (changes.period.isFirstChange()) {
	      init();
	    } else {
	      //reloadCalendars(vm.period);
	      init();
	    }
	  }
	  /*
	         const cancellationLabels = {
	        "999%100":"NRF",
	        "0%0":"Gratuite"
	      }
	        function reviveCancellation(rec) {
	          $log.debug(rec);
	          if (!rec.cancellation) return;
	             const hash = rec.cancellation.join('/');
	             $log.debug(hash);
	             if (!cancellationLabels[hash]) {
	            cancellationLabels[hash] = formatCancellation(rec.cancellation);
	          }
	          rec.cancellationLabel =  cancellationLabels[hash];
	        }
	           function formatCancellation(rules) {
	          return 'custom';
	        }
	     */
	}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(128);

	var _component2 = _interopRequireDefault(_component);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module("lectusAmenities", ["ngAnimate", "ngSanitize", "ngMessages", "ngAria", "ui.router", "ngMaterial", "lectusApi"]).component(_component2.default.name, _component2.default).config(["$stateProvider", function amenitiesRoutes($stateProvider) {
	  'ngInject';
	  // State

	  $stateProvider.state('property.amenities', {
	    url: '/amenities',
	    component: 'propertyAmenities',
	    data: {
	      menu: {
	        label: 'Services & équipements',
	        group: 'info',
	        position: 3
	      }
	    }
	  });
	}]);

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	PropertyAmenitiesCtrl.$inject = ["$log", "$http", "$q", "datasets", "$state", "$mdDialog"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _controller = __webpack_require__(129);

	var _controller2 = _interopRequireDefault(_controller);

	var _controller3 = __webpack_require__(130);

	var _controller4 = _interopRequireDefault(_controller3);

	var _controller5 = __webpack_require__(131);

	var _controller6 = _interopRequireDefault(_controller5);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var _ = __webpack_require__(5);

	exports.default = {
	  name: "propertyAmenities",
	  controller: PropertyAmenitiesCtrl,
	  templateUrl: "app/amenities/property/view/template.html",
	  require: {
	    propertyCtrl: '^propertyContainer'
	  }
	};


	function PropertyAmenitiesCtrl($log, $http, $q, datasets, $state, $mdDialog) {
	  "ngInject";

	  var vm = this;

	  vm.unitAmenitiesFilter = {
	    unit: true,
	    name: ""
	  };

	  vm.query = {
	    limit: 20,
	    order: 'name',
	    page: 1
	  };

	  vm.options = {};

	  vm.$onInit = function () {
	    var property = vm.propertyCtrl;
	    property.setBreadcrumb([{
	      label: 'Services & Equipements'
	    }]);

	    datasets.bindSets(["unit-types"], vm, true);

	    datasets.get("amenities").then(function (collection) {
	      //  console.log('dataset amenities....', collection);

	      property.get("amenities").then(function (amenities) {
	        //console.log('-------------amenities-----------', amenities)

	        vm._propertyAmenities = amenities.items;
	        vm.propertyAmenities = amenities.items.map(function (a) {
	          return a.amenity;
	        });
	        vm.permissions = amenities.permissions;

	        vm.options.property = collection.items.filter(function (a) {
	          return a.property;
	        }).map(function (a) {
	          var i = vm.propertyAmenities.indexOf(a.code);
	          angular.extend(a, i > -1 ? {
	            free: vm._propertyAmenities[i].free === null ? true : vm._propertyAmenities[i].free,
	            description: vm._propertyAmenities[i].description,
	            checked: true
	          } : {
	            free: true,
	            description: "",
	            checked: false
	          });
	          return a;
	        });
	      });

	      // vm.unitsPromise = property.get("units").then(processUnits)
	      //   .then(units => {
	      //     const unit = collection.items.filter(a => a.unit)
	      //     units.map(u => {
	      //       unit.map(a => {
	      //         // var v=
	      //         const j = u.amenities.indexOf(a.code);
	      //         if (j > -1) {
	      //           console.log('jjjjj', u._amenities[j].free)
	      //           a.free = u._amenities[j].free;
	      //           console.log('kkkkk', a.free)
	      //         }
	      //         return a;
	      //       })
	      //       return u;
	      //     })

	      //     vm.options.unit = unit
	      //     vm.units = units


	      //     // vm.options.unit = collection.items.filter(a => a.unit)
	      //     //   .map(a => {
	      //     //     vm.units.forEach(u => {
	      //     //       const i = u.amenities.indexOf(a.code);
	      //     //       if (i > -1) {
	      //     //         angular.extend(a, {
	      //     //           free: _.clone(u._amenities[i].free),
	      //     //           checked: true
	      //     //         })
	      //     //       } else {
	      //     //         angular.extend(a, {
	      //     //           free: true,
	      //     //           checked: false
	      //     //         })
	      //     //       }

	      //     //     });

	      //     //     return a

	      //     //   })

	      //     angular.extend(vm, {
	      //       toggleUnit: toggleUnitAmenity,
	      //       toggleProperty: togglePropertyAmenity
	      //       // checkedPropertyAmenities: checkedPropertyAmenities

	      //     })
	      //   });
	      vm.unitsPromise = property.get("units").then(processUnits).then(function (units) {
	        units.sort(function (a, b) {
	          return a.code > b.code ? 1 : b.code > a.code ? -1 : 0;
	        });
	        vm.units = units;
	        vm.options.unit = collection.items.filter(function (a) {
	          return a.unit;
	        });
	        angular.extend(vm, {
	          // query: query,
	          toggleUnit: toggleUnitAmenity,
	          uAmenitiesIsFree: uAmenitiesIsFree,
	          toggleProperty: togglePropertyAmenity,
	          editAmenityDescription: editAmenityDescription
	        });
	      });
	    });
	  };

	  function uAmenitiesIsFree(u, a) {
	    var i = u.amenities.indexOf(a.code);
	    if (i > -1) {
	      return u._amenities[i].free === null ? true : u._amenities[i].free;
	    }
	    return true;
	  }

	  // function isPaid(a) {
	  //   const index = vm.propertyAmenities.indexOf(a.code);
	  //   return index > -1 && !vm._propertyAmenities[index].free
	  // }

	  function processUnits(collection) {
	    var promises = collection.items.map(function (u) {
	      return _.pick(u, ["code", "name", "type", "links"]);
	    }).map(loadUnitAmenities);
	    return $q.all(promises);
	  }

	  function loadUnitAmenities(u) {
	    return $http.get(u.links.amenities.href).then(function (res) {
	      u._amenities = res.data.items;
	      u.amenities = res.data.items.map(function (a) {
	        return a.amenity;
	      });
	      return u;
	    });
	  }

	  function toggleUnitAmenity($event, u, a) {
	    if (a.disabled) return;
	    var baseUrl = u.links.amenities.href;
	    if (!u.amenities.includes(a.code)) addAmenity(a, baseUrl, u.amenities, u._amenities, $event, false);else removeAmenity(a, baseUrl, u.amenities, u._amenities);
	  }

	  function togglePropertyAmenity($event, a) {
	    $log.debug("togglePropertyAmenity", a);
	    if (a.disabled) return;

	    var propAmenities = vm.propertyAmenities;
	    var baseUrl = vm.propertyCtrl.property.links.amenities.href;
	    if (!propAmenities.includes(a.code)) addAmenity(a, baseUrl, propAmenities, vm._propertyAmenities, $event, true);else removeAmenity(a, baseUrl, propAmenities, vm._propertyAmenities);
	  }

	  // function checkedPropertyAmenities(a) {
	  //   var index = vm.propertyAmenities.indexOf(a.code)
	  //   if (index > -1) {
	  //     console.log('vm._propertyAmenities[index].free', vm._propertyAmenities[index])
	  //     a.free = vm._propertyAmenities[index].free
	  //     return true
	  //   } else {
	  //     a.free = false
	  //     return false
	  //   }

	  // }


	  function _freeConfirmDialogNoDesc($event, a) {
	    return {
	      targetEvent: $event,
	      templateUrl: 'app/amenities/property/view/confirm/dialog-nodesc.html',
	      locals: {
	        amenity: a
	      },
	      controller: _controller2.default,
	      controllerAs: '$ctrl'
	    };
	  }

	  function _freeConfirmDialogDesc($event, a) {
	    return {
	      targetEvent: $event,
	      templateUrl: 'app/amenities/property/view/confirm/dialog-desc.html',
	      locals: {
	        amenity: a
	      },
	      controller: _controller2.default,
	      controllerAs: '$ctrl'
	    };
	  }

	  function _amenityDecscriptionDialog($event, a) {
	    return {
	      targetEvent: $event,
	      templateUrl: 'app/amenities/property/view/amenity-description/dialog.html',
	      locals: {
	        amenity: a
	      },
	      controller: _controller4.default,
	      controllerAs: '$ctrl'
	    };
	  }

	  function editAmenityDescription($event, a) {
	    console.log('edit amenity...', a);
	    var baseUrl = vm.propertyCtrl.property.links.amenities.href + "/" + a.code;

	    $http.get(baseUrl).then(function (res) {
	      //console.log('success get', res)
	      a.description = res.data.description;

	      var amenityBaseUrl = res.data.links.self.href;
	      $mdDialog.show(_amenityDecscriptionDialog($event, a)).then(function (choice) {
	        //console.log('savvvvvvvvved.......', choice)
	        // a.disabled = true;
	        $http.put(amenityBaseUrl, {
	          //  property: 12,
	          property: vm.propertyCtrl.property.code,
	          amenity: a.code || a.amenity,
	          description: choice.description
	        });
	        // .then(
	        //   (res) => {
	        //     console.log('success update amenity', res)
	        //   }, () => {
	        //     $log.error("cannot add amenity");
	        //   })
	      });
	    }, function () {
	      $log.error("cannot add amenity");
	    });
	  }

	  function addAmenity(a, baseUrl, selectedCodes, selectedAmenities, $event, hasDesc) {
	    $log.debug("addAmenity", a, baseUrl, selectedCodes, selectedAmenities);

	    if (hasDesc) {
	      $mdDialog.show(_freeConfirmDialogDesc($event, a)).then(function (choice) {
	        a.disabled = true;
	        $http.post(baseUrl, {
	          amenity: a.code,
	          free: choice.free,
	          description: choice.description
	        }).then(function (res) {
	          selectedAmenities.push(res.data);
	          selectedCodes.push(a.code);
	          a.disabled = false;
	          a.checked = true;
	          a.free = choice.free;
	        }, function () {
	          $log.error("cannot add amenity");
	          a.disabled = false;
	        }).then(function () {
	          return $state.reload();
	        });
	      });
	    } else {
	      $mdDialog.show(_freeConfirmDialogNoDesc($event, a)).then(function (choice) {
	        a.disabled = true;
	        $http.post(baseUrl, {
	          amenity: a.code,
	          free: choice.free
	        }).then(function (res) {
	          selectedAmenities.push(res.data);
	          selectedCodes.push(a.code);
	          a.disabled = false;
	          a.checked = true;
	          a.free = choice.free;
	        }, function () {
	          $log.error("cannot add amenity");
	          a.disabled = false;
	        });
	        // .then(() => $state.reload())
	      });
	    }

	    // add;
	  }

	  function deleteAmenityConfirmDialog(a) {
	    return {
	      //targetEvent: $event,
	      templateUrl: 'app/amenities/property/view/amenity-delete-confirm/dialog.html',
	      locals: {
	        amenity: a
	      },
	      controller: _controller6.default,
	      controllerAs: '$ctrl'
	    };
	  }

	  function removeAmenity(a, baseUrl, selectedCodes, selectedAmenities) {
	    // console.log("removeAmenity", a)
	    //, baseUrl, selectedCodes, selectedAmenities
	    //return
	    var index = selectedCodes.indexOf(a.code);
	    // bug in mo-http for composite keys after post
	    //var url = selectedAmenities.find(pa => ua.amenity === a.code).links.self.href;

	    // var confirm = $mdDialog.confirm()
	    //   .title('Supprimer cet équipement ?')
	    //   .textContent("" + a.description)
	    //   .ariaLabel('Remove amenity')
	    //   // .targetEvent($event)
	    //   .ok('Supprimer')
	    //   .cancel('Ne pas supprimer');

	    $mdDialog.show(deleteAmenityConfirmDialog(a)).then(function () {
	      a.disabled = true;
	      $http.delete(baseUrl + "/" + a.code).then(function () {
	        selectedCodes.splice(index, 1);
	        selectedAmenities.splice(index, 1);
	        a.disabled = false;
	        a.free = true;
	        a.description = '';
	        a.checked = false;
	      }, function () {
	        $log.error("cannot remove amenity");
	        a.disabled = false;
	      });

	      // $http.put(baseUrl + "/" + a.code, {free:true}).then(
	      //   () => {
	      //     selectedCodes.splice(index, 1);
	      //     selectedAmenities.splice(index, 1);
	      //     a.disabled = false;
	      //     a.free = true
	      //     a.description = '';
	      //     a.checked = false
	      //   }, () => {
	      //     $log.error("cannot remove amenity");
	      //     a.disabled = false;
	      //   })
	    });
	    //.then(() => $state.reload());
	  }
	}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	FreeConfirmCtrl.$inject = ["$log", "$mdDialog", "amenity"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FreeConfirmCtrl;
	var _ = __webpack_require__(5);

	function FreeConfirmCtrl($log, $mdDialog, amenity) {
	  "ngInject";

	  var vm = this;

	  // vm.langs = lectusLanguages;
	  console.log("confirm paid amenity....", amenity);
	  vm.$onInit = function () {
	    var amen = _.cloneDeep(amenity);
	    amen.free = true;
	    angular.extend(vm, {
	      amenity: amen,
	      cancel: cancel,
	      save: save
	    });
	  };

	  function cancel() {
	    $mdDialog.cancel();
	  }

	  function save() {
	    $log.debug("close", vm.amenity);
	    $mdDialog.hide(vm.amenity);
	  }
	}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	AmenityDescriptionCtrl.$inject = ["$log", "$mdDialog", "amenity"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AmenityDescriptionCtrl;
	var _ = __webpack_require__(5);

	function AmenityDescriptionCtrl($log, $mdDialog, amenity) {
	  "ngInject";

	  var vm = this;

	  // vm.langs = lectusLanguages;
	  //console.log("confirm paid amenity....", amenity)
	  vm.$onInit = function () {
	    console.log("updatectrl");

	    var clonedAmenity = _.cloneDeep(amenity);
	    //  amen.free = true
	    angular.extend(vm, {
	      amenity: clonedAmenity,
	      cancel: cancel,
	      save: save
	    });
	  };

	  function cancel() {
	    $mdDialog.cancel();
	  }

	  function save() {
	    $log.debug("close", vm.amenity);
	    $mdDialog.hide(vm.amenity);
	  }
	}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	AmenityDeleteConfirmCtrl.$inject = ["$log", "$mdDialog", "amenity"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AmenityDeleteConfirmCtrl;

	var _controller = __webpack_require__(130);

	var _controller2 = _interopRequireDefault(_controller);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var _ = __webpack_require__(5);
	function AmenityDeleteConfirmCtrl($log, $mdDialog, amenity) {
	  "ngInject";

	  var vm = this;

	  // vm.langs = lectusLanguages;
	  vm.$onInit = function () {
	    var amen = _.cloneDeep(amenity);
	    angular.extend(vm, {
	      amenity: amen,
	      cancel: cancel,
	      save: save,
	      update: update
	    });
	  };

	  function cancel() {
	    $mdDialog.cancel();
	  }

	  function update(a) {
	    console.log("updateupdate:: ", a);
	    $mdDialog.hide();
	    return {
	      //targetEvent: $event,
	      templateUrl: 'app/amenities/property/view/amenity-description/dialog.html',
	      locals: {
	        amenity: a
	      },
	      controller: _controller2.default,
	      controllerAs: '$ctrl'
	    };
	  }

	  function save() {
	    $log.debug("close", vm.amenity);
	    $mdDialog.hide(vm.amenity);
	  }
	}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(133);

	var _component2 = _interopRequireDefault(_component);

	var _component3 = __webpack_require__(135);

	var _component4 = _interopRequireDefault(_component3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('lectusDestinations', ['ui.router', 'lectusApi']).component(_component2.default.name, _component2.default).component(_component4.default.name, _component4.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";

	  var resolveLectusApi = function resolveLectusApi(lectusApi) {
	    "ngInject";

	    return lectusApi;
	  };
	  resolveLectusApi.$inject = ["lectusApi"];
	  // State
	  $stateProvider.state('destinations', {
	    url: '/destinations',
	    component: _component2.default.name,
	    resolve: {
	      lectus: resolveLectusApi
	    }
	  }).state('destinationReport', {
	    url: '/destinations/:destination',
	    component: _component4.default.name,
	    resolve: {
	      lectus: resolveLectusApi,
	      destinationCode: ["$stateParams", function destinationCode($stateParams) {
	        "ngInject";
	        return $stateParams.destination;
	      }]
	    }
	  });
	}]);

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	DestinationListCtrl.$inject = ["$log", "$state", "lectusLanguages", "$scope", "$mdDialog", "$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _dialog = __webpack_require__(134);

	var _dialog2 = _interopRequireDefault(_dialog);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  name: "destinationList",
	  controller: DestinationListCtrl,
	  templateUrl: 'app/destinations/list/template.html',
	  bindings: {
	    lectus: "<"
	  }
	};


	function DestinationListCtrl($log, $state, lectusLanguages, $scope, $mdDialog, $http) {
	  "ngInject";

	  var vm = this;
	  var query = {
	    order: 'name',
	    search: '',
	    limit: 10,
	    page: 1
	  };

	  vm.load = load;
	  vm.langs = lectusLanguages;

	  vm.$onInit = function () {

	    angular.extend(vm, {
	      searchFilterOptions: {
	        debounce: 500
	      },
	      query: query,
	      load: load,
	      create: create,
	      edit: edit,
	      report: report
	    });
	    $scope.$watch(function () {
	      return vm.query.search;
	    }, onSearchChange);

	    //load();
	  };

	  function onSearchChange(newValue, oldValue) {
	    //console.log("onSearchChange bookmark", vm.query.page,newValue, oldValue)
	    var bookmark = vm.query.page;
	    if (!oldValue) {
	      bookmark = vm.query.page;
	    }

	    if (newValue !== oldValue) {
	      vm.query.page = 1;
	    }
	    if (!newValue) {
	      vm.query.page = bookmark;
	    }
	    //console.log(vm.query)
	    load();
	  }

	  function load() {
	    //const href = vm.propertyCtrl.property.links.bookings.href;
	    var href = vm.lectus.links.destinations.href;
	    //$log.debug(vm.query, arguments);
	    var sort = vm.query.order.indexOf("-") === 0 ? vm.query.order.replace("-", "") + ">" : vm.query.order + '<';
	    var q = vm.query;

	    vm.loadingPromise = $http.get(href, {
	      params: {
	        $limit: q.limit,
	        $skip: q.page * q.limit - q.limit,
	        $sort: sort,
	        search: q.search ? q.search : undefined
	      },
	      headers: {
	        'Accept-Language': '**'
	      }
	    }).then(function (res) {
	      angular.extend(vm, _.pick(res.data, ["items", "links", "permissions", "total"]));
	    });
	  }

	  function create() {
	    return edit({
	      links: {
	        index: vm.links.self
	      },
	      code: null,
	      name: {}
	    });
	  }

	  function report(destination) {
	    $state.go('destinationReport', { destination: destination.code });
	  }

	  function edit(destination, $event) {
	    $mdDialog.show({
	      templateUrl: _dialog2.default.templateUrl,
	      controller: _dialog2.default.controller,
	      controllerAs: _dialog2.default.controllerAs,
	      targetEvent: $event,
	      locals: {
	        destination: destination
	      }
	    }).then(function (result) {
	      if (result) {
	        load();
	      }
	    }).catch(function handleEditError(error) {
	      $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title("Erreur lors de l'enregistrement").textContent(error.message).ariaLabel("Erreur lors de l'enregistrement").ok("pfff...")).then(function () {
	        console.log("error.destination", error.destination);
	        if (error.destination) {
	          edit(error.destination);
	        }
	      });
	    });
	  }
	}

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  controllerAs: '$ctrl',
	  controller: ["$log", "$http", "$mdDialog", "lectusLanguages", "$q", "destination", "datasets", function DestinationEditCtrl($log, $http, $mdDialog, lectusLanguages, $q, destination, datasets) {
	    "ngInject";

	    var vm = this;

	    datasets.bindSets(["countries"], vm);

	    vm.langs = lectusLanguages;
	    $log.debug("DestinationEditCtrl");

	    vm.copy = angular.copy(destination);
	    vm.save = save;
	    vm.cancel = function () {
	      return $mdDialog.hide();
	    };

	    function save() {
	      var href = _.get(vm.copy, "links.self.href");
	      var changes = _.pick(vm.copy, ["code", "name", "country"]);
	      var conf = {
	        headers: {
	          "Content-Language": "**"
	        }
	      };
	      var promise = _.isString(href) ? $http.put(href, changes, conf) : $http.post(vm.copy.links.index.href, changes, conf);

	      return promise.then(function (res) {
	        return $mdDialog.hide(res.data);
	      }).catch(function (res) {
	        var err = {
	          message: "",
	          destination: vm.copy
	        };
	        if (res.data && res.data.message.indexOf("ERROR:  duplicate key value") === 0) {
	          err.message = "Une destination dont le code est " + vm.copy.code + " existe déja";
	        } else {
	          err.message = "Un erreur innatendue est survenue lors de l'enregistrement. Veuillez notifier le support technique.";
	        }
	        $mdDialog.cancel(err);
	      });
	    }
	  }],
	  templateUrl: 'app/destinations/edit/template.html'
	};

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	"use strict";

	DestinationReportCtrl.$inject = ["$window", "$rootScope", "$log", "$http"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "destinationReport",
	  controller: DestinationReportCtrl,
	  templateUrl: 'app/destinations/report/template.html',
	  bindings: {
	    lectus: "<",
	    destinationCode: "<"
	  }
	};


	function DestinationReportCtrl($window, $rootScope, $log, $http) {
	  "ngInject";

	  var vm = this;
	  vm.period = {
	    from: moment().startOf("month").format("YYYY-MM-DD"),
	    to: moment().endOf("month").format("YYYY-MM-DD")
	  };
	  vm.hasNext = true;
	  vm.hasPrevious = true;

	  vm.$onInit = function () {
	    load();
	  };

	  vm.nextMonth = function () {
	    var start = moment(vm.period.from).add(1, "month");
	    vm.period = {
	      from: start.format("YYYY-MM-DD"),
	      to: moment(start).endOf("month").format("YYYY-MM-DD")
	    };
	    load();
	  };
	  vm.previousMonth = function () {
	    var start = moment(vm.period.from).subtract(1, "month");
	    vm.period = {
	      from: start.format("YYYY-MM-DD"),
	      to: moment(start).endOf("month").format("YYYY-MM-DD")
	    };
	    load();
	  };

	  function load() {
	    var href = vm.lectus.links.destinations.href;
	    vm.loading = $http.get(href + "/" + vm.destinationCode + "/report", {
	      params: vm.period
	    }).then(function (res) {
	      $log.debug('dest', res.data);
	      angular.extend(vm, res.data);
	    });
	  }

	  vm.$onInit = function () {
	    load(vm.destinationCode);
	  };
	}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(137);

	var _component2 = _interopRequireDefault(_component);

	var _component3 = __webpack_require__(138);

	var _component4 = _interopRequireDefault(_component3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var _ = __webpack_require__(5);

	// import codeNameEditCtrl from './edit/component';

	exports.default = angular.module('lectusDatasets', ['ui.router', 'lectusApi', 'dndLists']).component(_component4.default.name, _component4.default)
	//.component(editComp.name,editComp)
	.component(_component2.default.name, _component2.default).config(["$stateProvider", function datasetsRoutes($stateProvider) {
	  'ngInject';

	  resolveCode.$inject = ["$stateParams"];
	  var data = [{
	    name: 'amenities',
	    label: 'Equipements',
	    listTemplate: 'app/datasets/amenities/list.html'
	  }, {
	    name: 'boards',
	    label: 'Pensions',
	    listTemplate: 'app/datasets/codename.list.html'
	  }, {
	    name: 'property-types',
	    label: 'Types d\'établissements',
	    listTemplate: 'app/datasets/codename.list.html'
	  }, {
	    name: 'unit-types',
	    label: 'Types d\'unités',
	    listTemplate: 'app/datasets/codename.list.html'
	  }, {
	    name: 'tags',
	    label: 'Tags',
	    listTemplate: 'app/datasets/codename.list.html'
	  }, {
	    name: 'tag-type',
	    label: 'Types des Tags',
	    listTemplate: 'app/datasets/codename.list.html'
	  }, {
	    name: 'rating-systems',
	    label: 'Classements',
	    listTemplate: 'app/datasets/rating-systems/list.html',
	    bindSets: ["property-types"]
	  }, {
	    name: 'destinations',
	    label: 'Destinations',
	    listTemplate: 'app/datasets/codename.list.html'
	  }, {
	    name: 'brands',
	    label: 'Chaines',
	    listTemplate: 'app/datasets/codename.list.html'
	  }];

	  function resolveCode($stateParams) {
	    'ngInject';

	    return $stateParams.code;
	  }

	  $stateProvider.state("datasets", {
	    url: '/datasets',
	    component: _component2.default.name,
	    resolve: {
	      dsInfo: function dsInfo() {
	        return data;
	      }
	    }
	  });

	  data.forEach(function (info) {
	    $stateProvider.state('datasets.' + _.camelCase(info.name), {
	      url: '/' + info.name,
	      component: _component4.default.name,
	      resolve: {
	        dsInfo: function dsInfo() {
	          return info;
	        }
	      }
	    });
	  });
	}]);

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	'use strict';

	DatasetsContainer.$inject = ["$log", "$mdSidenav", "$q", "$http", "$state"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "datasetsContainer",
	  controller: DatasetsContainer,
	  templateUrl: 'app/datasets/container/template.html',
	  bindings: {
	    dsInfo: '<dsInfo'
	  }
	};


	function DatasetsContainer($log, $mdSidenav, $q, $http, $state) {
	  "ngInject";

	  var vm = this;
	  //const relationsCache = new Map();

	  vm.$onInit = function () {
	    _setUpMenu(vm.dsInfo);
	  };

	  angular.extend(vm, {
	    toggleMenu: toggleMenu,
	    setActions: setActions,
	    setBreadcrumb: setBreadcrumb
	  });

	  function _setUpMenu(dsInfo) {
	    vm.menu = dsInfo.map(function (info) {
	      info.href = '#/datasets/' + info.name;
	      return info;
	    });
	  }

	  function toggleMenu() {
	    $mdSidenav('datasets-menu').toggle();
	  }

	  function setActions(actions) {
	    vm.actions = actions;
	    return vm;
	  }

	  function setBreadcrumb(crumbs) {
	    vm.breadcrumb = crumbs;
	    return vm;
	  }
	}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	DataSetListCtrl.$inject = ["$scope", "$log", "$http", "$mdDialog", "datasets"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _codenameEdit = __webpack_require__(139);

	var _codenameEdit2 = _interopRequireDefault(_codenameEdit);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  name: 'datasetList',
	  controller: DataSetListCtrl,
	  templateUrl: 'app/datasets/list/template.html',
	  bindings: {
	    dsInfo: '<dsInfo'
	  }
	};


	function DataSetListCtrl($scope, $log, $http, $mdDialog, datasets) {
	  "ngInject";

	  var vm = this;
	  // console.log("DataSetListCtrl")
	  vm.$onInit = function () {
	    console.log("vm.dsInfo", vm.dsInfo);
	    vm.loadingPromise = datasets.get(vm.dsInfo.name, {
	      headers: {
	        "Accept-Language": "**"
	      }
	    }).then(function (results) {
	      angular.extend(vm, results);
	    });
	    console.log("loadingPromise1", vm.loadingPromise);

	    if (vm.dsInfo.bindSets && vm.dsInfo.bindSets.length) {
	      datasets.bindSets(vm.dsInfo.bindSets, vm, true);
	    }
	  };

	  angular.extend(vm, {
	    edit: edit,
	    add: add,
	    addAmenities: addAmenities,
	    remove: remove,
	    updateAmenities: updateAmenities
	  });

	  function load() {
	    console.log("vm.dsInfo2", vm.dsInfo);

	    vm.loadingPromise = datasets.get(vm.dsInfo.name, {
	      headers: {
	        "Accept-Language": "**"
	      }
	    }).then(function (results) {
	      angular.extend(vm, results);
	    });

	    console.log("loadingPromise", vm.loadingPromise);
	  }

	  function remove(item, $event) {

	    var confirm = $mdDialog.confirm().title('Etes-vous sûr de vouloir supprimer ?').textContent('Cette opération est irreversible.').ariaLabel('Supression ').targetEvent($event).ok('Supprimer').cancel('Garder');

	    console.log('removeee', item.links.self.href);

	    $mdDialog.show(confirm).then(function () {
	      return $http.delete(item.links.self.href);
	    }).then(function () {
	      return load();
	    }
	    //$state.reload()
	    );
	  }

	  function edit(item, $event) {
	    $mdDialog.show({
	      templateUrl: 'app/datasets/codename.edit.html',
	      controller: _codenameEdit2.default,
	      controllerAs: '$ctrl',
	      targetEvent: $event,
	      locals: {
	        item: item,
	        collectionHref: vm.links.self.href,
	        dsInfo: vm.dsInfo
	      }
	    }).then(function (result) {
	      $log.debug('edit unit', result);
	      load();
	    });
	  }

	  function add($event) {
	    $mdDialog.show({
	      templateUrl: 'app/datasets/codename.edit.html',
	      // templateUrl: 'app/datasets/amenities/edit.html',

	      controller: _codenameEdit2.default,
	      controllerAs: '$ctrl',
	      targetEvent: $event,
	      locals: {
	        item: null,
	        collectionHref: vm.links.self.href,
	        dsInfo: vm.dsInfo

	      }
	    }).then(function (result) {
	      $log.debug('edit unit', result);
	      load();
	    });
	  }

	  function addAmenities($event) {
	    $mdDialog.show({
	      //   templateUrl: 'app/datasets/codename.edit.html',
	      templateUrl: 'app/datasets/amenities/edit.html',

	      controller: _codenameEdit2.default,
	      controllerAs: '$ctrl',
	      targetEvent: $event,
	      locals: {
	        item: null,
	        collectionHref: vm.links.self.href,
	        dsInfo: vm.dsInfo
	      }
	    }).then(function (result) {
	      $log.debug('edit unit', result);
	      load();
	    });
	  }

	  function updateAmenities(amenity, $event) {
	    console.log("update");
	    $mdDialog.show({
	      //   templateUrl: 'app/datasets/codename.edit.html',
	      templateUrl: 'app/datasets/amenities/edit.html',

	      controller: _codenameEdit2.default,
	      controllerAs: '$ctrl',
	      targetEvent: $event,
	      locals: {
	        item: amenity,
	        collectionHref: vm.links.self.href,
	        dsInfo: vm.dsInfo
	      }
	    }).then(function (result) {
	      $log.debug('edit unit', result);
	      load();
	    });
	  }
	}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	CodeNameEditCtrl.$inject = ["$log", "$mdDialog", "datasets", "$http", "item", "collectionHref", "lectusLanguages", "dsInfo"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CodeNameEditCtrl;
	var _ = __webpack_require__(5);

	function CodeNameEditCtrl($log, $mdDialog, datasets, $http, item, collectionHref, lectusLanguages, dsInfo) {
	  "ngInject";

	  var vm = this;

	  vm.langs = lectusLanguages;

	  if (item === null) {
	    if (dsInfo.name === 'tags') {
	      if (dsInfo.name === 'tags') init({
	        code: -1,
	        name: {},
	        type: -1
	      });
	    } else {
	      init({
	        code: -1,
	        name: {}
	      });
	    }
	  } else {

	    $log.debug("get item");
	    $http({
	      method: 'GET',
	      url: item.links.self.href,
	      headers: {
	        "Accept-Language": "**"
	      }
	    }).then(function (res) {
	      return init(res.data);
	    });
	  }

	  function init(item) {
	    console.log("datasets", datasets);

	    //datasets.get("tags")
	    //.then((collection) => (vm.tagTypes = collection.items));
	    var p3 = datasets.bindSets(["tag-type"], vm, true);
	    console.log("dsInfo", dsInfo.name);
	    console.log("vm.tagTypes", vm.tagType);
	    console.log("p3", p3);
	    console.log("p3", vm.tagType);

	    angular.extend(vm, {
	      status: 'loading',
	      title: item.code === -1 ? "Nouveau" : "Modification",
	      dsInfo: dsInfo,
	      copy: item,
	      save: save,
	      cancel: function cancel() {
	        return $mdDialog.cancel();
	      },
	      saveAmenities: saveAmenities,
	      remove: remove,
	      updateAmenities: updateAmenities

	    });
	  }

	  function remove(item, $event) {

	    var confirm = $mdDialog.confirm().title('Etes-vous sûr de vouloir supprimer ?').textContent('Cette opération est irreversible.').ariaLabel('Supression ').targetEvent($event).ok('Supprimer').cancel('Garder');

	    console.log('removeee', stpsls.links.self.href);

	    $mdDialog.show(confirm).then(function () {
	      return $http.delete(item.links.self.href);
	    }).then(function () {
	      return $state.reload();
	    });
	  }

	  function save() {
	    var item = vm.copy;
	    $log.debug("save", item);
	    var promise;
	    if (dsInfo.name === 'tags') {
	      if (item.code === -1) {
	        promise = $http({
	          method: "POST",
	          url: collectionHref,
	          headers: {
	            "Content-Language": "**"
	          },
	          data: _.pick(item, ['name', 'type'])
	        });
	      } else {
	        // shoud just send diff anuse patch
	        promise = $http({
	          method: "PUT",
	          url: item.links.self.href,
	          headers: {
	            "Content-Language": "**"
	          },
	          data: _.pick(item, ['code', 'name', 'type'])
	        });
	      }
	    } else {
	      if (item.code === -1) {
	        promise = $http({
	          method: "POST",
	          url: collectionHref,
	          headers: {
	            "Content-Language": "**"
	          },
	          data: _.pick(item, ['name'])
	        });
	      } else {
	        // shoud just send diff anuse patch
	        promise = $http({
	          method: "PUT",
	          url: item.links.self.href,
	          headers: {
	            "Content-Language": "**"
	          },
	          data: _.pick(item, ['code', 'name'])
	        });
	      }
	    }
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	  }

	  function saveAmenities() {
	    var item = vm.copy;
	    $log.debug("save", item);
	    console.log("save", item);
	    var promise;
	    if (item.code === -1) {

	      if (!item.property) item.property = false;
	      if (!item.unit) item.unit = false;
	      item.rate = false;
	      promise = $http({
	        method: "POST",
	        url: collectionHref,
	        headers: {
	          "Content-Language": "**"
	        },
	        data: _.pick(item, ['name', 'property', 'unit'])
	      });
	    } else {
	      if (!item.property) item.property = false;
	      if (!item.unit) item.unit = false;
	      // shoud just send diff anuse patch
	      promise = $http({
	        method: "PUT",
	        url: item.links.self.href,
	        headers: {
	          "Content-Language": "**"
	        },
	        data: _.pick(item, ['code', 'name', 'property', 'unit'])
	      });
	    }
	    return promise.then(function (res) {
	      return close(res.data);
	    }, saveFailed);
	  }

	  function close(item) {
	    $log.debug("close", item);
	    $mdDialog.hide(item);
	  }

	  function saveFailed() {
	    $log.error(arguments);
	  }

	  function updateAmenities(amenity) {

	    console.log("updateAmenities");
	    $mdDialog.show({
	      //   templateUrl: 'app/datasets/codename.edit.html',
	      templateUrl: 'app/datasets/amenities/edit.html',

	      controller: CodeNameEditCtrl,
	      controllerAs: '$ctrl',
	      targetEvent: $event,
	      locals: {
	        item: amenity,
	        collectionHref: vm.links.self.href,
	        dsInfo: vm.dsInfo
	      }
	    }).then(function (result) {
	      $log.debug('edit unit', result);
	      load();
	    });
	  }
	}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _component = __webpack_require__(141);

	var _component2 = _interopRequireDefault(_component);

	var _component3 = __webpack_require__(142);

	var _component4 = _interopRequireDefault(_component3);

	var _component5 = __webpack_require__(143);

	var _component6 = _interopRequireDefault(_component5);

	var _component7 = __webpack_require__(144);

	var _component8 = _interopRequireDefault(_component7);

	var _component9 = __webpack_require__(145);

	var _component10 = _interopRequireDefault(_component9);

	var _component11 = __webpack_require__(146);

	var _component12 = _interopRequireDefault(_component11);

	var _component13 = __webpack_require__(147);

	var _component14 = _interopRequireDefault(_component13);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module("lectusReports", ["ngAnimate", "ngSanitize", "ngAria", "ui.router", "ngMaterial", "md.data.table", "nvd3", "lectusApi"]).component(_component2.default.name, _component2.default).component(_component4.default.name, _component4.default).component(_component6.default.name, _component6.default).component(_component8.default.name, _component8.default).component(_component10.default.name, _component10.default).component(_component12.default.name, _component12.default).component(_component14.default.name, _component14.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';

	  //$urlRouterProvider.when('/home', '/home/index');

	  var resolveLectusApi = function resolveLectusApi(lectusApi) {
	    "ngInject";

	    return lectusApi;
	  };
	  resolveLectusApi.$inject = ["lectusApi"];

	  // State
	  $stateProvider.state('reports', {
	    url: '/reports',
	    templateUrl: "app/reports/container/template.html",
	    controllerAs: "$ctrl",
	    controller: ["$scope", "$rootScope", "$state", function controller($scope, $rootScope, $state) {
	      'ngInject';

	      $scope.currentState = $state.current.name;
	      var destroy = $rootScope.$on('$routeChangeSuccess', function (event, current) {
	        $scope.currentState = current.name;
	      });
	      $scope.$on('$destroy', function () {
	        destroy();
	      });
	    }],
	    data: {
	      acl: ["contracting"]
	    }
	  }).state('reports.offer', {
	    url: '/offer',
	    component: _component2.default.name,
	    resolve: {
	      lectus: resolveLectusApi
	      //abstract:true
	    } }).state('reports.discrepancies', {
	    url: '/discrepancies',
	    component: _component4.default.name,
	    resolve: {
	      lectus: resolveLectusApi
	      //abstract:true
	    } }).state('reports.monthly', {
	    url: '/monthly',
	    component: _component6.default.name,
	    resolve: {
	      lectus: resolveLectusApi
	      //abstract:true
	    } })
	  // .state('reports.monthlyProperties', {
	  //   url: '/monthlyProperties',
	  //   component: monthlyReportScreen.name,
	  //   resolve:{
	  //     lectus: resolveLectusApi
	  //   }
	  //   //abstract:true
	  // })
	  .state('reports.monthlyProperties', {
	    url: '/monthlyProperties',
	    component: _component8.default.name,
	    resolve: {
	      lectus: resolveLectusApi
	      //abstract:true
	    } });
	}]);

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	"use strict";

	OfferReportCtrl.$inject = ["$log", "$q", "$http", "apiUrl", "$mdPanel"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "offerReport",
	  controller: OfferReportCtrl,
	  templateUrl: "app/reports/offer/template.html"
	};


	function OfferReportCtrl($log, $q, $http, apiUrl, $mdPanel) {
	  "ngInject";

	  var vm = this;
	  //datasets.bindSets(["boards"], vm, true);
	  // if board change, change this hard coded thing
	  vm.boards = {
	    1000: "BO",
	    1100: "BB",
	    1110: "HB",
	    1101: "HBd",
	    1111: "FB",
	    1222: "AI",
	    TOTAL: "TOTAL"
	  };

	  vm.query = {
	    limit: 10,
	    page: 1
	    //const relationsCache = new Map();
	  };vm.loadingPromise = $http.get(apiUrl + "/reports/offer").then(function (res) {
	    //console.log(res.data);
	    vm.report = res.data.filter(function (row) {
	      return row.destination !== null;
	    }).map(processDestination);
	    vm.totals = res.data.find(function (row) {
	      return row.destination === null;
	    });
	    vm.count = vm.report.length;
	  });

	  function processDestination(d) {
	    if (d.products) {
	      if (_.isArray(d.boards)) {
	        d.boards.push(['TOTAL', d.products]);
	      }
	    }
	    return d;
	  }
	}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	"use strict";

	DiscrepanciesReportCtrl.$inject = ["$log", "$q", "$http", "apiUrl"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "discrepanciesReport",
	  controller: DiscrepanciesReportCtrl,
	  templateUrl: "app/reports/discrepancies/template.html"
	};


	function DiscrepanciesReportCtrl($log, $q, $http, apiUrl) {
	  "ngInject";

	  var vm = this;

	  //const relationsCache = new Map();
	  vm.loadingPromise = $http.get(apiUrl + "/reports/discrepancies").then(function (res) {
	    vm.count = res.data.length;
	    vm.report = res.data;
	    vm.options = {
	      rowSelection: false,
	      multiSelect: false,
	      autoSelect: false,
	      decapitate: false,
	      largeEditDialog: false,
	      boundaryLinks: true,
	      limitSelect: true,
	      pageSelect: true
	    };
	    vm.query = {
	      limit: 10,
	      page: 1
	    };
	  });
	}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	MonthlyReportCtrl.$inject = ["$window", "$rootScope", "$log", "$http", "apiUrl", "$timeout"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _chartUtils = __webpack_require__(44);

	var chartUtils = _interopRequireWildcard(_chartUtils);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	exports.default = {
	  name: "monthlyReportScreen",
	  controller: MonthlyReportCtrl,
	  templateUrl: 'app/reports/monthly/template.html',
	  bindings: {
	    lectus: "<"
	  }
	};


	function MonthlyReportCtrl($window, $rootScope, $log, $http, apiUrl, $timeout) {
	  "ngInject";

	  var vm = this;
	  var REPORT_HREF = apiUrl + "/reports/monthly";

	  /*
	    const commonOptions = _.defaultsDeep({
	      chart: {
	        height: 200,
	        useInteractiveGuideline: true,
	        stacked: true,
	        forceY: [0, 100],
	        tooltip: {
	          enable:true,
	          headerFormatter: d => console.log(d)
	        }
	      }
	    }, chartUtils.defaultOptions)
	    */

	  angular.extend(vm, {
	    period: {
	      from: moment().startOf("month").format("YYYY-MM-DD"),
	      to: moment().endOf("month").format("YYYY-MM-DD")
	    },
	    hasNext: true,
	    hasPrevious: true,
	    nextMonth: nextMonth,
	    previousMonth: previousMonth,
	    revenuePieOptions: {
	      chart: {
	        type: 'pieChart',
	        height: 300,
	        width: 400,
	        x: function x(d) {
	          return d.name;
	        },
	        y: function y(d) {
	          return d.confirmedCheckins.revenue;
	        },
	        showLabels: true,
	        duration: 500,
	        labelThreshold: 0.01,
	        labelSunbeamLayout: true,
	        legend: {
	          margin: {
	            top: 5,
	            right: 35,
	            bottom: 5,
	            left: 0
	          }
	        }
	      }
	    }
	  });

	  vm.pies = {
	    bookings: null,
	    bkRevenue: null,
	    checkins: null,
	    ciNights: null,
	    ciRevenue: null
	  };

	  vm.$onInit = function () {
	    load();
	  };

	  function nextMonth() {
	    var start = moment(vm.period.from).add(1, "month");
	    vm.period = {
	      from: start.format("YYYY-MM-DD"),
	      to: moment(start).endOf("month").format("YYYY-MM-DD")
	    };
	    load();
	  }

	  function previousMonth() {
	    var start = moment(vm.period.from).subtract(1, "month");
	    vm.period = {
	      from: start.format("YYYY-MM-DD"),
	      to: moment(start).endOf("month").format("YYYY-MM-DD")
	    };
	    load();
	  }

	  function load() {

	    vm.loadingPromise = $http.get(vm.lectus.links.properties.href).then(function (res) {
	      // if only one hotel and user has no add permission redirect to that hotel
	      if (!res.data.permissions.add && res.data.total == 1) {
	        showProperty(res.data.items[0]);
	      }
	      res.data.items.map(function (prop) {
	        prop.stat = $http.get(apiUrl + "/properties/" + prop.code + "/report", {
	          params: vm.period
	        });
	      });
	      angular.extend(vm, {
	        permissions: res.data.permissions,
	        properties: res.data.items,
	        total: res.data.total
	      });
	    });
	    console.log("vm.properties", vm);
	    console.log("vm.properties", vm.period);

	    // vm.properties.map(prop => {
	    //   prop.stat=$http.get(apiUrl+"properties/"+prop.code+"/report", {
	    //     params: vm.period
	    //   })

	    //   });
	    vm.loading = $http.get(REPORT_HREF, {
	      params: vm.period
	    }).then(function (res) {
	      // last row is totals
	      var totals = res.data.pop();
	      var destinations = res.data;
	      // totals don't have calendars.. (due lack nested aggregation support in ps/sql )
	      var sample = destinations[0].calendar;
	      var calendars = destinations.map(function (d) {
	        return d.calendar;
	      });
	      var totalsCal = _.times(sample.length, function (i) {
	        var day_i = calendars.map(function (c) {
	          return c[i];
	        });
	        return {
	          date: day_i[0].date,
	          booked: _.sum(day_i.map(function (x) {
	            return x.booked;
	          })),
	          available: _.sum(day_i.map(function (x) {
	            return x.available;
	          })), // XXX floating point
	          ciRevenue: _.sum(day_i.map(function (x) {
	            return x.ciRevenue;
	          })), // XXX floating point
	          caRevenue: _.sum(day_i.map(function (x) {
	            return x.caRevenue;
	          })), // XXX floating point
	          bk: _.sum(day_i.map(function (x) {
	            return x.bk;
	          })),
	          ca: _.sum(day_i.map(function (x) {
	            return x.ca;
	          })),
	          ci: _.sum(day_i.map(function (x) {
	            return x.ci;
	          })),
	          co: _.sum(day_i.map(function (x) {
	            return x.co;
	          }))
	        };
	      });
	      totals.calendar = totalsCal;
	      angular.extend(vm, totals);
	      vm.destinations = destinations;
	      pieData(destinations, totals);
	    });
	  }

	  function pieData(destinations, totals) {
	    var bookings = destinations.filter(function (d) {
	      return d.bookings.stays > 0;
	    });
	    var checkins = destinations.filter(function (d) {
	      return d.confirmedCheckins.stays > 0;
	    });

	    ["bookings", 'bkNights', "bkRevenue", "checkins", 'ciNights', "ciRevenue"].filter(function (name) {
	      return _.isObject(vm.pies[name]);
	    }).forEach(function (name) {
	      return vm.pies[name].destroy();
	    });

	    if (bookings.length) {
	      vm.pies.bookings = createPie("bookings-pie", totals.bookings.stays, "réservations", bookings.map(function (d) {
	        return {
	          label: d.name,
	          value: d.bookings.stays,
	          caption: chartUtils.formatNumber(d.bookings.stays) + " séjour(s)"
	        };
	      }));

	      vm.pies.bkNights = createPie("bookings-nights-pie", totals.bookings.nights, "nuitées", bookings.map(function (d) {
	        return {
	          label: d.name,
	          value: d.bookings.nights,
	          caption: chartUtils.formatNumber(d.bookings.nights) + " nuit(s)"
	        };
	      }));
	      vm.pies.bkRevenue = createPie("bookings-revenue-pie", "Revenu", chartUtils.formatNumber(totals.bookings.revenue) + " Devise", bookings.map(function (d) {
	        return {
	          label: d.name,
	          value: d.bookings.revenue,
	          caption: chartUtils.formatNumber(d.bookings.revenue) + " Devise"
	        };
	      }));
	    }

	    if (checkins.length) {
	      vm.pies.checkins = createPie("checkins-pie", totals.confirmedCheckins.stays, "séjours", checkins.map(function (d) {
	        return {
	          label: d.name,
	          value: d.confirmedCheckins.stays,
	          caption: chartUtils.formatNumber(d.confirmedCheckins.stays) + " séjours"
	        };
	      }));
	      vm.pies.ciNights = createPie("checkins-nights-pie", totals.confirmedCheckins.nights, "nuités", checkins.map(function (d) {
	        return {
	          label: d.name,
	          value: d.confirmedCheckins.nights,
	          caption: chartUtils.formatNumber(d.confirmedCheckins.nights) + " nuits"
	        };
	      }));
	      vm.pies.ciRevenue = createPie("checkins-revenue-pie", "Valeur", totals.confirmedCheckins.revenue + " Devise", checkins.map(function (d) {
	        return {
	          label: d.name,
	          value: d.confirmedCheckins.revenue,
	          caption: chartUtils.formatMAD(d.confirmedCheckins.revenue)
	        };
	      }));
	    }
	  }

	  function createPie(elementId, count, unit, data) {
	    return new d3pie(elementId, _.defaultsDeep({
	      header: {
	        title: {
	          text: count
	        },
	        subtitle: {
	          text: unit
	        }
	      },
	      size: {
	        canvasHeight: 240,
	        canvasWidth: 300,
	        pieInnerRadius: "60%",
	        pieOuterRadius: "75%"
	      },
	      misc: {
	        canvasPadding: {
	          "top": 0,
	          "right": 0,
	          "bottom": 0,
	          "left": 0
	        }
	      },
	      tooltips: {
	        type: 'caption'
	      },
	      data: {
	        content: data
	      }
	    }, chartUtils.pieOptions));
	  }

	  /*
	    function mapAvailabilitiesChartData(array, period) {
	      if (array.length === 0) return;
	       // create an array of dates
	      // we now the reportd is guaranteed to equal period
	      const start = moment.utc(period.to);
	      const count = start.diff(moment.utc(period.from), 'days');
	      const dates = _.times(count, i => start.clone()
	        .add(i, "days")
	        .toDate())
	        vm.available.data = array.filter(dest => dest.available !== null)
	        .map(dest =>
	          ({
	            key: dest.name,
	            values: dest.available.map((a, i) => ({
	              date: dates[i],
	              value: a
	            }))
	          })
	        )
	       vm.booked.data = array.filter(dest => dest.booked !== null)
	        .map(dest =>
	          ({
	            key: dest.name,
	            values: dest.booked.map((b, i) => ({
	              date: dates[i],
	              value: b
	            }))
	          })
	        )
	    }
	   */
	}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	MonthlyPropertiesReportCtrl.$inject = ["$window", "$rootScope", "$log", "$http", "apiUrl", "$timeout"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _chartUtils = __webpack_require__(44);

	var chartUtils = _interopRequireWildcard(_chartUtils);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	exports.default = {
	  name: "monthlyPropertiesReportScreen",
	  controller: MonthlyPropertiesReportCtrl,
	  templateUrl: 'app/reports/monthly/monthlyProp.html',
	  bindings: {
	    lectus: "<"
	  }
	};


	function MonthlyPropertiesReportCtrl($window, $rootScope, $log, $http, apiUrl, $timeout) {
	  "ngInject";

	  var vm = this;
	  var REPORT_HREF = apiUrl + "/reports/monthly";

	  /*
	    const commonOptions = _.defaultsDeep({
	      chart: {
	        height: 200,
	        useInteractiveGuideline: true,
	        stacked: true,
	        forceY: [0, 100],
	        tooltip: {
	          enable:true,
	          headerFormatter: d => console.log(d)
	        }
	      }
	    }, chartUtils.defaultOptions)
	    */

	  angular.extend(vm, {
	    period: {
	      from: moment().startOf("month").format("YYYY-MM-DD"),
	      to: moment().endOf("month").format("YYYY-MM-DD")
	    },
	    query: {
	      filter: '',
	      limit: 20,
	      order: 'name',
	      page: 1
	    },

	    hasAvail0Status: hasAvail0Status,
	    hasNext: true,
	    type: 'all',
	    hasPrevious: true,
	    nextMonth: nextMonth,
	    previousMonth: previousMonth,
	    load: load,
	    revenuePieOptions: {
	      chart: {
	        type: 'pieChart',
	        height: 300,
	        width: 400,
	        x: function x(d) {
	          return d.name;
	        },
	        y: function y(d) {
	          return d.confirmedCheckins.revenue;
	        },
	        showLabels: true,
	        duration: 500,
	        labelThreshold: 0.01,
	        labelSunbeamLayout: true,
	        legend: {
	          margin: {
	            top: 5,
	            right: 35,
	            bottom: 5,
	            left: 0
	          }
	        }
	      }
	    }
	  });

	  vm.pies = {
	    bookings: null,
	    bkRevenue: null,
	    checkins: null,
	    ciNights: null,
	    ciRevenue: null
	  };

	  vm.$onInit = function () {
	    load();
	  };

	  function nextMonth() {
	    var start = moment(vm.period.from).add(1, "month");
	    vm.period = {
	      from: start.format("YYYY-MM-DD"),
	      to: moment(start).endOf("month").format("YYYY-MM-DD")
	    };
	    load();
	  }

	  function previousMonth() {
	    var start = moment(vm.period.from).subtract(1, "month");
	    vm.period = {
	      from: start.format("YYYY-MM-DD"),
	      to: moment(start).endOf("month").format("YYYY-MM-DD")
	    };
	    load();
	  }

	  function load() {
	    var _arguments = arguments;

	    console.log("in MonthlyPropertiesReportCtrl ");
	    var sort = vm.query.order.indexOf("-") === 0 ? vm.query.order.replace("-", "") + ">" : vm.query.order + '<';
	    vm.loadingPromise = $http.get(vm.lectus.links.properties.href, {
	      params: {
	        $limit: vm.query.limit,
	        $skip: vm.query.page * vm.query.limit - vm.query.limit,
	        $sort: sort
	        // search: vm.query.filter || undefined,
	        // locality: vm.query.locality ? vm.query.locality.code : undefined
	      }
	    }).then(function (res) {
	      // if only one hotel and user has no add permission redirect to that hotel
	      var propHasAvail0 = [];
	      res.data.items.map(function (prop) {
	        //prop.stopsale00= $http.get(prop.links["stop-sales"].href , {
	        prop.stopsale00 = $http.get(prop.links.self.href + "/stopSalesList", {
	          params: vm.period
	          // headers: {
	          //   'accept-language': ''
	          // }
	        }).then(function (res) {
	          $log.debug('stopsales loaded', res.data);
	          console.log('stopsales loaded', res.data);
	          prop.stopsaless = res.data;
	          //vm.discount = discountsHelper.parse(res.data);
	        }, function () {
	          $log.debug('error loading stopsales', _arguments);
	        });

	        prop.stat = $http.get(prop.links.self.href + "/report", {
	          //apiUrl+"/properties/"+prop.code+"/report", {
	          params: vm.period

	        }).then(function (resProp) {
	          prop.statFinal = resProp.data;
	          prop.hasAvail0 = false;
	          resProp.data.calendar.map(function (calend) {
	            console.log("calend.available", calend.available);

	            if (calend.available == 0) prop.hasAvail0 = true;
	            console.log("calend.available", calend.available);
	            console.log("resProp.hasAvail0", prop.hasAvail0);
	          });
	          console.log("yesss", prop.hasAvail0);
	          if (prop.hasAvail0 === true) {
	            propHasAvail0.push(prop);
	            console.log("yesss");
	          }
	        });
	      });
	      // res.data.items.map(proper => {
	      //   console.log("proper.hasAvail0",proper);
	      //   console.log("proper.hasAvail00 ",proper.code);
	      //   console.log("proper.hasAvail000 ",proper.hasAvail0);

	      //   if(proper.hasAvail0===true) propHasAvail0.push(proper);
	      // })


	      vm.loading = $http.get(REPORT_HREF, {
	        params: vm.period
	      }).then(function (res) {
	        // last row is totals
	        var totals = res.data.pop();
	        var destinations = res.data;
	        // totals don't have calendars.. (due lack nested aggregation support in ps/sql )
	        var sample = destinations[0].calendar;
	        var calendars = destinations.map(function (d) {
	          return d.calendar;
	        });
	        var totalsCal = _.times(sample.length, function (i) {
	          var day_i = calendars.map(function (c) {
	            return c[i];
	          });
	          return {
	            date: day_i[0].date,
	            booked: _.sum(day_i.map(function (x) {
	              return x.booked;
	            })),
	            available: _.sum(day_i.map(function (x) {
	              return x.available;
	            })), // XXX floating point
	            ciRevenue: _.sum(day_i.map(function (x) {
	              return x.ciRevenue;
	            })), // XXX floating point
	            caRevenue: _.sum(day_i.map(function (x) {
	              return x.caRevenue;
	            })), // XXX floating point
	            bk: _.sum(day_i.map(function (x) {
	              return x.bk;
	            })),
	            ca: _.sum(day_i.map(function (x) {
	              return x.ca;
	            })),
	            ci: _.sum(day_i.map(function (x) {
	              return x.ci;
	            })),
	            co: _.sum(day_i.map(function (x) {
	              return x.co;
	            }))
	          };
	        });
	        totals.calendar = totalsCal;
	        angular.extend(vm, totals);
	        vm.destinations = destinations;
	        pieData(destinations, totals);
	      });
	      angular.extend(vm, {
	        permissions: res.data.permissions,
	        propertiesHasAvail0: propHasAvail0,
	        properties: res.data.items,
	        total: res.data.total
	      });
	    });
	    console.log("vm.properties", vm);
	    console.log("vm.properties", vm.period);

	    // vm.properties.map(prop => {
	    //   prop.stat=$http.get(apiUrl+"properties/"+prop.code+"/report", {
	    //     params: vm.period
	    //   })

	    //   });
	    // vm.loading = $http.get(REPORT_HREF, {
	    //     params: vm.period
	    //   })
	    //   .then(res => {
	    //     // last row is totals
	    //     const totals = res.data.pop();
	    //     const destinations = res.data;
	    //     // totals don't have calendars.. (due lack nested aggregation support in ps/sql )
	    //     const sample = destinations[0].calendar;
	    //     const calendars = destinations.map(d => d.calendar);
	    //     const totalsCal = _.times(sample.length, i => {
	    //       const day_i = calendars.map(c => c[i]);
	    //       return {
	    //         date: day_i[0].date,
	    //         booked: _.sum(day_i.map(x => x.booked)),
	    //         available: _.sum(day_i.map(x => x.available)), // XXX floating point
	    //         ciRevenue: _.sum(day_i.map(x => x.ciRevenue)), // XXX floating point
	    //         caRevenue: _.sum(day_i.map(x => x.caRevenue)), // XXX floating point
	    //         bk: _.sum(day_i.map(x => x.bk)),
	    //         ca: _.sum(day_i.map(x => x.ca)),
	    //         ci: _.sum(day_i.map(x => x.ci)),
	    //         co: _.sum(day_i.map(x => x.co))
	    //       }
	    //     })
	    //     totals.calendar = totalsCal;
	    //     angular.extend(vm, totals);
	    //     vm.destinations = destinations;
	    //    // pieData(destinations, totals);
	    //   })
	  }

	  function hasAvail0Status() {
	    console.log("vm.hasAvail0Status", vm.hasAvail0);
	    if (vm.hasAvail0 == false) vm.hasAvail0 = true;else vm.hasAvail0 = false;
	  }

	  function pieData(destinations, totals) {
	    var bookings = destinations.filter(function (d) {
	      return d.bookings.stays > 0;
	    });
	    var checkins = destinations.filter(function (d) {
	      return d.confirmedCheckins.stays > 0;
	    });
	    var avail = destinations.filter(function (d) {
	      return d.bookings.avail > 0;
	    });
	    ["bookings", 'bkNights', "bkRevenue", "checkins", 'ciNights', "ciRevenue"].filter(function (name) {
	      return _.isObject(vm.pies[name]);
	    }).forEach(function (name) {
	      return vm.pies[name].destroy();
	    });

	    destinations.map(function (d) {
	      console.log("distavail::", d.name);
	      console.log("availavail::", d.bookings.avail);
	    });

	    vm.pies.avail = createPie("avail-nights-pie", totals.bookings.avail, "Nuits", bookings.map(function (d) {
	      return {
	        label: d.name,
	        value: d.bookings.avail,
	        caption: chartUtils.formatNumber(d.bookings.avail) + " nuit(s)"
	      };
	    }));

	    if (bookings.length) {
	      vm.pies.bookings = createPie("bookings-pie", totals.bookings.stays, "réservations", bookings.map(function (d) {
	        return {
	          label: d.name,
	          value: d.bookings.stays,
	          caption: chartUtils.formatNumber(d.bookings.stays) + " séjour(s)"
	        };
	      }));

	      vm.pies.bkNights = createPie("bookings-nights-pie", totals.bookings.nights, "nuitées", bookings.map(function (d) {
	        return {
	          label: d.name,
	          value: d.bookings.nights,
	          caption: chartUtils.formatNumber(d.bookings.nights) + " nuit(s)"
	        };
	      }));
	      vm.pies.bkRevenue = createPie("bookings-revenue-pie", "Revenu", chartUtils.formatNumber(totals.bookings.revenue) + " Devise", bookings.map(function (d) {
	        return {
	          label: d.name,
	          value: d.bookings.revenue,
	          caption: chartUtils.formatNumber(d.bookings.revenue) + " Devise"
	        };
	      }));
	    }

	    if (checkins.length) {
	      vm.pies.checkins = createPie("checkins-pie", totals.confirmedCheckins.stays, "séjours", checkins.map(function (d) {
	        return {
	          label: d.name,
	          value: d.confirmedCheckins.stays,
	          caption: chartUtils.formatNumber(d.confirmedCheckins.stays) + " séjours"
	        };
	      }));
	      vm.pies.ciNights = createPie("checkins-nights-pie", totals.confirmedCheckins.nights, "nuités", checkins.map(function (d) {
	        return {
	          label: d.name,
	          value: d.confirmedCheckins.nights,
	          caption: chartUtils.formatNumber(d.confirmedCheckins.nights) + " nuits"
	        };
	      }));
	      vm.pies.ciRevenue = createPie("checkins-revenue-pie", "Valeur", totals.confirmedCheckins.revenue + " Devise", checkins.map(function (d) {
	        return {
	          label: d.name,
	          value: d.confirmedCheckins.revenue,
	          caption: chartUtils.formatMAD(d.confirmedCheckins.revenue)
	        };
	      }));
	    }
	  }

	  function createPie(elementId, count, unit, data) {
	    return new d3pie(elementId, _.defaultsDeep({
	      header: {
	        title: {
	          text: count
	        },
	        subtitle: {
	          text: unit
	        }
	      },
	      size: {
	        canvasHeight: 240,
	        canvasWidth: 300,
	        pieInnerRadius: "60%",
	        pieOuterRadius: "75%"
	      },
	      misc: {
	        canvasPadding: {
	          "top": 0,
	          "right": 0,
	          "bottom": 0,
	          "left": 0
	        }
	      },
	      tooltips: {
	        type: 'caption'
	      },
	      data: {
	        content: data
	      }
	    }, chartUtils.pieOptions));
	  }
	  /*
	    function mapAvailabilitiesChartData(array, period) {
	      if (array.length === 0) return;
	       // create an array of dates
	      // we now the reportd is guaranteed to equal period
	      const start = moment.utc(period.to);
	      const count = start.diff(moment.utc(period.from), 'days');
	      const dates = _.times(count, i => start.clone()
	        .add(i, "days")
	        .toDate())
	        vm.available.data = array.filter(dest => dest.available !== null)
	        .map(dest =>
	          ({
	            key: dest.name,
	            values: dest.available.map((a, i) => ({
	              date: dates[i],
	              value: a
	            }))
	          })
	        )
	       vm.booked.data = array.filter(dest => dest.booked !== null)
	        .map(dest =>
	          ({
	            key: dest.name,
	            values: dest.booked.map((b, i) => ({
	              date: dates[i],
	              value: b
	            }))
	          })
	        )
	    }
	   */
	}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moment = __webpack_require__(10);
	var d3 = __webpack_require__(15);

	exports.default = {
	  name: "calendarChart",
	  controller: CalendarChartCtrl,
	  templateUrl: "app/reports/calendar-chart/template.html",
	  bindings: {
	    reportData: "<",
	    reportPeriod: "<",
	    viewBy: "<"
	  }
	};


	function CalendarChartCtrl() {
	  "ngInject";

	  var vm = this;

	  var COLORS = {
	    bk: '#2196F3',
	    ca: '#F44336',
	    // ci:'#FF9800',
	    ci: '#95c5b6',
	    co: '#8BC34A'
	  };

	  var series = [{
	    key: "Réservé",
	    name: "booked",
	    color: COLORS.bk,
	    values: []
	  }, {
	    key: "Disponible",
	    name: "available",
	    color: COLORS.co,
	    values: []
	  }, {
	    key: "Réservations",
	    name: "bkRevenue",
	    color: COLORS.bk,
	    values: []
	  }, {
	    key: "Séjours",
	    name: "ciRevenue",
	    color: COLORS.ci,
	    values: []
	  }, {
	    key: "Annulation",
	    name: "caRevenue",
	    color: COLORS.ca,
	    dvalues: []
	  }, {
	    key: "Réservations",
	    name: "bk",
	    color: COLORS.bk,
	    values: []
	  }, {
	    key: "Annulations",
	    name: "ca",
	    color: COLORS.ca,
	    values: []
	  }, {
	    key: "Arrivées",
	    name: "ci",
	    color: COLORS.ci,
	    values: []
	  }, {
	    key: "Départs",
	    name: "co",
	    color: COLORS.co,
	    values: []
	  }];

	  init();

	  function init() {

	    var formatNumber = d3.format(',');
	    var formatMAD = function formatMAD(v) {
	      return formatNumber(v) + " ";
	    };

	    var defaultOptions = {
	      deepWatchOptions: false,
	      deepWatchData: false,
	      deepWatchDataDepth: false,
	      chart: {
	        type: "multiBarChart",
	        x: function x(d) {
	          return d.date;
	        },
	        y: function y(d) {
	          return d.value;
	        },
	        showValues: true,
	        showLegend: true,
	        showControls: false,
	        stacked: true,
	        forceY: [0, 1000],
	        duration: 500,
	        height: 160,
	        xAxis: {
	          tickFormat: function tickFormat(d) {
	            return moment(d).format('ddd D');
	          },
	          ticks: d3.time.week,
	          showMaxMin: true
	        },
	        //reduceXTicks: false,
	        yAxis: {
	          tickFormat: formatNumber,
	          showMaxMin: false
	        },
	        tooltip: {
	          headerFormatter: d3.time.format("%A %-d %b %Y")
	        }
	      }
	    };

	    angular.extend(vm, {
	      nights: {
	        options: _.defaultsDeep({
	          chart: {
	            forceY: [0, 10]
	          }
	        }, defaultOptions),
	        data: series.filter(function (s) {
	          return ["booked", "available"].includes(s.name);
	        })
	      },
	      revenue: {
	        options: _.defaultsDeep({
	          chart: {
	            stacked: true,
	            yAxis: {
	              tickFormat: function tickFormat(v) {
	                return v < 1000 ? formatMAD(v) : formatNumber(v / 1000) + "K ";
	              }
	            },
	            tooltip: {
	              valueFormatter: formatMAD,
	              keyFormatter: function keyFormatter(v) {
	                return 'Revenu ' + v;
	              }
	            }
	          }
	        }, defaultOptions),
	        data: series.filter(function (s) {
	          return ["ciRevenue", "caRevenue"].includes(s.name);
	        })

	      },
	      events: {
	        options: _.defaultsDeep({
	          chart: {
	            stacked: false,
	            forceY: [0, 5]
	          }
	        }, defaultOptions),
	        //options: eventsOptions,
	        data: series.filter(function (s) {
	          return ["bk", "ca", "ci", "co"].includes(s.name);
	        })
	      }
	    });
	  }

	  vm.$onChanges = function (changes) {
	    if (changes.reportData && vm.reportData) {
	      updateCalendar(vm.reportData);
	    }
	    if (changes.viewBy) {
	      if (vm.viewBy === "booking") {

	        vm.revenue.data = series.filter(function (s) {
	          return ["bkRevenue", "caRevenue"].includes(s.name);
	        });
	      } else if (vm.viewBy === "checkin") {
	        vm.revenue.data = series.filter(function (s) {
	          return ["ciRevenue", "caRevenue"].includes(s.name);
	        });
	      }
	    }
	  };

	  function updateCalendar(data) {
	    series.forEach(function (s) {
	      return s.values = new Array(data.length);
	    });
	    data.forEach(function (d, day) {
	      var date = moment.utc(d.date).toDate();
	      series.forEach(function (s) {
	        s.values[day] = {
	          date: date,
	          value: d[s.name]
	        };
	      });
	    });
	  }
	}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moment = __webpack_require__(10);
	var d3 = __webpack_require__(15);

	exports.default = {
	  name: "calendarCharts",
	  controller: CalendarChartsCtrl,
	  templateUrl: "app/reports/calendar-chart-prop-dispo/template.html",
	  bindings: {
	    reportData: "<",
	    reportPeriod: "<",
	    viewBy: "<"
	  }
	};


	function CalendarChartsCtrl() {
	  "ngInject";

	  var vm = this;

	  var COLORS = {
	    bk: '#2196F3',
	    ca: '#F44336',
	    // ci:'#FF9800',
	    ci: '#95c5b6',
	    co: '#8BC34A'
	  };

	  var series = [{
	    key: "Réservé",
	    name: "booked",
	    color: COLORS.bk,
	    values: []
	  }, {
	    key: "Disponible",
	    name: "available",
	    color: COLORS.co,
	    values: []
	  }, {
	    key: "Réservations",
	    name: "bkRevenue",
	    color: COLORS.bk,
	    values: []
	  }, {
	    key: "Séjours",
	    name: "ciRevenue",
	    color: COLORS.ci,
	    values: []
	  }, {
	    key: "Annulation",
	    name: "caRevenue",
	    color: COLORS.ca,
	    dvalues: []
	  }, {
	    key: "Réservations",
	    name: "bk",
	    color: COLORS.bk,
	    values: []
	  }, {
	    key: "Annulations",
	    name: "ca",
	    color: COLORS.ca,
	    values: []
	  }, {
	    key: "Arrivées",
	    name: "ci",
	    color: COLORS.ci,
	    values: []
	  }, {
	    key: "Départs",
	    name: "co",
	    color: COLORS.co,
	    values: []
	  }];

	  init();

	  function init() {

	    var formatNumber = d3.format(',');
	    var formatMAD = function formatMAD(v) {
	      return formatNumber(v) + " ";
	    };

	    var defaultOptions = {
	      deepWatchOptions: false,
	      deepWatchData: false,
	      deepWatchDataDepth: false,
	      chart: {
	        type: "multiBarChart",
	        x: function x(d) {
	          return d.date;
	        },
	        y: function y(d) {
	          return d.value;
	        },
	        showValues: true,
	        showLegend: true,
	        showControls: false,
	        stacked: true,
	        forceY: [0, 1000],
	        duration: 500,
	        height: 160,
	        xAxis: {
	          tickFormat: function tickFormat(d) {
	            return moment(d).format('ddd D');
	          },
	          ticks: d3.time.week,
	          showMaxMin: true
	        },
	        //reduceXTicks: false,
	        yAxis: {
	          tickFormat: formatNumber,
	          showMaxMin: false
	        },
	        tooltip: {
	          headerFormatter: d3.time.format("%A %-d %b %Y")
	        }
	      }
	    };

	    angular.extend(vm, {
	      nights: {
	        options: _.defaultsDeep({
	          chart: {
	            forceY: [0, 10]
	          }
	        }, defaultOptions),
	        data: series.filter(function (s) {
	          return ["booked", "available"].includes(s.name);
	        })
	      },
	      revenue: {
	        options: _.defaultsDeep({
	          chart: {
	            stacked: true,
	            yAxis: {
	              tickFormat: function tickFormat(v) {
	                return v < 1000 ? formatMAD(v) : formatNumber(v / 1000) + "K ";
	              }
	            },
	            tooltip: {
	              valueFormatter: formatMAD,
	              keyFormatter: function keyFormatter(v) {
	                return 'Revenu ' + v;
	              }
	            }
	          }
	        }, defaultOptions),
	        data: series.filter(function (s) {
	          return ["ciRevenue", "caRevenue"].includes(s.name);
	        })

	      },
	      events: {
	        options: _.defaultsDeep({
	          chart: {
	            stacked: false,
	            forceY: [0, 5]
	          }
	        }, defaultOptions),
	        //options: eventsOptions,
	        data: series.filter(function (s) {
	          return ["bk", "ca", "ci", "co"].includes(s.name);
	        })
	      }
	    });
	  }

	  vm.$onChanges = function (changes) {
	    if (changes.reportData && vm.reportData) {
	      updateCalendar(vm.reportData);
	    }
	    if (changes.viewBy) {
	      if (vm.viewBy === "booking") {

	        vm.revenue.data = series.filter(function (s) {
	          return ["bkRevenue", "caRevenue"].includes(s.name);
	        });
	      } else if (vm.viewBy === "checkin") {
	        vm.revenue.data = series.filter(function (s) {
	          return ["ciRevenue", "caRevenue"].includes(s.name);
	        });
	      }
	    }
	  };

	  function updateCalendar(data) {
	    series.forEach(function (s) {
	      return s.values = new Array(data.length);
	    });
	    data.forEach(function (d, day) {
	      var date = moment.utc(d.date).toDate();
	      series.forEach(function (s) {
	        s.values[day] = {
	          date: date,
	          value: d[s.name]
	        };
	      });
	    });
	  }
	}

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "overallReport",
	  controller: OverallReportCtrl,
	  templateUrl: "app/reports/overall/template.html",
	  bindings: {
	    bookings: "<",
	    cancellations: "<",
	    confirmedCheckins: "<",
	    canceledCheckins: "<",
	    viewBy: "<"
	  }
	};


	function OverallReportCtrl() {
	  "ngInject";

	  var vm = this;
	  vm.byBookingDate = true;
	  vm.byCheckinDate = true;
	  vm.singleMode = false;

	  vm.$onChanges = function (change) {
	    if (change.viewBy) {
	      switch (vm.viewBy) {
	        case "booking":
	          vm.byBookingDate = true;
	          vm.byCheckinDate = false;
	          vm.singleMode = true;
	          break;
	        case "checkin":
	          vm.byBookingDate = false;
	          vm.byCheckinDate = true;
	          vm.singleMode = true;
	          break;
	        default:
	          vm.byBookingDate = true;
	          vm.byCheckinDate = true;
	      }
	    }
	  };
	}

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isolateForm;

	// isolate sub form
	function isolateForm() {
	  'ngInject';

	  return {
	    restrict: 'A',
	    require: '?form',
	    link: function link(scope, elm, attrs, ctrl) {
	      if (!ctrl) {
	        return;
	      }
	      // Do a copy of the controller
	      var ctrlCopy = {};
	      angular.copy(ctrl, ctrlCopy);

	      // Get the parent of the form
	      var parent = elm.parent().controller('form');
	      // Remove parent link to the controller
	      parent.$removeControl(ctrl);

	      // Replace form controller with a "isolated form"
	      var isolatedFormCtrl = {
	        $setValidity: function $setValidity(validationToken, isValid, control) {
	          ctrlCopy.$setValidity(validationToken, isValid, control);
	          parent.$setValidity(validationToken, true, ctrl);
	        },
	        $setDirty: function $setDirty() {
	          elm.removeClass('ng-pristine').addClass('ng-dirty');
	          ctrl.$dirty = true;
	          ctrl.$pristine = false;
	        }
	      };
	      angular.extend(ctrl, isolatedFormCtrl);
	    }
	  };
	}

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	'use strict';

	TopBarCtrl.$inject = ["User", "Auth", "$state"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  templateUrl: 'app/components/topbar/template.html',
	  controller: TopBarCtrl
	};


	function TopBarCtrl(User, Auth, $state) {
	  'ngInject';

	  this.user = User;

	  var NAV = [{ label: "Etablissement", state: "properties", roles: ["*"] }, { label: "Réservations", state: "bookings", roles: ["atlasvoyages"] }, { label: "Rapports", state: "reports", roles: ["atlasvoyages"] }, { label: "Destinations", state: "destinations", roles: ["atlasvoyages"] }, { label: "Datasets", state: "datasets", roles: ["atlasvoyages"] }];

	  // console.log($state.current);
	  this.$state = $state;

	  this.links = {
	    account: Auth.createAccountUrl(),
	    logout: Auth.createLogoutUrl()
	  };

	  var roles = ["*"].concat(User.realm_access.roles);
	  console.log("roles ", roles);
	  for (var i = 0; i < roles.length; i++) {
	    console.log("roleslength ", roles.length);

	    if (roles[i] === "dmc") roles[i] = "atlasvoyages";
	    // if (roles[i] === "Comptable") roles[i] = "atlasvoyages";
	    // if (roles[i] === "To") roles[i] = "atlasvoyages";
	    // if (roles[i] === "Admin") roles[i] = "atlasvoyages";
	  }

	  console.log("roleslast ", roles);

	  this.navTabs = NAV.filter(function (item) {
	    return _.intersection(roles, item.roles).length;
	  });

	  this.goto = function (state) {
	    $state.go(state);
	  };
	}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	'use strict';

	themeConfig.$inject = ["$mdThemingProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = themeConfig;
	function themeConfig($mdThemingProvider) {
	  'ngInject';

	  var neonRedMap = $mdThemingProvider.extendPalette('orange', {
	    'contrastDefaultColor': 'light'
	  });

	  $mdThemingProvider.definePalette('atlas', neonRedMap);

	  var primaryPalette = "atlas";

	  $mdThemingProvider.theme('default').primaryPalette(primaryPalette, {
	    'default': '500', // by default use shade 400 from the pink palette for primary intentions
	    'hue-1': '100', // use shade 100 for the <code>md-hue-1</code> class
	    'hue-2': '400', // use shade 600 for the <code>md-hue-2</code> class
	    'hue-3': '700' // use shade A100 for the <code>md-hue-3</code> class
	  })
	  // If you specify less than all of the keys, it will inherit from the
	  // default shades
	  .accentPalette('blue', {
	    'default': '500' // use shade 200 for default, and keep all other shades the same
	  }).warnPalette('red');
	}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	'use strict';

	authInterceptor.$inject = ["$q", "Auth", "$log", "$window"];
	authHttpConfig.$inject = ["$httpProvider"];
	User.$inject = ["$window"];
	Auth.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authInterceptor = authInterceptor;
	exports.authHttpConfig = authHttpConfig;
	exports.User = User;
	exports.Auth = Auth;
	function authInterceptor($q, Auth, $log, $window) {
	  'ngInject';

	  return {
	    request: function request(config) {
	      //console.log("isTokenExpired", Auth.isTokenExpired());
	      var deferred = $q.defer();
	      // update token is valid for less than 5 seconds ()
	      //console.log(Auth.token);
	      Auth.updateToken(5).success(function () {
	        config.headers = config.headers || {};
	        // console.log('Auth.token...', Auth.token)
	        // if (!config.headers.Authorization)
	        config.headers.Authorization = 'Bearer ' + Auth.token;
	        deferred.resolve(config);
	      }).error(function (e) {
	        $log.error(e);
	        deferred.reject('Failed to refresh token');
	        $window.location.refresh(); // should be else where
	      });
	      return deferred.promise;
	    }
	  };
	}

	function authHttpConfig($httpProvider) {
	  'ngInject';

	  $httpProvider.interceptors.push('authInterceptor');
	}

	function User($window) {
	  'ngInject';

	  return $window._keycloak.tokenParsed;
	}
	function Auth($window) {
	  'ngInject';

	  return $window._keycloak;
	}

	/*
	export default function (ngModule) {
	  ngModule
	  .factory('User', $window => {
	    return $window._keycloak.tokenParsed;
	  })
	  .factory('Auth', $window => $window._keycloak)
	  .factory("authInterceptor",authInterceptor)
	  .config(httpConfig);
	}
	*/

/***/ })
/******/ ]);
angular.module("lectusAdminWui").run(["$templateCache", function($templateCache) {$templateCache.put("app/bookings/cc.html","<md-dialog aria-label=\"Credit card info\"><md-dialog-content layout=column style=\"padding:32px 16px 16px\"><md-input-container><label>Numéro</label><input readonly value={{::$ctrl.cc.number}}></md-input-container><md-input-container><label>Expiration</label><input readonly value={{::$ctrl.cc.month}}/{{::$ctrl.cc.year}}></md-input-container><md-input-container><label>CVV</label><input readonly value={{::$ctrl.cc.cvv}}></md-input-container><md-input-container ng-if=$ctrl.cc.name><label>Nom</label><input readonly value={{::$ctrl.cc.name}}></md-input-container></md-dialog-content><md-dialog-actions><md-button ng-click=$ctrl.close() class=md-primary>fermer</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/datasets/codename.edit.html","<md-dialog><form name=datasetItemForm><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><md-input-container ng-repeat=\"lang in ::$ctrl.langs\"><label>Libellé ({{lang.name}})</label><input type=text name=name required maxlength=128 ng-model=$ctrl.copy.name[lang.code] ng-pattern=/^(?![A-Z]{2,}).*$/ ><div ng-messages=unitForm.name.$error multiple><div ng-message=pattern>Prière de ne pas tout mettre en majuscule.</div></div></md-input-container><md-input-container ng-if=\"$ctrl.dsInfo.name==\'tags\'\"><label>Type de Tag</label><!-- <input md-maxlength=\"30\" required name=\"name\" ng-model=\"prestation.name\" /> --><md-select ng-change=\"\" ng-model=$ctrl.copy.type><!-- <md-option ng-value=\"-1\"> Toutes les chambres </md-option> --><md-option ng-repeat=\"tagType in $ctrl.tagType\" ng-value={{tagType.code}}>{{tagType.name}}</md-option></md-select><!-- <div class=\"hint\" ng-if=\"showHints\">Tell us what we should call you!</div>\n\n                    <div ng-messages=\"projectForm.name.$error\" ng-if=\"!showHints\">\n                        <div ng-message=\"required\">Name is required.</div>\n                        <div ng-message=\"md-maxlength\">The name has to be less than 30 characters long.</div>\n                    </div> --></md-input-container></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save() ng-disabled=datasetItemForm.$invalid>Enregister</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/datasets/codename.list.html","<thead md-head><tr md-row><th md-column><span>Code</span></th><th md-column><span>Libellé</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"i in $ctrl.items\"><td md-cell>{{i.code}}</td><td md-cell><!-- <div  ng-if=\"$ctrl.dsInfo.name!= \'boards\'\" class=\"translation\" ng-repeat=\"(lang,name) in i.name \" ng-click=\"$ctrl.edit(i,$event)\"><strong>{{::lang}}</strong> {{::name}}--><div ng-if=\"$ctrl.dsInfo.name!= \'boards\'\" ng-repeat=\"(lang,name) in i.name \" ng-click=$ctrl.edit(i,$event)><strong>{{::lang}}</strong> {{::name}}<!-- <div ng-if=\"$ctrl.dsInfo.name!= \'boards\'\" ng-repeat=\"name in i.name track by $index\" ng-click=\"$ctrl.edit(i,$event)\"> {{::name}} --></div><div ng-if=\"$ctrl.dsInfo.name== \'boards\'\" class=translation ng-repeat=\"(lang,name) in i.name \" ng-click=$ctrl.edit(i,$event)><strong>{{::lang}}</strong> {{::name}}<!-- <div ng-if=\"$ctrl.dsInfo.name== \'boards\'\" ng-click=\"$ctrl.edit(i,$event)\"> {{::i.name}} --></div></td><td md-cell><md-button ng-if=\"$ctrl.dsInfo.name!=\'destinations\' && $ctrl.dsInfo.name!=\'rating-systems\' \" class=\"md-icon-button md-warn\" aria-label=Settings ng-click=$ctrl.remove(i,$event)><md-icon>delete</md-icon></md-button></td></tr></tbody>");
$templateCache.put("app/allotment/add/template.html","<md-dialog><header><h2 class=md-title style=margin:0>Nouvel allotement - {{::$ctrl.unit.name}}</h2></header><form><md-dialog-content class=md-dialog-content ng-if=\"$ctrl.options.availableRateBases.length > 0\"><div><p>Choisissez les bases tarifaires à assigner à cet allotement</p><md-checkbox ng-repeat=\"basis in ::$ctrl.options.availableRateBases\" ng-model=$ctrl.selectedRateBases[basis.code]>{{::basis.description}}</md-checkbox></div></md-dialog-content><md-dialog-content ng-if=\"$ctrl.options.availableRateBases.length === 0\" layout-padding layout-margin><p>Toutes les bases tarifaire ont été assignées à des allotements pour la categorie {{::$ctrl.unit.name}}</p></md-dialog-content><md-dialog-actions><md-button ng-show=\"$ctrl.options.availableRateBases.length > 0\" ng-click=$ctrl.add()>Ajouter</md-button><md-button ng-click=$ctrl.close()>Fermer</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/allotment/bases-assignments/template.html","<header><h2>Affectation des bases tarifaires</h2></header><aside class=hint><p>Pour affecter une base tarifaire à un allotement, glissez la base tarifaire vers l\'allotement</p></aside><div class=content><div class=\"rate-bases-assignment unassigned\"><header>Tarifs</header><ul><li ng-repeat=\"basis in $ctrl.rateBases\" dnd-draggable=basis.code><span>{{::basis.description}}</span></li></ul></div><div ng-if=$ctrl.unitAllotments.openSell class=\"rate-bases-assignment open-sell\" ng-style=$ctrl.unitAllotments.openSell.style dnd-list=$ctrl.unitAllotments.openSell.bases dnd-disable-if=\"$ctrl.unitAllotments.openSell.premissions.edit == false\" dnd-drop=\"$ctrl.dropBasisOnAllotment(item, $ctrl.unitAllotments.openSell)\"><header>flex</header><ul><li ng-repeat=\"code in $ctrl.unitAllotments.openSell.bases\"><span flex>{{::$ctrl.unitAllotments.rateBasesIndex[code].description}}</span><md-button ng-if=::$ctrl.unitAllotments.openSell.permissions.edit ng-hide=\"$ctrl.unitAllotments.openSell.bases.length === 1\" class=md-icon-button ng-click=$ctrl.unassignRateBasis(code,$ctrl.unitAllotments.openSell)><md-icon>close</md-icon><md-tooltip>retirer de le l\'allotment flexible</md-tooltip></md-button></li></ul><footer><md-button ng-if=::$ctrl.unitAllotments.openSell.permissions.delete class=md-icon-button ng-click=$ctrl.deleteAllotment($ctrl.unitAllotments.openSell)><md-icon>delete</md-icon><md-tooltip>désactiver l\'allotment flexible</md-tooltip></md-button></footer></div><div class=rate-bases-assignment ng-repeat=\"a in $ctrl.unitAllotments.allotments | filter:{contracted:true}\" ng-style=a.style dnd-list=a.bases dnd-disable-if=\"a.permissions.edit == false\" dnd-drop=\"$ctrl.dropBasisOnAllotment(item, a)\"><header>allotment <span>{{$index+1}}</span></header><ul><li ng-repeat=\"code in a.bases\"><span flex>{{::$ctrl.unitAllotments.rateBasesIndex[code].description}}</span><md-button ng-if=::a.permissions.edit class=md-icon-button ng-hide=\"a.bases.length === 1\" ng-click=$ctrl.unassignRateBasis(code,a)><md-icon style=height:14px>close</md-icon><md-tooltip>retirer de cet allotement</md-tooltip></md-button></li></ul><div ng-if=\"a.bases.length === 0\" style=\"padding:4px; font-size:12px; text-align:center\"><md-icon>error</md-icon><br><span>Aucune base tarifaire affectée</span></div><footer><md-button ng-if=::a.permissions.delete class=md-icon-button ng-click=$ctrl.deleteAllotment(a)><md-icon>delete</md-icon><md-tooltip>supprimer cet allotement</md-tooltip></md-button></footer></div><div ng-show=\"$ctrl.unassignedRateBases.length > 0\"><md-button ng-if=::$ctrl.unitAllotments.permissions.add ng-disabled=\"$ctrl.unassignedRateBases.length === 0\" class=md-accent ng-click=$ctrl.createAllotment()>Ajouter un allotement</md-button></div><div ng-if=\"$ctrl.unitAllotments.allotments && !$ctrl.unitAllotments.openSell\" layout=column class=\"message warn\" style=\"background-color:rgb(255, 152, 0)\"><md-icon>error</md-icon><p>allotment flex non activé</p><footer flex layout=row layout-align=\"center end\"><md-button class=secondary ng-click=$ctrl.createOpenSell()>Activer</md-button></footer></div></div>");
$templateCache.put("app/allotment/calendar-edit/dialog.html","<md-dialog class=edit-availability aria-label=\"Modifier un allotment\"><header><h2 class=md-subhead>Modifier un allotement</h2><md-button class=md-icon-button ng-click=$ctrl.cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></header><md-dialog-content><form class=allotment-calendar name=editAllotmentsForm><div style=\"padding: 16px\"><md-checkbox ng-model=$ctrl.seasonMode>Mode Saisons</md-checkbox></div><div ng-if=!$ctrl.seasonMode><periods-input model=$ctrl.periods value-callback=$ctrl.getPeriods></periods-input></div><div ng-if=$ctrl.seasonMode><md-input-container><!--<div ng-repeat=\"s in ::$ctrl.seasons\" ng-if=\"$ctrl.seasonMode\">\n      <md-checkbox  ng-model=\"$ctrl.d\">{{::s.description}} {{::s.category}} </md-checkbox> </div>--><md-select ng-model=$ctrl.ranges multiple placeholder=Saison><md-option ng-repeat=\"s in ::$ctrl.seasons track by $index\" ng-value={{s}}><strong>Saison.</strong> {{s.description}} - {{s.category}}</md-option></md-select></md-input-container></div><table class=unit><thead><tr><th colspan=2 class=unit-name>{{::$ctrl.unit.name}}</th><th ng-if=$ctrl.someContracted><md-checkbox ng-model=$ctrl.edit.available style=\"margin: 0\">Disponibilité</md-checkbox></th><th ng-if=!$ctrl.someContracted>Disponibilité</th><th><md-checkbox ng-model=$ctrl.edit.release style=\"margin: 0\">Délais Rétro.</md-checkbox></th></tr></thead><tbody><tr class=allotment ng-repeat=\"a in ::$ctrl.allotments\" ng-style=a.style><td><md-switch ng-model=a.selected>{{::a.label}}</md-switch></td><td><small>{{::a.bases.join(\' / \')}}</small></td><td><input ng-model=a.available ng-required=\"a.selected && $ctrl.edit.available\" type=number min=0 max=999 placeholder=dispo></td><td><input ng-model=a.release ng-required=\"a.selected && $ctrl.edit.release\" type=number min=0 max=100 placeholder=rétrocession></td></tr></tbody></table></form></md-dialog-content><md-dialog-actions><!-- <md-button\n      class=\"md-accent\"\n      ng-click=\"$ctrl.applyChanges()\"\n     \n    >--><md-button class=md-accent ng-click=$ctrl.applyChanges() ng-disabled=\"editAllotmentsForm.$invalid || ($ctrl.periods.length === 0 && $ctrl.ranges.length === 0)\">Valider</md-button><md-button ng-click=$ctrl.cancel()>Annuler</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/allotment/unit/template.html","<header>Allotements {{::unitTypes[$ctrl.unit.type].name}} {{::$ctrl.unit.name}}</header><main><allotment-bases-editor class=section permissions=$ctrl.permissions rate-bases=$ctrl.rateBases allotments=$ctrl.allotments></allotment-bases-editor><section class=availability ng-if=\"$ctrl.availabilityGraphData.length > 0\"><header><h3 style=flex:1>Disponibilité</h3><md-button ng-click=\"$ctrl.editCalendar($event,\'available\')\" style=\"margin: 0\" class=\"md-raised md-accent\" ng-if=$ctrl.permissionsContracting>modifier</md-button></header><nvd3 options=::$ctrl.availabilityGraphOptions data=$ctrl.availabilityGraphData></nvd3></section><section class=release ng-if=\"$ctrl.releaseGraphData.length > 0\"><header><h3 style=flex:1>Délais de rétrocession (en jours)</h3><md-button ng-click=\"$ctrl.editCalendar($event,\'release\')\" style=\"margin: 0\" class=\"md-raised md-accent\" ng-if=$ctrl.permissionsContracting>modifier</md-button></header><nvd3 options=::$ctrl.releaseGraphOptions data=$ctrl.releaseGraphData></nvd3></section></main>");
$templateCache.put("app/amenities/edit/template.html","<md-dialog id=amenities-selector><md-dialog-content><input type=text ng-model=$ctrl.filter><md-divider></md-divider><md-list><md-item ng-repeat=\"a in $ctrl.amenities | filter: {name:$ctrl.filter}\" ng-click=$ctrl.select(a)>{{a.name}}</md-item></md-list></md-dialog-content></md-dialog>");
$templateCache.put("app/bookings/edit/template.html","<div class=card><header><!-- <h1>{{::$ctrl.property.name}}</h1>\n        <md-button class=\"md-accent\">Modifier\n        </md-button> --> <strong>Réservation N° : {{$ctrl.booking.number}}</strong><md-button class=md-accent ng-click=$ctrl.save($event)>Enregistrer</md-button></header><div layout=row layout-wrap><section flex=40 layout=row layout-wrap style=\"min-width:400px;padding:16px; margin-bottom: 16px\"><!-- <h4>Classement</h4> --><md-input-container><label>email</label><input type=text ng-model=$ctrl.booking.customer.email required></md-input-container><md-input-container><label>phone</label><input type=text ng-model=$ctrl.booking.customer.phone required></md-input-container><md-input-container><label>lastName</label><input type=text ng-model=$ctrl.booking.customer.lastName required></md-input-container><md-input-container><label>firstName</label><input type=text ng-model=$ctrl.booking.customer.firstName required></md-input-container><md-input-container><label>Pos</label><md-select ng-change=\"\" ng-model=$ctrl.booking.pos required><md-option ng-repeat=\"pos in $ctrl.pos\" ng-value={{pos}} ng-selected=\"$ctrl.booking.pos.name == pos.name\">{{pos.name}}</md-option></md-select></md-input-container></section><md-divider></md-divider><section flex=50 layout=row layout-wrap style=\"min-width:400px;padding:16px; margin-bottom: 16px\"><!-- <h4>Classement</h4> --><div ng-if=\"$ctrl.booking.payments && $ctrl.booking.payments.length > 0\"><header><h3 style=flex:1>Paiement</h3><md-button ng-click=$ctrl.addPayment() style=\"margin: 0\" class=\"md-raised md-accent\">Ajouter</md-button></header><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span>Mode de paiement</span></th><th md-column><span>Montant</span></th><th></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"payment in $ctrl.booking.payments\"><td md-cell><md-select name=chain ng-model=payment.method><md-option ng-repeat=\"p in ::$ctrl.paymentMethods\" ng-value=::p.code>{{::p.name}}</md-option></md-select></td><td md-cell><md-input-container><input type=text ng-model=payment.amount required></md-input-container></td><td md-cell><md-button class=\"md-icon-button md-warn\" ng-click=\"$ctrl.deletePayment($event,$ctrl.booking.payments, $index)\"><md-icon>delete</md-icon><md-tooltip>Supprimer</md-tooltip></md-button></td></tr></tbody></table></md-table-container></div></section></div></div><div ng-repeat=\"item in $ctrl.booking.items\"><div class=card><header><strong>ÉLÉMENT DE RÉSERVATION N° : {{$index +1}}</strong></header><div layout=row layout-wrap><section style=padding:16px flex=100 style=min-width:400px;padding:16px><div layout=row layout-wrap layout-align=\"start start\"><md-input-container><label>Chambre</label><md-select ng-model=item.product.unit><md-option ng-repeat=\"unit in $ctrl.units \" ng-value=::unit ng-selected=\"item.product.unit.code == unit.code\">{{::unit.name}}</md-option></md-select></md-input-container><md-input-container><label>Base tarifaire</label><md-select ng-model=item.product.basis><md-option ng-repeat=\"rateBase in $ctrl.rateBases\" ng-value=::rateBase ng-selected=\"item.product.basis.code == rateBase.code\">{{rateBase.description}}</md-option></md-select></md-input-container><md-input-container><label>Pension</label><md-select ng-model=item.product.board required><md-option ng-repeat=\"board in $ctrl.boards\" ng-value={{board.code}}>{{board.name}}</md-option></md-select></md-input-container><md-input-container><label>Prix d\'achat</label><input type=text ng-model=item.total required></md-input-container><md-input-container><label>Prix de vente</label><input type=text ng-model=item.totalSales required></md-input-container></div><div layout=row layout-wrap layout-align=\"start start\"><md-input-container><label>status</label><md-select name=chain ng-model=item.status><md-option ng-repeat=\"o in ::$ctrl.status\" ng-value=::o.code>{{::o.name}}</md-option></md-select></md-input-container><md-input-container><label>checkin</label><md-datepicker ng-model=item.checkin md-placeholder=\"Enter date\" input-aria-describedby=datepicker-description input-aria-labelledby=\"datepicker-header \"></md-datepicker></md-input-container><md-input-container><label>Calculette (Prix/nuitée)</label><input type=number ng-model=item.pricePerNight ng-change=$ctrl.updateTotal(item) required></md-input-container><md-input-container><label>Nombre de nuitées</label><input type=number min=1 max=18 ng-model=item.nights ng-change=$ctrl.updateTotal(item) required></md-input-container><md-input-container><label>total</label><input type=number ng-model=item.total required></md-input-container></div><!--Valeria block end --></section><md-divider></md-divider></div><section ng-if=\"item.guests && item.guests.length > 0\"><header><h3 style=flex:1>Voyageurs</h3><md-button ng-click=item.guests.push({}) style=\"margin: 0\" class=\"md-raised md-accent\">Ajouter</md-button></header><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span>lastName</span></th><th md-column><span>firstName</span></th><th></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"guest in item.guests\"><td md-cell><md-input-container><input type=text ng-model=guest.lastName required></md-input-container></td><td md-cell><md-input-container><input type=text ng-model=guest.firstName required></md-input-container></td><td md-cell><md-button class=\"md-icon-button md-warn\" ng-click=\"$ctrl.deleteGuest($event,item.guests, $index)\"><md-icon>delete</md-icon><md-tooltip>Supprimer</md-tooltip></md-button></td></tr></tbody></table></md-table-container></section><section ng-if=\"item.addon && item.addon.length > 0\"><header><h3 style=flex:1>Préstations</h3><md-button ng-click=$ctrl.addAddon(item) style=\"margin: 0\" class=\"md-raised md-accent\">Ajouter</md-button></header><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span>Nom</span></th><th md-column><span>Fournisseur</span></th><th md-column><span>Quantité</span></th><th md-column><span>Prix d\'achat</span></th><th md-column><span>Prix de vente</span></th><th md-column><span>Mode</span></th><th></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"addon in item.addon\"><td md-cell><md-input-container><input type=text ng-model=addon.name required></md-input-container></td><td md-cell><md-input-container><input type=text ng-model=addon.supplier required></md-input-container></td><td md-cell><md-input-container><input type=number ng-model=addon.qte required></md-input-container></td><td md-cell><md-input-container><input type=text ng-model=addon.totalPurchase required></md-input-container></td><td md-cell><md-input-container><input type=text ng-model=addon.total required></md-input-container></td><td md-cell><span ng-if=\"addon.code != \'-1\'\">Initiale</span> <span ng-if=\"addon.code == \'-1\'\">Édition</span></td><td md-cell><md-button class=\"md-icon-button md-warn\" ng-click=\"$ctrl.deleteAddon($event,item.addon, $index)\"><md-icon>delete</md-icon><md-tooltip>Supprimer</md-tooltip></md-button></td></tr></tbody></table></md-table-container></section><section ng-if=\"item.discount && item.discount.length > 0\"><header><h3 style=flex:1>Promotions</h3><md-button ng-click=$ctrl.addDiscount(item) style=\"margin: 0\" class=\"md-raised md-accent\">Ajouter</md-button></header><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span>Libellé</span></th><th md-column><span>Référence</span></th><th md-column><span>Prix d\'achat</span></th><th md-column><span>Prix de vente</span></th><th md-column><span>Mode</span></th><th></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"discount in item.discount track by $index\"><td md-cell><md-input-container><input type=text ng-model=discount.label required></md-input-container></td><td md-cell><md-input-container><input type=text ng-model=discount.reference required></md-input-container></td><td md-cell><md-input-container><input type=text ng-model=discount.purchaseTotal required></md-input-container></td><td md-cell><md-input-container><input type=text ng-model=discount.amount required></md-input-container></td><td md-cell><span ng-if=\"discount.code != \'-1\'\">Initiale</span> <span ng-if=\"discount.code == \'-1\'\">Édition</span></td><td md-cell><md-button class=\"md-icon-button md-warn\" ng-click=\"$ctrl.deleteDiscount($event,item.discount, $index)\"><md-icon>delete</md-icon><md-tooltip>Supprimer</md-tooltip></md-button></td></tr></tbody></table></md-table-container></section></div></div>");
$templateCache.put("app/bookings/list/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Réservations</span><form name=propertyFilterForm flex style=\"margin-left: 16px\" layout=row><label for=booking-search-input><md-icon class=material-icons>search</md-icon></label><input id=booking-search-input style=\"width: 100%;margin: 0 0 0 16px;font-size:14px;padding:4px;border: none;color: rgba(0, 0, 0, 0.87)\" type=text ng-model=$ctrl.query.customer ng-model-options=$ctrl.customerFilterOptions placeholder=\"rechercher (nom ou numéro)\"><md-button ng-class=\"{\'md-raised\':$ctrl.filter}\" ng-click=\"$ctrl.filter = !$ctrl.filter\"><md-icon class=material-icons>filter_list</md-icon>filtrer</md-button></form></div></md-toolbar><form style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 16px;\ndisplay: flex;\n    align-items: flex-start\" name=bookingsFilterForm ng-show=$ctrl.filter><span class=md-subhead style=\"margin: 25px 16px 0 8px\">Filtrer</span><md-input-container style=margin-left:16px><label>Date résa.</label><md-datepicker ng-model=$ctrl.query.createdOn name=bookingDate></md-datepicker></md-input-container><md-input-container style=margin-left:16px><label>Checkin</label><md-datepicker ng-model=$ctrl.query.checkin name=bookingDate></md-datepicker></md-input-container><md-input-container style=margin-left:16px><label>Etablissement</label><input type=text ng-model=$ctrl.query.propertyName name=bookingPropertyName></md-input-container></form><!-- exact table from live demo --><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.loadBookings><tr md-row><th md-column><span>Numéro</span></th><th md-column><span>Etablissement</span></th><th md-column><span>Client</span></th><th md-column md-order-by=createdOn><span>Date de réservation</span></th><th md-column md-order-by=checkin><span>Check in</span></th><th md-column md-numeric>Nombre de nuits</th><th md-column><span>Chambres</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"b in $ctrl.items\" ng-click=$ctrl.showBooking(b)><td md-cell>{{::b.number}}</td><td md-cell>{{::b.property.name}}</td><td md-cell>{{::b.items[0].guests[0].firstName}} {{::b.items[0].guests[0].lastName}}</td><td md-cell>{{::b.audit.createdOn | date:\'short\'}}</td><td md-cell>{{::b.items[0].checkin | date}}</td><td md-cell>{{::b.items[0].nights}} nuits</td><td md-cell><ul style=font-size:0.925em><li ng-repeat=\"i in b.items\">{{::i.product.unit.type}} {{::i.product.unit.name}}<br></li></ul></td></tr></tbody></table></md-table-container><md-table-pagination md-boundary-links=true md-limit=$ctrl.query.limit md- md-page=$ctrl.query.page md-total={{$ctrl.total}} md-on-paginate=$ctrl.loadBookings></md-table-pagination></md-card>");
$templateCache.put("app/bookings/property-booking-on-hold-list/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Précommandes</span></div></md-toolbar><form name=bookingsFilterForm><div layout=row layout-wrap><section><md-input-container style=\"margin-left: 16px\"><md-select ng-model=$ctrl.query.askforfree placeholder=\"Choisir un filtre\"><md-option value=false>Pré-Commande</md-option><md-option value=true>Gratuitée</md-option><!--<md-option value=\"false\">Paiement à l\'hôtel</md-option>--></md-select></md-input-container><md-input-container><label>Numéro</label><input type=text ng-model=$ctrl.query.customer></md-input-container><md-input-container><label>résa. Du</label><md-datepicker ng-model=$ctrl.query.createdOnStart name=bookingDate></md-datepicker></md-input-container><md-input-container><label>résa. Au</label><md-datepicker ng-model=$ctrl.query.createdOnEnd name=bookingDate></md-datepicker></md-input-container><md-input-container><label>Checkin</label><md-datepicker ng-model=$ctrl.query.checkin name=cheeckinDate></md-datepicker></md-input-container><md-input-container><label>Checkout</label><md-datepicker ng-model=$ctrl.query.checkout name=cheeckinDate></md-datepicker></md-input-container><md-input-container><md-button ng-click=$ctrl.loadBookings()><md-icon class=material-icons>search</md-icon>Rechercher</md-button></md-input-container></section></div></form><!-- exact table from live demo --><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.loadBookings><tr md-row><th md-column><span>N°</span></th><!-- <th md-column><span>Status</span></th> --><th md-column><span>Client</span></th><th md-column md-order-by=createdOn><span>Date résa.</span></th><th md-column md-order-by=checkin><span>Checkin</span></th><th md-column md-order-by=checkout><span>Checkout</span></th><th md-column md-numeric>Nuitée</th><th md-column><span>Ch</span></th><!-- <th md-column md-numeric>Pos</th> --><th md-column><span>Pymt</span></th><th md-column><span>Total</span></th><!-- <th md-column><span>Show</span></th> --><th md-column><span></span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"b in $ctrl.items\" ng-click=$ctrl.showBooking(b)><td md-cell>{{::b.number}}</td><!-- <td md-cell>{{::$ctrl.status[b.items[0].status]}}</td> --><td md-cell>{{::b.customer.firstName}} {{::b.customer.lastName}}</td><!-- <td md-cell>{{::b.items[0].guests[0].firstName}} {{::b.items[0].guests[0].lastName}}</td> --><td md-cell>{{::b.audit.createdOn | date:\'dd/MM/yyyy\'}}</td><td md-cell>{{::b.items[0].checkin | date:\'dd/MM/yyyy\'}}</td><td md-cell>{{::b.items[0].checkout | date:\'dd/MM/yyyy\'}}</td><td md-cell>{{::b.items[0].nights}}</td><td md-cell><ol><li ng-repeat=\"i in b.items\">{{::i.product.unit.type}} {{::i.product.unit.name}}<br></li></ol></td><!-- <td md-cell>{{::b.pos.name}} </td> --><td md-cell><ol><li ng-repeat=\"p in b.payments\">{{::p.amount}}<br></li></ol></td><td md-cell>{{::b.items[0].total}} {{::b.items[0].product.currency}}</td><!-- <td md-cell>{{::b.arrrived}}</td> --><td md-cell><md-button ng-click=$ctrl.addPayment($event,b)>Ajt. paiement</md-button><!-- ng-if=\"b.payments && b.payments.length > 0\" --><md-button ng-click=$ctrl.confirm($event,b)>Confirmer</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=$ctrl.query.limit md-page=$ctrl.query.page md-total={{$ctrl.total}} md-on-paginate=$ctrl.loadBookings></md-table-pagination></md-card>");
$templateCache.put("app/bookings/property-list/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Réservations</span></div></md-toolbar><form style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 350px;\ndisplay: flex;\n    align-items: flex-start\" name=bookingsFilterForm><section><!-- <md-input-container style=\"margin-left:16px\">\n\n    <md-button  class=\"md-accent\" ng-click=\"$ctrl.add($event)\" ng-click=\"$ctrl.showBooking(b)\">Ajouter Reservation </md-button>createBooking\n  </md-input-container> --><md-input-container style=margin-left:16px><md-button class=md-accent ng-click=$ctrl.createBooking()>Ajouter Reservation</md-button></md-input-container><md-input-container style=margin-left:16px><md-select ng-model=$ctrl.filtreType placeholder=\"Choisir un filtre\"><md-option value=name>nom ou numéro</md-option><md-option value=reservation checked>Date de Reservation</md-option><md-option value=checkin>Date de Checkin</md-option></md-select></md-input-container></section><md-input-container ng-if=\"$ctrl.filtreType == \'name\' \" style=margin-left:16px><label>nom ou numéro</label><input id=booking-search-input type=text ng-model=$ctrl.query.customer></md-input-container><md-input-container ng-if=\"$ctrl.filtreType == \'reservation\' \" style=margin-left:16px><label>résa. Du</label><md-datepicker ng-model=$ctrl.query.createdOnDu name=bookingDate></md-datepicker></md-input-container><md-input-container ng-if=\"$ctrl.filtreType == \'reservation\' \" style=margin-left:16px><label>résa. Au</label><md-datepicker ng-model=$ctrl.query.createdOnAu name=bookingDate></md-datepicker></md-input-container><md-input-container ng-if=\"$ctrl.filtreType == \'checkin\' \" style=margin-left:16px><label>Checkin Du</label><md-datepicker ng-model=$ctrl.query.checkinDu name=cheeckinDate></md-datepicker></md-input-container><md-input-container ng-if=\"$ctrl.filtreType == \'checkin\' \" style=margin-left:16px><label>Checkin Au</label><md-datepicker ng-model=$ctrl.query.checkinAu name=cheeckinDate></md-datepicker></md-input-container><md-input-container style=margin-left:16px><md-button ng-click=$ctrl.loadBookings()><md-icon class=material-icons>search</md-icon>Rechercher</md-button></md-input-container></form><div ng-if=\"$ctrl.calculStat==\'yes\'\" style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 20px;\n  display: flex;\n      align-items: flex-start\"><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#95c5b6;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>Nombre de Nuitées</small><br><span ng-bind=$ctrl.loadNuitee($ctrl.items)>{{::$ctrl.loadNuitee($ctrl.items)}}</span></div><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#2196F3;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>Chiffre d\'Affaires Total</small><br><span ng-bind=$ctrl.loadSum($ctrl.items)>{{::$ctrl.loadSum($ctrl.items)}}</span></div><!-- <div ng-if=\"$ctrl.checkoutfin \"  md-progress=\"$ctrl.loadingPromise\" style=\"display:block; --><!-- <div   md-progress=\"$ctrl.loadingPromise\" style=\"display:block; --><div ng-if=\"$ctrl.checkoutfin \" md-progress=$ctrl.loadingPromise style=\"display:block;\n    margin:0.5em 1em;\n    width:6em;\n    height:6em;\n    border-radius:50%;\n    text-align: center;\n    padding-top: 2em;\n    box-sizing: border-box;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n    transition: all 0.6s ease;\nbackground-color:#21a6f3;color:white;  width:14em;\n    border-radius:1.5em;\n    padding-top: 1em\"><small>Chiffre d\'Affaires</small><br><span ng-bind=$ctrl.loadSumRl($ctrl.items)>{{::$ctrl.loadSumRl($ctrl.items)}}</span></div><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#00CC66;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>Paiement</small><br><span ng-bind=$ctrl.loadPayments($ctrl.items)>{{::$ctrl.loadPayments($ctrl.items)}}</span></div><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#f32121;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>Le Reste</small><br><span ng-bind=$ctrl.loadRest($ctrl.items)>{{::$ctrl.loadRest($ctrl.items)}}</span></div><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#32df07;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>OTA</small><br>Nombre : <span ng-bind=$ctrl.posOTACmd($ctrl.items)>Nombre : {{::$ctrl.posOTACmd($ctrl.items)}} </span><br>Revenu :<span ng-bind=$ctrl.posOTARev($ctrl.items)> Revenu : {{::$ctrl.posOTARev($ctrl.items)}}</span></div><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#216bf3;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>Walk-in</small><br>Nombre : <span ng-bind=$ctrl.posWalkingCmd($ctrl.items)>Nombre : {{::$ctrl.posWalkingCmd($ctrl.items)}} </span><br>Revenu : <span ng-bind=$ctrl.posWalkingRev($ctrl.items)>Revenu : {{::$ctrl.posWalkingRev($ctrl.items)}}</span></div><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#f34b21;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>TO</small><br>Nombre : <span ng-bind=$ctrl.posTOCmd($ctrl.items)>Nombre : {{::$ctrl.posTOCmd($ctrl.items)}} </span><br>Revenu : <span ng-bind=$ctrl.posTORev($ctrl.items)>Revenu : {{::$ctrl.posTORev($ctrl.items)}}</span></div><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#2175f3;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>B2B</small><br>Nombre : <span ng-bind=$ctrl.posB2BCmd($ctrl.items)>Nombre : {{::$ctrl.posB2BCmd($ctrl.items)}} </span><br>Revenu : <span ng-bind=$ctrl.posB2BRev($ctrl.items)>Revenu : {{::$ctrl.posB2BRev($ctrl.items)}}</span></div><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#4121f3;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>B2C</small><br>Nombre: <span ng-bind=$ctrl.posB2CCmd($ctrl.items)>Nombre : {{::$ctrl.posB2CCmd($ctrl.items)}} </span><br>Revenu :<span ng-bind=$ctrl.posB2CRev($ctrl.items)> Revenu : {{::$ctrl.posB2CRev($ctrl.items)}}</span></div></div><!-- exact table from live demo --><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.loadBookings><tr md-row><th md-column><span>Numéro</span></th><th md-column><span>Status</span></th><th md-column><span>Client</span></th><th md-column md-order-by=createdOn><span>Date de réservation</span></th><th md-column md-order-by=checkin><span>Check in</span></th><th md-column md-numeric>Nombre de nuits</th><th md-column><span>Chambres</span></th><th md-column md-numeric>Pos</th><th md-column><span>Payments</span></th><th md-column><span>Total</span></th><th md-column><span>Show</span></th><th md-column><span></span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"b in $ctrl.items\" ng-click=$ctrl.showBooking(b)><td md-cell>{{::b.number}}</td><td md-cell>{{::$ctrl.status[b.items[0].status]}}</td><td md-cell>{{::b.customer.firstName}} {{::b.customer.lastName}}</td><!-- <td md-cell>{{::b.items[0].guests[0].firstName}} {{::b.items[0].guests[0].lastName}}</td> --><td md-cell>{{::b.audit.createdOn | date:\'dd/MM/yyyy\'}}</td><td md-cell>{{::b.items[0].checkin | date:\'dd/MM/yyyy\'}}</td><td md-cell>{{::b.items[0].nights}} nuits</td><td md-cell><ol><li ng-repeat=\"i in b.items\">{{::i.product.unit.type}} {{::i.product.unit.name}}<br></li></ol></td><td md-cell>{{::b.pos.name}}</td><td md-cell>{{::b.payments[0].amount}} {{::b.items[0].product.currency}}</td><td md-cell>{{::b.items[0].total}} {{::b.items[0].product.currency}}</td><td md-cell>{{::b.arrrived}}</td><td><md-button ng-click=$ctrl.showBooking(b)>show</md-button><md-button ng-click=$ctrl.editBooking(b)>edit</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=$ctrl.query.limit md-page=$ctrl.query.page md-total={{$ctrl.total}} md-on-paginate=$ctrl.loadBookings></md-table-pagination></md-card>");
$templateCache.put("app/bookings/property-list-day/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Les Réservations d\'aujoud\'hui</span></div></md-toolbar><div style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 350px;\n  display: flex;\n      align-items: flex-start\"><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#2196F3;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>CA</small><br><span>{{::$ctrl.summ}}<!-- <small>MAD</small> --></span></div><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#00CC66;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>Paiement</small><br><span>{{::$ctrl.paymnt}}<!-- <small>MAD</small> --></span></div><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#f32121;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>Le Reste</small><br><span>{{::$ctrl.rest}}<!-- <small>MAD</small> --></span></div></div><!-- <form style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 350px;\ndisplay: flex;\n    align-items: flex-start;\n\" name=\"bookingsFilterForm\" >\n\n\n\n<md-input-container style=\"margin-left:16px\">\n  <label>nom ou numéro</label>\n\n  <input id=\"booking-search-input\"  type=\"text\" ng-model=\"$ctrl.query.customer\"  >\n\n</md-input-container>\n  <md-input-container style=\"margin-left:16px\">\n       <label>Date résa.</label>\n       <md-datepicker ng-model=\"$ctrl.query.createdOn\" name=\"bookingDate\" ></md-datepicker>\n     </md-input-container>\n     <md-input-container style=\"margin-left:16px\">\n          <label>Checkin</label>\n          <md-datepicker ng-model=\"$ctrl.query.checkin\" name=\"cheeckinDate\" ></md-datepicker>\n      </md-input-container>\n      <md-button  ng-click=\"$ctrl.searchBookings($ctrl.query.createdOn)\"><md-icon class=\"material-icons\">search</md-icon> Rechercher</md-button>\n\n</form> --><!-- exact table from live demo --><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.loadBookings><tr md-row><th md-column><span>Numéro</span></th><th md-column><span>Client</span></th><th md-column md-order-by=createdOn><span>Date de réservation</span></th><th md-column md-order-by=checkin><span>Check in</span></th><th md-column md-numeric>Nombre de nuits</th><th md-column><span>Chambres</span></th><th md-column md-numeric>Pos</th><th md-column><span>Payments</span></th><th md-column><span>Total</span></th><th md-column><span>Show</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"b in $ctrl.items\" ng-click=$ctrl.showBooking(b)><td md-cell>{{::b.number}}</td><td md-cell>{{::b.items[0].guests[0].firstName}} {{::b.items[0].guests[0].lastName}}</td><td md-cell>{{::b.audit.createdOn | date:\'short\'}}</td><td md-cell>{{::b.items[0].checkin | date}}</td><td md-cell>{{::b.items[0].nights}} nuits</td><td md-cell><ol><li ng-repeat=\"i in b.items\">{{::i.product.unit.type}} {{::i.product.unit.name}}<br></li></ol></td><td md-cell>{{::b.pos.name}}</td><td md-cell>{{::b.items[0].payments[0].amount}} {{::b.items[0].product.currency}}</td><td md-cell>{{::b.items[0].total}} {{::b.items[0].product.currency}}</td><td md-cell>{{::b.arrived}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=$ctrl.query.limit md-page=$ctrl.query.page md-total={{$ctrl.total}} md-on-paginate=$ctrl.loadBookings></md-table-pagination></md-card>");
$templateCache.put("app/bookings/property-list-day-checkin/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>la liste des Checkin</span></div></md-toolbar><div style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 350px;\n  display: flex;\n      align-items: flex-start\"><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#2196F3;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>CA</small><br><span>{{::$ctrl.summ}}<!-- <small>MAD</small> --></span></div><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#00CC66;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>Paiement</small><br><span>{{::$ctrl.paymnt}}<!-- <small>MAD</small> --></span></div><div md-progress=$ctrl.loadingPromise style=\"display:block;\n      margin:0.5em 1em;\n      width:6em;\n      height:6em;\n      border-radius:50%;\n      text-align: center;\n      padding-top: 2em;\n      box-sizing: border-box;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);\n      transition: all 0.6s ease;\n  background-color:#f32121;color:white;  width:14em;\n      border-radius:1.5em;\n      padding-top: 1em\"><small>Le Reste</small><br><span>{{::$ctrl.rest}}<!-- <small>MAD</small> --></span></div></div><!-- <form style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 350px;\ndisplay: flex;\n    align-items: flex-start;\n\" name=\"bookingsFilterForm\" >\n\n\n\n<md-input-container style=\"margin-left:16px\">\n  <label>nom ou numéro</label>\n\n  <input id=\"booking-search-input\"  type=\"text\" ng-model=\"$ctrl.query.customer\"  >\n\n</md-input-container>\n  <md-input-container style=\"margin-left:16px\">\n       <label>Date résa.</label>\n       <md-datepicker ng-model=\"$ctrl.query.createdOn\" name=\"bookingDate\" ></md-datepicker>\n     </md-input-container>\n     <md-input-container style=\"margin-left:16px\">\n          <label>Checkin</label>\n          <md-datepicker ng-model=\"$ctrl.query.checkin\" name=\"cheeckinDate\" ></md-datepicker>\n      </md-input-container>\n      <md-button  ng-click=\"$ctrl.searchBookings($ctrl.query.createdOn)\"><md-icon class=\"material-icons\">search</md-icon> Rechercher</md-button>\n\n</form> --><!-- exact table from live demo --><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.loadBookings><tr md-row><th md-column><span>Numéro</span></th><th md-column><span>Client</span></th><th md-column md-order-by=createdOn><span>Date de réservation</span></th><th md-column md-order-by=checkin><span>Check in</span></th><th md-column md-numeric>Nombre de nuits</th><th md-column><span>Chambres</span></th><th md-column md-numeric>Pos</th><th md-column><span>Payments</span></th><th md-column><span>Total</span></th><th md-column><span>Show</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"b in $ctrl.items\" ng-click=$ctrl.showBooking(b)><td md-cell>{{::b.number}}</td><td md-cell>{{::b.items[0].guests[0].firstName}} {{::b.items[0].guests[0].lastName}}</td><td md-cell>{{::b.audit.createdOn | date:\'short\'}}</td><td md-cell>{{::b.items[0].checkin | date}}</td><td md-cell>{{::b.items[0].nights}} nuits</td><td md-cell><ol><li ng-repeat=\"i in b.items\">{{::i.product.unit.type}} {{::i.product.unit.name}}<br></li></ol></td><td md-cell>{{::b.pos.name}}</td><td md-cell>{{::b.items[0].payments[0].amount}} {{::b.items[0].product.currency}}</td><td md-cell>{{::b.items[0].total}} {{::b.items[0].product.currency}}</td><td md-cell>{{::b.arrived}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=$ctrl.query.limit md-page=$ctrl.query.page md-total={{$ctrl.total}} md-on-paginate=$ctrl.loadBookings></md-table-pagination></md-card>");
$templateCache.put("app/bookings/view/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools layout-align=\"space-between center\" style=\"background-color: aliceblue\"><span>Réservation n°{{$ctrl.booking.number}}</span><div style=font-size:0.7em><small>Date de réservation</small><br>{{$ctrl.booking.audit.createdOn | date:\'medium\'}}</div><!-- ng-if $ctrl.booking.cc --><div><md-button class=md-accent ng-click=$ctrl.updadePayment($event,$ctrl.booking)>Modifier le Paiement et POS</md-button></div><div><span>Checkin</span><md-checkbox aria-label=a.name ng-checked=\"$ctrl.arrived==true\" ng-click=$ctrl.toggleshow($event,$ctrl.booking,$ctrl.arrived)></md-checkbox><md-tooltip></md-tooltip></div></div></md-toolbar><!-- exact table from live demo --><md-table-container style=margin-bottom:16px><table md-table><thead md-head><tr md-row><!--\n        <th md-column><span>Ref</span></th>\n      --><th md-column><span>Etat</span></th><th md-column><span>Clients</span></th><th md-column><span>Séjour</span></th><th md-column><span>Chambre</span></th><th md-column><span>Promotion</span></th><th md-column><span>Prestations</span></th><th md-column md-numeric><span>Commission</span></th><th md-column md-numeric><span>POS</span></th><th md-column md-numeric><span>Total</span></th><!-- <th md-column md-numeric><span>Paiement</span></th> --><!-- <th md-column md-numeric><span>Le Reste</span></th> --></tr></thead><tbody md-body><tr md-row ng-repeat=\"i in $ctrl.booking.items\" ng-click=$ctrl.showBooking(b)><!--\n        <td md-cell>{{::i.number}}</td>\n      --><td md-cell>{{::$ctrl.status[i.status]}}</td><td md-cell><ul><li ng-repeat=\"g in i.guests\">{{::g.firstName}} {{::g.lastName}} <small ng-if=::g.birthdate>né le {{::g.birthdate | date}}</small></li></ul><!-- ng-if date > checkin && date <= checkout --><!-- <md-button style=\"transform:scale(0.8,0.8)\" class=\"md-accent\" ng-click=\"$ctrl.noShowFunction($event, i,$ctrl.booking)\">Signaler un no show</md-button>\n          <md-button style=\"transform:scale(0.8,0.8)\" class=\"md-accent\" ng-click=\"$ctrl.arrivedFunction($event, i,$ctrl.booking)\">Arrivée</md-button></td> --></td><td md-cell>{{::i.checkin | date:\'dd/MM/yyyy\'}}<br>{{::i.nights}} nuits</td><td md-cell><div>{{::i.product.unit.type}} {{i.product.unit.name}}</div><div>{{::$ctrl.boards[i.product.board].name}}</div><div>Tarif {{::i.product.basis.description}}</div><div ng-show=i.product.payOnArrival>Paiement à l\'hotel</div><strong>Conditions d\'annulation</strong><ul><li ng-repeat=\"r in i.cancellation\"><strong>A partir du {{r.from | date:\'dd/MM/yyyy\'}}</strong><br>{{r.charge}} {{::$ctrl.currency}} retenu</li></ul></td><!-- <td md-cell>{{::i.discount || \'N/A\'}}<br></td> --><td md-cell><ul><li ng-repeat=\"d in i.discount\">{{::d.label}} ,Prix: {{::d.amount}}{{::$ctrl.currency}}</li></ul><br></td><td md-cell><ul><li ng-repeat=\"a in i.addon\">{{::a.name}} ,Quantité: {{::a.qte}} ,Prix: {{::a.total}}</li></ul><br></td><td md-cell>{{::(i.product.commission*i.total/100) | number}} <sup>{{::$ctrl.currency}}</sup></td><td md-cell>{{::$ctrl.booking.pos.name}}</td><td md-cell>{{::i.total | number}} <sup>{{::i.product.currency}}</sup></td><!-- <td md-cell>{{::$ctrl.booking.paymentss}} <sup>{{::i.product.currency}}</sup></td> --><!-- <td md-cell><md-button  class=\"md-accent\" ng-click=\"$ctrl.edit($event,$ctrl.booking)\">Modifier le Item </md-button></td> --><td md-cell><div><md-button class=md-accent ng-click=$ctrl.editItem($event,$ctrl.booking,i)>Modifier</md-button></div><div><md-button class=md-accent ng-click=$ctrl.annulerItem($event,$ctrl.booking,i)>Annuler</md-button></div><div><md-button class=md-accent ng-click=$ctrl.confirmerItem($event,$ctrl.booking,i)>Confirmer</md-button></div></td></tr><tr><td class=md-cell colspan=6 style=text-align:right></td><td class=\"md-cell md-numeric\">Total: {{::$ctrl.booking.total | number}} <sup>{{::$ctrl.currency}}</sup></td><td class=\"md-cell md-numeric\">Paiement: {{::$ctrl.booking.paymentss}} <sup>{{::$ctrl.currency}}</sup></td><!-- <td md-cell>{{::$ctrl.booking.total | number}} - {{::$ctrl.payments.amount | number} {{::$ctrl.currency}}</td> --></tr></tbody></table></md-table-container><!-- <p style=\"text-align:right\" ng-if=\"$ctrl.booking.cc\"> --><!--<strong>Payable à l\'hôtel</strong>--><!-- <md-button class=\"md-accent md-raised\" ng-click=\"$ctrl.viewCC($event)\">Afficher la Carte bancaire</md-button>\n</p> --></md-card>");
$templateCache.put("app/common/periods-input/template.html","<table class=\"md-table period-input\"><thead><tr><th>Début</th><th>Fin</th><th ng-repeat=\"day in ::$ctrl.weekdays\" ng-bind=::day.name></th><th><md-button class=\"md-icon-button md-accent\" ng-click=$ctrl.addPeriod()><md-icon>add</md-icon><md-tooltip>Valider</md-tooltip></md-button></th></tr></thead><tbody><tr ng-form=periodForm class=md-row ng-repeat=\"p in $ctrl.model\"><td><md-datepicker name=start ng-model=p.start md-placeholder=Début md-min-date=$ctrl.options.minDate md-max-date=$ctrl.options.maxDate required md-current-view=year md-date-filter=p.dateFilterStart></md-datepicker></td><td><md-datepicker ng-model=p.end ng-disabled=periodForm.start.$invalid md-placeholder=Fin md-date-filter=p.dateFilterEnd required md-current-view=year md-min-date=p.start md-max-date=$ctrl.options.maxDate></md-datepicker></td><td ng-repeat=\"day in ::p.weekdays\"><md-checkbox aria-label={{::day.name}} ng-model=day.selected></md-checkbox></td><td><md-button class=md-icon-button ng-click=$ctrl.removePeriod(p)><md-icon>delete</md-icon></md-button></td></tr></tbody></table>");
$templateCache.put("app/comments-prop/list/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Commentaire</span></div></md-toolbar><form name=commentForm style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 16px;\n  display: flex; align-items: flex-start\"><!-- <span class=\"md-subhead\" style=\"    margin: 25px 16px 0 8px;\">Add</span> --><md-input-container class=md-block flex=20 required><label>description</label><input type=text ng-model=comment.description required></md-input-container><md-input-container style=margin-left:16px><label>Type</label><md-select placeholder=comment ng-change=\"\" ng-model=comment.type style=\"min-width: 130px\" required><!-- <md-select-label>{{$ctrl.units.name[media.unit]}}</md-select-label> --><md-option ng-value=0>All</md-option><md-option ng-value=1>Bases Tarifaires</md-option><md-option ng-value=2>chambre</md-option><!-- <md-option   ng-value=3> pensions </md-option>   --><!-- <md-option  ng-repeat=\"unit in $ctrl.units\" ng-selected=\"{{unit.name[media.unit]}}\" ng-value=\"{{unit.code}}\"> {{unit.name}} </md-option>   --></md-select></md-input-container><md-input-container ng-show=\"comment.type==\'1\'\" style=margin-left:16px><md-select placeholder=rate ng-change=\"\" ng-model=comment.typecode style=\"min-width: 130px\"><md-option ng-repeat=\"rateBases in $ctrl.rateBases\" ng-value={{rateBases.code}}>{{rateBases.description}}</md-option></md-select></md-input-container><md-input-container ng-show=\"comment.type==\'2\'\" style=margin-left:16px><md-select placeholder=room ng-change=\"\" ng-model=comment.typecode style=\"min-width: 130px\"><md-option ng-repeat=\"unit in $ctrl.units\" ng-value={{unit.code}}>{{unit.name}}</md-option></md-select></md-input-container><md-input-container style=margin-left:16px><!-- <md-checkbox ng-model=\"$ctrl.discount.ctrlStayPeriod\">Active pour le Checkin</md-checkbox> --><md-checkbox ng-model=comment.internal>B2B</md-checkbox><!-- <md-checkbox ng-model=\"$ctrl.discount.ctrlStayPeriod\">Active pour le Checkin</md-checkbox> --><md-checkbox ng-model=comment.external>B2C</md-checkbox></md-input-container><md-input-container style=margin-left:16px><div class=field-inline><label>Du</label><md-datepicker md-current-view=year ng-model=comment.debut md-min-date=$ctrl.minDate md-placeholder=jj/mm/aaaa required></md-datepicker></div></md-input-container><md-input-container style=margin-left:16px><div class=field-inline><label>Jusqu\'au</label><md-datepicker md-current-view=year ng-model=comment.fin md-min-date=comment.debut md-placeholder=jj/mm/aaaa required></md-datepicker></div></md-input-container><md-dialog-actions><md-button class=\"md-raised md-accent md-button md-ink-ripple\" ng-click=$ctrl.createComment(comment) ng-disabled=\"commentForm.$pristine || commentForm.$invalid\">Ajouter</md-button></md-dialog-actions></form><!-- exact table from live demo --><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-on-reorder=$ctrl.loadComment><tr md-row><th md-column><span>Nom</span></th><th md-column><span>Type</span></th><th md-column><span>Nom de Type </span></th><th md-column><span>B2B </span></th><th md-column><span>B2C </span></th><th md-column><span>Date de debut</span></th><th md-column><span>Date de fin</span></th><th md-column><span></span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"s in $ctrl.comments.items\"><td md-cell>{{::s.description}}</td><td md-cell>{{::s.type}}</td><td md-cell ng-if=\"s.type == \'Hotel\'\">{{::s.type}}</td><td md-cell ng-if=\"s.type == \'Base Tarifaire\'\">{{$ctrl.rateBases[s.typeCode].description}}</td><td md-cell ng-if=\"s.type == \'Unit\'\">{{$ctrl.units[s.typeCode].name}}</td><td md-cell>{{::s.internal}}</td><td md-cell>{{::s.external}}</td><td md-cell>{{::s.debut}}</td><td md-cell>{{::s.fin}}</td><td md-cell><!-- <md-button class=\"md-icon-button\" ng-click=\"$ctrl.edit($event,s)\"><md-icon>edit</md-icon>\n              <md-tooltip>Modifier</md-tooltip>\n            </md-button> --><md-button class=\"md-icon-button md-warn\" aria-label=Settings ng-click=$ctrl.remove($event,s)><md-icon>delete</md-icon></md-button><!-- <md-select placeholder=\"block\" ng-change= \"$ctrl.stopSalesStatus(s)\" ng-model=\"s.status\"  >  \n              <md-option   ng-value=\'true\'> Stop Sales</md-option>  \n              <md-option   ng-value=\'false\'> Open Sales </md-option>   --><!-- <md-option   ng-value=3> pensions </md-option>   --><!-- <md-option  ng-repeat=\"unit in $ctrl.units\" ng-selected=\"{{unit.name[media.unit]}}\" ng-value=\"{{unit.code}}\"> {{unit.name}} </md-option>   --><!-- </md-select>\n            <md-checkbox ng-change=\"$ctrl.stopSalesStatus(s)\" ng-model=\"s.status\">\n            </md-checkbox> --></td></tr></tbody></table></md-table-container><!-- <md-table-pagination md-boundary-links=\"true\" md-limit=\"$ctrl.query.limit\" md- md-page=\"$ctrl.query.page\" md-total=\"{{$ctrl.total}}\" md-on-paginate=\"$ctrl.loadBookings\"></md-table-pagination> --><div></div></md-card>");
$templateCache.put("app/components/topbar/template.html","<!-- <h1 class=\"brand\" style=\"width: 184px;\" md-nav-click=\"$ctrl.goto(\'properties\')\">\n  <img  ng-src=\"app/components/topbar/logobeds.png\"/>\n</h1> --> <img ng-src=app/components/topbar/logobeds.png><!--<img  style=\"width: 184px;\" ng-src=\"app/components/topbar/bedsconnect.png\"/> --><md-nav-bar class=brand style=\"margin-top: 8px;flex:1\" md-selected-nav-item=$ctrl.$state.current.name nav-bar-aria-label=\"navigation links\"><md-nav-item style=color:azure ng-repeat=\"i in $ctrl.navTabs\" md-nav-click=$ctrl.goto(i.state) name={{::i.state}}>{{::i.label}}</md-nav-item></md-nav-bar><nav><!-- <md-icon>settings</md-icon> --><md-menu><md-button aria-label=\"Open user menu\" ng-click=$mdMenu.open($event)><md-icon>person</md-icon>{{$ctrl.user.name}}</md-button><md-menu-content><md-menu-item><!-- <md-button ng-href=\"{{::$ctrl.links.account}}\"> --><md-button>Compte</md-button></md-menu-item><md-menu-item><md-button ng-href={{::$ctrl.links.logout}}>Se déconnecter</md-button></md-menu-item></md-menu-content></md-menu></nav>");
$templateCache.put("app/content/translation-edit/template.html","<form class=card name=translationForm><header><h2>{{::$ctrl.descriptionCtrl.languages[$ctrl.copy.lang].name}}</h2><md-button class=md-icon-button ng-click=$ctrl.closeHandler(false)><md-icon>close</md-icon><md-tooltip>Fermer</md-tooltip></md-button></header><aside class=guidelines><h5 class=md-subhead><md-icon>info</md-icon>Guideline</h5><ul><li>Veuillez ne pas inclure les services et équipements. Prenez soin de l\'orthographe</li><li>La description doit contenir 140 à 500 caractères</li><li>Indiquez les points forts de l\'hôtel par rapport à la concurence</li><li>Pour indiquer la fin d\'un pargraphe et le début d\'un autre, laissez une ligne vide entre les deux</li></ul></aside><section class=property><md-input-container class=md-block><label ng-if=$ctrl.copy.description>Description de l\'établissement (100 à 500 caractères)</label><!-- <textarea\n        lang=\"{{::$ctrl.lang.code}}\"\n        ng-model=\"$ctrl.copy.description\"\n        minlength=\"100\"\n        md-maxlength=\"500\"\n        rows=\"2\"\n        md-select-on-focus></textarea> --><text-angular lang={{::$ctrl.lang.code}} ng-model=$ctrl.copy.description ta-default-wrap=span></text-angular></md-input-container></section><section class=units><h2>Catégories d\'unités</h2><section class=unit ng-repeat=\"unit in ::$ctrl.copy.units\"><h3>{{::unit.name}}</h3><md-input-container class=md-block><label>Nom en {{::$ctrl.lang.name}}</label><input ng-model=unit.name maxlength=128 lang={{::$ctrl.lang.code}}></md-input-container><md-input-container class=md-block><label ng-if=unit.description>Description (100 à 400 caractères)</label><!-- <textarea ng-model=\"unit.description\" minlength=\"100\" lang=\"{{::$ctrl.lang.code}}\" md-maxlength=\"400\" rows=\"2\" ></textarea> --><text-angular lang={{::$ctrl.lang.code}} ng-model=unit.description ta-default-wrap=span></text-angular></md-input-container></section></section><section class=property><h3>Politique de l\'établissement (100 à 500 caractères)</h3><md-input-container class=md-block><!-- <label >Conditions d\'annulation  (100 à 500 caractères)</label> --><!-- <textarea\n        lang=\"{{::$ctrl.lang.code}}\"\n        ng-model=\"$ctrl.copy.description\"\n        minlength=\"100\"\n        md-maxlength=\"500\"\n        rows=\"2\"\n        md-select-on-focus></textarea> --><text-angular lang={{::$ctrl.lang.code}} ng-model=$ctrl.copy.policies ta-default-wrap=span></text-angular></md-input-container></section><footer layout=flex layout-align=\"end center\"><md-button class=\"md-raised md-accent\" ng-click=$ctrl.save() ng-disabled=translationForm.$invalid>Enregistrer</md-button></footer></form>");
$templateCache.put("app/content/translation-list/template.html","<md-list class=md-whiteframe-z1 style=background-color:white><md-list-item ng-repeat=\"t9n in ::$ctrl.translations\" ng-href={{::t9n.links.view.href}}><span ng-switch on=t9n.status><md-icon ng-switch-when=missing class=md-warn>error</md-icon><md-icon ng-switch-when=incomplete class=md-warn>warning</md-icon><md-icon ng-switch-default>done</md-icon></span>&nbsp; {{::$ctrl.languages[t9n.lang].name}}</md-list-item></md-list><ui-view></ui-view>");
$templateCache.put("app/content/translation-view/template.html","<section class=card ng-if=\"$ctrl.state===\'view\'\"><header><h2>{{::$ctrl.listCtrl.languages[$ctrl.translation.lang].name}}</h2><div><md-menu ng-show=::$ctrl.compare><md-button ng-click=$mdMenu.open($event) ng-disabled>Comparer<md-icon>expand_more</md-icon></md-button><md-menu-content width=1><md-menu-item ng-repeat=\"t9n in ::$ctrl.otherTranslations\"><md-button ng-click=$ctrl.compareTo(t9n)>{{::$ctrl.listCtrl.languages[t9n.lang].name}}</md-button></md-menu-item></md-menu-content></md-menu><md-button class=md-icon-button ng-show=$ctrl.closeHandler ng-click=$ctrl.closeHandler()><md-icon>close</md-icon></md-button></div></header><section><dl class=audit><dt>Dernière mis à jour</dt><dd>{{::$ctrl.translation.audit.modifiedOn | date: \'short\' }}</dd><dl></dl></dl></section><section class=\"property text\"><h2 class=md-title>L\'établissement</h2><div class=body-text ng-bind-html=::$ctrl.translation.description lang={{::$ctrl.translation.lang}}></div></section><section class=units lang={{::$ctrl.translation.lang}}><section class=\"unit text\" ng-repeat=\"unit in ::$ctrl.translation.units\"><h2 class=md-subhead><span style=opacity:0.7>{{::$ctrl.unitTypes[unit.type].name}}</span> {{::unit.name}}</h2><div class=body-text ng-bind-html=unit.description></div></section></section><section class=\"property text\"><h2 class=md-title>Politique de l\'établissement</h2><div class=body-text ng-bind-html=::$ctrl.translation.policies lang={{::$ctrl.translation.lang}}></div></section><footer><md-button ng-if=$ctrl.edit class=\"md-raised md-accent\" ng-click=$ctrl.edit()>Modifier</md-button></footer></section><property-translation-edit ng-if=\"$ctrl.state === \'edit\'\" translation=$ctrl.translation close-handler=$ctrl.closeEditView></property-translation-edit><div ng-if=$ctrl.compareToLang class=compare><property-translation-view language-code=$ctrl.compareToLang enable-compare=false close-handler=$ctrl.closeCompareView></property-translation-view></div>");
$templateCache.put("app/datasets/amenities/edit.html","<md-dialog><form name=datasetItemForm><header>{{::$ctrl.title}}</header><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><md-input-container ng-repeat=\"lang in ::$ctrl.langs\"><label>Libellé ({{lang.name}})</label><input type=text name=name required maxlength=128 ng-model=$ctrl.copy.name[lang.code] ng-pattern=/^(?![A-Z]{2,}).*$/ ><div ng-messages=unitForm.name.$error multiple><div ng-message=pattern>Prière de ne pas tout mettre en majuscule.</div></div></md-input-container><md-checkbox ng-model=$ctrl.copy.property>Etablissement</md-checkbox><md-checkbox ng-model=$ctrl.copy.unit>Unité</md-checkbox></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.saveAmenities() ng-disabled=datasetItemForm.$invalid>Enregister</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/datasets/amenities/list.html","<thead md-head><tr md-row><th md-column><span>Code</span></th><th md-column><span>Libellé</span></th><th md-column><span>Lieu</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"i in $ctrl.items\"><td md-cell>{{i.code}}</td><td md-cell><!-- <div class=\"translation\" ng-repeat=\"(lang,name) in i.name\"><strong>{{::lang}}</strong> {{::name}}</div> --><div ng-repeat=\"name in i.name\">{{::name}}</div></td><td md-cell><div ng-show=i.property>établissement</div><div ng-show=i.unit>unité</div><!-- <div ng-show=\"i.rate\">rate</div> --></td><td md-cell><md-button class=\"md-icon-button md-warn\" aria-label=Settings ng-click=$ctrl.remove(i,$event)><md-icon>delete</md-icon></md-button></td><td md-cell><md-button class=md-icon-button aria-label=Settings ng-click=$ctrl.updateAmenities(i)><md-icon>edit</md-icon></md-button></td></tr></tbody>");
$templateCache.put("app/datasets/container/template.html","<header layout=row layout-align=\"start center\"><h1 class=md-title><span>Datasets</span></h1><nav class=breadcrumb flex><a ng-repeat=\"crumb in $ctrl.breadcrumb\" ng-href={{::crumb.href}}><md-icon>chevron_right</md-icon>{{::crumb.label}}</a></nav><div class=actions ng-repeat=\"a in $ctrl.actions\"><md-menu ng-if=a.items><md-button class=md-raised ng-class=\"::{\'md-icon-button\': a.icon}\" ng-click=$mdOpenMenu($event)><md-icon ng-if=a.icon>{{::a.icon}}</md-icon><md-tooltip ng-if=a.icon>{{::a.label}}</md-tooltip><span ng-if=!a.icon>{{::a.label}}</span></md-button><md-menu-content><span>Modifier</span><md-menu-item ng-repeat=\"i in a.items\"><md-button ng-href={{i.href}}>{{::i.label}}</md-button></md-menu-item></md-menu-content></md-menu><md-button ng-if=!a.items class=md-raised ng-class=\"::{\'md-icon-button\': a.icon}\" ng-href={{a.href}} ng-click=a.run()><md-icon ng-if=a.icon>{{::a.icon}}</md-icon><md-tooltip ng-if=a.icon>{{::a.label}}</md-tooltip></md-button></div></header><div class=container><md-sidenav class=\"md-sidenav-left md-whiteframe-z2\" md-component-id=datasets-menu md-is-locked-open=true style=\"width: 200px\"><md-content md-scroll-y flex layout=column><md-list><md-list-item ng-repeat=\"item in ::$ctrl.menu\" ng-href={{::item.href}}>{{::item.label}}</md-list-item></md-list></md-content></md-sidenav><ui-view></ui-view></div>");
$templateCache.put("app/datasets/list/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>{{::$ctrl.dsInfo.label}}</span><!--\n    <form name=\"propertyFilterForm\" flex style=\"margin-left: 16px;\" layout=\"row\">\n      <md-icon class=\"material-icons\">search</md-icon>\n      <input style=\" width: 100%;\n    margin: 0 0 0 16px;\n    font-size:14px;\n    padding:4px;\n    border: none;\n    color: rgba(0, 0, 0, 0.87);\" type=\"text\" ng-model=\"$ctrl.query.filter\" ng-model-options=\"$ctrl.filter.options\" placeholder=\"rechercher\">\n    </form>\n  --> <span flex></span><md-button ng-if=::$ctrl.permissions.add class=\"md-icon-button md-raised\" ng-hide=$ctrl.showFilters ng-click=\"$ctrl.showFilters = !$ctrl.showFilters\"><md-icon>filter_list</md-icon><md-tooltip>filtrer</md-tooltip></md-button><md-button ng-if=\"$ctrl.dsInfo.name!=\'amenities\'\" style=margin-left:8px class=\"md-icon-button md-raised md-accent\" ng-click=$ctrl.add($event)><md-icon>add</md-icon><md-tooltip>Ajouter un établissement</md-tooltip></md-button><md-button ng-if=\"$ctrl.dsInfo.name==\'amenities\'\" style=margin-left:8px class=\"md-icon-button md-raised md-accent\" ng-click=$ctrl.addAmenities($event)><md-icon>add</md-icon><md-tooltip>Ajouter amenities</md-tooltip></md-button></div></md-toolbar><form style=\"padding:0 16px; background-color: aliceblue\" name=propertyFiltersForm ng-if=$ctrl.showFilters layout=row><span flex></span></form><md-table-container><table md-table md-progress=$ctrl.loadingPromise ng-include=$ctrl.dsInfo.listTemplate></table></md-table-container><!-- exact table from live demo --></md-card>");
$templateCache.put("app/datasets/rating-systems/edit.html","<md-dialog><form name=datasetItemForm><header>{{::$ctrl.title}}</header><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><md-input-container ng-repeat=\"lang in ::$ctrl.langs\"><label>Libellé ({{lang.name}})</label><input type=text name=name required maxlength=128 ng-model=$ctrl.copy.name[lang.code] ng-pattern=/^(?![A-Z]{2,}).*$/ ><div ng-messages=datasetItemForm.name.$error multiple><div ng-message=pattern>Prière de ne pas tout mettre en majuscule.</div></div></md-input-container><textarea ng-model=\"\"></textarea></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save() ng-disabled=datasetItemForm.$invalid>Enregister</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/datasets/rating-systems/list.html","<thead md-head><tr md-row><th md-column><span>Code</span></th><th md-column><span>Libellé</span></th><th md-column><span>Types d\'établissements</span></th><th md-column><span>Règles</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"i in $ctrl.items\"><td md-cell>{{i.code}}</td><td md-cell><div class=translation ng-repeat=\"(lang,name) in i.name\"><strong>{{::lang}}</strong> {{::name}}</div></td><td md-cell><div ng-repeat=\"type in i.propertyTypes\">{{::$ctrl.propertyTypes[type].name}}</div></td><td md-cell><pre>{{::i.definition|json}}</pre></td></tr></tbody>");
$templateCache.put("app/datasets/tag-types/list.html","");
$templateCache.put("app/datasets/tags/list.html","");
$templateCache.put("app/destinations/edit/template.html","<md-dialog><form name=destinationForm><md-input-container><label>Code Geonames</label><input type=number name=count min=1 ng-model=$ctrl.copy.code></md-input-container><md-input-container ng-repeat=\"lang in ::$ctrl.langs\"><label>Nom ({{lang.name}})</label><input type=text name=name required maxlength=128 ng-model=$ctrl.copy.name[lang.code]></md-input-container><md-input-container><label>Pays</label><md-select required name=country ng-model=$ctrl.copy.country><md-option ng-repeat=\"o in $ctrl.countries\" ng-value=o.code ng-bind=::o.name></md-option></md-select></md-input-container><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save() ng-disabled=unitForm.$invalid>Enregister</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/destinations/list/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Destinations</span><form name=propertyFilterForm flex style=\"margin-left: 16px\" layout=row><label for=search-input><md-icon class=material-icons>search</md-icon></label><input id=search-input style=\"width: 100%;margin: 0 0 0 16px;font-size:14px;padding:4px;border: none;color: rgba(0, 0, 0, 0.87)\" type=text ng-model=$ctrl.query.search ng-model-options=$ctrl.searchFilterOptions placeholder=rechercher></form></div></md-toolbar><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.load><tr md-row><th md-column><span>Code Geonames</span></th><th ng-repeat=\"l in ::$ctrl.langs\" md-column><span>Nom ({{::l.name}})</span></th><th md-column md-order-by=country><span>Pays</span></th><th md-column></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"d in $ctrl.items\"><td md-cell>{{::d.code}}</td><td ng-repeat=\"l in ::$ctrl.langs\" md-cell><md-icon style=color:red ng-hide=::d.name[l.code]>error</md-icon>{{::d.name[l.code]}}</td><td md-cell>{{::d.country}}</td><td md-cell><md-button ng-click=$ctrl.edit(d)>modifier</md-button><md-button ng-click=$ctrl.report(d)>rapports</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit-options=\"[10, 25, 50, 100]\" md-boundary-links=true md-limit=$ctrl.query.limit md-page=$ctrl.query.page md-total={{$ctrl.total}} md-on-paginate=$ctrl.load></md-table-pagination></md-card>");
$templateCache.put("app/destinations/report/template.html","<md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools layout-align=\"space-between center\" style=\"background-color: aliceblue\"><h2>Destination {{::$ctrl.destination.name}}</h2><div><md-button class=md-icon-button ng-click=$ctrl.previousMonth() ng-disabled=!$ctrl.hasPrevious><md-icon>chevron_left</md-icon></md-button><span>{{$ctrl.period.from | date:\'MMMM yyyy\'}}</span><md-button class=md-icon-button ng-click=$ctrl.nextMonth() ng-disabled=!$ctrl.hasNext><md-icon>chevron_right</md-icon></md-button></div></div></md-toolbar><div class=highlights><header class=md-subhead>Réservations</header><div class=\"zoom bk\"><span>{{$ctrl.bookings.stays}}</span> <small>Résa</small></div><div class=\"zoom bk\" ng-class=\"{na:$ctrl.bookings.stays === 0}\"><span>{{$ctrl.bookings.nights}}</span> <small>Nuitées</small></div><div class=\"zoom bk\" ng-class=\"{na:$ctrl.bookings.stays === 0}\"><span>±{{$ctrl.bookings.avgStay|number:0}}</span> <small>Nuit/Séj.</small></div><div class=\"zoom top bk\" ng-class=\"{na:$ctrl.bookings.stays === 0}\"><small>Arrivées</small> <span style=\"font-size: 1.6em\">j+{{$ctrl.bookings.tta | number:0}}</span></div><div class=\"zoom bk\" ng-class=\"{na:$ctrl.bookings.stays === 0}\"><span>{{$ctrl.bookings.guests}}</span> <small>Hôtes</small></div><div class=\"zoom ca\"><span>{{$ctrl.cancellations.stays}}</span> <small>Annulations</small></div><div class=\"zoom ca\" ng-class=\"{na:$ctrl.cancellations.stays === 0}\"><span>{{$ctrl.cancellations.rate}}%</span> <small>Annul.</small></div><div class=\"zoom top ca\" ng-class=\"{na:$ctrl.cancellations.stays === 0}\"><small>Annulés à</small> <span style=\"font-size: 1.6em\">j- {{$ctrl.cancellations.tta}}</span></div><div class=\"zoom revenue bk\"><small>Revenue</small> <span>{{$ctrl.bookings.revenue | number}} <small>MAD</small></span></div></div><div class=highlights><header class=md-subhead>Séjours</header><div class=\"zoom ci\"><span>{{$ctrl.confirmedCheckins.stays}}</span> <small>Séjours</small></div><div class=\"zoom ci\" ng-class=\"{na:$ctrl.confirmedCheckins.stays === 0}\"><span>{{$ctrl.confirmedCheckins.nights}}</span> <small>Nuitées</small></div><div class=\"zoom ci\" ng-class=\"{na:$ctrl.confirmedCheckins.stays === 0}\"><span>±{{$ctrl.confirmedCheckins.avgStay |number:0}}</span> <small>Nuit/Séj.</small></div><div class=\"zoom top ci\" ng-class=\"{na:$ctrl.confirmedCheckins.stays === 0}\"><small>Réservé à</small> <span style=\"font-size: 1.6em\">j-{{$ctrl.confirmedCheckins.tta|number:0}}</span></div><div class=\"zoom ci\" ng-class=\"{na:$ctrl.confirmedCheckins.stays === 0}\"><span>{{$ctrl.confirmedCheckins.guests}}</span> <small>Hôtes</small></div><div class=\"zoom ca\"><span>{{$ctrl.canceledCheckins.stays}}</span> <small>Annulés</small></div><div class=\"zoom ca\" ng-class=\"{na:$ctrl.canceledCheckins.stays === 0}\"><span>{{$ctrl.canceledCheckins.rate}}%</span> <small>Annul.</small></div><div class=\"zoom top ca\" ng-class=\"{na:$ctrl.canceledCheckins.stays === 0}\"><small>Annulés à</small> <span style=\"font-size: 1.6em\">j- {{$ctrl.canceledCheckins.tta}}</span></div><div class=\"zoom revenue ci\"><small>Valeur</small> <span>{{$ctrl.confirmedCheckins.revenue | number}} <small>MAD</small></span></div></div><!--\n<section class=\"numbers\" style=\"display:flex;flex-wrap:wrap\">\n  <md-card flex=\"33\">\n    <header>Réservations</header>\n    <div ng-if=\"$ctrl.bookings.stays > 0\">\n      <div class=\"stat\">\n        <strong>Séjours</strong><span>{{$ctrl.bookings.stays}}</span>\n      </div>\n      <div class=\"stat\">\n        <strong>Valeur</strong><span>{{$ctrl.bookings.revenue | currency:\'MAD\':2}}</span>\n      </div>\n    </div>\n    <header>Annulations</header>\n    <dl>\n        <dt>Séjours</dt><dd>{{$ctrl.cancellations.stays}}</dd>\n        <dt>Nuités</dt><dd>{{$ctrl.cancellations.nights}}</dd>\n        <dt>Revenue</dt><dd>{{$ctrl.cancellations.revenue | currency:\'MAD\':2}}</dd>\n    </dl>\n  </md-card>\n\n  <md-card flex=\"33\">\n    <header>Séjours</header>\n    <div ng-if=\"$ctrl.confirmedCheckins.stays > 0\">\n\n      <div class=\"stat\">\n        <strong>Hôtes/Unités</strong><span>{{$ctrl.confirmedCheckins.avgGuests}}</span>\n      </div>\n\n      <div class=\"stat\">\n        <strong>Pax*Nuitées</strong><span>{{::($ctrl.confirmedCheckins.nights * $ctrl.confirmedCheckins.guests)  | number:1}}</span>\n      </div>\n      <div class=\"stat\">\n        <strong>Durée moyenne de séjour</strong>\n        <span ng-pluralize\n              count=\"$ctrl.confirmedCheckins.avgNights\"\n              when=\"{\'0\':\'N/A\',\'1\':\'1 jour\',\'other\':\'{} jours\'}\" ></span>\n      </div>\n      <div class=\"stat\">\n        <strong>Délais de réservation</strong>\n        <span ng-pluralize\n              count=\"$ctrl.confirmedCheckins.tta\"\n              when=\"{\'0\':\'Le jour même\',\'1\':\'1 jour\',\'other\':\'{} jours\'}\"></span>\n      </div>\n      <div class=\"stat\">\n        <strong>Séjours annulés</strong><span>{{::$ctrl.canceledCheckins.stays}}</span>\n      </div>\n      <div class=\"stat\">\n        <strong>Taux d\'annulation</strong><span>{{$ctrl.canceledCheckins.rate | number : 2}} %</span>\n      </div>\n      <div class=\"stat\">\n        <strong>Délais d\'annulation</strong><span>{{$ctrl.canceledCheckins.tta | number : 2}} %</span>\n      </div>\n    </div>\n  </md-card>\n\n</section>\n\n--><calendar-chart report-period=$ctrl.period report-data=$ctrl.calendar></calendar-chart>");
$templateCache.put("app/discounts/copy/template.html","<md-dialog><form name=discountCopyForm ng-submit=$ctrl.save()><md-dialog-content><div class=data-line><md-input-container flex=100 required><label>Reference</label><input name=name type=text maxlength=128 ng-model=$ctrl.reference></md-input-container></div><div class=data-line><label>Réservation</label><div><md-input-container style=\"margin: 0\"><label>A partir du</label><md-datepicker required ng-model=$ctrl.booking.start md-min-date=$ctrl.options.bookingMin></md-datepicker></md-input-container><md-input-container style=\"margin: 0\"><label>Jusqu\'au</label><md-datepicker required ng-model=$ctrl.booking.end md-min-date=$ctrl.booking.start></md-datepicker></md-input-container></div></div><div class=data-line><label>Séjour</label><div><md-input-container style=\"margin: 0\"><label>A partir du</label><!-- <md-datepicker required name=\"stayStart\" ng-model=\"$ctrl.stay.start\" md-min-date=\"$ctrl.booking.start\" md-date-filter=\"$ctrl.stayDateFilter\"></md-datepicker> --><md-datepicker required name=stayStart ng-model=$ctrl.stay.start md-min-date=$ctrl.booking.start></md-datepicker></md-input-container><md-input-container style=\"margin: 0\"><label>Jusqu\'au</label><!-- <md-datepicker required name=\"stayEnd\" ng-model=\"$ctrl.stay.end\" md-min-date=\"$ctrl.stay.start\" md-date-filter=\"$ctrl.stayDateFilter\"></md-datepicker> --><md-datepicker required name=stayEnd ng-model=$ctrl.stay.end md-min-date=$ctrl.stay.start></md-datepicker></md-input-container></div></div></md-dialog-content><md-dialog-actions><md-button type=submit ng-disabled=discountCopyForm.$invalid>Enregistrer</md-button><md-button type=button ng-click=$ctrl.cancel()>Annuler</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/discounts/edit/template.html","<div layout=row layout-align=space-around ng-hide=::$ctrl.ready><md-progress-circular md-mode=indeterminate></md-progress-circular></div><form name=discountForm class=card ng-if=::$ctrl.ready><section class=header><md-input-container class=md-block><!-- <input aria-label=\"reference\" ng-model=\"$ctrl.discount.reference\" maxlength=\"16\" placeholder=\"référence\" disabled> --> <input aria-label=reference ng-model=$ctrl.discount.reference maxlength=16 placeholder=référence required></md-input-container><md-input-container ng-repeat=\"lang in ::$ctrl.languages\" class=md-block><label>Libellé / {{::lang.name}}</label><input ng-model=$ctrl.discount.label[lang.code] required></md-input-container><md-input-container flex class=md-block><label>Score de 1 à 10</label><input name=score type=number min=1 max=10 required ng-model=$ctrl.discount.score></md-input-container></section><section><div class=data-line><label>Réservation</label><div><md-input-container style=\"margin: 0\"><label>A partir du</label><md-datepicker ng-model=$ctrl.discount.booking.period.start md-min-date=$ctrl.options.bookingMin></md-datepicker></md-input-container><md-input-container style=\"margin: 0\"><label>Jusqu\'au</label><md-datepicker ng-model=$ctrl.discount.booking.period.end md-min-date=$ctrl.discount.booking.period.start></md-datepicker></md-input-container></div></div><div class=data-line><label>Délais</label><md-input-container style=\"width:4em;margin: 0\"><input style=text-align:center required type=number ng-model=$ctrl.discount.booking.advance.min min=0 max=999 aria-label=\"minimum advanced booking\"></md-input-container><div>à</div><md-input-container style=\"width:4em; margin: 0\"><input style=text-align:center required type=number ng-model=$ctrl.discount.booking.advance.max min={{$ctrl.basis.booking.advance.min}} max=999 aria-label=\"maximum advanced booking\"></md-input-container><span>Jours à l\'avance</span></div></section><section><div class=data-line><label>Séjour</label><div><md-input-container style=\"margin: 0\"><label>A partir du</label><md-datepicker name=stayStart ng-model=$ctrl.discount.stay.period.start md-min-date=$ctrl.options.bookingMin></md-datepicker><!-- <md-datepicker name=\"stayStart\" ng-model=\"$ctrl.discount.stay.period.start\" ></md-datepicker> --></md-input-container><md-input-container style=\"margin: 0\"><label>Jusqu\'au</label><md-datepicker name=stayEnd ng-model=$ctrl.discount.stay.period.end md-min-date=$ctrl.discount.stay.period.start></md-datepicker><!-- <md-datepicker name=\"stayEnd\" ng-model=\"$ctrl.discount.stay.period.end\" ></md-datepicker> --></md-input-container></div></div><div class=data-line style=\"align-items: center\"><label>Durée</label><md-input-container style=\"width:4em;margin: 0\"><input style=text-align:center required type=number ng-model=$ctrl.discount.stay.length.min min=1 max=999 aria-label=\"minimum stay\"></md-input-container><div>à</div><md-input-container style=\"width:4em; margin: 0\"><input style=text-align:center required type=number ng-model=$ctrl.discount.stay.length.max min={{$ctrl.basis.booking.advance.min}} max=999 aria-label=\"maximum stay\"></md-input-container><span>Nuits</span></div><div style=\"padding-left: 50px\"><md-checkbox ng-model=$ctrl.discount.ctrlCheckinDate>Active pour le Checkin</md-checkbox><md-checkbox ng-model=$ctrl.discount.ctrlCheckoutDate style=\"padding-left: 98px\">Active pour le Checkout</md-checkbox></div><!-- <div style=\" padding-left: 50px;\">\n      <md-checkbox ng-model=\"$ctrl.discount.ctrlCheckoutDate\">Active pour le Checkout</md-checkbox>\n    </div>--><div style=\"padding-left: 50px\"><md-checkbox ng-model=$ctrl.discount.btob>Active uniquement pour le B2B</md-checkbox><md-checkbox ng-model=$ctrl.discount.btoc style=\"padding-left: 50px\">Active uniquement pour le B2C</md-checkbox></div><!-- <md-select ng-model=\"$ctrl.discount.pos\"  >\n      <md-option value=\"ALL\" >ALL</md-option>\n      <md-option value=\"btob\" checked>Active uniquement pour le B2B</md-option>\n      <md-option value=\"btc\">Active uniquement pour le B2C</md-option>\n\n    </md-select>--></section><section><h4>Remise</h4><div><md-input-container><label>Unité</label><md-select ng-model=$ctrl.discount.rule.unit required><md-option ng-repeat=\"(unit,label) in ::units\" ng-value=unit>{{::label}}</md-option><md-option value=n>en nuitée</md-option><md-option value=m>Forfaitaire</md-option><md-option value=%>en pourcentage</md-option></md-select></md-input-container><md-input-container><label>Valeur</label><input type=number min=0 max=9999999 style=width:5em ng-model=$ctrl.discount.rule.value required></md-input-container><md-input-container ng-if=\"$ctrl.discount.rule.unit === \'n\'\"><label>Nuit(s) gratuites</label><md-select ng-model=$ctrl.discount.rule.nights required><md-option ng-repeat=\"(v,label) in ::$ctrl.options.discountNights\" ng-value=v>{{::label}}</md-option></md-select></md-input-container><!-- <md-checkbox ng-model=\"$ctrl.discount.baseOnly\">Remise sur la base seulement</md-checkbox>--><md-checkbox ng-model=$ctrl.allProducts>Applicable à tous les tarifs/offres</md-checkbox></div></section><section><md-checkbox ng-model=$ctrl.discount.combinable>Combinable</md-checkbox><div ng-repeat=\"d in ::$ctrl.items track by $index\" ng-if=$ctrl.discount.combinable><md-checkbox ng-if=\"d.code != $ctrl.discount.code\" ng-checked=\"$ctrl.combinationGroup.indexOf(d.code) > -1\" ng-click=$ctrl.toggleCombinDiscount(d)>{{::d.label}} : A partir du {{::d.stay.period.start}} Jusqu\'au {{::d.stay.period.end}}</md-checkbox></div></section><section><!-- \n    <md-select ng-model=\"$ctrl.discount.combinationRule\"  ng-if=\"$ctrl.discount.combinable\">\n      <md-option value=\"S\" checked>Séquentiel</md-option>\n      <md-option value=\"T\">Total</md-option>\n\n    </md-select> --><md-input-container class=md-block><label>Description</label><text-angular ng-model=$ctrl.discount.description ta-default-wrap=span md-select-on-focus></text-angular></md-input-container></section><section ng-if=!$ctrl.allProducts><div ng-repeat=\"u in ::$ctrl.units\" class=unit><h4 style=\"margin-bottom: 0\">{{::$ctrl.unitTypes[u.type].name}} {{::u.name}}</h4><div ng-if=::u.products.length><product-select-matrix boards=::$ctrl.boards products=::u.products rate-bases=::$ctrl.rateBases unit=::u values=$ctrl.discount.products></product-select-matrix></div><p ng-if=\"::(u.products.length === 0)\">Aucune offre parametrée pour cette catégorie</p></div></section><section><h4>Conditions spéciales</h4></section><section><dl><dt><md-checkbox ng-model=$ctrl.toggles.cancellation>Annulation</md-checkbox></dt><dd><cancellation-input ng-if=$ctrl.toggles.cancellation ng-model=$ctrl.discount.cancellation currency=\"\'MAD\'\"></cancellation-input></dd><dt><md-checkbox ng-model=$ctrl.toggles.payment>Conditions de paiement</md-checkbox></dt><dd><md-radio-group ng-if=$ctrl.toggles.payment flex layout=row ng-model=$ctrl.discount.payOnArrival layout-margin flex layout=column><md-radio-button ng-value=false class=md-primary>Le client paye à la réservation</md-radio-button><md-radio-button ng-value=true class=md-primary>Le client paye à l\'arrivée (à l\'hotel)</md-radio-button></md-radio-group></dd><dt><md-checkbox ng-model=$ctrl.toggles.availability>Disponibilité limité</md-checkbox></dt><dd><md-input-container ng-if=$ctrl.toggles.availability><label>Nombre de réservation</label><input type=number step=1 ng-pattern=/^\\d+$/ min=1 aria-label=Disponibilité ng-model=$ctrl.discount.availability min=0 required></md-input-container></dd><dt><md-checkbox ng-model=$ctrl.toggles.markets>Marchés spécifiques</md-checkbox></dt><dd><markets-input ng-if=$ctrl.toggles.markets ng-model=$ctrl.discount.markets countries=$ctrl.countries></markets-input></dd></dl></section><md-divider></md-divider><footer layout=row layout-align=\"end center\" style=\"padding: 8px\"><md-button class=\"md-raised md-accent\" ng-click=$ctrl.save($ctrl.basis) ng-disabled=discountForm.$error.required>Enregitrer</md-button><md-button ui-sref=^.discounts>fermer</md-button></footer></form><!-- <pre>{{$ctrl.discount | json}}</pre> -->");
$templateCache.put("app/discounts/list/template.html","<div ng-if=\"$ctrl.items.length === 0\" class=md-card style=\"text-align:center; max-width:600;margin:56px auto\">Aucune promotion.<md-button class=md-accent ui-sref=\"^.discountEdit({discount:\'new\'})\">ajouter une promotion</md-button></div><section class=\"card discount\" ng-repeat=\"d in ::$ctrl.items\"><header><h3>Réf. {{::d.reference}} - {{::d.label}} <small>{{::d.rule | discountRule:$ctrl.propertyCtrl.property.currency}} <span ng-if=::d.baseOnly>sur la base<span></span></span></small></h3></header><section><div class=data-line><label>Réservation</label><p>du <strong>{{::d.booking.period.start | date:\'d/MM/yyyy\'}}</strong> au <strong>{{::d.booking.period.end | date:\'d/MM/yyyy\'}}</strong></p></div><div class=data-line><label>Délais</label><p>{{::d.booking.advance.min}} à {{::d.booking.advance.max}} jour(s) à l\'avance</p></div><div class=data-line><label>Séjour</label><p>du <strong>{{d.stay.period.start | date:\'d/MM/yyyy\'}}</strong> au <strong>{{d.stay.period.end | date:\'d/MM/yyyy\'}}</strong></p></div><div class=data-line><label>Durée</label><p>{{d.stay.length.min}} à {{d.stay.length.max}} nuit(s)</p></div></section><section><div class=data-line ng-if=::d.cancellation.length><label>Annulation</label><div ng-repeat=\"c in ::d.cancellation\">{{::c | cancellation}}</div></div><div class=data-line ng-show=::d.payOnArrival><label>Paiement</label><p>à l\'hôtel</p></div><div class=data-line ng-if=::d.markets.length><label>Marché</label><span ng-repeat=\"cc in d.markets\">{{cc}}</span></div></section><a ng-click=\"d.showAllRooms = !d.showAllRooms\"><span ng-if=!d.showAllRooms>Développer</span> <span ng-if=d.showAllRooms>Réduire</span></a><section ng-if=d.showAllRooms ng-repeat=\"u in ::d.unitsGrid\" class=unit-discounts><h4><md-icon>hotel</md-icon>{{::$ctrl.unitTypes[u.unit.type].name}} {{::u.unit.name}}<br></h4><div ng-if=::u.unit.all><span style=\"font-size: 12px;font-weight: 500;text-align: left;color: #009688\">Remise sur toutes les offres</span></div><table ng-if=::(!u.unit.all) ng-repeat=\"rbDim in ::u.grid\" class=discount-grid><thead><tr><th style=\"font-size: 12px;text-align: left\">{{::$ctrl.rateBases[u.rateBases[$index]].description}}</th><th ng-repeat=\"b in ::u.boards\">{{::$ctrl.boards[b].name}}</th></tr></thead><tbody><tr ng-repeat=\"ocDim in ::rbDim\"><th>{{::u.occupancies[$index]|occupancy}}</th><td ng-repeat=\"match in ::ocDim track by $index\"><md-icon ng-bind=\"::(match?\'check\':\'\')\"></md-icon></td></tr></tbody></table></section><footer style=\"text-align: right;background-color: rgba(0, 162, 255, 0.25)\" ng-if=$ctrl.permissionsContracting><md-button class=md-accent ui-sref=^.discountEdit({discount:d.code})>modifier</md-button><md-button ng-click=\"$ctrl.copy($event, d)\">dupliquer</md-button><md-button ng-click=\"$ctrl.remove($event, d)\">supprimer</md-button></footer></section>");
$templateCache.put("app/discounts/list/template2.html","<div ng-if=\"$ctrl.items.length === 0\" class=md-card style=\"text-align:center; max-width:600;margin:56px auto\">Aucune promotion.<md-button class=md-accent ui-sref=\"^.discountEdit({discount:\'new\'})\">ajouter une promotion</md-button></div><!-- <pre>{{$ctrl.units}}</pre> --><md-card ng-if=\"$ctrl.items.length > 0\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><h3>{{::$ctrl.items.length}} Promotions</h3><div class=search-text flex><md-icon>search</md-icon><input style=width:100% type=text ng-model=$ctrl.search placeholder=Filtrer...></div></div></md-toolbar><md-table-container><table md-table><thead md-head><tr md-row><!-- <th md-column></th> --><th md-column>Réf</th><!-- <th md-column>Type</th> --><th md-column>Rule</th><th md-column>Réservation</th><th md-column>Delais</th><th md-column>Séjour</th><th md-column>Chambre</th><th md-column></th></tr></thead><tbody md-body><!-- <tr md-row style=\"cursor:pointer\" ng-repeat-start=\"p in $ctrl.prestations | filter: $ctrl.search \"> --><!-- <tr md-row style=\"cursor:pointer\" ng-repeat-start=\"r in $ctrl.rateBases\"> --><tr md-row style=cursor:pointer ng-repeat-start=\"d in $ctrl.items | filter: $ctrl.search \"><!-- <td md-cell>\n  \n                          <span class=\"material-icons\" ng-click=\"p.details = !p.details\"\n                              ng-bind=\"p.details ? \'expand_less\' : \'expand_more\'\">\n                          </span>\n                      </td> --><td md-cell>{{::d.reference}} - {{::d.label}}</td><td md-cell>{{::d.rule | discountRule:$ctrl.propertyCtrl.property.currency}}</td><td md-cell>{{::d.booking.period.start | date:\'d/MM/yyyy\'}} au {{::d.booking.period.end | date:\'d/MM/yyyy\'}}</td><td md-cell>{{::d.booking.advance.min}} à {{::d.booking.advance.max}} jour(s) à l\'avance</td><td md-cell>{{d.stay.period.start | date:\'d/MM/yyyy\'}} au {{d.stay.period.end | date:\'d/MM/yyyy\'}}</td><td md-cell><a ng-click=\"d.showAllRooms = !d.showAllRooms\"><span ng-if=!d.showAllRooms>Développer</span> <span ng-if=d.showAllRooms>Réduire</span></a><ul ng-if=d.showAllRooms><li ng-repeat=\"u in ::d.unitsGrid\">{{::u.unit.name}}</li></ul></td><td md-cell style=\"width: 230px\" ng-if=\" $ctrl.permissionsContracting\"><md-button class=md-icon-button ui-sref=^.discountEdit({discount:d.code})><md-icon>edit</md-icon><md-tooltip>Modifier</md-tooltip></md-button><md-button class=md-icon-button ng-click=\"$ctrl.copy($event, d)\"><md-icon>content_copy</md-icon><md-tooltip>Dupliquer</md-tooltip></md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"$ctrl.remove($event, d)\"><md-icon>delete</md-icon><md-tooltip>Supprimer</md-tooltip></md-button></td></tr><tr md-row ng-repeat-end ng-show=\"p.details === true\"><td colspan=8><table md-table><thead md-head style=\"background-color: rgb(226 229 231)\"><tr md-row><th md-column>Type</th><th md-column>Prix/%</th><th md-column>Type tarif</th><th md-column>Tarif App</th><th md-column>Option</th><th md-column>promos.</th><!-- <th md-column> offers.</th> --><th md-column>Enfants</th><!-- <th md-column> Bébé</th> --><th md-column>M.stay</th><th md-column>Description</th><th md-column>Date début</th><th md-column>Date fin</th></tr></thead><tbody><tr md-row><td md-cell>{{::p.typology}}</td><td md-cell>{{::p.pricePourcentage}}</td><td md-cell>{{::p.tarifType}}</td><td md-cell>{{::p.tarifApplicable}}</td><td md-cell>{{::p.option}}</td><td md-cell><ul><li ng-repeat=\"discountName in p.discountsNames\">{{::discountName}}</li></ul></td><!-- <td md-cell>\n                                          <ul>\n                                              <li ng-repeat=\"offerName in p.offers\">\n                                                  {{::offerName}}\n                                              </li>\n                                          </ul>\n  \n                                      </td> --><td md-cell><ul><li ng-repeat=\"child in p.childs\"><span>à : {{::child.to}} </span><span>unité :<p ng-if=\"child.unit == 0\">prix</p><p ng-if=\"child.unit == 1\">%</p></span><span>valeur : {{::child.value}}</span></li></ul></td><td md-cell>{{::p.minStay}}</td><td md-cell>{{::p.description}}</td><td md-cell>{{::p.debut}}</td><td md-cell>{{::p.fin}}</td></tr><tr></tr></tbody></table></td></tr></tbody></table></md-table-container></md-card>");
$templateCache.put("app/media/gallery/template.html","<div ng-if=\"($ctrl.items.length === 0)\" style=\"text-align:center; max-width:600;margin:56px auto\"><p>Aucune photo. Cliquez sur le bouton ajouter en haut à droite pour ajouter une photo.</p></div><section layout=row layout-wrap dnd-list=$ctrl.items dnd-effect-allowed=move dnd-drop=$ctrl.changeOrder(item,index)><!--<pre>{{$ctrl.units | json}}</pre>--><md-card ng-repeat=\"media in $ctrl.items\" style=width:320px dnd-draggable=media dnd-moved=\"$ctrl.items.splice($index, 1)\"><md-card-header style=position:relative><md-card-header-text><span class=md-subhead ng-model=$ctrl.copy.subject>{{media.subject}}</span></md-card-header-text><!-- <pre>{{media | json}}</pre> --></md-card-header><!--<img ng-if=\"media.contentType.indexOf(\'image\') == 0\"\n    ng-src=\"http://imgrsz.atlasvoyages.com/img/320x180/{{media.url}}\" class=\"md-card-image\"\n      ng-model=\"$ctrl.copy.url\" />--> <img ng-if=\"media.contentType.indexOf(\'image\') == 0\" ng-src=https://fio.fractalite.com/img/320x180/{{media.url}} class=md-card-image ng-model=$ctrl.copy.url><iframe ng-if=\"media.contentType.indexOf(\'html\') >= 0\" ng-src={{media.url}} class=md-card-image ng-model=$ctrl.copy.url></iframe><video ng-if=\"media.contentType.indexOf(\'video\') == 0\" ng-src={{media.url}} class=md-card-image ng-model=$ctrl.copy.url></video><md-card-actions layout=row layout-align=\"center center\"><!-- <label>add to room <input type=\"checkbox\" ng-model=\"addroom\" ng-init=\"checked=true\" /></label><br/> --><!-- <md-select placeholder=\"Affecter à\" ng-change= \"$ctrl.update($event,media,selectroom)\" ng-model=\"selectroom\" style=\"min-width: 150px;\" >   --><md-select placeholder=\"Affecter à\" ng-change=$ctrl.update($event,media) ng-model=media.unit style=\"min-width: 150px\"><!-- <md-select-label>{{$ctrl.units.name[media.unit]}}</md-select-label> --><!-- <md-option   ng-value=\"null\"> Hôtel </md-option>   --><!-- <md-option ng-repeat=\"unit in $ctrl.units\" ng-selected=\"{{unit.code[media.unit]}}\" ng-value=\"{{unit.code}}\">\n          {{unit.name}} </md-option> --><md-option ng-repeat=\"unit in $ctrl.units\" ng-value={{unit.code}}>{{unit.name}}</md-option></md-select><!-- <md-select-label>{{$ctrl.units.name[media.unit]}}</md-select-label> --><!-- <md-option   ng-value=\"null\"> Hôtel </md-option>   --><!-- <md-option ng-repeat=\"unit in $ctrl.units\" ng-selected=\"{{unit.code[media.unit]}}\" ng-value=\"{{unit.code}}\">\n        {{unit.name}} </md-option> --><!-- <button ng-if=\"addroom\"   ng-click=\"$ctrl.update($event,media,selectroom)\">Ajouter</button> --><!-- <md-input-container>\n        <label>Unité</label>\n        <md-select placeholder=\"Affecter à\" ng-change=\"$ctrl.update($event,media)\" ng-model=\"media.unit\"\n          style=\"min-width: 150px;\">\n          <md-option ng-repeat=\"unit in $ctrl.units\" ng-value=\"{{unit.code}}\">\n            {{unit.name}} </md-option>\n        </md-select>\n      </md-input-container>\n\n      <md-input-container>\n        <label>Weight</label>\n         <input type=\"number\" min=\"0\" max=\"999999\" ng-model=\"media.weight\" style=\"width:5em;\" required /> \n        <md-select placeholder=\"Affecter à\" ng-change=\"$ctrl.update($event,media)\" style=\"width:4em;\"\n          ng-model=\"media.weight\">\n          <md-option ng-repeat=\"w in [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]\" ng-value=\"{{w}}\">\n            {{w}} </md-option>\n        </md-select>\n      </md-input-container> --></md-card-actions><md-card-actions layout=row layout-align=\"center center\"><label>Classement</label><input id=rating name=rating type=number min=1 ng-model=media.ranking style=\"margin-left: 10px;width: 50px\" maxlength=4 size=4 ng-blur=$ctrl.test($event,media)></md-card-actions><md-card-actions layout=row layout-align=\"end center\"><md-button class=\"md-icon-button md-warn\" aria-label=Settings ng-click=\"$ctrl.removeMedia($event, media)\"><md-icon>delete</md-icon></md-button></md-card-actions></md-card></section>");
$templateCache.put("app/media/upload/template.html","<form name=uploadForm><md-dialog-content><div style=\"padding:8px 16px\"><md-input-container class=md-block><label>Titre</label><input name=subject ng-model=$ctrl.subject required></md-input-container></div><div ng-hide=$ctrl.file required ngf-drop ng-model=$ctrl.file class=drop-box style=\"width:320px;height:180px;background: #ededed;padding:8px 16px\"><p style=text-align:center>Glisser la photo ici</p><ul><!-- <li ng-class=\"{\'md-warn\':uploadForm.file.$error.minHeight}\">hauteur min: {{$ctrl.validation.height.min}}px</li>\n        <li ng-class=\"{\'md-warn\':uploadForm.file.$error.minWidth}\">largeur min: {{$ctrl.validation.width.min}}px</li> --><li ng-class=\"{\'md-warn\':uploadForm.file.$error.size}\">taille max: {{$ctrl.validation.size}}</li><!-- <li ng-class=\"{\'md-warn\':uploadForm.file.$error.pattern}\">Photo jpeg seulement</li> --></ul></div><img style=display:block ng-if=$ctrl.file ngf-src=$ctrl.file ngf-resize=\"{width: 320, height: 180, quality: 0.9}\"><div class=\"md-button md-primary\" ng-class=\"{\'md-raised\':!$ctrl.file}\" ngf-select ng-model=$ctrl.file name=file ngf-validate=::$ctrl.validation><md-icon>attach_file</md-icon><span>{{$ctrl.file ?\'changer\':\'choisir\'}}...</span></div><md-progress-linear md-mode=indeterminate ng-show=$ctrl.posting></md-progress-linear></md-dialog-content><md-dialog-actions ng-hide=$ctrl.posting><md-button ng-click=$ctrl.post() class=md-accent ng-disabled=uploadForm.$invalid>Enregistrer</md-button><md-button ng-click=$ctrl.onCancel()>Annuler</md-button></md-dialog-actions></form>");
$templateCache.put("app/on-request/list/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>En Request</span></div></md-toolbar><form name=onRequestForm style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 16px;\n  display: flex; align-items: flex-start\"><!-- <span class=\"md-subhead\" style=\"    margin: 25px 16px 0 8px;\">Add</span> --><md-input-container class=md-block flex=20 required><label>description</label><input type=text ng-model=onRequest.description></md-input-container><md-input-container style=margin-left:16px><label>Type</label><md-select placeholder=\"On Request Type\" ng-change=\"\" ng-model=onRequest.type style=\"min-width: 150px\"><!-- <md-select-label>{{$ctrl.units.name[media.unit]}}</md-select-label> --><md-option ng-value=0>All</md-option><md-option ng-value=1>Bases Tarifaires</md-option><md-option ng-value=2>chambre</md-option><!-- <md-option   ng-value=3> pensions </md-option>   --><!-- <md-option  ng-repeat=\"unit in $ctrl.units\" ng-selected=\"{{unit.name[media.unit]}}\" ng-value=\"{{unit.code}}\"> {{unit.name}} </md-option>   --></md-select></md-input-container><md-input-container ng-show=\"onRequest.type==\'1\'\" style=margin-left:16px><md-select placeholder=rate ng-change=\"\" ng-model=onRequest.typecode style=\"min-width: 150px\"><md-option ng-repeat=\"rateBases in $ctrl.rateBases\" ng-value={{rateBases.code}}>{{rateBases.description}}</md-option></md-select></md-input-container><md-input-container ng-show=\"onRequest.type==\'2\'\" style=margin-left:16px><md-select placeholder=room ng-change=\"\" ng-model=onRequest.typecode style=\"min-width: 150px\"><md-option ng-repeat=\"unit in $ctrl.units\" ng-value={{unit.code}}>{{unit.name}}</md-option></md-select></md-input-container><md-input-container style=margin-left:16px><div class=field-inline><label>Du</label><md-datepicker md-current-view=year ng-model=onRequest.debut md-min-date=$ctrl.minDate md-placeholder=jj/mm/aaaa required></md-datepicker></div></md-input-container><md-input-container style=margin-left:16px><div class=field-inline><label>Jusqu\'au</label><md-datepicker md-current-view=year ng-model=onRequest.fin md-min-date=onRequest.debut md-placeholder=jj/mm/aaaa required></md-datepicker></div></md-input-container><md-dialog-actions ng-if=\" $ctrl.permissionsContracting\"><md-button class=\"md-raised md-accent md-button md-ink-ripple\" ng-click=$ctrl.createonrequests(onRequest) ng-disabled=\"onRequestForm.$pristine || onRequestForm.$invalid\">Ajouter</md-button></md-dialog-actions></form><div layout=row layout-align=\"start center\" style=\"padding: 8px 16px\"><md-input-container><label>Filtrer à partir de</label><md-datepicker ng-model=$ctrl.filteronrequests.filterStartDate md-placeholder=jj/mm/aaaa></md-datepicker></md-input-container><md-input-container style=margin-left:16px><label>Jusqu\'à</label><md-datepicker ng-model=$ctrl.filteronrequests.filterEndDate md-placeholder=jj/mm/aaaa></md-datepicker></md-input-container><md-input-container style=margin-left:16px><label>Type de chambre</label><md-select ng-model=$ctrl.filteronrequests.selectedRoomType><md-option value=\"\">Tous</md-option><md-option ng-repeat=\"unit in $ctrl.units\" ng-value={{unit.code}}>{{unit.name}}</md-option></md-select></md-input-container><md-button class=\"md-raised md-primary\" style=margin-left:16px ng-click=$ctrl.applyDateFilter($ctrl.filteronrequests.filterStartDate,$ctrl.filteronrequests.filterEndDate,$ctrl.filteronrequests.selectedRoomType)>Filtrer</md-button><md-button class=md-raised ng-click=$ctrl.clearDateFilter()>Effacer</md-button></div><!-- exact table from live demo --><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-on-reorder=$ctrl.loadonrequests><tr md-row><th md-column><span>Nom</span></th><th md-column><span>Type</span></th><th md-column><span>Nom de Type </span></th><th md-column><span>Date de debut</span></th><th md-column><span>Date de fin</span></th><!-- <th md-column ><span>Action</span></th> --></tr></thead><tbody md-body><!--<tr md-row ng-repeat=\"r in $ctrl.onRequests.items\" >--><tr md-row ng-repeat=\"r in $ctrl.filteredOnRequests\"><td md-cell>{{::r.description}}</td><td md-cell>{{::r.type}}</td><td md-cell ng-if=\"r.type == \'Hotel\'\">{{::r.type}}</td><td md-cell ng-if=\"r.type == \'Base Tarifaire\'\">{{$ctrl.rateBases[r.typeCode].description}}</td><td md-cell ng-if=\"r.type == \'Unit\'\">{{$ctrl.units[r.typeCode].name}}</td><!-- <td md-cell ng-if=\"r.type == \'Unit\'\">{{r.typeCode}}</td> --><!-- <td md-cell ng-if=\"r.type == \'Unit\'\">{{$ctrl.units}}</td> --><td md-cell>{{::r.debut}}</td><td md-cell>{{::r.fin}}</td><td md-cell><!-- <md-button class=\"md-icon-button\" ng-click=\"$ctrl.edit($event,s)\"><md-icon>edit</md-icon>\n              <md-tooltip>Modifier</md-tooltip>\n            </md-button> --><md-button ng-if=\" $ctrl.permissionsContracting\" class=\"md-icon-button md-warn\" aria-label=Settings ng-click=$ctrl.remove($event,r)><md-icon>delete</md-icon></md-button></td></tr></tbody></table></md-table-container><!-- <md-table-pagination md-boundary-links=\"true\" md-limit=\"$ctrl.query.limit\" md- md-page=\"$ctrl.query.page\" md-total=\"{{$ctrl.total}}\" md-on-paginate=\"$ctrl.loadBookings\"></md-table-pagination> --><div></div></md-card>");
$templateCache.put("app/prestations/edit/template.html","<form name=prestationCard class=card><md-card style=\"width: 600px\"><div layout=column layout-wrap><md-content layout-padding><form name=projectForm class=card><div layout-gt-sm=row><md-input-container class=md-block><label>Nom</label><input required md-no-asterisk name=name ng-model=$ctrl.prestation.nom style=\"min-width: 250px\"><!-- <div ng-messages=\"projectForm.name.$error\">\n                            <div ng-message=\"required\">This is required.</div>\n                            <div ng-message=\"md-maxlength\">The description must be less than 30 characters long.</div>\n                        </div> --></md-input-container><md-input-container class=md-block><label>Code Fournisseur</label><input md-maxlength=30 required md-no-asterisk name=supplier ng-model=$ctrl.prestation.supplier required><!-- <div ng-messages=\"projectForm.supplier.$error\">\n                            <div ng-message=\"required\">This is required.</div>\n                            <div ng-message=\"md-maxlength\">The description must be less than 30 characters long.</div>\n                        </div> --></md-input-container></div><!-- <div layout-gt-sm=\"row\"> --><md-input-container class=md-block style=\"min-height: 150px\"><label>Description</label><!-- <input required type=\"text\" name=\"description\" ng-model=\"$ctrl.prestation.description\"\n                            minlength=\"10\" maxlength=\"1000\" /> --><text-angular ng-model=$ctrl.prestation.description ta-default-wrap=span md-select-on-focus></text-angular><!-- <textarea ng-model=\"$ctrl.prestation.description\" rows=\"4\" md-select-on-focus required></textarea> --><!-- <div ng-messages=\"projectForm.description.$error\" role=\"alert\">\n                        <div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">\n                            Your email must be between 10 and 1000 characters long and look like an e-mail address.\n                        </div>\n                    </div> --></md-input-container><!-- </div> --><!-- <md-input-container class=\"md-block\">\n                    <label>Hourly Rate (USD)</label>\n                    <input required type=\"number\" step=\"any\" name=\"rate\" ng-model=\"prestation.rate\" min=\"800\" max=\"4999\"\n                        ng-pattern=\"/^1234$/\" />\n\n                    <div ng-messages=\"projectForm.rate.$error\" multiple md-auto-hide=\"false\">\n                        <div ng-message=\"required\">\n                            You\'ve got to charge something! You can\'t just <b>give away</b> a Missile Defense\n                            System.\n                        </div>\n\n                        <div ng-message=\"min\">\n                            You should charge at least $800 an hour. This job is a big deal... if you mess up,\n                            everyone dies!\n                        </div>\n\n                        <div ng-message=\"pattern\">\n                            You should charge exactly $1,234.\n                        </div>\n\n                        <div ng-message=\"max\">\n                            {{projectForm.rate.$viewValue | currency:\"$\":0}} an hour? That\'s a little ridiculous. I\n                            doubt even Bill Clinton could afford that.\n                        </div>\n                    </div>\n                </md-input-container> --><!-- <md-divider></md-divider> --><!-- <div layout=\"row\">\n                    <md-input-container flex=\"20\">\n                        <label>Client Name</label>\n                        <input required name=\"clientName\" ng-model=\"prestation.clientName\">\n                        <div ng-messages=\"projectForm.clientName.$error\">\n                            <div ng-message=\"required\">This is required.</div>\n                        </div>\n                    </md-input-container>\n\n                    <div flex=\"5\" hide-xs hide-sm>\n                    </div>\n\n                    <md-input-container flex=\"20\">\n                        <label>Project Type</label>\n                        <md-select name=\"type\" ng-model=\"prestation.type\" required>\n                            <md-option value=\"app\">Application</md-option>\n                            <md-option value=\"web\">Website</md-option>\n                        </md-select>\n                        <div ng-messages=\"projectForm.type.$error\">\n                            <div ng-message=\"required\">This is required.</div>\n                        </div>\n                    </md-input-container>\n                    <div flex=\"5\" hide-xs hide-sm>\n                    </div>\n\n                    <md-input-container flex=\"20\">\n                        <label>Project Type</label>\n                        <md-select name=\"type\" ng-model=\"prestation.type\" required>\n                            <md-option value=\"app\">Application</md-option>\n                            <md-option value=\"web\">Website</md-option>\n                        </md-select>\n                        <div ng-messages=\"projectForm.type.$error\">\n                            <div ng-message=\"required\">This is required.</div>\n                        </div>\n                    </md-input-container>\n                    <div flex=\"5\" hide-xs hide-sm>\n                    </div>\n                    <md-input-container flex=\"20\">\n                        <label>Project Type</label>\n                        <md-select name=\"type\" ng-model=\"prestation.type\" required>\n                            <md-option value=\"app\">Application</md-option>\n                            <md-option value=\"web\">Website</md-option>\n                        </md-select>\n                        <div ng-messages=\"projectForm.type.$error\">\n                            <div ng-message=\"required\">This is required.</div>\n                        </div>\n                    </md-input-container>\n\n                </div> --><!-- <div layout=\"row\">\n                    <md-input-container flex=\"20\">\n                        <label>Client Name</label>\n                        <input required name=\"clientName\" ng-model=\"prestation.clientName\">\n                        <div ng-messages=\"projectForm.clientName.$error\">\n                            <div ng-message=\"required\">This is required.</div>\n                        </div>\n                    </md-input-container>\n\n                    <div flex=\"5\" hide-xs hide-sm>\n                    </div>\n\n                    <md-input-container flex=\"20\">\n                        <label>Project Type</label>\n                        <md-select name=\"type\" ng-model=\"prestation.type\" required>\n                            <md-option value=\"app\">Application</md-option>\n                            <md-option value=\"web\">Website</md-option>\n                        </md-select>\n                        <div ng-messages=\"projectForm.type.$error\">\n                            <div ng-message=\"required\">This is required.</div>\n                        </div>\n                    </md-input-container>\n                    <div flex=\"5\" hide-xs hide-sm>\n                    </div>\n\n                    <md-input-container flex=\"20\">\n                        <label>Project Type</label>\n                        <md-select name=\"type\" ng-model=\"prestation.type\" required>\n                            <md-option value=\"app\">Application</md-option>\n                            <md-option value=\"web\">Website</md-option>\n                        </md-select>\n                        <div ng-messages=\"projectForm.type.$error\">\n                            <div ng-message=\"required\">This is required.</div>\n                        </div>\n                    </md-input-container>\n                    <div flex=\"5\" hide-xs hide-sm>\n                    </div>\n                    <md-input-container flex=\"20\">\n                        <label>Project Type</label>\n                        <md-select name=\"type\" ng-model=\"prestation.type\" required>\n                            <md-option value=\"app\">Application</md-option>\n                            <md-option value=\"web\">Website</md-option>\n                        </md-select>\n                        <div ng-messages=\"projectForm.type.$error\">\n                            <div ng-message=\"required\">This is required.</div>\n                        </div>\n                    </md-input-container>\n\n                </div> --><md-input-container class=md-block flex-gt-sm><!-- <input name=\"social\" ng-model=\"prestation.social\" ng-pattern=\"/^[0-9]{3}-[0-9]{2}-[0-9]{4}$/\" /> --><md-checkbox ng-model=$ctrl.prestation.justification>justification</md-checkbox><!-- <div class=\"hint\" ng-if=\"showHints\">###-##-####</div>\n        \n                              <div ng-messages=\"projectForm.social.$error\" ng-if=\"!showHints\">\n                                  <div ng-message=\"pattern\">###-##-#### - Please enter a valid SSN.</div>\n                              </div> --></md-input-container><md-input-container class=md-block flex-gt-sm><!-- <input name=\"social\" ng-model=\"prestation.social\" ng-pattern=\"/^[0-9]{3}-[0-9]{2}-[0-9]{4}$/\" /> --><md-checkbox ng-model=$ctrl.prestation.btob>Active uniquement pour le B2B</md-checkbox><md-checkbox ng-model=$ctrl.prestation.btoc style=\"padding-left: 50px\">Active uniquement pour le B2C</md-checkbox><!-- <div class=\"hint\" ng-if=\"showHints\">###-##-####</div>\n        \n                              <div ng-messages=\"projectForm.social.$error\" ng-if=\"!showHints\">\n                                  <div ng-message=\"pattern\">###-##-#### - Please enter a valid SSN.</div>\n                              </div> --></md-input-container><!--   <md-input-container class=\"md-block\" flex-gt-sm style=\" padding-left: 100px;\" >\n                  <label style=\" padding-left: 100px;\">Nombre d\'Adults </label>\n                  <input type=\"number\" min=\"0\" step=\"1\" ng-model=\"$ctrl.prestation.adultsNbr\"  style=\"width: 100px\" />\n                 \n                </md-input-container>--><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm><label>Chambre</label><!-- <input md-maxlength=\"30\" required name=\"name\" ng-model=\"prestation.name\" /> --><md-select ng-change=\"\" ng-model=$ctrl.prestation.unit style=\"min-width: 150px; max-width: 300px\" multiple><!-- <md-option ng-value=\"-1\"> Toutes les chambres </md-option> --><md-option ng-repeat=\"unit in $ctrl.units\" ng-value={{unit.code}}>{{unit.name}}</md-option></md-select><!-- <div class=\"hint\" ng-if=\"showHints\">Tell us what we should call you!</div>\n\n                        <div ng-messages=\"projectForm.name.$error\" ng-if=\"!showHints\">\n                            <div ng-message=\"required\">Name is required.</div>\n                            <div ng-message=\"md-maxlength\">The name has to be less than 30 characters long.</div>\n                        </div> --></md-input-container><div flex=5 hide-xs hide-sm><!-- Spacer //--></div><md-input-container class=md-block flex-gt-sm><label>Type</label><!-- <input name=\"social\" ng-model=\"prestation.social\" ng-pattern=\"/^[0-9]{3}-[0-9]{2}-[0-9]{4}$/\" /> --><md-select ng-change=\"\" ng-model=$ctrl.prestation.type required><md-option ng-value=0>Reduction</md-option><md-option ng-value=1>Supplement</md-option></md-select><!-- <div class=\"hint\" ng-if=\"showHints\">###-##-####</div>\n\n                        <div ng-messages=\"projectForm.social.$error\" ng-if=\"!showHints\">\n                            <div ng-message=\"pattern\">###-##-#### - Please enter a valid SSN.</div>\n                        </div> --></md-input-container><md-input-container class=md-block flex-gt-sm><label>Nombre d\'Adults</label><input type=number min=0 step=1 ng-model=$ctrl.prestation.adultsNbr style=\"width: 100px\"></md-input-container><div flex=5 hide-xs hide-sm><!-- Spacer //--></div></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm><label>Type du Tarif</label><!-- <input md-maxlength=\"30\" required name=\"name\" ng-model=\"prestation.name\" /> --><md-select ng-change=\"\" ng-model=$ctrl.prestation.tarifType required><md-option ng-value=0>Forfait</md-option><md-option ng-value=1>Chambre</md-option><md-option ng-value=2>Pax</md-option></md-select><!-- \n                        <div class=\"hint\" ng-if=\"showHints\">Tell us what we should call you!</div>\n\n                        <div ng-messages=\"projectForm.name.$error\" ng-if=\"!showHints\">\n                            <div ng-message=\"required\">Name is required.</div>\n                            <div ng-message=\"md-maxlength\">The name has to be less than 30 characters long.</div>\n                        </div> --></md-input-container><div flex=5 hide-xs hide-sm><!-- Spacer //--></div><md-input-container class=md-block flex-gt-sm><label>Tarif Applicable</label><!-- <input name=\"social\" ng-model=\"prestation.social\" ng-pattern=\"/^[0-9]{3}-[0-9]{2}-[0-9]{4}$/\" /> --><md-select ng-change=\"\" ng-model=$ctrl.prestation.tarifApp required><md-option ng-value=0>Séjour</md-option><md-option ng-value=1>Nuit</md-option></md-select><!-- \n                        <div class=\"hint\" ng-if=\"showHints\">###-##-####</div>\n\n                        <div ng-messages=\"projectForm.social.$error\" ng-if=\"!showHints\">\n                            <div ng-message=\"pattern\">###-##-#### - Please enter a valid SSN.</div>\n                        </div> --></md-input-container><div flex=5 hide-xs hide-sm><!-- Spacer //--></div><md-input-container class=md-block flex-gt-sm><label>Condition</label><md-select ng-change=\"\" ng-model=$ctrl.prestation.option required><md-option ng-value=0>Obligatoire</md-option><md-option ng-value=1>Optionelle</md-option><md-option ng-value=2>Sélectionnée par défaut</md-option></md-select><!-- <div class=\"hint\" ng-show=\"showHints\">How can we reach you?</div>\n\n                        <div ng-messages=\"projectForm.email.$error\" ng-hide=\"showHints\">\n                            <div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">\n                                Your email must be between 10 and 100 characters long and look like an e-mail\n                                address.\n                            </div>\n                        </div> --></md-input-container><div flex=5 hide-xs hide-sm><!-- Spacer //--></div><md-input-container class=md-block flex-gt-sm><label>Min Stay</label><input type=number min=1 step=1 ng-model=$ctrl.prestation.minStay required><!-- <div class=\"hint\" ng-show=\"showHints\">(###) ###-####</div>\n\n                        <div ng-messages=\"projectForm.phone.$error\" ng-hide=\"showHints\">\n                            <div ng-message=\"pattern\">(###) ###-#### - Please enter a valid phone number.</div>\n                        </div> --></md-input-container></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm><label>Prix achat</label><!-- <input md-maxlength=\"30\" required name=\"name\" ng-model=\"prestation.name\" /> --> <input type=number min=0 step=1 ng-model=$ctrl.prestation.purchaseprice ng-blur=$ctrl.blurAdultPurchaseprice($ctrl.prestation) required><!--<div class=\"hint\" ng-if=\"showHints\">Tell us what we should call you!</div>\n\n                         <div ng-messages=\"projectForm.name.$error\" ng-if=\"!showHints\">\n                            <div ng-message=\"required\">Name is required.</div>\n                            <div ng-message=\"md-maxlength\">The name has to be less than 30 characters long.</div>\n                        </div> --></md-input-container><div flex=5 hide-xs hide-sm><!-- Spacer //--></div><md-input-container class=md-block flex-gt-sm><label>Markup</label><input type=number min=0 step=1 ng-model=$ctrl.prestation.markup ng-blur=$ctrl.blurAdultPurchaseprice($ctrl.prestation)></md-input-container><md-input-container class=md-block flex-gt-sm><label>Prix vente</label><input type=number min=0 step=1 ng-model=$ctrl.prestation.price ng-blur=$ctrl.blurAdultPrice($ctrl.prestation) required></md-input-container><div flex=5 hide-xs hide-sm></div><md-input-container class=md-block flex-gt-sm><label>Unité prix</label><md-select ng-change=\"\" ng-model=$ctrl.prestation.pricePourcentage required><md-option ng-value=0>Prix</md-option><md-option ng-value=1>%</md-option></md-select></md-input-container><div flex=5 hide-xs hide-sm></div></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm><label>Base tarifaire</label><md-select ng-change=\"\" ng-model=$ctrl.prestation.rate required><md-option ng-repeat=\"rateBase in $ctrl.rateBases\" ng-value={{rateBase.code}}>{{rateBase.description}}</md-option></md-select></md-input-container><md-input-container class=md-block flex-gt-sm><label>Pensions</label><!-- <input md-maxlength=\"30\" required name=\"name\" ng-model=\"prestation.name\" /> --><md-select ng-change=\"\" ng-model=$ctrl.prestation.boards style=\"min-width: 150px; max-width: 300px\" multiple><!-- <md-option ng-value=\"-1\"> Toutes les chambres </md-option> --><md-option ng-repeat=\"board in $ctrl.boards\" ng-value={{board.code}}>{{board.name}}</md-option></md-select><!-- <div class=\"hint\" ng-if=\"showHints\">Tell us what we should call you!</div>\n\n                        <div ng-messages=\"projectForm.name.$error\" ng-if=\"!showHints\">\n                            <div ng-message=\"required\">Name is required.</div>\n                            <div ng-message=\"md-maxlength\">The name has to be less than 30 characters long.</div>\n                        </div> --></md-input-container></div><div layout-gt-sm=row><md-input-container style=\"margin-right: 10px\"><label>Type</label><md-select ng-change=\"\" ng-model=$ctrl.prestation.typology required><!-- <md-option ng-repeat=\"prestationType in $ctrl.prestationTypes\"\n                                ng-value=\"{{prestationType.code}}\">\n                                {{prestationType.name}}\n                            </md-option> --><md-option ng-value=0>Offre</md-option><md-option ng-value=1>Assurance</md-option><md-option ng-value=2>Transfert</md-option><md-option ng-value=3>Pensions</md-option><md-option ng-value=4>Autres</md-option></md-select></md-input-container><md-input-container ng-if=\"$ctrl.prestation.typology === 0 ||$ctrl.prestation.typology === 3 \"><label>Combinable avec des promotions?</label><md-select ng-model=$ctrl.prestation.discounts multiple style=\"min-width: 150px; max-width: 200px\"><md-option ng-value=d.code ng-repeat=\"d in $ctrl.discounts\"><strong>Réf.</strong>{{::d.reference}} - {{::d.name}} - {{::d.label}}</md-option></md-select></md-input-container><md-input-container ng-if=\"$ctrl.prestation.typology === 0 ||$ctrl.prestation.typology === 3\"><label>Combinable avec des offres?</label><md-select ng-model=$ctrl.prestation.offers multiple style=\"min-width: 150px; max-width: 200px\"><md-option ng-value=d.code ng-repeat=\"d in $ctrl.prestations | filter : $ctrl.filterSelfOffre\"><strong>Offre.</strong>{{::d.nom}}</md-option></md-select></md-input-container></div><div layout-gt-sm=row ng-if=\"$ctrl.prestation.typology === 0 \"><md-input-container class=md-block flex-gt-sm><!-- <input name=\"social\" ng-model=\"prestation.social\" ng-pattern=\"/^[0-9]{3}-[0-9]{2}-[0-9]{4}$/\" /> --><md-checkbox ng-model=$ctrl.prestation.applyOnBoard>Active pour les prestations de type pensions</md-checkbox><!-- <div class=\"hint\" ng-if=\"showHints\">###-##-####</div>\n\n                      <div ng-messages=\"projectForm.social.$error\" ng-if=\"!showHints\">\n                          <div ng-message=\"pattern\">###-##-#### - Please enter a valid SSN.</div>\n                      </div> --></md-input-container></div><!-- <md-divider></md-divider> --><!-- <div layout-gt-sm=\"row\">\n         \n\n        </div> --><!-- <section>\n          <div>Périods<md-button ng-click=\"$ctrl.addLine()\">\n              <md-icon>add</md-icon>\n            </md-button>\n          </div>\n          <div layout=\"row\" layout-align=\"start-center\" ng-repeat=\"saison in $ctrl.prestation.saisons track by $index\">\n            <md-input-container class=\"md-block\" flex-gt-sm>\n              <label>Du</label>\n              <md-datepicker md-current-view=\"year\" ng-model=\"saison.debut\" md-min-date=\"$ctrl.minDate\"\n                md-placeholder=\"jj/mm/aaaa\" required></md-datepicker>\n\n            </md-input-container>\n\n            <md-input-container class=\"md-block\" flex-gt-sm>\n              <label>Au</label>\n              <md-datepicker md-current-view=\"year\" ng-model=\"saison.fin\" md-min-date=\"$ctrl.prestation.debut\"\n                md-placeholder=\"jj/mm/aaaa\" required></md-datepicker>\n            </md-input-container>\n          </div>\n        </section> --><section></section></form><h4>Périodes de Reservation</h4><md-table-container><table md-table><thead md-head><tr md-row><th md-column>From</th><th md-column>To</th><th md-column></th></tr>{{$ctrl.prestation.bookingperiod.ranges}}<tr md-row ng-repeat=\"range in $ctrl.prestation.bookingPeriod.ranges track by $index\"><td md-cell>{{ range.from}}</td><td md-cell>{{range.to}}</td><td md-cell><md-button class=md-icon-button ng-click=$ctrl.removeBookingPeriodRange($index)><md-icon>delete</md-icon></md-button></td></tr></thead><tbody md-body><tr md-row><td md-cell><md-input-container class=md-block flex-gt-sm><label>Du</label><md-datepicker md-current-view=year ng-model=$ctrl.newRangeBooking.from md-placeholder=jj/mm/aaaa></md-datepicker></md-input-container></td><td md-cell><md-input-container flex-gt-sm><label>Au</label><!-- md-min-date=\"$ctrl.options.minEndDate\" --><md-datepicker md-current-view=year ng-model=$ctrl.newRangeBooking.to md-placeholder=jj/mm/aaaa></md-datepicker></md-input-container></td><td md-cell><md-button class=md-icon-button ng-click=$ctrl.addReservationPeriodRange()><md-icon>add</md-icon></md-button></td></tr></tbody></table></md-table-container><section><h4>Périodes de sejour</h4><md-table-container><table md-table><thead md-head><tr md-row><th md-column>From</th><th md-column>To</th><th md-column></th></tr><tr md-row ng-repeat=\"range in $ctrl.prestation.period.ranges track by $index\"><td md-cell>{{ range.from}}</td><td md-cell>{{range.to}}</td><td md-cell><md-button class=md-icon-button ng-click=$ctrl.removePeriodRange($index)><md-icon>delete</md-icon></md-button></td></tr></thead><tbody md-body><tr md-row><td md-cell><md-input-container flex-gt-sm><label>Du</label><md-datepicker md-current-view=year ng-model=$ctrl.newRange.from md-placeholder=jj/mm/aaaa></md-datepicker></md-input-container></td><td md-cell><md-input-container flex-gt-sm><label>Au</label><!-- md-min-date=\"$ctrl.options.minEndDate\" --><md-datepicker md-current-view=year ng-model=$ctrl.newRange.to md-placeholder=jj/mm/aaaa></md-datepicker></md-input-container></td><td md-cell><md-button class=md-icon-button ng-click=$ctrl.addPeriodRange()><md-icon>add</md-icon></md-button></td></tr></tbody></table></md-table-container></section><md-divider></md-divider><md-input-container ng-if=\"$ctrl.prestation.childs.length != 0\"><!-- <label>Enfant suit les parents</label> --><md-checkbox ng-model=$ctrl.prestation.childTypologieParents>Les enfants suivent les parents</md-checkbox></md-input-container><section><div>Politique enfants / tranches d\'age<md-button ng-click=$ctrl.addChildrenPolicy()><md-icon>add</md-icon></md-button></div><div layout=row layout-align=start-center ng-repeat=\"policy in $ctrl.prestation.childs track by $index\"><!-- <label style=\"width:130px\" ng-pluralize>age</label> --><md-input-container class=md-block flex=20><label>Moins de</label><input type=number min=1 max=18 ng-model=$ctrl.prestation.childs[$index].to></md-input-container><md-input-container><label>Prix achat</label><input style=\"color: #000000\" name=childmax type=number min=0 step=1 ng-model=$ctrl.prestation.childs[$index].purchaseprice ng-blur=$ctrl.blurChildPurchaseprice($ctrl.prestation.childs[$index])></md-input-container><md-input-container><label>Markup</label><input style=\"color: #000000\" name=childmax type=number min=0 step=1 ng-model=$ctrl.prestation.childs[$index].markup ng-blur=$ctrl.blurChildPurchaseprice($ctrl.prestation.childs[$index])></md-input-container><md-input-container><label>Prix vente</label><input style=\"color: #000000\" name=childmax type=number min=0 step=1 ng-model=$ctrl.prestation.childs[$index].value ng-blur=$ctrl.blurChildValue($ctrl.prestation.childs[$index])></md-input-container><md-input-container><label>Unité</label><md-select ng-change=\"\" ng-model=$ctrl.prestation.childs[$index].unit><md-option ng-value=0>Prix</md-option><md-option ng-value=1>%</md-option></md-select></md-input-container><md-button class=md-icon-button ng-click=\"$ctrl.remove($event, $index)\"><md-icon>delete</md-icon></md-button></div></section><!-- <p style=\"font-size:.8em; width: 100%; text-align: center;\">\n                    Make sure to include <a href=\"https://docs.angularjs.org/api/ngMessages\"\n                        target=\"_blank\">ngMessages</a>\n                    module when using ng-message markup.\n                </p> --></md-content></div><md-card-actions layout=row layout-align=\"end center\"><!-- <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.createPrestation()\" >\n      Enregistrer\n    </md-button> --><md-button class=\"md-raised md-accent\" ng-click=$ctrl.createPrestation() ng-disabled=prestationCard.$error.required>Enregistrer</md-button><md-button ui-sref=^.prestations>Fermer</md-button></md-card-actions><!-- <pre>\n    {{$ctrl.prestation | json}}\n    </pre> --></md-card></form>");
$templateCache.put("app/prestations/edit/tmp.html","<form name=prestationForm class=card><section class=header><md-input-container class=md-block required><label>Nom</label><input type=text ng-model=prestation.nom required></md-input-container><md-input-container class=md-block><label>Description</label><textarea ng-model=prestation.description md-maxlength=400 rows=1 md-select-on-focus required></textarea></md-input-container><md-input-container class=md-block><label>Code Fournisseur</label><input type=text ng-model=prestation.supplier></md-input-container></section><section><!-- <div class=\"data-line\" style=\"align-items: center;\">\n            <label>Du</label>\n            <md-input-container>\n                <md-datepicker md-current-view=\"year\" ng-model=\"prestation.debut\" md-min-date=\"$ctrl.minDate\"\n                    md-placeholder=\"jj/mm/aaaa\" required></md-datepicker>\n            </md-input-container>\n            <div>Jusqu\'au</div>\n            <md-input-container>\n                <md-datepicker md-current-view=\"year\" ng-model=\"prestation.fin\" md-min-date=\"prestation.debut\"\n                    md-placeholder=\"jj/mm/aaaa\" required></md-datepicker>\n            </md-input-container>\n        </div>\n\n        <div class=\"data-line\" style=\"align-items: center;\">\n            <label>Min Stay</label>\n            <md-input-container>\n                <input type=\"number\" min=\"1\" step=\"1\" ng-model=\"prestation.minStay\" required />\n            </md-input-container>\n        </div> --><div layout-gt-xs=row><div flex-gt-xs><h4>Date</h4><md-datepicker ng-model=prestation.myDate md-placeholder=\"Enter date\" md-min-date=ctrl.minDate></md-datepicker></div><div flex-gt-xs><h4>Only</h4><md-datepicker ng-model=prestation.myDate md-placeholder=\"Enter date\"></md-datepicker></div><div flex-gt-xs><h4>Date</h4><md-input-container><input type=number min=1 step=1 ng-model=prestation.minStay required></md-input-container></div></div></section><section><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm><md-select placeholder=\"Tarif Applicable\" ng-change=\"\" ng-model=prestation.tarifApp required><md-option ng-value=0>Séjour</md-option><md-option ng-value=1>Nuit</md-option></md-select><div class=hint ng-if=showHints>Tell us what we should call you!</div><div ng-messages=userForm.name.$error ng-if=!showHints><div ng-message=required>Name is required.</div><div ng-message=md-maxlength>The name has to be less than 30 characters long.</div></div></md-input-container><div flex=5 hide-xs hide-sm><!-- Spacer //--></div><md-input-container class=md-block flex-gt-sm><md-select placeholder=\"Tarif Applicable\" ng-change=\"\" ng-model=prestation.tarifApp required><md-option ng-value=0>Séjour</md-option><md-option ng-value=1>Nuit</md-option></md-select><div class=hint ng-if=showHints>###-##-####</div><div ng-messages=userForm.social.$error ng-if=!showHints><div ng-message=pattern>###-##-#### - Please enter a valid SSN.</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm><md-select placeholder=\"Tarif Applicable\" ng-change=\"\" ng-model=prestation.tarifApp required><md-option ng-value=0>Séjour</md-option><md-option ng-value=1>Nuit</md-option></md-select><div class=hint ng-show=showHints>How can we reach you?</div><div ng-messages=userForm.email.$error ng-hide=showHints><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Your email must be between 10 and 100 characters long and look like an e-mail address.</div></div></md-input-container><div flex=5 hide-xs hide-sm><!-- Spacer //--></div><md-input-container class=md-block flex-gt-sm><label>Phone Number</label><md-select placeholder=\"Tarif Applicable\" ng-change=\"\" ng-model=prestation.tarifApp required><md-option ng-value=0>Séjour</md-option><md-option ng-value=1>Nuit</md-option></md-select><div class=hint ng-show=showHints>(###) ###-####</div><div ng-messages=userForm.phone.$error ng-hide=showHints><div ng-message=pattern>(###) ###-#### - Please enter a valid phone number.</div></div></md-input-container><style>/*\n                 * The Material demos system does not currently allow targeting the body element, so this\n                 * must go here in the HTML.\n                 */\n                body[dir=rtl] .hint {\n                    right: 2px;\n                    left: auto;\n                }</style></div></section><!-- <section>\n\n        <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm>\n                <md-select placeholder=\"Base tarifaire\" ng-change=\"\" ng-model=\"prestation.rate\" required>\n                    <md-option ng-repeat=\"rateBases in $ctrl.rateBases\" ng-value=\"{{rateBases.code}}\">\n                        {{rateBases.description}}\n                    </md-option>\n                </md-select>\n            </md-input-container>\n\n            <md-input-container class=\"md-block\" flex-gt-sm>\n                <md-select placeholder=\"Chambre\" ng-change=\"\" ng-model=\"prestation.unit\" style=\"min-width: 150px;\">\n                    <md-option ng-value=\"-1\"> Toutes les chambres </md-option>\n                    <md-option ng-repeat=\"unit in $ctrl.units\" ng-value=\"{{unit.code}}\"> {{unit.name}} </md-option>\n                </md-select>\n            </md-input-container>\n\n            <md-input-container class=\"md-block\" flex-gt-sm>\n                <md-select placeholder=\"\" ng-change=\"\" ng-model=\"prestation.type\" required>\n                    <md-option ng-value=\"0\"> Reduction </md-option>\n                    <md-option ng-value=\"1\"> Supplement </md-option>\n                </md-select>\n            </md-input-container>\n\n        </div>\n\n        <div layout-gt-sm=\"row\" class=\"data-line\" style=\"align-items: center;\">\n            <md-input-container class=\"md-block\" flex-gt-sm>\n                <input placeholder=\"Prix\" type=\"number\" min=\"0\" step=\"1\" ng-model=\"prestation.price\" required />\n            </md-input-container>\n\n            <md-input-container class=\"md-block\" flex-gt-sm>\n                <md-select placeholder=\"Prix/% \" ng-change=\"\" ng-model=\"prestation.pricePourcentage\" required>\n                    <md-option ng-value=\"0\"> Prix </md-option>\n                    <md-option ng-value=\"1\"> % </md-option>\n                </md-select>\n            </md-input-container>\n\n            <md-input-container class=\"md-block\" flex-gt-sm>\n                <md-select placeholder=\"Type de Tarif\" ng-change=\"\" ng-model=\"prestation.tarifType\" required>\n                    <md-option ng-value=\"0\"> Forfait </md-option>\n                    <md-option ng-value=\"1\"> Chambre </md-option>\n                    <md-option ng-value=\"2\"> Pax </md-option>\n                </md-select>\n            </md-input-container>\n\n            <md-input-container class=\"md-block\" flex-gt-sm>\n                <md-select placeholder=\"Tarif Applicable\" ng-change=\"\" ng-model=\"prestation.tarifApp\" required>\n                    <md-option ng-value=\"0\"> Séjour </md-option>\n                    <md-option ng-value=\"1\"> Nuit </md-option>\n                </md-select>\n            </md-input-container>\n\n\n            <md-input-container class=\"md-block\" flex-gt-sm>\n                <md-select placeholder=\"Condition\" ng-change=\"\" ng-model=\"prestation.option\" required>\n                    <md-option ng-value=\"0\"> Obligatoire </md-option>\n                    <md-option ng-value=\"1\"> Optionelle </md-option>\n                    <md-option ng-value=\"2\"> Sélectionnée par défaut </md-option>\n                </md-select>\n            </md-input-container>\n\n        </div>\n\n    </section> --><!-- \n    <section>\n        <div layout=\"row\">\n\n            <div>\n                <h4>Enfant</h4>\n\n\n                <md-input-container style=\"padding: 0 50px 0 0; width: 100px\">\n                    <label>Prix/% </label>\n                    <md-select placeholder=\"\" ng-change=\"\" ng-model=\"prestation.enfantpricetype\">\n                        <md-option ng-value=\"0\"> Prix </md-option>\n                        <md-option ng-value=\"1\"> % </md-option>\n\n\n                    </md-select>\n                </md-input-container>\n                <md-input-container style=\"padding: 0 10px 0 0; width: 150px\">\n\n                    <label>Prix</label>\n                    <input type=\"number\" min=\"0\" step=\"1\" ng-model=\"prestation.enfantprice\" />\n                </md-input-container>\n\n\n            </div>\n            <md-divider></md-divider>\n            <div>\n                <h4>Bebe</h4>\n\n\n                <md-input-container style=\"padding: 0 50px 0 0; width: 100px\">\n                    <label>Prix/% </label>\n                    <md-select placeholder=\"\" ng-change=\"\" ng-model=\"prestation.bebepricetype\">\n                        <md-option ng-value=\"0\"> Prix </md-option>\n                        <md-option ng-value=\"1\"> % </md-option>\n\n\n                    </md-select>\n                </md-input-container>\n                <md-input-container style=\"padding: 0 10px 0 0; width: 150px\">\n\n                    <label>Prix</label>\n                    <input type=\"number\" min=\"0\" step=\"1\" ng-model=\"prestation.bebetprice\" />\n                </md-input-container>\n            </div>\n\n        </div>\n    </section> --><section><md-input-container flex=50><div><!-- <h5>Enfant</h5> --><md-input-container><label>Minimum</label><md-select placeholder=\"Tarif Applicable\" ng-change=\"\" ng-model=prestation.tarifApp required><md-option ng-value=0>Séjour</md-option><md-option ng-value=1>Nuit</md-option></md-select></md-input-container><md-input-container><label>Maximum</label><md-select placeholder=\"Tarif Applicable\" ng-change=\"\" ng-model=prestation.tarifApp required><md-option ng-value=0>Séjour</md-option><md-option ng-value=1>Nuit</md-option></md-select></md-input-container></div><div><!-- <h5>Bébé</h5> --><md-input-container><label>Minimum</label><input style=\"color: #000000\" name=infdmin ng-model=prestation.a type=number min=0 max=10 required></md-input-container><md-input-container><label>Maximum</label><input style=\"color: #000000\" name=infdmax ng-model=prestation.a type=number min=0 max=10 required></md-input-container></div></md-input-container><md-input-container flex=50><div><!-- <h5>Enfant</h5> --><md-input-container><label>Minimum</label><input style=\"color: #000000\" name=childmin ng-model=prestation.a type=number min=0 max=10 required></md-input-container><md-input-container><label>Maximum</label><input style=\"color: #000000\" name=childmax ng-model=prestation.a type=number min=1 max=10 required></md-input-container></div><div><!-- <h5>Bébé</h5> --><md-input-container><label>Minimum</label><input style=\"color: #000000\" name=infdmin ng-model=prestation.a type=number min=0 max=10 required></md-input-container><md-input-container><label>Maximum</label><input style=\"color: #000000\" name=infdmax ng-model=prestation.a type=number min=0 max=10 required></md-input-container></div></md-input-container></section><section><md-input-container flex=50><div><h5>Enfant</h5><md-input-container><label>Minimum</label><input style=\"color: #000000\" name=childmin ng-model=prestation.a type=number min=0 max=10 required></md-input-container><md-input-container><label>Maximum</label><input style=\"color: #000000\" name=childmax ng-model=prestation.a type=number min=1 max=10 required></md-input-container></div><div><h5>Bébé</h5><md-input-container><label>Minimum</label><input style=\"color: #000000\" name=infdmin ng-model=prestation.a type=number min=0 max=10 required></md-input-container><md-input-container><label>Maximum</label><input style=\"color: #000000\" name=infdmax ng-model=prestation.a type=number min=0 max=10 required></md-input-container></div></md-input-container></section><md-divider></md-divider><footer layout=row layout-align=\"end center\" style=\"padding: 8px\"><md-button class=\"md-raised md-accent\" ng-click=$ctrl.createPrestation(prestation)>Enregitrer</md-button><md-button ui-sref=^.prestations>fermer</md-button></footer></form>");
$templateCache.put("app/prestations/list/template.html","<div ng-if=\"$ctrl.prestations.length === 0\" class=md-card style=\"text-align:center; max-width:600;margin:56px auto\">Aucune préstation.<md-button class=md-accent ui-sref=\"^.prestationEdit({prestation:\'new\'})\">Ajouter une préstation</md-button></div><!-- <pre>{{$ctrl.units}}</pre> --><md-card ng-if=\"$ctrl.prestations.length > 0\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><h3>{{::$ctrl.prestations.length}} préstations</h3><div class=search-text flex><md-icon>search</md-icon><input style=width:100% type=text ng-model=$ctrl.search placeholder=Filtrer...></div></div></md-toolbar><md-table-container><table md-table><thead md-head><tr md-row><!-- <th md-column></th> --><th md-column>Nom</th><!-- <th md-column>Type</th> --><th md-column>Fournisseur</th><th md-column>Type de préstation</th><th md-column>Base tarifaire</th><th md-column>Chambre</th><th md-column>Prix</th><th md-column></th></tr></thead><tbody md-body><tr md-row style=cursor:pointer ng-repeat-start=\"p in $ctrl.prestations | filter: $ctrl.search \"><!-- <tr md-row style=\"cursor:pointer\" ng-repeat-start=\"r in $ctrl.rateBases\"> --><!--   <tr md-row style=\"cursor:pointer\" ng-repeat-start=\"p in $ctrl.prestations | filter:{rateBasis:code} \">--><!-- <td md-cell>\n\n                        <span class=\"material-icons\" ng-click=\"p.details = !p.details\"\n                            ng-bind=\"p.details ? \'expand_less\' : \'expand_more\'\">\n                        </span>\n                    </td> --><td md-cell>{{::p.nom}}</td><td md-cell>{{::p.supplier}}</td><td md-cell>{{::p.prestationType}}</td><td md-cell>{{$ctrl.rateBases[p.rate].description}}</td><td md-cell><a ng-click=\"d.showAllRooms = !d.showAllRooms\"><span ng-if=!d.showAllRooms>Développer</span> <span ng-if=d.showAllRooms>Réduire</span></a><ul ng-if=d.showAllRooms><li ng-repeat=\"unitName in p.unitsNames\">{{::unitName}}</li></ul></td><td md-cell>{{::p.price}}</td><td md-cell style=\"width: 230px\" ng-if=\" $ctrl.permissionsContracting\"><md-button class=md-icon-button ng-click=\"$ctrl.edit($event, p)\"><md-icon>edit</md-icon><md-tooltip>Modifier</md-tooltip></md-button><md-button class=md-icon-button ng-click=\"$ctrl.clone($event, p)\"><md-icon>content_copy</md-icon><md-tooltip>Dupliquer</md-tooltip></md-button><md-button class=md-icon-button ng-click=\"p.details = !p.details\"><md-icon ng-bind=\"p.details ? \'visibility_off\' : \'visibility\'\"></md-icon><md-tooltip>Plus de détail</md-tooltip></md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"$ctrl.remove($event, p)\"><md-icon>delete</md-icon><md-tooltip>Supprimer</md-tooltip></md-button></td></tr><tr md-row ng-repeat-end ng-show=\"p.details === true\"><td colspan=8><table md-table><thead md-head style=\"background-color: rgb(226 229 231)\"><tr md-row><th md-column>Type</th><th md-column>Prix/%</th><th md-column>Type tarif</th><th md-column>Tarif App</th><th md-column>Option</th><th md-column>promos.</th><!-- <th md-column> offers.</th> --><th md-column>Enfants</th><!-- <th md-column> Bébé</th> --><th md-column>M.stay</th><th md-column>Description</th><th md-column>Date début</th><th md-column>Date fin</th></tr></thead><tbody><tr md-row><td md-cell>{{::p.typology}}</td><td md-cell>{{::p.pricePourcentage}}</td><td md-cell>{{::p.tarifType}}</td><td md-cell>{{::p.tarifApplicable}}</td><td md-cell>{{::p.option}}</td><td md-cell><ul><li ng-repeat=\"discountName in p.discountsNames\">{{::discountName}}</li></ul></td><!-- <td md-cell>\n                                        <ul>\n                                            <li ng-repeat=\"offerName in p.offers\">\n                                                {{::offerName}}\n                                            </li>\n                                        </ul>\n\n                                    </td> --><td md-cell><ul><li ng-repeat=\"child in p.childs\"><span>à : {{::child.to}} </span><span>unité :<p ng-if=\"child.unit == 0\">prix</p><p ng-if=\"child.unit == 1\">%</p></span><span>valeur : {{::child.value}}</span></li></ul></td><td md-cell>{{::p.minStay}}</td><td md-cell>{{::p.description}}</td><td md-cell>{{::p.debut}}</td><td md-cell>{{::p.fin}}</td></tr><tr></tr></tbody></table></td></tr></tbody></table></md-table-container></md-card>");
$templateCache.put("app/prestations/list/template2.html","<md-card style=\"width: 1000px\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Prestations</span></div></md-toolbar><form style=\"border-top:1px solid #ccc;   padding: 0 16px;\n  display: flex;\n      align-items: flex-start\" name=bookingsFilterForm><md-input-container class=field-inline style=\"padding: 0 20px; width: 150px\" required><label>Nom</label><input type=text ng-model=prestation.nom required></md-input-container><md-input-container style=\"padding: 0 20px; width: 150px\"><label>Code Fournisseur</label><input type=text ng-model=prestation.supplier></md-input-container><md-input-container class=field-inline style=\"padding: 0 20px; width: 150px\" required><md-select placeholder=\"Base tarifaire\" ng-change=\"\" ng-model=prestation.rate required><md-option ng-repeat=\"rateBases in $ctrl.rateBases\" ng-value={{rateBases.code}}>{{rateBases.description}}</md-option></md-select></md-input-container><md-input-container class=field-inline style=\"padding: 0 20px; width: 150px\" required><md-select placeholder=Chambre ng-change=\"\" ng-model=prestation.unit style=\"min-width: 150px\"><md-option ng-value=-1>Toutes les chambres</md-option><md-option ng-repeat=\"unit in $ctrl.units\" ng-value={{unit.code}}>{{unit.name}}</md-option></md-select></md-input-container><md-input-container style=\"padding: 0 20px; width: 150px\"><label>Type</label><md-select placeholder=\"\" ng-change=\"\" ng-model=prestation.type required><!-- <md-select-label>{{$ctrl.units.name[media.unit]}}</md-select-label> --><md-option ng-value=0>Reduction</md-option><md-option ng-value=1>Supplement</md-option><!-- <md-option   ng-value=3> pensions </md-option>   --><!-- <md-option  ng-repeat=\"unit in $ctrl.units\" ng-selected=\"{{unit.name[media.unit]}}\" ng-value=\"{{unit.code}}\"> {{unit.name}} </md-option>   --></md-select></md-input-container></form><form style=\"border-bottom:1px solid #ccc;  padding: 0 16px\"><md-input-container style=\"padding: 0 20px; width: 150px\"><label>Prix</label><input type=number min=0 step=1 ng-model=prestation.price required></md-input-container><md-input-container style=\"padding: 0 20px; width: 150px\"><label>Prix/%</label><md-select placeholder=\"\" ng-change=\"\" ng-model=prestation.pricePourcentage required><md-option ng-value=0>Prix</md-option><md-option ng-value=1>%</md-option></md-select></md-input-container><md-input-container style=\"padding: 0 20px; width: 150px\"><label>Type Tarif</label><md-select placeholder=\"\" ng-change=\"\" ng-model=prestation.tarifType required><md-option ng-value=0>Forfait</md-option><md-option ng-value=1>Chambre</md-option><md-option ng-value=2>Pax</md-option></md-select></md-input-container><!-- </div> --><md-input-container style=\"padding: 0 20px; width: 150px\"><label>Tarif Applicable</label><md-select placeholder=\"\" ng-change=\"\" ng-model=prestation.tarifApp required><md-option ng-value=0>Séjour</md-option><md-option ng-value=1>Nuit</md-option></md-select></md-input-container><md-input-container style=\"padding: 0 20px; width: 150px\"><label>Condition</label><md-select placeholder=\"\" ng-change=\"\" ng-model=prestation.option required><md-option ng-value=0>Obligatoire</md-option><md-option ng-value=1>Optionelle</md-option><md-option ng-value=2>Sélectionnée par défaut</md-option></md-select></md-input-container></form><form style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 16px;display: flex; align-items: flex-start\"><md-input-container class=md-block style=\"padding: 0 60px 0 0; width: 250px\"><label>Description</label><textarea ng-model=prestation.description md-maxlength=400 rows=1 md-select-on-focus required></textarea></md-input-container><md-input-container style=\"padding: 0 20px; width: 150px\"><label>Min Stay</label><input type=number min=1 step=1 ng-model=prestation.minStay required></md-input-container><md-input-container flex=20><div class=field-inline><label>Du</label><md-datepicker md-current-view=year ng-model=prestation.debut md-min-date=$ctrl.minDate md-placeholder=jj/mm/aaaa required></md-datepicker></div></md-input-container><md-input-container flex=20><div class=field-inline><label>Jusqu\'au</label><md-datepicker md-current-view=year ng-model=prestation.fin md-min-date=prestation.debut md-placeholder=jj/mm/aaaa required></md-datepicker></div></md-input-container></form><form style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 16px\"><div layout=row><div><h4>Enfant</h4><md-input-container style=\"padding: 0 50px 0 0; width: 100px\"><label>Prix/%</label><md-select placeholder=\"\" ng-change=\"\" ng-model=prestation.enfantpricetype><md-option ng-value=0>Prix</md-option><md-option ng-value=1>%</md-option></md-select></md-input-container><md-input-container style=\"padding: 0 10px 0 0; width: 150px\"><label>Prix</label><input type=number min=0 step=1 ng-model=prestation.enfantprice></md-input-container></div><md-divider></md-divider><div><h4>Bebe</h4><md-input-container style=\"padding: 0 50px 0 0; width: 100px\"><label>Prix/%</label><md-select placeholder=\"\" ng-change=\"\" ng-model=prestation.bebepricetype><md-option ng-value=0>Prix</md-option><md-option ng-value=1>%</md-option></md-select></md-input-container><md-input-container style=\"padding: 0 10px 0 0; width: 150px\"><label>Prix</label><input type=number min=0 step=1 ng-model=prestation.bebetprice></md-input-container></div><md-dialog-actions style=\"padding: 60px 100px 0 0\"><md-button class=\"md-raised md-accent md-button md-ink-ripple\" ng-click=$ctrl.createPrestation(prestation)>Ajouter</md-button></md-dialog-actions></div></form><!-- exact table from live demo --><form style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 40px 16px;display: flex; align-items: flex-start\"><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-on-reorder=$ctrl.loadPrestations><tr md-row><th md-column style=\"padding: 0 50px 0 0\"><span>Nom</span></th><th md-column style=\"padding: 0 30px 0 0\"><span>Fournisseur</span></th><th md-column style=\"padding: 0 30px 0 0\"><span>Type</span></th><th md-column style=\"padding: 0 30px 0 0\"><span>Base tarifaire</span></th><th md-column style=\"padding: 0 30px 0 0\"><span>chambre</span></th><th md-column style=\"padding: 0 50px 0 0\"><span>Prix</span></th><th md-column style=\"padding: 0 30px 0 0\"><span>prix/%</span></th><th md-column style=\"padding: 0 30px 0 0\"><span>Type Tarif</span></th><th md-column style=\"padding: 0 30px 0 0\"><span>Tarif Applicable</span></th><th md-column style=\"padding: 0 30px 0 0\"><span>Option</span></th><!-- <th md-column style=\"    padding: 0 50px 0 0;\"><span>Enfant Prix</span></th>\n            <th md-column style=\"    padding: 0 30px 0 0;\"><span>Enfant prix/%</span></th>\n            <th md-column style=\"    padding: 0 50px 0 0;\"><span>Bebe Prix</span></th>\n            <th md-column style=\"    padding: 0 30px 0 0;\"><span>Bebe prix/%</span></th> --><th md-column style=\"padding: 0 50px 0 0\"><span>Minimum stay</span></th><!-- <th md-column style=\"    padding: 0 50px 0 0;\"><span>Description</span></th> --><th md-column style=\"padding: 0 50px 0 0\"><span>Date de debut</span></th><th md-column style=\"padding: 0 70px 0 0\"><span>Date de fin</span></th><!-- <th md-column ><span>Action</span></th> --></tr></thead><tbody md-body><tr md-row ng-repeat=\"p in $ctrl.prestationsss.items\"><td md-cell>{{::p.nom}}</td><td md-cell>{{::p.supplier}}</td><td md-cell>{{::p.prestationType}}</td><td md-cell>{{$ctrl.rateBases[p.rate].description}}</td><td md-cell ng-if=\"p.unit != -1\">{{p.unit}}</td><td md-cell ng-if=\"p.unit == -1\">toutes les chambres</td><td md-cell>{{::p.price}}</td><td md-cell>{{::p.pricePourcentage}}</td><td md-cell>{{::p.tarifType}}</td><td md-cell>{{::p.tarifApplicable}}</td><td md-cell ng-if=\"p.option != \'Selected\'\">{{::p.option}}</td><td md-cell ng-if=\"p.option == \'Selected\'\">par défaut</td><!-- <td md-cell>{{::p.enfantPrice}}</td>\n            <td md-cell>{{::p.priceEnfantPourcentage}}</td>\n            <td md-cell>{{::p.bebePrice}}</td>\n            <td md-cell>{{::p.priceBebePourcentage}}</td> --><td md-cell>{{::p.minStay}}</td><!-- <td md-cell>{{::p.description}}</td> --><td md-cell>{{::p.debut}}</td><td md-cell>{{::p.fin}}</td><td md-cell><!-- <md-button class=\"md-icon-button\" ng-click=\"$ctrl.edit($event,s)\"><md-icon>edit</md-icon>\n              <md-tooltip>Modifier</md-tooltip>\n            </md-button> --><md-button class=\"md-icon-button md-warn\" aria-label=Settings ng-click=$ctrl.remove($event,p)><md-icon>delete</md-icon></md-button></td></tr></tbody></table></md-table-container></form><!-- <md-table-pagination md-boundary-links=\"true\" md-limit=\"$ctrl.query.limit\" md- md-page=\"$ctrl.query.page\" md-total=\"{{$ctrl.total}}\" md-on-paginate=\"$ctrl.loadBookings\"></md-table-pagination> --><div></div></md-card>");
$templateCache.put("app/products/add/template.html","<md-dialog id=occupancy-dialog><form name=occupancyForm><md-dialog-content><section class=rate-bases><h5 style=flex:100>Bases tarifaires</h5><md-checkbox ng-repeat=\"rb in :: $ctrl.rateBases\" ng-model=rb.selected>{{::rb.description}}</md-checkbox></section><section class=guest-count><div class=category-count ng-repeat=\"(key, item) in $ctrl.inputs\"><h5>{{::item.label}}</h5><md-input-container><label>Minimum</label><input ng-model=item.min type=number ng-min=item.min max=10 required></md-input-container><md-input-container><label>Maximum</label><input ng-model=item.max type=number ng-min=item.min max=10 required></md-input-container></div></section></md-dialog-content><md-dialog-actions><md-button ng-click=$ctrl.applyChanges() class=\"md-primary md-raised\" ng-disabled=occupancyForm.$invalid>Appliquer</md-button><p class=error ng-show=$ctrl.basisNeeded>Veuillez cocher une ou plusieurs bases tarifaires</p><md-button ng-click=$ctrl.cancel()>Annuler</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/products/calendar-edit/dialog.html","<md-dialog class=edit-rates aria-label=\"Mod tarif\"><form name=ratesCalendarForm><header><h2 class=md-subhead>Modifier les tarifs</h2><md-button class=md-icon-button ng-click=$ctrl.cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></header><md-dialog-content><div style=\"padding: 16px\"><md-checkbox ng-model=$ctrl.seasonMode>Mode Saisons</md-checkbox></div><div ng-if=!$ctrl.seasonMode><periods-input model=$ctrl.periods value-callback=$ctrl.getPeriods></periods-input></div><div ng-if=$ctrl.seasonMode><md-input-container><!--<div ng-repeat=\"s in ::$ctrl.seasons\" ng-if=\"$ctrl.seasonMode\">\n          <md-checkbox  ng-model=\"$ctrl.d\">{{::s.description}} {{::s.category}} </md-checkbox> </div>--><md-select ng-model=$ctrl.ranges multiple placeholder=Saison><md-option ng-repeat=\"s in ::$ctrl.seasons track by $index\" ng-value={{s}}><strong>Saison.</strong> {{s.description}} - {{s.category}}</md-option></md-select></md-input-container></div><div style=\"padding: 16px\"><md-checkbox ng-model=$ctrl.paxMode>Saisir en mode demi double</md-checkbox></div><div class=\"rate-grid flat-mode\" ng-class=\"{\'pax-mode\':$ctrl.paxMode}\"><section ng-repeat=\"unit in ::$ctrl.units\" class=unit><header>{{::unit.name}}</header><div class=rate-groups><section class=rate-group ng-repeat=\"group in ::unit.rateGroups \"><!-- <section class=\"rate-group\" ng-repeat=\"group in ::unit.rateGroups | filter:{ selected:true }\"> --><header><md-switch ng-model=group.selected arial-label=basis ng-change=$ctrl.onRateGroupSwitch(group)>Tarif {{::group.basis.description}}</md-switch><!-- <md-select ng-if=\"!$ctrl.paxMode && group.selected\" placeholder=\"saisir a partir de la base\"\n                  ng-model=\"$ctrl.selectrate\" style=\"min-width: 150px\"> --><md-select ng-if=\"!$ctrl.paxMode \" placeholder=\"saisir a partir de la base\" ng-model=$ctrl.selectrate style=\"min-width: 150px\"><!-- <md-select-label>{{$ctrl.units.name[media.unit]}}</md-select-label> --><!-- <md-option ng-selected=\"true\" ng-value=\"\"> </md-option> --><!-- <md-option  ng-repeat=\"rte in ::unit.rateGroups\" ng-selected=\"{{rte}}\" ng-value=\"{{rte}}\"> {{::rte.basis.description}} </md-option>   --><md-option ng-show=\"rte.basis.code!=group.basis.code\" ng-repeat=\"rte in ::unit.rateGroups\" ng-value={{rte}}>{{::rte.basis.description}}</md-option></md-select><input ng-if=\"!$ctrl.paxMode \" ng-model=group.pourcent type=number min=0 max=999999 placeholder=\"valeur en %\" style=\"width: 90px\"><md-button ng-if=\"!$ctrl.paxMode \" class=md-accent ng-click=$ctrl.copyPorduct(group,$ctrl.selectrate.basis.code,unit.rateGroups,group.pourcent)>Appliquer</md-button></header><!-- ng-if=\"group.selected\" --><div class=content><div class=flat-form><div class=rate-input ng-repeat=\"item in ::group.products\" ng-class={selected:item.selected}><div layout=row><md-table-container><table md-table><thead md-head><tr md-row><td md-column><div><md-switch ng-model=item.selected arial-label=product></md-switch><span class=occupancy>{{::item.product.occupancy|occupancy}}</span> <span class=board>{{::$ctrl.boards[item.product.board].name}}</span></div></td><td md-column><md-input-container><input ng-model=item.price type=number min=0 max=999999 ng-disabled=\"!item.selected || $ctrl.paxMode\" placeholder=\"Entrer le tarif ici\"></md-input-container></td><td md-column><section class=guest-count ng-if=\"$ctrl.policiesAge.length > 0 && $ctrl.productHasChilds(item.product.occupancy)\"><div class=category-count ng-repeat=\"age in ::$ctrl.policiesAge track by age\"><!-- <md-input-container> --><label>suppl. 1 Enf moins de {{age}}</label><input ng-model=item.product.supEnf[age] type=number min=0 max=999999 placeholder=\"Tarif ici\"><!-- </md-input-container> --></div></section></td><td md-column><section class=guest-count ng-if=$ctrl.productHasTwoChilds(item.product.occupancy)><div class=category-count ng-repeat=\"age in ::$ctrl.policiesAge track by age\"><!-- <md-input-container> --><label>suppl. 2+ Enf moins de {{age}}</label><input ng-model=item.product.supEnf2[age] type=number min=0 max=999999 placeholder=\"Tarif ici\"><!-- </md-input-container> --></div></section></td></tr></thead></table></md-table-container><!-- <div flex=\"30\">\n                        <div class=\"\">\n                          <md-switch ng-model=\"item.selected\" arial-label=\"product\">\n                          </md-switch>\n                          <span class=\"occupancy\"\n                            >{{::item.product.occupancy|occupancy}}</span\n                          >\n                          <span class=\"board\"\n                            >{{::$ctrl.boards[item.product.board].name}}</span\n                          >\n                        </div>\n                      </div>\n                      <div flex=\"35\">\n                       \n                        <md-input-container>\n                          <input\n                          ng-model=\"item.price\"\n                          type=\"number\"\n                          min=\"0\"\n                          max=\"999999\"\n                          ng-disabled=\"!item.selected || $ctrl.paxMode\"\n                          placeholder=\"....\"\n                        />\n                        </md-input-container>\n                      </div>\n                      <div flex=\"35\">\n                        <section\n                          class=\"guest-count\"\n                          ng-if=\"$ctrl.policiesAge.length > 0 && $ctrl.productHasChilds(item.product.occupancy)\"\n                        >\n                          <div\n                            class=\"category-count\"\n                            ng-repeat=\"age in ::$ctrl.policiesAge track by age\"\n                          >\n                            <label>suppl.Enf moins de {{age}}</label>\n                            <input\n                              ng-model=\"item.product.supEnf[age]\"\n                              type=\"number\"\n                              min=\"0\"\n                              max=\"999999\"\n                              placeholder=\"...\"\n                            />\n                          </div>\n                        </section>\n                      </div> --></div><!-- <div layout=\"row\">\n                      <div ng-if=\" $ctrl.policiesAge.length > 0 && $ctrl.productHasChilds(item.product.occupancy)\"\n                        ng-repeat=\"age in ::$ctrl.policiesAge track by age\">\n                        <label count=\"$index\">suppl.Enf moins de {{age}} </label>\n                        <input ng-model=\"item.product.supEnf[age]\" type=\"number\" min=\"0\" max=\"999999\"\n                          placeholder=\"...\" />\n                      </div>\n                    </div> --><!-- <div ng-if=\" $ctrl.policiesAge.length > 0 && $ctrl.productHasChilds(item)\"\n                        ng-repeat=\"age in ::$ctrl.policiesAge track by age\">\n                        <label count=\"$index\">suppl.Enf moins de {{age}} </label>\n                        <input ng-model=\"group.supEnf[age]\" type=\"number\" min=\"0\" max=\"999999\" placeholder=\"...\" />\n\n                    </div> --></div><!-- <div ng-if=\"$ctrl.policiesAge.length > 0\" class=\"rate-input\"\n                    ng-repeat=\"age in ::$ctrl.policiesAge track by age\">\n                    <label count=\"$index\">supplement Enfants inf a {{age}} </label>\n                    <input ng-model=\"group.supEnf[age]\" type=\"number\" min=\"0\" max=\"999999\" placeholder=\"...\" />\n\n                  </div> --><!-- <div  class=\"rate-input\" >\n                      <label >Markup </label>\n                     <input ng-model=\"group.markup\" type=\"number\" min=\"0\" max=\"999999\"  placeholder=\"...\"/>\n\n                      </div> --></div><rates-pax-form ng-if=$ctrl.paxMode rate-group=group indexed-boards=::$ctrl.boards first-child-age=::$ctrl.firstChildAge></rates-pax-form></div></section></div></section></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=$ctrl.cancel()>Annuler</md-button><span flex></span><div class=calc><label>calculette</label><input ng-model=$ctrl.calculator> = {{$eval($ctrl.calculator) | number}}</div><span flex></span><!-- <md-button ng-click=\"$ctrl.applyChanges()\" >--><md-button ng-click=$ctrl.applyChanges() ng-disabled=ratesCalendarForm.$invalid>Valider</md-button></md-dialog-actions></form><!--<pre>{{$ctrl.policiesCombinaisons | json}}</pre>--></md-dialog>");
$templateCache.put("app/products/clone-rates-period/dialog.html","<md-dialog class=edit-rates aria-label=\"Mod tarif\"><form name=ratesCalendarForm><header><h2 class=md-subhead>Prolonger la periode des tarifs</h2><md-button class=md-icon-button ng-click=$ctrl.cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></header><md-dialog-content><label>Du</label><md-datepicker md-current-view=year ng-model=$ctrl.clone.start md-min-date=$ctrl.minDate md-placeholder=jj/mm/aaaa required></md-datepicker><label>Au</label><md-datepicker md-current-view=year ng-model=$ctrl.clone.end md-min-date=clone.debut md-placeholder=jj/mm/aaaa required></md-datepicker><md-input-container style=min-width:100px><label>À</label><!-- <input style =\" color: #000000; \" name=\"childmin\" ng-model=\"$ctrl.copy.occupancy.children.min\" type=\"number\" min=\"0\" max=\"10\" required/> --> <input type=number min=2023 max=2099 step=1 value=2023 ng-model=$ctrl.clone.applicableDate style=min-width:75px></md-input-container><md-input-container style=min-width:100px><label>+Pourcentage</label><!-- <input style =\" color: #000000; \" name=\"childmin\" ng-model=\"$ctrl.copy.occupancy.children.min\" type=\"number\" min=\"0\" max=\"10\" required/> --> <input type=number ng-model=$ctrl.clone.pourcent style=min-width:75px></md-input-container><!-- <label>À</label>\n      <input type=\"number\" min=\"2023\" max=\"2099\" step=\"1\" value=\"2023\" ng-model=\"$ctrl.clone.applicableDate\" /> --><md-dialog-actions layout=row><md-button ng-click=$ctrl.cancel()>Annuler</md-button><span flex></span><md-button><md-button ng-click=$ctrl.applyClone($ctrl.group,$ctrl.clone) ng-disabled=ratesCalendarForm.$invalid>Valider</md-button></md-button></md-dialog-actions></md-dialog-content></form><!--<pre>{{$ctrl.policiesCombinaisons | json}}</pre>--></md-dialog>");
$templateCache.put("app/products/select-matrix/template.html","<!-- <table class=\"product-matrix\" ng-repeat=\"g in $ctrl.rateGroups\" ng-if=\"$ctrl.permissionsContracting\"> --><table class=product-matrix ng-repeat=\"g in $ctrl.rateGroups\"><thead><tr><th style=text-align:left><!-- <md-checkbox  ng-model=\"g.checked\" class=\"md-primary\" ng-change=\"$ctrl.rateGroupChanged(g)\" \n          aria-label=\"all rate basis\">\n          tarif {{::g.basis.description}} {{g.checked}}\n        </md-checkbox> --><div class=md-label><span>tarif {{::g.basis.description}}</span></div></th><th ng-repeat=\"item in ::g.boardCodes\"><label style=display:block>{{::$ctrl.boards[item.code].name}}</label><md-checkbox ng-hide=::angular.isUndefined(item.product) ng-model=item.checked ng-change=\"$ctrl.boardChanged(g, $index)\" class=md-primary aria-label=board></md-checkbox></th></tr></thead><tbody><tr ng-repeat=\"occupancyLine in ::g.lines\"><th><md-checkbox ng-hide=::angular.isUndefined(item.product) ng-model=g.occupancies[$index].checked ng-change=\"$ctrl.occupancyChanged(g, $index)\" class=md-primary aria-label=occupancy>{{::g.occupancies[$index].code | occupancy}}</md-checkbox></th><td ng-repeat=\"item in ::occupancyLine track by $index\"><md-checkbox ng-hide=item.disabled ng-disabled=item.disabled ng-model=item.checked ng-change=\"$ctrl.valueChanged(g, item)\" aria-label={{::$ctrl.boards[g.boards[$index].code].name}}></md-checkbox></td></tr></tbody></table>");
$templateCache.put("app/products/unit/template.html","<header class=main-header style=\"margin: 16px\"><h1 class=md-title>Offres {{::$ctrl.unitTypes[$ctrl.unit.type].name}} {{::$ctrl.unit.name}}</h1></header><main><section ng-repeat=\"g in $ctrl.rateGroups\" ng-if=$ctrl.permissionsContracting><header><span>Base tarifaire {{::g.basis.description}}</span><!-- <md-button  class=\"md-raised md-accent\" ng-click=\"$ctrl.addOccupancies(g.basis)\" style=\"width: 220px;\">\n      Ajouter des occupations\n    </md-button> --></header><table class=product-matrix><thead><tr><th style=text-align:left>Occupation</th><th ng-repeat=\"code in g.matrix.boards\">{{::$ctrl.boards[$index].name}}<br></th></tr><tr><th style=text-align:left></th><th ng-repeat=\"boardCode in g.matrix.boards\"><!-- {{boardCode}} {{ vm.checkAll }} --><md-checkbox ng-model=$ctrl.checkAll[boardCode] ng-change=\"$ctrl.toggleAllProducts(g, boardCode)\" aria-label=\"Selectionner Tous\"></md-checkbox></th></tr></thead><tbody><tr ng-repeat=\"occupancyLine in g.matrix.values\"><!-- <textarea name=\"\" id=\"\" cols=\"30\" rows=\"10\">{{g.matrix.values | json}}</textarea> --><!-- | occupancy --><th>{{::g.matrix.occupancies[$index] | occupancy }}</th><td ng-repeat=\"item in occupancyLine track by $index\"><!-- {{item.product.board}} --><!-- <md-checkbox ng-model=\"item.checked\" ng-change=\"$ctrl.toggleProduct(g,$parent.$index, $index, item.product)\"\n              aria-label=\"{{::$ctrl.boards[$index].name}}\">\n            </md-checkbox> --><md-checkbox ng-model=item.checked ng-change=\"$ctrl.toggleProduct(g, $parent.$index, $index, item.product, false)\" aria-label={{::$ctrl.boards[$index].name}}></md-checkbox><md-tooltip>{{::$ctrl.boards[$index].name}}</md-tooltip></td></tr></tbody></table><!--\n  <div ng-repeat=\"p in g.products\">\n    {{::p.occupancy | occupancy}} {{::$ctrl.boards[p.board].name}}\n  </div>\n--></section></main>");
$templateCache.put("app/property/add/template.html","<!--markup\n<md-steppers>\n    <md-step label=\"Step 1\" md-complete=\"step1.completed\"  ng-disabled=\"step1.disabled\">\n        <md-content></md-content>\n    </md-step>\n    <md-step label=\"Step 2\" md-complete=\"step2.completed\"  ng-disabled=\"step2.disabled\">\n        <md-content></md-content>\n    </md-step>\n    <md-step label=\"Finish\" md-complete=\"step3.completed\"  ng-disabled=\"step3.disabled\">\n        <md-content></md-content>\n    </md-step>\n</md-steppers>\n--><div><md-stepper id=stepper md-linear=true><md-step md-label=\"Information general\"><md-step-body>dmlksdmkdsm<property-info-edit></property-info-edit></md-step-body><md-step-actions><md-button class=\"md-primary md-raised\" ng-click=$ctrl.selectCampaign();>Continue</md-button><md-button class=md-primary ng-click=$ctrl.cancel();>Cancel</md-button></md-step-actions></md-step><md-step md-label=\"Create an group\"><md-step-body><p>Step content</p></md-step-body><md-step-actions><md-button class=\"md-primary md-raised\" ng-click=$ctrl.nextStep();>Continue</md-button><md-button class=md-primary ng-click=$ctrl.previousStep();>Back</md-button></md-step-actions></md-step><!-- Other steps if needed ... --></md-stepper></div>");
$templateCache.put("app/property/boards/template.html","<header><h4>Formules des pensions</h4><!-- <md-button ng-click=\"$ctrl.add($event)\" class=\"md-accent\" aria-label=\"Ajouter un commentaire\">\n    Ajouter\n  </md-button> --></header><md-table-container><table md-table><thead md-head><tr md-row><th style=\"width: 35%\" md-column><span>Libellé</span></th><th md-column><span>Alias</span></th><th md-column><span>Description</span></th><th style=\"width: 14%\" md-column></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"b in $ctrl.boardsGroups\"><td md-cell><div class=translation>{{::b.name}}</div></td><td md-cell><div ng-if=\"b.isNew==false\" class=translation ng-repeat=\"(lang,name) in b.alternativenames track by $index\">{{::name}}</div></td><td md-cell><div ng-if=\"b.isNew==false\" class=translation ng-repeat=\"(lang,name) in b.description track by $index\"><span ng-bind-html=name></span></div></td><td md-cell><md-button class=md-icon-button ng-click=$ctrl.edit($event,b)><md-icon>edit</md-icon><md-tooltip>Modifier la formule</md-tooltip></md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"$ctrl.remove($event,b, $index)\"><md-icon>delete</md-icon><md-tooltip>Supprimer la formule</md-tooltip></md-button></td></tr></tbody></table></md-table-container><!-- <pre>{{$ctrl.boardsGroups | json}}</pre> -->");
$templateCache.put("app/property/comments/template.html","<header><h4>Commentaires</h4><md-button ng-click=$ctrl.add($event) class=md-accent aria-label=\"Ajouter un commentaire\">Ajouter</md-button></header><!-- <pre>{{$ctrl.items | json}}</pre> --><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span>Libellé</span></th><th md-column><span>Description</span></th><th md-column md-numeric>Documents</th><th></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"c in $ctrl.items\"><td md-cell>{{c.label}}</td><td md-cell>{{c.description}}</td><td md-cell><span ng-repeat=\"u in c.url track by $index\"><a ng-href={{u}} target=_blank download><!-- <img ng-src=\"{{u}}\" width=\"50\" height=\"40\"> --> <span class=material-icons>attachment </span><!-- {{$index +1}} --></a><br></span></td><td md-cell style=\"width: 128px\"><!-- <md-button class=\"md-icon-button\" ng-click=\"$ctrl.edit($event,c)\">\n            <md-icon>edit</md-icon>\n            <md-tooltip>Modifier</md-tooltip>\n          </md-button> --><md-button class=\"md-icon-button md-warn\" ng-click=$ctrl.remove($event,c)><md-icon>delete</md-icon><md-tooltip>Supprimer</md-tooltip></md-button></td></tr></tbody></table></md-table-container>");
$templateCache.put("app/property/contacts/add.html","<md-dialog><form name=contactForm><md-toolbar><div class=md-toolbar-tools style=background-color:blue><h2>Contact</h2><span flex></span></div></md-toolbar><md-dialog-content><!-- <pre>{{$ctrl.contact.usage | json}}</pre> --><md-content layout-gt-sm=row layout-padding><md-input-container><label>Utilisation</label><md-select ng-model=$ctrl.contact.usage required><md-option value={{code}} ng-repeat=\"(code,name) in $ctrl.usage\">{{name}}</md-option></md-select></md-input-container><md-input-container flex=50><md-select ng-model=$ctrl.contact.medium required><md-option value={{code}} ng-repeat=\"(code,name) in $ctrl.medium\">{{name}}</md-option></md-select></md-input-container><md-input-container flex=100 ng-if=\"$ctrl.contact.medium === \'email\'\" required><input type=email name=value required ng-model=$ctrl.contact.value placeholder=email><div ng-messages=contactForm.value.$error multiple><div ng-message=pattern>Prière de ne pas tout mettre en majuscule.</div><div ng-message=notIn>Une autre catégorie porte le même nom.</div></div></md-input-container><md-input-container flex=100 ng-if=\"$ctrl.contact.medium !== \'email\'\" required><label>{{$ctrl.medium[$ctrl.contact.medium]}}</label><input type=tel name=value required ng-model=$ctrl.contact.value phone-number country-code=$ctrl.property.country pattern=[0-9+-]{8,15}></md-input-container></md-content><md-content layout-gt-sm=row layout-padding><md-input-container flex=50 ng-if=\"$ctrl.contact.usage === \'commercial\'\" required><label>Nom</label><input type=lastName name=value required ng-model=$ctrl.contact.lastName></md-input-container><md-input-container flex=50 ng-if=\"$ctrl.contact.usage === \'commercial\'\" required><label>Prénom</label><input type=firstName name=value required ng-model=$ctrl.contact.firstName></md-input-container></md-content></md-dialog-content><md-dialog-actions layout=row layout-align=space-between><md-button ng-click=$ctrl.cancel()>Annuler</md-button><md-button class=\"md-raised md-accent\" ng-click=$ctrl.confirm() ng-disabled=contactForm.$invalid>Enregister</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/property/contacts/template.html","<header><h3>Contacts</h3><md-button ng-click=$ctrl.add() class=md-accent aria-label=\"Ajouter une catégorie d\'unités\">Ajouter</md-button></header><md-list class=md-dense style=padding:0><md-subheader class=md-no-sticky>Général</md-subheader><md-list-item class=\"md-dense md-2-line\" ng-repeat=\"c in $ctrl.contacts | filter:{usage:\'default\'}\"><md-icon class=md-avatar-icon ng-show=\"c.medium===\'email\'\">email</md-icon><md-icon class=md-avatar-icon ng-show=\"c.medium===\'tel\'\">phone</md-icon><md-icon class=md-avatar-icon ng-show=\"c.medium===\'fax\'\">print</md-icon><div class=md-list-item-text ng-bind=c.value></div><md-button class=\"md-secondary md-icon-button\" ng-click=$ctrl.remove(c) aria-label=remove><md-icon>delete</md-icon></md-button></md-list-item><md-divider></md-divider><md-subheader class=md-no-sticky>Réservation</md-subheader><md-list-item class=\"md-dense md-2-line\" ng-repeat=\"c in $ctrl.contacts | filter:{usage:\'booking\'}\"><md-icon class=md-avatar-icon ng-show=\"c.medium===\'email\'\">email</md-icon><md-icon class=md-avatar-icon ng-show=\"c.medium===\'tel\'\">phone</md-icon><md-icon class=md-avatar-icon ng-show=\"c.medium===\'fax\'\">print</md-icon><div class=md-list-item-text ng-bind=c.value></div><md-button class=\"md-secondary md-icon-button\" ng-click=$ctrl.remove(c) aria-label=remove><md-icon>delete</md-icon></md-button></md-list-item><md-divider></md-divider><md-subheader class=md-no-sticky>Comptabilité</md-subheader><md-list-item class=\"md-dense md-2-line\" ng-repeat=\"c in $ctrl.contacts | filter:{usage:\'accounting\'}\"><md-icon class=md-avatar-icon ng-show=\"c.medium===\'email\'\">email</md-icon><md-icon class=md-avatar-icon ng-show=\"c.medium===\'tel\'\">phone</md-icon><md-icon class=md-avatar-icon ng-show=\"c.medium===\'fax\'\">print</md-icon><div class=md-list-item-text ng-bind=c.value></div><md-button class=\"md-secondary md-icon-button\" ng-click=$ctrl.remove(c) aria-label=remove><md-icon>delete</md-icon></md-button></md-list-item><md-divider></md-divider><md-subheader class=md-no-sticky>Commercial</md-subheader><md-list-item class=\"md-dense md-2-line\" ng-repeat=\"c in $ctrl.contacts | filter:{usage:\'commercial\'}\"><!-- <pre>{{c | json}}</pre> --><md-icon class=md-avatar-icon ng-show=\"c.medium===\'email\'\">email</md-icon><md-icon class=md-avatar-icon ng-show=\"c.medium===\'tel\'\">phone</md-icon><md-icon class=md-avatar-icon ng-show=\"c.medium===\'fax\'\">print</md-icon><div class=md-list-item-text layout=column><h3>{{c.value}}</h3><h4>{{c.firstName}} &nbsp;{{c.lastName}}</h4><!-- <p>{{c.lastName}}</p> --></div><md-button class=\"md-secondary md-icon-button\" ng-click=$ctrl.remove(c) aria-label=remove><md-icon>delete</md-icon></md-button></md-list-item></md-list>");
$templateCache.put("app/property/container/template.html","<header layout=row layout-align=\"start center\"><h1 class=md-title><span>{{::$ctrl.property.name}}</span></h1><nav class=breadcrumb flex><a ng-repeat=\"crumb in $ctrl.breadcrumb\" ng-href={{::crumb.href}}><md-icon>chevron_right</md-icon>{{::crumb.label}}</a></nav><div class=actions ng-repeat=\"a in $ctrl.actions\"><md-menu ng-if=a.items><md-button class=md-raised ng-class=\"::{\'md-icon-button\': a.icon}\" ng-click=$mdOpenMenu($event)><md-icon ng-if=a.icon>{{::a.icon}}</md-icon><md-tooltip ng-if=a.icon>{{::a.label}}</md-tooltip><span ng-if=!a.icon>{{::a.label}}</span></md-button><md-menu-content><span>Modifier</span><md-menu-item ng-repeat=\"i in a.items\"><md-button ng-href={{i.href}}>{{::i.label}}</md-button></md-menu-item></md-menu-content></md-menu><md-button ng-if=!a.items class=md-raised ng-class=\"::{\'md-icon-button\': a.icon}\" ng-href={{a.href}} ng-click=a.run()><md-icon ng-if=a.icon>{{::a.icon}}</md-icon><md-tooltip ng-if=a.icon>{{::a.label}}</md-tooltip></md-button></div></header><div class=container><md-sidenav class=\"md-sidenav-left md-whiteframe-z2\" md-component-id=property-menu md-is-locked-open=true style=\"width: 200px\"><md-content md-scroll-y flex layout=column><md-list><md-list-item ui-sref=property.dashboard>Tableau de bord</md-list-item><!--<md-subheader ng-repeat-start=\"(group,items) in ::$ctrl.menu\" class=\"md-no-sticky\">{{::group}}</md-subheader>--><hr ng-repeat-start=\"(group,items) in ::$ctrl.menu\"><md-list-item ng-repeat-end ng-repeat=\"item in ::items\" ng-href={{::item.href}}>{{::item.label}}</md-list-item></md-list></md-content></md-sidenav><ui-view></ui-view></div>");
$templateCache.put("app/property/dashboard/template.html","<header layout=row layout-align=\"start center\"><h2>Tableau de bord</h2><md-nav-bar md-selected-nav-item=$ctrl.viewMode nav-bar-aria-label=\"report view modes\"><md-nav-item md-nav-click=\"$ctrl.viewMode === \'booking\'\" name=booking>Vue Réservation</md-nav-item><md-nav-item md-nav-click=\"$ctrl.viewMode === \'checkin\'\" name=checkin>Vue Séjour</md-nav-item></md-nav-bar><md-button class=md-icon-button ng-click=$ctrl.previousMonth() ng-disabled=!$ctrl.hasPrevious><md-icon>chevron_left</md-icon></md-button><strong ng-bind=\"$ctrl.period.from | date:\'MMMM yyyy\'\"></strong><md-button class=md-icon-button ng-click=$ctrl.nextMonth() ng-disabled=!$ctrl.hasNext><md-icon>chevron_right</md-icon></md-button></header><main><overall-report style=font-size:0.9em bookings=$ctrl.bookings cancellations=$ctrl.cancellations confirmed-checkins=$ctrl.confirmedCheckins canceled-checkins=$ctrl.canceledCheckins view-by=$ctrl.viewMode></overall-report><section class=card><sales-breakdown units-map=::$ctrl.unitsMap report-data=$ctrl.salesBreakdown view-by=$ctrl.viewMode></sales-breakdown></section><calendar-chart class=card report-period=$ctrl.period report-data=$ctrl.calendar view-by=$ctrl.viewMode></calendar-chart></main>");
$templateCache.put("app/property/datasheet/template.html","<property-info-view class=card ng-if=\"!$ctrl.editInfo && $ctrl.permissionsContracting\" property=$ctrl.property on-edit=$ctrl.toggleEditInfo() update-prop=$ctrl.updateProp()></property-info-view><property-info-edit class=card ng-if=\"$ctrl.editInfo === true && $ctrl.permissionsContracting\" property=$ctrl.property on-close=$ctrl.toggleEditInfo() on-change=$ctrl.onInfoChanged(changes)></property-info-edit><div layout=row layout-align=\"start start\" ng-if=\"::$ctrl.property && $ctrl.permissionsContracting\"><property-policies ng-if=!$ctrl.editPolicies property=$ctrl.property languages=languages flex=50 class=card style=\"min-width: 400px\" on-edit=$ctrl.toggleEditPolicies()></property-policies><property-policies-edit ng-if=$ctrl.editPolicies property=$ctrl.property flex=50 class=card style=\"min-width: 400px\" on-close=$ctrl.toggleEditPolicies() on-change=$ctrl.onPoliciesChanged(changes)></property-policies-edit><property-contacts flex=50 property=$ctrl.property class=card style=\"min-width: 400px\"></property-contacts></div><property-units ng-if=\"::$ctrl.property && $ctrl.permissionsContracting\" property=$ctrl.property class=card></property-units><property-comments ng-if=\"::$ctrl.property && $ctrl.permissionsContracting\" property=$ctrl.property class=card></property-comments><property-tags ng-if=\"::$ctrl.property && $ctrl.permissionsContracting\" property=$ctrl.property class=card></property-tags><property-boards ng-if=\"::$ctrl.property && $ctrl.permissionsContracting\" property=$ctrl.property class=card></property-boards><div class=danger style=margin-bottom:0 ng-if=\"::$ctrl.property.permissions.delete && $ctrl.permissionsContracting\"><md-button style=\"display:block;margin:16px auto\" ng-click=$ctrl.confirmDelete() class=\"md-raised md-warn\">Supprimer cette établissement</md-button></div>");
$templateCache.put("app/property/list/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Etablissements</span><!--\n    <form name=\"propertyFilterForm\" flex style=\"margin-left: 16px;\" layout=\"row\">\n      <md-icon class=\"material-icons\">search</md-icon>\n      <input style=\" width: 100%;\n    margin: 0 0 0 16px;\n    font-size:14px;\n    padding:4px;\n    border: none;\n    color: rgba(0, 0, 0, 0.87);\" type=\"text\" ng-model=\"$ctrl.query.filter\" ng-model-options=\"$ctrl.filter.options\" placeholder=\"rechercher\">\n    </form>\n  --> <span flex></span><md-button class=\"md-icon-button md-raised\" ng-hide=$ctrl.showFilters ng-click=\"$ctrl.showFilters = !$ctrl.showFilters\"><md-icon>filter_list</md-icon><md-tooltip>filtrer</md-tooltip></md-button><md-button ng-if=::$ctrl.permissions.add style=margin-left:8px class=\"md-icon-button md-raised md-accent\" ui-sref=\"property.datasheet({property:\'new\'})\"><md-icon>add</md-icon><md-tooltip>Ajouter un établissement</md-tooltip></md-button></div></md-toolbar><form style=\"padding:0 16px; background-color: aliceblue\" name=propertyFiltersForm ng-if=$ctrl.showFilters layout=row><span flex></span></form><!-- exact table from live demo --><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head ng-show=$ctrl.showFilters><tr md-row style=\"background-color: aliceblue\"><td md-column></td><td md-column><md-input-container><label>Nom</label><input ng-model=$ctrl.query.filter ng-model-options=$ctrl.filter.options></md-input-container></td><td md-column><md-autocomplete md-floating-label=destination md-selected-item=$ctrl.query.locality md-items=\"item in $ctrl.dest.items\" md-search-text=$ctrl.dest.searchText md-item-text=item.name><span>{{ item.name }}</span></md-autocomplete></td><td md-column style=text-align:right><md-button style=margin-right:24px class=md-icon-button ng-click=\"$ctrl.showFilters = false\"><md-icon>close</md-icon></md-button></td></tr></thead><thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.loadProperties><tr md-row><th md-column><span>Type</span></th><th md-column><span>Code fournisseur</span></th><th md-column md-order-by=name><span>Etablissement</span></th><th md-column><span>Catégorie(étoile)</span></th><th md-column><span>Recomendation</span></th><th md-column><span>Destination</span></th><th md-column><span>Pays</span></th><th md-column md-numeric>Modifié le</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"p in $ctrl.properties\" ng-click=$ctrl.showProperty(p)><td md-cell>{{p.type.name}}</td><td md-cell>{{p.accountingCode}}</td><td md-cell>{{p.name}}</td><td md-cell>{{p.rating[1]}}</td><td md-cell>{{p.rating[2]}}</td><td md-cell>{{p.locality.name}}</td><td md-cell>{{p.country}}</td><td md-cell>{{p.audit.modifiedOn | date}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit-options=[20,50,100] md-limit=$ctrl.query.limit md-page=$ctrl.query.page md-total={{$ctrl.total}} md-on-paginate=$ctrl.loadProperties></md-table-pagination></md-card>");
$templateCache.put("app/property/tags/template.html","<!-- <section class=\"card\"> --><header><h4>Tags</h4></header><ul layout=row layout-wrap style=list-style:none><!-- <div class=\"translation\" ng-repeat=\"(lang,name) in i.name track by $index\" ng-if=\"lang == \'fr\'\">\n    \n  </div> --><li ng-repeat=\"a in ::$ctrl.options.tags track by $index\" flex=10><md-checkbox ng-disabled=a.disabled ng-checked=\"$ctrl.propertyTags.indexOf(a.code) > -1\" ng-click=$ctrl.toggleProperty(a)>{{::a.name}}</md-checkbox></li></ul><!-- </section> -->");
$templateCache.put("app/property/unit-rel-wrapper/template.html","<nav class=units><ul ng-repeat=\"group in ::$ctrl.unitGroups\"><li class=header>{{::group.type.name}}</li><li ng-repeat=\"unit in ::group.units\" ng-class=\"{active:$ctrl.activeUnit === unit}\"><a href ng-click=$ctrl.showUnit(unit)>{{::unit.name}}</a></li></ul></nav><ui-view flex><div class=prompt><p>Sélectionnez une catégorie d\'unités</p><nav class=units><ul ng-repeat=\"group in ::$ctrl.unitGroups\"><li class=header>{{::group.type.name}}</li><li ng-repeat=\"unit in ::group.units\" ng-class=\"{active:$ctrl.activeUnit === unit}\"><a href ng-click=$ctrl.showUnit(unit)>{{::unit.name}}</a></li></ul></nav></div></ui-view>");
$templateCache.put("app/property/units/template.html","<header><h4>Catégories d\'unités/chambres</h4><md-button ng-click=$ctrl.add($event) class=md-accent aria-label=\"Ajouter une catégorie d\'unités\">Ajouter</md-button></header><md-table-container><table md-table><thead md-head md-order=$ctrl.query.order><tr md-row><th md-column md-order-by=code><span></span></th><th md-column><span>Type</span></th><th md-column><span>Libellé</span></th><th md-column><span>Occupation</span></th><th md-column><span>Occup max</span></th><th md-column md-numeric>Nombre</th><th md-column md-numeric>Superficie</th><th></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"u in $ctrl.items | orderBy: $ctrl.query.order\"><td md-cell>{{u.code}}</td><td md-cell>{{$ctrl.unitTypes[u.type].name}}</td><td md-cell>{{u.name}}</td><td md-cell>{{u.occupancy.adults.label}}:{{u.occupancy.adults.max}} , {{u.occupancy.children.label}}:{{u.occupancy.children.max}}</td><td md-cell>{{u.maxOccupancy || \'N/A\'}}</td><td md-cell>{{u.count}}</td><td md-cell>{{u.area}} m<sup>2</sup></td><td md-cell style=\"width: 265px\"><md-button class=\"md-icon-button md-accent\" ng-disabled=$last ng-click=$ctrl.moveUp($event,$index+1)><md-icon>keyboard_arrow_down</md-icon><md-tooltip>Descendre cette categorie</md-tooltip></md-button><md-button class=\"md-icon-button md-accent\" ng-disabled=$first ng-click=$ctrl.moveUp($event,$index)><md-icon>keyboard_arrow_up</md-icon><md-tooltip>Remonter cette categorie</md-tooltip></md-button><md-button class=md-icon-button ng-click=$ctrl.edit($event,u)><md-icon>edit</md-icon><md-tooltip>Modifier</md-tooltip></md-button><md-button class=md-icon-button ng-click=$ctrl.combinationsEdit($event,u)><md-icon>supervisor_account</md-icon><md-tooltip>Combinaisons</md-tooltip></md-button><md-button class=\"md-icon-button md-warn\" ng-click=$ctrl.remove($event,u)><md-icon>delete</md-icon><md-tooltip>Supprimer</md-tooltip></md-button></td></tr></tbody></table></md-table-container>");
$templateCache.put("app/rate-basis/cancellation-input/template.html","<div layout=row><md-radio-group ng-model=cancellationType layout-margin flex layout=column><md-radio-button value=free class=md-primary ng-click=freeCancellation()>Annulation Gratuite</md-radio-button><md-radio-button value=nrf class=md-primary ng-click=nonRefundable()>Non Remboursable</md-radio-button><md-radio-button value=custom class=md-primary>Autre</md-radio-button></md-radio-group><div ng-if=\"cancellationType === \'custom\'\" flex><ul><li ng-repeat=\"r in rules\" class=md-2-line layout=row layout-align=\"start center\"><div flex ng-pluralize count=r.days when=\"{\'0\':\'No show/jour d\\\'arrivée\',\'1\':\'un jour avant check-in\',\'other\':\'{} jours avant check-in\'}\"></div><div flex=30>{{::r.charge}}&nbsp; {{::units[r.unit]}} retenu</div><md-button class=\"md-icon-button md-warn\" aria-label=\"Use Android\" ng-click=remove($index)><md-icon>delete</md-icon></md-button></li></ul><div ng-form=newRuleForm layout=row layout-align=\"start start\" isolate-form><md-input-container flex=20><label>Jours avant</label><input type=number min=0 max=999 ng-model=newRule.days required></md-input-container><md-input-container flex><label>Facturer</label><input type=number min=0 ng-model=newRule.charge required></md-input-container><md-input-container flex><label>Unité</label><md-select ng-model=newRule.unit required><md-option ng-repeat=\"(unit,label) in ::units\" ng-value=unit>{{::label}}</md-option></md-select></md-input-container><md-button class=md-raised style=\"margin-top: 16px\" ng-click=\"add(newRule, true)\" ng-disabled=newRuleForm.$invalid>OK</md-button></div></div></div>");
$templateCache.put("app/rate-basis/edit/template.html","<form ng-if=$ctrl.basis name=rateBasisForm><section layout-wrap layout=row><md-input-container flex=100><label>Libellé</label><input ng-model=$ctrl.basis.description required></md-input-container><md-input-container style=\"width:130px;margin-right: 12px\"><label>Type</label><md-select ng-model=$ctrl.basis.commissionable ng-disabled=\"$ctrl.basis.code != -1\"><md-option ng-value=false>Net</md-option><!-- <md-option ng-value=\"true\">Commission</md-option> --><md-option ng-value=true>Bar</md-option></md-select></md-input-container><md-input-container ng-if=$ctrl.basis.commissionable style=width:130px><label>Commission</label><input ng-model=$ctrl.basis.commission type=number required min=0.1 max=100></md-input-container><md-input-container style=\"width:130px;    margin-right: 12px\"><label>Taxes</label><md-select ng-model=$ctrl.basis.taxInc><md-option ng-value=true>Incluses</md-option><md-option ng-value=false>Excluses</md-option></md-select></md-input-container><md-input-container><label>Paiement</label><md-select ng-model=$ctrl.basis.payOnArrival><md-option ng-value=false>Le client paye à la réservation</md-option><md-option ng-value=true>Le client paye à l\'hôtel</md-option></md-select></md-input-container><!-- <md-input-container>\n      <label>Devise</label>\n      <md-select name=\"currency\"  ng-model=\"$ctrl.basis.currency\"  >\n        <md-option ng-value=\"MAD\">MAD</md-option>\n        <md-option ng-value=\"EUR\">EUR</md-option>\n        <md-option ng-value=\"USD\">USD</md-option>\n        <md-option ng-value=\"USD\">TND</md-option>\n\n      </md-select>\n    </md-input-container> --><md-input-container><label>Devise</label><md-select name=currency ng-model=$ctrl.basis.currency required><md-option value=MAD>MAD</md-option><md-option value=EUR>EUR</md-option><md-option value=USD>USD</md-option><md-option value=TND>TND</md-option><md-option value=XOF>XOF</md-option><md-option value=SAR>SAR</md-option></md-select></md-input-container></section><section class=booking><h4>Booking Window</h4><div class=fieldset><h5>Période</h5><div class=field-inline><label>Du</label><md-datepicker md-min-date=\"::($ctrl.disableBookingStart ? undefined : $ctrl.minDate)\" ng-model=$ctrl.basis.booking.period.start md-placeholder=jj/mm/aaaa md-current-view=year required></md-datepicker></div><div class=field-inline ng-if=!$ctrl.basis.booking.period.open><label>Jusqu\'au</label><md-datepicker md-min-date=$ctrl.basis.booking.period.start md-current-view=year ng-model=$ctrl.basis.booking.period.end md-placeholder=jj/mm/aaaa required></md-datepicker></div></div><div class=fieldset><h5>Délais</h5><!--\n      <small flex=100>Nombre de jour entre résa et checkin</small>\n    --><div class=field-inline><label for=bookingAdvanceMin>Au plus tôt</label><md-input-container><input style=\"width: 50px;text-align:center\" type=number aria-label=\"au plus tot\" id=bookingAdvanceMin required ng-model=$ctrl.basis.booking.advance.max min=0 max=999></md-input-container><label>jours,</label><label for=bookingAdvanceMax>au plus tard</label><md-input-container style=\"width:4em; margin: 0\"><input style=\"width: 50px;text-align:center\" id=bookingAdvanceMax aria-label=\"au plus tard\" required type=number ng-model=$ctrl.basis.booking.advance.min min=0 max={{$ctrl.basis.booking.advance.max}}></md-input-container><label for=bookingAdvanceMax>jours avant l\'arrivée.</label><label ng-show=\"$ctrl.basis.booking.advance.min === 0\"><strong>Heure limite pour les réservations du même jour</strong></label><md-input-container flex=33 ng-if=\"$ctrl.basis.booking.advance.min === 0\"><input type=time aria-label=\"délais last minute\" ng-model=$ctrl.basis.booking.advance.timeLimit value=23:59></md-input-container><!-- <pre>{{$ctrl.basis.booking.advance}}</pre> --></div></div></section><section class=stay><h4>Période Séjour</h4><div class=fieldset><h5>Période</h5><div class=field-inline><label>Du</label><md-datepicker ng-model=$ctrl.basis.stay.period.start md-min-date=$ctrl.basis.booking.period.start md-placeholder=date required></md-datepicker></div><div class=field-inline ng-if=!$ctrl.basis.booking.period.open><label>Jusqu\'au</label><md-datepicker ng-model=$ctrl.basis.stay.period.end md-current-view=year md-min-date=$ctrl.basis.booking.period.end md-placeholder=date required></md-datepicker></div></div><div class=fieldset><h5>Maximum Stay</h5><md-input-container><input type=number style=\"width: 50px\" aria-label=\"max stay\" min=1 ng-model=$ctrl.basis.stay.max></md-input-container><span>nuits</span></div></section><!--\n  <section class=\"season\">\n    <h4>Saisons</h4>\n    \n    \n\n      <md-table-container>\n        <table md-table>\n          <thead md-head>\n            <tr md-row>\n              <th md-column>From</th>\n              <th md-column>To</th>\n              <th md-column>saison</th>\n            </tr>\n            <tr md-row ng-repeat=\"range in $ctrl.basis.seasons.ranges track by $index\">\n              <td md-cell>{{ range.from}}</td>\n              <td md-cell>{{range.to}}</td>\n              <td md-cell>{{range.season}}</td>\n              <td md-cell>\n                <md-button class=\"md-icon-button\" ng-click=\"$ctrl.removeSeasonsPeriodRange($index)\">\n                  <md-icon>delete</md-icon>\n                </md-button>\n              </td>\n            </tr>\n          </thead md-head>\n          <tbody md-body>\n            <tr md-row>\n              <td md-cell>\n                <md-input-container class=\"md-block\" flex-gt-sm>\n                  <label>Du</label>\n                  <md-datepicker md-current-view=\"year\" ng-model=\"$ctrl.seasons.from\" md-placeholder=\"jj/mm/aaaa\" ></md-datepicker>\n                </md-input-container>\n              </td>\n              <td md-cell>\n                <md-input-container  flex-gt-sm>\n                  <label>Au</label>\n                  \n                  <md-datepicker md-current-view=\"year\" ng-model=\"$ctrl.seasons.to\" md-placeholder=\"jj/mm/aaaa\" ></md-datepicker>\n                </md-input-container>\n              </td>\n              <td md-cell>\n                <md-input-container  flex-gt-sm>\n                  <label>saison</label>\n                  <md-select placeholder=\"\" ng-change=\"\" ng-model=\"$ctrl.seasons.season\" required>\n                    <md-option ng-value=\"\'High\'\"> High Season </md-option>\n                    <md-option ng-value=\"\'Mid\'\"> Mid-Season </md-option>\n                    <md-option ng-value=\"\'Low\'\"> Low Season </md-option>\n\n                    \n                  </md-select>\n                </md-input-container>\n              </td>\n              <td md-cell>\n                <md-button class=\"md-icon-button\" ng-click=\"$ctrl.addSeasonPeriodRange()\">\n                  <md-icon>add</md-icon>\n                </md-button>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </md-table-container>\n    \n  </section>--><section class=restriction><md-switch ng-model=$ctrl.countriesRestrict>Restriction pays</md-switch><div ng-if=$ctrl.countriesRestrict><markets-input ng-model=$ctrl.basis.sales.countries countries=$ctrl.countriesList></markets-input></div></section><section class=restriction><md-switch ng-model=$ctrl.countriesExcluded>Exclusion pays</md-switch><div ng-if=$ctrl.countriesExcluded><markets-input ng-model=$ctrl.basis.stop.countries countries=$ctrl.countriesList></markets-input></div></section><!-- <section class=\"restriction\">\n    <md-switch ng-model=\"$ctrl.segmentsRestrict\">Canaux</md-switch>\n    <div ng-if=\"$ctrl.segmentsRestrict\">\n    \n      <md-checkbox ng-repeat=\"segment in $ctrl.segments\" ng-model=\"$ctrl.basis.sales.segments[segment.name]\">\n        {{::segment.name}}\n      </md-checkbox>\n    </div>\n  </section> --><section class=restriction><md-switch ng-model=$ctrl.segmentsRestrict>Canaux</md-switch><div ng-if=$ctrl.segmentsRestrict><!-- <md-checkbox ng-repeat=\"(key,label) in $ctrl.segments\" ng-model=\"$ctrl.basis.sales.segments[key]\">{{::label}}\n      </md-checkbox> --><!-- <md-checkbox ng-repeat=\"segment in $ctrl.segments\" ng-model=\"$ctrl.basis.sales.segments[segment.segmentId]\">--><md-checkbox ng-repeat=\"segment in $ctrl.segments\" ng-model=$ctrl.basis.sales.segments[segment.segmentId]>{{::segment.name}}</md-checkbox></div></section><section class=restriction><md-switch ng-model=$ctrl.markupsRestrict>markup</md-switch><div ng-if=$ctrl.markupsRestrict><md-checkbox ng-repeat=\"mark in $ctrl.markups\" ng-model=$ctrl.basis.markups[mark.name]>{{::mark.name}}</md-checkbox></div></section><!-- <pre>{{$ctrl.basis.sales.segments | json}}</pre>\n  <pre>{{$ctrl.segments | json}}</pre> --><!-- <section class=\"restriction\">\n    <md-switch ng-model=\"$ctrl.prestationsRestrict\">Prestations Supp</md-switch>\n    <div ng-if=\"$ctrl.prestationsRestrict \">\n      <md-checkbox ng-repeat=\"(key,label) in $ctrl.prestations\" ng-model=\"$ctrl.basis.prestations[key]\">{{::label}}</md-checkbox>\n    </div>\n  </section> --><!--\n    more flexibility that KCA does not want\n    <section class=\"restriction\">\n      <md-switch  ng-model=\"$ctrl.basis.sales.packagingRestrict\">Restriction packaging</md-switch>\n      <div ng-if=\"$ctrl.basis.sales.packagingRestrict\">\n        <md-checkbox ng-model=\"$ctrl.basis.sales.packaging.individual\">Individuel</md-checkbox>\n        <md-checkbox ng-model=\"$ctrl.basis.sales.packaging.group\">Groupe</md-checkbox>\n        <md-checkbox ng-model=\"$ctrl.basis.sales.packaging.package\">Package/serie</md-checkbox>\n      </div>\n    </section>\n    <section class=\"restriction\">\n      <md-switch  ng-model=\"$ctrl.basis.sales.customerRestrict\">Client final</md-switch>\n      <div ng-if=\"$ctrl.basis.sales.customerRestrict\">\n        <md-radio-group ng-model=\"$ctrl.basis.sales.traveller\">\n          <md-radio-button ng-value=\"b\">Corporate/business</md-radio-button>\n          <md-radio-button ng-value=\"l\">Particulier/leisure</md-radio-button>\n        </md-radio-group>\n      </div>\n    </section> \n  --><!-- <section class=\"restriction\">\n    <md-switch ng-model=\"$ctrl.amenitiesRestrict\" >Prestations test</md-switch>\n\n  \n    <div ng-if=\"$ctrl.amenitiesRestrict\">\n      <md-checkbox ng-repeat=\"a in $ctrl.options.rate\"  aria-label=\"a.name\"   ng-click=\"$ctrl.toggleRate($ctrl.basis,a)\" >{{::a.name}}</md-checkbox>\n    </div>\n    \n  </section> --><!-- <section  ng-if=\"$ctrl.basis.code\">\n\n    \n      <h4>Prestations Complémentaires</h4>\n      <div class=\"fieldset\" >\n      <ul layout=\"row\" layout-wrap style=\"list-style:none;\">\n        <li ng-repeat=\"a in $ctrl.options.rate \" flex=\"50\"> --><!-- <md-checkbox  ng-checked=\"$ctrl.amenitiesss1.indexOf(a.code) > -1\"     ng-click=\"$ctrl.toggleRate($ctrl.basis,a.code)\">{{::a.name}}</md-checkbox> --><!-- <md-checkbox  ng-checked=\"$ctrl.amenitiesss2.indexOf(a.code) > -1 || $ctrl.selected.indexOf(a.code) > -1 \"     ng-click=\"$ctrl.toggleRate($ctrl.basis,a.code)\">{{::a.name}}</md-checkbox> --><!-- <md-checkbox  ng-checked=\"$ctrl.amenitiesss2.indexOf(a.code) > -1 || $ctrl.selected.indexOf(a.code) > -1 \"     ng-click=\"$ctrl.toggleRate($ctrl.basis,a.code)\">{{::a.name}}</md-checkbox>\n\n        </li>\n        </u>\n      </div>\n  </section> --><!-- <section class=\"restriction\">\n    <header>\n      <h4>Prestations Complémentaires</h4>    \n    </header>\n    <ul layout=\"row\" layout-wrap style=\"list-style:none;\">\n      <li ng-repeat=\"a in $ctrl.options.rate \" flex=\"25\">\n      <md-checkbox  ng-checked=\"$ctrl.amenitiesss2.indexOf(a.code) > -1 || $ctrl.selected.indexOf(a.code) > -1 \"     ng-click=\"$ctrl.toggleRate($ctrl.basis,a.code)\">{{::a.name}}</md-checkbox>\n\n    \n      </li>\n      </u>\n  </section> --><!-- <section class=\"restriction\">\n  <md-table-container>\n  <table md-table md-progress=\"$ctrl.unitsPromise\">\n    <thead md-head>\n      <tr md-row>\n        <th md-column><span>prestations incluses</span></th>\n        <th md-column  style=\"text-align:center\"> Prix</th>\n      </tr>\n    </thead>\n    <tbody md-body>\n      <tr md-row  ng-repeat=\"a in $ctrl.options.rate \">\n        <td md-cell >\n\n        <md-switch ng-model=\"a.selected\" ng-disabled=\"a.selected\">\n          <span > {{::a.name}}</span>\n        </md-switch></td>\n       \n\n\n        <td md-cell  style=\"text-align:center\"><md-input-container style=\"width:4em;margin: 0;\">\n        <input style=\"text-align:center\" required type=\"number\" ng-model=\"a.price\" min=\"0\" max=\"9999\"  aria-label=\"minimum advanced booking\"/>\n      </md-input-container><md-tooltip> <span ng-bind=\"::u.name\"></span> {{::a.name}}</md-tooltip>\n      </td>\n      </tr>\n    </tbody>\n  </table>\n</md-table-container>\n</section> --><!-- <section class=\"restriction\" ng-if=\"$ctrl.basis.code\">\n\n    \n    <h4>Prestations</h4>\n  <div class=\"content\" >\n    <div class=\"flat-form\">\n      <div class=\"rate-input\" ng-repeat=\"am in $ctrl.amenitiesss3\" >\n        <md-switch ng-model=\"am.selected\" arial-label=\"product\">\n          <span class=\"occupancy\">{{::am.code}}</span>\n        </md-switch>\n\n        <input ng-model=\"am.price\" type=\"number\" min=\"0\" max=\"999999\" ng-disabled=\"!am.selected || $ctrl.paxMode\" placeholder=\"...\"/>\n      </div>\n    </div>\n  </div>\n</section> --><footer style=\"text-align: right;background-color: rgba(255, 152, 0, 0.25)\"><md-button ui-sref=^.rateBasisList>Annuler</md-button><!-- <md-button aria-label=\"More\" ng-click=\"$ctrl.save($ctrl.basis)\" ng-disabled=\"rateBasisForm.$invalid || rateBasisForm.$pristine\"> --><md-button aria-label=More ng-click=$ctrl.save($ctrl.basis)>Enregistrer</md-button></footer></form>");
$templateCache.put("app/rate-basis/edit-calendar/template.html","<md-dialog aria-label=\"Mod dispo\"><header layout=row style=\"padding: 16px\" layout-align=start-center><h2 class=md-subhead style=\"margin:0 16px 0 0\" flex>Modifier {{::$ctrl.title}}</h2><md-button class=md-icon-button ng-click=$ctrl.cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></header><md-dialog-content><periods-input model=$ctrl.periods value-callback=$ctrl.getPeriods></periods-input><form name=editForm><!-- min stay --><md-input-container ng-if=::$ctrl.editMinStay><label>Minimum stay</label><input type=number min=1 max=30 ng-model=$ctrl.minStay required></md-input-container><!-- Markup --><md-input-container ng-if=::$ctrl.editMarkup><label>Markup</label><input type=number min=0 ng-model=$ctrl.markup required></md-input-container><!-- Markup --><md-input-container style=\"padding-left: 30px\" ng-if=::$ctrl.editMarkupss ng-repeat=\"mark in $ctrl.rateBasis.markps track by $index\"><label style=\"padding-left: 40px\">{{::mark}}</label><input type=number min=0 ng-model=$ctrl.markupss[mark] required></md-input-container><!-- Cancellation --><cancellation-input ng-if=::$ctrl.editCancellation ng-model=$ctrl.rules currency=\"\'Devise\'\"></cancellation-input></form></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=$ctrl.cancel()>Annuler</md-button><span flex></span><md-button ng-click=$ctrl.applyChanges() ng-disabled=\"$ctrl.periods.length === 0 || editForm.$invalid\">Valider</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/rate-basis/edit-cancellation/template.html","<md-dialog aria-label=\"Mod dispo\"><header layout=row style=\"padding: 16px\" layout-align=start-center><h2 class=md-subhead style=\"margin:0 16px 0 0\" flex>Modifier les conditions d\'annulation</h2><md-button class=md-icon-button ng-click=$ctrl.cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></header><md-dialog-content><periods-input model=$ctrl.periods></periods-input><form name=minStayForm><md-input-container><label>Minimum stay</label><input type=number min=1 max=30 ng-model=$ctrl.minStay required></md-input-container></form></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=$ctrl.cancel()>Annuler</md-button><span flex></span><md-button ng-click=$ctrl.applyChanges() ng-disabled=\"$ctrl.periods.length === 0 || minStayForm.$invalid\">Valider</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/rate-basis/list/template.html","<div ng-if=\"$ctrl.rateBases.length === 0\"><p style=\"margin:16px auto; max-width:600px; padding:32px; background-color:rgba(0,0,0,0.1)\">Pas de base tarifaire définie pour l\'établissement {{::$ctrl.propertyCtrl.property.name}}<br><span>Cliquez sur le bouton<md-icon>add</md-icon>pour en créer une.</span></p></div><section class=rate-basis-card ng-repeat=\"basis in ::$ctrl.rateBases\"><header style=\"padding-right: 4px\"><h1>{{::basis.description}}</h1><!-- <md-menu>\n      <md-button class=\"md-icon-button md-primary md-raised\" ng-click=\"$mdMenu.open($event)\"><md-icon>menu</md-icon></md-button>\n      <md-menu-content width=\"2\">\n        <md-menu-item>\n          <md-button ng-href=\"{{::basis.links.view}}\">Detail et calendrier</md-button>\n        </md-menu-item>\n        <md-menu-item ng-if=\"::basis.permissions.edit\">\n          <md-button ng-href=\"{{::basis.links.edit}}\">Modifier</md-button>\n        </md-menu-item>\n        <md-menu-item ng-if=\"::basis.permissions.delete\">\n          <md-button ng-click=\"$ctrl.confirmDelete($event, basis)\" class=\"md-warn\">Supprimer</md-button>\n        </md-menu-item>    \n\n        </md-menu-item>\n      </md-menu-content>\n    </md-menu> --></header><section><div class=data-line><label>Type</label><span>{{::basis.type}} <strong ng-if=::basis.commission>{{::basis.commission}}%</strong></span></div><div class=data-line><label>Taxes</label><span ng-if=::basis.taxInc>Incluses</span> <span ng-if=\"::(basis.taxInc === false)\">Excluses</span></div><div class=data-line><label>Devise</label><span>{{::basis.currency}}</span></div></section><section><div class=data-line><label>Réservation</label><span>entre le <strong>{{basis.booking.period.start|date:\'d/MM/yyyy\'}}</strong> et <strong>{{basis.booking.period.end|date:\'d/MM/yyyy\'}}</strong></span></div><div class=data-line><label>Délais</label><span><strong>{{::basis.booking.advance | deadline}}</strong><br><small ng-show=::basis.booking.timeLimit>last minute {{::basis.booking.timeLimit | date:\"HH:mm\"}}</small></span></div></section><section><div class=data-line><label>Séjour</label><span>entre le <strong>{{basis.stay.period.start|date:\'d/MM/yyyy\'}}</strong> et <strong>{{basis.stay.period.end|date:\'d/MM/yyyy\'}}</strong></span></div><div class=data-line><label>Maximum stay</label><span>{{basis.stay.max}} nuits</span></div><div class=data-line><label>Minimum stay</label><a ui-sref=^.rateBasisView({basis:basis.code})>Afficher le calendrier<md-icon>event</md-icon></a></div></section><section><div class=data-line><label>Paiement client</label><span ng-if=\"::(basis.payOnArrival === false)\">Le client paye <strong>l\'agence</strong> </span><span ng-if=::basis.payOnArrival>Le client paye à l\'hotel</span></div><div class=data-line><label>Annulation</label><a ui-sref=^.rateBasisView({basis:basis.code})>Afficher le calendrier<md-icon>event</md-icon></a></div></section><section><div class=data-line><label>Marchés</label><span ng-repeat=\"c in ::basis.sales.countries\">{{::c}}&nbsp;</span> <span ng-if=!basis.sales.countries.length>Tous les pays</span></div><div class=data-line><label>Marchés non autorisés</label><span ng-repeat=\"cn in ::basis.stop.countries\">{{::cn}}&nbsp;</span> <span ng-repeat=\"cN in ::basis.stopCountries\">{{::cN}}&nbsp;</span></div><div class=data-line><label>Canaux</label><ul><li ng-repeat=\"(key,label) in ::basis.sales.segments\">{{::key}}</li><br><!-- <li ng-repeat=\"(key,label) in ::basis.sales.segments\">{{$ctrl.segments[::key].name}} </li><br>--><!--  <li  ng-repeat=\"(key,label) in ::basis.sales.segments\" >{{$ctrl.segments[::key].name}} </li><br>--><!-- <li>TO</li>\n        <li>Agence</li>\n        <li>Site Web</li> \n        <li>Application</li>\n        <li>CRS</li>\n        <li>Trip.com</li> \n        <li>Booking</li> \n        <li>Expedia</li> \n        <li>Trip.com</li>  --></ul></div></section><!--  <section>\n    <div class=\"data-line\">\n      <label>Prestations</label>\n      <ul >\n        <li ng-repeat=\"(key,label) in ::basis.prestations\" >{{::key}}</li>\n      </ul>\n    </div>\n  </section>--><section><footer style=\"text-align: right;background-color: rgba(0, 162, 255, 0.25)\" ng-if=$ctrl.permissionsContracting><md-button ng-click=\"$ctrl.confirmDelete($event, basis)\">Supprimer</md-button><md-button ng-href={{::basis.links.view}}>Detail</md-button><md-button class=md-accent ng-href={{::basis.links.edit}}>Modifier</md-button></footer></section></section>");
$templateCache.put("app/rate-basis/markets-input/template.html","<md-chips ng-model=selection md-autocomplete-snap md-require-match=true md-on-add=updateViewValue() md-on-remove=updateViewValue()><md-autocomplete md-selected-item=selectedItem md-search-text=countrySearch md-items=\"c in countries | filter: {name:countrySearch}\" md-item-text=c.name placeholder=pays><span md-highlight-text=searchText>{{c.name}}</span></md-autocomplete><md-chip-template>{{::$chip.name}}</md-chip-template></md-chips>");
$templateCache.put("app/rate-basis/view/template.html","<section class=info><header><span>Base tarifaire</span></header><div class=rate-basis-card><header><h1 flex>{{::$ctrl.basis.description}}</h1><md-button ng-if=::$ctrl.basis.permissions.edit ng-href={{::$ctrl.basis.links.edit.href}} class=\"md-raised md-accent\" style=margin-right:0>modifier<md-tooltip>Modifier les détail de la base tarifaire</md-tooltip></md-button></header><section><div class=data-line><label>Type</label><span>{{::$ctrl.basis.type}} <strong ng-if=::$ctrl.basis.commission>{{::$ctrl.basis.commission}}%</strong></span></div><div class=data-line><label>Taxes</label><span ng-if=::$ctrl.basis.taxInc>Incluses</span> <span ng-if=!$ctrl.basis.taxInc>Excluses</span></div><div class=data-line ng-if=::$ctrl.basis.commission><label>Paiement client</label><span ng-if=!$ctrl.basis.payOnArrival>Le client paye <strong>l\'agence</strong> </span><span ng-if=::$ctrl.basis.payOnArrival>Le client paye à l\'hotel</span></div><div class=data-line><label>Devise</label><span>{{::$ctrl.basis.currency}}</span></div></section><section><h4>Réservation</h4><div class=data-line><label>Période</label><span>entre le <strong>{{::$ctrl.basis.booking.period.start|date:\'d/MM/yyyy\'}}</strong> et <strong>{{::$ctrl.basis.booking.period.end|date:\'d/MM/yyyy\'}}</strong></span></div><div class=data-line><label>Délais</label><span><strong>{{::$ctrl.basis.booking.advance | deadline}}</strong><br><small ng-show=::$ctrl.basis.booking.timeLimit>last minute {{::$ctrl.basis.booking.timeLimit | date:\"HH:mm\"}}</small></span></div></section><section><h4>Séjour</h4><div class=data-line><label>Période</label><span>entre le <strong>{{::$ctrl.basis.stay.period.start|date:\'d/MM/yyyy\'}}</strong> et <strong>{{::$ctrl.basis.stay.period.end|date:\'d/MM/yyyy\'}}</strong></span></div><div class=data-line><label>Maximum stay</label><span>{{::$ctrl.basis.stay.max}} nuits</span></div></section><section><h4>Marché</h4><div class=data-line ng-if=::$ctrl.basis.sales.countries.length><label>Géographique</label><div><abbr ng-repeat=\"c in ::$ctrl.basis.sales.countries\" style=text-transform:uppercase>{{::c}}</abbr></div></div><div class=data-line><label>Canaux</label><ul><li ng-repeat=\"(key,label) in ::$ctrl.basis.sales.segments\">{{::key}}</li><!-- <li ng-repeat=\"(key,label) in ::$ctrl.basis.sales.segments\">{{$ctrl.segments[key].name}} </li>--><!-- <li>Réseaux atlas</li>\n          <li>Agence</li>\n          <li>Onliner</li> --></ul></div></section></div></section><section class=calendars><header>Calendrier minimum stay et annulation</header><div class=md-whiteframe-z1><header layout=row layout-align=\"start center\"><h4 flex class=legend style=\"padding: 16px;color: #737373\">Minimum stay</h4><md-button ng-click=$ctrl.editMinStay($event) class=\"md-raised md-accent\" aria-label=Modifier style=margin-right:0>Modifier<md-tooltip>Modifier le minimum stay</md-tooltip></md-button></header><nvd3 ng-if=::$ctrl.minStay.data options=::$ctrl.minStay.options data=$ctrl.minStay.data></nvd3><!--\n    <div class=\"md-whiteframe-z1\"> --><header layout=row layout-align=\"start center\"><h4 flex class=legend style=\"padding: 16px;color: #737373\">Markup</h4><md-button ng-click=$ctrl.editMarkup($event) class=\"md-raised md-accent\" aria-label=Modifier style=margin-right:0>Modifier<md-tooltip>Modifier le Markup</md-tooltip></md-button></header><nvd3 ng-if=::$ctrl.markup.data options=::$ctrl.markup.options data=$ctrl.markup.data></nvd3><!--\n      <header layout=\"row\" layout-align=\"start center\">\n        <h4 flex class=\"legend\" style=\"padding: 16px;color: #737373;\">Markups</h4>\n        <md-button ng-click=\"$ctrl.editMarkupss($event)\" class=\"md-raised md-accent\" aria-label=\"Modifier\"\n          style=\"margin-right:0\">\n          Modifier\n          <md-tooltip>Modifier le Markupss</md-tooltip>\n\n        </md-button>\n\n      </header>\n\n\n      <nvd3 ng-if=\"::$ctrl.markups.datas\" options=\"::$ctrl.markups.options\" data =\"$ctrl.markups.datas\"></nvd3>\n\n     --><md-divider></md-divider><header layout=row layout-align=\"start center\" style=\"background-color: #fafafa\"><h4 flex class=legend style=\"padding: 16px;\n    color: #737373\">Conditions d\'annulation</h4><md-button ng-click=$ctrl.editCancellation($event) class=\"md-raised md-accent\" aria-label=Modifier style=margin-right:0>Modifier<md-tooltip>Modifier le conditions d\'annulation</md-tooltip></md-button></header><div style=overflow-y:scroll><timelanes ng-if=$ctrl.cancellation.data config=::$ctrl.cancellation.options data=$ctrl.cancellation.data></timelanes></div></div></section>");
$templateCache.put("app/reports/calendar-chart/template.html","<h4>Disponibilité</h4><nvd3 options=::$ctrl.nights.options data=$ctrl.nights.data></nvd3><h4>Revenu</h4><nvd3 options=::$ctrl.revenue.options data=$ctrl.revenue.data></nvd3><h4>Evenements</h4><nvd3 options=::$ctrl.events.options data=$ctrl.events.data></nvd3>");
$templateCache.put("app/reports/calendar-chart-prop-dispo/template.html","<h4>Disponibilité</h4><nvd3 options=::$ctrl.nights.options data=$ctrl.nights.data></nvd3>");
$templateCache.put("app/reports/container/template.html","<md-nav-bar style=\"margin-top: 8px;flex:1\" md-selected-nav-item=currentState nav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-sref=reports.offer name=reports.offer>Offre</md-nav-item><md-nav-item md-nav-sref=reports.discrepancies name=reports.discrepancies>Anomalies</md-nav-item><md-nav-item md-nav-sref=reports.monthly name=reports.monthly>Situation</md-nav-item><md-nav-item md-nav-sref=reports.monthlyProperties name=reports.monthlyProperties>Situation des Etablissements</md-nav-item></md-nav-bar><ui-view style=\"flex: 100%;overflow-y:scroll\"></ui-view>");
$templateCache.put("app/reports/discrepancies/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><h3>{{::$ctrl.report.length}} établissements ayant des informations manquantes</h3><div class=search-text flex><md-icon>search</md-icon><input style=width:100% type=text ng-model=$ctrl.search placeholder=Filtrer...></div></div></md-toolbar><md-table-container><table md-table><tbody md-body><tr md-row ng-repeat=\"r in $ctrl.report | filter: $ctrl.search | orderBy: $ctrl.query.order | limitTo: $ctrl.query.limit : ($ctrl.query.page -1) * $ctrl.query.limit\"><td md-cell class=property style=cursor:pointer ng-click=\"r.details = !r.details\"><header><span class=md-caption ng-bind=::r.property.name></span></header><ul ng-show=\"r.details === true\"><li ng-if=\"::(r.noBasis  === true)\"><md-icon style=color:#F44336>error</md-icon><a href=#/properties/{{::r.property.code}}/rate-bases>Base tarifaire</a> manquantes</li><li ng-if=\"::(r.noUnits  === true)\"><md-icon style=color:#F44336>error</md-icon>Unités manquantes</li><li ng-repeat=\"u in ::r.units_noAllotements\"><md-icon style=color:#F44336>error</md-icon><span>pas d\'allotement pour la catégorie <span><a href=#/properties/{{::r.property.code}}/allotments/{{::u.code}} ng-bind=::u.name></a></span></span></li><li ng-if=\"::(r.noDesc  === true)\"><md-icon style=color:#F44336>error</md-icon><a href=#/properties/{{::r.property.code}}/description>Descriptif</a> manquant</li></ul></td></tr></tbody></table></md-table-container><md-table-pagination ng-hide=\"$ctrl.search.length > 0\" md-limit=$ctrl.query.limit md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{::$ctrl.count}} md-page-select=$ctrl.options.pageSelect md-boundary-links=$ctrl.options.boundaryLinks></md-table-pagination></md-card>");
$templateCache.put("app/reports/monthly/monthlyProp.html","<md-toolbar class=\"md-table-toolbar md-default\"><!-- <form style=\"padding:0 16px; background-color: aliceblue\" name=\"propertyFiltersForm\" \n    layout=\"row\">\n    <span flex></span>\n\n\n\n\n\n  </form> --><div class=md-toolbar-tools layout-align=\"space-between center\" style=\"background-color: aliceblue\"><h2>Situation (toutes les établissements)</h2><!-- <md-checkbox  ng-model=\"$ctrl.hasAvail0\" ng-change=\"$ctrl.hasAvail0Status($ctrl.hasAvail0)\"> \n        </md-checkbox> --><label><input type=radio ng-model=$ctrl.type value=all selected> Toutes</label><label><input type=radio ng-model=$ctrl.type value=avail0> Pas de dispo</label></div></md-toolbar><div><md-button class=md-icon-button ng-click=$ctrl.previousMonth() ng-disabled=!$ctrl.hasPrevious><md-icon>chevron_left</md-icon></md-button><span>{{$ctrl.period.from | date:\'MMMM yyyy\'}}</span><md-button class=md-icon-button ng-click=$ctrl.nextMonth() ng-disabled=!$ctrl.hasNext><md-icon>chevron_right</md-icon></md-button></div><md-card><h2 style=text-align:center class=md-title>Répartition par destination</h2><section><div><div id=avail-nights-pie style=\"display: flex;  justify-content: center\"></div></div></section></md-card><md-card ng-if=\"$ctrl.type==\'all\'\" ng-repeat=\"p in $ctrl.properties\"><h2 style=\"margin-left: 15px\">{{p.name}}</h2><a href=#/properties/{{::p.code}}/calendars/room/table>Mode Tableau</a><calendar-charts report-period=$ctrl.period report-data=p.statFinal.calendar></calendar-charts><h4 ng-if=p.stopsaless.length style=\"margin-left: 16px;  margin-bottom: 0\">Stop Sales</h4><md-table-container ng-if=p.stopsaless.length><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-on-reorder=$ctrl.loadstopsales><tr md-row><th md-column><span>Nom</span></th><th md-column><span>Type</span></th><th md-column><span>Nom de Type </span></th><th md-column><span>Date de debut</span></th><th md-column><span>Date de fin</span></th><!-- <th md-column ><span>Action</span></th> --></tr></thead><tbody md-body><tr md-row ng-repeat=\"s in p.stopsaless\"><td md-cell>{{::s.description}}</td><td md-cell>{{::s.type}}</td><td md-cell ng-if=\"s.type == \'Hotel\'\">{{::s.type}}</td><td md-cell ng-if=\"s.type == \'Base Tarifaire\'\">{{$ctrl.rateBases[s.typeCode].description}}</td><td md-cell ng-if=\"s.type == \'Unit\'\">{{$ctrl.units[s.typeCode].name}}</td><td md-cell>{{::s.debut}}</td><td md-cell>{{::s.fin}}</td></tr></tbody></table></md-table-container></md-card><md-card g-if=\"$ctrl.type==\'avail0\'\" ng-repeat=\"pa in $ctrl.propertiesHasAvail0\"><h2 style=\"margin-left: 15px\">{{pa.name}}</h2><calendar-charts report-period=$ctrl.period report-data=pa.statFinal.calendar></calendar-charts></md-card><md-card><md-table-pagination md-limit-options=[20,50,100,200] md-limit=$ctrl.query.limit md-page=$ctrl.query.page md-total={{$ctrl.total}} md-on-paginate=$ctrl.load></md-table-pagination></md-card>");
$templateCache.put("app/reports/monthly/template.html","<md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools layout-align=\"space-between center\" style=\"background-color: aliceblue\"><h2>Situation (toutes destinations)</h2><div><md-button class=md-icon-button ng-click=$ctrl.previousMonth() ng-disabled=!$ctrl.hasPrevious><md-icon>chevron_left</md-icon></md-button><span>{{$ctrl.period.from | date:\'MMMM yyyy\'}}</span><md-button class=md-icon-button ng-click=$ctrl.nextMonth() ng-disabled=!$ctrl.hasNext><md-icon>chevron_right</md-icon></md-button></div></div></md-toolbar><overall-report bookings=$ctrl.bookings cancellations=$ctrl.cancellations confirmed-checkins=$ctrl.confirmedCheckins canceled-checkins=$ctrl.canceledCheckins></overall-report><md-card><calendar-chart report-period=$ctrl.period report-data=$ctrl.calendar></calendar-chart></md-card><h2 style=text-align:center class=md-title>Répartition par destination</h2><md-card><section class=pies><div class=bookings-pies><h4 style=flex:100%;text-align:center>Réservations</h4><div class=pie id=bookings-pie></div><div class=pie id=bookings-revenue-pie></div><div class=pie id=bookings-nights-pie></div></div><div class=checkins-pies><h4 style=flex:100%;text-align:center>Sejours</h4><div class=pie id=checkins-pie></div><div class=pie id=checkins-revenue-pie></div><div class=pie id=checkins-nights-pie></div></div></section></md-card>");
$templateCache.put("app/reports/monthly-properties/template.html","<md-toolbar class=\"md-table-toolbar md-default\"><!-- <form style=\"padding:0 16px; background-color: aliceblue\" name=\"propertyFiltersForm\" \n    layout=\"row\">\n    <span flex></span>\n\n\n\n\n\n  </form> --><div class=md-toolbar-tools layout-align=\"space-between center\" style=\"background-color: aliceblue\"><h2>Situation (toutes les établissements)</h2><div><md-button class=md-icon-button ng-click=$ctrl.previousMonth() ng-disabled=!$ctrl.hasPrevious><md-icon>chevron_left</md-icon></md-button><span>{{$ctrl.period.from | date:\'MMMM yyyy\'}}</span><md-button class=md-icon-button ng-click=$ctrl.nextMonth() ng-disabled=!$ctrl.hasNext><md-icon>chevron_right</md-icon></md-button></div></div></md-toolbar><md-card ng-repeat=\"p in $ctrl.properties\"><h2 style=\"margin-left: 15px\">{{p.name}}</h2><calendar-chart report-period=$ctrl.period report-data=p.statFinal.calendar></calendar-chart><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-on-reorder=$ctrl.loadstopsales><tr md-row><th md-column><span>Nom</span></th><th md-column><span>Type</span></th><th md-column><span>Nom de Type </span></th><th md-column><span>Date de debut</span></th><th md-column><span>Date de fin</span></th><!-- <th md-column ><span>Action</span></th> --></tr></thead><tbody md-body><tr md-row ng-repeat=\"s in p.stpsales.items\"><td md-cell>{{::s.description}}</td><td md-cell>{{::s.type}}</td><td md-cell ng-if=\"s.type == \'Hotel\'\">{{::s.type}}</td><td md-cell ng-if=\"s.type == \'Base Tarifaire\'\">{{$ctrl.rateBases[s.typeCode].description}}</td><td md-cell ng-if=\"s.type == \'Unit\'\">{{$ctrl.units[s.typeCode].name}}</td><td md-cell>{{::s.debut}}</td><td md-cell>{{::s.fin}}</td></tr></tbody></table></md-table-container></md-card><md-card><md-table-pagination md-limit-options=[20,50,100] md-limit=$ctrl.query.limit md-page=$ctrl.query.page md-total={{$ctrl.total}} md-on-paginate=$ctrl.load></md-table-pagination></md-card>");
$templateCache.put("app/reports/offer/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><h3>Offre globale</h3><div class=search-text flex><md-icon>search</md-icon><input style=width:100% type=text ng-model=$ctrl.search placeholder=Filtrer...></div></div></md-toolbar><!-- exact table from live demo --><md-table-container><table md-table md-progress=$ctrl.loadingPromise md-order=$ctrl.order><thead md-head md-order=$ctrl.order><tr md-row><th md-column><span>Destination</span></th><th md-column md-numeric md-order-by=properties><span>Etablissements</span></th><th md-column md-numeric md-order-by=units><span>Cat. unités</span></th><th md-column md-order-by=rates style=\"padding: 0 40px 0 16px;\n    text-align: center\"><span>Tarifs</span></th><th md-column md-order-by=allotments style=\"padding: 0 40px 0 16px;\n  text-align: center\"><span>Allotements</span></th><th md-column md-numeric md-order-by=products><span>Produits</span></th><th md-column style=\"padding: 0 40px 0 16px;\n    text-align: center\"><span>Pensions</span></th><th md-column><span>Occupations</span></th></tr></thead><tbody md-body><tr md-row style=\"background: aliceblue\"><td md-cell>TOTAL</td><td md-cell ng-bind=::$ctrl.totals.properties></td><td md-cell ng-bind=::$ctrl.totals.units></td><td md-cell class=inline-table><div class=item><strong>Com</strong><span ng-bind=::$ctrl.totals.rates_com></span></div><div class=item><strong>Net</strong><span ng-bind=::$ctrl.totals.rates_net></span></div><div class=item><strong>TOTAL</strong><span ng-bind=::$ctrl.totals.rates></span></div></td><td md-cell class=inline-table><div class=item><strong>guaranti</strong><span ng-bind=::$ctrl.totals.allotments_contracted></span></div><div class=item><strong>flex</strong><span ng-bind=::$ctrl.totals.allotments_flex></span></div><div class=item><strong>TOTAL</strong><span ng-bind=::$ctrl.totals.allotments></span></div></td><td md-cell ng-bind=::$ctrl.totals.products></td><td md-cell></td><td md-cell></td></tr><tr md-row ng-repeat=\"r in $ctrl.report | filter: $ctrl.search | orderBy: $ctrl.query.order | limitTo: $ctrl.query.limit : ($ctrl.query.page -1) * $ctrl.query.limit\"><td md-cell ng-bind=::r.destination.name></td><td md-cell ng-bind=::r.properties></td><td md-cell ng-bind=::r.units></td><td md-cell class=inline-table><div class=item><strong>Com.</strong><span ng-bind=::r.rates_com></span></div><div class=item><strong>Net</strong><span ng-bind=::r.rates_net></span></div><div class=\"item total\"><strong>TOTAL</strong><span ng-bind=::r.rates></span></div></td><td md-cell class=inline-table><div class=item><strong>guarantie</strong><span ng-bind=::r.allotments_flex></span></div><div class=item><strong>flex</strong><span ng-bind=::r.allotments_contracted></span></div><div class=\"item total\"><strong>TOTAL</strong><span ng-bind=::r.allotments></span></div></td><td md-cell ng-bind=::r.products></td><td md-cell class=inline-table><div class=item ng-repeat=\"b in ::r.boards\" style=display:flex><strong>{{::$ctrl.boards[b[0]]}}</strong> <span>{{::b[1]}}</span></div></td><td md-cell class=\"inline-table grid\"><div class=item ng-repeat=\"o in ::r.occupancies\" style=display:flex><strong>{{::o[0]|occupancy}}</strong> <span>{{::o[1]}}</span></div></td></tr></tbody></table></md-table-container><md-table-pagination ng-hide=\"$ctrl.search.length > 0\" md-limit=$ctrl.query.limit md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{::$ctrl.count}} md-page-select=$ctrl.options.pageSelect md-boundary-links=true></md-table-pagination></md-card>");
$templateCache.put("app/reports/overall/template.html","<div class=wrapper ng-class=\"{\'single-mode\': $ctrl.singleMode}\"><div class=highlights ng-show=$ctrl.byBookingDate><header>Réservations</header><div class=\"zoom bk\"><span>{{$ctrl.bookings.stays}}</span> <small>Réservations</small></div><div class=\"zoom bk\" ng-class=\"{na:$ctrl.bookings.stays === 0}\"><span>{{$ctrl.bookings.nights}}</span> <small>Nuits</small></div><!-- <div class=\"zoom revenue bk\">\n      <small>Nuitées</small>\n      <span>{{$ctrl.bookings.nightsPax}}\n      </span>\n    </div> --><div class=\"zoom bk\" ng-class=\"{na:$ctrl.bookings.stays === 0}\"><span>±{{$ctrl.bookings.avgStay|number:0}}</span> <small>Nuit/Séj.</small></div><div class=\"zoom top bk\" ng-class=\"{na:$ctrl.bookings.stays === 0}\"><small>Arrivées</small> <span style=\"font-size: 1.6em\">&asymp; j+{{$ctrl.bookings.tta | number:0}}</span></div><div class=\"zoom bk\" ng-class=\"{na:$ctrl.bookings.stays === 0}\"><span>{{$ctrl.bookings.guests}}</span> <small>pax</small></div><div class=\"zoom ca\"><span>{{$ctrl.cancellations.stays}}</span> <small>Annulations</small></div><div class=\"zoom ca\" ng-class=\"{na:$ctrl.cancellations.stays === 0}\"><span>{{$ctrl.cancellations.rate}}%</span> <small>Annul.</small></div><div class=\"zoom top ca\" ng-class=\"{na:$ctrl.cancellations.stays === 0}\"><small>Annulés à</small> <span style=\"font-size: 1.6em\">&asymp; j-{{$ctrl.cancellations.tta}}</span></div><div class=\"zoom revenue bk\"><small>Revenu</small> <span>{{$ctrl.bookings.revenue | number}}<!-- <small>MAD</small> --></span></div></div><div class=highlights ng-show=$ctrl.byCheckinDate><header>Séjours</header><div class=\"zoom ci\"><span>{{$ctrl.confirmedCheckins.stays}}</span> <small>Chambres</small></div><div class=\"zoom ci\" ng-class=\"{na:$ctrl.confirmedCheckins.stays === 0}\"><span>{{$ctrl.confirmedCheckins.nights}}</span> <small>Nuits</small></div><!-- <div class=\"zoom ci\" ng-class=\"{na:$ctrl.confirmedCheckins.stays === 0}\">\n      <span>{{$ctrl.confirmedCheckins.nightsPax}}</span>\n      <small>NuitéesPax</small>\n    </div> --><div class=\"zoom revenue ci\"><small>Nuitées</small> <span>{{$ctrl.confirmedCheckins.nightsPax |number:0}}<!-- <small>MAD</small> --></span></div><div class=\"zoom ci\" ng-class=\"{na:$ctrl.confirmedCheckins.stays === 0}\"><span>±{{$ctrl.confirmedCheckins.avgStay |number:0}}</span> <small>Nuit/Séj.</small></div><div class=\"zoom top ci\" ng-class=\"{na:$ctrl.confirmedCheckins.stays === 0}\"><small>Réservé à</small> <span style=\"font-size: 1.6em\">&asymp; j-{{$ctrl.confirmedCheckins.tta|number:0}}</span></div><div class=\"zoom ci\" ng-class=\"{na:$ctrl.confirmedCheckins.stays === 0}\"><span>{{$ctrl.confirmedCheckins.guests}}</span> <small>Pax</small></div><div class=\"zoom ca\"><span>{{$ctrl.canceledCheckins.stays}}</span> <small>Annulés</small></div><div class=\"zoom ca\" ng-class=\"{na:$ctrl.canceledCheckins.stays === 0}\"><span>{{$ctrl.canceledCheckins.rate}}%</span> <small>Annul.</small></div><div class=\"zoom top ca\" ng-class=\"{na:$ctrl.canceledCheckins.stays === 0}\"><small>Annulés à</small> <span style=\"font-size: 1.6em\">&asymp; j- {{$ctrl.canceledCheckins.tta}}</span></div><div class=\"zoom revenue ci\"><small>Valeur</small> <span>{{$ctrl.confirmedCheckins.revenue | number}}<!-- <small>MAD</small> --></span></div></div></div>");
$templateCache.put("app/requests/list/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Demandes de réservation (on request)</span><form name=propertyFilterForm flex style=\"margin-left: 16px\" layout=row><label for=booking-search-input><md-icon class=material-icons>search</md-icon></label><input id=booking-search-input style=\"width: 100%;margin: 0 0 0 16px;font-size:14px;padding:4px;border: none;color: rgba(0, 0, 0, 0.87)\" type=text ng-model=$ctrl.query.customer ng-model-options=$ctrl.customerFilterOptions placeholder=\"rechercher (nom ou numéro)\"><md-button ng-class=\"{\'md-raised\':$ctrl.filter}\" ng-click=\"$ctrl.filter = !$ctrl.filter\"><md-icon class=material-icons>filter_list</md-icon>filtrer</md-button></form></div></md-toolbar><form style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 16px;\ndisplay: flex;\n    align-items: flex-start\" name=bookingsFilterForm ng-show=$ctrl.filter><span class=md-subhead style=\"margin: 25px 16px 0 8px\">Filtrer</span><md-input-container style=margin-left:16px><label>Date demande</label><md-datepicker ng-model=$ctrl.query.createdOn name=bookingDate></md-datepicker></md-input-container><md-input-container style=margin-left:16px><label>Check-in</label><md-datepicker ng-model=$ctrl.query.checkin name=bookingDate></md-datepicker></md-input-container><md-input-container style=margin-left:16px><label>Etablissement</label><input type=text ng-model=$ctrl.query.propertyName name=bookingPropertyName></md-input-container></form><!-- exact table from live demo --><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.loadBookings><tr md-row><th md-column><span>Numéro</span></th><th md-column><span>Etablissement</span></th><th md-column><span>Client</span></th><th md-column md-order-by=createdOn><span>Date de réservation</span></th><th md-column md-order-by=checkin><span>Check in</span></th><th md-column md-numeric>Nombre de nuits</th><th md-column><span>Chambre</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"b in $ctrl.items\" ng-click=$ctrl.showBooking(b)><td md-cell>{{::b.number}}</td><td md-cell>{{::b.property.name}}</td><td md-cell>{{::b.items[0].guests[0].firstName}} {{::b.items[0].guests[0].lastName}}</td><td md-cell>{{::b.audit.createdOn | date:\'short\'}}</td><td md-cell>{{::b.items[0].checkin | date}}</td><td md-cell>{{::b.items[0].nights}} nuits</td><td md-cell><ul style=font-size:0.925em><li ng-repeat=\"i in b.items\">{{::i.product.unit.type}} {{::i.product.unit.name}}<br></li></ul></td></tr></tbody></table></md-table-container><md-table-pagination md-boundary-links=true md-limit=$ctrl.query.limit md- md-page=$ctrl.query.page md-total={{$ctrl.total}} md-on-paginate=$ctrl.loadBookings></md-table-pagination></md-card>");
$templateCache.put("app/requests/property-list/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Demandes de réservation (on request)</span><form name=propertyFilterForm flex style=\"margin-left: 16px\" layout=row><label for=booking-search-input><md-icon class=material-icons>search</md-icon></label><input id=booking-search-input style=\"width: 100%;\n    margin: 0 0 0 16px;\n    font-size:14px;\n    padding:4px;\n    border: none;\n    color: rgba(0, 0, 0, 0.87)\" type=text ng-model=$ctrl.query.customer ng-model-options=$ctrl.customerFilterOptions placeholder=\"rechercher (nom ou numéro)\"></form></div></md-toolbar><!-- exact table from live demo --><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.loadBookings><tr md-row><th md-column><span>Etat</span></th><th md-column><span>Numéro</span></th><th md-column><span>Client</span></th><th md-column md-order-by=createdOn><span>Date de demande</span></th><th md-column md-order-by=checkin><span>Check in</span></th><th md-column md-numeric>Nuités</th><th md-column><span>Chambres</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"b in $ctrl.items\" ng-click=$ctrl.showBooking(b)><td md-cell style=\"font-weight: 500\" ng-class=\"{pending:b.status === 8}\"><md-icon class=status style=color:{{::$ctrl.statusUI[b.status].color}}>{{::$ctrl.statusUI[b.status].icon}}</md-icon>{{::$ctrl.statusUI[b.status].label}}</td><td md-cell>{{::b.number}}</td><td md-cell>{{::b.items[0].guests[0].firstName}} {{::b.items[0].guests[0].lastName}}</td><td md-cell>{{::b.audit.createdOn | date:\'short\'}}</td><td md-cell>{{::b.items[0].checkin | date}}</td><td md-cell>{{::b.items[0].nights}} nuits</td><td md-cell><ol style=\"list-style: none;padding:0\"><li ng-repeat=\"i in b.items\">{{::i.product.unit.type}} {{::i.product.unit.name}}<br></li></ol></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=$ctrl.query.limit md-page=$ctrl.query.page md-total={{$ctrl.total}} md-on-paginate=$ctrl.loadBookings></md-table-pagination></md-card>");
$templateCache.put("app/requests/view/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools layout-align=\"space-between center\" style=\"background-color: aliceblue\"><div><span class=booking-ref>Demande de Réservation réf: {{$ctrl.booking.number}}</span> <strong class=status style=color:{{::$ctrl.statusUI[$ctrl.booking.status].color}}><md-icon class=status style=color:{{::$ctrl.statusUI[$ctrl.booking.status].color}}>{{::$ctrl.statusUI[$ctrl.booking.status].icon}}</md-icon>{{::$ctrl.statusUI[$ctrl.booking.status].label}} </strong></div><div style=font-size:0.7em><small style=\"font-weight: 500;\n      color: #757575\">Date de la demande</small><br>{{$ctrl.booking.audit.createdOn | date:\'medium\'}}</div><!-- ng-if $ctrl.booking.cc --></div></md-toolbar><!-- exact table from live demo --><md-table-container style=margin-bottom:16px><table md-table><thead md-head><tr md-row><th md-column><span>Clients</span></th><th md-column><span>Séjour</span></th><th md-column><span>Chambre</span></th><th md-column><span>Promotion</span></th><th md-column md-numeric><span>Commission</span></th><th md-column md-numeric><span>Total</span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"i in $ctrl.booking.items\" ng-click=$ctrl.showBooking(b)><td md-cell><ul class=guests><li ng-repeat=\"g in i.guests\">{{::g.firstName}} {{::g.lastName}} <small ng-if=::g.birthdate>né le {{::g.birthdate | date}}</small></li></ul></td><td md-cell><time>{{::i.checkin | date:\'dd/MM/yyyy\'}}</time><br><span>{{::i.nights}} nuits</span></td><td md-cell><div style=\"font-weight: 500\">{{::i.product.unit.type}} {{i.product.unit.name}}</div><div style=\"font-size: 12px\">{{i.product.occupancy|occupancy}} -<md-icon class=board>restaurant</md-icon>{{::$ctrl.boards[i.product.board].name}}</div><div style=\"font-size: 12px\">Tarif {{::i.product.basis.description}}</div><div ng-show=i.product.payOnArrival>Paiement à l\'hotel</div><strong style=\"font-size: 12px;color: grey\">Conditions d\'annulation</strong><ul class=cancellation-rules><li ng-repeat=\"r in i.cancellation\"><strong>A partir du {{r.from | date:\'dd/MM/yyyy\'}}</strong><br>{{r.charge}} {{::$ctrl.currency}} retenu</li></ul></td><td md-cell>{{::i.discount || \'N/A\'}}<br></td><td md-cell>{{::(i.product.commission*i.totals.total/100) | number}} <sup>{{::$ctrl.currency}}</sup><br><small>({{::(i.product.commission) | number:2}}%)</small></td><td md-cell>{{::i.totals.total | number:2}} <sup>{{::$ctrl.currency}}</sup></td></tr><tr><td class=\"md-cell md-numeric\" colspan=6 style=\"text-align:right;font-size: 1.2em;font-weight: 500\">{{::$ctrl.booking.totals.total | number:2}} <sup>{{::$ctrl.currency}}</sup></td></tr></tbody></table></md-table-container><footer style=\"text-align:center;background: aliceblue\" ng-if=\"($ctrl.booking.status === $ctrl.STATUS.REQUESTED)\"><md-button class=\"md-raised md-primary\" ng-click=$ctrl.acceptRequest()>Accepter</md-button><md-button class=md-warn ng-click=$ctrl.rejectRequest()>Rejeter</md-button></footer></md-card>");
$templateCache.put("app/seasons/list/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Saisons</span></div></md-toolbar><form name=seasonsForm style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 16px;\n  display: flex; align-items: flex-start\"><md-input-container flex-gt-sm><label>Description</label><input type=text ng-model=season.description required><!-- md-min-date=\"$ctrl.options.minEndDate\" --></md-input-container><md-input-container flex-gt-sm style=\"margin-left: 50px\"><label>Saison</label><md-select placeholder=Saison ng-change=\"\" ng-model=season.season required><md-option ng-value=\"\'Peak\'\">Peak Season</md-option><md-option ng-value=\"\'High\'\">High Season</md-option><md-option ng-value=\"\'Mid\'\">Mid-Season</md-option><md-option ng-value=\"\'Low\'\">Low Season</md-option></md-select><!-- md-min-date=\"$ctrl.options.minEndDate\" --></md-input-container><md-table-container style=\"margin-left: 50px\"><table md-table><thead md-head><tr md-row style=height:49px><th md-column>Du</th><th md-column>Au</th></tr><tr md-row ng-repeat=\"range in season.ranges track by $index\"><td md-cell>{{ range.start}}</td><td md-cell>{{range.end}}</td><td md-cell><md-button class=md-icon-button ng-click=$ctrl.removeSeasonsPeriodRange(season,$index)><md-icon>delete</md-icon></md-button></td></tr></thead><tbody md-body><tr md-row><td md-cell><md-input-container class=md-block flex-gt-sm><label>Du</label><md-datepicker md-current-view=year ng-model=$ctrl.seasonRng.start md-placeholder=jj/mm/aaaa></md-datepicker></md-input-container></td><td md-cell><md-input-container flex-gt-sm><label>Au</label><!-- md-min-date=\"$ctrl.options.minEndDate\" --><md-datepicker md-current-view=year ng-model=$ctrl.seasonRng.end md-placeholder=jj/mm/aaaa></md-datepicker></md-input-container></td><td md-cell><md-button class=md-icon-button ng-click=$ctrl.addSeasonPeriodRange(season)><md-icon>add</md-icon></md-button></td></tr></tbody></table></md-table-container><!--  <md-input-container  class=\"md-block\" flex=\"20\" required>\n    <label>description</label>\n    <input  type=\"text\"  ng-model=\"seasons.description\" required />\n  </md-input-container>\n    <md-input-container style=\"margin-left:16px\">\n         <label>Saisons</label>\n         <md-select placeholder=\"Saison\" ng-change= \"\" ng-model=\"seasons.category\" style=\"min-width: 150px;\" >  \n          <md-option ng-value=\"\'High\'\"> High Season </md-option>\n                    <md-option ng-value=\"\'Mid\'\"> Mid-Season </md-option>\n                    <md-option ng-value=\"\'Low\'\"> Low Season </md-option>\n         \n        </md-select>      \n        </md-input-container>\n      \n        \n        <md-input-container style=\"margin-left:16px\">\n\n          <div class=\"field-inline\" >\n            <label>Du</label>\n            <md-datepicker md-current-view=\"year\" ng-model=\"seasons.debut\"  md-min-date=\"$ctrl.minDate\" md-placeholder=\"jj/mm/aaaa\" required ></md-datepicker>\n          </div>\n        </div>\n      </md-input-container>\n        <md-input-container style=\"margin-left:16px\">\n\n        <div class=\"field-inline\" >\n          <label>Au</label>\n          <md-datepicker  md-current-view=\"year\" ng-model=\"seasons.fin\" md-min-date=\"seasons.debut\" md-placeholder=\"jj/mm/aaaa\" required></md-datepicker>\n        </div>\n      </div>--><md-dialog-actions ng-if=\" $ctrl.permissionsContracting\"><md-button class=\"md-raised md-accent md-button md-ink-ripple\" ng-click=$ctrl.createSeasons(season) ng-disabled=\"seasonsForm.$pristine || seasonsForm.$invalid\">Ajouter</md-button></md-dialog-actions></form><!-- exact table from live demo --><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-on-reorder=$ctrl.loadonrequests><tr md-row><th md-column><span>Description</span></th><th md-column><span>Saisons</span></th><th md-column><span>Dates</span></th><th md-column><span>Action</span></th><!-- <th md-column ><span>Action</span></th> --></tr></thead><tbody md-body><tr md-row ng-repeat=\"s in $ctrl.seasons.items\"><td md-cell>{{::s.description}}</td><td md-cell ng-if=\"s.category == \'High\'\">High Season</td><td md-cell ng-if=\"s.category == \'Mid\'\">Mid-Season</td><td md-cell ng-if=\"s.category == \'Low\'\">Low Season</td><td md-cell ng-if=\"s.category == \'Peak\'\">Peak Season</td><!-- <td md-cell ng-if=\"r.type == \'Unit\'\">{{r.typeCode}}</td> --><!-- <td md-cell ng-if=\"r.type == \'Unit\'\">{{$ctrl.units}}</td> --><!-- <td md-cell ng-repeat=\"r in s.ranges\">{{::r.from}}  to  {{::r.to}} </td>--><td><ul ng-repeat=\"r in s.ranges\"><li>{{::r.start}} to {{::r.end}}</li></ul></td><td md-cell><!-- <md-button class=\"md-icon-button\" ng-click=\"$ctrl.edit($event,s)\"><md-icon>edit</md-icon>\n              <md-tooltip>Modifier</md-tooltip>\n            </md-button> --><md-button ng-if=\" $ctrl.permissionsContracting\" class=\"md-icon-button md-warn\" aria-label=Settings ng-click=$ctrl.remove($event,s)><md-icon>delete</md-icon></md-button></td></tr></tbody></table></md-table-container><!-- <md-table-pagination md-boundary-links=\"true\" md-limit=\"$ctrl.query.limit\" md- md-page=\"$ctrl.query.page\" md-total=\"{{$ctrl.total}}\" md-on-paginate=\"$ctrl.loadBookings\"></md-table-pagination> --><div></div></md-card>");
$templateCache.put("app/stop-sales/list/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Stop Sales</span></div></md-toolbar><form name=stopSalesForm style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 16px;\n  display: flex; align-items: flex-start\"><!-- <span class=\"md-subhead\" style=\"    margin: 25px 16px 0 8px;\">Add</span> --><md-input-container class=md-block flex=20 required><label>description</label><input type=text ng-model=stpsls.description required></md-input-container><md-input-container style=margin-left:16px><label>Type</label><md-select placeholder=block ng-change=\"\" ng-model=stpsls.type style=\"min-width: 150px\" required><!-- <md-select-label>{{$ctrl.units.name[media.unit]}}</md-select-label> --><md-option ng-value=0>All</md-option><md-option ng-value=1>Bases Tarifaires</md-option><md-option ng-value=2>chambre</md-option><!-- <md-option   ng-value=3> pensions </md-option>   --><!-- <md-option  ng-repeat=\"unit in $ctrl.units\" ng-selected=\"{{unit.name[media.unit]}}\" ng-value=\"{{unit.code}}\"> {{unit.name}} </md-option>   --></md-select></md-input-container><md-input-container ng-show=\"stpsls.type==\'1\'\" style=margin-left:16px><md-select placeholder=rate ng-change=\"\" ng-model=stpsls.typecode style=\"min-width: 150px\"><md-option ng-repeat=\"rateBases in $ctrl.rateBases\" ng-value={{rateBases.code}}>{{rateBases.description}}</md-option></md-select></md-input-container><md-input-container ng-show=\"stpsls.type==\'2\'\" style=margin-left:16px><md-select placeholder=room ng-change=\"\" ng-model=stpsls.typecode style=\"min-width: 150px\"><md-option ng-repeat=\"unit in $ctrl.units\" ng-value={{unit.code}}>{{unit.name}}</md-option></md-select></md-input-container><md-input-container style=margin-left:16px><div class=field-inline><label>Du</label><md-datepicker md-current-view=year ng-model=stpsls.debut md-min-date=$ctrl.minDate md-placeholder=jj/mm/aaaa required></md-datepicker></div></md-input-container><md-input-container style=margin-left:16px><div class=field-inline><label>Jusqu\'au</label><md-datepicker md-current-view=year ng-model=stpsls.fin md-min-date=stpsls.debut md-placeholder=jj/mm/aaaa required></md-datepicker></div></md-input-container><md-dialog-actions ng-if=\" $ctrl.permissionsContracting\"><md-button class=\"md-raised md-accent md-button md-ink-ripple\" ng-click=$ctrl.createstopsales(stpsls) ng-disabled=\"stopSalesForm.$pristine || stopSalesForm.$invalid\">Ajouter</md-button></md-dialog-actions></form><div layout=row layout-align=\"start center\" style=\"padding: 8px 16px\"><md-input-container><label>Filtrer à partir de</label><md-datepicker ng-model=$ctrl.filterstopsales.filterStartDate md-placeholder=jj/mm/aaaa></md-datepicker></md-input-container><md-input-container style=margin-left:16px><label>Jusqu\'à</label><md-datepicker ng-model=$ctrl.filterstopsales.filterEndDate md-placeholder=jj/mm/aaaa></md-datepicker></md-input-container><md-input-container style=margin-left:16px><label>Type de chambre</label><md-select ng-model=$ctrl.filterstopsales.selectedRoomType><md-option value=\"\">Tous</md-option><md-option ng-repeat=\"unit in $ctrl.units\" ng-value={{unit.code}}>{{unit.name}}</md-option></md-select></md-input-container><md-button class=\"md-raised md-primary\" style=margin-left:16px ng-click=$ctrl.applyDateFilter($ctrl.filterstopsales.filterStartDate,$ctrl.filterstopsales.filterEndDate,$ctrl.filterstopsales.selectedRoomType)>Filtrer</md-button><md-button class=md-raised ng-click=$ctrl.clearDateFilter()>Effacer</md-button></div><!-- exact table from live demo --><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-on-reorder=$ctrl.loadstopsales><tr md-row><th md-column><span>Nom</span></th><th md-column><span>Type</span></th><th md-column><span>Nom de Type </span></th><th md-column><span>Date de debut</span></th><th md-column><span>Date de fin</span></th><th md-column><span></span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"s in $ctrl.filteredStopSales\"><td md-cell>{{::s.description}}</td><td md-cell>{{::s.type}}</td><td md-cell ng-if=\"s.type == \'Hotel\'\">{{::s.type}}</td><td md-cell ng-if=\"s.type == \'Base Tarifaire\'\">{{$ctrl.rateBases[s.typeCode].description}}</td><td md-cell ng-if=\"s.type == \'Unit\'\">{{$ctrl.units[s.typeCode].name}}</td><td md-cell>{{::s.debut}}</td><td md-cell>{{::s.fin}}</td><td md-cell><!-- <md-button class=\"md-icon-button\" ng-click=\"$ctrl.edit($event,s)\"><md-icon>edit</md-icon>\n              <md-tooltip>Modifier</md-tooltip>\n            </md-button> --><md-button ng-if=\" $ctrl.permissionsContracting\" class=\"md-icon-button md-warn\" aria-label=Settings ng-click=$ctrl.remove($event,s)><md-icon>delete</md-icon></md-button><!-- <md-select placeholder=\"block\" ng-change= \"$ctrl.stopSalesStatus(s)\" ng-model=\"s.status\"  >  \n              <md-option   ng-value=\'true\'> Stop Sales</md-option>  \n              <md-option   ng-value=\'false\'> Open Sales </md-option>   --><!-- <md-option   ng-value=3> pensions </md-option>   --><!-- <md-option  ng-repeat=\"unit in $ctrl.units\" ng-selected=\"{{unit.name[media.unit]}}\" ng-value=\"{{unit.code}}\"> {{unit.name}} </md-option>   --><!-- </md-select>\n            <md-checkbox ng-change=\"$ctrl.stopSalesStatus(s)\" ng-model=\"s.status\">\n            </md-checkbox> --></td></tr></tbody></table></md-table-container><!-- <md-table-pagination md-boundary-links=\"true\" md-limit=\"$ctrl.query.limit\" md- md-page=\"$ctrl.query.page\" md-total=\"{{$ctrl.total}}\" md-on-paginate=\"$ctrl.loadBookings\"></md-table-pagination> --><div></div></md-card>");
$templateCache.put("app/yield/property-table/template.html","<main><div style=\"background-color: rgb(141 222 236)\"><div style=\"display: flex\"><div ng-repeat=\"occ in $ctrl.occupancies\"><md-checkbox aria-label=a.name ng-click=$ctrl.selectedProductType(occ) ng-blur=$route.reload();>{{::occ}} Adult(s)</md-checkbox></div><!-- <md-select ng-model=\"$ctrl.prestation.discounts\" multiple>\n          <md-option ng-value=\"occ\" ng-repeat=\"occ in $ctrl.occupancies\">\n            <strong></strong>{{::occ}} Adult(s)\n          </md-option>\n        </md-select> --></div><div style=\"display: flex\"><div ng-repeat=\"board in $ctrl.boards\"><md-checkbox aria-label=a.board ng-click=$ctrl.selectedBoard(board.code) ng-blur=\"productssBoard=$ctrl.selectedBoards\"><h8>{{::board.name}}</h8></md-checkbox></div><div><!-- <md-select ng-model=\"$ctrl.prestation.discounts\" multiple>\n        <md-option ng-value=\"board.code\" ng-repeat=\"board in $ctrl.boards\">\n          <strong></strong>{{::board.name}}\n        </md-option>\n      </md-select> --><md-input-container style=margin-left:16px><md-button ng-click=$ctrl.updateChanges() class=\"md-raised md-accent\"><md-icon class=material-icons>loop</md-icon>Charger</md-button></md-input-container></div></div></div><header><div><md-datepicker ng-model=$ctrl.startDate name=dateField md-min-date=$ctrl.minDate md-max-date=$ctrl.maxDate ng-change=$ctrl.updatePeriod($ctrl.startDate)></md-datepicker></div><ol class=days><li ng-repeat=\"date in $ctrl.period.dates\">{{::date|date:\'EEE\'}}<br>{{::date | date:\'d MMM\'}}</li></ol></header><div><section ng-repeat=\"unit in ::$ctrl.units\" class=unit id=unit-{{::unit.code}}-info><header><h2>{{::unit.name}}</h2></header><unit-allotments-table ng-if=$ctrl.permissionsContracting unit=::unit rate-bases=::$ctrl.rateBasesIndexed period=$ctrl.period viewfilter=$ctrl.viewFilter></unit-allotments-table><unit-stopsales-table unit=::unit rate-bases=::$ctrl.rateBasesIndexed boards=::$ctrl.boards period=$ctrl.period selected-product=$ctrl.selectedProduct selected-boards=$ctrl.selectedBoards occupancies=$ctrl.occupancies boardss=$ctrl.boards viewfilter=$ctrl.viewFilter property=$ctrl.propertyCtrl stop-sales=::$ctrl.stopSales on-requests=::$ctrl.onRequests></unit-stopsales-table><unit-onrequests-table unit=::unit rate-bases=::$ctrl.rateBasesIndexed boards=::$ctrl.boards period=$ctrl.period selected-product=$ctrl.selectedProduct selected-boards=$ctrl.selectedBoards occupancies=$ctrl.occupancies boardss=$ctrl.boards viewfilter=$ctrl.viewFilter property=$ctrl.propertyCtrl on-requests=::$ctrl.onRequests></unit-onrequests-table><unit-products-table ng-if=$ctrl.permissionsContracting unit=::unit rate-bases=::$ctrl.rateBasesIndexed boards=::$ctrl.boards period=$ctrl.period selected-product=$ctrl.selectedProduct selected-boards=$ctrl.selectedBoards occupancies=$ctrl.occupancies boardss=$ctrl.boards viewfilter=$ctrl.viewFilter propertyctrl=$ctrl.propertyCtrl></unit-products-table><!-- <unit-requests-table    unit=\"::unit\" rate-bases=\"::$ctrl.rateBasesIndexed\" boards=\"::$ctrl.boards\" period=\"$ctrl.period\" selected-product=\"$ctrl.selectedProduct\"  selected-boards=\"$ctrl.selectedBoards\" occupancies=\"$ctrl.occupancies\"  boardss=\"$ctrl.boards\" viewFilter=\"$ctrl.viewFilter\" property=\"$ctrl.propertyCtrl\" stop-sales=\"::$ctrl.stopSales\"></unit-requests-table> --><!-- <unit-allotments-table ng-if=\"$ctrl.selectedProduct.length > 0\"   unit=\"::unit\" rate-bases=\"::$ctrl.rateBasesIndexed\" period=\"$ctrl.period\" viewFilter=\"$ctrl.viewFilter\"></unit-allotments-table>\n      <unit-products-table  ng-if=\"$ctrl.selectedProduct.length > 0\"  unit=\"::unit\" rate-bases=\"::$ctrl.rateBasesIndexed\" boards=\"::$ctrl.boards\" period=\"$ctrl.period\" productssOccup=\"::$ctrl.selectedProduct\"  productssBoards=\"::$ctrl.selectedBoards\" viewFilter=\"$ctrl.viewFilter\"></unit-products-table> --></section></div></main>");
$templateCache.put("app/yield/property-table-room/template.html","<main><!-- <div style=\"background-color: rgb(218, 228, 230);\"> --><div style=\"background-color: rgb(141 222 236)\"><div style=\"display: flex\"><section><md-input-container style=margin-left:16px><md-select placeholder=Chambre ng-change=\"\" ng-model=$ctrl.selectedRoom style=\"min-width: 150px\" ng-change=$ctrl.roomChange($ctrl.selectedRoom)><md-option ng-value=-1>All</md-option><md-option ng-repeat=\"unit in $ctrl.units\" ng-value={{unit.code}}>{{unit.name}}</md-option></md-select></md-input-container><!-- <md-input-container style=\"margin-left:16px\">\n          <md-button ng-click=\"$ctrl.updateChangesUnit($ctrl.selectedRoom)\" class=\"md-raised md-accent\">\n            <md-icon class=\"material-icons\">loop</md-icon> Charger\n          </md-button>\n        </md-input-container> --></section><!-- <md-select ng-model=\"$ctrl.prestation.discounts\" multiple>\n          <md-option ng-value=\"occ\" ng-repeat=\"occ in $ctrl.occupancies\">\n            <strong></strong>{{::occ}} Adult(s)\n          </md-option>\n        </md-select> --></div><div><md-datepicker ng-model=$ctrl.startDate name=dateField md-min-date=$ctrl.minDate md-max-date=$ctrl.maxDate ng-change=$ctrl.updatePeriod($ctrl.startDate)></md-datepicker></div></div><header><h3>date</h3><ol class=days><li ng-repeat=\"date in $ctrl.period.dates\">{{::date|date:\'EEE\'}}<br>{{::date | date:\'d MMM\'}}</li></ol></header><div><section ng-repeat=\"unit in ::$ctrl.units\" class=unit id=unit-{{::unit.code}}-info ng-if=\"$ctrl.selectedRoom && $ctrl.selectedRoom != -1\"><header ng-if=\"$ctrl.selectedRoom == unit.code\"><h2 style=\"color: blue\">{{::unit.name}}</h2></header><unit-stopsales-table-room ng-if=\"$ctrl.selectedRoom == unit.code\" unit=::unit rate-bases=::$ctrl.rateBasesIndexed selected-room=$ctrl.selectedRoom boards=::$ctrl.boards period=$ctrl.period selected-product=$ctrl.selectedProduct selected-boards=$ctrl.selectedBoards occupancies=$ctrl.occupancies boardss=$ctrl.boards viewfilter=$ctrl.viewFilter property=$ctrl.propertyCtrl stop-sales=::$ctrl.stopSales on-requests=::$ctrl.onRequests></unit-stopsales-table-room><unit-onrequests-table-room ng-if=\"$ctrl.selectedRoom == unit.code\" unit=::unit rate-bases=::$ctrl.rateBasesIndexed selected-room=$ctrl.selectedRoom boards=::$ctrl.boards period=$ctrl.period selected-product=$ctrl.selectedProduct selected-boards=$ctrl.selectedBoards occupancies=$ctrl.occupancies boardss=$ctrl.boards viewfilter=$ctrl.viewFilter property=$ctrl.propertyCtrl on-requests=::$ctrl.onRequests></unit-onrequests-table-room><!-- <unit-requests-table    unit=\"::unit\" rate-bases=\"::$ctrl.rateBasesIndexed\" boards=\"::$ctrl.boards\" period=\"$ctrl.period\" selected-product=\"$ctrl.selectedProduct\"  selected-boards=\"$ctrl.selectedBoards\" occupancies=\"$ctrl.occupancies\"  boardss=\"$ctrl.boards\" viewFilter=\"$ctrl.viewFilter\" property=\"$ctrl.propertyCtrl\" stop-sales=\"::$ctrl.stopSales\"></unit-requests-table> --><!-- <unit-allotments-table ng-if=\"$ctrl.selectedProduct.length > 0\"   unit=\"::unit\" rate-bases=\"::$ctrl.rateBasesIndexed\" period=\"$ctrl.period\" viewFilter=\"$ctrl.viewFilter\"></unit-allotments-table>\n      <unit-products-table  ng-if=\"$ctrl.selectedProduct.length > 0\"  unit=\"::unit\" rate-bases=\"::$ctrl.rateBasesIndexed\" boards=\"::$ctrl.boards\" period=\"$ctrl.period\" productssOccup=\"::$ctrl.selectedProduct\"  productssBoards=\"::$ctrl.selectedBoards\" viewFilter=\"$ctrl.viewFilter\"></unit-products-table> --></section><section ng-repeat=\"unit in ::$ctrl.units\" class=unit id=unit-{{::unit.code}}-info ng-if=\"!$ctrl.selectedRoom || $ctrl.selectedRoom == -1\"><header><h2 style=\"color: blue\">{{::unit.name}}</h2></header><unit-stopsales-table-room unit=::unit rate-bases=::$ctrl.rateBasesIndexed selected-room=$ctrl.selectedRoom boards=::$ctrl.boards period=$ctrl.period selected-product=$ctrl.selectedProduct selected-boards=$ctrl.selectedBoards occupancies=$ctrl.occupancies boardss=$ctrl.boards viewfilter=$ctrl.viewFilter property=$ctrl.propertyCtrl stop-sales=::$ctrl.stopSales on-requests=::$ctrl.onRequests></unit-stopsales-table-room><unit-onrequests-table-room unit=::unit rate-bases=::$ctrl.rateBasesIndexed selected-room=$ctrl.selectedRoom boards=::$ctrl.boards period=$ctrl.period selected-product=$ctrl.selectedProduct selected-boards=$ctrl.selectedBoards occupancies=$ctrl.occupancies boardss=$ctrl.boards viewfilter=$ctrl.viewFilter property=$ctrl.propertyCtrl on-requests=::$ctrl.onRequests></unit-onrequests-table-room><!-- <unit-requests-table    unit=\"::unit\" rate-bases=\"::$ctrl.rateBasesIndexed\" boards=\"::$ctrl.boards\" period=\"$ctrl.period\" selected-product=\"$ctrl.selectedProduct\"  selected-boards=\"$ctrl.selectedBoards\" occupancies=\"$ctrl.occupancies\"  boardss=\"$ctrl.boards\" viewFilter=\"$ctrl.viewFilter\" property=\"$ctrl.propertyCtrl\" stop-sales=\"::$ctrl.stopSales\"></unit-requests-table> --><!-- <unit-allotments-table ng-if=\"$ctrl.selectedProduct.length > 0\"   unit=\"::unit\" rate-bases=\"::$ctrl.rateBasesIndexed\" period=\"$ctrl.period\" viewFilter=\"$ctrl.viewFilter\"></unit-allotments-table>\n      <unit-products-table  ng-if=\"$ctrl.selectedProduct.length > 0\"  unit=\"::unit\" rate-bases=\"::$ctrl.rateBasesIndexed\" boards=\"::$ctrl.boards\" period=\"$ctrl.period\" productssOccup=\"::$ctrl.selectedProduct\"  productssBoards=\"::$ctrl.selectedBoards\" viewFilter=\"$ctrl.viewFilter\"></unit-products-table> --></section></div></main>");
$templateCache.put("app/yield/unit-graphs/template.html","<!--\n<header class=\"main\">\n  <h1>Tarifs et dispos - {{::$ctrl.unitListCtrl.unitTypesIndex[$ctrl.unit.type].name}} {{$ctrl.unit.type}}\n\n  {{::$ctrl.unit.name}}</h1>\n\n  <nav>\n  <md-button class=\"md-icon-button\"><md-icon>view_comfy</md-icon>\n  </md-button>\n  </nav>\n</header>\n--><main><section><md-input-container style=margin-left:16px><label>Date Debut</label><md-datepicker ng-model=$ctrl.uploadStart name=dateDebut></md-datepicker></md-input-container><md-input-container style=margin-left:16px><md-button ng-click=$ctrl.loadData() class=\"md-raised md-accent\"><md-icon class=material-icons>loop</md-icon>Charger</md-button></md-input-container></section><section><header><h3 style=flex:1>Disponibilité</h3><md-button style=margin-right:0 class=\"md-raised md-accent\" ng-click=$ctrl.editAvailable($event) ng-if=$ctrl.permissionsContracting>modifier</md-button></header><nvd3 options=::$ctrl.availability.options data=::$ctrl.availability.data api=$ctrl.availabilityChartApi></nvd3></section><section ng-repeat=\"group in ::$ctrl.rateGroups\"><header><h3 style=flex:1>Tarifs <span>{{::group.basis.description}}</span></h3><div ng-repeat=\"occupancy in ::group.occupancies\" style=flex:1><!--<span>{{::occupancy}} Adulte(s)</span>--><md-checkbox aria-label=a.name ng-click=$ctrl.selectedProductType(group,occupancy)>{{::occupancy}} Adulte(s)</md-checkbox></div><br><div ng-repeat=\"board in ::group.boards\" style=flex:1><!--<span>{{::occupancy}} Adulte(s)</span>--><md-checkbox aria-label=a.board ng-click=$ctrl.selectedBoards(group,board)>{{::$ctrl.boards[board].name}}</md-checkbox></div><!-- <md-button ng-if=\"::group.basis.permissions.edit\" style=\"margin-right:0\" class=\"md-raised md-accent\"\n        ng-click=\"$ctrl.clonePeriodRates($event, group)\" ng-disabled=\"group.disabled\" >Prolonger Date</md-button>\n        <md-button ng-if=\"::group.basis.permissions.edit\" style=\"margin-right:0\" class=\"md-raised md-accent\"\n        ng-click=\"$ctrl.editRates($event, group)\" ng-disabled=\"group.disabled\" >modifier</md-button> --><md-button style=margin-right:0 class=\"md-raised md-accent\" ng-click=\"$ctrl.clonePeriodRates($event, group)\" ng-disabled=group.disabled ng-if=$ctrl.permissionsContracting>Prolonger Date</md-button><md-button style=margin-right:0 class=\"md-raised md-accent\" ng-click=\"$ctrl.editRates($event, group)\" ng-disabled=group.disabled ng-if=$ctrl.permissionsContracting>modifier</md-button></header><nvd3 options=::group.options data=::group.data api=group.chartApi></nvd3></section></main>");
$templateCache.put("app/yield-price/list/template.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Yield Price</span></div></md-toolbar><form style=\"border-top:1px solid #ccc;border-bottom:1px solid #ccc;    padding: 0 16px;\n  display: flex;\n      align-items: flex-start\" name=bookingsFilterForm><!-- <span class=\"md-subhead\" style=\"    margin: 25px 16px 0 8px;\">Add</span> --><md-input-container class=md-block flex=20 required><label>description</label><input type=text ng-model=yld.description></md-input-container><md-input-container style=margin-left:16px><md-select placeholder=rate ng-change=\"\" ng-model=yld.rate style=\"min-width: 150px\" required><md-option ng-repeat=\"rateBases in $ctrl.rateBases\" ng-value={{rateBases.code}}>{{rateBases.description}}</md-option></md-select></md-input-container><md-input-container style=margin-left:16px><md-select placeholder=room ng-change=\"\" ng-model=yld.unit style=\"min-width: 150px\" required><md-option ng-repeat=\"unit in $ctrl.units\" ng-value={{unit.code}}>{{unit.name}}</md-option></md-select></md-input-container><md-input-container flex=30 style=\"padding: 0 10px 0 0; width: 200px\"><label>Prix en %</label><input type=number min=0 step=1 ng-model=yld.pourcent></md-input-container><md-input-container flex=30 style=\"padding: 0 10px 0 0; width: 200px\"><label>Taux en %</label><input type=number min=0 step=1 ng-model=yld.taux></md-input-container><md-input-container style=margin-left:16px><div class=field-inline><label>Du</label><md-datepicker md-current-view=year ng-model=yld.debut md-min-date=$ctrl.minDate md-placeholder=jj/mm/aaaa required></md-datepicker></div></md-input-container><md-input-container style=margin-left:16px><div class=field-inline><label>Jusqu\'au</label><md-datepicker md-current-view=year ng-model=yld.fin md-min-date=yld.debut md-placeholder=jj/mm/aaaa required></md-datepicker></div></md-input-container><md-dialog-actions><md-button class=\"md-raised md-accent md-button md-ink-ripple\" ng-click=$ctrl.createyield(yld)>Ajouter</md-button></md-dialog-actions></form><!-- exact table from live demo --><md-table-container><table md-table md-progress=$ctrl.loadingPromise><thead md-head md-on-reorder=$ctrl.loadstopsales><tr md-row><th md-column><span>Nom</span></th><th md-column><span>Base Tarifaire</span></th><th md-column><span>unit</span></th><th md-column><span>prix en %</span></th><th md-column><span>taux</span></th><th md-column><span>Date de debut</span></th><th md-column><span>Date de fin</span></th><!-- <th md-column ><span>Action</span></th> --></tr></thead><tbody md-body><tr md-row ng-repeat=\"y in $ctrl.ylds.items\"><td md-cell>{{::y.description}}</td><td md-cell>{{::y.rate}}</td><td md-cell>{{::y.unit}}</td><td md-cell>{{::y.pourcent}}</td><td md-cell>{{::y.remplissage}}</td><td md-cell>{{::y.debut}}</td><td md-cell>{{::y.fin}}</td><td md-cell><!-- <md-button class=\"md-icon-button\" ng-click=\"$ctrl.edit($event,s)\"><md-icon>edit</md-icon>\n              <md-tooltip>Modifier</md-tooltip>\n            </md-button> --><md-button class=\"md-icon-button md-warn\" aria-label=Settings ng-click=$ctrl.remove($event,y)><md-icon>delete</md-icon></md-button></td></tr></tbody></table></md-table-container><!-- <md-table-pagination md-boundary-links=\"true\" md-limit=\"$ctrl.query.limit\" md- md-page=\"$ctrl.query.page\" md-total=\"{{$ctrl.total}}\" md-on-paginate=\"$ctrl.loadBookings\"></md-table-pagination> --><div></div></md-card>");
$templateCache.put("app/amenities/property/view/template.html","<section class=card style=\"width: 1065px\"><header><h2>Les équipement de l\'établissement</h2></header><!-- <div layout=\"row\">\n        <hr style=\"width:10%;text-align:left;margin-left:0; color: blueviolet;\">\n        <br>\n        <hr style=\"width:10%;text-align:left;margin-left:0; color:cornflowerblue;\">\n    </div> --><ul layout=row layout-wrap style=list-style:none><li ng-repeat=\"a in ::$ctrl.options.property track by $index\" flex=25><!--  --><!-- $ctrl.propertyAmenities.indexOf(a.code) > -1 --><md-checkbox ng-disabled=a.disabled ng-checked=a.checked ng-click=$ctrl.toggleProperty($event,a)>{{::a.name}} <span ng-if=\"a.checked && a.free\">(G)</span> <span ng-if=\"a.checked && !a.free\">(P)</span></md-checkbox><!-- <br> --><md-button ng-if=a.checked class=md-icon-button ng-click=$ctrl.editAmenityDescription($event,a)><md-icon>edit</md-icon></md-button><!-- <a href ng-click=\"$ctrl.editAmenityDescription($event,a)\">--</a> --></li></ul></section><section class=card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Les équipements de la chambre</span><form name=propertyFilterForm flex style=\"margin-left: 16px\" layout=row><md-icon class=material-icons>filter_list</md-icon><input style=\"width: 100%;\n      margin: 0 0 0 16px;\n      font-size:14px;\n      padding:4px;\n      border: none;\n      color: rgba(0, 0, 0, 0.87)\" type=text ng-model=$ctrl.unitAmenitiesFilter.name placeholder=\"Filtrer \"></form></div></md-toolbar><!-- <pre>{{$ctrl.query | json}}</pre> --><md-table-container><table md-table md-progress=$ctrl.unitsPromise><thead md-head md-order=$ctrl.query.order><tr md-row><th md-column md-order-by=name><span>Service/Equipement</span></th><th scope=col md-column ng-repeat=\"u in ::$ctrl.units\" style=\"width: 150px;\nwhite-space: normal;\n    text-align: center\"><span ng-bind=::$ctrl.unitTypes[u.type].name></span> <span ng-bind=::u.name></span></th></tr></thead><tbody md-body><!--unit sont les options et services--><!-- | filter:$ctrl.unitAmenitiesFilter --><tr md-row ng-repeat=\"a in $ctrl.options.unit | filter:$ctrl.unitAmenitiesFilter | orderBy: $ctrl.query.order\"><td md-cell>{{a.name}}</td><!--units sont les types de chambres--><td md-cell ng-repeat=\"u in ::$ctrl.units \" style=text-align:center><!-- u.amenities.includes(a.code) --><md-checkbox ng-disabled=a.disabled aria-label=a.name ng-checked=u.amenities.includes(a.code) ng-click=$ctrl.toggleUnit($event,u,a)><span ng-if=\"u.amenities.includes(a.code) && $ctrl.uAmenitiesIsFree(u,a)\">(G)</span> <span ng-if=\"u.amenities.includes(a.code) && !$ctrl.uAmenitiesIsFree(u,a)\">(P)</span><!-- <span ng-if=\"u.amenities.includes(a.code) && a.free\">(G)</span>\n                            <span ng-if=\"u.amenities.includes(a.code) && !a.free\">(P) </span> --></md-checkbox><md-tooltip><span ng-bind=::$ctrl.unitTypes[u.type].name></span> <span ng-bind=::u.name></span> / {{::a.name}}</md-tooltip></td></tr></tbody></table></md-table-container><!-- <pre>{{$ctrl.options.property | json}}</pre>  --></section>");
$templateCache.put("app/bookings/edit/traveller/template.html","<md-dialog><form name=travellerForm><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><md-input-container flex=50><label>Prefix</label><input type=text name=label ng-model=$ctrl.copy.prefix></md-input-container><md-input-container flex=50><label>firstName</label><input type=text name=label ng-model=$ctrl.copy.firstname></md-input-container><md-input-container flex=50><label>lastName</label><input type=text name=label ng-model=$ctrl.copy.lastname></md-input-container></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save() ng-disabled=travellerForm.$invalid>Enregister</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/bookings/property-booking-on-hold-list/payment/template.html","<md-dialog><form name=paymentForm><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><md-input-container flex=50><label>Méthode</label><!-- <input type=\"text\" name=\"label\" ng-model=\"$ctrl.copy.method\"> --><md-select name=chain ng-model=$ctrl.copy.method><md-option ng-repeat=\"p in ::$ctrl.paymentMethods\" ng-value=::p.code>{{::p.name}}</md-option></md-select></md-input-container><md-input-container flex=50 ng-if=\"$ctrl.copy.method === \'3\'\"><label>Référence chèque</label><input type=text name=description ng-model=$ctrl.copy.check.number></md-input-container><md-input-container flex=50 ng-if=\"$ctrl.copy.method === \'2\'\"><label>Numéro STAN</label><input type=number name=description ng-model=$ctrl.copy.stan></md-input-container><md-input-container flex=50><label>montant</label><input type=text name=montant ng-model=$ctrl.copy.amount></md-input-container></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save() ng-disabled=paymentForm.$invalid>Enregister</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/bookings/property-list/createBooking/template.html","<md-dialog><form name=unitForm><header>L\'ajout d\'une Reservation</header><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><md-input-container class=field-inline style=\"padding: 0 20px; width: 150px\" required><label>nombre de Chambre</label><input type=number name=night ng-model=$ctrl.roomCount></md-input-container><md-input-container class=field-inline style=\"padding: 0 20px; width: 150px\" required><label>nombre de nuits</label><input type=number name=night ng-model=$ctrl.night></md-input-container><div ng-repeat=\"board in $ctrl.roomCount\"><md-input-container class=field-inline style=\"padding: 0 20px; width: 150px\" required><md-select placeholder=Chambre ng-change=\"\" ng-model=$ctrl.copy.unit style=\"min-width: 150px\"><md-option ng-repeat=\"unit in $ctrl.units\" ng-value={{unit.code}}>{{unit.name}}</md-option></md-select></md-input-container><md-input-container class=field-inline style=\"padding: 0 20px; width: 150px\" required><md-select placeholder=Board ng-change=\"\" ng-model=$ctrl.copy.board style=\"min-width: 150px\"><md-option ng-repeat=\"board in $ctrl.board\" ng-value={{board.code}}>{{bord.name}}</md-option></md-select></md-input-container><md-input-container class=field-inline style=\"padding: 0 20px; width: 150px\" required><div class=field-inline><label>Checkin</label><md-datepicker md-current-view=year ng-model=$ctrl.copy.checkin md-placeholder=jj/mm/aaaa required></md-datepicker></div></md-input-container><md-input-container class=field-inline style=\"padding: 0 20px; width: 150px\" required><label>prix</label><input type=number name=night ng-model=$ctrl.copy.total></md-input-container></div><!-- <md-input-container flex=\"50\">\n        <label>Payments</label>\n        <input type=\"number\" name=\"payments\"  ng-model=\"$ctrl.copy.payments[0].amount\">\n      </md-input-container> --></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save($ctrl.copy) ng-disabled=unitForm.$invalid>Enregister</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/bookings/property-list/createBookings/template.html","<!-- <md-card name=\"createOrderCard\" style=\"  width: 1400px;padding: 60px;flex-direction: row !important;display: block !important;\"> --><form name=createOrderCard style=\"background-color:#FFF ;width: 1000px;padding: 60px;flex-direction: row !important;display: block !important\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><span>Ajouter Reservation</span></div></md-toolbar><h4>Informations de Client</h4><div style=\"margin-top: 40px;display: flex;  justify-content: center\"><md-input-container class=field-inline style=\"padding: 0;margin-right: 40px;width: 200px\" required><div style=\"padding: 0\"><label>Nom</label><input type=text name=Customer ng-model=$ctrl.order.customer.lastName required></div></md-input-container><md-input-container class=field-inline style=\"padding: 0;margin-right: 40px;width: 200px\" required><div style=\"padding: 0\"><label>Prenom</label><input type=text name=Customer ng-model=$ctrl.order.customer.firstName required></div></md-input-container><md-input-container class=field-inline style=\"padding: 0;margin-right: 40px;width: 200px\" required><div style=\"padding: 0\"><label>Telephone</label><input type=text name=Telephone ng-model=$ctrl.order.customer.phone required></div></md-input-container><md-input-container class=field-inline style=\"padding: 0;margin-right: 40px;width: 200px\"><div style=\"padding: 0\"><label>Email</label><input type=email name=email ng-model=$ctrl.order.customer.email></div></md-input-container></div><md-divider style=\"margin-top: 40px\"></md-divider><h4>Booking details</h4><div style=\"margin-top: 40px;display: flex;  justify-content: center\"><md-input-container style=\"padding: 0;margin-right: 40px;width: 200px\" required><div style=\"padding: 0\"><label>Checkin</label><md-datepicker md-current-view=year ng-model=$ctrl.checkin md-placeholder=jj/mm/aaaa required></md-datepicker></div></md-input-container><md-input-container class=field-inline style=\"width: 150px;margin-right: 40px\" required><div><label>nombre de nuits</label><input type=number name=night min=1 ng-model=$ctrl.night required></div></md-input-container><md-input-container class=field-inline style=\"padding: 0 40px; width: 200px\" required><label>Base Tarifaire</label><md-select placeholder=\"Base Tarifaire\" ng-change=\"\" ng-model=$ctrl.baseTarifaire required><md-option ng-repeat=\"base in $ctrl.rateBases \" ng-value={{base}}>{{base.description}}</md-option></md-select></md-input-container><md-input-container class=field-inline style=\"padding: 0 40px; width: 100px\" required><label>POS</label><md-select placeholder=pos ng-change=\"\" ng-model=$ctrl.pos required><md-option ng-repeat=\"pos in $ctrl.posS \" ng-value={{pos}}>{{pos.name}}</md-option></md-select></md-input-container><!-- <md-input-container class=\"field-inline\" style=\"     width: 150px;margin-right: 40px;\" required>\n      <div>\n  \n  \n        <label>Paiement</label>\n        <input type=\"number\" name=\"guests\" ng-model=\"$ctrl.payments[0].amount\">\n      </div>\n  \n    </md-input-container> --></div><md-divider style=\"margin-top: 40px\"></md-divider><h4>Details de la Chambre</h4><div ng-repeat=\"item in $ctrl.item track by $index\" style=\"margin-top: 40px;display: flex;\n    justify-content: center\"><md-input-container class=field-inline style=\"padding: 0 10px;    width: 200px\" required><md-select placeholder=Chambre ng-change=\"\" ng-model=$ctrl.orderItems[$index].product.unit style=\"min-width: 150px\" required><md-option ng-repeat=\"unit in $ctrl.units \" ng-value={{unit}}>{{unit.name}}</md-option></md-select></md-input-container><md-input-container class=field-inline style=\"padding: 0 10px;    width: 150px\" required><md-select placeholder=Board ng-change=\"\" ng-model=$ctrl.orderItems[$index].product.board style=\"min-width: 150px\" required><md-option ng-repeat=\"board in $ctrl.boards \" ng-value={{board.code}}>{{board.name}}</md-option></md-select></md-input-container><md-input-container class=field-inline style=\"margin-left: 10px;  width: 110px\" required><label>nombre d\'Adultes</label><input type=number name=guests ng-model=$ctrl.orderItems[$index].guests required></md-input-container><md-input-container class=field-inline style=\"margin-left: 10px;  width: 110px\" required><label>nombre d\'enfants</label><input type=number name=guests min=0 ng-model=$ctrl.orderItems[$index].child required></md-input-container><md-input-container class=field-inline style=\"margin-left: 10px;  width: 110px\" required><label>nombre de bebe</label><input type=number name=guests min=0 ng-model=$ctrl.orderItems[$index].infant required></md-input-container><md-input-container class=field-inline style=\"margin-left: 10px;  width: 100px\" required><label>prix de la nuit</label><input type=number name=night min=0 ng-model=$ctrl.orderItems[$index].total ng-blur=\"$ctrl.orderItems[$index].totalTarfi=$ctrl.orderItems[$index].total * $ctrl.night\" required></md-input-container><md-input-container style=\"margin-left: 10px;  width: 100px\"><label>Prix total</label><input readonly type=number name=totalitem ng-model=$ctrl.orderItems[$index].totalTarfi></md-input-container></div><!-- <div style=\"     margin-top: 60px;text-align: right;\">\n  \n    <md-input-container style=\"   margin-left: 10px;  width: 100px;\">\n      <label>Prix total</label>\n      <input readonly type=\"number\" name=\"totalitem\"  ng-model=\"$ctrl.orderItems[$index].totalTarfi\">\n    </md-input-container>\n    </div> --><div style=\"margin-top: 60px;text-align: right\"><label>Ajouter Cham</label><md-button ng-click=$ctrl.addItem()><md-icon>add</md-icon></md-button></div><!-- <div ng-if=\"$ctrl.item.length > 1\" style=\"     margin-top: 60px;margin-left:0;\">\n      <label>Delete Item</label>\n  \n      <md-button ng-click=\"$ctrl.deleteItem()\">\n        <md-icon>delete</md-icon>\n      </md-button>\n    </div>\n    <div ng-show=\"$ctrl.item.length > 1\" style=\"     margin-top: 60px;margin-left:0;\">\n      <label>Delete Item</label>\n  \n      <md-button ng-click=\"$ctrl.deleteItem()\">\n        <md-icon>delete</md-icon>\n      </md-button>\n    </div>\n    <div ng-if=\"$ctrl.item.length =! 1\" style=\"     margin-top: 60px;margin-left:0;\">\n      <label>Delete Item</label> --><!-- <md-button ng-click=\"$ctrl.deleteItem()\">\n        <md-icon>delete</md-icon>\n      </md-button>\n    </div> --><!-- <div ng-if=\"$ctrl.item.length =! \'1\'\" style=\"     margin-top: 60px;margin-left:0;\">\n      <label>Delete Item</label>\n  \n      <md-button ng-click=\"$ctrl.deleteItem()\">\n        <md-icon>delete</md-icon>\n      </md-button>\n    </div> --><md-divider style=\"margin-top: 40px\"></md-divider><h4>Paiement</h4><div style=\"margin-top: 60px;margin-left: 60px ;text-align: center\"><md-input-container class=field-inline style=\"width: 300px;margin-right: 40px;text-align: left\" required><div><label>Paiement</label><input type=number name=guests ng-model=$ctrl.payments[0].amount required></div></md-input-container></div><md-dialog-actions layout=row layout-align=\"space-between end\" style=\"width: 100%;margin-top: 6rem\"><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save($ctrl.order,$ctrl.orderItems,$ctrl.night,$ctrl.checkin) ng-disabled=\"createOrderCard.$pristine || createOrderCard.$invalid\">Enregister</md-button></md-dialog-actions></form><!-- </md-card> -->");
$templateCache.put("app/bookings/view/edit/template.html","<md-dialog><form name=unitForm><header>Modification de Paiement et POS</header><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><md-input-container flex=50><div style=\"padding: 0\"><label>Nom</label><input type=text name=Customer ng-model=$ctrl.copy.customer.lastName></div></md-input-container><md-input-container flex=50><div style=\"padding: 0\"><label>Prenom</label><input type=text name=Customer ng-model=$ctrl.copy.customer.firstName></div></md-input-container><md-input-container flex=50><div style=\"padding: 0\"><label>Telephone</label><input type=text name=Telephone ng-model=$ctrl.copy.customer.phone></div></md-input-container><md-input-container flex=50><div style=\"padding: 0\"><label>Email</label><input type=email name=email ng-model=$ctrl.copy.customer.email></div></md-input-container><!-- <md-input-container ng-repeat=\"i in $ctrl.copy.items\" flex=\"50\">\n        <label>Prix</label>\n        <input type=\"number\" name=\"totalitem\"  ng-model=\"i.total\">\n      </md-input-container> --><md-input-container flex=50><label>Paiement</label><input type=number name=payments ng-model=$ctrl.copy.payments[0].amount></md-input-container><md-input-container class=field-inline style=\"padding: 0 40px; width: 100px\"><label>POS</label><md-select ng-change=\"\" ng-model=$ctrl.copy.pos.name><md-option ng-repeat=\"pos in $ctrl.posS \" ng-value={{pos.name}}>{{pos.name}}</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save($ctrl.copy) ng-disabled=unitForm.$invalid>Enregister</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/bookings/view/editBooking/template.html","<md-dialog><form name=unitForm><header>Modification de item</header><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><md-input-container flex=50><label>Checkin</label><md-datepicker md-current-view=year ng-model=$ctrl.item.checkin md-placeholder=jj/mm/aaaa></md-datepicker></md-input-container><md-input-container flex=50><label>nights</label><input type=number name=night min=1 ng-model=$ctrl.item.nights ng-blur=\"$ctrl.totalTarif=$ctrl.nightTarif * $ctrl.item.nights\"></md-input-container><md-input-container flex=50><label>nombre de personnes</label><input type=number name=night min=0 ng-model=$ctrl.paxNbr></md-input-container><md-input-container flex=50><label>nombre d\'enfants</label><input type=number name=night min=0 ng-model=$ctrl.paxNbrChild></md-input-container><md-input-container flex=50><label>nombre de bebe</label><input type=number name=night min=0 ng-model=$ctrl.paxNbrInf></md-input-container><md-input-container class=field-inline><md-select placeholder=Chambre ng-change=\"\" ng-model=$ctrl.item.product.unit.code style=\"min-width: 150px\"><md-option ng-repeat=\"unit in $ctrl.units \" ng-value={{unit.code}}>{{unit.name}}</md-option></md-select></md-input-container><md-input-container flex=50><label>Prix par nuit</label><input type=number name=nightitem min=0 ng-model=$ctrl.nightTarif ng-blur=\"$ctrl.totalTarif=$ctrl.nightTarif * $ctrl.item.nights\"></md-input-container><md-input-container flex=50><label>Prix total</label><input readonly type=number name=totalitem ng-model=$ctrl.totalTarif></md-input-container><!-- <md-input-container class=\"field-inline\" style=\" padding: 0 40px; width: 100px;\" required>\n        <label>POS</label>\n        <md-select placeholder=\"pos\" ng-change=\"\" ng-model=\"$ctrl.pos\" required>\n          <md-option ng-repeat=\"pos in $ctrl.posS \" ng-value=\"{{pos}}\"> {{pos.name}} </md-option>\n    \n    \n    \n        </md-select>\n      </md-input-container> --><!-- <md-input-container  flex=\"50\">\n          <label>Checkin</label>\n          <md-datepicker md-current-view=\"year\" ng-model=\"$ctrl.item.checkin\" md-placeholder=\"jj/mm/aaaa\" required>\n          </md-datepicker>\n      </md-input-container> --><!-- <md-input-container flex=\"50\">\n        <label>Payments</label>\n        <input type=\"number\" name=\"payments\"  ng-model=\"$ctrl.copy.payments[0].amount\">\n      </md-input-container> --></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.saveItem($ctrl.item) ng-disabled=unitForm.$invalid>Enregister</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/products/calendar-edit/flat/template.html","<header>{{::unit.name}}</header><section ng-repeat=\"group in $ctrl.rateGroups\"><h5>{{::group.basis.description}}</h5><div ng-repeat=\"p in ::group.products\"><md-checkbox ng-model=p.edit>{{::p.occupancy | occupancy}} {{::p.board}}</md-checkbox><input ng-model=p.rate type=number min=0 max=9999999 ng-required=p.edit ng-show=p.edit></div></section>");
$templateCache.put("app/products/calendar-edit/pax/template.html","<div class=rate-input><label>Demi-doube ( {{::$ctrl.indexedBoards[$ctrl.baseBoard].name}})</label><input ng-model=$ctrl.base required type=number min=1 max=999999 placeholder=... ng-blur=\"$ctrl.valueChanged(\'base\')\"> <span class=value-unit>Devise</span></div><div ng-if=::$ctrl.hasSingle class=rate-input><label for=singleValue>Sup.Single</label><input id=singleValue required ng-model=$ctrl.single type=number min=0 max=999999 placeholder=... ng-blur=\"$ctrl.valueChanged(\'base\')\"> <span class=value-unit>Devise</span></div><div class=subheader ng-show=::$ctrl.adt.length><label>Adultes</label><md-select ng-model=$ctrl.units.adt ng-model-options=\"{ trackBy: \'$value.id\' }\" class=md-no-underline ng-blur=\"$ctrl.valueChanged(\'base\')\"><md-option ng-repeat=\"o in ::$ctrl.valueTypes \" ng-value=o>{{::o.label}}</md-option></md-select></div><div class=rate-input ng-repeat=\"o in $ctrl.adt track by $index\"><label for=adultValue{{::$index}}>{{::$index+3}}° adulte</label><input id=adultValue{{::$index}} required ng-model=$ctrl.adt[$index] placeholder=... type=number min=-999999 max=999999 ng-blur=\"$ctrl.valueChanged(\'adt\')\"> <span class=value-unit>{{$ctrl.units.adt.symbol}}</span></div><section ng-if=::$ctrl.hasChildren><div class=subheader><label>Enfants de la 1er tranche - {{::$ctrl.firstChildAge}} ans</label><md-select ng-model=$ctrl.units.chd ng-model-options=\"{ trackBy: \'$value.id\' }\" class=md-no-underline ng-change=\"$ctrl.valueChanged(\'base\')\"><md-option ng-repeat=\"o in ::$ctrl.valueTypes\" ng-value=o>{{::o.label}}</md-option></md-select></div><div class=rate-input ng-repeat=\"o in $ctrl.chd track by $index\"><label for=childRate{{::$index}}>{{::$index+1}}° enfant</label><input id=childRate{{::$index}} type=number min={{$ctrl.units.chd.min}} max={{$ctrl.units.chd.max}} required ng-model=$ctrl.chd[$index] placeholder=... ng-blur=\"$ctrl.valueChanged(\'chd\')\"> <span class=value-unit>{{$ctrl.units.chd.symbol}}</span></div><div class=rate-input ng-repeat=\"o in $ctrl.inf track by $index\"><label for=infantRate{{::$index}}>{{::$index+1}}° bébé</label><input id=infantRate{{::$index}} type=number min=-999999 max=999999 required ng-model=$ctrl.inf[$index] ng-blur=\"$ctrl.valueChanged(\'inf\')\"> <span class=value-unit>{{$ctrl.units.chd.symbol}}</span></div></section><div ng-hide=\"$ctrl.boards.length === 0\"><div class=subheader><label>Pension adulte</label><md-select ng-model=$ctrl.units.board class=md-no-underline ng-change=\"$ctrl.valueChanged(\'boards\')\"><!-- <md-option ng-repeat=\"o in ::$ctrl.valueTypes\" ng-value=\"o\">{{::o.label}}</md-option> --><md-option ng-value=::$ctrl.valueTypes[3]>{{::$ctrl.valueTypes[3].label}}</md-option></md-select></div><div class=rate-input ng-repeat=\"o in ::$ctrl.boards\"><label for=adultBoardRate{{::$index}} ng-bind=::$ctrl.indexedBoards[o.code].name></label><input id=adultBoardRate{{::$index}} type=number min=-999999 max=999999 required ng-model=o.adt ng-blur=\"$ctrl.valueChanged(\'boards\')\"> <span class=value-unit>Devise</span></div><div class=subheader ng-if=::$ctrl.chd.length><label>Pension enfant de la 1er tranche - {{::$ctrl.firstChildAge}} ans (base pension adulte)</label><md-select ng-model=$ctrl.units.boardChd ng-model-options=\"{ trackBy: \'$value.id\' }\" class=md-no-underline ng-change=\"$ctrl.valueChanged(\'boards\')\"><!-- <md-option ng-repeat=\"o in ::$ctrl.valueTypes\" ng-value=\"o\">{{::o.label}}</md-option> --><md-option ng-selected=true ng-value=::$ctrl.valueTypes[3]>{{::$ctrl.valueTypes[3].label}}</md-option></md-select></div><div class=rate-input ng-if=::$ctrl.chd.length ng-repeat=\"o in ::$ctrl.boards\"><label for=childtBoardValue{{::$index}} ng-bind=::$ctrl.indexedBoards[o.code].name></label><input required type=number ng-model=o.chd ng-blur=\"$ctrl.valueChanged(\'boards\')\" id=childBoardValue{{::$index}} min={{$ctrl.units.chdBoard.min}} max={{$ctrl.units.chdBoard.max}}> <span class=value-unit>{{$ctrl.units.boardChd.symbol}}</span></div><div class=subheader ng-show=::$ctrl.inf.length><label>Pension bébé (base pension adulte)</label></div><div class=rate-input ng-if=::$ctrl.inf.length ng-repeat=\"o in ::$ctrl.boards\"><label for=infantBoardValue{{::$index}} ng-bind=::$ctrl.indexedBoards[o.code].name></label><input required type=number ng-model=o.inf ng-blur=\"$ctrl.valueChanged(\'boards\')\" id=infantBoardValue{{::$index}} min={{$ctrl.units.chdBoard.min}} max={{$ctrl.units.chdBoard.max}}> <span class=value-unit>{{$ctrl.units.boardChd.symbol}}</span></div></div>");
$templateCache.put("app/property/boards/edit/template.html","<md-dialog><form name=propertyBoardItemForm style=\"width: 500px\"><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><md-input-container ng-repeat=\"lang in ::$ctrl.langs | filter : $ctrl.languagesFilter\"><label>Libellé ({{lang.name}})</label><!-- ng-pattern=\"/^(?![A-Z]{2,}).*$/\" --><!-- maxlength=\"128\" --> <input type=text name=name ng-model=$ctrl.copy.name disabled><!-- <div ng-messages=\"datasetItemForm.name.$error\" multiple>\n          <div ng-message=\"pattern\">\n            Prière de ne pas tout mettre en majuscule.\n          </div>\n        </div> --><!-- <p>{{$ctrl.copy.name[lang.code]}}</p> --></md-input-container><md-input-container ng-repeat=\"lang in ::$ctrl.langs | filter : $ctrl.languagesFilter\"><label>Alias ({{lang.name}})</label><!-- ng-pattern=\"/^(?![A-Z]{2,}).*$/\" --> <input type=text name=alternativenames maxlength=128 ng-model=$ctrl.copy.alternativenames[lang.code] required><!-- <div ng-messages=\"datasetItemForm.alternativenames.$error\" multiple>\n          <div ng-message=\"pattern\">\n            Prière de ne pas tout mettre en majuscule.\n          </div>\n        </div> --></md-input-container><!-- <md-input-container>\n        <label>Description </label>\n        <input type=\"text\" name=\"description\" required maxlength=\"128\" ng-model=\"$ctrl.copy.alternativenames.fr\">\n        <div ng-messages=\"unitForm.description.$error\" multiple>\n          <div ng-message=\"pattern\">\n            Prière de ne pas tout mettre en majuscule.\n          </div>\n        </div>\n      </md-input-container> --><md-input-container ng-repeat=\"lang in ::$ctrl.langs \" ng-if=\"lang.code == \'fr\'\"><label>Description ({{lang.name}})</label><!-- <input type=\"text\" name=\"description\" maxlength=\"128\" ng-model=\"$ctrl.copy.description[lang.code]\" required> --><!-- <textarea name=\"description\" ng-model=\"$ctrl.copy.description[lang.code]\"  rows=\"3\"\n          md-select-on-focus></textarea> --><text-angular ng-model=$ctrl.copy.description[lang.code] ta-default-wrap=span></text-angular></md-input-container></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save() ng-disabled=propertyBoardItemForm.$invalid>Enregistrer</md-button></md-dialog-actions><md-dialog-footer><!-- <pre>{{$ctrl.copy |json}}</pre> --></md-dialog-footer></form></md-dialog>");
$templateCache.put("app/property/comments/edit/template.html","<md-dialog><form name=commentForm><!-- <header>\n      {{::$ctrl.title}}\n    </header> --><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><md-input-container flex=50><label>Libellé</label><input type=text name=label ng-model=$ctrl.copy.label><div ng-messages=commentForm.label.$error multiple md-auto-hide=false><div ng-message=max>Plus de 1000 caractères?</div><div ng-message=min>Veuillez indiquer le libellé.</div></div></md-input-container><md-input-container flex=50><label>Description</label><textarea rows=3 type=text name=description ng-model=$ctrl.copy.description></textarea><!--<div ng-messages=\"commentForm.description.$error\" multiple md-auto-hide=\"false\">\n          <div ng-message=\"max\">\n            Plus de 1000 caractères?\n          </div>\n          <div ng-message=\"min\">\n            Veuillez indiquer une description.\n          </div>\n        </div>--></md-input-container><md-input-container flex=50><!-- ngf-multiple=\"true\" --><div ng-hide=$ctrl.files required ngf-drop ng-model=$ctrl.files class=drop-box style=\"width:320px;height:180px;background: #ededed;padding:8px 16px\"><p style=text-align:center>Glisser le document ici</p><ul><li ng-class=\"{\'md-warn\':commentForm.files.$error.size}\">taille max: {{$ctrl.validation.size}}</li></ul></div><table><tbody><tr ng-repeat=\"file in $ctrl.files track by $index\"><td><!-- ngf-multiple=\"true\" --> <img style=display:block ng-if=file ngf-src=file ngf-resize=\"{width: 320, height: 180, quality: 0.9}\"></td><td><md-button ng-click=$ctrl.remove($index) style=margin-left:0>Supprimer</md-button></td></tr></tbody></table><div class=\"md-button md-primary\" ng-class=\"{\'md-raised\':!$ctrl.files}\" ngf-select ngf-multiple=true ng-model=$ctrl.files name=file ngf-validate=::$ctrl.validation><md-icon>attach_file</md-icon><span>{{$ctrl.files ? \'changer\' : \'choisir\'}}...</span></div></md-input-container></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save() ng-disabled=commentForm.$invalid>Enregistrer</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/property/dashboard/sales-breakdown/template.html","<div class=bookings-pies ng-show=\"$ctrl.hasBookings && $ctrl.viewBy === \'booking\'\"><h4>Répartition des réservations</h4><div class=pie id=bookings-units-pie></div><div class=pie id=bookings-boards-pie></div><div class=pie id=bookings-occupancies-pie></div></div><div class=checkins-pies ng-show=\"$ctrl.hasCheckins && $ctrl.viewBy === \'checkin\'\"><h4>Répartition des séjours</h4><div class=pie id=checkins-units-pie></div><div class=pie id=checkins-boards-pie></div><div class=pie id=checkins-occupancies-pie></div></div>");
$templateCache.put("app/property/datasheet/edit/template.html","<form name=datasheetEditForm><div layout=row layout-wrap><section flex=33 layout=row layout-wrap style=min-width:400px;padding:16px><md-input-container flex=100 required><label>Nom de l\'établissement</label><input name=name type=text maxlength=128 ng-model=$ctrl.copy.name></md-input-container><md-input-container flex=40><label>Type</label><md-select name=type required ng-model=$ctrl.copy.type><md-option ng-repeat=\"o in ::$ctrl.options.propertyTypes\" ng-value=::o.code>{{::o.name}}</md-option></md-select></md-input-container><md-input-container flex=40 class=md-block><label>Chaine</label><md-select name=chain ng-model=$ctrl.copy.brand><!-- <md-option ng-value=\"null\">Independant</md-option> --><md-option ng-repeat=\"o in ::$ctrl.options.brands\" ng-value=::o.code>{{::o.name}}</md-option></md-select></md-input-container><md-input-container class=md-block flex=20><label>Construit en</label><input name=yearBuilt type=number max={{::$ctrl.options.yearBuilt.max}} min={{::$ctrl.options.yearBuilt.min}} ng-model=$ctrl.copy.yearBuilt></md-input-container><!-- Must be disabled for valeria--><!-- <md-input-container class=\"md-block\" flex=\"20\" ng-if=\"$ctrl.hasGlobalCRMConfig\"> --><md-input-container class=md-block flex=20><label>Code giata</label><input name=giataCode type=number ng-model=$ctrl.copy.giata></md-input-container><!--    <md-input-container class=\"md-block\"  >\n\n        <label>Code mautourco</label>\n        <input name=\"mautourco\" type=\"number\" ng-model=\"$ctrl.copy.mautourco\" />\n      </md-input-container>--><!-- Must be disabled for valeria --><div flex=100 style=\"border-bottom: 1px solid #ededed;margin-bottom: 16px\"><h4>Classement</h4><md-slider-container ng-repeat=\"sys in $ctrl.options.ratingSystems\"><span style=\"max-width: inherit\" flex><md-checkbox ng-model=sys.selected>{{::sys.name}}</md-checkbox></span><md-slider ng-if=sys.selected md-discrete style=width:200px ng-model=$ctrl.copy.rating[sys.code] min={{::sys.definition.min}} max={{::sys.definition.max}} step={{::sys.definition.step}} aria-label={{::sys.code}} id=red-slider></md-slider><span>{{$ctrl.copy.rating[sys.code]}}</span></md-slider-container></div><!-- <md-input-container flex=\"50\" class=\"md-block\">\n        <label>Code fournisseur</label>\n        <input name=\"accountingCode\" ng-model=\"$ctrl.copy.accountingCode\"  />\n      </md-input-container> --><md-input-container flex=50 class=md-block><label>Code fournisseur</label><md-autocomplete md-selected-item=$ctrl.copy.accountingCode md-search-text=searchTxt md-items=\"supplier in $ctrl.getSuppliers(searchTxt)\" md-item-text=supplier.name md-mode=standard md-input-minlength=0 md-delay=1000><md-item-template md-delay=1000><span md-highlight-text=searchTxt>{{supplier.name}}</span></md-item-template></md-autocomplete></md-input-container><md-input-container class=md-block><label>Devise</label><md-select name=currency ng-model=$ctrl.copy.currency required><md-option value=MAD>MAD</md-option><md-option value=EUR>EUR</md-option><md-option value=USD>USD</md-option><md-option value=TND>TND</md-option><md-option value=XOF>XOF</md-option><md-option value=SAR>SAR</md-option></md-select></md-input-container><md-input-container class=md-block><label>Taxes locales ({{$ctrl.copy.currency}}/pax/nuit)</label><input name=taxes type=number min=0 required ng-model=$ctrl.copy.taxes></md-input-container><md-input-container flex=50 class=md-block><label>Combinabilité des offres</label><md-select ng-model=$ctrl.copy.combination_rule required><md-option value=S>Séquentielle</md-option><md-option value=T>Globale</md-option></md-select></md-input-container></section><md-divider></md-divider><section style=padding:16px flex=33 style=min-width:400px;padding:16px><div layout=row layout-wrap layout-align=\"start start\"><md-input-container flex=100><label>Adresse</label><input name=address type=text maxlength=255 required ng-model=$ctrl.copy.address></md-input-container><md-input-container flex=33><label>Code postal</label><input name=postCode type=text maxlength=20 ng-model=$ctrl.copy.post_code></md-input-container><!-- <md-input-container flex=33>\n          <label>Localité</label>\n          <md-select name=\"locality\"  ng-model=\"$ctrl.copy.locality\">\n            <md-option ng-repeat=\"o in $ctrl.options.destinations\" ng-value=\"o.code\">\n              {{o.name}}\n            </md-option>\n          </md-select>\n        </md-input-container> --><!-- <md-input-container flex=33>\n        <md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in $ctrl.query(searchText)\" md-item-text=\"item.DestinationName\">\n          <md-item-template>\n            <span md-highlight-text=\"searchText\">{{item.DestinationName}}</span>\n          </md-item-template>\n        </md-autocomplete>\n      </md-input-container> --><md-input-container flex=33><label>Localité</label><md-autocomplete md-selected-item=$ctrl.copy.locality md-search-text=searchText md-items=\"destination in $ctrl.giataDestinations(searchText)\" md-item-text=destination.name md-mode=standard md-input-minlength=2 md-delay=1000 required><md-item-template md-delay=1000><span md-highlight-text=searchText>{{destination.name}}, {{destination.countryName}}</span></md-item-template></md-autocomplete></md-input-container><!-- <md-autocomplete flex required\n      md-input-name=\"autocompleteField\"\n      md-input-minlength=\"2\"\n      md-input-maxlength=\"18\"\n      md-no-cache=\"ctrl.noCache\"\n      md-selected-item=\"ctrl.selectedItem\"\n      md-search-text=\"searchText\"\n      md-items=\"item in ctrl.testquery(searchText)\"\n      md-item-text=\"item.DestinationName\"\n      md-floating-label=\"Favorite state\"\n      placeholder=\"What is your favorite US state?\">\n    <md-item-template>\n      <span md-highlight-text=\"ctrl.searchText\">{{item.DestinationName}}</span>\n    </md-item-template>\n\n  </md-autocomplete> --><md-input-container flex=33><label>Province</label><input name=province type=text maxlength=255 ng-model=$ctrl.copy.province></md-input-container><!--  <md-input-container flex=33>\n          <label>code hotel TGX</label>\n          <input name=\"province\" type=\"text\" maxlength=\"255\" ng-model=\"$ctrl.copy.tgx_code\">\n        </md-input-container>--><!-- <md-input-container flex=33>\n          <label>Pays</label>\n          <md-select  name=\"country\" ng-model=\"$ctrl.copy.country\">\n            <md-option ng-repeat=\"o in $ctrl.options.countries\" ng-value=\"o.code\">\n              {{o.name}}\n            </md-option>\n          </md-select>\n        </md-input-container> --><!-- <md-input-container class=\"md-block\" flex>\n          <label>Fuseau horaire</label>\n          <md-select name=\"timezone\" ng-model=\"$ctrl.copy.timezone\" required>\n            <md-option ng-repeat=\"tz in ::$ctrl.options.timezones\" ng-value=\"::tz\">{{::tz}}</md-option>\n          </md-select>\n        </md-input-container> --><md-input-container class=md-block flex=25><label>Latitude</label><input name=lat type=number ng-model=$ctrl.map.markers.property.lat min=-90 max=90 step=0.0005 maxlength=18 required></md-input-container><md-input-container class=md-block flex=25><label>Longitude</label><input name=lng type=number ng-model=$ctrl.map.markers.property.lng min=-180 max=180 step=0.0005 maxlength=18 required></md-input-container><!--Valeria block start --><!--Valeria block end --><!-- <div ng-hide=\"$ctrl.copy.file\" required ngf-drop ng-model=\"$ctrl.copy.file\" class=\"drop-box\" style=\"width:320px;height:180px;background: #ededed;padding:8px 16px\">\n         \n          </div>\n          <img style=\"display:block\"  ng-if=\"$ctrl.file\" ngf-src=\"$ctrl.file\" ngf-resize=\"{width: 320, height: 180, quality: 0.9}\">\n          <div class=\"md-button md-primary\" ng-class=\"{\'md-raised\':!$ctrl.copy.file}\" ngf-select ng-model=\"$ctrl.copy.file\" name=\"file\" >\n            <md-icon>attach_file</md-icon><span>{{$ctrl.file ?\'changer\':\'choisir\'}}...</span>\n            \n          </div> --><div ng-if=!$ctrl.hasGlobalCRMConfig><md-input-container class=md-block><label>Lien adresse CRM</label><input name=crmAddress type=url maxlength=255 ng-model=$ctrl.copy.crmAdresse></md-input-container><md-input-container class=md-block><label>Adresse CRM Chaine</label><input name=crmCRMChaine type=text maxlength=255 ng-model=$ctrl.copy.crmAdresseChaine></md-input-container><md-input-container class=md-block><label>Email Réservation</label><input name=EmailReservation type=text maxlength=255 ng-model=$ctrl.copy.reservation></md-input-container><md-input-container class=md-block><label>Password Email</label><input name=passwordReservaation type=text maxlength=255 ng-model=$ctrl.copy.passwordReservation></md-input-container></div><md-input-container class=md-block><text-angular lang={{::$ctrl.lang.code}} ta-default-wrap=span></text-angular></md-input-container></div></section><div flex style=min-width:200px;min-height:200px><leaflet width=100% height=100% markers=$ctrl.map.markers center=$ctrl.map.center markers-watch=true></leaflet></div><!-- <ng-quill-editor ng-model=\"message\"></ng-quill-editor> --></div><md-divider></md-divider><div layout=row layout-align=\"end end\"><!-- <ng-quill-editor ng-model=\"message\"></ng-quill-editor> --><md-button ng-click=$ctrl.onClose()>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save() ng-disabled=\"datasheetEditForm.$pristine || datasheetEditForm.$invalid\">Enregistrer</md-button></div></form><!-- <pre>{{datasheetEditForm | json}}</pre> --> <!--\n      <form name=\"userForm\">\n        <div layout layout-sm=\"column\">\n          <md-input-container style=\"width:80%\">\n            <label>Company (Disabled)</label>\n            <input ng-model=\"property.company\">\n          </md-input-container>\n          <md-input-container flex>\n            <label>Submission Date</label>\n            <input ng-model=\"user.submissionDate\" type=\"date\">\n          </md-input-container>\n        </div>\n        <div layout layout-sm=\"column\">\n          <md-input-container flex>\n            <label>First name</label>\n            <input ng-model=\"user.firstName\">\n          </md-input-container>\n          <md-input-container flex>\n            <label>Last Name</label>\n            <input ng-model=\"theMax\">\n          </md-input-container>\n        </div>\n        <md-input-container flex>\n          <label>Address</label>\n          <input ng-model=\"user.address\">\n        </md-input-container>\n        <md-input-container md-no-float>\n          <input ng-model=\"user.address2\" placeholder=\"Address 2\">\n        </md-input-container>\n        <div layout layout-sm=\"column\">\n          <md-input-container flex>\n            <label>City</label>\n            <input ng-model=\"user.city\">\n          </md-input-container>\n          <md-input-container flex>\n            <label>State</label>\n            <input ng-model=\"user.state\">\n          </md-input-container>\n          <md-input-container flex>\n            <label>Postal Code</label>\n            <input ng-model=\"user.postalCode\">\n          </md-input-container>\n        </div>\n        <md-input-container flex>\n          <label>Biography</label>\n          <textarea columns=\"1\" md-maxlength=\"150\" ng-model=\"user.biography\"></textarea>\n        </md-input-container>\n      </form>\n-->");
$templateCache.put("app/property/datasheet/view/template.html","<header><h1>{{::$ctrl.property.name}}</h1><!-- <md-button ng-if=\"::$ctrl.property.permissions.edit\" ng-click=\"$ctrl.updateProp()\" class=\"md-accent\">Update TGX</md-button> --><md-button ng-if=::$ctrl.property.permissions.edit ng-click=$ctrl.onEdit() class=md-accent>Modifier</md-button></header><div layout=row layout-wrap><section flex=33 layout=row layout-wrap style=min-width:400px;padding:16px><md-input-container flex=100 required><label>Nom de l\'établissement</label><input readonly ng-value=$ctrl.property.name></md-input-container><md-input-container flex=40><label>Type</label><input readonly ng-value=$ctrl.property.type.name></md-input-container><md-input-container flex=40 class=md-block><label>Chaine</label><input readonly ng-value=\"::($ctrl.property.brand.name || \'Indépendant\')\"><!-- <input readonly ng-value=\"$ctrl.property.brand.name \"> --><!-- <input readonly ng-value=\"$ctrl.brandss[$ctrl.property.brand].name \">  --></md-input-container><md-input-container class=md-block flex=20><label>Construit en</label><input readonly ng-value=$ctrl.property.yearBuilt></md-input-container><!-- Must be disabled for valeria--><!-- <md-input-container class=\"md-block\" flex=\"20\" ng-if=\"$ctrl.hasSingleCRMConfig\"> --><md-input-container class=md-block flex=20><label>code Giata</label><input readonly ng-value=$ctrl.property.giata></md-input-container><!--   <md-input-container class=\"md-block\"  >\n\n      <label> Code mautourco</label>\n      <input readonly ng-value=\"$ctrl.property.mautourco\" />\n    </md-input-container>--><!-- Must be disabled for valeria--><div flex=100 style=\"border-bottom: 1px solid #ededed;    margin-bottom: 16px\"><h4>Classement</h4><md-input-container ng-repeat=\"rating in ::$ctrl.ratingSystems\"><label>{{::rating.name}}</label><input readonly ng-value=::($ctrl.property.rating[rating.code])></md-input-container></div><md-input-container flex=30 class=md-block><label>Code fournisseur</label><input readonly ng-value=$ctrl.property.accountingCode></md-input-container><md-input-container flex=20 class=md-block><label>Devise</label><input readonly ng-value=$ctrl.property.currency></md-input-container><md-input-container flex class=md-block><label>Taxes locales (par pax/par nuit)</label><input readonly ng-value=$ctrl.property.taxes></md-input-container><md-input-container flex=50 class=md-block><label>Combinabilité des offres</label><input readonly ng-value=$ctrl.combinableHashMap[$ctrl.property.combination_rule]></md-input-container></section><md-divider></md-divider><section style=padding:16px flex=33 style=min-width:400px;padding:16px><div layout=row layout-wrap layout-align=\"start start\"><md-input-container flex=100><label>Adresse</label><input readonly ng-value=$ctrl.property.address></md-input-container><md-input-container flex=33><label>Code postal</label><input readonly ng-value=$ctrl.property.post_code></md-input-container><md-input-container flex=33><label>Localité</label><input readonly ng-value=$ctrl.property.locality.name></md-input-container><md-input-container flex=33><label>Province</label><input readonly ng-value=$ctrl.property.province></md-input-container><!-- <md-input-container flex=33>\n        <label>code hotel TGX</label>\n        <input name=\"province\" type=\"text\" maxlength=\"255\" ng-model=\"$ctrl.property.tgxCode\">\n      </md-input-container> --><!-- <md-input-container flex=100>\n        <label>Pays</label>\n        <input readonly ng-value=\"$ctrl.property.country\">\n      </md-input-container>--><!-- <md-input-container class=\"md-block\" flex>\n          <label>Fuseau horaire</label>\n          <input readonly  ng-value=\"$ctrl.property.timezone\">\n        </md-input-container> --><md-input-container class=md-block flex=25><label>Latitude</label><input readonly ng-value=$ctrl.map.markers.property.lat></md-input-container><md-input-container class=md-block flex=25><label>Longitude</label><input readonly ng-value=$ctrl.map.markers.property.lng></md-input-container><!--Valeria block start --><div ng-if=!$ctrl.hasGlobalCRMConfig><md-input-container class=md-block><label>Lien adresse CRM</label><input readonly name=crmAdresse type=text maxlength=255 ng-model=$ctrl.property.crmAdresse></md-input-container><md-input-container class=md-block><label>Adresse CRM Chaine</label><input readonly name=crmAdresse type=text maxlength=255 ng-model=$ctrl.property.crmAdresseChaine></md-input-container><md-input-container class=md-block><label>Email Réservation</label><input readonly name=reservation type=text maxlength=255 ng-model=$ctrl.property.reservation></md-input-container><md-input-container class=md-block><label>Password Email</label><input readonly name=passwordReservaation type=text maxlength=255 ng-model=$ctrl.property.passwordReservation></md-input-container></div><!--Valeria block end --></div></section><div flex style=min-width:200px;min-height:200px><leaflet width=100% height=100% markers=$ctrl.map.markers center=$ctrl.map.center></leaflet></div></div><!-- <div class=\"row\">\n  <pre>  {{::$ctrl.property | json}}\n  </pre>\n</div> -->");
$templateCache.put("app/property/policies/edit/template.html","<form name=policiesForm ng-submit=$ctrl.save()><header><h4>Politique de l\'établissement</h4></header><section><h4>Heure limite check out/début checkin</h4><md-input-container><label>check out jusqu\'à</label><input ng-model=$ctrl.copy.checkout type=time style=\"width: 120px\"></md-input-container><md-input-container><label>check in à partir de</label><input ng-model=$ctrl.copy.checkin type=time style=\"width: 120px\"></md-input-container></section><!-- <pre>{{$ctrl.copy | json}}</pre> --><section><h4>Politique enfants</h4><md-checkbox ng-model=$ctrl.copy.adultsOnly>Adultes seulement</md-checkbox><div ng-if=!$ctrl.copy.adultsOnly>Politique enfants / tranches d\'age<md-button ng-click=$ctrl.addAgeSegment()><md-icon>add</md-icon></md-button></div><div ng-if=!$ctrl.copy.adultsOnly ng-repeat=\"cat in $ctrl.copy.age track by $index\" ng-hide=\"cat === 0\" layout=row layout-align=start-center><label style=width:130px ng-pluralize count=$index when=\"{\'0\':\'Bébé (2 ans max.)\',\'one\':\'Enfant/Ado\',\'other\':\'Enfant/Ado\'}\"></label><!-- <md-input-container class=\"md-block\" flex=\"20\">\n          <label>Moins de</label>\n          <input type=\"number\" min=\"0\" max=\"18\" ng-model=\"$ctrl.copy.age[$index]\" required />\n        </md-input-container> --><md-input-container class=md-block flex=20><label>Moins de</label><input type=number min=0 max=18 ng-model=$ctrl.copy.age[$index] required></md-input-container><md-input-container class=md-block flex=20><label>name</label><textarea ng-model=$ctrl.copy.name[$index] required maxlength=30></textarea></md-input-container><md-button class=md-icon-button ng-hide=\"$ctrl.copy.age.length === 1\" ng-click=$ctrl.copy.age.splice($index,1)><md-icon>delete</md-icon></md-button></div></section><!-- <section>\n    <h4>Cartes accéptées</h4>\n    <md-checkbox ng-repeat=\"c in ::$ctrl.copy.cc\" ng-model=\"c.selected\">{{::c.name}}</md-checkbox>\n  </section> --><section><h4><md-checkbox ng-model=$ctrl.copy.petsAllowed>Animaux de compagnie</md-checkbox></h4><div ng-if=$ctrl.copy.petsAllowed><p class=inline-help style=\"color: #2196F3\">Spécifiez ci-dessous les contraintes (chat, chien, poids etc...)</p><md-input-container ng-repeat=\"lang in ::$root.languages\" class=md-block><label>Langue: {{::lang.name}}</label><textarea ng-model=$ctrl.copy.pets[lang.code] required maxlength=254 lang={{::lang.code}}></textarea></md-input-container></div></section><section><h4><md-checkbox ng-model=$ctrl.copy.hasOther>Autre</md-checkbox></h4><div ng-if=$ctrl.copy.hasOther><md-input-container ng-repeat=\"lang in ::$root.languages\" class=md-block><label>{{::lang.name}}</label><!--  <textarea ng-model=\"$ctrl.copy.other[lang.code]\" required maxlength=\"254\" lang=\"{{::lang.code}}\"></textarea>--><textarea ng-if=\"lang.code == \'fr\'\" ng-model=\"$ctrl.copy.other[\'fr\']\" required maxlength=254 lang={{::lang.code}}></textarea><textarea ng-if=\"lang.code == \'en\'\" ng-model=\"$ctrl.copy.other[\'en\']\" required maxlength=254 lang={{::lang.code}}></textarea></md-input-container></div></section><footer layout-align=end><md-button type=submit class=edit>Enregistrer</md-button></footer></form><!--\n\nCard Type	Card Number Prefix\nAmerican Express	34, 37\nChina UnionPay	62, 88\nDiners ClubCarte Blanche	300-305\nDiners Club International	300-305, 309, 36, 38-39\nDiners Club US & Canada	54, 55\nDiscover Card	6011, 622126-622925, 644-649, 65\nJCB	3528-3589\nLaser	6304, 6706, 6771, 6709\nMaestro	5018, 5020, 5038, 5612, 5893, 6304, 6759, 6761, 6762, 6763, 0604, 6390\nDankort	5019\nMasterCard	50-55\nVisa	4\nVisa Electron	4026, 417500, 4405, 4508, 4844, 4913, 4917\n-->");
$templateCache.put("app/property/policies/view/template.html","<header><h4>Politique de l\'établissement</h4><md-button ng-click=$ctrl.onEdit() class=md-accent>Modifier</md-button></header><dl><dt>Check in</dt><dd>à partir de {{::$ctrl.property.policies.checkin.substring(0,5)}}</dd><dt>Check out</dt><dd>au plus tard {{::$ctrl.property.policies.checkout.substring(0,5)}}</dd><dt>Politique enfants</dt><dd ng-if=::$ctrl.property.policies.adultsOnly>Adultes seulement</dd><dd ng-if=::(!$ctrl.property.policies.adultsOnly)><!-- <dl layout=\"row\" layout-wrap ng-if=\"::(!$ctrl.property.policies.age)\">\n      <dt flex=30>Bébé</dt>\n      <dd flex=70>moins de 2 ans</dd>\n      <dt flex=30>Enfant</dt>\n      <dd flex=70>mois de 12 ans</dd>\n    </dl> --><dl layout=row layout-wrap ng-if=::$ctrl.property.policies.age><dt flex=30 ng-repeat-start=\"age in ::$ctrl.property.policies.age\" ng-hide=\"age === 0\">{{age | childAge}}</dt><dd flex=70 ng-repeat-end ng-hide=\"age === 0\">moins de {{::age}} ans</dd></dl></dd><dt>Animaux domestiques</dt><dd style=\"width: calc(100% - 160px)\"><div ng-show=$ctrl.property.policies.petsAllowed>Accéptés. <em>{{::$ctrl.property.policies.pets}}</em></div></dd><!-- <dt>Cartes accéptés</dt>\n  <dd>\n    <ul style=\"list-style:none;margin:0;padding:0\">\n      <li style=\"display:inline-block\" ng-repeat=\"cc in $ctrl.property.policies.cc\"><i style=\"font-size: 24px;color:#666\" class=\"pf {{::$ctrl.cc.get(cc).icon}}\"></i><span ng-hide=\"::($ctrl.cc.get(cc).icon)\">{{::$ctrl.cc.get(cc).name}}<span></li>\n    </ul>\n  </dd> --><dt>Autre</dt><dd>{{::$ctrl.property.policies.other}}</dd></dl><!-- <pre>{{$ctrl.property.policies.age | json}}</pre> -->");
$templateCache.put("app/property/tags/edit/template.html","<md-dialog id=amenities-selector><md-dialog-content><input type=text ng-model=$ctrl.filter><md-divider></md-divider><md-list><md-item ng-repeat=\"a in $ctrl.amenities | filter: {name:$ctrl.filter}\" ng-click=$ctrl.select(a)>{{a.name}}</md-item></md-list></md-dialog-content></md-dialog>");
$templateCache.put("app/property/units/edit/template.html","<md-dialog><form name=unitForm ng-int=$ctrl.copy.occupancy.infants.><header>{{::$ctrl.title}}</header><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><md-input-container><label>Type d\'unités</label><md-select name=unitType ng-model=$ctrl.copy.type required><md-option ng-repeat=\"option in ::$ctrl.unitTypes\" ng-value=::option.code>{{::option.name}}</md-option></md-select><div ng-messages=unitForm.unitType.$error ng-if=unitForm.unitType.$dirty><div ng-message=required>Veuillez choisir un type.</div></div></md-input-container><md-input-container ng-repeat=\"lang in ::$ctrl.langs\"><label>Nom ({{lang.name}})</label><input type=text name=name required maxlength=128 xnot-in=$ctrl.existingNames ng-model=$ctrl.copy.name[lang.code] ng-pattern=/^(?![A-Z]{2,}).*$/ ><div ng-messages=unitForm.name.$error multiple><div ng-message=pattern>Prière de ne pas tout mettre en majuscule.</div><div ng-message=notIn>Une autre catégorie porte le même nom.</div></div></md-input-container><md-input-container flex=50><label>Nombre</label><input type=number name=count max=1000 min=1 ng-model=$ctrl.copy.count><div ng-messages=unitForm.count.$error multiple md-auto-hide=false><div ng-message=max>Plus de 1000 unités?</div><div ng-message=min>Veuillez indiquer le nombre d\'unité (au moins 1)</div></div></md-input-container><md-input-container flex=50><label>Supérficie</label><input type=number name=area max=999 min=1 ng-model=$ctrl.copy.area><div ng-messages=unitForm.area.$error md-auto-hide=false><div ng-message=min,max>Indiquez la superficie en m<sup>2</sup></div></div></md-input-container><md-input-container flex=50><label>Occupation maximale</label><input type=number name=area max=19 min=1 ng-model=$ctrl.copy.maxOccupancy><div ng-messages=unitForm.area.$error md-auto-hide=false><div ng-message=min,max>Indiquez l\'occupation maximale</div></div></md-input-container><!-- <md-input-container flex=\"50\">\n\n        <div class=\"category-count\" ng-repeat=\"(key, item) in $ctrl.inputs\">\n          <h5>{{::item.label}}</h5>\n          <md-input-container>\n            <label>Minimum</label>\n            <input ng-model=\"item.min\" type=\"number\" ng-min=\"item.min\" max=\"10\" required/>\n          </md-input-container>\n          <md-input-container>\n            <label>Maximum</label>\n            <input ng-model=\"item.max\" type=\"number\" ng-min=\"item.min\" max=\"10\" required/>\n          </md-input-container>\n        </div>\n    </md-input-container> --><md-input-container flex=50><div><h5>Adult</h5><md-input-container><label>Minimum</label><input style=\"color: #000000\" name=adltmin ng-model=$ctrl.copy.occupancy.adults.min type=number min=0 max=19 required></md-input-container><md-input-container><label>Maximum</label><input style=\"color: #000000\" name=adltmax ng-model=$ctrl.copy.occupancy.adults.max type=number ng-min=$ctrl.copy.occupancy.adults.min max=19 required></md-input-container></div><div ng-if=\"$ctrl.property.policies.adultsOnly == false\"><h5>Enfant</h5><md-input-container><label>Minimum</label><input style=\"color: #000000\" name=childmin ng-model=$ctrl.copy.occupancy.children.min type=number min=0 max=10 required></md-input-container><md-input-container><label>Maximum</label><input style=\"color: #000000\" name=childmax ng-model=$ctrl.copy.occupancy.children.max type=number ng-min=$ctrl.children.min max=10 required></md-input-container></div><!-- <div  ng-if=\"$ctrl.property.policies.adultsOnly == false\">\n          <h5>Bébé</h5>\n          <md-input-container>\n            <label>Minimum</label>\n            <input style =\" color: #000000; \" name=\"infdmin\" ng-model=\"$ctrl.copy.occupancy.infants.min\" type=\"number\" min=\"0\" max=\"10\" required/>\n          </md-input-container>\n          <md-input-container>\n            <label>Maximum</label>\n            <input  style =\" color: #000000; \" name=\"infdmax\" ng-model=\"$ctrl.copy.occupancy.infants.max\" type=\"number\" ng-min=\"$ctrl.infants.min\" max=\"10\" required/>\n          </md-input-container>\n        </div> --></md-input-container><!-- <section>\n      <div\n        class=\"category-count\"\n        ng-repeat=\"policyCombination in ::$ctrl.policiesCombinations track by $index\"\n      >\n        <md-checkbox ng-model=\"policyCombination.value\">\n          {{policyCombination.label}}\n        </md-checkbox>\n      </div>\n    </section> --></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save() ng-disabled=unitForm.$invalid>Enregistrer</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/property/units/policies-combinations/template.html","<md-dialog style=\"width: 421px\"><form name=unitForm><header>{{::$ctrl.title}}</header><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><!-- <section>\n        <div\n          class=\"category-count\"\n          ng-repeat=\"policyCombination in ::$ctrl.policiesCombinations track by $index\"\n        >\n          <md-checkbox ng-model=\"policyCombination.value\">\n            {{policyCombination.label}}\n          </md-checkbox>\n        </div>\n      </section> --><md-table-container><table md-table><thead md-head><tr md-row><th md-column>Nombre d\'adultes</th><th md-column>L\'âge des enfants</th><!-- <th md-column>Nombre de bébés</th> --></tr></thead><tbody md-body><tr md-row ng-repeat=\"comb in $ctrl.combinations\"><td md-cell width=30><!-- <md-checkbox ng-model=\"comb.adults.value\">\n                  </md-checkbox> --> {{comb.adults.label}}</td><td md-cell width=70><section><md-checkbox ng-model=comb.selectAll ng-change=$ctrl.changeSelectAllState(comb) style=padding-bottom:10px>Cocher/décocher</md-checkbox></section><a ng-click=\"comb.showAllChildrenCombs = !comb.showAllChildrenCombs\"><span ng-if=!comb.showAllChildrenCombs>Développer</span> <span ng-if=comb.showAllChildrenCombs>Réduire</span></a><div ng-if=comb.showAllChildrenCombs class=category-count ng-repeat=\"childrenComb in ::comb.childrens track by $index\"><md-checkbox ng-model=childrenComb.selected>{{childrenComb.label}}</md-checkbox></div></td><!-- <td md-cell>\n                <div class=\"category-count\"\n                ng-repeat=\"inf in ::comb.infants track by $index\"\n              >\n                <md-checkbox ng-model=\"inf.value\">\n                  {{inf.label}}\n                </md-checkbox>\n              </div>\n              </td> --></tr></tbody></table></md-table-container></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save() ng-disabled=unitForm.$invalid>Enregistrer</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/yield/property-table/unit-allotments/template.html","<section style=\"border-top:2px solid {{::allotment.color}}\" class=allotment ng-repeat=\"allotment in :: $ctrl.allotments\" ng-hide=$ctrl.loading style=height:150px><h3 style=background-color:{{::allotment.lightColor}}>{{::allotment.label}}</h3><div class=items><section class=available style=height:50px><h4 style=height:50px>Disponible</h4><ol class=days ng-if=::allotment.permissions.edit><li ng-class={warn:!night.available} ng-repeat=\"date in $ctrl.period.dates\"><input type=number ng-model=allotment.calendar.items[$index].available aria-label=avalaible min=0 max=99 ng-blur=$ctrl.availabilityChanged(allotment,allotment.calendar.items[$index])></li></ol><ol class=days ng-if=::!allotment.permissions.edit><li ng-class={warn:!night.available} ng-repeat=\"date in $ctrl.period.dates\">{{::allotment.calendar.items[$index].available}}</li></ol></section><section class=booked style=height:50px><h4 style=height:50px>Reservé</h4><ol class=days><li ng-repeat=\"date in $ctrl.period.dates\" ng-bind=::allotment.calendar.items[$index].booked></li></ol></section><section class=release ng-if=::allotment.contracted style=height:50px><h4 style=height:50px>Rétrocession</h4><ol class=days ng-if=::allotment.permissions.edit><li ng-repeat=\"date in $ctrl.period.dates\"><input type=number ng-model=allotment.calendar.items[$index].release min=0 max=15 ng-blur=$ctrl.releaseChanged(allotment,allotment.calendar.items[$index])></li></ol><ol class=days ng-if=::!allotment.permissions.edit><li ng-class={warn:!night.available} ng-repeat=\"date in $ctrl.period.dates\">{{::allotment.calendar.items[$index].release}}</li></ol></section></div></section>");
$templateCache.put("app/yield/property-table/unit-products/template.html","<section class=product-group ng-repeat=\"(code,basis) in ::$ctrl.rateBases\" ng-hide=$ctrl.pendingSupp><h3>Tarif {{::basis.description}}</h3><!-- <h3>length {{::$ctrl.pdts.length}}</h3> --><!-- <div  class=\"items\">\n      <div ng-repeat=\"occ in ::$ctrl.occupancies\" style=\"flex:1\">\n        \n       <md-checkbox     >{{::occ }} Adulte\n      </md-checkbox>\n    </div>\n  </div>\n  <div class=\"items\" > --><div class=items><section class=product ng-repeat=\"product in ::(filtered = $ctrl.products | filter:{rateBasis:code}) track by $index\" style=height:50px><!-- <section class=\"product\" ng-repeat=\"product in ::(filtered = $ctrl.pdts | filter:{rateBasis:code}) track by $index\"> --><!-- <section class=\"product\" ng-repeat=\"product in :: $ctrl.products  \"> --><h4 style=height:50px><span class=occupancy>{{::product.occupancy | occupancy}}</span><!-- <span ng-if=\"product.name\" class=\"occupancy\">{{::product.name }}</span> --> <span class=board>{{::$ctrl.boards[product.board].name}}</span></h4><ol class=days ng-repeat=\"date in $ctrl.period.dates\" style=height:50px><!-- <li ng-if=\"product.name!=\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><li ng-class={warn:!night.price}><input type=number ng-model=product.calendar.items[$index].price min=1 max=999999 ng-blur=$ctrl.priceChanged(product,product.calendar.items[$index])></li><!-- <li  ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><!-- <li ng-if=\"product.name==\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li> --></ol><!-- <br></br>LastproductsAdded\n    <ol class=\"days\" ng-repeat=\"date in $ctrl.peariod.dates\" >\n      <li ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li>\n     \n      <li ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li>\n\n    </ol>\n     --></section><div class=items><!-- <section class=\"product\" ng-repeat=\"product in ::(filtered = $ctrl.products | filter:{rateBasis:code}) track by $index\"> --><!-- <section class=\"product\" ng-repeat=\"pd in ::(filtered = $ctrl.pdts | filter:{rateBasis:code}) track by $index\"> --><section class=product ng-repeat=\"pd in $ctrl.pdts track by $index\"><!-- <section class=\"product\" ng-repeat=\"product in :: $ctrl.products  \"> --><h4><span class=occupancy>{{::pd.occupancy | occupancy}}</span> <span ng-if=pd.name class=occupancy>{{::pd.name }}</span> <span class=board>{{::$ctrl.boards[pd.board].name}}</span></h4><ol class=days ng-repeat=\"date in $ctrl.period.dates\"><!-- <li ng-if=\"product.name!=\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><li ng-class={warn:!night.price}><input type=number ng-model=pd.calendar.items[$index].price min=1 max=999999></li><!-- <li  ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><!-- <li ng-if=\"product.name==\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li> --></ol><!-- <br></br>LastproductsAdded\n      <ol class=\"days\" ng-repeat=\"date in $ctrl.peariod.dates\" >\n        <li ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li>\n       \n        <li ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li>\n  \n      </ol>\n       --></section><!-- <section class=\"product\" ng-repeat=\"product in :: $ctrl.LastproductsAdded  \">\n\n\n    <h4>\n      <span class=\"occupancy\">{{::product.occupancy | occupancy}}</span>\n      <span class=\"board\">{{::$ctrl.boards[product.board].name}}</span>\n    </h4>\n    <ol class=\"days\" ng-repeat=\"date in $ctrl.period.dates\" >\n      <li ng-if=\"product.name!=\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li>\n     \n\n    </ol>\n   \n  </section> --><!-- <section >\n  \n  <h4>\n    <span class=\"occupancy\">sup{{::product.occupancy | occupancy}}</span>\n    <span class=\"board\">sup{{::$ctrl.boards[product.board].name}}</span>\n  </h4>\n  <ol class=\"days\" ng-repeat=\"date in $ctrl.period.dates\" >\n  <li ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li>\n</ol>\n\n</section> --><!-- <br> --><!-- <section >\n    <h4>\n      <span class=\"occupancy\">sup</span>\n    </h4>\n    <ol class=\"days\" ng-repeat=\"date in $ctrl.period.dates\" >\n\n    <li ng-model=\"sup in product.calendar.items[$index].supplement\">\n      <ul>\n        <li>sup{{::sup}}</li>\n      </ul>\n    </li>\n     </ol>\n    </section>\n  </section>\n  <li ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li> --></div></div></section>");
$templateCache.put("app/yield/property-table/unit-stopSales/template.html","<section class=product-group style=\"background-color:rgb(20, 201, 207); height: 30px\"><h3>Stop Sales</h3><!-- <h3>length {{::$ctrl.pdts.length}}</h3> --><!-- <div  class=\"items\">\n        <div ng-repeat=\"occ in ::$ctrl.occupancies\" style=\"flex:1\">\n          \n         <md-checkbox     >{{::occ }} Adulte\n        </md-checkbox>\n      </div>\n    </div>\n    <div class=\"items\" > --><div class=items><!-- <section class=\"product\" ng-repeat=\"product in ::(filtered = $ctrl.pdts | filter:{rateBasis:code}) track by $index\"> --><!-- <section class=\"product\" ng-repeat=\"product in :: $ctrl.products  \"> --><section class=product><ol class=days ng-repeat=\"date in $ctrl.period.dates\"><!-- <li ng-if=\"product.name!=\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><!-- <li ng-if=\"$ctrl.stopSalesExist[$index].exist== true \" ng-class=\"{warn:!night.price}\"><input type=\"text\" placeholder=\"NDisp\" min=\"1\"  max=\"999999\"  style=\"background-color:rgb(207, 20, 20); \" disabled></li> --><!-- <li ng-if=\"$ctrl.stopSalesExist[$index].exist== false \"   ng-class=\"{warn:!night.price}\"><input type=\"text\" placeholder=\"Disp\"  min=\"1\"  max=\"999999\"  style=\"background-color:rgb(5, 114, 32); \" disabled></li> --><li ng-if=\"$ctrl.stopSalesExist[$index].exist== false && $ctrl.permissionsContracting\" ng-class={warn:!night.price}><input type=text placeholder=Disp min=1 max=999999 style=\"background-color:rgb(5, 114, 32)\" ng-blur=$ctrl.stopChanged($ctrl.stopSalesExist[$index],$index,date)></li><li ng-if=\"$ctrl.stopSalesExist[$index].exist== false && !$ctrl.permissionsContracting \" ng-class={warn:!night.price}><input type=text placeholder=Disp min=1 max=999999 style=\"background-color:rgb(5, 114, 32)\"></li><li ng-if=\"$ctrl.stopSalesExist[$index].exist== true && $ctrl.permissionsContracting\" ng-class={warn:!night.price}><input type=text placeholder=NDisp min=1 max=999999 style=\"background-color:rgb(207, 20, 20)\" ng-blur=$ctrl.stopChanged($ctrl.stopSalesExist[$index],$index,date)></li><li ng-if=\"$ctrl.stopSalesExist[$index].exist== true && !$ctrl.permissionsContracting\" ng-class={warn:!night.price}><input type=text placeholder=NDisp min=1 max=999999 style=\"background-color:rgb(207, 20, 20)\"></li><!-- <li ng-if=\"$ctrl.onRequests[$index].exist== true \" ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"$ctrl.onRequests[$index].exist\" min=\"1\"  max=\"999999\"  style=\"background-color:rgb(207, 20, 20); \"></li>\n        <li ng-if=\"$ctrl.onRequests[$index].exist== false \"   ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"$ctrl.onRequests[$index].exist\" min=\"1\"  max=\"999999\"  style=\"background-color:rgb(5, 114, 32); \"></li> --><!-- <li  ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><!-- <li ng-if=\"product.name==\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li> --></ol><!-- <br></br>LastproductsAdded\n      <ol class=\"days\" ng-repeat=\"date in $ctrl.peariod.dates\" >\n        <li ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li>\n       \n        <li ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li>\n  \n      </ol>\n       --></section></div></section>");
$templateCache.put("app/yield/property-table/unit-requests/template.html","<section class=product-group style=\"background-color:rgb(20, 207, 176); height: 30px\"><h3>On Request</h3><!-- <h3>length {{::$ctrl.pdts.length}}</h3> --><!-- <div  class=\"items\">\n        <div ng-repeat=\"occ in ::$ctrl.occupancies\" style=\"flex:1\">\n          \n         <md-checkbox     >{{::occ }} Adulte\n        </md-checkbox>\n      </div>\n    </div>\n    <div class=\"items\" > --><div class=items><!-- <section class=\"product\" ng-repeat=\"product in ::(filtered = $ctrl.pdts | filter:{rateBasis:code}) track by $index\"> --><!-- <section class=\"product\" ng-repeat=\"product in :: $ctrl.products  \"> --><section class=product><ol class=days ng-repeat=\"date in $ctrl.period.dates\"><!-- <li ng-if=\"product.name!=\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><li ng-if=\"$ctrl.onRequestsExist[$index].exist== true && $ctrl.permissionsContracting  \" ng-class={warn:!night.price}><input type=text placeholder=\"On Req\" min=1 max=999999 style=\"background-color:rgb(198, 207, 20)\" ng-blur=$ctrl.onReqChanged($ctrl.onRequestsExist[$index],$index,date)></li><li ng-if=\"$ctrl.onRequestsExist[$index].exist== false  && $ctrl.permissionsContracting \" ng-class={warn:!night.price}><input type=text placeholder=Disp min=1 max=999999 style=\"background-color:rgb(5, 114, 32)\" ng-blur=$ctrl.onReqChanged($ctrl.onRequestsExist[$index],$index,date)></li><li ng-if=\"$ctrl.onRequestsExist[$index].exist== true  && !$ctrl.permissionsContracting \" ng-class={warn:!night.price}><input type=text placeholder=\"On Req\" min=1 max=999999 style=\"background-color:rgb(198, 207, 20)\" disabled></li><li ng-if=\"$ctrl.onRequestsExist[$index].exist== false  && !$ctrl.permissionsContracting \" ng-class={warn:!night.price}><input type=text placeholder=Disp min=1 max=999999 style=\"background-color:rgb(5, 114, 32)\" disabled></li><!-- <li ng-if=\"$ctrl.onRequests[$index].exist== true \" ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"$ctrl.onRequests[$index].exist\" min=\"1\"  max=\"999999\"  style=\"background-color:rgb(207, 20, 20); \"></li>\n        <li ng-if=\"$ctrl.onRequests[$index].exist== false \"   ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"$ctrl.onRequests[$index].exist\" min=\"1\"  max=\"999999\"  style=\"background-color:rgb(5, 114, 32); \"></li> --><!-- <li  ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><!-- <li ng-if=\"product.name==\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li> --></ol><!-- <br></br>LastproductsAdded\n      <ol class=\"days\" ng-repeat=\"date in $ctrl.peariod.dates\" >\n        <li ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li>\n       \n        <li ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li>\n  \n      </ol>\n       --></section></div></section>");
$templateCache.put("app/yield/property-table-room/unit-allotments/template.html","<section style=\"border-top:2px solid {{::allotment.color}}\" class=allotment ng-repeat=\"allotment in :: $ctrl.allotments\" ng-hide=$ctrl.loading style=height:150px><h3 style=background-color:{{::allotment.lightColor}}>{{::allotment.label}}</h3><div class=items><section class=available style=height:50px><h4 style=height:50px>Disponible</h4><ol class=days ng-if=::allotment.permissions.edit><li ng-class={warn:!night.available} ng-repeat=\"date in $ctrl.period.dates\"><input type=number ng-model=allotment.calendar.items[$index].available aria-label=avalaible min=0 max=99 ng-blur=$ctrl.availabilityChanged(allotment,allotment.calendar.items[$index])></li></ol><ol class=days ng-if=::!allotment.permissions.edit><li ng-class={warn:!night.available} ng-repeat=\"date in $ctrl.period.dates\">{{::allotment.calendar.items[$index].available}}</li></ol></section><section class=booked style=height:50px><h4 style=height:50px>Reservé</h4><ol class=days><li ng-repeat=\"date in $ctrl.period.dates\" ng-bind=::allotment.calendar.items[$index].booked></li></ol></section><section class=release ng-if=::allotment.contracted style=height:50px><h4 style=height:50px>Rétrocession</h4><ol class=days ng-if=::allotment.permissions.edit><li ng-repeat=\"date in $ctrl.period.dates\"><input type=number ng-model=allotment.calendar.items[$index].release min=0 max=15 ng-blur=$ctrl.releaseChanged(allotment,allotment.calendar.items[$index])></li></ol><ol class=days ng-if=::!allotment.permissions.edit><li ng-class={warn:!night.available} ng-repeat=\"date in $ctrl.period.dates\">{{::allotment.calendar.items[$index].release}}</li></ol></section></div></section>");
$templateCache.put("app/yield/property-table-room/unit-products/template.html","<section class=product-group ng-repeat=\"(code,basis) in ::$ctrl.rateBases\" ng-hide=$ctrl.pendingSupp><h3>Tarif {{::basis.description}}</h3><!-- <h3>length {{::$ctrl.pdts.length}}</h3> --><!-- <div  class=\"items\">\n      <div ng-repeat=\"occ in ::$ctrl.occupancies\" style=\"flex:1\">\n        \n       <md-checkbox     >{{::occ }} Adulte\n      </md-checkbox>\n    </div>\n  </div>\n  <div class=\"items\" > --><div class=items><section class=product ng-repeat=\"product in ::(filtered = $ctrl.products | filter:{rateBasis:code}) track by $index\" style=height:50px><!-- <section class=\"product\" ng-repeat=\"product in ::(filtered = $ctrl.pdts | filter:{rateBasis:code}) track by $index\"> --><!-- <section class=\"product\" ng-repeat=\"product in :: $ctrl.products  \"> --><h4 style=height:50px><span class=occupancy>{{::product.occupancy | occupancy}}</span><!-- <span ng-if=\"product.name\" class=\"occupancy\">{{::product.name }}</span> --> <span class=board>{{::$ctrl.boards[product.board].name}}</span></h4><ol class=days ng-repeat=\"date in $ctrl.period.dates\" style=height:50px><!-- <li ng-if=\"product.name!=\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><li ng-class={warn:!night.price}><input type=number ng-model=product.calendar.items[$index].price min=1 max=999999 ng-blur=$ctrl.priceChanged(product,product.calendar.items[$index])></li><!-- <li  ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><!-- <li ng-if=\"product.name==\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li> --></ol><!-- <br></br>LastproductsAdded\n    <ol class=\"days\" ng-repeat=\"date in $ctrl.peariod.dates\" >\n      <li ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li>\n     \n      <li ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li>\n\n    </ol>\n     --></section><div class=items><!-- <section class=\"product\" ng-repeat=\"product in ::(filtered = $ctrl.products | filter:{rateBasis:code}) track by $index\"> --><!-- <section class=\"product\" ng-repeat=\"pd in ::(filtered = $ctrl.pdts | filter:{rateBasis:code}) track by $index\"> --><section class=product ng-repeat=\"pd in $ctrl.pdts track by $index\"><!-- <section class=\"product\" ng-repeat=\"product in :: $ctrl.products  \"> --><h4><span class=occupancy>{{::pd.occupancy | occupancy}}</span> <span ng-if=pd.name class=occupancy>{{::pd.name }}</span> <span class=board>{{::$ctrl.boards[pd.board].name}}</span></h4><ol class=days ng-repeat=\"date in $ctrl.period.dates\"><!-- <li ng-if=\"product.name!=\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><li ng-class={warn:!night.price}><input type=number ng-model=pd.calendar.items[$index].price min=1 max=999999></li><!-- <li  ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><!-- <li ng-if=\"product.name==\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li> --></ol><!-- <br></br>LastproductsAdded\n      <ol class=\"days\" ng-repeat=\"date in $ctrl.peariod.dates\" >\n        <li ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li>\n       \n        <li ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li>\n  \n      </ol>\n       --></section><!-- <section class=\"product\" ng-repeat=\"product in :: $ctrl.LastproductsAdded  \">\n\n\n    <h4>\n      <span class=\"occupancy\">{{::product.occupancy | occupancy}}</span>\n      <span class=\"board\">{{::$ctrl.boards[product.board].name}}</span>\n    </h4>\n    <ol class=\"days\" ng-repeat=\"date in $ctrl.period.dates\" >\n      <li ng-if=\"product.name!=\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li>\n     \n\n    </ol>\n   \n  </section> --><!-- <section >\n  \n  <h4>\n    <span class=\"occupancy\">sup{{::product.occupancy | occupancy}}</span>\n    <span class=\"board\">sup{{::$ctrl.boards[product.board].name}}</span>\n  </h4>\n  <ol class=\"days\" ng-repeat=\"date in $ctrl.period.dates\" >\n  <li ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li>\n</ol>\n\n</section> --><!-- <br> --><!-- <section >\n    <h4>\n      <span class=\"occupancy\">sup</span>\n    </h4>\n    <ol class=\"days\" ng-repeat=\"date in $ctrl.period.dates\" >\n\n    <li ng-model=\"sup in product.calendar.items[$index].supplement\">\n      <ul>\n        <li>sup{{::sup}}</li>\n      </ul>\n    </li>\n     </ol>\n    </section>\n  </section>\n  <li ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li> --></div></div></section>");
$templateCache.put("app/yield/property-table-room/unit-requests/template.html","<section class=product-group style=\"background-color:rgb(20, 207, 176); height: 30px\"><h3>Request</h3><!-- <h3>length {{::$ctrl.pdts.length}}</h3> --><!-- <div  class=\"items\">\n        <div ng-repeat=\"occ in ::$ctrl.occupancies\" style=\"flex:1\">\n          \n         <md-checkbox     >{{::occ }} Adulte\n        </md-checkbox>\n      </div>\n    </div>\n    <div class=\"items\" > --><div class=items><!-- <section class=\"product\" ng-repeat=\"product in ::(filtered = $ctrl.pdts | filter:{rateBasis:code}) track by $index\"> --><!-- <section class=\"product\" ng-repeat=\"product in :: $ctrl.products  \"> --><section class=product><ol class=days ng-repeat=\"date in $ctrl.period.dates\"><!-- <li ng-if=\"product.name!=\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><li ng-if=\"$ctrl.onRequestsExist[$index].exist== true && $ctrl.permissionsContracting  \" ng-class={warn:!night.price}><input type=text placeholder=\"On Req\" min=1 max=999999 style=\"background-color:rgb(198, 207, 20)\" ng-blur=$ctrl.onReqChanged($ctrl.onRequestsExist[$index],$index,date)></li><li ng-if=\"$ctrl.onRequestsExist[$index].exist== false  && $ctrl.permissionsContracting \" ng-class={warn:!night.price}><input type=text placeholder=Disp min=1 max=999999 style=\"background-color:rgb(8, 173, 50)\" ng-blur=$ctrl.onReqChanged($ctrl.onRequestsExist[$index],$index,date)></li><li ng-if=\"$ctrl.onRequestsExist[$index].exist== true  && !$ctrl.permissionsContracting \" ng-class={warn:!night.price}><input type=text placeholder=\"On Req\" min=1 max=999999 style=\"background-color:rgb(198, 207, 20)\" disabled></li><li ng-if=\"$ctrl.onRequestsExist[$index].exist== false  && !$ctrl.permissionsContracting \" ng-class={warn:!night.price}><input type=text placeholder=Disp min=1 max=999999 style=\"background-color:rgb(8, 173, 50)\" disabled></li><!-- <li ng-if=\"$ctrl.onRequests[$index].exist== true \" ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"$ctrl.onRequests[$index].exist\" min=\"1\"  max=\"999999\"  style=\"background-color:rgb(207, 20, 20); \"></li>\n        <li ng-if=\"$ctrl.onRequests[$index].exist== false \"   ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"$ctrl.onRequests[$index].exist\" min=\"1\"  max=\"999999\"  style=\"background-color:rgb(5, 114, 32); \"></li> --><!-- <li  ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><!-- <li ng-if=\"product.name==\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li> --></ol><!-- <br></br>LastproductsAdded\n      <ol class=\"days\" ng-repeat=\"date in $ctrl.peariod.dates\" >\n        <li ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li>\n       \n        <li ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li>\n  \n      </ol>\n       --></section></div></section>");
$templateCache.put("app/yield/property-table-room/unit-stopSales/template.html","<section class=product-group style=\"background-color:rgb(20, 201, 207); height: 30px\"><h3>Stop</h3><!-- <h3>length {{::$ctrl.pdts.length}}</h3> --><!-- <div  class=\"items\">\n        <div ng-repeat=\"occ in ::$ctrl.occupancies\" style=\"flex:1\">\n          \n         <md-checkbox     >{{::occ }} Adulte\n        </md-checkbox>\n      </div>\n    </div>\n    <div class=\"items\" > --><div class=items><!-- <section class=\"product\" ng-repeat=\"product in ::(filtered = $ctrl.pdts | filter:{rateBasis:code}) track by $index\"> --><!-- <section class=\"product\" ng-repeat=\"product in :: $ctrl.products  \"> --><section class=product><ol class=days ng-repeat=\"date in $ctrl.period.dates\"><!-- <li ng-if=\"product.name!=\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><!-- <li ng-if=\"$ctrl.stopSalesExist[$index].exist== true \" ng-class=\"{warn:!night.price}\"><input type=\"text\" placeholder=\"NDisp\" min=\"1\"  max=\"999999\"  style=\"background-color:rgb(207, 20, 20); \" disabled></li> --><!-- <li ng-if=\"$ctrl.stopSalesExist[$index].exist== false \"   ng-class=\"{warn:!night.price}\"><input type=\"text\" placeholder=\"Disp\"  min=\"1\"  max=\"999999\"  style=\"background-color:rgb(5, 114, 32); \" disabled></li> --><li ng-if=\"$ctrl.stopSalesExist[$index].exist== false && $ctrl.permissionsContracting\" ng-class={warn:!night.price}><input type=text placeholder=Disp min=1 max=999999 style=\"background-color:rgb(8, 173, 50)\" ng-blur=$ctrl.stopChanged($ctrl.stopSalesExist[$index],$index,date)></li><li ng-if=\"$ctrl.stopSalesExist[$index].exist== false && !$ctrl.permissionsContracting \" ng-class={warn:!night.price}><input type=text placeholder=Disp min=1 max=999999 style=\"background-color:rgb(8, 173, 50)\"></li><li ng-if=\"$ctrl.stopSalesExist[$index].exist== true && $ctrl.permissionsContracting\" ng-class={warn:!night.price}><input type=text placeholder=NDisp min=1 max=999999 style=\"background-color:rgb(207, 20, 20)\" ng-blur=$ctrl.stopChanged($ctrl.stopSalesExist[$index],$index,date)></li><li ng-if=\"$ctrl.stopSalesExist[$index].exist== true && !$ctrl.permissionsContracting\" ng-class={warn:!night.price}><input type=text placeholder=NDisp min=1 max=999999 style=\"background-color:rgb(207, 20, 20)\"></li><!-- <li ng-if=\"$ctrl.onRequests[$index].exist== true \" ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"$ctrl.onRequests[$index].exist\" min=\"1\"  max=\"999999\"  style=\"background-color:rgb(207, 20, 20); \"></li>\n        <li ng-if=\"$ctrl.onRequests[$index].exist== false \"   ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"$ctrl.onRequests[$index].exist\" min=\"1\"  max=\"999999\"  style=\"background-color:rgb(5, 114, 32); \"></li> --><!-- <li  ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li> --><!-- <li ng-if=\"product.name==\'sup\'\" ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li> --></ol><!-- <br></br>LastproductsAdded\n      <ol class=\"days\" ng-repeat=\"date in $ctrl.peariod.dates\" >\n        <li ng-class=\"{warn:!night.price}\"><input type=\"number\" ng-model=\"product.calendar.items[$index].price\" min=\"1\"  max=\"999999\" ng-blur=\"$ctrl.priceChanged(product,product.calendar.items[$index])\"></li>\n       \n        <li ng-class=\"{warn:!night.price}\"><input type=\"text\" ng-model=\"product.calendar.items[$index].supplement\" min=\"0\"  max=\"999999\" ></li>\n  \n      </ol>\n       --></section></div></section>");
$templateCache.put("app/amenities/property/view/amenity-delete-confirm/dialog.html","<md-dialog><form name=amenityDeleteForm><header>{{$ctrl.amenity.name}}</header><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><div ng-bind-html=$ctrl.amenity.description layout=column></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Ne pas supprimer</md-button><!-- <md-button class=\"md-accent\" ng-click=\"$ctrl.update($ctrl.amenity)\" >\n                Modifier cet équipement ?\n            </md-button> --><md-button class=md-accent ng-click=$ctrl.save()>Supprimer cet équipement ?</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/amenities/property/view/confirm/dialog-desc.html","<md-dialog><form name=unitForm><!-- <header>\n            Gratuit/payant\n        </header> --><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><!-- <md-input-container>\n                <label>Type d\'unités</label>\n                <md-select name=\"unitType\" ng-model=\"$ctrl.copy.type\" required>\n                    <md-option ng-repeat=\"option in ::$ctrl.unitTypes\" ng-value=\"::option.code\">\n                        {{::option.name}}\n                    </md-option>\n                </md-select>\n                <div ng-messages=\"unitForm.unitType.$error\" ng-if=\"unitForm.unitType.$dirty\">\n                    <div ng-message=\"required\">\n                        Veuillez choisir un type.\n                    </div>\n                </div>\n            </md-input-container>--><md-input-container><md-radio-group ng-model=$ctrl.amenity.free aria-labelledby=favoriteFruit><md-radio-button ng-value=true>Gratuit</md-radio-button><md-radio-button ng-value=false>Payant</md-radio-button></md-radio-group></md-input-container><md-input-container><label ng-if=$ctrl.amenity.description>Description</label><!-- <input type=\"text\" name=\"description\" maxlength=\"128\" ng-model=\"$ctrl.copy.description[lang.code]\" required> --><!-- <textarea name=\"description\" ng-model=\"$ctrl.amenity.description\" md-maxlength=\"800\" rows=\"3\"\n                  md-select-on-focus>\n                </textarea> --><text-angular ng-model=$ctrl.amenity.description ta-default-wrap=span></text-angular></md-input-container></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save() ng-disabled=unitForm.$invalid>Enregistrer</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/amenities/property/view/confirm/dialog-nodesc.html","<md-dialog><form name=unitForm><!-- <header>\n            Gratuit/payant\n        </header> --><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><!-- <md-input-container>\n                <label>Type d\'unités</label>\n                <md-select name=\"unitType\" ng-model=\"$ctrl.copy.type\" required>\n                    <md-option ng-repeat=\"option in ::$ctrl.unitTypes\" ng-value=\"::option.code\">\n                        {{::option.name}}\n                    </md-option>\n                </md-select>\n                <div ng-messages=\"unitForm.unitType.$error\" ng-if=\"unitForm.unitType.$dirty\">\n                    <div ng-message=\"required\">\n                        Veuillez choisir un type.\n                    </div>\n                </div>\n            </md-input-container>--><md-input-container><md-radio-group ng-model=$ctrl.amenity.free aria-labelledby=favoriteFruit><md-radio-button ng-value=true>Gratuit</md-radio-button><md-radio-button ng-value=false>Payant</md-radio-button></md-radio-group></md-input-container><!-- \n      <md-input-container>\n        <label ng-if=\"$ctrl.amenity.description\">Description </label>\n\n        <text-angular ng-model=\"$ctrl.amenity.description\" ta-default-wrap=\"span\"></text-angular>\n\n      </md-input-container> --></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save() ng-disabled=unitForm.$invalid>Enregistrer</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/amenities/property/view/amenity-description/dialog.html","<md-dialog><form name=unitForm><!-- <header>\n            Gratuit/payant\n        </header> --><md-dialog-content layout=column style=\"padding: 32px 16px 0\"><!-- <md-input-container>\n        <label>Description </label>\n        <textarea name=\"description\" ng-model=\"$ctrl.amenity.description\" md-maxlength=\"800\" rows=\"3\"\n          md-select-on-focus>\n                </textarea>\n      </md-input-container> --><md-input-container><label ng-if=$ctrl.amenity.description>Description</label><!-- <input type=\"text\" name=\"description\" maxlength=\"128\" ng-model=\"$ctrl.copy.description[lang.code]\" required> --><!-- <textarea name=\"description\" ng-model=\"$ctrl.amenity.description\" md-maxlength=\"800\" rows=\"3\"\n          md-select-on-focus>\n        </textarea> --><text-angular ng-model=$ctrl.amenity.description ta-default-wrap=span></text-angular></md-input-container></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between end\" style=padding-left:8px><md-button ng-click=$ctrl.cancel() style=margin-left:0>Annuler</md-button><md-button class=md-accent ng-click=$ctrl.save() ng-disabled=unitForm.$invalid>Enregistrer</md-button></md-dialog-actions></form></md-dialog>");}]);